import { setAssetOwners } from './asset_queue'
import { choiceTimerOn, retryLabels } from './adv_fix2'
import { houndWalkLiftNow, stepHoundWalkLift } from './hound_walk_lift'
import { drawLampMote, lampMoteOld } from './lamp_mote'
import { drawLampLightV1, lampFlicker, lampLightV1 } from './lamp_light'
import { execMortarDripOn, execMortarShellOrb, execStepGlowOn, execStepWind } from './exec_look_1101'
import { shadeSlashBlend, shadeSlashDx, shadeSlashDy, shadeSlashStepKey, shadeSlashSmoothMode, SHADE_SLASH_STEP_KEYS, type ShadeSlashStepKey } from './shade_slash_smooth_1028'
import { TUT_SIX, tutSix } from './tut_six'
import { VOICE_CLEAR, VOICE_CLEAR_SHOW_SEC, VOICE_FOCUS, VOICE_GOAL, tutVoiceLook, voiceBannerAge, voiceGoalKey, voiceHeader } from './tut_voice'
import { drawBattleWhisper, drawVoiceBanner, drawVoiceFocus } from './tut_voice_view'
import { actMarksAt, advChoiceIdleAlpha, advChoiceIdleColor, advChoiceLook, drawChoiceInk } from './readability_1104'
import { ACT_MARK_FLASH_SEC, ACT_MARK_SNUFF_OLD_SEC, ACT_MARK_SNUFF_SEC, ACT_REFILL_SEC, HUD_OLD_EXEC_DEATH_TIP, HUD_OLD_WARN_AT, HUD_V2_EXEC_DEATH_TIP, HUD_V2_LINE_SEC, HUD_V2_WARN_AT, hudOld, hudV2, hudV2Line } from './hud_v2'
import { postureHoldTip } from './player_combo3_power'
import { awokenCamPullBack } from './awoken_cam_pull'
import { awokenBaseGlowMult, awokenParryCue } from './awoken_face_glow'
import { AWOKEN_FACE_FRONT_GHOST_ALPHA, awokenFaceFrontActive } from './awoken_face_front'
import { mortarArcMode, mortarArcPhase, mortarArcPointLow } from './exec_mortar_arc_1104'
import { overlapBossAlpha, overlapRimStrength } from './overlap_read_1104'
import { breakJoltOffset } from './break_stop_fx'
import { activeParryBloom,bloomZoom, bloomShapeFor, drawBloomLitBody, drawParryBloom, parryWashVariant, type BloomShape } from './parry_bloom_fx'
import { drawParryWashFx, drawWashRing, WP, createWashSparkRetention, isStrongWash } from './parry_wash_fx'
import { activeKesakiSpark, applyKesakiGray, beginKesakiFrame, drawKesakiBodyLights, drawKesakiContact, drawKesakiFloorGlow, drawKesakiGem, drawKesakiHair,
  drawKesakiLitBody, drawKesakiSparks, drawKesakiWallShadows, kesakiClock, kesakiContactLight, kesakiGemPoint, kesakiGray, kesakiHairBackLight, kesakiLook,
  kesakiOwns, kesakiPlayerLights, kesakiTakes, fillKesakiBody, kickKesakiHair, redrawKesakiBody, type PlayerFoot } from './parry_kesaki_fx'
import { activeTehonSpark, drawTehonBloom, drawTehonEmbers, drawTehonFlare, drawTehonFloorGlow, drawTehonScreenFlash, drawTehonSlash, drawTehonStreaks,
  parryTehonOn, TEHON_COLOR, tehonBodyLight, tehonBodyLit, tehonOwns, tehonTakes, tehonVeilAlpha, tehonZoom } from './parry_tehon_fx'
import { drawTehonMolten } from './parry_spark_molten'
import { drawBrideThreadSweep } from './bride_thread_sweep'
import {
  brideSpinAngle, brideSpinBackFilter, brideSpinBodyOn, brideSpinBodyScale, brideSpinClock, brideSpinLayersOn,
  brideSpinTurnArtOn, brideTurnImage, brideTurnPick, drawBrideTurnArt,
  drawBrideSpinLayers, drawBrideSpinVeil, drawBrideSlamCloth, brideHemFlashK, brideGhostOn, drawBrideSpinGhosts,
} from './bride_spin_fx'
import { deathFrontActive, deathRimStrength, defeatHintStyle } from './fresh_eyes_fix_trials'
import { defeatTipForDefeat, defeatTipsMode } from './defeat_tips'
import { knightHelmetScaleEnabled } from './knight_helmet_scale'
import { knightGaitDrawOffsetPx } from './knight_gait'
import { wallHuntGameSample, drawWallHuntHitMask } from './awoken_wall_hunt_game'
import { cannonProjectileDrawAngle } from './executioner_cannon_tracking'
import { isAwokenChaseStudy } from './awoken_rush_study'
import { drawParryBreak, getParryBreakLook } from './parry_break_fx'
import { drawParryBreakAB, drawGuardImpactA2, drawGuardImpactImg, getGuardFxLook, guardPushMul, parryBreakDesat,
  parryDownCamera, drawParryDownFlash, drawParryDownTint } from './parry_family_fx'
import { drawPlantedTravelGuide } from './boss_planted_travel_guide'
import { isExecutionerFajin } from './executioner_cannon_fajin'
import { cannonFajinChargeProgress, drawCannonFajinCharge } from './executioner_fajin_charge_fx'
import { KNIGHT_SWEEP_ART, knightSweepTrailAlpha } from './knight_sweep_motion'
import { drawKnightLungeDust } from './knight_lunge_dust'
import { applyHoundHowlWarp, drawHoundHowlBehind } from './hound_howl_fx'
import { applyRoarTellBackground, drawRoarTellBand, roarRingsHidden, roarTellOn } from './exec_roar_tell'
import { ROAR_AIR, roarAirOn, roarAirSpeedPxPerSec } from './exec_roar_air'
import { act2BlinkRoarCutMs, act2BlinkVisual } from './exec_act2_blink'
import { applyRoarAirBackground, drawRoarAirWorld, roarAirFronts } from './exec_roar_air_fx'
import { drawKnightSweepScrape } from './knight_sweep_scrape'
import { KNIGHT_CHARGE_STRIDE } from './knight_wall_charge'
import { getKnightLeapTell, KNIGHT_SWEEP_WINDUP_ONSET_MS } from './knight_spacing'
import { knightFloorScrape } from './knight_floor_scrape'
import { awokenHopFx } from './awoken_hop_fx'
import { drawKnightSweepStudy, knightSweepStudyApplies } from './knight_sweep_study'
import { bladeQuickMannequinApplies, drawBladeQuickMannequin } from './blade_quick_mannequin'
import { drawKnightSweepDust, knightSweepImpactShake } from './knight_sweep_weight'
﻿// Phase 4: ボス別シルエット (Hound / Harpy)、パリィ可/不可の視覚区別、記憶ヒントパネル。
// 設計のキモ:
//  - drawBoss は boss.id で分岐 (Hound / Harpy)
//  - パリィ可: 紫グロー / 紫テレグラフバー
//  - パリィ不可: 赤グロー＋震え / 赤テレグラフバー＋ "DODGE!" キュー強化
//  - 左サイドに「記憶 (Memory)」パネル ― 解放済みヒントを表示

import type { ActiveHit, AttackDef, Boss, EndingChoice, FxEvent, GameState, Player, SpriteKey, TutorialFocusStepId } from './types'
import { drawSweepRibbon } from './sweep_ribbon'
import { breakReadyRatio, bossHudLegacyMode, drawBossHudSilver, silverHudLayout, createBossHudPreviewState, withBossHudPreview } from './boss_hud_view'
import { cardHudDemoAt, type CardHudDemo } from './card_hud_demo'
import { heavyBarGhost, postureHoldLevel } from './heavy_combo_hud'
import { ARENA, BOSS, BOSS_CORE, BOSS_EXECUTE_FX, COMBAT, EXECUTE, EXECUTE_FX, FIXED_DT, PALETTE, PLAYER, PLAYER_DISPLAY_HEIGHT, SOUL_BLUE, STAGGER_SPOT, STUN_ASH, TUTORIAL, arenaWalls, arenaBoundsFor, getArenaWidthMul, playerAttackReachFor, worldBoundsFor } from './balance'
import { EXECUTIONER_CANNON_MUZZLE, EXECUTIONER_CANNON_MUZZLE_AIM, EXECUTIONER_CANNON_MUZZLE_MORTAR, getAttack } from './attacks'
import { bossPostureGainMul, chipFloor, parryGainHpMul, roomHpFraction } from './combat'
import { finisherBeat, beatProgress, T_PULL, T_DISSOLVE, T_END } from './finisher'
import { EXEC_V2, FIN_C, FINISHER_V2_ANIM, execBossStaggerHold, execFxLookNow, execNormalVariant, execV2AnimName, execWoundPoint, finisherCBgDark, finisherCGmOfClock, finisherCOn, finisherCWoundPoint, finisherFreezeProgress, finisherProfileFor, finisherV2On } from './luna_finisher'
import { drawBgDarkAlpha, drawFinisherV2BgDark, drawFinisherV2Front, drawLunaExecHit } from './luna_finisher_fx'
import { drawLunaExecHitV3 } from './luna_exec_fx_v3'
import { drawFinisherCFront, drawLunaExecHitC } from './luna_exec_fx_c'
import { effectiveChargeMs } from './boss'
import { getBossDefinitionById, bossCoreHalfWidth } from './bosses'
import { execHeavyPoseSec, execParryEnabled, execPushCameraKick, stunParryPoseElapsedSec } from './exec_parry'
import { drawExecParryGlow } from './exec_parry_glow'
import { activeExecSlowGlow, drawExecSlowContact, drawExecSlowScreen, execParryFxNew, execSlowClockMs, execSlowContact, execSlowFlash, execSlowGray,
  execSlowShake, execSlowSpecOf, execSlowVignette, execSlowZoom, type ExecSlowSpec } from './exec_parry_slow_fx'
import { drawPushWeightContactFlash, drawPushWeightScreenFlash, pushWeightClockMs, pushWeightDarkLevel, pushWeightFlashLevel, pushWeightPivot, pushWeightShake, pushWeightSpec, pushWeightZoom, type PushWeightSpec } from './exec_push_weight'
import { awokenDevourActiveAura, awokenDevourAuraK } from './awoken_devour'
import { execUniqueAuraK } from './exec_unique'
import { bladeClapAuraK } from './blade_finisher_v2'
import { drawExecUniqueFxBehind, drawExecUniqueFxFront } from './exec_unique_fx'
import { bossIntroCardShown, bossIntroHolding } from './state'
import { playerMaxHp, playerMaxPosture } from './difficulty'
import { formatClearTime, hasCampaignProgress, isCampaignCleared } from './campaign'
import { activeTextLine, advDisplaySegments, takeAdvDisplayCharacters, visibleLines, totalTextLineCount, activeCueBeat, choiceRevealAlpha, type AdvScene, type AdvTextLine, type AdvRuntime, type AdvChoice } from './adv'
import { getEndingScene, getInterludeScene, getPreBattleScene, ENDING_RECAP_SYMBOLS } from './adv_scripts'
// 絵が主役の ADV (2026-10-01・絵の行を持つ場面だけ)。描画は adv_picture_view.ts に分けた (render.ts は主人公の攻撃の作業と同時に触っていたため)。
import { isPictureScene, ADV_BATTLE_EXIT_MS } from './adv'
import { drawPictureInterlude, measurePictureChoiceRects } from './adv_picture_view'
import { activeGlint, rampageFaceCue } from './awoken_rampage_v5'
import { roosterLandingPreview, roosterRoamGlint } from './rooster_aerial_roam'
import { roosterDropGlint, roosterDropPreview } from './rooster_vertical'
import { roosterRushCue, roosterRushJitterPx } from './rooster_rush'
import { roosterFrenzyBreathing, roosterFrenzyStage } from './rooster_frenzy'
import { FRENZY_STAGES, roosterFrenzyHud, roosterFrenzyOn } from './rooster_frenzy_spec'
import { AWOKEN_SPIN_ID, drawAwokenSpinArc, drawAwokenSpinDust } from './awoken_spin_fx'
import { drawRampageWave, drawRampageGlint, drawRampageSpirit, drawRampageContact } from './awoken_rampage_fx'
import { drawAwokenWaveRemnants } from './awoken_wave_rift_fx'
import { drawBossSprite, drawShadeSprite, hasBossSprite, preloadBossSprites, bossSpriteReady, PARRY_OVERLAY_DURATION_SEC, SPRITE_EXT_BY_BOSS, resolveBossFaceAnchor, resolveBossFaceAnchorInArt, resolveBossTimelinePose, projectBossSpriteRelativePoint, projectBossSpriteSourcePoint, loadedBossSpriteArtPlacement, SOURCE_FACING, setBossShakeOverride, type BossSpritePlacement } from './sprites'
import { bossProxyEnabled } from './boss_proxy'
import { updatePlayerAnimState, resetPlayerAnimState } from './player_walk_state'
import { drawSpinePlayer, hasSpinePlayerAnimation, spinePlayerRapierPoints } from './spine_player'
import { UKEMI, ukemiCoverAlpha, ukemiKind, ukemiOn, ukemiSince } from './ukemi'
import { prepareWalkNewDraw, resetWalkNewDraw, walkNewAnimState } from './player_walk_new_draw'
import { captureDodgeStartShadow, counterAccentColor, counterLookShadow, counterSignalStrength, drawCounterBurstShadow,
  drawCounterSignal, drawMikiriShadow, mikiriShadowStepId, noteMikiri, resetMikiriShadowIfRewound, type BladePoints } from './dodge_counter_look'
import { drawPlayerAttackFrame } from './player_attack_frames'
import { playerComboEnabled } from './player_combo_switch'
import { drawBossSpineIfReady } from './boss_spine_player'
import { ATTACK_SETTLE_SEC, needsAttackSettle, playerAttackAnimationCandidates, PARRY_HEAVY_OUT_SEC, PARRY_TAIL_SEC, type PlayerVisualState } from './spine_anim_map'
import { getParryFlash, getFinisherFx, getLanceButtEruption, getBrideHazard, getRampageGrudge } from './fx_sprites'
import { drawThornAisle } from './bride_thorn_rise'
import { drawBrideRoseWithers } from './bride_rose_thorns'
import { rippleSyncOn, rippleBurstRise, rippleCastEarly, ripplePoseElapsedSec, RIPPLE_SYNC_LEAD_MS, RIPPLE_RISE_MS } from './shade_wave_sync'
import { drawShadeWaveMist, shadeMistLookOn } from './shade_wave_mist_fx'
import { getPurpleSwap, sw as swc, type PurpleSwapRole } from './purple_swap'
import { et } from './exec_tint'
import { getRedSignals } from './red_signals'
import { glowMote, emberBurst, emberRise, hash01, taperStreak } from './fx_kit'
import { drawQuakeActive, drawQuakeTelegraph, getQuakeLook, type QuakeFxContext } from './quake_fx'
import { drawExecFloorActive, drawExecFloorLinger, drawMortarRingTelegraph } from './exec_floor_fx'
import { drawFajinWave, drawFajinWindFrame, getFajinLook } from './fajin_fx'
import { SHADE_TIPS_CARDS, tipsCardsForBoss, pendingTipsCardIndex, type TutorialCard } from './tutorial_cards'
import { DEV_COLLAPSE_FOCUS, FOCUS_STEPS, TUT_FOCUS, currentLesson, tutorialLessonsFor, type FocusTargetId, type FocusTextPos } from './tut_focus'
import { isHitCollisionActive, meleeStrikeNow } from './hits'
import { strikeWorldInterval } from './combat_geometry'
import { getKeyBindings, inputDeviceView, keyCaptureView } from './input'
import { kbmCodeLabel, padButtonLabel } from './key_bindings'
import { CONTROLS_CLOSE_INDEX, CONTROLS_PANEL, CONTROLS_RESET_INDEX, CONTROLS_ROWS, controlsButtonRect, controlsCellRect, controlsFixedRowTop, controlsPanelX, controlsRowTop } from './controls_panel'
import { CREDITS_PANEL, creditLineHeight, creditLines, creditsCloseRect, creditsMaxScroll, creditsPanelX } from './credits'
import { inputLabel, resolveInputText } from './input_labels'
import { audioUnlocked } from './audio'
import { drawKnightSpearTrail, getKnightLeapFx } from './knight_spear_trail'
import { drawKnightCrossArc } from './knight_cross_arc'
import { drawVeilHandsActive, drawVeilHandsLinger, drawVeilHandsTelegraph, getBrideVeilFx, isVeilHandsFx } from './bride_veil_hands'
import { drawVeilClothActive, drawVeilClothLinger, drawVeilClothTelegraph } from './bride_veil_cloth'
import { drawVeilTsunamiActive, drawVeilTsunamiLinger, drawVeilTsunamiTelegraph, VEIL_TSUNAMI_KINDS, veilTsunamiDir, type VeilTsunamiKind } from './bride_veil_tsunami'
import { drawVeilRiseActive, drawVeilRiseLinger, drawVeilRiseTelegraph, VEIL_RISE_KINDS, type VeilRiseKind } from './bride_veil_rise'
import { brideVeilCurtain, paintVeilCurtainLayer } from './bride_veil_wallcloth'
import { drawVeilSidesActive, drawVeilSidesLinger, drawVeilSidesTelegraph, isVeilSidesKind, type VeilSidesKind } from './bride_veil_sides'
import { drawBladeHemActive, drawBladeHemLinger, drawBladeHemTelegraph, getBladeHemFx } from './blade_hem_bloom'
import { drawHoundRoarActive, drawHoundRoarLinger, drawHoundRoarTelegraph, getHoundRoarFx } from './hound_roar_floor'
import { drawButtCrackActive, drawButtCrackLinger, drawButtCrackTelegraph, drawLanceStar, getKnightButtFx, getKnightThrustFx } from './knight_lance_fx'
import { KNIGHT_CROSS_HOP_AT_MS, KNIGHT_LEAP_AIR_MS, knightCrossForwardPx, knightCrossLiftY } from './knight_leap_slash'
import { knightSuriDust } from './knight_suri_dust'
import { knightStepDust } from './knight_step_dust'
import { currentDodgeVariant, dodgeSettleMs, dodgeTrailOn, dodgeTrailStyle, dodgeTravelMs, dodgeVisualLeadPx } from './player_locomotion_trial'
import { EXECUTIONER, executionerMorphTiming, executionerStepVisual } from './executioner_weapon'
import { findContactKey, getExecutionerScoopVariant, getKnightSweepVariant, getKnightSweepLink, type BossPoseMotion } from './boss_pose_timeline'
import {
  TITLE_MENU_LEFT, TITLE_MENU_ROW_H, TITLE_MENU_TEXT_OFFSET_X, TITLE_MENU_FONT_PX,
  DIFFICULTY_LEFT_NAME, DIFFICULTY_START_Y, DIFFICULTY_NAME_ROW_H, DIFFICULTY_NAME_FONT_PX,
  DIFFICULTY_DESC_LINE_H, DIFFICULTY_DESC_GAP, DIFFICULTY_TAIL_GAP,
  PAUSE_MAIN_PANEL_W, PAUSE_MAIN_PANEL_Y, PAUSE_MAIN_ROW_H, PAUSE_MAIN_FIRST_ROW_OFFSET_Y, PAUSE_MAIN_FONT_PX,
  PAUSE_SETTINGS_PANEL_W, PAUSE_SETTINGS_PANEL_Y, PAUSE_SETTINGS_ROW_H, PAUSE_SETTINGS_FIRST_ROW_OFFSET_Y, PAUSE_SETTINGS_FONT_PX,
  ENDING_CHOICE_OFFSET_X, ENDING_CHOICE_Y_FRAC, ENDING_CHOICE_FONT_PX,
  NEW_GAME_CONFIRM_LEFT, NEW_GAME_CONFIRM_EYEBROW_Y, NEW_GAME_CONFIRM_BODY_Y, NEW_GAME_CONFIRM_BODY_LINE_H,
  NEW_GAME_CONFIRM_CHOICE_Y, NEW_GAME_CONFIRM_ROW_H, NEW_GAME_CONFIRM_FONT_PX, NEW_GAME_CONFIRM_ITEMS,
  TITLE_MENU_LABELS, titleMenuItems, newGameConfirmRects,
  titleMenuRects, titleMenuTop, difficultyMenuRects, pauseMainRects, pauseMainItems, pauseSettingsRects, endingChoiceRects,
  type MenuRect,
} from './menu_layout'
import {
  DEFEAT_OVERLAY_TIMING_SEC,
  defeatDifficultyHintVisible,
  defeatOverlayTimeline,
} from './defeat_overlay_timing'
import { applyCamZoomTransform, blitCamZoom, camZoomView, camZoomX, camZoomY, currentAwokenCamTune, updateCamZoom, type CamZoomInput } from './cam_zoom'
import { compensateShadowBlur, renderScale } from './render_scale'
import { drawLunaNormalFx } from './luna_unravel_fx'
import { advanceBossRise, bossRiseBlend, bossRiseFitOn, bossRiseHoldMs, bossRiseKey } from './boss_rise'
import { ALICE, THRUST, aliceBurstAtClock, aliceClockMs, aliceDashOffsetPx, aliceDashTargetX, aliceGrayAmount, execCrackPosOld, lampExecBossHold, lunaExecPierceOn, lunaExecSwapOn, normalExecAnim, pullBossJoltPx, pullTimingOn, thrustTimingOn } from './luna_exec_swap'
import { type PierceSilhouette, drawPierceFx, pierceBgDark, pierceBodyAlpha, pierceBossShake, pierceCrumbleThreshold, pierceSinceHitMs, pierceSpill } from './luna_pierce_fx'
import { aliceLampSeamExtentY, drawLunaAliceFx } from './luna_alice_fx'
import { brideKaeshiOn, drawBrideKaeshi } from './bride_kaeshi'
import { drawBrideKaeshiBlade } from './bride_kaeshi_blade'
import { drawBladePullRibbon } from './blade_dancer_pull_ribbon'
import { BLADE_THROW_ID, drawBladeKnife, drawBladeThrowHand } from './blade_dancer_throw_knife'
import { drawBladeFxV2 } from './blade_dancer_fx_v2'
import { drawBrideKaeshiTrail } from './bride_kaeshi_tween'
import { drawBrideHugFront } from './bride_redraw_1023'
import { drawBrideHugHearts } from './bride_hug_bind'
import { execAuraMist } from './exec_aura'
import { drawRoosterEyeGlint, drawRoosterFrenzyCue, drawRoosterRushFluff, drawRoosterFeatherActive, drawRoosterFeatherLinger, drawRoosterFeatherTelegraph, drawRoosterStompFx, isRoosterFeatherHit, roosterFx } from './rooster_fx'
import { MIST_FORMS, MIST_STEPS, SHELL_FLY_CORE_R, SHELL_FLY_CORE_X, drawMat, execSwingBrushOn, execSwingLite, mistReady, mistSprite, preloadExecFxMats, shellFlyReady, shellFlySprite, swingReady, swingSprite, tinted } from './exec_fx_mats'
import { KNIGHT_ARC_CHORD, knightArcFrame, knightArcLook, knightArcReady, knightArcSprite, preloadKnightArc } from './knight_arc_brush'
import { drawExecStepDust, execStepDustReady, execStepFxMode } from './exec_step_dust'
import { drawEmberShot, drawEmberShotBreak, drawExecFinisherFlame, drawShotMuzzleFlame, execShotFxOn, SHOT_MUZZLE_FLAME_MS } from './exec_fx'
import { twinsActMarks, twinsBgSrc, twinsFightOn } from './twins_fight'
import { advEntryHolding } from './battle_asset_gate'
import { drawLoadingMoon, loadingAlpha, loadingLook, LOADING_X, LOADING_Y, TITLE_BOOT_WAIT_MAX_MS } from './loading_indicator'
import { drawTwinsFight } from './twins_fight_draw'
import { titleV9, titleV9Font, TITLE_V9_BG, TITLE_V9_MENU_ROW_H, TITLE_V9_MENU_TOP } from './title_v9'
import { UI_SERIF, uiSans } from './ui_font'
import { drawFloorWarnFront, drawFloorWarnUnder } from './floor_warn_vis'

// 花嫁 v3 rev2 (2026-07-01): 素材両端はソフトフェード = crop して濃い部分を判定幅全体に scaleX で伸ばす。
//   目的 = 「絵として見えてる範囲 = 判定範囲」 の一致 (UI 帯や色シフトの警告不要)。
//   per-kind:
//     poison_mist は中央集中の霧塊で両端の疎な部分が多い → 15% で中央 70% を使う (判定端まで濃く)
//     veil / thorn_growth は端まで濃く描かれてる → 6% で中央 88% を使う
const HAZARD_CROP_FRAC = { poison_mist: 0.15, veil_stream: 0.06, thorn_growth: 0.06 } as const

// drawPlayer 内 walking 検出用 dt 計算のため直前 draw 時刻を保持
let prevPlayerDrawTime = 0
// 被弾フリンチ override の強制リスタート検知用 (多段2発目を頭から見せる)。 直前に hurt を出した nonce。
let prevPlayerHurtNonce = 0
// ガード解除の尾 (描画専用)。 ガードは parry の受け姿を止めているだけなので、 離したら
//   idle へ飛ばさずに parry の続き = ほどく動きを最後まで流す。 state.time (秒) の期限。
//   ゲーム側は従来どおり即 idle (離すと即解除・spec 1) = 判定も操作も止めない。
let guardTailUntil = -1
let prevPlayerWasGuarding = false
// 連撃をやめた時の戻りの尾 (描画専用)。 1・2段目は構え直しの姿で終わるので、 次を押さずに idle へ戻ったら
//   素立ちへ飛ばさずに attack_settle (構え → 素立ち) を流す。 state.time (秒) の期限。 ゲーム側は従来どおり即 idle。
let attackSettleUntil = -1
// 回避が明けた後、操作しない間だけ回避のアニメの残り (低く止まって立つ) を見せる (回避 d・10-07)
let dodgeSettleUntil = -1
let prevPlayerWasStepping = false
// 致命を弾いて押された後の、重い受けの姿からのほどきの尾 (DEV ?execPush=new・src/exec_parry.ts)。ガード解除の尾と同じ作り。
let prevPlayerWasHeavy = false
let heavyTailUntil = -1
// 受け身 (10-21・src/ukemi.ts): いま出している弾きの t と姿・ガードで受けた出来事の t。
let ukemiSparkT = -1
let ukemiAnim: string | undefined
let ukemiGuardT = -1
let ukemiGuardShowing = false
// 受け身の押し戻しで x が動いたのを「歩き」と取り違えない (updatePlayerAnimState は x の動きだけで歩きを決める)。
let ukemiPrevClock: number | undefined
let ukemiPrevX: number | null = null
let ukemiPrevRem = 0
function walkedByInput(p: Player): boolean {
  const rem = p.knockbackRemainingPx ?? 0
  const moved = ukemiPrevX !== null && Math.abs(p.x - ukemiPrevX) > 0.05
  const pushed = rem !== 0 || ukemiPrevRem !== 0
  ukemiPrevX = p.x
  ukemiPrevRem = rem
  return moved && !pushed
}
let prevPlayerAttack: { step: number, isCounter: boolean } | null = null

// プレイヤー描画に使う時計 (純関数・テスト対象)。
//   🔴 **state.time だけを見てはいけない。**
//   開幕の名乗り中 (`bossIntroHolding`・2026-07-19 `e9fcb5d` で導入) は戦闘シムが止まり、
//   **state.time は進まず bossIntroMs だけが進む**。 time だけで dt を取ると名乗りの 1.8 秒は
//   ずっと dt=0 になり、 Spine が 1 コマも進まない = 直前の姿のまま固まる。
//   再演 (リトライ) 直後は直前の姿が defeat (伏せ) なので、 **LUNAIRE が倒れたまま名乗りが終わる**
//   (2026-07-22 ユーザー実機報告・「クリックすると起きる」= スキップで time が動き出すため)。
//   → 名乗りカード自身の時計と同じく **和** を使う (停止中は bossIntroMs が、 解除後は time が
//     進むので、 和は必ず連続する)。 導入戦 (名乗り無し) は bossIntroMs=0 のまま = time と等価。
export function playerDrawClock(timeSec: number, bossIntroMs: number): number {
  return bossIntroMs / 1000 + timeSec
}

// プレイヤー描画に渡す dt と「時間が巻き戻ったか」を決める (純関数・テスト対象)。
//   時計は 再演(リトライ) / タイトルへ戻る / __setBoss で 0 へ戻るが、 直前 draw 時刻は
//   モジュール変数なので前の戦闘の終了時刻を保持したままになる。 差を Math.max(0, …) で潰すと
//   **前の戦闘が続いた秒数のあいだ dt が 0** になり、 Spine の update(0) が進まず、
//   保持していた defeat (伏した姿) のまま次の戦闘が始まる (2026-07-22 実機バグ)。
//   → 巻き戻りは 1 フレームぶん進めて通常の mix に乗せる。
export function playerDrawDt(time: number, prevTime: number): { dt: number, rewound: boolean } {
  const raw = time - prevTime
  return raw < 0 ? { dt: FIXED_DT, rewound: true } : { dt: raw, rewound: false }
}

// 被弾フリンチ (hurt) の総尺。 hits.ts の `hurtVisualUntil: time + 0.4` と対になる値。
//   ⚠️ hits.ts 側を変えたらここも合わせること (片方だけ変えると出始めがズレる)。
const HURT_VISUAL_SEC = 0.4

// 2026-07-22 ユーザー裁定で HURT_ONSET_DELAY_SEC (出始め遅延) 方式は撤去。
//   のけぞりは被弾と同時に出す (「被弾 → のけぞる → 立て直す」)。 重なりの解消は
//   下の whiffedParryHiddenByFlinch (空振りパリィの姿を隠す側) で行う。
export function hurtFlinchVisible(time: number, hurtVisualUntil: number): boolean {
  return time < hurtVisualUntil
}

// 被弾して始まった空振りパリィか (純関数・テスト対象)。
//
// ユーザー裁定 2026-07-22:「見え方 = 被弾 → のけぞる → 立て直す」
//   ジャストパリィを狙って遅れ、被弾直後にパリィが出ると、のけぞり(体が沈む・後ろ) と
//   パリィ(腕が上がる・前) が Spine の既定クロスフェード 0.12 秒で混ざり、
//   どちらでもない中途半端な姿を通る = ユーザーの言う「重なってる」。
//   → この空振りパリィは **パリィが終わるまで** 姿を出さない (のけぞり → 立て直す の 1 本にする)。
//
// ⚠️ 「のけぞりが終わるまで」では駄目。 空振りパリィは 470ms
//    (startup 0 + active 200 + recovery 120 + wastedParryStiffness 150) 続くのに
//    のけぞりは 400ms しかなく、差の 70ms で**パリィの尻尾だけが出る**。
//    実測でそれが「押してから 300ms 後にパリィが出る」に化けた (不採用案)。
// ⚠️ 2026-07-23 (3度目の修正): 旧実装は「1 発でも吸収したら (parryAbsorbed) 隠さない」としていた。
//    「弾いたのに姿が出ないのは嘘になる」という理由。 だがこれが**バタバタの残った原因**だった。
//    ── 遅れパリィが連撃の次弾を弾く (parryAbsorbed) と、のけぞり(剣が下・後ろ)から
//    パリィ(剣が上・前)へ **のけぞりの窓の内側で** 切り替わり、Spine の既定クロスフェード0.12sで
//    逆方向の姿が混ざる。 scripts/probe_anim_flutter.mjs で実測: rapier が 1回の混色で
//    約 −16度 → +133度 と 150度 近く振れて戻る = ユーザーの言う「バタバタ」。
//    → **吸収しても隠す**。 パリィの手応え (spark / hitStop / 揺れ / ボスのけぞり・崩し) は
//    プレイヤーの姿とは独立に hits.ts が出す FX なので、姿を隠しても「弾いた」実感は消えない。
//    見え方はユーザー裁定どおり「被弾 → のけぞる → 立て直す」の1本に戻る (切り替わり・混ざりゼロ)。
//    ※ 隠すのは「被弾の窓の内側で始まったパリィ」だけ。 通常のパリィ (被弾直後でない) や、
//    　のけぞりの窓を過ぎてから押したパリィ (parryStartedAt >= hurtVisualUntil) は従来どおり出る。
export function whiffedParryHiddenByFlinch(
  time: number,
  playerState: PlayerVisualState,
  stateElapsedSec: number,
  hurtVisualUntil: number,
): boolean {
  if (playerState !== 'parrying') return false
  const hitAt = hurtVisualUntil - HURT_VISUAL_SEC
  const parryStartedAt = time - stateElapsedSec
  // 被弾の瞬間以降・のけぞりの窓の内側で始まったパリィだけが対象
  return parryStartedAt >= hitAt && parryStartedAt < hurtVisualUntil
}

// 被弾の窓の内側で始まったパリィが長押しでガードへ化けた場合、のけぞりが終わるまで
// ガードの姿を出さない (2026-07-23 バタバタ3度目の正体・実測=遅延60-120msで hurt->guard_in が103度混色)。
//   パリィ隠し (そのパリィが終わるまで) と違い、ガードは意図した構えなので「窓明けまで遅延」に留める。
//   連鎖の開始時刻はフィールド追加なしで逆算できる: guarding の開始 = time - stateElapsed、
//   その直前の parry の開始 = guarding開始 - (parryStartupMs + parryActiveMsEffective)/1000
//   (enterGuarding は parryActiveMsEffective を持ち越す・player.ts:325-334)。
export function guardPoseHiddenByFlinch(
  time: number,
  playerState: PlayerVisualState,
  stateElapsedSec: number,
  hurtVisualUntil: number,
  parryActiveMsEffective: number,
): boolean {
  if (playerState !== 'guarding') return false
  if (time >= hurtVisualUntil) return false          // のけぞりの窓が明けたら普通に見せる
  const hitAt = hurtVisualUntil - HURT_VISUAL_SEC
  const guardStartedAt = time - stateElapsedSec
  const chainParryStartedAt = guardStartedAt - (PLAYER.parryStartupMs + parryActiveMsEffective) / 1000
  // 被弾の瞬間以降・のけぞりの窓の内側で始まった連鎖だけが対象 (窓の外で構えたガードは普通に見せる)
  return chainParryStartedAt >= hitAt && chainParryStartedAt < hurtVisualUntil
}

// =====================================================================
// カメラ (2026-07-27) — 舞台を画面より広く取り、二人の中点を追って横に動かす
// =====================================================================
//   ⚠️ **既定は無効 = 画面座標がそのままワールド座標** (このファイルの他の全コードの前提)。
//      無効の間 cameraX は常に 0 なので、描画結果は導入前と 1px も変わらない。
//   有効にできるのは main.ts の `import.meta.env.DEV` 配下のキーだけ。
//   広げた舞台 (balance.ts の setArenaWidthMul) とセットで使う。
//   ⚠️ カメラは **世界の層だけ** に効かせる。HUD・ADV・選択肢・タイトル・ヴィネットは
//      draw() の ctx.restore() より後にあるので、ここでは一切触らない。
let cameraOn = false
let cameraX = 0            // ビューポート左端のワールド x
let cameraSettled = false  // 初回は補間せず即座に合わせる (戦闘開始で画面が滑らない)
let cameraWorld: { left: number; right: number } = { left: 0, right: ARENA.width }
let cameraLastTime = 0

const CAMERA_DEADZONE_PX = 70   // 中心からこの幅は追わない = 小刻みな揺れで画面が動かない
// ※ 旧 CAMERA_EDGE_PX (見切れ防止の内側マージン) は不要になった。
//    🔴 2026-09-06 訂正＝ 当初は「二人の距離を PAIR_LEASH_PX = 560 で縛っているから」と
//    書いていたが、その縄自体を撤去した (balance.ts 参照)。「画面から人が消えない」根拠は
//    縄ではなく**部屋の壁**＝全ボスの部屋の幅 (最大840px) が画面幅 (960px) より狭く、
//    可動域が丸ごと1画面に収まるため (docs/candidates/2026-09-06-camera-smash-style-fable-design.md §2)。
const CAMERA_LERP_PER_SEC = 5   // 追従の速さ (大きいほど張り付く)
// 背景がカメラに対して動く割合 (0=貼り付き / 1=世界と同速)。
//   🔴 **この背景は「遠景」ではなく「いま立っている部屋」** なので、本来は 1.0 (世界と同速) が正しい。
//      0.25 では動いていないようにしか見えず、逆に気持ち悪くなる (2026-07-27 ユーザー判定)。
//      1.0 にできない理由は絵だけ = 横長の本番背景がまだ無い。仮の埋め方 (下の drawBackground) が
//      持ちこたえる範囲として 0.6 を置く。**本番背景が入ったら 1.0 にする。**
//   ⚠️ **背景の絵によって正解が違う** (2026-07-28)。
//     ・横長の本番背景 (縦横比 3 超) = 世界の幅ぶん描いてある → **1.0** (世界と同速)。
//       この絵は「いま立っている部屋」そのものなので、ズレて流れると嘘になる。
//     ・従来の 1枚絵 (1672x941 = 1.78:1) = 画面1枚ぶんしか無い → 引き伸ばして埋める仮処理。
//       1.0 にすると引き伸ばし量が跳ね上がって破綻するので **0.6** に留める (2026-07-27 実表示)。
//   ⚠️ **舞台1倍 (= 配布版) では両者とも結果が同じ**。 span が 0 なので視差は効かない。
// 「横長の本番背景」と判定する縦横比の下限。 従来の1枚絵は 1.78 なので余裕で下回る。
//   2026-07-28: 騎士の新背景 knight-hall-v2.png (2.978:1) を等倍・中央寄せ経路に通すため
//   3 → 2.5 へ下げた。他の部屋は 1.78:1 のままなので判定は変わらない。
const WIDE_BG_MIN_ASPECT = 2.5
const BG_PARALLAX_FLAT = 0.6
const BG_PARALLAX_WIDE = 1.0
// いま描いている背景が横長の本番素材か。 drawBackground の入口で毎フレーム決まる。
let bgWide = false
// 覚醒王の部屋は柱 (世界の座標・1.0 倍) と同じ速さで流す (2026-10-27・配布版の既定・旧＝DEV ?awokenFloor=old)。
//   作者「カメラが動く時に、柱が床の上を滑るように見えた」「柱だけ独立して揺れているように見える」。
//   0.6 倍だと柱の台座が床の上を最大 86px 滑り、 画面の揺れも柱にだけ掛かっていた。 部屋の絵ごと柱に固定し、 柱は背景と同じく揺らさない
//   (奥行きの視差は無くなる・絵は縦横おなじ倍率で 1.135→1.225 倍に拡大＝床の線は動かない)。
let awokenRoomLock = true
let bgLocked = false
/** 開発版の ?awokenFloor=old だけが呼ぶ (main.ts)。 */
export function useAwokenRoomSlide(): void { awokenRoomLock = false }
function bgParallax(): number { return bgWide || bgLocked ? BG_PARALLAX_WIDE : BG_PARALLAX_FLAT }

export function setCameraEnabled(on: boolean): void {
  cameraOn = on
  if (!on) { cameraX = 0; cameraSettled = false }
}
export function isCameraEnabled(): boolean { return cameraOn }
/** 撮影の道具だけが読む (いまのカメラの左端と、 大技で縮めている倍率)。 */
export function cameraDebugNow(): { cameraX: number; far: number } { return { cameraX, far: farNow } }
// 世界の層に置かれた「全画面塗り」用。 カメラ分ずらした画面矩形をワールド座標で返す。
function screenRectInWorld(): { x: number; w: number } {
  return { x: cameraX, w: ARENA.width }
}
// 縁取り用オフスクリーンは「画面と同じ大きさ」なので、中身も画面座標で描く必要がある。
//   バッファへ描く時に -cameraX、合成する時に +cameraX (bufferRect)。 無効時はどちらも 0。
// オフスクリーンが映す世界の範囲。 普段は画面と同じ (cameraX から画面幅)。
//   覚醒王の大技で縮めている間 (farNow < 1) は、 縮めて見えている広さ全体を映す (2026-10-29)。
//   画面と同じ範囲のままだと、 縮める前の画面の外にいる体が縦の線で切れ、 作者には「技中、壁の向こう側に体がなくなって」見えた。
function bufferRect(): { x: number; y: number; w: number; h: number } {
  if (farNow === 1) return { x: cameraX, y: 0, w: ARENA.width, h: ARENA.height }
  const w = ARENA.width / farNow, h = ARENA.height / farNow
  return { x: cameraX + ARENA.width / 2 - w / 2, y: ARENA.floorY - ARENA.floorY / farNow, w, h }
}
// オフスクリーンを世界の層へ戻す (dx・dy = 縁取りのずらし)。
function drawBufferToWorld(ctx: CanvasRenderingContext2D, canvas: CanvasImageSource, dx = 0, dy = 0): void {
  const r = bufferRect()
  ctx.drawImage(canvas, r.x + dx, r.y + dy, r.w, r.h)
}

// オフスクリーンへ「画面座標で」描き直す準備。 消去 → カメラのズレを乗せる、の順で行う。
//   🔴 **ズラした座標系のまま clearRect すると端に消え残りの帯ができる。**
//      その帯へ毎フレーム上書きされ、絵が四角く積もる (2026-07-27 実際に発生・カメラ導入時)。
//      消去はキャンバス全面 (device 座標) へ掛けること。
function resetOutlineBuffer(bctx: CanvasRenderingContext2D): void {
  bctx.setTransform(1, 0, 0, 1, 0, 0)
  bctx.clearRect(0, 0, bctx.canvas.width, bctx.canvas.height)
  const r = bufferRect(), k = renderScale() * ARENA.width / r.w
  bctx.setTransform(k, 0, 0, k, -r.x * k, -r.y * k)
}

// 背景を貼る座標系 (視差つき)。 世界の左端にタイル0の左端を合わせる = 倍率1なら常に 0。
function bgParallaxShift(): number {
  return -(cameraX - cameraWorld.left) * bgParallax()
}
// 視差つきで動かした時に画面を覆いきるのに必要な背景の横幅 (px)。
//   🔴 **タイルで並べない。** 鏡像タイルは門・柱が繰り返して「絵が壊れている」ようにしか見えなかった
//      (2026-07-27 実表示で確認)。1枚を必要な幅まで横に伸ばすほうが、仮でも絵として成立する。
//   本番の横長背景 (gpt-image-2 発注) に差し替えたら、伸ばさず等倍で貼る。
function bgSpanPx(): number {
  const span = Math.max(0, (cameraWorld.right - cameraWorld.left) - ARENA.width)
  return ARENA.width + span * bgParallax()
}
// 床・塵・霧が敷き詰める範囲 (ワールド座標)。 倍率1なら 0..ARENA.width = 従来と同じ。
function worldSpan(): { left: number; right: number } { return cameraWorld }

// 覚醒王の大技の間は、 カメラを部屋の中央に固定し、 部屋の端から端 (柱から柱) までを1画面に縮めて映す (2026-10-27)。
//   作者「その大技の時は、カメラを中央で固定して、全体が映るようにしてほしい」
//   「飛んできても、画面のカメラ内に入らないと見えなくて、理不尽さがある」「ボス本体もカメラ外から飛んでくる感じがする」。
//   縮める倍率 = 画面幅 / 壁から壁の幅 (広い舞台なら 960/1176 ≈ 0.82)。
//   🔴 カメラの余白まで含めた世界の幅 (1656) で割らない。 0.58 まで縮んで絵の上が空き、 部屋の灯りが宙に浮いて見えた (2026-10-29)。 中心は (画面の中央, 床の線) = 床の高さは変わらない。
//   部屋の絵は 1.0 倍で 1.225 倍に拡大して貼っている (bgLocked) ので、 縮めるとちょうど画面を覆う。
//   引く時は速く (6/秒・予告の引きと同じ)、 戻す時はゆっくり (1.5/秒)。 戻る間はカメラの横も中央から追従の位置へ戻す。
const FAR_OUT_RATE = 6
const FAR_IN_RATE = 1.5
let cameraFollowX = 0      // 追従だけで決めたカメラ (縮めている間の中央寄せを混ぜる前)
let farNow = 1
let farLastTime = 0
function farMin(state: GameState): number {
  if (!state.boss) return 1
  const walls = arenaBoundsFor(state.boss.id)
  const roomW = walls.rightWall - walls.leftWall
  return roomW <= ARENA.width ? 1 : ARENA.width / roomW
}
// 大技以外は、 二人 (体の幅の余白込み) が 960 に入りきらない時だけ、 入る分だけ縮める (2026-10-29)。
//   作者「赤攻撃の突進とかで毎回極限までカメラを引いたり」→ 突進・壁走りは大技の引きから外した。
//   ただし広い舞台では壁から壁 (1176) が画面より広く、 壁走りで反対の壁へ張りつくと、 構えの間ボスの体が画面の端で半分切れた。
const PAIR_FIT_MARGIN_PX = 150
function pairFitFar(state: GameState): number {
  const fMin = farMin(state)
  if (fMin >= 1 || !state.boss) return 1
  const gap = Math.abs(state.player.x - state.boss.x) + 2 * PAIR_FIT_MARGIN_PX
  return gap <= ARENA.width ? 1 : Math.max(fMin, ARENA.width / gap)
}
function farTarget(state: GameState): number {
  if (!cameraOn) return 1
  if (!awokenCamPullBack(state.boss)) return pairFitFar(state)
  return farMin(state)
}
// 広い舞台では、 追従の遅れで二人が画面の外へ出ないよう、 縮めた後に見えている広さへ二人を押し込む。
//   押し込んだ分は追従の位置にも足す (足さないと、 押し込みが外れた1コマでカメラが 84px 跳んだ＝壁走りの折り返し)。
function clampPairInView(state: GameState): void {
  if (!state.boss || farMin(state) >= 1) return
  const half = ARENA.width / 2 / farNow
  const lo = Math.min(state.player.x, state.boss.x) - PAIR_FIT_MARGIN_PX
  const hi = Math.max(state.player.x, state.boss.x) + PAIR_FIT_MARGIN_PX
  const c = cameraX + ARENA.width / 2, before = cameraX
  if (hi - lo >= 2 * half) cameraX = (lo + hi) / 2 - ARENA.width / 2
  else if (lo < c - half) cameraX = lo + half - ARENA.width / 2
  else if (hi > c + half) cameraX = hi - half - ARENA.width / 2
  cameraFollowX += cameraX - before
}
function updateFarView(state: GameState): void {
  const target = farTarget(state)
  const dt = Math.max(0, Math.min(0.1, state.time - farLastTime))
  farLastTime = state.time
  if (target === 1 && farNow === 1) { if (cameraOn) clampPairInView(state); return }
  const rate = target < farNow ? FAR_OUT_RATE : FAR_IN_RATE
  farNow += (target - farNow) * (1 - Math.exp(-rate * dt))
  if (Math.abs(farNow - target) < 1e-3) farNow = target
  const fMin = farMin(state)
  const k = fMin < 1 ? Math.max(0, Math.min(1, (1 - farNow) / (1 - fMin))) : 0
  const center = (cameraWorld.left + cameraWorld.right) / 2 - ARENA.width / 2
  cameraX = cameraFollowX + (center - cameraFollowX) * k
  if (cameraOn) clampPairInView(state)
}
// 縮めて映す変換 (draw の頭で掛け、 画面の寄せの切り取りの前に外す)。
function applyFarView(ctx: CanvasRenderingContext2D): void {
  if (farNow === 1) return
  ctx.translate(ARENA.width / 2, ARENA.floorY)
  ctx.scale(farNow, farNow)
  ctx.translate(-ARENA.width / 2, -ARENA.floorY)
}
// 縮めた後の画面座標 (世界の層より後に描く画面の効果の中心を、 縮めた絵に合わせる)。
function farX(x: number): number { return farNow === 1 ? x : ARENA.width / 2 + (x - ARENA.width / 2) * farNow }
function farY(y: number): number { return farNow === 1 ? y : ARENA.floorY + (y - ARENA.floorY) * farNow }

function updateCamera(state: GameState): void {
  cameraX = cameraFollowX
  updateCameraFollow(state)
  cameraFollowX = cameraX
  updateFarView(state)
}
function updateCameraFollow(state: GameState): void {
  cameraWorld = cameraOn ? worldBoundsFor(state.boss?.id) : { left: 0, right: ARENA.width }
  if (!cameraOn) { cameraX = 0; cameraSettled = false; return }
  const span = Math.max(0, (cameraWorld.right - cameraWorld.left) - ARENA.width)
  const px = state.player.x
  const bx = state.boss ? state.boss.x : px
  // 二人の中点を画面中央へ。
  //   🔴 2026-09-06 訂正＝ 当初は「距離を PAIR_LEASH_PX (560) で縛っているので画面幅 (960) より
  //   狭い」と書いていたが、その縄は撤去した。「二人が画面に入りきらない場合が構造的に起きない」
  //   根拠は縄ではなく**部屋の壁**＝全ボスの部屋の幅 (最大840px) が画面幅より狭いこと
  //   (docs/candidates/2026-09-06-camera-smash-style-fable-design.md §2)。 例外分岐は持たない。
  let want = (px + bx) / 2 - ARENA.width / 2
  want = Math.max(cameraWorld.left, Math.min(cameraWorld.left + span, want))
  if (!cameraSettled) { cameraX = want; cameraSettled = true; cameraLastTime = state.time; return }
  // dt は state.time の差分 (秒)。 巻き戻し/大きな飛びは 0.1s で頭打ちにする。
  const dt = Math.max(0, Math.min(0.1, state.time - cameraLastTime))
  cameraLastTime = state.time
  const err = want - cameraX
  const over = Math.abs(err) - CAMERA_DEADZONE_PX
  if (over > 0) cameraX += Math.sign(err) * over * (1 - Math.exp(-CAMERA_LERP_PER_SEC * dt))
  cameraX = Math.max(cameraWorld.left, Math.min(cameraWorld.left + span, cameraX))
}

export type RenderOptions = {
  hideBackdrop?: boolean
  hideHud?: boolean
  bossSilhouette?: boolean
  // 実験用フラグ (2026-09-01・王/dream-hound の houndBite だけ対象): 既定 undefined = 従来どおり
  // 一切変わらない。true の時だけ drawBoss が Spine 経路を試み、対象外なら黙って既存絵へ戻る。
  bossSpine?: boolean
}

let bossSilhouetteCanvas: HTMLCanvasElement | null = null

// ラボ専用の輪郭検査。現在の描画変換をそのまま別キャンバスへ写し、ボスの画素だけ黒で塗る。
// drawBoss 自体は共通経路を通るため、タイムライン・接地・向き・描画probeは実機と同じ。
function drawBossAsSilhouette(ctx: CanvasRenderingContext2D, state: GameState, opts?: RenderOptions): void {
  const source = ctx.canvas
  if (!bossSilhouetteCanvas) bossSilhouetteCanvas = document.createElement('canvas')
  if (bossSilhouetteCanvas.width !== source.width || bossSilhouetteCanvas.height !== source.height) {
    bossSilhouetteCanvas.width = source.width
    bossSilhouetteCanvas.height = source.height
  }
  const bctx = bossSilhouetteCanvas.getContext('2d')
  if (!bctx) { drawBoss(ctx, state, opts); return }

  bctx.setTransform(1, 0, 0, 1, 0, 0)
  bctx.globalCompositeOperation = 'source-over'
  bctx.clearRect(0, 0, bossSilhouetteCanvas.width, bossSilhouetteCanvas.height)
  bctx.setTransform(ctx.getTransform())
  drawBoss(bctx, state, opts)
  bctx.setTransform(1, 0, 0, 1, 0, 0)
  bctx.globalCompositeOperation = 'source-in'
  bctx.fillStyle = '#000'
  bctx.fillRect(0, 0, bossSilhouetteCanvas.width, bossSilhouetteCanvas.height)
  bctx.globalCompositeOperation = 'source-over'

  ctx.save()
  ctx.setTransform(1, 0, 0, 1, 0, 0)
  ctx.drawImage(bossSilhouetteCanvas, 0, 0)
  ctx.restore()
}

const retainWashSparks = createWashSparkRetention<FxEvent>()
let washEncounter: string | undefined
// 「毛先の紫」の比較版 (DEV ?parryLook=kesaki) の接点の光が止めの進みを読むための、いまのコマの止めの残り (drawFx へ渡す)。
let kesakiHitStop = 0

// 致命を弾いた時の押し戻しの重さ (既定 c・DEV ?execPushWeight=off|a|b で比較・src/exec_push_weight.ts)。光の長い残りに版の印 (pw) がある間だけ。
type PushWeightLook = { f: Extract<FxEvent, { kind: 'exec_parry_glow' }>; spec: PushWeightSpec; clockMs: number; zoom: number; pivot: { x: number; y: number } }
function activePushWeight(state: GameState): PushWeightLook | null {
  if (state.phase !== 'playing' || execParryFxNew()) return null
  let f: Extract<FxEvent, { kind: 'exec_parry_glow' }> | undefined
  for (const e of state.fx) if (e.kind === 'exec_parry_glow' && e.pw && state.time >= e.t && (!f || e.t >= f.t)) f = e
  if (!f || !f.pw) return null
  const spec = pushWeightSpec(f.pw.v, f.pw.bossId)
  if (!spec) return null
  const clockMs = pushWeightClockMs(state.time - f.t, state.hitStopRemaining, spec)
  const pivot = pushWeightPivot(spec, f.x, f.y, f.pw.playerX, f.pw.playerY, f.pw.bossX)
  return { f, spec, clockMs, zoom: pushWeightZoom(clockMs, spec), pivot }
}

// 致命を弾いた時の「白黒＋接点へ寄る＋スロー」(既定・配布版 2026-10-14・旧は DEV ?execParryFx=old・src/exec_parry_slow_fx.ts)。
//   r = 弾いてからの実時間 (ms)。光の残りの印 (pw) がある間だけ。
type ExecSlowLook = { f: Extract<FxEvent, { kind: 'exec_parry_glow' }>; spec: ExecSlowSpec; r: number }
function activeExecSlow(state: GameState): ExecSlowLook | null {
  if (state.phase !== 'playing') return null
  const f = activeExecSlowGlow(state.fx, state.time)
  const spec = f ? execSlowSpecOf(f) : null
  if (!f || !spec) return null
  return { f, spec, r: execSlowClockMs(state.time - f.t, state.hitStopRemaining, spec) }
}

// 覚醒獣の体の中心から頭・尾の先までの幅 (画面の端で切らない保証・11-01)。
const AWOKEN_HARD_MARGIN_PX = 170
// 画面の寄せ (DEV ?camZoom=・src/cam_zoom.ts) へ渡す、 二人と予告の位置 (拡大前の画面座標)。 戦い以外の画面は null = 寄せない。
function camZoomInputOf(state: GameState): CamZoomInput | null {
  if (state.phase !== 'playing' && state.phase !== 'victory' && state.phase !== 'defeat') return null
  const threats: CamZoomInput['threats'] = []
  let topY: number | null = null
  for (const hz of state.hits) {
    // 案C: 迫撃砲は撃ってから落ちるまで、 弧の頂点 (画面の上端近く) が入るところまで引く。 出発 (450ms) 前から引き始める。
    if (hz.attackId === 'exec_cannonMortar' && !hz.follow && hz.telegraphMs > 0 && hz.elapsedMs < hz.telegraphMs) {
      topY = Math.min(topY ?? Infinity, CANNON_MORTAR_APEX_Y - CANNON_MORTAR_SHELL_R)
    }
    if (hz.follow === 'travel') {
      if (hz.consumed || hz.x === undefined) continue
      const half = (hz.widthPx ?? 40) / 2
      threats.push({ lo: farX(hz.x - half - cameraX), hi: farX(hz.x + half - cameraX) })
    } else if (!hz.follow && hz.xEnd > hz.xStart) {
      threats.push({ lo: farX(hz.xStart - cameraX), hi: farX(hz.xEnd - cameraX) })
    }
  }
  // 案C: 名乗りの「間」と決着 (勝ち・負け) は等倍。 ボスの頭 (足元 − 表示の高さ) は床より高く上がった時も画面に入れる。
  const wide = state.phase !== 'playing' || bossIntroHolding(state)
  const bossTopY = state.boss ? bossFootY(state.boss) - bossDisplayHeightFor(state.boss.id) : null
  return { playerX: farX(state.player.x - cameraX), bossX: state.boss ? farX(state.boss.x - cameraX) : null, threats, wide, topY: topY === null ? null : farY(topY), bossTopY: bossTopY === null ? null : farY(bossTopY), pullBack: awokenCamPullBack(state.boss),
    ...(state.boss?.id === 'crowned-king-awoken' ? awokenCamZoomFields() : {}) }
}
// 覚醒獣の寄せの数 (余白と寄せの上限を広げた版・src/cam_zoom.ts AWOKEN_CAM_ROOMY・11-01。 開発版 ?awokenCam=old で前の版)。
function awokenCamZoomFields(): Pick<CamZoomInput, 'bossHardMarginPx' | 'tune'> {
  const tune = currentAwokenCamTune()
  return { bossHardMarginPx: (tune?.bossHardMarginPx ?? AWOKEN_HARD_MARGIN_PX) * farNow, ...(tune ? { tune } : {}) }
}

export function draw(ctx: CanvasRenderingContext2D, state: GameState, options: RenderOptions = {}): void {
  ctx.clearRect(0, 0, ARENA.width, ARENA.height)
  // 会話場面を通らずに戦いへ入った頭で、一戦の絵を待っている間は黒と読み込み待ちの常夜燈だけ (src/battle_asset_gate.ts battleEntryStep・11-03)。
  if (state.phase === 'playing' && state.battleEntryWaitMs != null) {
    ctx.fillStyle = '#000'
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    drawLoadingIndicator(ctx, state.battleEntryWaitMs)
    return
  }
  stepHoundWalkLift(state.boss, state.time)
  updateCamera(state)
  updateCamZoom(camZoomInputOf(state), state.time)
  ctx.save() // 覚醒王の大技の間の「部屋全体を映す」縮め (applyFarView)
  applyFarView(ctx)

  // 崩した瞬間 (10-06)：接点を中心に一瞬寄って、ぶれる (背景と世界の層・HUD は動かさない)。
  const down = state.fx.find((f): f is Extract<FxEvent, { kind: 'parry_down' }> =>
    f.kind === 'parry_down' && state.time - f.t >= 0 && state.time - f.t < 0.25)
  const downCam = down ? parryDownCamera(state.time - down.t) : null
  // 普段のパリィの見た目「手本」(既定 = 配布版・2026-10-15・src/parry_tehon_fx.ts): 普段のパリィは手本が受け持ち、
  //   「毛先の紫」(src/parry_kesaki_fx.ts) は致命の弾きだけ (今のまま)。 DEV の見比べ: 毛先の紫 = ?parryLook=kesaki-default・旧の金の雲 = ?parryLook=old。
  const tehonOnNow = parryTehonOn()
  const kesaki = state.phase === 'playing' ? activeKesakiSpark(tehonOnNow ? state.fx.filter(f => !tehonOwns(f)) : state.fx, state.time) : undefined
  const tehon = state.phase === 'playing' ? activeTehonSpark(state.fx, state.time) : undefined
  const tehonSince = tehon ? kesakiClock(tehon, state.time, state.hitStopRemaining).since : 0
  if (kesakiLook() !== 'off' || tehon) beginKesakiFrame()
  const kesakiC = kesaki ? kesakiClock(kesaki, state.time, state.hitStopRemaining) : null
  // 3回目 (10-10 夜・白黒): 止めの間は世界の層を白黒にし、髪の光と背中の照り返しだけ白黒の後に色で描く (gray > 0 の間)。
  const exSlow = activeExecSlow(state)
  //   致命の弾きは白黒を実時間で長く保ち、スローの間も薄く残す (exec_parry_slow_fx.ts の execSlowGray)。
  const kesakiG = exSlow ? execSlowGray(exSlow.r, exSlow.spec) : kesakiC ? kesakiGray(kesakiC) : 0
  kesakiHitStop = state.hitStopRemaining
  // 旧の金の雲は手本の弾きを拾わない (手本の弾きが消えるまでの 0.5 秒の端で雲が出ない)。
  const bloom = kesaki || tehon ? undefined : activeParryBloom(tehonOnNow ? state.fx.filter(f => !tehonOwns(f)) : state.fx, state.time)
  ctx.save()
  if (bloom || tehon || (kesaki && !(kesaki.exec && exSlow))) {
    const z = (bloom ?? tehon ?? kesaki)!
    // 手本の案に寄りがあればそれ (DEV ?parryLook=tehon-yori)、無ければ前からの小さな寄り。
    const zoom = (z === tehon ? tehonZoom(tehonSince) : null) ?? bloomZoom(state.time - z.t, z.isJust ?? false)
    const x = z.x - cameraX, y = z.y
    ctx.translate(x, y); ctx.scale(zoom, zoom); ctx.translate(-x, -y)
  }
  if (down && downCam) {
    const dx = down.x - cameraX, dy = down.y
    ctx.translate(dx + downCam.ox, dy + downCam.oy); ctx.scale(downCam.zoom, downCam.zoom); ctx.translate(-dx, -dy)
  }
  // 致命を弾いた時の押し戻しの重さ (既定 c・src/exec_push_weight.ts): 止めの間に寄り切って、止め明けから戻る (背景ごと・HUD は動かさない)。
  const pwLook = activePushWeight(state)
  if (pwLook && pwLook.zoom !== 1) {
    const px = pwLook.pivot.x - cameraX, py = pwLook.pivot.y
    ctx.translate(px, py); ctx.scale(pwLook.zoom, pwLook.zoom); ctx.translate(-px, -py)
  }
  // 致命を弾いた時 (既定): 接点へ寄る (止めの中で寄り切り、速さが戻り始めてから引く・背景ごと・HUD は動かさない)。
  const exZoom = exSlow ? execSlowZoom(exSlow.r, exSlow.spec) : 1
  if (exSlow && exZoom !== 1) {
    const px = exSlow.f.x - cameraX, py = exSlow.f.y
    ctx.translate(px, py); ctx.scale(exZoom, exZoom); ctx.translate(-px, -py)
  }
  // 騎士の薙ぎの重さ候補 a (DEV ?sweepWeight=a) の手応えの揺れを足す。描画だけ (state.shake には触れない)。
  const sweepImpact = knightSweepImpactShake(state)
  // 致命を弾いて押される時 (DEV ?execPush=new) の、止め明けに押される向きへの揺れ。描画だけ。
  //   重さ (既定 c・?execPushWeight) が効いている間は、その版の揺れに置き換える (new の 5px の揺れは出さない)。
  //   致命を弾いた時 (既定): 速さが戻る瞬間の一突きに置き換える (押し戻しの 5px の揺れはスローの中で鈍く見えるので出さない)。
  const pushKick = exSlow ? execSlowShake(exSlow.r, exSlow.spec, exSlow.f.dir)
    : pwLook ? pushWeightShake(pwLook.clockMs, pwLook.spec, pwLook.f.dir) : execPushCameraKick(state.player, state.phase === 'playing')
  const sx = (Math.random() * 2 - 1) * state.shake.amplitude + sweepImpact.x + pushKick.x
  const sy = (Math.random() * 2 - 1) * state.shake.amplitude + sweepImpact.y + pushKick.y
  // 背景は画面シェイクの影響を受けない (静止)
  if (!options.hideBackdrop) {
    drawBackground(ctx, state.time, state.boss?.id)
    // 戴冠獣のしかかりの吠え (10-06): 背景だけを口の高さを中心に波打たせる (獣・主人公・HUD はこの後に描くので動かない)。
    applyHoundHowlWarp(ctx, state.boss, bossFootY(state.boss), PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[state.boss.id] ?? DEFAULT_BOSS_HEIGHT_RATIO))
    // 介錯の咆哮の合図の比較版 (DEV ?roarTell=v2・src/exec_roar_tell.ts): 波の帯の真上だけ背景を熱かげろうで揺らし、帯の床の目地を光らせる。配布版は通らない。
    if (import.meta.env.DEV && roarTellOn()) applyRoarTellBackground(ctx, state.hits, state.time, cameraX)
    // 介錯の咆哮の空気の衝撃波 (既定・配布版も。旧は DEV ?roarAir=0・src/exec_roar_air_fx.ts): 前縁のまわりの背景だけを外へ押すふくらみで歪ませ、裾をめくり炎を倒す。
    if (roarAirOn() && state.phase === 'playing') {
      applyRoarAirBackground(ctx, roarAirFronts(state.hits, arenaBoundsFor(state.boss.id)), cameraX,
        bossDisplayHeightFor(state.boss.id), bgWide ? null : { shiftX: bgParallaxShift(), scale: bgSpanPx() / ARENA.width })
    }
  }

  ctx.save()
  // ★ ここから ctx.restore() までが「世界の層」。 カメラの平行移動もここに乗せる
  //   (cameraX は無効時は常に 0 = 従来と同一)。
  ctx.translate(sx - cameraX, sy)

  drawDust(ctx, state.time)
  drawFloor(ctx)
  // 覚醒王の柱は背景の一部なので、 世界の層の中でも揺れを打ち消して描く (柱だけ揺れて見えた・10-27 作者「背景は揺れてないなら柱も揺らすのおかしい」)。
  if (!options.hideBackdrop) {
    const stillWalls = awokenRoomLock
    if (stillWalls) { ctx.save(); ctx.translate(-sx, -sy) }
    drawAwokenWalls(ctx, state.boss.id)
    if (stillWalls) ctx.restore()
  }
  // 最後の一撃の新しい版 (DEV ?lunaFinisher=new): 刺した姿の止めの間、背景と床だけ暗く沈める (キャラ・光はこの後に描く)。
  //   最後の一撃 C (既定・src/luna_finisher.ts FIN_C): 抜いた後も少し暗さを残し、静けさと名前の間に引いていく。
  if (state.finisher && finisherCOn()) drawBgDarkAlpha(ctx, finisherCBgDark(state.finisher.elapsedMs, state.hitStopRemaining), cameraX)
  else if (state.finisher && lunaExecPierceOn()) { const ac = aliceClockMs(state); if (ac !== null) drawBgDarkAlpha(ctx, pierceBgDark(pierceSinceHitMs(ac)), cameraX) }
  else if (state.finisher && finisherV2On()) drawFinisherV2BgDark(ctx, state.finisher.elapsedMs, state.hitStopRemaining, finisherProfileFor(state.boss.id), cameraX)
  // 「毛先の紫」の床の照り (止めの間の白)。 ＋影 (DEV ?parryLook=kesaki-shadow): 宝石の光で奥の壁に二人の大きな影 (前のコマの体の絵を黒く塗って広げる)。
  if (kesaki && kesakiC) drawKesakiFloorGlow(ctx, kesaki, kesakiC, state.player.y)
  if (tehon) drawTehonFloorGlow(ctx, tehon, tehonSince, state.player.y)
  if (kesaki && kesakiC && kesakiLook() === 'kesaki-shadow') drawKesakiWallShadows(ctx, kesaki, kesakiC, kesakiGemPoint(playerFoot(state)), state.player.y)

  drawHazards(ctx, state)   // 空間ハザード (予告ライン+判定の実体)。 キャラの後ろ・床の上
  // 介錯の咆哮の空気の衝撃波 (既定・配布版も。旧は DEV ?roarAir=0): 前縁の霞と足もとの砂ぼこり (キャラの後ろ・床の上)。
  if (roarAirOn() && state.phase === 'playing') {
    drawRoarAirWorld(ctx, roarAirFronts(state.hits, arenaBoundsFor(state.boss.id)), bossDisplayHeightFor(state.boss.id), roarAirSpeedPxPerSec())
  }
  // 回避反撃「影抜き」(DEV ?counterLook=shadow・10-09): 見切った所に残る影1体。 ボスより先に描く = 槍・爪が影の上を素通りする。
  if (counterLookShadow() && !options.bossSilhouette) drawMikiriShadowLayer(ctx, state)
  drawExecUniqueFxBehind(ctx, state, bossFootY(state.boss), bossDisplayHeightFor(state.boss.id)) // 騎士の固有の致命の光の尾・床の残り火 (騎士は配布版・花嫁は DEV ?execUnique=1・キャラの後ろ・床の上)

  if (!options.bossSilhouette) drawCurseAuraBehind(ctx, state)  // 裁定C: 弾けない攻撃の予兆 = 背面の赤黒い煙 (本体の "後")
  if (!options.bossSilhouette) drawExecutionerMorphGlow(ctx, state) // 介錯の変形 = 黒い武器を背後の深紫で読む逆光
  if (!options.bossSilhouette) drawRoarFxBehind(ctx, state)     // G11 咆哮 FX 背面 = 吸気の pull-in dust + 環境の減光
  if (!options.bossSilhouette) drawHoundHowlBehind(ctx, state.boss, bossFootY(state.boss), PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[state.boss.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)) // 戴冠獣のしかかりの吠え: 圧の帯 + 足元の砂ぼこり (獣の背面)
  // 主人公の層。配布版はボスの後 (手前) に描く。DEV ?awokenFaceFront=1 は覚醒王の予備動作の間だけボスの前 (奥) に描く (src/awoken_face_front.ts)。
  // DEV ?deathFront=1 (10-09 R2): 死の一拍〜負け画面だけ、主人公はここで描かず FX の後 (世界の層の一番手前) へ回す。配布版は常にここ。
  const deathFront = deathFrontActive(state)
  const drawPlayerLayer = () => {
    if (!deathFront && kesaki && kesakiC) {
      const foot = playerFoot(state)
      kickKesakiHair(kesaki, kesakiC, foot.facing, state.hitStopRemaining)
      const withGem = kesakiLook() === 'kesaki-shadow'
      drawKesakiLitBody(ctx, 'player', target => drawPlayer(target, state), state.player.x, state.player.y - 60, () => kesakiPlayerLights(kesaki, kesakiC, foot, withGem))
      if (kesakiG <= 0) {
        drawKesakiBodyLights(ctx, 'player', state.player.x, state.player.y - 60, kesakiHairBackLight(kesakiC, foot))
        drawKesakiHair(ctx, kesaki, kesakiC, foot)
      }
      if (withGem) drawKesakiGem(ctx, kesaki, kesakiC, foot)
    } else if (!deathFront && tehon && tehonBodyLit(tehonSince)) {
      drawKesakiLitBody(ctx, 'player', target => drawPlayer(target, state), state.player.x, state.player.y - 60, () => [tehonBodyLight(tehon, tehonSince, 'player')])
    } else if (!deathFront) drawBloomLitBody(ctx, bloom, state.time, state.player.x, state.player.y - 60, target => drawPlayer(target, state), state.player.y)
  }
  const faceFront = !options.bossSilhouette && awokenFaceFrontActive(state.boss)
  if (faceFront) drawPlayerLayer()
  if (options.bossSilhouette) drawBossAsSilhouette(ctx, state, options)
  else {
    // 崩した瞬間の体の崩れ (DEV ?breakStop=b・src/break_stop_fx.ts): 描くだけ後ろへ押して沈める。既定はずれ 0。
    const jolt = breakJoltOffset(state)
    ctx.save()
    ctx.translate(jolt.dx, jolt.dy)
    // 重なった主人公を読みやすくする比較版 thin (DEV ?overlapRead=thin・src/overlap_read_1104.ts): 重なった間だけ獣を少し透かす。配布版 (rim) は 1。
    if (state.phase === 'playing') ctx.globalAlpha *= overlapBossAlpha(state.boss.id, state.player.x, state.boss.x)
    if (kesaki && kesakiC) drawKesakiLitBody(ctx, 'boss', target => drawBoss(target, state, options), state.boss.x, bossFootY(state.boss) - 70, () => [kesakiContactLight(kesaki, kesakiC)])
    else if (tehon && tehonBodyLit(tehonSince)) drawKesakiLitBody(ctx, 'boss', target => drawBoss(target, bossDrawState(state), options), state.boss.x, bossFootY(state.boss) - 70, () => [tehonBodyLight(tehon, tehonSince, 'boss')])
    else drawBloomLitBody(ctx, bloom, state.time, state.boss.x, bossFootY(state.boss) - 70, target => drawBoss(target, bossDrawState(state), options), bossFootY(state.boss))
    ctx.restore()
  }
  if (!options.bossSilhouette) drawCurseAuraFront(ctx, state)   // 裁定C: 輪郭リム + 火の粉 (本体の縁の "外")
  if (!options.bossSilhouette) drawBrideHemFlash(ctx, state)    // 花嫁の裾乱れの溜めの終わりに裾が一度だけ紫に光る (DEV ?brideWind=bc|ac・11-02)
  if (!options.bossSilhouette) drawRoarFxFront(ctx, state)      // G11 咆哮 FX 前面 = 光条 + シルエット閃光 + radial dust blast
  drawPostureStrainEmbers(ctx, state)  // 体幹が満ちてきた時の足元の熱 (人形の "下")
  if (!faceFront) drawPlayerLayer()
  else if (!deathFront && !kesaki) {
    // ボスの奥へ回した主人公を、薄くもう一度手前に重ねる (自分の位置を見失わない・顔は透けて見える)。
    ctx.save()
    ctx.globalAlpha = AWOKEN_FACE_FRONT_GHOST_ALPHA
    drawPlayerLayer()
    ctx.restore()
  }
  if (!options.bossSilhouette) drawBrideHugFront(ctx, state.boss?.id, lastBossBodyPlacement) // 抱く腕を主人公の前へ (10-27 から配布版・src/bride_redraw_1023.ts)
  drawBrideHugHearts(ctx, state.boss?.id, state.player, state.time, lastBossBodyPlacement) // 抱きとめた間の♡ (花嫁の胸もとから) (配布版の既定・src/bride_hug_bind.ts)
  drawForegroundLayers(ctx, state.boss?.id, sx, sy)
  drawExecutionerCannonTell(ctx, state) // 砲口の脈 (telegraph 中だけ)。
  // 🔵 2026-09-03 第4便: 榴弾の弾は telegraph を抜けても (撃ったらすぐ次の行動へ移っても) 独立して落ち続けるので、
  //   telegraph 限定の drawExecutionerCannonTell の外へ出す (関数内部で phase/boss.id を自前ガード)。
  drawCannonMortarProjectile(ctx, state)
  drawExecutionerCannonMuzzleBridge(ctx, state) // 直射/速射: 構え砲口→発射砲口のワープへ橋を架ける残像+フラッシュ
  drawBossContactSmear(ctx, state) // 接触の絵に同期した刃スメア (旧 drawExecutionerSwingTrail の後継。介錯+騎士)
  drawKnightSweepDust(ctx, state)  // 騎士の薙ぎの重さ候補 c (DEV ?sweepWeight=c) の前足の砂ぼこり
  drawExecutionerDragSparks(ctx, state)  // 斬り上げ: 溜め後半に刃先が地面を擦る短い火花 (2026-09-02)
  drawExecutionerScoopFollowArc(ctx, state) // 斬り上げ 候補 a3: 接触→振り抜きを頭上の短い弧で繋ぐ (2026-09-02 夜)
  drawCastProjectiles(ctx, state) // 腕砲の飛翔体。背景に埋もれない最前面。
  drawBrideKaeshiBlade(ctx, state.boss, state.time, bossFootY(state.boss)) // 返しの一閃の切っ先の軌跡 (DEV ?brideKaeshi=blade・src/bride_kaeshi_blade.ts)
  drawBrideKaeshiTrail(ctx, state.boss, state.time, bossFootY(state.boss)) // 返しの一閃のヴェールの振りの跡 (DEV ?brideKaeshi=trail|both・src/bride_kaeshi_tween.ts)
  if (state.boss) drawBladePullRibbon(ctx, state.boss, state.player, bossFootY(state.boss), state.time) // 剣舞の引き寄せの布 (DEV ?bladePull=1・src/blade_dancer_pull_ribbon.ts)
  if (state.boss) drawBladeThrowHand(ctx, state.boss, bossFootY(state.boss)) // 剣舞の暗器投げの、構えた手の小刀 (DEV ?bladeThrow=1)
  if (state.boss && state.phase === 'playing') drawBladeFxV2(ctx, state.boss, bossFootY(state.boss), state.time) // 剣舞の床の FX を描いた絵で (比較版 ?bladeFx=v2・src/blade_dancer_fx_v2.ts)
  drawExecUniqueFxFront(ctx, state, bossFootY(state.boss), bossDisplayHeightFor(state.boss.id)) // 騎士と花嫁の固有の致命 (騎士は配布版・花嫁は DEV ?execUnique=1): 騎士の光の尾の先・花嫁の♡ (src/exec_unique_fx.ts)
  drawFloorWarnFront(ctx, state) // 床の技の予告の、足に隠れない手前の分 (src/floor_warn_vis.ts)

  const strongWash = import.meta.env.DEV && isStrongWash(parryWashVariant()) && state.phase === 'playing'
  if (washEncounter !== state.boss.id) retainWashSparks([], state.time, false)
  washEncounter = state.boss.id
  drawFx(ctx, retainWashSparks(state.fx, state.time, strongWash), state.time, state.boss, state.player)
  // 普段のパリィの光 W3 (DEV ?parryFlash=w3) だけ：主人公の胴を囲む薄い輪 (撮影台の (PX+4, FY-72))。
  const washRing = bloom ? parryWashVariant() : null
  if (bloom && washRing && WP[washRing].ring) {
    drawWashRing(ctx, state.player.x + (state.player.facing === 'left' ? -4 : 4), state.player.y - 72, state.time - bloom.t, bloom.isJust ?? false)
  }
  // テレグラフバーは廃止。代わりにボスのボディランゲージで予兆を伝える。

  // 致命トドメ演出 FX (シーンの上、 HUD の下)。 魔法陣→崩落粒子→破裂/残光/光片(最前)。
  //   2026-06-25: 魂の糸 (drawFinisherSoul = 主人公をかすめ左上へ流れる帯) は「不自然に寄って
  //   流れる」とのユーザー判断で撃破からは不採用 (関数は将来の真上版用に残置)。
  //   最後の一撃 C (既定の新しい版・src/luna_exec_fx_c.ts): 出どころを刺し傷 1 か所にまとめる = 足元の魔法陣・ボスの中心の灰・
  //     画面いっぱいの霧と光の満ち・白い閃光は出さない (前の版は ?lunaFinFx=v2 で残る)。
  const aliceClock = aliceClockMs(state)
  if (aliceClock === null) aliceRiftLyingFit = null
  if (aliceClock !== null) {
    // 止め (アリスの技を手本にした版・DEV ?lunaExec=swap): 溜めの間は世界を灰色へ沈め、その上に銀の粒だけで裂け目と弾けを描く。今の版の魔法陣・白い閃光は出さない。
    applyKesakiGray(ctx, aliceGrayAmount(aliceClock))
    const p = state.player, b = state.boss
    const bh = bossDisplayHeightFor(b.id)
    const scale = Math.max(0.8, Math.min(1.6, bh / PLAYER_DISPLAY_HEIGHT * 0.7))
    const fit = aliceRiftFit(b, bh, scale)
    if (import.meta.env.DEV) (globalThis as { __aliceRiftCenter?: unknown }).__aliceRiftCenter = { x: b.x, y: fit.y, squashY: fit.squashY, old: bossFootY(b) - bh * 0.36, clock: aliceClock }
    drawLunaAliceFx(ctx, { clockMs: aliceClock, start: { x: p.x, y: p.y },
      end: { x: aliceDashTargetX(p, b, arenaBoundsFor(b.id)), y: p.y }, facing: p.facing === 'right' ? 1 : -1,
      center: { x: b.x, y: fit.y }, scale, floorY: bossFootY(b), seamSquashY: fit.squashY })
    // 一突きの版 (DEV ?lunaExec=pierce): 短い軌跡1本・刺した一点の光・昇る粒 (体の芯の光は drawPierceBossBody)。
    if (lunaExecPierceOn()) {
      drawPierceFx(ctx, { sinceHitMs: pierceSinceHitMs(aliceClock), wound: pierceWound(b, fit.y),
        tipX: p.x + aliceDashOffsetPx(aliceClock, p, b, arenaBoundsFor(b.id)) + (p.facing === 'right' ? 1 : -1) * 44,
        facing: p.facing === 'right' ? 1 : -1, scale, silhouette: state.finisher ? pierceSil?.sil ?? null : null })
    }
  } else if (!finisherCOn()) {
    drawFinisherCircle(ctx, state)
    drawFinisherMotes(ctx, state)
    drawFinisherBurst(ctx, state)   // 破裂→残光が満ちる→銀白の光片が舞う (冷色・余韻型・世界座標)
  }
  if (aliceClock !== null) { /* 止め (アリスの技) は白で隠さない */ }
  else if (!finisherV2On()) drawFinisherImpact(ctx, state)   // 新しい版 (DEV ?lunaFinisher=new) は白で隠さない
  else if (state.finisher && finisherCOn()) {
    const prof = finisherProfileFor(state.boss.id)
    drawFinisherCFront(ctx, finisherCGmOfClock(state.finisher.elapsedMs), finisherFreezeProgress(state.finisher.elapsedMs, state.hitStopRemaining, prof),
      FIN_C.pullAtGm, finisherCWoundPoint(state.player), state.player.y)
  } else if (state.finisher) {
    drawFinisherV2Front(ctx, state.finisher.elapsedMs, state.hitStopRemaining, finisherProfileFor(state.boss.id),
      execWoundPoint(state.player, state.boss), state.player.y)
  }
  // DEV ?deathFront=1 (10-09 R2): 伏した主人公を噛みの光などの FX より手前に描き、体の縁を薄い月光で縁取る (src/fresh_eyes_fix_trials.ts)。
  if (deathFront) drawPlayer(ctx, state, deathRimStrength(state))

  // 「毛先の紫」3回目 (DEV ?parryLook=kesaki): 止めの間は画面 (HUD を除く) を白黒にし、その上に髪の光と背中の照り返しだけ色で描く。
  //   致命を弾いた時 (既定) は髪の光が消えた後も白黒が薄く残るので、白黒だけ先にかける。
  if (kesakiG > 0 && !deathFront && (kesaki || exSlow)) {
    applyKesakiGray(ctx, kesakiG)
    if (kesaki && kesakiC) {
      const foot = playerFoot(state)
      drawKesakiBodyLights(ctx, 'player', state.player.x, state.player.y - 60, kesakiHairBackLight(kesakiC, foot))
      drawKesakiHair(ctx, kesaki, kesakiC, foot)
    }
  }
  // 「毛先の紫」4回目 (DEV ?parryLook=kesaki・10-10 夜): 接点から散る火花。 白黒の後に描く = 白黒の間も色を持つ (?kesakiSpark=white|gold)。
  //   前の弾きの火花も消えるまで描く (続けて弾いても前の火花が途中で消えない)。
  if (kesakiLook() !== 'off' && state.phase === 'playing' && !deathFront) {
    const facing = playerFoot(state).facing
    for (const f of state.fx) {
      if (kesakiOwns(f) && !tehonOwns(f)) drawKesakiSparks(ctx, f, kesakiClock(f, state.time, f === kesaki ? state.hitStopRemaining : 0), facing)
    }
  }
  // 普段のパリィ「手本」(既定・配布版): 接点の光の塊・横一直線の光・斜めの光 → 主人公の体を描き直す → 火花のすじ・火の粉
  //   (前の弾きの物も消えるまで描く)。 体の描き直し = やわらかい光に埋もれた上半身の輪郭を読ませる (10-15 夜・弾いて 1〜2 コマ)。
  if (tehonOnNow && state.phase === 'playing' && !deathFront) {
    const facing = playerFoot(state).facing
    const viewLeft = cameraX - sx
    const owned: { f: Extract<FxEvent, { kind: 'parry_spark' }>; since: number }[] = []
    for (const f of state.fx) {
      if (!tehonOwns(f)) continue
      owned.push({ f, since: kesakiClock(f, state.time, f === tehon ? state.hitStopRemaining : 0).since })
    }
    for (const { f, since } of owned) {
      drawTehonBloom(ctx, f, since)
      drawTehonFlare(ctx, f, since, viewLeft, ARENA.width)
      drawTehonSlash(ctx, f, since, facing, ARENA.width)
    }
    if (tehon && redrawKesakiBody(ctx, 'player', tehonVeilAlpha(tehonSince))) {
      drawKesakiBodyLights(ctx, 'player', state.player.x, state.player.y - 60, [tehonBodyLight(tehon, tehonSince, 'player')])
    }
    // 受け身 (10-21・src/ukemi.ts): 弾いた瞬間に体を光で一瞬隠し、その下で受け身の姿へ切り替える (姿になるのは 0.06 秒)。
    if (tehon && ukemiOn()) fillKesakiBody(ctx, 'player', TEHON_COLOR.warm, ukemiCoverAlpha(tehonSince, ukemiKind(tehon.weight)))
    for (const { f, since } of owned) {
      drawTehonStreaks(ctx, f, since, facing)
      drawTehonEmbers(ctx, f, since, facing)
      drawTehonMolten(ctx, f, since, facing, state.player.y)
    }
  }

  // DEV: 判定ボックス可視化 (H キー)。 本番は tree-shake。 キャラ/FXの上・世界座標で描く。
  if (import.meta.env.DEV) drawHitboxesDev(ctx, state)

  ctx.restore()
  ctx.restore() // 崩した瞬間の寄り
  ctx.restore() // 部屋全体を映す縮め
  // 画面の寄せ (src/cam_zoom.ts・配布版 1.3 倍): 描き終えた世界の層を切り取って拡大する。 ここから下の画面の効果は中心を camZoomX/Y で写す。
  //   戦い以外の画面と ?camZoom=1 (開発版の旧の見え方) は等倍 = 何もしない・camZoomX/Y もそのままの値を返す。
  blitCamZoom(ctx)

  drawPostureStrainVignette(ctx, state) // 自分の体幹が満ちてきた時の画面端の警告 (被弾ヴィネットの下)
  // 弾き崩し (10-05)：世界の層と体幹の警告の色が抜け、その上に朱の光 (HUD は抜かない・見比べ版の動画と同じ重なり)
  drawParryBreakScreen(ctx, state, sx - cameraX, sy)
  if (down) drawParryDownTint(ctx, ARENA.width, ARENA.height, camZoomX(farX(down.x - cameraX)), camZoomY(farY(down.y)), state.time - down.t) // 崩した瞬間：画面ごと金に染まる (HUD の下)
  if (pwLook) {
    // 致命を弾いた時の押し戻しの重さ (既定 c・src/exec_push_weight.ts): 接点のにじんだ光／画面全体の白・金・暗い沈み (HUD の下)。
    //   接点の画面位置 = 寄りの中心から倍率ぶん離し、揺れを足す (光の雲の小さな寄りは無視・数 px)。
    const z = pwLook.zoom, pvx = pwLook.pivot.x - cameraX, pvy = pwLook.pivot.y
    const cx = camZoomX(farX(pvx + (pwLook.f.x - cameraX - pvx) * z + sx)), cy = camZoomY(farY(pvy + (pwLook.f.y - pvy) * z + sy))
    const level = pushWeightFlashLevel(pwLook.clockMs, pwLook.spec)
    drawPushWeightContactFlash(ctx, cx, cy, level, pwLook.spec, pwLook.f.isJust)
    drawPushWeightScreenFlash(ctx, ARENA.width, ARENA.height, cx, cy, level, pushWeightDarkLevel(pwLook.clockMs, pwLook.spec), pwLook.spec, pwLook.f.isJust)
  }
  if (exSlow) {
    // 致命を弾いた時 (既定): 接点のにじんだ白・弾いた瞬間の画面の白 (3 コマ)・スローの間の縁の暗さ (HUD の下)。
    //   寄りの中心 = 接点なので、接点の画面位置は寄っても動かない (揺れだけ倍率ぶん足す)。
    const cx = camZoomX(farX(exSlow.f.x - cameraX + sx * exZoom)), cy = camZoomY(farY(exSlow.f.y + sy * exZoom))
    drawExecSlowContact(ctx, cx, cy, execSlowContact(exSlow.r, exSlow.spec), exSlow.spec)
    drawExecSlowScreen(ctx, ARENA.width, ARENA.height, cx, cy, execSlowFlash(exSlow.r), execSlowVignette(exSlow.r, exSlow.spec), exSlow.spec)
  }
  // 普段のパリィ「手本」(既定・配布版): 弾いた瞬間に画面全体が明るくなってすぐ戻る (HUD の下)。
  if (tehon && !deathFront) drawTehonScreenFlash(ctx, tehonSince, camZoomX(farX(tehon.x - cameraX + sx)), camZoomY(farY(tehon.y + sy)), ARENA.width, ARENA.height)
  drawDamageVignette(ctx, state.fx, state.time)
  drawFinaleRoomPulse(ctx, state)      // 花嫁最終部屋: 画面周辺の赤い心拍 vignette (2026-07-01・狂気モードの視覚化)
  drawExecutionCinematic(ctx, state)   // 処刑死の全画面シネマティック (フラッシュ+色収差+締まる暗ヴィネット)
  if (!options.hideHud) drawHud(ctx, state)
  // 崩れ=致命可能: 舞台の照明が絞られる。 **HUD より後**に置く = 下端の帯も一緒に沈む。
  //   ここを HUD より前にすると、 周りが暗くなった分だけ HUD だけが明るく浮いて
  //   「画面の重心が下へ落ちる」(2026-07-26 実機却下の理由) が再発する。
  drawStaggerSpotlight(ctx, state)
  if (!options.hideHud) drawTutorialPrompts(ctx, state)      // 導入戦 (名も無き亡霊) 限定の操作プロンプト
  if (!options.hideHud) drawBossIntroCard(ctx, state)        // ボス開幕タイトルカード (名乗り・導入戦以外)
  if (!options.hideHud) drawFelledBanner(ctx, state)    // ER/Nightreign 流: 「討伐」バナー (画面座標・スロー中の余韻)
  if (!options.hideHud) drawTutorialFocus(ctx, state)   // 稽古の「止めて、照らして、教える」(比較版 DEV ?tutFocus だけ・src/tut_focus.ts)
  // 記憶パネルは戦闘中は出さない (SEKIRO/ZZZ風の最小UI)
  // 死亡/勝利のリフレクション画面 (drawPhaseOverlay 内) で表示
  drawPhaseOverlay(ctx, state)
  // 幕間メニューオーバーレイ (playing フェーズ限定・drawPhaseOverlay の上)
  if (state.paused) drawPauseOverlay(ctx, state)

  // TIPS チュートリアルカード (最上位モーダル・2026-07-12)
  if (!options.hideHud) drawTipsCard(ctx, state)
  if (import.meta.env.DEV && !options.hideHud && cardHudDemoActive(state)) {
    const elapsedMs = devTipsCardId ? performance.now() - devTipsCardSinceMs : (state.tutorial?.cardEnterMs ?? 0)
    cardHudPreview ??= createBossHudPreviewState()
    withBossHudPreview(cardHudPreview, () => {
      // Exactly one HUD draw, above the card's dimmer. No live state is modified.
      drawBossHudSilverFromState(ctx, state, cardHudDemoAt(elapsedMs / 1000))
    })
  } else if (import.meta.env.DEV) cardHudPreview = null

  // DEV: メニュー当たり矩形の可視化 (?menuHit=1 で起動。本番は tree-shake)。
  //   見えている位置と押せる位置がズレていないかを実表示で目視確認するための専用票 (2026-07-25 第2段 §7-4)。
  if (import.meta.env.DEV) drawMenuHitOverlayDev(ctx, state)
}

function drawMenuHitOverlayDev(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (!(globalThis as { __showMenuHitboxes?: boolean }).__showMenuHitboxes) return
  let rects: MenuRect[] = []
  let label = ''
  if (state.phase === 'title' && state.pausePanel === 'difficulty') {
    rects = difficultyMenuRects(state.difficultyIndex); label = 'difficultyMenuRects'
  } else if (state.phase === 'title' && state.pausePanel === 'newGameConfirm') {
    rects = newGameConfirmRects(); label = 'newGameConfirmRects'
  } else if (state.phase === 'title' && state.titleEntered && !state.pausePanel) {
    rects = titleMenuRects(titleMenuItems(hasCampaignProgress(state.campaign)).length); label = 'titleMenuRects'
  } else if (state.phase === 'choice') {
    rects = endingChoiceRects(); label = 'endingChoiceRects'
  } else if (state.paused && state.pausePanel === 'settings') {
    rects = pauseSettingsRects(); label = 'pauseSettingsRects'
  } else if (state.paused && !state.pausePanel) {
    rects = pauseMainRects(); label = 'pauseMainRects'
  }
  if (rects.length === 0) return
  ctx.save()
  ctx.strokeStyle = 'rgba(255,60,60,0.95)'
  ctx.lineWidth = 1
  ctx.setLineDash([4, 3])
  ctx.font = '10px monospace'
  ctx.fillStyle = 'rgba(255,60,60,0.95)'
  ctx.textAlign = 'left'
  rects.forEach((r, i) => {
    ctx.strokeRect(r.x, r.y, r.w, r.h)
    ctx.fillText(`${i}`, r.x + 2, r.y + 10)
  })
  ctx.setLineDash([])
  ctx.fillText(label, 4, 12)
  ctx.restore()
}

// ===================== TIPS チュートリアルカード (2026-07-12) =====================
// 枠 = 生成アート (public/ui/tips/card_frame.png)、中身 (タイトル/本文/写真/ページ番号) は
//   ここでコード合成する。座標は枠画像内の割合 (0..1)。実機スクショで微調整する。
// 字 (2026-11-01 作者 font=1): 見出しも本文も同梱の Zen Old Mincho SemiBold (src/ui_font.ts)。
//   本文は前はゴシック (07-12 の研究: 明朝は横線が細く画面で溶ける)。SemiBold は横線が太いので本文にも使う。前の版 = 開発版 ?uiFont=os。
const TIPS_TITLE_FONT = UI_SERIF
let tipsFrameImg: HTMLImageElement | null = null
function tipsFrame(): HTMLImageElement | null {
  if (!tipsFrameImg) { tipsFrameImg = new Image(); tipsFrameImg.src = '/ui/tips/card_frame.png' }
  return tipsFrameImg.complete && tipsFrameImg.naturalWidth > 0 ? tipsFrameImg : null
}
const tipsPhotoCache: Record<string, HTMLImageElement> = {}
function tipsPhoto(key: string): HTMLImageElement | null {
  let img = tipsPhotoCache[key]
  if (!img) { img = new Image(); img.src = `/ui/tips/${key}.png`; tipsPhotoCache[key] = img }
  return img.complete && img.naturalWidth > 0 ? img : null
}

// 枠画像 (1536×1024) 内の各ゾーン (割合)。実測で微調整する。
const TIPS_ZONE = {
  titleX: 0.130, titleY: 0.250,
  inputY: 0.335,          // 入力キーバッジ (Lies of P の「L1：ガード」に相当) の上端
  bodyTop: 0.352,         // 入力バッジが無い回 (画面説明) の本文開始
  bodyTopWithInput: 0.430, // 入力バッジがある回はその分だけ本文を下げる
  bodyX: 0.130, bodyW: 0.345, bodyLineH: 0.058, paraGap: 0.022,
  bodySize: 0.034,   // 本文の文字サイズ (fh 比)。16px 相当以上を確保 (GAG: 小さすぎる文字は不可)
  photo: { x: 0.548, y: 0.356, w: 0.318, h: 0.300 },
  pageX: 0.492, pageY: 0.800,
} as const

// DEV: カードの見た目確認用オーバーライド。本番フロー配線 (state 駆動) とは独立。
let devTipsCardId: string | null = null
let devTipsCardSinceMs = 0
if (import.meta.env.DEV && typeof window !== 'undefined') {
  ;(window as unknown as Record<string, unknown>).__showTipsCard = (id: string | null) => {
    const collapse = cardHudDemoEnabled && id === 'execute'
    if (DEV_COLLAPSE_FOCUS) {
      DEV_COLLAPSE_FOCUS.active = collapse
      DEV_COLLAPSE_FOCUS.ms = 0
    }
    devTipsCardId = collapse ? null : id
    devTipsCardSinceMs = performance.now()
    cardHudPreview = null
  }
}

// 行頭に置いてはいけない文字 (禁則処理)。句読点・閉じ括弧・長音など。
const TIPS_NO_LINE_START = '、。，．・：；？！」』）］｝〕〉》”’ー〜…'

// canvas 用の折り返し (日本語=文字単位で計測) + 禁則処理。
//   行頭禁止文字が来る時は前の行へ「ぶら下げる」= 「、」始まりや「。」だけの行を作らない。
function wrapTipsText(ctx: CanvasRenderingContext2D, text: string, maxW: number): string[] {
  const lines: string[] = []
  let cur = ''
  for (const ch of text) {
    if (cur !== '' && ctx.measureText(cur + ch).width > maxW) {
      if (TIPS_NO_LINE_START.includes(ch)) {
        // 禁則: 行頭に来てはいけない文字は前行にぶら下げてから改行する
        lines.push(cur + ch)
        cur = ''
        continue
      }
      lines.push(cur)
      cur = ch
    } else {
      cur += ch
    }
  }
  if (cur) lines.push(cur)
  return lines
}

// カードが出るまでの演出時間 (ms)。速すぎると「バグかと思った」になる (2026-07-12 実機FB)。
//   暗幕が先に沈む → 少し遅れてカードが横から滑り込む、の二段構え。
const TIPS_SLIDE_MS = 420

// いま表示するカード + そのカード表・index。DEV override (__showTipsCard) が最優先。
function activeTipsCard(state: GameState): { card: TutorialCard; cards: TutorialCard[]; index: number } | null {
  if (import.meta.env.DEV && DEV_COLLAPSE_FOCUS?.active && state.boss.id === 'nameless-shade') return null
  if (devTipsCardId) {
    const i = SHADE_TIPS_CARDS.findIndex((c) => c.id === devTipsCardId)
    return i >= 0 ? { card: SHADE_TIPS_CARDS[i]!, cards: SHADE_TIPS_CARDS, index: i } : null
  }
  const tut = state.tutorial
  if (!tut || state.phase !== 'playing' || state.finisher || state.paused) return null
  const cards = tipsCardsForBoss(state.boss.id)
  const i = pendingTipsCardIndex(cards, tut.lesson, tut.cardCursor)
  return i >= 0 ? { card: cards[i]!, cards, index: i } : null
}

function drawTipsCard(ctx: CanvasRenderingContext2D, state: GameState): void {
  const active = activeTipsCard(state)
  if (!active) return
  const { card, cards, index } = active
  const frame = tipsFrame()
  if (!frame) return

  ctx.save()
  const enterMs = devTipsCardId ? TIPS_SLIDE_MS : (state.tutorial?.cardEnterMs ?? TIPS_SLIDE_MS)

  // 1) 暗幕を先にフェードイン = 画面がまず「沈む」。唐突に紙が現れるのを防ぐ。
  const tDim = Math.max(0, Math.min(1, enterMs / (TIPS_SLIDE_MS * 0.55)))
  const dimEase = 1 - Math.pow(1 - tDim, 2)
  ctx.fillStyle = `rgba(4, 2, 8, ${(0.62 * dimEase).toFixed(3)})`
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)

  // 1b) カードは暗幕にワンテンポ遅れて、横から滑り込む (ページをめくる体感)。
  const tCard = Math.max(0, Math.min(1, (enterMs - TIPS_SLIDE_MS * 0.28) / (TIPS_SLIDE_MS * 0.72)))
  const ease = 1 - Math.pow(1 - tCard, 3)   // easeOutCubic
  if (ease <= 0) { ctx.restore(); return }
  ctx.globalAlpha = ease
  ctx.translate((1 - ease) * ARENA.width * 0.10, 0)

  // 2) 枠を contain で中央配置
  const scale = Math.min(ARENA.width / frame.naturalWidth, ARENA.height / frame.naturalHeight)
  const fw = frame.naturalWidth * scale, fh = frame.naturalHeight * scale
  const fx = (ARENA.width - fw) / 2, fy = (ARENA.height - fh) / 2
  ctx.drawImage(frame, fx, fy, fw, fh)
  const zx = (u: number) => fx + u * fw
  const zy = (v: number) => fy + v * fh

  // 3) 写真 (あれば cover で窓へ。無ければ枠の空窓のまま)
  const photo = tipsPhoto(card.photoKey)
  if (photo) {
    const px = zx(TIPS_ZONE.photo.x), py = zy(TIPS_ZONE.photo.y)
    const pw = TIPS_ZONE.photo.w * fw, ph = TIPS_ZONE.photo.h * fh
    ctx.save()
    ctx.beginPath(); ctx.rect(px, py, pw, ph); ctx.clip()
    const ps = Math.max(pw / photo.naturalWidth, ph / photo.naturalHeight)
    const dw = photo.naturalWidth * ps, dh = photo.naturalHeight * ps
    ctx.drawImage(photo, px + (pw - dw) / 2, py + (ph - dh) / 2, dw, dh)
    ctx.restore()
  }

  ctx.textBaseline = 'alphabetic'
  ctx.textAlign = 'left'
  const bx = zx(TIPS_ZONE.bodyX)
  const maxW = TIPS_ZONE.bodyW * fw
  const lineH = TIPS_ZONE.bodyLineH * fh
  const bodySize = Math.round(fh * TIPS_ZONE.bodySize)

  // 4) 入力バッジの寸法 (複数可) → 本文の開始位置をここから逆算する
  const badges = (card.inputs ?? []).map((s) => resolveInputText(s, inputDeviceView()))
  const kSize = Math.round(fh * 0.030)
  const bpX = fw * 0.012, bpY = fh * 0.015
  const badgeH = kSize + bpY * 2
  const badgeGap = fh * 0.014
  const badgesTop = zy(TIPS_ZONE.inputY)
  const badgesH = badges.length > 0
    ? badges.length * badgeH + (badges.length - 1) * badgeGap
    : 0
  const bodyTopPx = badges.length > 0
    ? badgesTop + badgesH + fh * 0.052
    : zy(TIPS_ZONE.bodyTop)

  // 5) 本文を先に折り返して高さを測る (下地パネルの寸法に使う)
  ctx.font = `500 ${bodySize}px ${uiSans()}`
  const blocks = card.body.map((p) => wrapTipsText(ctx, p, maxW))
  const bodyLines = blocks.reduce((n, b) => n + b.length, 0)
  const bodyH = bodyLines * lineH + Math.max(0, blocks.length - 1) * TIPS_ZONE.paraGap * fh

  // 5) 書字域の下地パネル (可読性の要)。
  //   まだら模様の古紙に文字を直接置くとコントラスト比 4.5:1 を割る (Game Accessibility
  //   Guidelines: 変化する背景の上の文字には半透明の下地を敷け)。硬いUI箱に見せないよう縁を
  //   ぼかし、「古文書は書字域だけ紙が綺麗」の理屈で世界観に馴染ませる。
  //   ⚠️ 濃く塗ると「白いUI箱」= スライド資料の見た目になり世界観を壊す (ユーザー禁止事項)。
  //   薄く + 縁を大きくぼかして「紙が綺麗な部分」として溶かす。まだらを均せれば十分。
  const padX = fw * 0.022
  const panelX = bx - padX
  const panelY = zy(TIPS_ZONE.titleY) - fh * 0.055
  const panelW = maxW + padX * 2
  const panelH = (bodyTopPx + bodyH + fh * 0.020) - panelY
  ctx.save()
  ctx.shadowColor = 'rgba(247, 242, 229, 0.55)'
  ctx.shadowBlur = fh * 0.10          // 大きくぼかして矩形の輪郭を消す
  ctx.fillStyle = 'rgba(247, 242, 229, 0.42)'   // 薄く = 箱に見せない
  ctx.beginPath()
  ctx.roundRect(panelX, panelY, panelW, panelH, fh * 0.05)
  ctx.fill()
  ctx.restore()

  // 6) タイトル (明朝 = 世界観。大きく短いので可読性を保てる)
  ctx.fillStyle = '#171009'
  ctx.font = `700 ${Math.round(fh * 0.046)}px ${TIPS_TITLE_FONT}`
  ctx.fillText(card.title, bx, zy(TIPS_ZONE.titleY))

  // 7) 入力キーバッジ (Lies of P の「L1：ガード」に相当)。
  //   ⚠️ チュートリアルで最も重要な情報 = 「どのボタンを押すのか」。最初に、目立たせて出す。
  //   操作は必ずここで見せる (本文に素のテキストで書かない = 見た目を統一する)。
  if (badges.length > 0) {
    ctx.save()
    ctx.font = `700 ${kSize}px ${uiSans()}`
    ctx.lineWidth = Math.max(1, fh * 0.003)
    for (let i = 0; i < badges.length; i += 1) {
      const label = badges[i]!
      const bw = ctx.measureText(label).width + bpX * 2
      const byTop = badgesTop + i * (badgeH + badgeGap)
      // 刻印された銘板のような見た目 (濃い墨の縁 + 少し暗い紙地) = UIボタンでなく証書の一部に見せる
      ctx.fillStyle = 'rgba(60, 48, 32, 0.16)'
      ctx.strokeStyle = 'rgba(38, 28, 16, 0.72)'
      ctx.beginPath()
      ctx.roundRect(bx, byTop, bw, badgeH, fh * 0.010)
      ctx.fill()
      ctx.stroke()
      ctx.fillStyle = '#14100a'
      ctx.textBaseline = 'middle'
      ctx.fillText(label, bx + bpX, byTop + badgeH / 2)
    }
    ctx.restore()
    ctx.textBaseline = 'alphabetic'
  }

  // 8) 本文 (ゴシック = 読ませる。にじむ光彩は使わない = 輪郭をクッキリ保つ)
  ctx.fillStyle = '#1b1610'
  ctx.font = `500 ${bodySize}px ${uiSans()}`
  let ly = bodyTopPx
  for (const lines of blocks) {
    for (const line of lines) { ctx.fillText(line, bx, ly); ly += lineH }
    ly += TIPS_ZONE.paraGap * fh
  }

  // 9) ページ番号 (中央楕円飾り)
  ctx.fillStyle = '#2a1d0e'
  ctx.textAlign = 'center'
  ctx.font = `600 ${Math.round(fh * 0.024)}px ${TIPS_TITLE_FONT}`
  ctx.fillText(`${index + 1} / ${cards.length}`, zx(TIPS_ZONE.pageX), zy(TIPS_ZONE.pageY))

  // 10) 進める促し。写真の下の空き紙面に置く (カード内に収める = HUDに被らない)。
  //   何を押せば進むかを必ず出す (UXライティング: 次の行動を明示する)。
  //   ⚠️ 2026-07-24: 下地なしでまだら紙地に直書きしておりコントラスト比が崩れていた (実機視認性FB)。
  //   →(5)の本文パネルと同じ配色の薄い半透明下地を敷く (バッジ(7)のような縁取りは付けない裁定)。
  const isLast = index + 1 >= cards.length
  const nextToken = inputDeviceView().device === 'pad' ? '{retry}' : '{attack}'
  const nextText = resolveInputText(isLast ? `${nextToken} で はじめる` : `${nextToken} で 次へ`, inputDeviceView())
  const nextSize = Math.round(fh * 0.026)
  ctx.font = `600 ${nextSize}px ${uiSans()}`
  const nextCx = zx(0.707), nextBaseline = zy(0.742)
  const nextW = ctx.measureText(nextText).width
  const nextPadX = fw * 0.014, nextPadY = fh * 0.012
  const nextPanelW = nextW + nextPadX * 2
  const nextPanelH = nextSize * 1.05 + nextPadY * 2
  ctx.save()
  ctx.shadowColor = 'rgba(247, 242, 229, 0.55)'
  ctx.shadowBlur = fh * 0.035
  ctx.fillStyle = 'rgba(247, 242, 229, 0.42)'
  ctx.beginPath()
  ctx.roundRect(nextCx - nextPanelW / 2, nextBaseline - nextSize * 0.80 - nextPadY, nextPanelW, nextPanelH, fh * 0.02)
  ctx.fill()
  ctx.restore()
  ctx.fillStyle = 'rgba(58, 44, 30, 0.92)'
  ctx.fillText(nextText, nextCx, nextBaseline)

  ctx.restore()
}

// ============== 花嫁最終部屋の心拍 vignette (2026-07-01) ==============
// executesTaken >= 2 の花嫁戦時、 画面周辺に灰紫→黒紫の vignette を心拍で脈動 +
//   画面下部から立ち上る紫の霧 (床の呪詛が画面を包む) で「呪詛が満ちる狂気モード」 を視覚化。
// ユーザー指摘: BGM 転調だけでは攻撃ペース加速に気付けず違和感 = 花嫁色 (灰紫 #9a7ac4 / 黒紫 #1a0a2a) で世界観に溶かす。
// 常時表示 (最終部屋の間ずっと)。 中央は透明 = プレイの視認性は損なわない。
function drawFinaleRoomPulse(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (state.phase !== 'playing') return
  const boss = state.boss
  if (!boss || boss.id !== 'bride' || boss.executesTaken < 2) return
  const t = state.time
  // 1.4Hz 心拍 (少し速めで煽る)。 pulse = 0..1 の周期波
  const pulse = 0.5 + 0.5 * Math.sin(t * 2 * Math.PI * 1.4)
  const alpha = 0.18 + 0.22 * pulse   // 0.18〜0.40 の範囲で脈動

  ctx.save()
  const cx = ARENA.width / 2
  const cy = ARENA.height / 2

  // 1) 外周 vignette: 灰紫 (中央近く) → 黒紫 (外周)
  //   花嫁の呪詛カラー = #9a7ac4 (灰紫) + #1a0a2a (黒紫)。 中央は完全透明で視認性維持。
  const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, ARENA.width * 0.55)
  grad.addColorStop(0.35, 'rgba(154,122,196,0)')                                   // 中央 = 完全透明
  grad.addColorStop(0.75, `rgba(154,122,196,${(alpha * 0.55).toFixed(3)})`)         // 中間 = 灰紫
  grad.addColorStop(1.0, `rgba(26,10,42,${alpha.toFixed(3)})`)                     // 外周 = 黒紫
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)

  // 2) 画面下部から立ち上る紫の霧 (床の呪詛が画面を包む)
  //   床基線 (ARENA.floorY 相当) から画面高 45% まで、 上に行くほど薄い。
  //   心拍と少しずらした位相 (offset PI/3) で「霧が息をする」 質感、 常に完全消えない (base + pulse)。
  const fogPhase = 0.5 + 0.5 * Math.sin(t * 2 * Math.PI * 1.0 + Math.PI / 3)     // 1.0Hz・位相ずれ
  const fogAlphaBase = 0.10 + 0.10 * fogPhase                                   // 0.10〜0.20
  const fogTopY = ARENA.height * 0.55
  const fogBotY = ARENA.height
  const fogGrad = ctx.createLinearGradient(0, fogTopY, 0, fogBotY)
  fogGrad.addColorStop(0, 'rgba(154,122,196,0)')                                // 上端は透明
  fogGrad.addColorStop(0.5, `rgba(154,122,196,${(fogAlphaBase * 0.7).toFixed(3)})`)
  fogGrad.addColorStop(1, `rgba(122,90,166,${fogAlphaBase.toFixed(3)})`)         // 下端 (床側) が濃い
  ctx.fillStyle = fogGrad
  ctx.fillRect(0, fogTopY, ARENA.width, fogBotY - fogTopY)

  ctx.restore()
}

// ============== 致命トドメ FX ==============

// トドメ着弾: 全画面の閃光+色収差(コード) と、 着弾点の炸裂スプライト(絵)を重ねる。
function drawFinisherImpact(ctx: CanvasRenderingContext2D, state: GameState): void {
  const f = state.finisher
  if (!f) return
  if (finisherBeat(f.elapsedMs) !== 'impact') return
  // 全画面フラッシュ+色収差 (光=コード)
  const a = 1 - f.elapsedMs / EXECUTE_FX.impactFlashMs
  if (a > 0) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = a * 0.8
    // 世界の層の中にある全画面塗り = カメラ分ずらさないと画面の端が欠ける。
    const sr = screenRectInWorld()
    ctx.fillStyle = SOUL_BLUE.white; ctx.fillRect(sr.x, 0, sr.w, ARENA.height)   // 旧 #c8b0ec (紫)
    // 色収差の赤 (#ff3a6e) は外した (2026-10-11 夜)。全画面の一色の塗りをずらしても見えるのは画面の端だけで、
    //   赤と青が白に重なって画面全体が薄紫になっていた (撮影 .ai-team/checks/soulblue-ingame-1011・閃光 50ms で紫 74%)。
    //   答え purple-soul-blue「灯より白い青白」・b10「冷白へ」に合わせ、冷たい青だけを足す。旧へ戻すなら赤の行を戻す。
    ctx.globalAlpha = a * 0.25
    ctx.fillStyle = '#6f8fd0'; ctx.fillRect(sr.x + EXECUTE_FX.chromaticAberrationPx, 0, sr.w, ARENA.height)
    ctx.restore()
  }
  // 着弾点の炸裂スプライト (絵=生成素材)。 弾けて広がりながら消える
  const img = getFinisherFx('impact_soulblue')   // 旧 'impact' (紫)
  if (img) {
    const prog = Math.min(1, f.elapsedMs / EXECUTE_FX.impactHitStopMs)
    const w = 280 * (0.85 + 0.5 * prog)
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = Math.max(0, 1 - prog)
    ctx.translate(f.bossX, f.bossY - 70)
    ctx.drawImage(img, -w / 2, -w / 2, w, w)
    ctx.restore()
  }
}

// 足元の魔法陣: pull/absorb ビートで青白の二重リングが回転しながら開く (魂を吸い出す陣)。
// 足元の魔法陣: 生成スプライト(黒背景)を床に寝かせ回転・additive 合成。
// 仮の楕円描画から差し替え (2026-06-01)。 未読み込み時は何も描かない。
// pull=立ち上げ / absorb=最大 / dissolve=なめらかに消えながら少し広がる(プツッと切らない)。
function drawFinisherCircle(ctx: CanvasRenderingContext2D, state: GameState): void {
  const f = state.finisher; if (!f) return
  const e = f.elapsedMs
  if (e < T_PULL) return
  const img = getFinisherFx('sigil_soulblue')   // 旧 'sigil' (紫)
  if (!img) return
  // 連続: pull で立ち上がり → 魂が流れる間ずっと開いている → 魂が全部届いたら滑らかに消える。
  const win = T_DISSOLVE - T_PULL
  const allArrivedAt = T_PULL + win * 1.35 + win * 1.0
  let alpha: number, growth: number
  if (e <= allArrivedAt) {
    const rise = Math.min(1, (e - T_PULL) / EXECUTE_FX.pullDurationMs)
    alpha = 0.3 + 0.7 * rise
    growth = 0.6 + 0.4 * rise
  } else {
    const fp = Math.min(1, (e - allArrivedAt) / (EXECUTE_FX.silenceBeatMs * 0.5))
    alpha = (1 - fp) * (1 - fp)   // 散りながら消える
    growth = 1 + fp * 0.35
  }
  if (alpha <= 0.01) return
  const w = 240 * growth
  ctx.save()
  ctx.translate(f.bossX, f.bossY)
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = alpha
  ctx.scale(1, 0.34)            // 床に寝かせる遠近
  ctx.rotate(state.time * 0.6)  // ゆっくり回転
  ctx.drawImage(img, -w / 2, -w / 2, w, w)
  ctx.restore()
}

// 柔らかい光の粒 (加算)。 硬い図形でなく"光"なので世界観ルールに適合 (全画面フラッシュと同類)。
function drawGlowDot(ctx: CanvasRenderingContext2D, x: number, y: number, r: number, color: string, alpha: number): void {
  if (alpha <= 0.01 || r <= 0.4) return
  const g = ctx.createRadialGradient(x, y, 0, x, y, r)
  g.addColorStop(0, color)
  g.addColorStop(0.35, color)
  g.addColorStop(1, 'rgba(255,255,255,0)')
  ctx.globalAlpha = alpha
  ctx.fillStyle = g
  ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill()
}

// ⬜暫定。本番スプライトができたら実機で合わせ直す。
// 旧 BOSS_FACE_ANCHOR_BY_POSE と同じく、ボス表示高を1とした [横, 縦]。負の横 = facing 前方、負の縦 = 足元より上。
const DEFAULT_BOSS_CAST_FLASH_ANCHOR: [number, number] = [-0.32, -1.02]
const BOSS_CAST_FLASH_RISE_MS = 120

// 予兆の途中で立ち上がり、active へ入った瞬間に消える光の強さ。
// 純粋関数として切り出し、振り → 光 → 当たりの時間契約を描画なしで検査できるようにする。
export function castFlashStrength(
  attack: AttackDef | null,
  bossState: Boss['state'],
  stateElapsedMs: number,
): number {
  if (bossState !== 'telegraph' || attack?.castFlashAtMs === undefined) return 0
  return Math.max(0, Math.min(1, (stateElapsedMs - attack.castFlashAtMs) / BOSS_CAST_FLASH_RISE_MS))
}

// 4体目「請われぬ介錯」の 振り → 光 → 当たり。覚醒王の顔グローとは独立させ、淡青だけを重ねる。
function drawBossCastFlash(
  ctx: CanvasRenderingContext2D,
  state: GameState,
  h: number,
  bossVisibility: number,
): void {
  const b = state.boss
  const attack = b.currentAttack
  const strength = castFlashStrength(attack, b.state, b.stateElapsed * 1000) * bossVisibility
  if (!attack || strength <= 0.01) return

  const devAnchor = import.meta.env.DEV
    ? (globalThis as { __castFlashFix?: [number, number] | null }).__castFlashFix
    : undefined
  const anchor = devAnchor ?? attack.castFlashAnchor ?? DEFAULT_BOSS_CAST_FLASH_ANCHOR
  const timelinePose = resolveBossTimelinePose(b.id, b)
  const motion = timelinePose?.motion
  const side = b.facing === 'left' ? 1 : -1 // 元絵は左向き。負の横値を facing 前方へ反転する
  const forwardScreen = b.facing === 'left' ? -1 : 1
  const cx = b.x + anchor[0] * h * side * (motion?.scaleX ?? 1)
    + forwardScreen * (motion?.offsetX ?? 0)
  const cy = bossFootY(b) + anchor[1] * h * (motion?.scaleY ?? 1) + (motion?.offsetY ?? 0)

  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  drawGlowDot(ctx, cx, cy, h * 0.15, 'rgba(150,210,255,1)', strength * 0.34)
  drawGlowDot(ctx, cx, cy, h * 0.075, 'rgba(205,235,255,1)', strength * 0.72)
  drawGlowDot(ctx, cx, cy, h * 0.026, 'rgba(255,255,255,1)', strength)
  ctx.restore()
}

// 心臓の鼓動 (lub-dub の二連拍)。 tm[秒] → 0..1 の脈。 崩しゲージの「血と金の鼓動」用。
function heartbeatPulse(tm: number): number {
  const p = (tm % 0.95) / 0.95
  const lub = Math.exp(-Math.pow((p - 0.02) / 0.05, 2))
  const dub = 0.75 * Math.exp(-Math.pow((p - 0.20) / 0.06, 2))
  return Math.min(1, lub + dub)
}
function lerpRgb(a: [number, number, number], b: [number, number, number], t: number): string {
  const r = Math.round(a[0] + (b[0] - a[0]) * t)
  const g = Math.round(a[1] + (b[1] - a[1]) * t)
  const bl = Math.round(a[2] + (b[2] - a[2]) * t)
  return `rgb(${r},${g},${bl})`
}

// 魂 (#9 リワーク 2026-06-22): 致命=解放は嘘 / 紫の魂=自分を縛る鎖。 ボスの魂は主人公へ噴き出すが
//   彼女のものにならず、 かすめて通り過ぎ常夜燈へ吸い上げられる (= 舞台が奪う / 縫い留め)。
//   旧実装の「魂→主人公に吸収→主人公が発光→残光」(力を得た勝者) を撤去。 主人公は光らない (ユーザー裁定3)。
//   各粒の経路 = 二次ベジェ: P0=ボス → P1=主人公(制御点=ここへ膨らみ「彼女へ来る」) → P2=常夜燈。
//   到着に応じて常夜燈が冷青で静かに応える (#2 drawDeathPurification と同じ言語)。 鎖は比喩のみ=描かない(裁定2)。
// export: 撃破魂FXの見た目を単体ループで確認する finisher-preview.html 用 (実機と同一描画)。
export function drawFinisherSoul(ctx: CanvasRenderingContext2D, state: GameState): void {
  const f = state.finisher; if (!f) return
  const e = f.elapsedMs
  if (e < T_PULL) return                              // impact 中はまだ魂は出ない
  const px = state.player.x, py = state.player.y - PLAYER.height / 2
  const bx = f.bossX, by = f.bossY - 70
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'

  // 2026-06-24: 旧実装は二次ベジェ P0=ボス→P1=主人公(かすめ)→P2=常夜燈位置 で
  //   「魂が常夜燈へ奪われる」軌跡を視覚的に明示し、 常夜燈位置に冷青グローを灯らせて
  //   「舞台が取り込む」を見せていた。
  //   ユーザー裁定 (2026-06-24): 常夜燈は背景に紛れる存在=位置 reveal を避ける運用へ
  //   ([[reference_ghostlight_bg_anchor]] / 灰の王城-design-system §4.2)。
  //   よって紫魂の終端は **画面上方の散らばった点** とし、 主人公をかすめた後
  //   「上の方へ消えていく=蒸発」へ変える。 collapse の方向 (=上) だけ匂わせ、
  //   どこへ行くかは明示しない=プレイヤーは段階的に違和感を蓄積する。
  //   常夜燈の応え (冷青グロー) は撤去=位置を反応で示さない。
  //   旧物語意図 (舞台が魂を奪う / LUNAIRE は得ない) は終盤・3エンドで回収する想定。
  // 2026-06-25 リワーク: 「丸い泡が浮く」→「光がほどけて、どこかへ流れていく」へ。
  //   ① 出生は細い結び目 (元細かく) ② 直後に外へポップ=ほどける ③ 主人公をかすめ上方へ流れて
  //   細りながら消散。 各粒は丸ドットでなく経路に沿うコメット状の尾 (光の糸=流れ) で描く。
  //   旧「魂芯 soul スプライト (紫のもや)」は浮いて見える=撤去 (ユーザー裁定 2026-06-25)。
  const N = 44
  const emitWin = (T_DISSOLVE - T_PULL) * 1.4         // 出生をばらけさせる窓 (連続放出)
  const travel = (T_DISSOLVE - T_PULL) * 1.3          // 各粒がボス→(主人公)→上空へかかる時間
  const TRAIL = 4                                      // コメット尾のサンプル数 (光の流れ)
  const EPS = 0.05                                     // 尾を取る lt の刻み
  for (let i = 0; i < N; i++) {
    const birth = T_PULL + (i / N) * emitWin
    const lt = (e - birth) / travel
    if (lt >= 1) continue                             // 上方で消散しきった粒は描かない
    if (lt < 0) continue
    // ① 出生 = ボス上の細い結び目 (元を細く絞る)。 旧 spread 38-102 → 5-21px。
    const ang = hash01(i * 3.1) * Math.PI * 2
    const knot = 5 + hash01(i * 1.7) * 16
    const ox = bx + Math.cos(ang) * knot
    const oy = by - 10 + Math.sin(ang) * 0.7 * knot
    // 経路: 二次ベジェ P0=結び目 → P1=主人公(かすめる) → P2=画面上方の散らばった点。
    const ascendX = px + (hash01(i * 6.7) - 0.5) * 260
    const ascendY = ARENA.height * 0.04 + hash01(i * 7.3) * 46
    const cx = px + (hash01(i * 4.3) - 0.5) * 30       // P1: 主人公をかすめる
    const cy = py - 8 + (hash01(i * 5.1) - 0.5) * 24
    // ② ほどけて弾けるポップ: 生まれて最初の 25% だけ外へ膨らむ (結び目が解ける)
    const popMax = 14 + hash01(i * 8.1) * 22
    const headColor = hash01(i * 2.3) > 0.7 ? SOUL_BLUE.tail : SOUL_BLUE.head  // 大半は青白・一部ほぼ白 (旧 #cdb0f0 / #eadcff = 菫)
    const baseR = 1.4 + hash01(i * 2.3) * 1.8         // 1.4-3.2px = 旧 3.5-7 より細い
    const fadeIn = Math.min(1, (e - birth) / 60)
    const fadeOut = lt < 0.55 ? 1 : Math.max(0, 1 - (lt - 0.55) / 0.45)  // 上方で消散
    const aHead = fadeIn * fadeOut * 0.85
    // ③ 経路に沿うコメット尾を描く = 光が「流れる」筋に見せる
    for (let s = 0; s < TRAIL; s += 1) {
      const tt = lt - s * EPS
      if (tt < 0) break
      const mt = tt * tt * (3 - 2 * tt)               // smoothstep
      const u = 1 - mt
      const bxp = u * u * ox + 2 * u * mt * cx + mt * mt * ascendX
      const byp = u * u * oy + 2 * u * mt * cy + mt * mt * ascendY
      const popS = (tt < 0.25 ? 1 - tt / 0.25 : 0) * popMax           // ②のポップ (尾の各点も追従)
      const waver = Math.sin(tt * Math.PI * 2 + i) * 6 * (1 - tt)     // 有機的な横揺れ
      const wx = bxp + Math.cos(ang) * popS + waver
      const wy = byp + Math.sin(ang) * 0.7 * popS
      const r = baseR * (1 - 0.5 * lt) * (1 - s / (TRAIL + 1))        // 頭が太く尾は細る・上昇で蒸発
      drawGlowDot(ctx, wx, wy, r, headColor, aHead * (1 - s / TRAIL))
    }
  }

  // 旧実装にあった「常夜燈の応え (冷青グロー)」は撤去 (位置 reveal 防止)。
  ctx.restore()
}

// ボス崩落 (噴出=pull と同時): ボスが崩れて灰/残り火が魂と一緒に外へ噴き出す。
//   芯として ash スプライトを開始時だけ薄く重ねる。
function drawFinisherMotes(ctx: CanvasRenderingContext2D, state: GameState): void {
  const f = state.finisher; if (!f) return
  // ボス崩落の灰は pull 開始から少し長めの窓で散らし、 dissolve 序盤まで滑らかに尾を引かせる
  //   (ビート境界でブツッと消えない)。
  const ashWin = EXECUTE_FX.pullDurationMs * 1.3
  const p = (f.elapsedMs - T_PULL) / ashWin
  if (p < 0 || p >= 1) return
  ctx.save(); ctx.globalCompositeOperation = 'lighter'
  // 芯: ash スプライトを冒頭だけ薄く (崩れ始めの一塊)
  const img = getFinisherFx('ash_soulblue')   // 旧 'ash' (紫)
  if (img && p < 0.5) {
    const w = 200
    ctx.globalAlpha = (0.5 - p) * 0.7
    ctx.save(); ctx.translate(f.bossX, f.bossY - 50)
    ctx.drawImage(img, -w / 2, -w * 0.7, w, w)
    ctx.restore()
  }
  // 灰の粒: ボス中心から外へ放射(ブワッ)しつつ少し上昇して消える
  const N = 32, life = 0.75
  for (let i = 0; i < N; i++) {
    const spawn = (i / N) * (1 - life)
    const lt = (p - spawn) / life
    if (lt <= 0 || lt >= 1) continue
    const out = 1 - (1 - lt) * (1 - lt)             // 外へ放射(ease-out)
    const ang = hash01(i * 1.3) * Math.PI * 2
    const dist = (40 + hash01(i * 2.1) * 95) * out
    const x = f.bossX + Math.cos(ang) * dist
    const y = (f.bossY - 30) + Math.sin(ang) * 0.7 * dist - lt * 28
    const r = (2.5 + hash01(i * 5.1) * 5) * (1 - 0.35 * lt)
    const gold = hash01(i * 6.7) > 0.8
    drawGlowDot(ctx, x, y, r, gold ? '#f4d878' : SOUL_BLUE.hazeLight   /* 旧 #dcc8f4 (淡い藤) */, (1 - lt) * (1 - lt) * 0.95)
  }
  ctx.restore()
}

// 撃破直後の punctuate FX (世界座標)。 ELDEN RING 撃破 (ラダーン「GOD SLAIN」) の "リッチさ" を
//   分解 = ①画面を満たす霧 (空気の密度) ②中央の高輝度コア+強いブルーム ③天へ伸びる光柱。
//   2026-06-25 全面リワーク: 旧 3 ビート (粒子のみ・金寄り) は「点描でスカスカ=安っぽい」→
//   霧/コア/光柱の 3 層を足し、 色は灰の王城の冷色 (白〜淡菫・銀青) へ翻訳 (金は撤去=ジャスト専用に温存)。
//   物語的には: ボスは派手に爆ぜるのでなく、 冷たい霧の中で光がほどけ天へ昇って消える (喪失の荘厳)。
//   ※紫魂の経路は drawFinisherSoul 側で並走 (主人公をかすめ→上方蒸発)。
// export: finisher-preview.html で撃破トドメ全体を目視するため。
export function drawFinisherBurst(ctx: CanvasRenderingContext2D, state: GameState): void {
  const f = state.finisher; if (!f) return
  const e = f.elapsedMs
  // 2026-06-25: 撃破FXは finisher state が生きてる間だけ描かれる (state 終了 = lt が T_END-T_DISSOLVE
  //   に達した瞬間に f=null で打ち切られる)。 BURST_END をその手前 (-80ms) に置き、 全レイヤーが
  //   ここまでに 0 へ達するよう各寿命を収める = state 終了時に生き残りがプツッと消えるのを防ぐ。
  const BURST_END = (T_END - T_DISSOLVE) - 80
  const lt = e - T_DISSOLVE
  if (lt < 0 || lt > BURST_END) return
  const bx = f.bossX
  const by = f.bossY - 70
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'

  // ===== 層0: 立ち込める霧 (空気の密度) — ER の砂塵もうもうの翻訳 =====
  //   大半径の柔らかいグローを多数、 画面下〜中に湧かせゆっくり昇る。 これが "地" になり点描感を消す。
  //   冷色 (淡菫〜銀) で低 alpha・大サイズ。 立ち上がり早・退き遅 (余韻として長く残る)。
  {
    const hazeIn = Math.min(1, lt / 240)                  // 0-240ms で満ちる
    const hazeOut = Math.max(0, 1 - Math.max(0, lt - (BURST_END - 700)) / 700)
    const hazeEnv = hazeIn * hazeOut
    if (hazeEnv > 0.01) {
      const N_HAZE = 16
      for (let i = 0; i < N_HAZE; i += 1) {
        const hx = bx + (hash01(i * 2.3) - 0.5) * 520     // 画面幅広めに散らす
        const drift = Math.sin(lt / 1000 * (0.6 + hash01(i * 3.1)) + i) * 26
        const climb = (lt / BURST_END) * (40 + hash01(i * 4.7) * 70)
        const hy = by + 40 + (hash01(i * 5.3) - 0.4) * 150 - climb
        const r = 90 + hash01(i * 6.1) * 170              // 大きい靄
        const tone = hash01(i * 7.7)
        const col = tone > 0.6 ? SOUL_BLUE.hazeLight : tone > 0.3 ? SOUL_BLUE.haze : '#c4cade'   // 旧 #cdc2e8 / #bcb2d8 (淡菫)
        const a = hazeEnv * (0.05 + hash01(i * 8.9) * 0.06)
        drawGlowDot(ctx, hx + drift, hy, r, col, a)
      }
    }
  }

  // ===== 層1: 中央コアの破裂 (0-) — "ドン" の瞬発 → 余韻 =====
  //   2026-06-25: 「ドン…ふわ〜」の余韻型 (荘厳・ER寄り) へ。 コアは鋭く立ち上がり (破裂) すぐ退く。
  //   ピークは後段の「残光が満ちる」へ譲るので、 ここは短く強い一閃に留める。
  if (lt < 700) {
    // 破裂: 0-90ms で一気にピーク → その後すばやく退く (鋭い立ち上がり)
    const pop = lt < 90 ? lt / 90 : Math.max(0, 1 - (lt - 90) / 610)
    const punch = pop * pop                                       // 鋭さ
    drawGlowDot(ctx, bx, by, 80 + punch * 90, SOUL_BLUE.head, punch * 0.34)   // 青白の大滲み (旧 #c8b0ec 淡菫)
    drawGlowDot(ctx, bx, by, 34 + punch * 40, SOUL_BLUE.white, punch * 0.62)   // 冷白の核
    drawGlowDot(ctx, bx, by, 12 + punch * 16, '#ffffff', punch * 0.92)   // 白の芯
  }

  // ===== 層2: 残光が満ちて引く (60-) — ★ピーク。 全画面にじわ〜と冷光が満ち、 すっと抜ける =====
  //   破裂の一拍おいてから画面全体が淡く発光し、 ゆっくり満ちて引く。 これが「ふわ〜」=荘厳の主役。
  {
    const gp = (lt - 60) / (BURST_END - 60)
    if (gp > 0 && gp < 1) {
      // 立ち上がり遅め→中盤ピーク→長い退き (満ちて引く)。 sin より後ろ寄りの山。
      const fillEnv = Math.sin(Math.min(1, gp * 1.7) * Math.PI) * (1 - gp * 0.25)
      if (fillEnv > 0.01) {
        // 中央が明るく縁が沈む放射グラデ (べた塗りでなく"光が満ちる")
        const g = ctx.createRadialGradient(bx, by - 30, 30, bx, by - 30, ARENA.width * 0.72)
        g.addColorStop(0, SOUL_BLUE.white)   // 旧 #dfd8f5
        g.addColorStop(0.5, SOUL_BLUE.haze)   // 旧 #bfb6e0
        g.addColorStop(1, 'rgba(0,0,0,0)')
        ctx.globalAlpha = fillEnv * 0.22
        ctx.fillStyle = g
        const sr = screenRectInWorld()
        ctx.fillRect(sr.x, 0, sr.w, ARENA.height)
        ctx.globalAlpha = 1
      }
    }
  }

  // ===== 層3: 光片が舞い上がって画面を満たす (20ms-) — ★華の主役 =====
  //   旧「灰の粒」を "輝く銀白の光片" に格上げ。 破裂で外＋上へ放出 → ゆっくり舞い上がり画面を埋める。
  //   余韻型 = 個々の寿命を長く・ピークを後ろに。 大量に出して "光が満ちる" を粒でも作る。
  if (lt >= 20) {
    const N_MOTE = 150
    // 出生は撃破後の前半に寄せて締める (絶対時間)。 これ以降は新規光片を出さない =
    //   最後の粒子 (spawn≤550) + 寿命 (≤1600) ≈ 2150ms < BURST_END = state 終了前に全部フェード。
    const MOTE_SPAWN_END = 550
    for (let i = 0; i < N_MOTE; i += 1) {
      const spawn = hash01(i * 1.9) * hash01(i * 1.9) * MOTE_SPAWN_END   // 破裂直後に多く→波状に薄く
      const localAge = lt - 20 - spawn
      if (localAge < 0) continue
      const lifeSpan = 1000 + hash01(i * 2.7) * 600        // 1000-1600ms (ゆっくり満ちて消散)
      if (localAge > lifeSpan) continue
      const lt2 = localAge / lifeSpan
      // 出発点: ボス周辺に水平広めに散らす (画面幅を埋める)
      const x0 = bx + (hash01(i * 3.1) - 0.5) * 300
      const y0 = by + (hash01(i * 4.1) - 0.5) * 40
      // 破裂の初速 (生後すぐ外へ吹く) + 上昇 (ふわ〜と昇る)
      const burstDir = hash01(i * 2.3) * Math.PI * 2
      const burstKick = (lt2 < 0.2 ? 1 - lt2 / 0.2 : 0) * (30 + hash01(i * 5.9) * 50)
      const rise = 110 + hash01(i * 4.7) * 230
      const yRise = (1 - (1 - lt2) ** 2.3) * rise          // ease-out 強め=ゆっくり漂う
      const driftPhase = hash01(i * 5.3) * Math.PI * 2
      const driftAmp = 12 + hash01(i * 6.9) * 26
      const driftFreq = 0.9 + hash01(i * 7.7) * 1.3
      const x = x0 + Math.cos(burstDir) * burstKick
        + Math.sin(driftPhase + lt2 * driftFreq * Math.PI * 2) * driftAmp * (0.3 + lt2 * 0.9)
      const y = y0 + Math.sin(burstDir) * 0.6 * burstKick - yRise
      // 透明度: ピークを後ろ寄りに (満ちていく)。 終盤ゆっくり消散。
      const alpha = Math.sin(Math.min(1, lt2 * 1.15) * Math.PI) * (0.4 + hash01(i * 8.3) * 0.34)
      const r = (2.0 + hash01(i * 9.1) * 3.0) * (1 - lt2 * 0.5)   // 旧より一回り大きい光片
      // 色: 輝く銀白 主体 + 一部 淡菫/銀青 (冷色)
      const tone = hash01(i * 10.3)
      const col = tone > 0.5 ? '#eef0ff' : tone > 0.25 ? SOUL_BLUE.head : '#c6d2e6'   // 旧 #d8cef4 (淡菫)
      drawGlowDot(ctx, x, y, r, col, alpha)
    }
  }

  ctx.restore()
}

// ER/Nightreign 流の「討伐」バナー (画面座標): スロー中の余韻 (silence) に金の明朝で
//   倒したボス名を掲げる。 「GREAT ENEMY FELLED / NIGHTLORD SLAIN」の翻訳。 戦闘ヒントでなく
//   撃破の句読点なので文字を出してよい (CLAUDE.md の戦闘中文字NGは予兆ヒントの話)。
function drawFelledBanner(ctx: CanvasRenderingContext2D, state: GameState): void {
  const f = state.finisher; if (!f) return
  if (finisherBeat(f.elapsedMs) !== 'silence') return
  const p = beatProgress(f.elapsedMs)                  // 0→1 (silence 全体)
  const a = p < 0.16 ? p / 0.16 : p > 0.82 ? Math.max(0, (1 - p) / 0.18) : 1
  if (a <= 0.01) return
  const cx = ARENA.width / 2
  const y = ARENA.height * 0.32
  ctx.save()
  ctx.textAlign = 'center'
  ctx.globalAlpha = a
  // 上下の細い金罫線 (端 fade)
  const ruleW = 230
  for (const ry of [y - 30, y + 16]) {
    const lg = ctx.createLinearGradient(cx - ruleW, 0, cx + ruleW, 0)
    lg.addColorStop(0, 'rgba(244,216,120,0)')
    lg.addColorStop(0.5, 'rgba(244,216,120,0.85)')
    lg.addColorStop(1, 'rgba(244,216,120,0)')
    ctx.fillStyle = lg
    ctx.fillRect(cx - ruleW, ry, ruleW * 2, 1.4)
  }
  // ボス名 (金・明朝・グロー・二度刷り)
  ctx.fillStyle = PALETTE.fxGold
  ctx.shadowColor = 'rgba(244,216,120,0.9)'
  ctx.shadowBlur = 26
  ctx.font = `600 30px ${UI_SERIF}`
  ctx.fillText(state.boss.displayName, cx, y)
  ctx.shadowBlur = 12
  ctx.fillText(state.boss.displayName, cx, y)
  ctx.shadowBlur = 0
  // 「討 伐」(小さめ・字間広め)
  ctx.fillStyle = 'rgba(248,238,200,0.92)'
  ctx.font = `15px ${UI_SERIF}`
  ctx.fillText('討　伐', cx, y - 40)
  // 横に走る光沢スイープ (ER の金の照り)
  //   最後の一撃 C (既定の新しい版) では出さない: 背景を沈めた画面だと上下の縁が硬い灰色の四角に見えた (10-12d 撮影)。前の版・配布版はそのまま。
  if (finisherCOn()) { ctx.restore(); return }
  const sweep = (performance.now() / 1000 * 0.5) % 1.4 - 0.2   // ゆっくり左→右
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = a * 0.5
  const sx = cx - ruleW + sweep * ruleW * 2
  const sg = ctx.createLinearGradient(sx - 40, 0, sx + 40, 0)
  sg.addColorStop(0, 'rgba(255,250,230,0)')
  sg.addColorStop(0.5, 'rgba(255,250,230,0.8)')
  sg.addColorStop(1, 'rgba(255,250,230,0)')
  ctx.fillStyle = sg
  ctx.fillRect(sx - 40, y - 26, 80, 30)
  ctx.restore()
}

// ============== 背景画像 (ドリームランド) ==============
// そざい画像を public/bg/ に配置、初回アクセス時に非同期ロード。
// ロード前は星空フォールバックで動作継続。
// 背景: boss ごとに差し替え。 未登録ボスは城ホール(castle)を共通使用。
// テスト用 export: 背景パスの typo / 欠落を tests/bg_layer_assets.test.ts で検出する。
export const BG_SRC_BY_BOSS: Record<string, string> = {
  // 2026-07-28: knight-hall-v2.png (2144x720, 接地線=画像高さの81.5%) へ差し替え。
  //   旧絵は床の前縁が足元にありその下が崖の面だった(「ヘリで戦っている」)のと、
  //   人物との縮尺が合っていなかった(「二人が小人」)ため。実測=作業票 §2。
  'vigil-knight': '/bg/knight-hall-v2.png',
  // 2026-07-28: 稽古と王は同じ広間の絵を共有していたが、脚本が指す場所と違っていたので
  //   部屋そのものを分けた (発注 = docs/candidates/2026-07-28-story-matched-rooms-order.md)。
  //   稽古 = 「廊下の奥に、影のような者が立っていた」→ 廊下。 壁龕に**空の台座**が並ぶ (絵の小道具。役どころの意味は持たせない)。
  //     突き当りの扉の継ぎ目から紫の光
  //     = 「廊下の奥で、何かが目を覚ましたようだった」= 次の王戦。
  //   王 = 「謁見の間。砕けた王冠の縁から、冷たい光が漏れている」(10-11 まで「冷たい紫の光」)→ 玉座の間。
  //     玉座は台帳の確定事項 (2026-07-06 ADV裁定「#1王戦の玉座と#3騎士戦Trueの空の玉座は同一」)
  //     かつ2択「王冠を、玉座へ戻してあげる」の対象。 柱から垂れる鎖と床の環
  //     = 役どころ「玉座を離れられぬ、灰の王城の主」。
  //   ⚠️ castle.png 自体は残す = 処刑人より後の未登録ボスの既定として今も使われている。
  'nameless-shade': '/bg/shade-corridor.png',
  'dream-hound': '/bg/throne-hall.png',
  // 2026-07-28: 婚礼の間も崖があった (段差39.6) ため bride-hall-v2 へ差し替え。
  //   青灯は右の描き込み = 下の常夜燈も右へアンカー (実測 871,306)。
  'bride': '/bg/bride-hall-v2.png',
  // 2026-10-01: 砕き場 → 施療院 (ユーザー選択・当て絵 room_B から男を消した絵)。 旧 executioner-crushing-yard.png は残す。
  //   左の寝台の陰に看病の人の足と倒れた水差し (ユーザー「一旦入れてみて」= 試し)、 右から3番目が空いた寝台。
  'the-executioner': '/bg/executioner-hospice.png',
  // 2026-10-19: 剣舞 = C 金の舞台 (作者 10-18 選択・room_c_v1)。 明るさは今のまま (暗さの膜もそのまま)。
  //   旧 = 城の既定 (castle.png)。 DEV ?bladeArt=old で戻る (blade_dancer_art.ts)。
  'blade-dancer': '/bg/blade-dancer-stage.png',
  // 2026-10-20: 覚醒王 = A3 に奥行きを付けた B 灯りの版 (作者 10-19 選択)。 獣の立つ・跳ぶ高さの暗い所だけ薄い霞で底上げした
  //   (作者「ちょっと見にくいぐらい」・記録 docs/research/2026-10-20-awoken-room-ship.md)。 左右の柱は awoken-wall.png (drawAwokenWalls)。
  //   旧 = 城の既定 (castle.png)＋仮の石の板。 DEV ?awokenRoom=old で戻る (useAwokenOldRoom)。
  'crowned-king-awoken': '/bg/awoken-room.png',
  // 2026-11-03: 鶏 = 鐘楼の頂上 (物語の場面と同じ場所)。 床を手前へ伸ばした版 (作者 11-02「これでいい」・鐘はこのまま・「いま替える」)。
  //   記録 docs/research/2026-11-03-rooster-floor.md。 旧 = 城の既定 (castle.png)。 DEV ?roosterRoom=castle / v1 で戻る (useRoosterOldRoom)。
  'inverted-jester': '/bg/rooster-bell-tower-floor.png',
}
const DEFAULT_BG_SRC = '/bg/castle.png'
// 舞台を広げた時だけ使う横長版 (2026-07-28)。 未登録の部屋は従来どおり上の1枚絵を引き伸ばす。
//   🔴 **1倍 (= 配布版) では絶対に使わない。** 横長版は中央の構図が元絵と1px単位では一致せず、
//     1倍でも使うと**クローズ済みの騎士の部屋の絵が黙って変わる**ため。
//     広い舞台自体が DEV 限定なので、この分岐も配布版には出ない。
// テスト用 export: 背景パスの typo / 欠落を tests/bg_layer_assets.test.ts で検出する。
export const BG_WIDE_SRC_BY_BOSS: Record<string, string> = {
  // 2026-07-28: 'vigil-knight' 行を削除 (作業票 §3-4)。 新背景は世界1608pxぶんしかなく、
  //   舞台1.4倍の世界(1940px)を覆う横長版(3.59:1)は画像生成の上限3:1を超えるため作れない。
  //   舞台1.4倍(STAGE_MULS)自体を畳んだので、この表は当面どのボスも参照しない。
  //   表と仕組みは他の部屋のために残す。
}
// 部屋の背景はファイル名でボスが分からない物があるので、読む順番 (src/asset_queue.ts) に持ち主を教える。
setAssetOwners(BG_SRC_BY_BOSS); setAssetOwners(BG_WIDE_SRC_BY_BOSS)

// 層構造の背景 (2026-07-28)。 **奥から順に**並べる。 登録が無い部屋は上の1枚絵の経路のまま
// = 部屋を1つずつ移していける。 舞台1倍では使わない (BG_WIDE_SRC_BY_BOSS と同じ理由)。
//   🔴 奥の層は**手前が透けていないと永久に見えない**。 部屋の層は窓が抜けた RGBA であること。
//   視差の値: 奥ほど小さい = ゆっくり流れる。 部屋の層は 1.0 = 世界と同速
//   (この層に常夜燈の灯体が描き込まれているので、1.0 でないと青いグローとズレる)。
//   奥の層は `sky` = **コードで描く**。 絵にしない理由 (2026-07-28):
//     ①この層は手前の窓の開口部からしか見えず、雲・月・遠景の尖塔しか要らない
//       = 描き込みが不要な唯一の層で、手続きで足りる
//     ②画像生成が繰り返し失敗して進行が止まった。外部サービスに握られない
//     ③幅の制限が消える。 世界がどれだけ広くなっても継ぎ目も繰り返しも出ない
//     ④定数で調整できる (絵は作り直しになる)
type BgPart = { src: string; x: number; y: number; scale: number }
type BgLayer =
  | { src: string; parallax: number }
  | { sky: true; parallax: number }
  | { parts: BgPart[]; parallax: number }
// テスト用 export: 背景パスの typo / 欠落を tests/bg_layer_assets.test.ts で検出する。
export const BG_LAYERS_BY_BOSS: Record<string, BgLayer[]> = {
  // 2026-07-28: 'vigil-knight' 行を削除 (作業票 §3-4)。 舞台1.4倍を畳んだため層構造は使わない。
  //   表と仕組みは他の部屋のために残す。 drawLayeredBackground 等の関数も消さない。
}

// 部屋の絵に描き込まれた「床より手前に立つ柱」を、キャラより前へもう一度描くための登録。
//   🔴 同じ画像の同じ位置へ同じ画素を重ねる = ズレようがない。 マスクの粗さも見えない。
//   u = 部屋の絵に対する左端の比 (画像 x / 画像幅)。 絶対座標で持たない。
type BgFrontPart = { src: string; u: number }
// テスト用 export: 背景パスの typo / 欠落を tests/bg_layer_assets.test.ts で検出する。
export const BG_FRONT_BY_BOSS: Record<string, BgFrontPart[]> = {
  // 2026-07-28: 'vigil-knight' 行を削除 (作業票 §3-4)。 舞台1.4倍を畳んだため前景柱の再描画は使わない。
  //   画像は削除せず public/bg/archived/ へ退避。 表と仕組みは他の部屋のために残す。
}

// 奥の層 (夜空) を手続きで描く。 span はこの層が覆うべき幅。
//   🔴 **手前の石より明るいこと**が要件。 暗いと窓が窓に見えない (第1版の絵の失敗)。
//   ⚠️ 乱数を使わない。 雲も尖塔も下の表で位置を持つ = 毎フレーム同じ絵になる (ちらつかない)。
const SKY_TOP = '#141033'
const SKY_MID = '#3b3a86'
const SKY_LOW = '#2a2560'
// 雲: [中心x(幅比), 中心y(高さ比), 半径x(幅比), 半径y(高さ比), 濃さ]
const SKY_CLOUDS: [number, number, number, number, number][] = [
  [0.08, 0.42, 0.13, 0.055, 0.30], [0.23, 0.26, 0.09, 0.038, 0.22],
  [0.34, 0.55, 0.16, 0.065, 0.26], [0.47, 0.33, 0.07, 0.030, 0.34],
  [0.58, 0.62, 0.19, 0.050, 0.20], [0.71, 0.29, 0.12, 0.058, 0.28],
  [0.83, 0.50, 0.10, 0.036, 0.24], [0.94, 0.36, 0.15, 0.062, 0.18],
]
// 尖塔のシルエット: [頂点x(幅比), 高さ(高さ比), 幅(幅比)]。 間隔も高さも不揃いにする。
const SKY_SPIRES: [number, number, number][] = [
  [0.04, 0.16, 0.020], [0.11, 0.26, 0.014], [0.15, 0.11, 0.026], [0.26, 0.31, 0.017],
  [0.31, 0.19, 0.012], [0.40, 0.24, 0.022], [0.44, 0.13, 0.015], [0.55, 0.29, 0.019],
  [0.62, 0.17, 0.013], [0.66, 0.22, 0.025], [0.75, 0.34, 0.016], [0.80, 0.14, 0.021],
  [0.88, 0.27, 0.015], [0.96, 0.20, 0.023],
]
const SKY_MOON_X = 0.42          // 中央よりやや左
const SKY_MOON_Y = 0.30
function drawSkyLayer(ctx: CanvasRenderingContext2D, span: number): void {
  const h = ARENA.height
  ctx.save()
  const g = ctx.createLinearGradient(0, 0, 0, h)
  g.addColorStop(0, SKY_TOP)
  g.addColorStop(0.52, SKY_MID)
  g.addColorStop(1, SKY_LOW)
  ctx.fillStyle = g
  ctx.fillRect(0, 0, span, h)

  // 月 (主光源)。 halo は加算 = 雲の上にも光が乗る
  const mx = span * SKY_MOON_X, my = h * SKY_MOON_Y
  ctx.globalCompositeOperation = 'lighter'
  const halo = ctx.createRadialGradient(mx, my, 0, mx, my, h * 0.30)
  halo.addColorStop(0, 'rgba(214,220,255,0.55)')
  halo.addColorStop(0.35, 'rgba(150,160,235,0.22)')
  halo.addColorStop(1, 'rgba(90,100,200,0)')
  ctx.fillStyle = halo
  ctx.beginPath(); ctx.arc(mx, my, h * 0.30, 0, Math.PI * 2); ctx.fill()
  ctx.globalCompositeOperation = 'source-over'
  ctx.fillStyle = 'rgba(236,240,255,0.92)'
  ctx.beginPath(); ctx.arc(mx, my, h * 0.036, 0, Math.PI * 2); ctx.fill()

  // 雲 (柔らかい塊。 輪郭を立てない = 遠景に見える)
  for (const [cx, cy, rx, ry, a] of SKY_CLOUDS) {
    const x = span * cx, y = h * cy, ax = span * rx, ay = h * ry
    const cg = ctx.createRadialGradient(x, y, 0, x, y, Math.max(ax, ay))
    cg.addColorStop(0, `rgba(178,184,232,${a.toFixed(3)})`)
    cg.addColorStop(1, 'rgba(150,156,215,0)')
    ctx.save()
    ctx.translate(x, y); ctx.scale(1, ay / Math.max(ax, ay)); ctx.translate(-x, -y)
    ctx.fillStyle = cg
    ctx.beginPath(); ctx.arc(x, y, Math.max(ax, ay), 0, Math.PI * 2); ctx.fill()
    ctx.restore()
  }

  // 遠景の尖塔 (下側の帯・黒に近い。 空より必ず暗い = 奥行きの手掛かり)
  const baseY = h * 0.86
  ctx.fillStyle = 'rgba(16,14,34,0.88)'
  for (const [sx, sh, sw] of SKY_SPIRES) {
    const x = span * sx, w = span * sw, top = baseY - h * sh
    ctx.beginPath()
    ctx.moveTo(x - w / 2, baseY)
    ctx.lineTo(x - w / 2, top + h * 0.05)
    ctx.lineTo(x, top)
    ctx.lineTo(x + w / 2, top + h * 0.05)
    ctx.lineTo(x + w / 2, baseY)
    ctx.closePath(); ctx.fill()
  }
  ctx.fillRect(0, baseY, span, h - baseY)
  ctx.restore()
}
// 層1枚を貼る矩形。 縦横比は保つ (横だけ伸ばすと柱が太る)。 足りなければ拡大して覆う。
//   ⚠️ **常夜燈の位置もここから逆算する**ので、描画と位置計算で同じ関数を通すこと
//     (別々に計算すると、舞台の倍率を変えた時にだけ光がズレる = 見つけにくいバグになる)。
function bgLayerRect(img: HTMLImageElement, span: number): { x: number; w: number; h: number } {
  const aspect = img.width / img.height
  const w = Math.max(span, ARENA.height * aspect)
  return { x: (span - w) / 2, w, h: w / aspect }
}
function drawBgLayer(ctx: CanvasRenderingContext2D, img: HTMLImageElement, span: number): void {
  const rect = bgLayerRect(img, span)
  ctx.drawImage(img, rect.x, 0, rect.w, rect.h)
}

// 横長背景に描き込まれた常夜燈の灯芯の位置 (画像に対する比)。 背景を差し替えたら測り直す
// (道具 = tmp/find_lantern.py。 仕様書 `2026-07-28-layered-background-design.md` §5)。
//   🔴 **絶対座標で持たない。** 舞台の倍率で貼る矩形が変わるため、比から毎回逆算する。
const WIDE_GHOST_LIGHT_BY_BOSS: Record<string, { u: number; v: number; scale: number; alpha: number }> = {
  // 2026-07-28: 'vigil-knight' 行を削除 (作業票 §3-4)。 舞台1.4倍を畳んだため層構造は使わない。
  //   表と仕組みは他の部屋のために残す。
}

// 横長背景を「元の1枚絵と同じ部屋の縮尺」で貼るための実測値 (2026-07-28)。
//   🔴 **画面の高さに合わせて貼ってはいけない。** 生成された横長絵は部屋を元より大きく描いており、
//     高さ合わせで貼ると部屋が **27%** 育つ (実測: 常夜燈の灯芯→床が 135px → 172px)。
//     キャラの表示サイズは不変なので、そのぶん二人が小さく見える。
//   縮尺は **灯芯から床までの距離**で決める。縦の距離なので横の歪みに影響されない物差し。
//   道具 = tmp/measure_floor_line.py (灯芯と床の前縁を実測する)
//   ⚠️ この縮尺だと絵の横幅が世界幅に届かない (騎士 1721 < 1940)。届かない左右は `edge` で埋める。
//     カメラが端まで振れた時だけ画面端に出る。元絵の端はもともとほぼ黒なので馴染む
//     (実測: 左端24列の平均 (12,13,23) / 右端 (10,12,19))。
type WideRoomFit = { vLantern: number; vFloor: number; lanternToFloorPx: number; edge: string }
const WIDE_ROOM_FIT_BY_BOSS: Record<string, WideRoomFit> = {
  // 2026-07-28: 'vigil-knight' 行を削除 (作業票 §3-4)。 舞台1.4倍を畳んだため層構造は使わない。
  //   表と仕組みは他の部屋のために残す。
}
/** 部屋の層を貼る矩形。 縮尺は灯芯→床の実測で決め、床が ARENA.floorY に来るよう縦位置を出す。 */
function wideRoomRect(
  img: HTMLImageElement, fit: WideRoomFit, worldW: number,
): { x: number; y: number; w: number; h: number } {
  const density = fit.lanternToFloorPx / ((fit.vFloor - fit.vLantern) * img.height)
  const w = img.width * density
  const h = img.height * density
  return { x: (worldW - w) / 2, y: ARENA.floorY - fit.vFloor * h, w, h }
}
// 🔴 背景に描かれた灯へグローを重ねる時は、必ずこれを通す (2026-07-29)。
//   `drawGhostLight` は渡した y の **40*scale だけ上** に灯を描く (立ち灯籠の支柱の高さぶん)。
//   以前は表が「支柱の根元」を持ち、灯芯 + (-2.5, +37.4) を手で足していたが、
//   **実際の描画は -40*scale = -34 (scale 0.85)** なので、常に約4px ズレていた。
//   支柱は `post: false` で描いていない = 支柱基準で持つ意味がそもそも無い。
//   → **表は「絵の灯芯」をそのまま持つ**。 計測スクリプトの出力と1:1で突き合わせられる。
function drawGhostLightAtFlame(
  ctx: CanvasRenderingContext2D, flameX: number, flameY: number, scale: number, alpha: number,
): void {
  // 比較版 v1 (11-03・src/lamp_light.ts): 芯から減るにじみ・炎の揺らぎ・床と壁の照り返し・立ちのぼる粒。配布版 (DEV ?lampLight=old で前の版)。
  //   戦いの部屋の灯りは奥の壁や柱の上にあり、 ARENA.floorY は手前の床の線 = 真下に光だまりを置くと遠近が崩れる。
  //   床は照らさず、 壁の照り返しを下へ長く伸ばして代える (11-03 撮影で確かめた)。
  if (lampLightV1()) { drawLampLightV1(ctx, flameX, flameY, scale, alpha, { seed: 1 }); return }
  drawGhostLight(ctx, flameX, flameY + 40 * scale, scale, alpha, { post: false, tint: 'cool' })
}

// 空気遠近の強さ。 視差1.0の層には 0 になるので、部屋の絵は 1px も変わらない。
//   0 = 生成した絵そのまま / 大きいほど奥が沈む。 実機で見て決める1つのツマミ。
const FAR_LAYER_HAZE = 0.28
const bgCache: Record<string, { img: HTMLImageElement; loaded: boolean }> = {}
function ensureBg(src: string): { img: HTMLImageElement; loaded: boolean } | null {
  if (typeof Image === 'undefined') return null
  let entry = bgCache[src]
  if (!entry) {
    const img = new Image()
    entry = { img, loaded: false }
    bgCache[src] = entry
    img.onload = () => { entry!.loaded = true }
    img.src = src
  }
  return entry
}

// 次の部屋・回想・負け画面の絵を、使う前に読み始める (11-01・docs/research/2026-11-01-scene-transition-slow-net.md)。
//   背景は使う時に初めて読んでいた (遅い回線で黒い背景が出る)。呼ぶのは src/prefetch_next.ts の流れ (main)。
export function prefetchRoomBackground(bossId: string): void {
  ensureBg(BG_SRC_BY_BOSS[bossId] ?? DEFAULT_BG_SRC)
}
export function prefetchFlashbackImages(): void {
  for (const src of FLASHBACK_SRCS) ensureBg(src)
}
// 1枚絵の部屋の背景 (drawBackground が層を使わない時に貼る絵)。 層は今どの部屋も持たない (BG_LAYERS_BY_BOSS が空)。
function roomBgSrc(bossId: string | undefined): string {
  const twinsSrc = import.meta.env.DEV ? twinsBgSrc(bossId) : undefined
  const wideSrc = getArenaWidthMul() > 1 && bossId ? BG_WIDE_SRC_BY_BOSS[bossId] : undefined
  return twinsSrc || wideSrc || (bossId && BG_SRC_BY_BOSS[bossId]) || DEFAULT_BG_SRC
}
// 取りに行き終えたか (読めた・読めなかったの両方を終わりと数える・img.complete)。 まだなら読み始める。
function bgSettled(src: string): boolean {
  const entry = ensureBg(src)
  return !entry || entry.img.complete
}
/** その部屋の背景 (覚醒王は左右の柱も) を取りに行き終えたか。 戦いへ抜ける暗転を延ばす判定 (src/battle_asset_gate.ts・11-02)。 */
export function roomBackgroundSettled(bossId: string): boolean {
  if (!bgSettled(roomBgSrc(bossId))) return false
  if (bossId === 'crowned-king-awoken' && !awokenOldRoom && !bgSettled(AWOKEN_WALL_SRC)) return false
  return true
}
/** 先代の回想の4枚を取りに行き終えたか。 幕間の頭を延ばす判定 (src/battle_asset_gate.ts・11-02)。 */
export function flashbackImagesSettled(): boolean {
  return FLASHBACK_SRCS.every(bgSettled)
}
const TIPS_PHOTO_KEYS = ['tips_evade', 'tips_execute', 'tips_guard', 'tips_just_parry', 'tips_parry', 'tips_ui', 'tips_zone']
export function prefetchTipsArt(): void {
  tipsFrame()
  for (const key of TIPS_PHOTO_KEYS) tipsPhoto(key)
}

// 体幹バー PNG 素材 (将来フォールバック用残置・現在は Canvas 直描き A案)
let postureEmptyImg: HTMLImageElement | null = null
let postureMoongoldImg: HTMLImageElement | null = null
let postureCrimsonImg: HTMLImageElement | null = null
// @ts-ignore -- 将来 PNG 版フォールバック用に残置 (現在 Canvas A案のため未呼び出し)
function ensurePostureBarImages(): void {
  if (typeof Image === 'undefined') return
  if (!postureEmptyImg) {
    postureEmptyImg = new Image()
    postureEmptyImg.src = '/ui/boss-hud/posture_trough_empty.png'
  }
  if (!postureMoongoldImg) {
    postureMoongoldImg = new Image()
    postureMoongoldImg.src = '/ui/boss-hud/posture_trough_moongold.png'
  }
  if (!postureCrimsonImg) {
    postureCrimsonImg = new Image()
    postureCrimsonImg.src = '/ui/boss-hud/posture_trough_crimson.png'
  }
}

function drawBackground(ctx: CanvasRenderingContext2D, t: number, bossId: string | undefined): void {
  bgLocked = awokenRoomLock && bossId === 'crowned-king-awoken'
  // 層構造が登録されていて、土台になる画像層が全部ロード済みならそちらを使う。
  // パーツ層は層内の全画像が揃うまでその層だけ描かず、奥と部屋は先に描く。
  // 軍配者たちの部屋 (開発版の二人の戦いだけ・10-30)。 hollow-actor の層の背景より先に選ぶ。
  const twinsSrc = import.meta.env.DEV ? twinsBgSrc(bossId) : undefined
  const layers = getArenaWidthMul() > 1 && bossId && !twinsSrc ? BG_LAYERS_BY_BOSS[bossId] : undefined
  const layerBgs = layers?.map((layer) => {
    if ('sky' in layer) return null
    if ('parts' in layer) return layer.parts.map((part) => ensureBg(part.src))
    return ensureBg(layer.src)
  })
  if (
    layers
    && layerBgs
    && layerBgs.every((bg, i) => {
      const layer = layers[i]!
      return 'sky' in layer || 'parts' in layer || (bg && !Array.isArray(bg) && bg.loaded)
    })
  ) {
    drawLayeredBackground(ctx, t, bossId, layers, layerBgs)
    return
  }
  const bg = ensureBg(roomBgSrc(bossId))
  // ⚠️ 視差より先に決める。 bgParallaxShift / bgSpanPx / drawFloorFog が読む。
  //   判定は**絵の縦横比だけ**で、ボスIDの表を持たない = 部屋を1つずつ差し替えていける。
  bgWide = !!bg && bg.loaded && bg.img.width / bg.img.height > WIDE_BG_MIN_ASPECT
  // 画像未ロード時は深い夜空のグラデで埋める (ガクッと感をなくす)
  if (!bg || !bg.loaded) {
    const grad = ctx.createLinearGradient(0, 0, 0, ARENA.height)
    grad.addColorStop(0, '#08041a')
    grad.addColorStop(1, '#06030d')
    ctx.fillStyle = grad
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    return
  }
  // 背景画像を描画。 カメラ有効時は視差 (BG_PARALLAX) で流す。
  //   ⚠️ 足りない横幅は **縦横おなじ倍率で拡大して** 埋める (仮)。横だけ伸ばすと柱が太る。
  //      拡大の基準は床の線 = 床の高さが変わらないので、人物と床の関係がズレない。
  //      画の上側ははみ出して切れるが、聖堂の天井が近く見えるだけで絵としては破綻しない。
  //   本番の横長背景が入ったら、この拡大をやめて等倍で貼る。
  ctx.save()
  const bgShift = bgParallaxShift()
  // 等倍でない絵を拡大して貼る倍率 (床の線が基準)。 絵に描き込まれた灯体へ重ねる常夜燈も、 同じ倍率で写す。
  const bgScale = bgWide ? 1 : bgSpanPx() / ARENA.width
  ctx.translate(bgShift, 0)
  if (bgWide) {
    // 横長の本番背景は**等倍で貼る**。 縦を画面高へ合わせ、横は縦横比のまま = 歪みゼロ。
    //   世界の中央へ置く = 端が足りない時も左右へ均等に不足する (片側だけ切れない)。
    const drawH = ARENA.height
    const drawW = drawH * (bg.img.width / bg.img.height)
    const worldW = cameraWorld.right - cameraWorld.left
    ctx.drawImage(bg.img, (worldW - drawW) / 2, 0, drawW, drawH)
  } else {
    ctx.drawImage(bg.img, 0, ARENA.floorY - ARENA.floorY * bgScale, ARENA.width * bgScale, ARENA.height * bgScale)
  }
  // 戦闘要素の視認性のため、軽く暗くする (灰の王城は元々暗いので控えめ)
  //   覚醒王の大技で部屋全体へ引くと画面の上 (y<0) も映るので、 上下にも広く敷く (帯の段差が出た・10-27)。
  ctx.fillStyle = 'rgba(6,3,13,0.22)'
  ctx.fillRect(0, -ARENA.height, Math.max(bgSpanPx(), cameraWorld.right - cameraWorld.left), ARENA.height * 3)
  ctx.restore()
  // 蝋燭グロー(CANDLES)は城ホールの燭台位置に合わせた固定座標。 城ホール専用=それ以外はオフ。
  //   専用背景3種には固有の灯体が描き込まれているため、城ホール座標の炎は重ねない。
  const useCastleCandles = (!bossId || !BG_SRC_BY_BOSS[bossId]) && !twinsSrc
  // 蝋燭と常夜燈は「背景画に描き込まれた灯体」に重ねるものなので、背景と同じ視差の座標系で描く。
  ctx.save()
  ctx.translate(bgShift, 0)
  if (useCastleCandles) drawCandleFlicker(ctx, t)
  // 床の霧ドリフト で止め絵感を消す
  drawFloorFog(ctx, t)
  // 常夜燈 (ghost light・spec 2026-06-03 §3): 全戦闘エリアの隅に常在する「消えない一灯」。
  //   死ぬほどに「これは何をしても消えない」と体で覚える = ラストの伏線。 全ボス共通。
  const ghostLight = bossId ? GHOST_LIGHT_BY_BOSS[bossId] : undefined
  if (ghostLight) {
    //   拡大した絵ではランタンも拡大した位置にある。 拡大前の座標のまま描くと、 灯りだけ部屋の中央寄りに浮く
    //   (2026-10-29 作者「中央あたりに青白い光がずっと固定で置かれてる」・覚醒王の広い舞台で 1.725 倍)。
    drawGhostLightAtFlame(ctx, ghostLight.x * bgScale, ARENA.floorY - (ARENA.floorY - ghostLight.y) * bgScale,
      ghostLight.scale * bgScale, ghostLight.alpha)
  } else {
    drawGhostLight(ctx, ARENA.rightWall + 18, ARENA.floorY + 2, 0.85, 0.7)
  }
  ctx.restore()
}

// 層構造の背景を描く (2026-07-28)。 1枚絵の drawBackground と同じ後処理 (暗さ・霧・常夜燈) を行う。
//   ⚠️ **層ごとに視差が違う = 層ごとに translate をやり直す。** 1つの座標系にまとめられない。
function drawLayeredBackground(
  ctx: CanvasRenderingContext2D, t: number, bossId: string | undefined,
  layers: BgLayer[],
  bgs: (
    | { img: HTMLImageElement; loaded: boolean }
    | ({ img: HTMLImageElement; loaded: boolean } | null)[]
    | null
  )[],
): void {
  // 部屋の層 (いちばん手前 = 常夜燈の灯体が乗っている層) の視差を、後処理の基準にする。
  bgWide = true
  const worldW = cameraWorld.right - cameraWorld.left
  const camOffset = cameraX - cameraWorld.left
  // 抜けた窓の向こうが未ロードでも黒く落ちないよう、最初に夜空色で埋める。
  ctx.save()
  ctx.fillStyle = '#06030d'
  ctx.fillRect(0, 0, worldW, ARENA.height)
  ctx.restore()
  for (let i = 0; i < layers.length; i += 1) {
    const layer = layers[i]!
    // その層が覆うべき幅。 視差が小さいほど狭くて済む (= 奥ほど小さくて足りる)。
    const span = ARENA.width + Math.max(0, worldW - ARENA.width) * layer.parallax
    ctx.save()
    ctx.translate(-camOffset * layer.parallax, 0)
    if ('sky' in layer) {
      drawSkyLayer(ctx, span)
    } else if ('parts' in layer) {
      const partBgs = bgs[i]
      // パーツ層は1枚でも未ロードなら層全体を描かない。他の層はそのまま描く。
      if (Array.isArray(partBgs) && partBgs.every((bg) => bg?.loaded)) {
        for (let partIndex = 0; partIndex < layer.parts.length; partIndex += 1) {
          const part = layer.parts[partIndex]!
          const img = partBgs[partIndex]!.img
          ctx.drawImage(
            img,
            part.x,
            part.y,
            img.width * part.scale,
            img.height * part.scale,
          )
        }
      }
    } else {
      const bg = bgs[i]
      const fit = layer.parallax === 1 && bossId ? WIDE_ROOM_FIT_BY_BOSS[bossId] : undefined
      if (bg && !Array.isArray(bg) && fit) {
        // 部屋の層: 元の1枚絵と同じ縮尺で貼る (画面高へ合わせない)。
        const rect = wideRoomRect(bg.img, fit, worldW)
        // 届かない左右を先に埋める。 絵の端の色そのものなので継ぎ目が出ない。
        ctx.fillStyle = fit.edge
        if (rect.x > 0) ctx.fillRect(-ARENA.width, 0, rect.x + ARENA.width, ARENA.height)
        const right = rect.x + rect.w
        if (right < worldW) ctx.fillRect(right, 0, worldW - right + ARENA.width, ARENA.height)
        ctx.drawImage(bg.img, rect.x, rect.y, rect.w, rect.h)
      } else if (bg && !Array.isArray(bg)) {
        drawBgLayer(ctx, bg.img, span)
      }
    }
    // 空気遠近: 奥の層ほど部屋の色をかぶせて沈める。 生成した夜空はそのままだと彩度が高く、
    //   手前の石より「前に出て」見える。 視差1.0の層 (部屋そのもの) には一切かからない。
    if (layer.parallax < 1) {
      ctx.fillStyle = `rgba(14,10,30,${(FAR_LAYER_HAZE * (1 - layer.parallax)).toFixed(3)})`
      ctx.fillRect(-span, 0, span * 3, ARENA.height)
    }
    ctx.restore()
  }
  ctx.save()
  ctx.translate(-camOffset, 0)
  ctx.fillStyle = 'rgba(6,3,13,0.22)'
  ctx.fillRect(0, 0, worldW, ARENA.height)
  drawFloorFog(ctx, t)
  // 常夜燈: 灯体は**部屋の層に描き込まれている**ので、その層の貼り位置から逆算する。
  //   部屋の層 = 視差 1.0 の画像レイヤー (この座標系と一致する層)。
  const roomIdx = layers.findIndex((layer, i) => {
    const bg = bgs[i]
    return !('sky' in layer) && !('parts' in layer) && layer.parallax === 1 && !!bg && !Array.isArray(bg)
  })
  const wideAnchor = bossId ? WIDE_GHOST_LIGHT_BY_BOSS[bossId] : undefined
  if (wideAnchor && roomIdx >= 0) {
    const roomBg = bgs[roomIdx] as { img: HTMLImageElement; loaded: boolean }
    // ⚠️ 部屋の層と**同じ矩形の出し方**を通すこと。別々に計算すると、縮尺を変えた時に光だけズレる。
    const roomFit = bossId ? WIDE_ROOM_FIT_BY_BOSS[bossId] : undefined
    const rect = roomFit
      ? wideRoomRect(roomBg.img, roomFit, worldW)
      : { ...bgLayerRect(roomBg.img, worldW), y: 0 }
    drawGhostLightAtFlame(
      ctx,
      rect.x + wideAnchor.u * rect.w,
      rect.y + wideAnchor.v * rect.h,
      wideAnchor.scale, wideAnchor.alpha,
    )
  } else {
    const ghostLight = bossId ? GHOST_LIGHT_BY_BOSS[bossId] : undefined
    if (ghostLight) {
      drawGhostLightAtFlame(ctx, ghostLight.x, ghostLight.y, ghostLight.scale, ghostLight.alpha)
    } else {
      drawGhostLight(ctx, ARENA.rightWall + 18, ARENA.floorY + 2, 0.85, 0.7)
    }
  }
  ctx.restore()
}

/** 部屋の絵の「手前に立つ柱」をキャラより前へ描く。 部屋の層とまったく同じ矩形へ貼る。 */
// 覚醒王の部屋の左右の柱 (2026-10-20・作者 10-19「柱の明るさ このくらい」= wall_n1)。 絵は高さ 892 (2倍) で持ち、高さ 446 で描く。
//   胴の内側の縁 (高さ 45% の所) を壁の線 (arenaBoundsFor の leftWall / rightWall) に合わせ、右は鏡写し。 台座だけ内側へ 24px 張り出す。
//   暗さの膜より後に描く = 背景より少し明るい、いちばん手前の面。 原本 = LUNAIRE-notes の assets/2026-10-19-awoken-room-depth/wall_n1.png
const AWOKEN_WALL_SRC = '/bg/awoken-wall.png'
const AWOKEN_WALL_H = 446
const AWOKEN_WALL_INNER_PX = 111
const AWOKEN_WALL_SHADOW_RY = 26
let awokenOldRoom = false
/** 覚醒王を旧の部屋 (城の既定の背景＋仮の石の板) へ戻す (DEV の ?awokenRoom=old だけが呼ぶ)。 */
export function useAwokenOldRoom(): void {
  awokenOldRoom = true
  delete BG_SRC_BY_BOSS['crowned-king-awoken']
  delete GHOST_LIGHT_BY_BOSS['crowned-king-awoken']
}
// 2026-11-02: 鐘楼の頂上の最初の絵 (立つ線のすぐ下が塔の外壁で、崖の縁に見えた・記録 docs/research/2026-11-02-rooster-next.md)。
export const ROOSTER_BELL_TOWER_BG_SRC = '/bg/rooster-bell-tower.png'
// 2026-11-03: 床を手前へ伸ばした版 = 配布版 (作者「ヘリで戦っているみたいに見えるから、手前にも足場があるような書き方をしてほしい」)。
//   v1 の立つ線より下の塔の外壁を、床の目地を遠近で繰り返して置き換えた (作り方 = scripts/rooster_floor_extend_1103.py)。
export const ROOSTER_BELL_TOWER_FLOOR_BG_SRC = '/bg/rooster-bell-tower-floor.png'
/** 鶏の部屋を前の版へ戻す (DEV の ?roosterRoom=castle＝城の既定 / v1＝床を伸ばす前の鐘楼 だけが呼ぶ)。 */
export function useRoosterOldRoom(version: 'castle' | 'v1'): void {
  if (version === 'castle') delete BG_SRC_BY_BOSS['inverted-jester']
  else BG_SRC_BY_BOSS['inverted-jester'] = ROOSTER_BELL_TOWER_BG_SRC
}
function drawAwokenWalls(ctx: CanvasRenderingContext2D, bossId: string): void {
  if (bossId !== 'crowned-king-awoken') return
  if (awokenOldRoom) { drawAwokenPlaceholderWalls(ctx, bossId); return }
  const wall = ensureBg(AWOKEN_WALL_SRC)
  if (!wall?.loaded) return
  const walls = arenaBoundsFor(bossId)
  const w = wall.img.width * AWOKEN_WALL_H / wall.img.height
  // 足元の影 (2026-10-27・作者「柱が浮いて見えるようになった」)。 広い舞台ではカメラが動き、 背景の床は 0.6 倍でしか流れないので、
  //   柱の台座が床の上を滑って見える。 台座の下に接地の影を敷いて、 床に立っているように見せる。
  for (const cx of [walls.leftWall - AWOKEN_WALL_INNER_PX + w / 2, walls.rightWall + AWOKEN_WALL_INNER_PX - w / 2]) {
    ctx.save()
    ctx.translate(cx, ARENA.floorY + 4)
    ctx.scale(1, AWOKEN_WALL_SHADOW_RY / (w * 0.62))
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, w * 0.62)
    g.addColorStop(0, 'rgba(4,3,8,0.78)')
    g.addColorStop(0.6, 'rgba(4,3,8,0.45)')
    g.addColorStop(1, 'rgba(4,3,8,0)')
    ctx.fillStyle = g
    ctx.beginPath()
    ctx.arc(0, 0, w * 0.62, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
  }
  ctx.drawImage(wall.img, walls.leftWall - AWOKEN_WALL_INNER_PX, 0, w, AWOKEN_WALL_H)
  ctx.save()
  ctx.translate(walls.rightWall + AWOKEN_WALL_INNER_PX, 0)
  ctx.scale(-1, 1)
  ctx.drawImage(wall.img, 0, 0, w, AWOKEN_WALL_H)
  ctx.restore()
}

// 旧の仮壁 (2026-09-12 ユーザー指示)。 2026-10-20 に絵の柱 (drawAwokenWalls) へ替えた。 DEV ?awokenRoom=old でだけ描く。
function drawAwokenPlaceholderWalls(ctx: CanvasRenderingContext2D, bossId: string): void {
  if (bossId !== 'crowned-king-awoken') return
  const walls = arenaBoundsFor(bossId)
  ctx.save()
  for (const [x, outward] of [[walls.leftWall, -1], [walls.rightWall, 1]] as const) {
    ctx.save()
    ctx.translate(x, 0)
    ctx.scale(outward, 1)
    const stone = ctx.createLinearGradient(0, 0, 64, 0)
    stone.addColorStop(0, '#48424e')
    stone.addColorStop(.12, '#292632')
    stone.addColorStop(1, '#111019')
    ctx.fillStyle = stone
    ctx.fillRect(0, 0, 80, ARENA.floorY)
    ctx.fillStyle = '#797080'
    ctx.fillRect(0, 0, 2, ARENA.floorY)
    ctx.fillStyle = '#17151e'
    for (let y = 24; y < ARENA.floorY; y += 48) {
      ctx.fillRect(3, y, 77, 2)
      ctx.fillRect(26 + (Math.floor(y / 48) % 2) * 24, y + 2, 2, 46)
    }
    ctx.fillStyle = '#37313e'
    ctx.fillRect(0, ARENA.floorY - 18, 80, 18)
    ctx.fillStyle = '#625969'
    ctx.fillRect(0, ARENA.floorY - 18, 80, 2)
    ctx.restore()
  }
  ctx.restore()
}

export function drawForegroundLayers(
  ctx: CanvasRenderingContext2D, bossId: string | undefined,
  shakeX: number, shakeY: number,
): void {
  if (getArenaWidthMul() <= 1 || !bossId) return
  const parts = BG_FRONT_BY_BOSS[bossId]
  const layers = BG_LAYERS_BY_BOSS[bossId]
  const fit = WIDE_ROOM_FIT_BY_BOSS[bossId]
  if (!parts || !layers || !fit) return

  const roomLayer = layers.find((layer): layer is Extract<BgLayer, { src: string }> =>
    'src' in layer && layer.parallax === 1)
  if (!roomLayer) return
  const roomBg = ensureBg(roomLayer.src)
  if (!roomBg?.loaded) return

  const worldW = cameraWorld.right - cameraWorld.left
  const rect = wideRoomRect(roomBg.img, fit, worldW)
  const density = rect.w / roomBg.img.width
  ctx.save()
  // draw() の世界座標にはシェイクが乗っているが、背景はシェイクの外側。
  // 同じ画素へ重ねる前景柱もシェイクを相殺し、部屋の層から剥がれないようにする。
  ctx.translate(-shakeX, -shakeY)
  for (const part of parts) {
    const partBg = ensureBg(part.src)
    // 片方のロード待ちで、ロード済みのもう片方まで止めない。
    if (!partBg?.loaded) continue
    const dx = cameraWorld.left + rect.x + part.u * rect.w
    ctx.drawImage(
      partBg.img,
      dx,
      rect.y,
      partBg.img.width * density,
      partBg.img.height * density,
    )
  }
  ctx.restore()
}

type GhostLightAnchor = { x: number; y: number; scale: number; alpha: number }
// 専用背景に描き込まれた常夜燈へ Canvas の青グローだけを重ねる。
// 🔴 **x, y = 絵に描かれた灯芯そのもの** (画面 960x540 座標)。 支柱基準ではない。
//   描画は必ず `drawGhostLightAtFlame` を通す = 支柱ぶんの読み替えはそこ1箇所だけ。
//
// 全5部屋を 2026-07-29 に測り直した。 計器 = `tmp/lantern_flame_centers.py`
//   ① 青さで**灯の在る場所**(塊)を絞る … 月や窓を除くための位置決めにだけ使う
//   ② その塊の中で **輝度が最大の点** を灯芯とする
//   ③ 印を描き戻して必ず目視確認する
//
// 🔴 **「青さの最大点」を灯芯にしてはいけない。**
//   灯の芯はほぼ**白** (R≈G≈B) なので、青さ (B-R) はそこで**低くなる**。
//   青さが最大になるのは芯を取り巻く**青いにじみ**で、それは上下左右で対称ではない
//   (吊り灯は上のにじみが強い)。 芯より上・右へ寄った点を拾ってしまう。
//   2026-07-29 に実際にこれで外し、ユーザー実機「なんかズレてるように見える」で発覚した。
//   拡大して見れば一目で分かるズレを、数値だけ見て「1px以内」と報告していた。
const GHOST_LIGHT_BY_BOSS: Record<string, GhostLightAnchor> = {
  'vigil-knight': { x: 64, y: 273, scale: 0.85, alpha: 0.75 },
  'bride': { x: 883, y: 269, scale: 0.85, alpha: 0.75 },
  // 稽古(廊下) = 右壁の腕木 / 王(謁見の間) = 右の台座
  'nameless-shade': { x: 852, y: 274, scale: 0.85, alpha: 0.75 },
  'dream-hound': { x: 775, y: 304, scale: 0.85, alpha: 0.75 },
  // (旧・砕き場の記録) 砕き場の右奥。 ⚠️ ここだけ灯体が**ガラス玉ではなく「炎の柱」**なので、他の部屋の測り方
  //   (塊の中の最も明るい1点) では決まらない。 1点は炎のゆらぎで上下に飛ぶ。
  //   → **明るい画素(上位2%)の重心**を芯とする。 実測: 炎の軸は x=853〜855 で一定、
  //     明るい帯は y=222〜247、その重心が (854.1, 235.9)。 計器 = tmp/measure_exec_flame.py
  // 2026-10-01: 施療院の右壁の吊りランタン。 灯芯 (1622, 289)/1672x941 = 青い塊の中の最大輝度点
  //   (計器と印 = そざい/_inbox/2026-10-01-executioner-hospice-bg/notes.md・lantern_mark.png)。
  //   旧・砕き場の炎の柱は (854, 236)。
  'the-executioner': { x: 931, y: 166, scale: 0.85, alpha: 0.75 },
  // 2026-10-20: 覚醒王の部屋の右の吊りランタン。 960x540 に縮めた絵の、青い塊の中の最大輝度点 (ぼかし 1.5px) = (774, 306)。印で目視確認済み。
  'crowned-king-awoken': { x: 774, y: 306, scale: 0.85, alpha: 0.75 },
}

// 蝋燭の灯火: 背景画の燭台位置に合わせた近似座標へ、 加算で暖色グローをゆらす。
// [x, y, 半径]
const CANDLES: [number, number, number][] = [
  [120, 300, 24], [150, 258, 17],
  [842, 300, 24], [808, 258, 17],
]
function drawCandleFlicker(ctx: CanvasRenderingContext2D, t: number): void {
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  for (let i = 0; i < CANDLES.length; i += 1) {
    const [x, y, r] = CANDLES[i]
    // ゆっくりした息づかい + 速い微震えの二重ゆらぎ
    const flick = 0.72 + Math.sin(t * (7 + i) + i * 1.7) * 0.13 + Math.sin(t * 23 + i) * 0.05
    const rr = r * (0.9 + flick * 0.15)
    const g = ctx.createRadialGradient(x, y, 0, x, y, rr)
    g.addColorStop(0, `rgba(244,216,120,${0.34 * flick})`)
    g.addColorStop(0.5, `rgba(230,160,80,${0.14 * flick})`)
    g.addColorStop(1, 'rgba(230,160,80,0)')
    ctx.fillStyle = g
    ctx.beginPath(); ctx.arc(x, y, rr, 0, Math.PI * 2); ctx.fill()
  }
  ctx.restore()
}

// 床の霧: 加算の淡紫ヘイズが横にゆっくりドリフト。 奥行きと「生きてる」感。
function drawFloorFog(ctx: CanvasRenderingContext2D, t: number): void {
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  // 背景の座標系で描かれる (drawBackground の中から呼ばれる)。 タイル枚数ぶんを流す。
  const fogWidth = bgSpanPx()
  for (let i = 0; i < 3; i += 1) {
    const speed = 6 + i * 4
    const offset = ((t * speed + i * 400) % (fogWidth + 400)) - 200
    const y = ARENA.floorY - 26 + i * 16
    const w = 440
    const g = ctx.createRadialGradient(offset, y, 0, offset, y, w * 0.5)
    g.addColorStop(0, `rgba(122,110,172,${0.10 - i * 0.02})`)
    g.addColorStop(1, 'rgba(122,110,172,0)')
    ctx.fillStyle = g
    ctx.beginPath(); ctx.ellipse(offset, y, w * 0.5, 44, 0, 0, Math.PI * 2); ctx.fill()
  }
  ctx.restore()
}

// 舞う塵: 旧 starfield を流用。 ゆっくり落ちる淡紫 (たまに金) の微粒子で空間に密度を出す。
function drawDust(ctx: CanvasRenderingContext2D, t: number): void {
  ctx.save()
  // 世界の層。 舞台を広げた時は広げた範囲へ均す (倍率1なら 0..ARENA.width = 従来と同一)。
  const span = worldSpan()
  const spanW = span.right - span.left
  const count = Math.round(44 * (spanW / ARENA.width))
  for (let i = 0; i < count; i += 1) {
    const seed = i * 73.13
    const baseX = (i * 137) % spanW
    const x = span.left + ((((baseX + Math.sin(t * 0.15 + seed) * 18) % spanW) + spanW) % spanW)
    const y = (i * 91 + t * (6 + (i % 3) * 3)) % (ARENA.floorY + 40)
    const a = 0.05 + 0.10 * Math.abs(Math.sin(t * 0.5 + i))
    ctx.globalAlpha = a
    ctx.fillStyle = i % 4 === 0 ? '#f4d878' : '#b9a8e0'
    ctx.fillRect(x, y, i % 5 === 0 ? 1.6 : 1, i % 5 === 0 ? 1.6 : 1)
  }
  ctx.restore()
}

function drawFloor(ctx: CanvasRenderingContext2D): void {
  // 灰の王城の石床に馴染ませるため、 旧ネオン紫ライン+グラデは廃止。
  // 接地面にごく淡い影バンドだけ敷いて、 キャラの「立ってる」感を補強する。
  ctx.save()
  const g = ctx.createLinearGradient(0, ARENA.floorY - 10, 0, ARENA.height)
  g.addColorStop(0, 'rgba(10,6,18,0)')
  g.addColorStop(1, 'rgba(8,5,16,0.45)')
  ctx.fillStyle = g
  const fs = worldSpan()
  ctx.fillRect(fs.left, ARENA.floorY - 10, fs.right - fs.left, ARENA.height - (ARENA.floorY - 10))
  ctx.restore()
}

// 亡霊の波 (shadeRipple) だけを他の shock (王/先代) から選り分ける純判定 (2026-07-05 チケットE)。
export function isShadeRippleHazard(hz: ActiveHit): boolean {
  return hz.kind === 'shock' && hz.attackId === 'shadeRipple'
}

// 覚醒王「大暴れ」だけを、同じ shock を使う亡霊・先代の姫から選り分ける。
export function isRampageHazard(hz: ActiveHit): boolean {
  return hz.kind === 'shock' && hz.attackId === 'rampage'
}

// 旧「儀式の境界線」(白青の細線+端の縦杭) へ戻す DEV ツマミ。 前後を並べて見る用。
//   `__rampageFx = 'off'` で旧表示。 既定 (本番も) は新しい床。
function rampageFxDisabled(): boolean {
  return import.meta.env.DEV && (window as any).__rampageFx === 'off'
}

// 描画寸法。 ✅2026-08-11 ユーザー確定 (「大きさ 中」を採用)。
//   🔴 下端は常に ARENA.floorY = 主人公・獣と同じ床の線。 ここを下げると足場が3本になる。
//   ⚠️ 見た目の横幅は判定幅そのまま (広げない = 安全な位置が危なく見えるのを防ぐ)。
const RAMPAGE_FX_HEIGHT = 135
const RAMPAGE_FX_GAIN = 1.15

// 素材を「判定枠と同じ比で中央切り出し」すると、 素材に焼いてある縁のフェードごと捨ててしまい、
//   加算合成の帯が四角い箱に見える (2026-08-11 実測)。 切り出した後にもう一度縁を溶かす必要があるので、
//   切り出し済みの1枚をオフスクリーンで作って左右と上を落とし、 それをキャッシュして貼る。
const rampageMaskCache = new Map<string, HTMLCanvasElement>()
function maskedRampageSprite(
  img: HTMLImageElement, key: string, srcX: number, srcW: number, srcH: number, w: number, h: number,
): HTMLCanvasElement | null {
  const id = `${key}:${Math.round(w)}x${Math.round(h)}`
  const hit = rampageMaskCache.get(id)
  if (hit) return hit
  if (typeof document === 'undefined') return null
  const cv = document.createElement('canvas')
  cv.width = Math.max(1, Math.round(w)); cv.height = Math.max(1, Math.round(h))
  const c = cv.getContext('2d')
  if (!c) return null
  c.drawImage(img, srcX, 0, srcW, srcH, 0, 0, cv.width, cv.height)
  c.globalCompositeOperation = 'destination-out'
  const side = c.createLinearGradient(0, 0, cv.width, 0)
  side.addColorStop(0, 'rgba(0,0,0,1)'); side.addColorStop(0.16, 'rgba(0,0,0,0)')
  side.addColorStop(0.84, 'rgba(0,0,0,0)'); side.addColorStop(1, 'rgba(0,0,0,1)')
  c.fillStyle = side; c.fillRect(0, 0, cv.width, cv.height)
  const top = c.createLinearGradient(0, 0, 0, cv.height)
  top.addColorStop(0, 'rgba(0,0,0,1)'); top.addColorStop(0.3, 'rgba(0,0,0,0)')
  c.fillStyle = top; c.fillRect(0, 0, cv.width, cv.height)
  // 素材に焼かれている「床の線」(横一直線の明るい帯) を落とす。 これを残すと、
  //   足跡の光と別に真っ直ぐな base line が出て「面の上の現象」ではなく「壁の裾」に見える。
  const foot = c.createLinearGradient(0, cv.height * 0.84, 0, cv.height)
  foot.addColorStop(0, 'rgba(0,0,0,0)'); foot.addColorStop(1, 'rgba(0,0,0,1)')
  c.fillStyle = foot; c.fillRect(0, 0, cv.width, cv.height)
  rampageMaskCache.set(id, cv)
  return cv
}

// この床の奥行き圧縮率。 出所 = ボスの影 ellipse(rx 70, ry 12)。
//   「床の上の円は、画面では縦がこの比率まで潰れて見える」= 遠近の唯一の定数。
//   新しい床の現象を作る時はここを使う (別の値を発明しない)。
const GROUND_FORESHORTEN = 12 / 70

// 床の足跡。 楕円の輪郭は描かない (完全な楕円は UI 図形読み = 禁止)。
//   楕円の内側に粒を撒き、 手前の縁ほど大きく明るく・奥の縁ほど小さく暗くする。
//   near=true では手前半分だけを描く (塊より後に呼ぶ = 手前の粒が塊に重なる = 遮蔽)。
function drawRampageFootprint(
  ctx: CanvasRenderingContext2D,
  cx: number, cy: number, rx: number, ry: number, alpha: number, near: boolean,
): void {
  const count = 260
  ctx.save()
  if (!near) {
    // 焦げ = 床が黒く灼けている。 加算光だけだと「宙に浮いた靄」に見えるので、
    //   先に面を暗く汚してから光を乗せる (光が"面に当たっている"と読ませるための下地)。
    ctx.globalCompositeOperation = 'source-over'
    for (let i = 0; i < 40; i += 1) {
      const u = hash01(i * 5.31 + 2.7) * 2 - 1
      const v = hash01(i * 9.17 + 4.1) * 2 - 1
      if (u * u + v * v > 1) continue
      const g = ctx.createRadialGradient(cx + u * rx, cy + v * ry, 0, cx + u * rx, cy + v * ry, 10 + 16 * hash01(i * 2.9))
      g.addColorStop(0, `rgba(14,4,8,${(0.5 * alpha * (1 - u * u)).toFixed(3)})`)
      g.addColorStop(1, 'rgba(14,4,8,0)')
      ctx.fillStyle = g
      ctx.fillRect(cx - rx, cy - ry * 2, rx * 2, ry * 4)
    }
  }
  ctx.globalCompositeOperation = 'lighter'
  for (let i = 0; i < count; i += 1) {
    const u = hash01(i * 3.71 + 1.3) * 2 - 1          // -1..1 (横)
    const v = hash01(i * 7.13 + 5.9) * 2 - 1          // -1..1 (奥行き。 +1 = 手前)
    if (u * u + v * v > 1) continue                    // 楕円の外は捨てる
    if (near !== (v > 0.1)) continue                   // 手前/奥 の描き分け
    // 手前ほど大きく明るい = 距離の手がかり。 端 (|u|→1) は薄れて輪郭を出さない。
    const depth = (v + 1) / 2                          // 0 = 奥, 1 = 手前
    const edgeFade = 1 - u * u * u * u
    // 大きさは強くばらす。 同じ大きさの粒を等間隔に置くと「丸が並んでいる」= UI 図形に読める。
    const r = (2.5 + 13 * depth) * (0.25 + 1.15 * hash01(i * 11.7) * hash01(i * 4.3 + 0.7))
    const a = alpha * (0.05 + 0.10 * depth) * edgeFade
    glowMote(ctx, cx + u * rx, cy + v * ry, r, depth > 0.55 ? '#ff5140' : '#a3202a', a)
  }
  ctx.restore()
}

// 立ち上がる塊を1枚。 奥の列と手前の列で別々に呼ぶ (大きさ・明るさ・接地の深さを変える)。
function drawRampageMass(
  ctx: CanvasRenderingContext2D,
  sprite: CanvasImageSource,
  cx: number, baseY: number, width: number, height: number, alpha: number, mirror: boolean,
): void {
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = Math.max(0, Math.min(1, alpha))
  if (mirror) {
    // 同じ絵を2枚重ねると双子に見える。 手前の列だけ左右を反転して別の塊として読ませる。
    ctx.translate(cx, 0)
    ctx.scale(-1, 1)
    ctx.translate(-cx, 0)
  }
  ctx.drawImage(sprite, cx - width / 2, baseY - height, width, height)
  ctx.restore()
}

function drawRampageGrudge(
  ctx: CanvasRenderingContext2D,
  hz: ActiveHit,
  reveal: number,
  alpha: number,
  /** 塊が噴き出している量 (0 = 床だけ・1 = 全開)。 予告中は 0 = 獣が空中にいる間は床しか出ない。 */
  erupt = 1,
): boolean {
  if (rampageFxDisabled()) return false
  const img = getRampageGrudge()
  if (!img || !img.complete || img.naturalWidth <= 0) return false

  const width = hz.xEnd - hz.xStart
  const xLeft = hz.xStart
  const bottomY = ARENA.floorY                    // 主人公・獣と同じ床の線。 ここは動かさない
  const height = RAMPAGE_FX_HEIGHT
  const revealedHeight = height * Math.max(0, Math.min(1, reveal))
  if (revealedHeight <= 0) return true

  // 🔴 素材を横へ潰さない。 判定幅190px に素材 (約2.9:1) をそのまま伸ばすと横8.8倍/縦4.4倍の
  //    異方スケールになり、 手も顔も塊も「縦に伸びた炎」に化けて3案の区別が消える (2026-08-11 実測)。
  //    → 描画枠と同じ比になるよう素材を中央で横に切り出して等方に貼る。
  const srcH = img.naturalHeight
  const srcW = Math.min(img.naturalWidth, srcH * (width / height))
  const srcX = (img.naturalWidth - srcW) / 2

  // ---- 遠近 (2026-08-11 ユーザー指摘「床から出ているように見えない」) ----
  // 床は水平な面で、 カメラは少し上から見ている。 だから床の上の「範囲」は画面上で線ではなく
  // 奥行きを持った楕円になる。 圧縮率はこの作品が既に使っている値を借りる:
  //   ボスの影 = ellipse(rx 70, ry 12) → 奥行きの圧縮 = 12/70。
  // 帯 (幅190) の足跡は rx 95 / ry 約16 = 画面上で上下 32px ぶんの床面を占める。
  //   奥の縁 = floorY - ry (キャラの立つ線より上)、 手前の縁 = floorY + ry (カメラ寄り=下)。
  //   ⚠️ これは「全体を下げる」のとは違う。 接地面は主人公・獣と同じ floorY のまま。
  //      下へ出るのは足跡の**手前の縁**だけ = 面に奥行きがあることの当然の帰結。
  const cx = xLeft + width / 2
  const rx = width / 2
  const ry = rx * GROUND_FORESHORTEN
  const top = bottomY - revealedHeight

  // 手前から奥へ、 遠い順に描く (画家の順番)。
  //   ①奥の床 →②奥の列の塊 →③手前の床 →④手前の列の塊。
  //   同じ絵を1枚貼るだけでは塊自体に奥行きが無く「平たい」と読まれる (2026-08-11 ユーザー指摘)。
  const a = alpha * RAMPAGE_FX_GAIN
  const sprite = maskedRampageSprite(img, 'grudge', srcX, srcW, srcH, width, height)
  const e = Math.max(0, Math.min(1, erupt))

  ctx.save()
  // clip = 立ち上がる矩形 ∪ 床の足跡楕円。 底が中央で手前へ膨らむ = 面から生えて見える。
  ctx.beginPath()
  ctx.rect(xLeft, top, width, Math.max(0, bottomY - top))
  ctx.ellipse(cx, bottomY, rx, ry, 0, 0, Math.PI * 2)
  ctx.clip()

  // ① 足跡 (奥) — 床そのものが灼けている。 粒で描く (楕円の輪郭は出さない)。
  drawRampageFootprint(ctx, cx, bottomY, rx, ry, a, false)

  if (sprite && e > 0.01) {
    // ② 奥の列 — 足跡の奥の縁から立つ。 遠いので小さく暗い。
    drawRampageMass(ctx, sprite, cx, bottomY - ry * 0.55, width * 0.84, height * 0.84 * e, a * 0.5, false)
  }

  // ③ 足跡 (手前)
  ctx.globalAlpha = 1
  drawRampageFootprint(ctx, cx, bottomY, rx, ry, a, true)

  if (sprite && e > 0.01) {
    // ④ 手前の列 — 足跡の手前の縁から立つ。 近いので大きく明るく、 奥の列に重なる。
    drawRampageMass(ctx, sprite, cx, bottomY + ry * 0.5, width, height * e, a, true)
  } else if (!sprite) {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = Math.max(0, Math.min(1, a))
    ctx.drawImage(img, srcX, 0, srcW, srcH, xLeft, bottomY - height * e, width, height * e)
  }
  ctx.restore()
  return true
}

// 亡霊の霊気の色 (亡霊の眼の色系・冷たい藤青。赤/金は使わない)
// 亡霊の霊気FXの色 (2026-07-06 ユーザー検収「床エフェクトが見えにくい」→視認性UP):
//   粒=青白 (双眸と同系=幽霊の記号) / 帯・床霧=藤紫 (体のヴェールと同系)。チュートリアルなので
//   可読性優先、ただし背景から浮きすぎない範囲 (色相は体に合わせ alpha/サイズで持ち上げ)。
const SHADE_MIST_RGB = '172,162,216'
const SHADE_SPIRIT_RGB = '186,224,242'

// shadeRipple telegraph: 儀式境界線 (破線+杭) の代わりに、 床霧の帯 + 立ち上る霊気の粒。
//   帯=判定幅 [xStart..xEnd] にぴったり一致 (両端 8px ソフトフェード)。 線・杭・輝線は描かない。
function drawShadeRippleTelegraph(ctx: CanvasRenderingContext2D, hz: ActiveHit, t: number): void {
  const w = hz.xEnd - hz.xStart
  const progress = hz.elapsedMs / hz.telegraphMs
  const lateCue = progress >= 0.7
  const pulse = lateCue ? 1 + 0.20 * Math.sin(t * 14) : 1
  const bandH = 14 + 18 * progress
  const floorY = ARENA.floorY

  // ① 冷光ウォッシュ (加算・青白) = 視認性の主役 (2026-07-06 ユーザー検収「見えにくい」→
  //    暗床に source-over の霧は沈む → 危険帯そのものは光で読ませる。可読性>世界観)。
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  //    強度は実測校正 (2026-07-06): x1=沈む/x3=白飛び → 終盤 ~0.45 で「はっきり読めるが場に馴染む」。
  const glowA = Math.min(1, (0.16 + 0.30 * progress) * pulse)
  const glow = ctx.createLinearGradient(0, floorY - bandH - 8, 0, floorY + 4)
  glow.addColorStop(0, `rgba(${SHADE_SPIRIT_RGB},0)`)
  glow.addColorStop(0.8, `rgba(${SHADE_SPIRIT_RGB},${glowA.toFixed(3)})`)
  glow.addColorStop(1, `rgba(${SHADE_SPIRIT_RGB},0)`)   // 下端も溶かす (床にパキッとした光の線=UI感を出さない)
  ctx.fillStyle = glow
  ctx.fillRect(hz.xStart, floorY - bandH - 8, w, bandH + 12)
  ctx.restore()

  ctx.save()
  // ② 床霧の帯 (藤紫・source-over) = 質感 (光の上に薄く重ねて「霊気の靄」に見せる)
  const fadeW = Math.min(8, w * 0.5)
  const bandA = (0.12 + 0.16 * progress) * pulse
  const vGrad = ctx.createLinearGradient(0, floorY - bandH, 0, floorY)
  vGrad.addColorStop(0, 'rgba(0,0,0,0)')
  vGrad.addColorStop(1, `rgba(${SHADE_MIST_RGB},${bandA.toFixed(3)})`)
  ctx.fillStyle = vGrad
  ctx.fillRect(hz.xStart, floorY - bandH, w, bandH)
  // 両端フェード (帯の上に重ねて overwrite=透明にする代わりに黒でマスクせず、 端だけ薄い alpha で再フェード)
  if (fadeW > 0.5) {
    const lGrad = ctx.createLinearGradient(hz.xStart, 0, hz.xStart + fadeW, 0)
    lGrad.addColorStop(0, 'rgba(6,4,10,1)')
    lGrad.addColorStop(1, 'rgba(6,4,10,0)')
    ctx.globalCompositeOperation = 'destination-out'
    ctx.fillStyle = lGrad
    ctx.fillRect(hz.xStart, floorY - bandH, fadeW, bandH)
    const rGrad = ctx.createLinearGradient(hz.xEnd - fadeW, 0, hz.xEnd, 0)
    rGrad.addColorStop(0, 'rgba(6,4,10,0)')
    rGrad.addColorStop(1, 'rgba(6,4,10,1)')
    ctx.fillStyle = rGrad
    ctx.fillRect(hz.xEnd - fadeW, floorY - bandH, fadeW, bandH)
    ctx.globalCompositeOperation = 'source-over'
  }
  ctx.restore()

  // ③ 立ち上る霊気の粒 (青白・glowMote+hash01・安定散布)
  const moteCount = Math.round(w / 16)
  const moteRgba = (a: number) => `rgba(${SHADE_SPIRIT_RGB},${a.toFixed(3)})`
  for (let k = 0; k < moteCount; k++) {
    const x = hz.xStart + hash01(k * 13.7) * w
    const cycleSpeed = 0.45 + 0.3 * hash01(k * 7.3)
    const p = (t * cycleSpeed + hash01(k * 3.1)) % 1
    const y = floorY - p * 40
    const a = Math.sin(Math.PI * p) * (0.5 + 0.4 * progress) * pulse
    const r = 2.4 + 2.4 * hash01(k * 5.9)
    glowMote(ctx, x, y, r, moteRgba(1), a)
  }
}

// shadeRipple active: 波 — 粒が高く濃く噴き上がる (~55px) + 床の冷光ウォッシュ。
//   rise/fade は drawHazards active 側の既存変数を流用。 走る輝線・端柱は描かない。
function drawShadeRippleActive(
  ctx: CanvasRenderingContext2D, hz: ActiveHit, t: number, rise: number, fade: number,
): void {
  const w = hz.xEnd - hz.xStart
  const floorY = ARENA.floorY
  const moteRgba = (a: number) => `rgba(${SHADE_SPIRIT_RGB},${a.toFixed(3)})`
  const moteCount = Math.round(w / 14)
  for (let k = 0; k < moteCount; k++) {
    const x = hz.xStart + hash01(k * 13.7) * w
    const cycleSpeed = (0.45 + 0.3 * hash01(k * 7.3)) * 2   // 噴き上がり=telegraphの2倍速
    const p = (t * cycleSpeed + hash01(k * 3.1)) % 1
    const y = floorY - p * 80
    const a = Math.sin(Math.PI * p) * 0.9 * rise * fade
    const r = 2.6 + 2.6 * hash01(k * 5.9)
    glowMote(ctx, x, y, r, moteRgba(1), a)
  }
  // 床の冷光ウォッシュ (加算・telegraph ①と同系で強く = 「いま危ない」の面)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = 0.42 * rise * fade
  const floorGlow = ctx.createLinearGradient(0, floorY - 30, 0, floorY + 4)
  floorGlow.addColorStop(0, `rgba(${SHADE_SPIRIT_RGB},0)`)
  floorGlow.addColorStop(0.7, `rgba(${SHADE_SPIRIT_RGB},0.7)`)
  floorGlow.addColorStop(1, `rgba(${SHADE_SPIRIT_RGB},0)`)
  ctx.fillStyle = floorGlow
  ctx.fillRect(hz.xStart, floorY - 30, w, 34)
  ctx.restore()
}

// ============== 花嫁「ヴェールの招待」(2026-07-10 procedural-only + clip reveal 再設計) ==============
// 「立ち上がる婚礼のヴェールの壁」。技=腕から翻ったヴェールが背後を囲って閉じる。
//   安全=花嫁の懐(前)。procedural-only (完成PNGの全面scaleは廃止・2026-07-10 Codex監査回答で確定)
//   = 白銀布の壁 (固定形状) + 縦の襞 + 根元の菫呪詛光 + 走る絹の光沢 + 立ち昇る粒子。
//   完成形の高さ fullH=246 は常に固定 (reveal で形自体を縮めない)。
//   reveal: 床から上へどこまで見せるか (0=まだ見えない、1=完成高全部)。telegraph=0→1、active=常に1。
//   alpha: 全体不透明度。 t: 秒。
//   audit-answer.md「drawVeilWall() の変更方針」に従う: shimmer/粒子/布本体は reveal でclipし、
//   床境界線 (5) と根元の菫呪詛光 (3) は clip 外・常時全幅で描く (telegraph 0% から読める)。
function drawVeilWall(
  ctx: CanvasRenderingContext2D, xStart: number, w: number, floorY: number,
  reveal: number, alpha: number, t: number, menace = 0,
  curtain: HTMLImageElement | null = null,   // 10-23 DEV ?brideVeilFx=wall-cloth: ①の塗りだけヴェールの絵に替える (動きの式は同じ)
): void {
  const rv = Math.max(0, Math.min(1, reveal))
  const a = Math.max(0, Math.min(1, alpha))
  const men = Math.max(0, Math.min(1, menace))   // 危険度 (0=ただ綺麗な布 / 1=呪われた立入禁止)
  const fullH = 246   // 完成高 (固定・reveal で縮めない)
  if (a <= 0.01 || w <= 2) return
  const cols = Math.max(8, Math.round(w / 22))
  const cw = w / cols
  // 各コマの上端 (翻る/裂けた縁): fullH 基準で常に同じ形 (reveal によって再計算しない)。
  //   低周波の billow + 高周波の不揃いで「裂けたヴェールの縁」を作る。
  const colTop = (i: number, phase: number): number => {
    const billow = 0.15 * (0.5 + 0.5 * Math.sin(t * 0.9 + phase + i * 0.7))
    const tear = 0.09 * (0.5 + 0.5 * Math.sin(i * 2.3 + phase * 1.7))
    return fullH * (1 - billow - tear)
  }
  ctx.save()
  // 3) 根元の呪詛 (danger read・menace で毒々しく・呼吸で脈動・加算)。
  //    clip 外・常時全幅 = telegraph 0〜15% (reveal=0) でも「呪われた地面」だけは見える。
  ctx.globalCompositeOperation = 'lighter'
  const throb = 0.7 + 0.3 * Math.sin(t * 3.4)
  // 3a) 菫の発光の下地 (menace で高く・濃く脈打つ)
  const glowH = 60 + 40 * men
  const baseG = ctx.createLinearGradient(0, floorY - glowH, 0, floorY)
  baseG.addColorStop(0, `rgba(${swc('unparry', '150,110,204')},0)`)
  baseG.addColorStop(1, `rgba(${swc('unparry', '158,116,214')},${((0.4 + 0.3 * men) * a * throb).toFixed(3)})`)
  ctx.fillStyle = baseG
  ctx.fillRect(xStart, floorY - glowH, w, glowH)
  // 3b) 呪いの澱み = 濃い菫が床に roiling して溜まる (menace で濃く・不均一に脈打つ = 「立つな」)
  if (men > 0.03) {
    const lumps = Math.max(3, Math.round(w / 64))
    for (let i = 0; i < lumps; i++) {
      const seed = i * 53.7
      const lx = xStart + ((i + 0.5) / lumps) * w + Math.sin(t * 1.4 + seed) * 7
      const lh = (26 + 24 * men) * (0.6 + 0.5 * Math.abs(Math.sin(t * 1.9 + seed * 1.3)))
      const pg = ctx.createRadialGradient(lx, floorY, 2, lx, floorY, lh)
      pg.addColorStop(0, `rgba(${swc('unparry', '150,70,214')},${(0.5 * men * a * throb).toFixed(3)})`)
      pg.addColorStop(1, `rgba(${swc('unparry', '80,30,130')},0)`)
      ctx.fillStyle = pg
      ctx.fillRect(lx - lh, floorY - lh, lh * 2, lh)
    }
  }

  // 1)(2)(4) 布本体・走る絹の光沢・立ち昇る粒子: 床から上へ reveal ぶんだけ clip して描く。
  //   clip の内側では常に fullH 基準の完成形を描く = drawImage の destination height を縮めない
  //   (audit-answer.md 禁止事項: 「growth でHbase自体を縮める」旧実装の再発防止)。
  const revealH = fullH * rv
  if (revealH > 1) {
    ctx.save()
    ctx.beginPath()
    ctx.rect(xStart, floorY - revealH, w, revealH)
    ctx.clip()

    // 1) 布本体: procedural 3層 = 紫基調の呪われたカーテン (2026-07-10 ユーザー案「紫基調のカーテン」)。
    //    白い薄布=「光ってるだけ」→ 濃い菫の厚みあるカーテン=「触れたら呪われる壁」。上端は裂けて薄れ
    //    (topA 低)、 根元は不透明なカーテン (botA 高) = 実体として読ませる。
    ctx.globalCompositeOperation = 'source-over'
    const layers = [
      { hue: swc('unparry', '96,60,156'), phase: 0.0, sway: 11, topA: 0.14, botA: 0.52 },    // 深い菫 (下地・不透明寄り)
      { hue: swc('unparry', '68,42,116'), phase: 1.4, sway: 8, topA: 0.14, botA: 0.58 },     // より暗い菫 (襞の陰)
      { hue: swc('unparry', '176,138,230'), phase: 2.7, sway: 5, topA: 0.16, botA: 0.40 },   // 明るいラベンダー (襞のハイライト)
    ]
    if (curtain) {
      // 絵の帯を柱ごとに同じ高さ (colTop)・同じ揺れ (sway) で置く。3層は絵の取り出し位置をずらして重ねる。
      const imgA = [0.4, 0.3, 0.45]
      layers.forEach((L, li) => paintVeilCurtainLayer(ctx, curtain, xStart, w, floorY, fullH, cols,
        (i) => colTop(i, L.phase), (i) => Math.sin(t * 1.05 + L.phase + i * 0.5) * L.sway, imgA[li]! * a, li * 0.37))
    } else for (const L of layers) {
      for (let i = 0; i < cols; i++) {
        const cx = xStart + (i + 0.5) * cw
        const sway = Math.sin(t * 1.05 + L.phase + i * 0.5) * L.sway
        const colH = colTop(i, L.phase)
        const topY = floorY - colH
        const foldA = 0.68 + 0.32 * Math.sin(i * 1.3 + L.phase)   // 襞の明暗
        const g = ctx.createLinearGradient(0, topY, 0, floorY)
        g.addColorStop(0, `rgba(${L.hue},0)`)
        g.addColorStop(0.22, `rgba(${L.hue},${(L.topA * a * foldA).toFixed(3)})`)
        g.addColorStop(1, `rgba(${L.hue},${(L.botA * a * foldA).toFixed(3)})`)
        ctx.fillStyle = g
        ctx.fillRect(cx - cw / 2 + sway, topY, cw + 1, colH)
      }
    }

    // 2) 走る絹の光沢 (shimmer・加算・reveal 範囲内に限定)
    ctx.globalCompositeOperation = 'lighter'
    const sh = (t * 0.3) % 1
    const shX = xStart - w * 0.2 + w * 1.4 * sh
    const shW = w * 0.13
    const shG = ctx.createLinearGradient(shX - shW, 0, shX + shW, 0)
    shG.addColorStop(0, `rgba(${swc('unparry', '226,204,255')},0)`)
    shG.addColorStop(0.5, `rgba(${swc('unparry', '226,204,255')},${(0.18 * a).toFixed(3)})`)
    shG.addColorStop(1, `rgba(${swc('unparry', '226,204,255')},0)`)
    ctx.fillStyle = shG
    ctx.fillRect(Math.max(xStart, shX - shW), floorY - fullH, Math.min(w, shW * 2), fullH)

    // 4) 立ち昇る菫の粒子 (ENDER LILIES の儚さ・加算・reveal 範囲内に限定)
    const motes = Math.max(3, Math.round(w / 55))
    for (let i = 0; i < motes; i++) {
      const seed = i * 97.13
      const mx = xStart + (Math.sin(seed) * 0.5 + 0.5) * w
      const cycle = (t * 0.24 + (Math.sin(seed * 2.1) * 0.5 + 0.5)) % 1
      const my = floorY - cycle * fullH * 0.92
      const mA = (1 - cycle) * 0.5 * a
      const r = Math.abs(1.5 + 1.3 * Math.sin(seed * 3.3))
      ctx.globalAlpha = Math.max(0, mA)
      ctx.fillStyle = `rgba(${swc('unparry', '208,182,248')},1)`
      ctx.beginPath()
      ctx.arc(mx, my, r, 0, Math.PI * 2)
      ctx.fill()
    }
    ctx.globalAlpha = 1
    ctx.restore()   // clip 解除
  }

  // 5) 床の境界線 (安全/危険の境目は絶対ぼかさない・menace で脈打って主張・clip 外・全幅)
  ctx.globalCompositeOperation = 'source-over'
  const edgePulse = 0.7 + 0.3 * Math.sin(t * 4)
  const edgeH = 3 + 3 * men
  ctx.globalAlpha = Math.min(1, (0.5 + 0.35 * men * edgePulse) * a)
  ctx.fillStyle = men > 0.5 ? `rgba(${swc('unparry', '216,150,248')},0.95)` : `rgba(${swc('unparry', '200,170,240')},0.9)`
  ctx.fillRect(xStart, floorY - edgeH, w, edgeH)
  ctx.globalAlpha = 1
  ctx.restore()
}

// ============== 凍結ゾーンヒット (hit-timeline 2026-06-11) ==============
// 予告と判定を同一データ (ActiveHit) から描く: 「どこが危ないか」が花嫁戦の教材。
//   telegraph 中 = 床の予兆ライン (紫→終盤は赤・点滅)
//   active 中    = kind 別の実体 (茨のせり上がり / ヴェールの帯 / 抱擁の腕影)。 全部手続き=仮ビジュアル。
export function executionerCannonMuzzle(boss: Boss): { x: number; y: number } {
  const dir = boss.facing === 'right' ? 1 : -1
  const motion = resolveBossTimelinePose(boss.id, boss)?.motion
  // 砲口は体と同じ timeline offset だけを受ける。足元ピボット由来の scale / rot 二次項は扱わない。
  // telegraph 中 = 構え (aim_hold) の砲口 (高い)。それ以外 = 発射 (fire_recoil) の砲口 (低い)。
  //   溜めの岩は構えの砲口で組み上がり、弾は振り下ろした砲身の先から出る (2026-08-27 実測どおり)。
  const anchor = boss.state === 'telegraph' ? EXECUTIONER_CANNON_MUZZLE_AIM : EXECUTIONER_CANNON_MUZZLE
  return {
    x: boss.x + dir * (anchor.spawnForwardPx + (motion?.offsetX ?? 0)),
    y: boss.y - anchor.spawnOffsetY + (motion?.offsetY ?? 0),
  }
}

const CANNON_CHARGE_BACKLIGHT_MAX_ALPHA = 0.24

// 請われぬ介錯の変形逆光。座標・濃度・軌跡の見た目を Claude が実機で詰めるための唯一の調整点。
export const EXECUTIONER_MORPH_GLOW = {
  // 🎚 光の総量のつまみ。1.0 = 砲口の逆光と同じ量 (背後の淡い光で黒い武器を読ませる既存の作法)。
  //   🔵 2026-08-25 ユーザー選定 = 1.8 (候補 1.0 / 1.8 / 2.6 を並べた `_確認用/153_変形の光_強さ3段くらべ.png`)。
  //     1.0 = 振り上げの光が見えず3コマに分けた意味が光へ出ない / 2.6 = 武器の輪郭が紫に食われ「黒鉄」でなくなる。
  //   ⚠️ **この値の是非はラボでは出せない**（ユーザー明言 2026-08-25「この確認方法だと是非を出せない」）。
  //     技を1つ切り出したスローGIFでは「他の演出と並んで馴染むか」が判らない。**実プレイで見て決め直す**。
  //   🔴 ここを上げても各 alpha の比率は変わらない (全体に掛かるだけ)。実プレイ後の調整はこの1行で足りる。
  intensityMul: 1.8,
  personDrawHeightPx: 236,
  weaponPath: [
    { progress: 1 / 6, forwardRatio: 0.12, upRatio: 1.03 },
    { progress: 1 / 2, forwardRatio: 0.21, upRatio: 0.66 },
    { progress: 5 / 6, forwardRatio: 0.21, upRatio: 0.45 },
  ],
  waveOriginUpRatio: 0.62,
  frameEndProgress: { raise: 1 / 3, swing: 2 / 3 },
  frameWeight: { raise: 0.35, swing: 1, settle: 0.3 },
  backlightRadiusPx: 58,
  backlightInnerScale: 0.58,
  backlightWideAlpha: 0.16,
  backlightNarrowAlpha: CANNON_CHARGE_BACKLIGHT_MAX_ALPHA,
  waveMoteCount: 3,
  waveMoteSpread: 0.11,
  waveRadiusPx: 24,
  waveInnerScale: 0.58,
  waveWideAlpha: 0.11,
  waveNarrowAlpha: 0.17,
  trailProgressLag: 0.12,
  trailSegments: 8,
  trailWidthPx: 2.5,
  trailMaxAlpha: 0.20,
  deepColor: '#5f2091',
  brightColor: '#a05ad7',
} as const

export type ExecutionerMorphGlowLayout = {
  progress: number
  strength: number
  waveProgress: number
  waveOrigin: { x: number; y: number }
  weapon: { x: number; y: number }
  waveMotes: { x: number; y: number }[]
  trail: { start: { x: number; y: number }; end: { x: number; y: number }; alpha: number }[]
}

function executionerMorphWeaponPosition(
  boss: Boss,
  progress: number,
): { x: number; y: number } {
  const points = EXECUTIONER_MORPH_GLOW.weaponPath
  const clampedProgress = Math.max(points[0].progress, Math.min(points[2].progress, progress))
  const from = clampedProgress <= points[1].progress ? points[0] : points[1]
  const to = clampedProgress <= points[1].progress ? points[1] : points[2]
  const localProgress = (clampedProgress - from.progress) / (to.progress - from.progress)
  const lerp = (start: number, end: number): number => start + (end - start) * localProgress
  const dir = boss.facing === 'right' ? 1 : -1
  const height = EXECUTIONER_MORPH_GLOW.personDrawHeightPx
  return {
    x: boss.x + lerp(from.forwardRatio, to.forwardRatio) * height * dir,
    y: boss.y - lerp(from.upRatio, to.upRatio) * height,
  }
}

/** 変形FXのゲートと配置だけを解く純粋関数。Canvas描画や戦闘状態は変更しない。 */
export function executionerMorphGlowLayout(state: GameState): ExecutionerMorphGlowLayout | null {
  const boss = state.boss
  const exec = boss.exec
  if (
    state.phase !== 'playing'
    || boss.id !== 'the-executioner'
    || boss.hp <= 0
    || !exec
    || exec.morph !== 'morphing'
  ) return null

  const timing = executionerMorphTiming(exec)
  const elapsedMs = exec.morphElapsedMs
  if (elapsedMs < timing.shoveEndMs || elapsedMs >= timing.durationMs) return null

  const clamp01 = (value: number): number => Math.max(0, Math.min(1, value))
  const lerp = (from: number, to: number, progress: number): number => from + (to - from) * progress
  const progress = clamp01((elapsedMs - timing.shoveEndMs) / Math.max(1, timing.durationMs - timing.shoveEndMs))
  const raiseEnd = EXECUTIONER_MORPH_GLOW.frameEndProgress.raise
  const swingEnd = EXECUTIONER_MORPH_GLOW.frameEndProgress.swing
  let strength: number
  if (progress < raiseEnd) {
    strength = EXECUTIONER_MORPH_GLOW.frameWeight.raise * (progress / raiseEnd)
  } else if (progress < swingEnd) {
    const local = (progress - raiseEnd) / (swingEnd - raiseEnd)
    strength = local < 0.5
      ? lerp(EXECUTIONER_MORPH_GLOW.frameWeight.raise, EXECUTIONER_MORPH_GLOW.frameWeight.swing, local * 2)
      : lerp(EXECUTIONER_MORPH_GLOW.frameWeight.swing, EXECUTIONER_MORPH_GLOW.frameWeight.settle, (local - 0.5) * 2)
  } else {
    strength = EXECUTIONER_MORPH_GLOW.frameWeight.settle * (1 - (progress - swingEnd) / (1 - swingEnd))
  }
  strength *= EXECUTIONER_MORPH_GLOW.intensityMul

  const weapon = executionerMorphWeaponPosition(boss, progress)
  const waveOrigin = {
    x: boss.x,
    y: boss.y - EXECUTIONER_MORPH_GLOW.waveOriginUpRatio * EXECUTIONER_MORPH_GLOW.personDrawHeightPx,
  }

  // held は変形前の形態。blade→cannon は根元から先、cannon→blade は先から根元へ走る。
  const waveProgress = exec.held === 'blade' ? progress : 1 - progress
  const waveMotes = Array.from({ length: EXECUTIONER_MORPH_GLOW.waveMoteCount }, (_, index) => {
    const centeredIndex = index - (EXECUTIONER_MORPH_GLOW.waveMoteCount - 1) / 2
    const along = clamp01(waveProgress + centeredIndex * EXECUTIONER_MORPH_GLOW.waveMoteSpread)
    return {
      x: lerp(waveOrigin.x, weapon.x, along),
      y: lerp(waveOrigin.y, weapon.y, along),
    }
  })

  const trail: ExecutionerMorphGlowLayout['trail'] = []
  if (progress >= raiseEnd && progress < swingEnd) {
    const previousWeapon = executionerMorphWeaponPosition(
      boss,
      Math.max(0, progress - EXECUTIONER_MORPH_GLOW.trailProgressLag),
    )
    for (let index = 0; index < EXECUTIONER_MORPH_GLOW.trailSegments; index += 1) {
      const from = index / EXECUTIONER_MORPH_GLOW.trailSegments
      const to = (index + 1) / EXECUTIONER_MORPH_GLOW.trailSegments
      trail.push({
        start: {
          x: lerp(previousWeapon.x, weapon.x, from),
          y: lerp(previousWeapon.y, weapon.y, from),
        },
        end: {
          x: lerp(previousWeapon.x, weapon.x, to),
          y: lerp(previousWeapon.y, weapon.y, to),
        },
        alpha: EXECUTIONER_MORPH_GLOW.trailMaxAlpha * strength * to,
      })
    }
  }

  return { progress, strength, waveProgress, waveOrigin, weapon, waveMotes, trail }
}

function drawExecutionerMorphGlow(ctx: CanvasRenderingContext2D, state: GameState): void {
  const layout = executionerMorphGlowLayout(state)
  if (!layout || layout.strength <= 0) return

  glowMote(
    ctx, layout.weapon.x, layout.weapon.y,
    EXECUTIONER_MORPH_GLOW.backlightRadiusPx,
    et('parry', EXECUTIONER_MORPH_GLOW.deepColor),
    layout.strength * EXECUTIONER_MORPH_GLOW.backlightWideAlpha,
  )
  glowMote(
    ctx, layout.weapon.x, layout.weapon.y,
    EXECUTIONER_MORPH_GLOW.backlightRadiusPx * EXECUTIONER_MORPH_GLOW.backlightInnerScale,
    et('parry', EXECUTIONER_MORPH_GLOW.brightColor),
    layout.strength * EXECUTIONER_MORPH_GLOW.backlightNarrowAlpha,
  )
  for (const mote of layout.waveMotes) {
    glowMote(
      ctx, mote.x, mote.y,
      EXECUTIONER_MORPH_GLOW.waveRadiusPx,
      et('parry', EXECUTIONER_MORPH_GLOW.deepColor),
      layout.strength * EXECUTIONER_MORPH_GLOW.waveWideAlpha,
    )
    glowMote(
      ctx, mote.x, mote.y,
      EXECUTIONER_MORPH_GLOW.waveRadiusPx * EXECUTIONER_MORPH_GLOW.waveInnerScale,
      et('parry', EXECUTIONER_MORPH_GLOW.brightColor),
      layout.strength * EXECUTIONER_MORPH_GLOW.waveNarrowAlpha,
    )
  }

  if (layout.trail.length > 0) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.strokeStyle = et('parry', EXECUTIONER_MORPH_GLOW.brightColor)
    ctx.lineWidth = EXECUTIONER_MORPH_GLOW.trailWidthPx
    ctx.lineCap = 'round'
    for (const segment of layout.trail) {
      ctx.globalAlpha = segment.alpha
      ctx.beginPath()
      ctx.moveTo(segment.start.x, segment.start.y)
      ctx.lineTo(segment.end.x, segment.end.y)
      ctx.stroke()
    }
    ctx.restore()
  }
}

function drawCannonChargeBacklight(
  ctx: CanvasRenderingContext2D,
  muzzle: { x: number; y: number },
  progress: number,
  radius: number,
): void {
  const p = Math.max(0, Math.min(1, progress))
  glowMote(ctx, muzzle.x, muzzle.y, radius, et('parry', '#5f2091'), p * 0.16)
  glowMote(ctx, muzzle.x, muzzle.y, radius * 0.58, et('parry', '#a05ad7'), p * CANNON_CHARGE_BACKLIGHT_MAX_ALPHA)
}

// 腕砲の弾の見た目切替: 'orb' = 紫の光の玉 (既定・2026-09-03 第4便 ユーザー裁定)。
// 'rock' = 旧・黒鉄の岩塊 (?shot=rock で検収用に残す)。
let cannonShotLook: 'orb' | 'rock' = 'orb'

export function setCannonShotLook(look: 'orb' | 'rock'): void {
  if (look !== 'orb' && look !== 'rock') return
  cannonShotLook = look
}

export function getCannonShotLook(): 'orb' | 'rock' {
  return cannonShotLook
}

// 🔴 2026-09-03 第4便 ユーザー裁定で光の収束へ置換。岩の溜めは ?shot=rock の時だけ使う。
// 直射弾(旧): 黒鉄の破片が砲口へ集まり、紫の亀裂を持つ一個の岩塊へ組み上がる。
export function drawCannonShotChargeRock(
  ctx: CanvasRenderingContext2D,
  muzzle: { x: number; y: number },
  progress: number,
  widthPx = 42,
): void {
// 🎨 腕砲の色 = この作品の既存の語彙をそのまま使う (2026-08-13 ユーザー裁定「案1」)。
//   弾ける2本 (直射弾/3連速射) = CHARGE_* の深紫 #a05ad7。
//     根拠 = 深紫チャージオーラは既に「弾ける溜め大技」の色で、**同じボスの刃「据えの一打」が使っている**。
//   弾けない1本 (山なり榴弾) = CURSE_* の赤黒 #e13a3a / #b01822 / #7a0b14 (全ボス共通の「弾けない」色)。
//   🔴 旧 = 水色 #a9d9ff / #91d2ff / 橙 #e86a45。**どちらもこの世界の色語彙に無く**、
//      実プレイ D-3 で「記号っぽい」と出た一因。色は発明せず必ず上の定数系から採る。
//   出所 = docs/playtest/packs/2026-08-12-three-boss-judgment-pack.md D-3 / FX世界観ルール(色語彙)。
  const p = Math.max(0, Math.min(1, progress))
  // 岩自体は暗いまま、砲口の深紫を背にした逆光シルエットとして読ませる。
  drawCannonChargeBacklight(ctx, muzzle, p, widthPx * 0.95)
  const gather = 1 - p * p * (3 - 2 * p)
  const fragmentCount = Math.min(10, 6 + Math.floor(p * 5))
  for (let i = 0; i < fragmentCount; i += 1) {
    const seed = 710 + i * 9.17
    const angle = hash01(seed) * Math.PI * 2
    const spread = widthPx * (0.58 + hash01(seed + 1.7) * 0.62) * gather
    const clusterRadius = widthPx * p * (0.12 + hash01(seed + 2.1) * 0.20)
    const x = muzzle.x + Math.cos(angle) * (spread + clusterRadius)
    const y = muzzle.y + Math.sin(angle) * (spread * 0.72 + clusterRadius)
    const radius = widthPx * (0.055 + hash01(seed + 3.1) * 0.035) * (0.45 + p * 0.55)
    drawIronRockFacet(ctx, x, y, radius, seed, 0.70 + p * 0.25, 0.22 + p * 0.33)
  }

  // 終盤は破片の隙間を暗い芯で埋め、発射時の widthPx と同じ直径へ育てる。
  if (p > 0.42) {
    const coreP = (p - 0.42) / 0.58
    drawIronRockCore(ctx, muzzle.x, muzzle.y, widthPx * 0.5 * coreP, 970, 0.88, 0.50)
  }
}

// 直射弾: 紫の粒が砲口へ収束し、撃つ瞬間に閃光と尾を残す (2026-09-03 第4便 ユーザー裁定「収束」)。
//   色は既存語彙 CHARGE_* (#5f2091 / #a05ad7) と CANNON_BRIDGE_CORE (#c8b0ec) だけを使う。
export function drawCannonShotCharge(
  ctx: CanvasRenderingContext2D,
  muzzle: { x: number; y: number },
  progress: number,
  widthPx = 42,
): void {
  const p = Math.max(0, Math.min(1, progress))
  drawCannonChargeBacklight(ctx, muzzle, p, widthPx * 0.95)

  for (let i = 0; i < 12; i += 1) {
    const seed = 810 + i * 7.31
    const r0 = widthPx * 2.2 * (0.7 + hash01(seed) * 0.6)
    const angle = hash01(seed + 1.1) * Math.PI * 2
    // y成分を0.6倍 = 横長の楕円から集める (砲口の高さへ寄せる)。
    const departure = {
      x: muzzle.x + Math.cos(angle) * r0,
      y: muzzle.y + Math.sin(angle) * r0 * 0.6,
    }
    const ph = hash01(seed + 2.3)
    const u = Math.max(0, Math.min(1, (p - ph * 0.35) / 0.65))
    const easeIn = u * u
    const x = departure.x + (muzzle.x - departure.x) * easeIn
    const y = departure.y + (muzzle.y - departure.y) * easeIn
    // 🔵 2026-09-03 実画面で「砲口の小さな点」にしか見えなかったので、モック (266 A) の印象へ寄せて粒を太く・明るく。
    const moteRadius = 5.0 + hash01(seed + 3.7) * 3.5
    const alpha = (0.45 + 0.50 * u) * (u < 1 ? 1 : 0)
    glowMote(ctx, x, y, moteRadius * 1.8, et('parry', '#5f2091'), alpha * 0.5)
    glowMote(ctx, x, y, moteRadius, et('parry', '#a05ad7'), alpha)
    glowMote(ctx, x, y, moteRadius * 0.45, et('parry', '#c8b0ec'), alpha * 0.7)

    const dx = departure.x - x
    const dy = departure.y - y
    const dist = Math.hypot(dx, dy)
    if (dist > 0.5) {
      const tailLen = 10 + 14 * u
      const tailWidth = Math.max(2, moteRadius * 1.4)
      taperStreak(ctx, x, y, dx / dist, dy / dist, tailLen, tailWidth, et('parry', '#a05ad7'), 0.45 * u)
    }
  }

  // 砲口の芯: 溜めが進むほど太く、終盤は白っぽい紫で飽和させる (撃つ直前の合図)。
  // 大きさの物差し = 撃つ瞬間の閃光 (drawExecutionerCannonMuzzleFlash: 背光 46 / 芯 24)。溜め切りで背光がそこへ届く。
  const rc = widthPx * (0.25 + 0.9 * p * p)
  glowMote(ctx, muzzle.x, muzzle.y, rc * 2.2, et('parry', '#3a0a5a'), 0.25 + 0.35 * p)
  glowMote(ctx, muzzle.x, muzzle.y, rc * 1.4, et('parry', '#5f2091'), 0.35 + 0.40 * p)
  glowMote(ctx, muzzle.x, muzzle.y, rc, et('parry', '#a05ad7'), 0.55 + 0.45 * p)
  if (p > 0.55) {
    glowMote(ctx, muzzle.x, muzzle.y, rc * 0.5, et('parry', '#c8b0ec'), (p - 0.55) / 0.45 * 0.95)
  }
}

// 3連速射の脈は発射時刻から逆算する。chargeMs が周期の倍数でなくても、
// 最後の脈が必ず発射へ重なり、暗部でも粒群そのものは消えない。
export function cannonVolleyPulseStrength(
  elapsedMs: number,
  chargeMs: number,
  periodMs: number,
): number {
  if (periodMs <= 0) return 0
  const progress = chargeMs > 0 ? Math.max(0, Math.min(1, elapsedMs / chargeMs)) : 1
  const remainingMs = Math.max(0, chargeMs - elapsedMs)
  const reversePhase = (remainingMs % periodMs) / periodMs
  const wave = 0.5 + 0.5 * Math.cos(reversePhase * Math.PI * 2)
  const pulse = 0.34 + 0.66 * Math.pow(wave, 2.2)
  return pulse * (0.82 + 0.18 * progress)
}

// 🔴 2026-09-03 第4便 ユーザー裁定で光の収束へ置換。岩の溜めは ?shot=rock の時だけ使う。
// 3連速射(旧): 小さい石片三個を砲口の周りに浮かべ、亀裂だけを発射周期で脈打たせる。
export function drawCannonVolleyChargeRock(
  ctx: CanvasRenderingContext2D,
  muzzle: { x: number; y: number },
  elapsedMs: number,
  chargeMs: number,
  periodMs: number,
): void {
  const p = chargeMs > 0 ? Math.max(0, Math.min(1, elapsedMs / chargeMs)) : 1
  const pulse = cannonVolleyPulseStrength(elapsedMs, chargeMs, periodMs)
  drawCannonChargeBacklight(ctx, muzzle, p, 36)
  const gatherT = Math.max(0, Math.min(1, (p - 0.45) / 0.55))
  const gatherProgress = gatherT * gatherT * (3 - 2 * gatherT)
  // 前半は三塊の離れた予告を保ち、後半だけ30%の楕円へ収束する。一点には融合させない。
  const orbitScale = 1 - gatherProgress * 0.70
  const orbit = elapsedMs * 0.0018 * (1 + gatherProgress * 1.6)
  for (let i = 0; i < 3; i += 1) {
    const seed = 1400 + i * 17.13
    const angle = orbit + i * Math.PI * 2 / 3
    const x = muzzle.x + Math.cos(angle) * 22 * orbitScale
    const y = muzzle.y + Math.sin(angle) * 13 * orbitScale
    const radius = 6.5 + hash01(seed) * 2.5

    ctx.save()
    ctx.translate(x, y)
    ctx.rotate(angle * 0.35 + seed)
    ctx.beginPath()
    for (let point = 0; point < 6; point += 1) {
      const a = point * Math.PI * 2 / 6
      const r = radius * (0.78 + hash01(seed + point * 2.7) * 0.24)
      const px = Math.cos(a) * r
      const py = Math.sin(a) * r
      if (point === 0) ctx.moveTo(px, py)
      else ctx.lineTo(px, py)
    }
    ctx.closePath()
    ctx.fillStyle = `rgb(${CANNON_IRON})`
    ctx.fill()
    ctx.strokeStyle = 'rgba(8,6,10,0.95)'
    ctx.lineWidth = 1.4
    ctx.stroke()

    // 暗い岩の輪郭だけを深紫で切り、背後の光から三塊それぞれを分離する。
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = 0.18 + p * 0.28
    ctx.strokeStyle = '#5f2091'
    ctx.lineWidth = 0.8
    ctx.stroke()

    // beginPath を増やさず三塊をテストで数えられるよう、亀裂は細い矩形で刻む。
    ctx.globalAlpha = 0.35 + pulse * 0.65
    ctx.fillStyle = '#a05ad7'
    ctx.fillRect(-radius * 0.55, -0.65, radius * 0.62, 1.3)
    ctx.rotate(1.05)
    ctx.fillRect(-radius * 0.12, -0.55, radius * 0.55, 1.1)
    ctx.restore()
  }
}

// 3連速射: 砲口を回る紫の光の粒三個。軌道と収束は旧・岩塊版と同じ、見た目だけ光の玉へ置換 (2026-09-03 第4便)。
export function drawCannonVolleyCharge(
  ctx: CanvasRenderingContext2D,
  muzzle: { x: number; y: number },
  elapsedMs: number,
  chargeMs: number,
  periodMs: number,
): void {
  const p = chargeMs > 0 ? Math.max(0, Math.min(1, elapsedMs / chargeMs)) : 1
  const pulse = cannonVolleyPulseStrength(elapsedMs, chargeMs, periodMs)
  drawCannonChargeBacklight(ctx, muzzle, p, 36)
  const gatherT = Math.max(0, Math.min(1, (p - 0.45) / 0.55))
  const gatherProgress = gatherT * gatherT * (3 - 2 * gatherT)
  // 前半は三塊の離れた予告を保ち、後半だけ30%の楕円へ収束する。一点には融合させない。
  const orbitScale = 1 - gatherProgress * 0.70
  const orbit = elapsedMs * 0.0018 * (1 + gatherProgress * 1.6)
  for (let i = 0; i < 3; i += 1) {
    const seed = 1400 + i * 17.13
    const angle = orbit + i * Math.PI * 2 / 3
    const x = muzzle.x + Math.cos(angle) * 22 * orbitScale
    const y = muzzle.y + Math.sin(angle) * 13 * orbitScale
    glowMote(ctx, x, y, 3.5 + hash01(seed) * 1.5, et('parry', '#a05ad7'), 0.35 + pulse * 0.55)
    glowMote(ctx, x, y, 1.6, et('parry', '#c8b0ec'), 0.3 + pulse * 0.6)
  }
}

// 山なり榴弾: 砲口では収束も明滅もせず、重い粒が下へ滲み続ける。
function drawCannonMortarDrip(
  ctx: CanvasRenderingContext2D,
  muzzle: { x: number; y: number },
  elapsedMs: number,
): void {
  // 11-02 比較版 DEV ?execMortarDrip=off で出さない (src/exec_look_1101.ts)。既定 = 下の赤い光の粒。
  //   粒は executionerCannonMuzzle の点に出るが、榴弾の構えは砲を高く掲げるので、砲口から離れた宙に浮いて見える (11-02 撮影)。
  if (!execMortarDripOn()) return
  for (let i = 0; i < 24; i += 1) {
    const seed = 2200 + i * 5.31
    const speed = 0.00018 + hash01(seed + 1.9) * 0.00016
    const fall = (elapsedMs * speed + hash01(seed + 2.7)) % 1
    const x = muzzle.x + (hash01(seed) - 0.5) * (20 + fall * 10)
      + Math.sin(fall * Math.PI * 2 + seed) * 2.5
    const y = muzzle.y - 8 + fall * (28 + hash01(seed + 3.3) * 34)
    const radius = 3.2 + hash01(seed + 4.1) * 4.8 + fall * 2.4
    const color = hash01(seed + 5.7) > 0.7 ? '#e13a3a' : '#b01822'
    glowMote(ctx, x, y, radius, color, 0.28 + hash01(seed + 6.9) * 0.34)
  }
}

function mortarArcPoint(
  start: { x: number; y: number },
  end: { x: number; y: number },
  progress: number,
): { x: number; y: number } {
  const x = start.x + (end.x - start.x) * progress
  const linearY = start.y + (end.y - start.y) * progress
  return { x, y: linearY - 170 * 4 * progress * (1 - progress) }
}

type CannonProjectilePalette = { deep: string; mid: string; bright: string }

const CANNON_IRON = '34,31,35'

function traceAngularRock(
  ctx: CanvasRenderingContext2D,
  radiusX: number,
  radiusY: number,
  seed: number,
  points: number,
): void {
  ctx.beginPath()
  for (let i = 0; i < points; i += 1) {
    const angle = i * Math.PI * 2 / points
    const rough = 0.82 + hash01(seed + i * 3.71) * 0.24
    const x = Math.cos(angle) * radiusX * rough
    const y = Math.sin(angle) * radiusY * rough
    if (i === 0) ctx.moveTo(x, y)
    else ctx.lineTo(x, y)
  }
  ctx.closePath()
}

function drawIronRockFacet(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  radius: number,
  seed: number,
  alpha: number,
  rimAlpha = 0,
): void {
  ctx.save()
  ctx.translate(x, y)
  ctx.rotate(seed * 0.17)
  ctx.globalAlpha = alpha
  traceAngularRock(ctx, radius, radius * 0.78, seed, 5)
  ctx.fillStyle = `rgb(${CANNON_IRON})`
  ctx.fill()
  ctx.strokeStyle = 'rgba(9,7,11,0.94)'
  ctx.lineWidth = Math.max(0.8, radius * 0.16)
  ctx.stroke()
  if (rimAlpha > 0.01) {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = alpha * rimAlpha
    ctx.strokeStyle = '#5f2091'
    ctx.lineWidth = Math.max(0.65, radius * 0.10)
    ctx.stroke()
  }
  ctx.restore()
}

function drawIronRockCore(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  radius: number,
  seed: number,
  crackAlpha: number,
  rimAlpha = 0,
): void {
  if (radius <= 0.4) return
  ctx.save()
  ctx.translate(x, y)
  traceAngularRock(ctx, radius, radius * 0.82, seed, 7)
  ctx.fillStyle = `rgb(${CANNON_IRON})`
  ctx.fill()
  ctx.strokeStyle = 'rgba(8,6,10,0.96)'
  ctx.lineWidth = Math.max(1, radius * 0.09)
  ctx.stroke()
  if (rimAlpha > 0.01) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = rimAlpha
    ctx.strokeStyle = '#5f2091'
    ctx.lineWidth = Math.max(0.8, radius * 0.045)
    ctx.stroke()
    ctx.restore()
  }

  // 面ごとの明暗。輪郭を丸めず、黒鉄の多面体として読むための三角面。
  ctx.beginPath()
  ctx.moveTo(-radius * 0.82, -radius * 0.12)
  ctx.lineTo(-radius * 0.18, -radius * 0.72)
  ctx.lineTo(radius * 0.05, radius * 0.02)
  ctx.closePath()
  ctx.fillStyle = 'rgba(65,59,70,0.72)'
  ctx.fill()
  ctx.beginPath()
  ctx.moveTo(radius * 0.05, radius * 0.02)
  ctx.lineTo(radius * 0.72, -radius * 0.30)
  ctx.lineTo(radius * 0.54, radius * 0.56)
  ctx.closePath()
  ctx.fillStyle = 'rgba(22,19,25,0.82)'
  ctx.fill()

  // 細い紫の亀裂。塊の面積を光で埋めず、黒い外殻を主役に残す。
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = crackAlpha
  ctx.strokeStyle = '#a05ad7'
  ctx.lineWidth = Math.max(0.8, radius * 0.055)
  ctx.beginPath()
  ctx.moveTo(-radius * 0.56, -radius * 0.42)
  ctx.lineTo(-radius * 0.12, -radius * 0.08)
  ctx.lineTo(radius * 0.18, -radius * 0.18)
  ctx.lineTo(radius * 0.48, radius * 0.24)
  ctx.stroke()
  ctx.strokeStyle = '#5f2091'
  ctx.beginPath()
  ctx.moveTo(-radius * 0.22, radius * 0.60)
  ctx.lineTo(-radius * 0.06, radius * 0.14)
  ctx.lineTo(radius * 0.26, radius * 0.08)
  ctx.stroke()
  ctx.restore()
}

// 弾ける二本の飛翔体。黒鉄の角張った岩塊が、紫の亀裂と石片を引いて飛ぶ。
export function drawHeatedIronProjectile(
  ctx: CanvasRenderingContext2D,
  center: { x: number; y: number },
  directionRad: number,
  size: number,
  palette: CannonProjectilePalette,
  seedBase: number,
  timeSec: number,
  reflected = false,
): void {
  const dirX = Math.cos(directionRad)
  const dirY = Math.sin(directionRad)
  const normalX = -dirY
  const normalY = dirX
  const bodySize = size * (reflected ? 0.7 : 1)
  const tailCount = 4

  for (let i = 0; i < tailCount; i += 1) {
    const seed = seedBase + 500 + i * 9.71
    const life = (timeSec * (1.55 + hash01(seed) * 0.45) + hash01(seed + 1.3)) % 1
    const back = bodySize * (0.55 + life * 1.28)
    const side = (hash01(seed + 2.7) - 0.5) * bodySize * (0.56 + life * 0.34)
    const x = center.x - dirX * back + normalX * side
    const y = center.y - dirY * back + normalY * side
    if (!reflected) {
      drawIronRockFacet(ctx, x, y, bodySize * (0.055 + hash01(seed + 3.9) * 0.045), seed, 1 - life)
    }
    const glowRadius = 2 + hash01(seed + 5.1) * 3.2
    glowMote(ctx, x, y, glowRadius, `rgb(${palette.bright})`, (0.32 + hash01(seed + 6.7) * 0.34) * (1 - life))
  }

  ctx.save()
  ctx.translate(center.x, center.y)
  ctx.rotate(directionRad + Math.sin(timeSec * 10 + seedBase * 0.07) * 0.14)
  drawIronRockCore(ctx, 0, 0, bodySize * 0.5, seedBase, reflected ? 1 : 0.78)

  // 核だけになった戻り弾は、外殻の暗面より亀裂面を多く見せる。
  if (reflected) {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = 0.72
    ctx.strokeStyle = `rgb(${palette.bright})`
    ctx.lineWidth = Math.max(1, bodySize * 0.045)
    ctx.beginPath()
    ctx.moveTo(-bodySize * 0.31, 0)
    ctx.lineTo(-bodySize * 0.04, -bodySize * 0.21)
    ctx.lineTo(bodySize * 0.24, bodySize * 0.12)
    ctx.stroke()
  }
  ctx.restore()
}

// 一個の黒鉄を主役にし、熱は縁と後端、粒は剥がれた火の粉だけに留める。
// directionRad は見た目だけの進行方向。判定・速度・軌道は呼び出し元の値をそのまま使う。
function drawLegacyHeatedIronProjectile(
  ctx: CanvasRenderingContext2D,
  center: { x: number; y: number },
  directionRad: number,
  size: number,
  palette: CannonProjectilePalette,
  seedBase: number,
  timeSec: number,
): void {
  const dirX = Math.cos(directionRad)
  const dirY = Math.sin(directionRad)
  const normalX = -dirY
  const normalY = dirX

  // 塊から短く剥がれる火の粉。輪郭より先に描き、弾本体を主役に保つ。
  for (let i = 0; i < 6; i += 1) {
    const seed = seedBase + 500 + i * 9.71
    const life = (timeSec * (1.9 + hash01(seed) * 0.7) + hash01(seed + 1.3)) % 1
    const back = size * (0.45 + life * 1.05)
    const side = (hash01(seed + 2.7) - 0.5) * size * (0.48 + life * 0.28)
    const x = center.x - dirX * back + normalX * side
    const y = center.y - dirY * back + normalY * side + life * life * 5
    const radius = 1.4 + hash01(seed + 3.9) * 2.6
    const color = hash01(seed + 5.1) > 0.72 ? `rgb(${palette.bright})` : `rgb(${palette.mid})`
    glowMote(ctx, x, y, radius, color, (0.16 + hash01(seed + 6.7) * 0.28) * (1 - life))
  }

  const halfLength = size * 0.52
  const halfHeight = size * 0.34
  const tumble = Math.sin(timeSec * 12 + seedBase * 0.07) * 0.20

  ctx.save()
  ctx.translate(center.x, center.y)
  ctx.rotate(directionRad + tumble)

  const traceChunk = (): void => {
    ctx.beginPath()
    ctx.moveTo(-halfLength * 0.94, -halfHeight * 0.30)
    ctx.lineTo(-halfLength * 0.48, -halfHeight * 0.92)
    ctx.lineTo(halfLength * 0.32, -halfHeight)
    ctx.lineTo(halfLength, -halfHeight * 0.28)
    ctx.lineTo(halfLength * 0.82, halfHeight * 0.54)
    ctx.lineTo(halfLength * 0.18, halfHeight)
    ctx.lineTo(-halfLength * 0.70, halfHeight * 0.74)
    ctx.closePath()
  }

  // 焼けた外縁。光の球に戻らないよう、塊と同じ輪郭だけを薄く発光させる。
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = 0.58
  ctx.strokeStyle = `rgb(${palette.mid})`
  ctx.lineWidth = Math.max(3, size * 0.12)
  ctx.lineJoin = 'round'
  traceChunk()
  ctx.stroke()
  ctx.restore()

  // 不透明な黒鉄の芯と明確な輪郭。
  traceChunk()
  ctx.fillStyle = `rgb(${CANNON_IRON})`
  ctx.fill()
  ctx.strokeStyle = 'rgba(7,6,8,0.96)'
  ctx.lineWidth = 2.2
  ctx.lineJoin = 'round'
  ctx.stroke()

  // 進行方向と重さを読むため、後端だけを深色→明色の灼けで縁取る。
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = 0.92
  ctx.strokeStyle = `rgb(${palette.deep})`
  ctx.lineWidth = Math.max(3.2, size * 0.13)
  ctx.beginPath()
  ctx.moveTo(-halfLength * 0.48, -halfHeight * 0.92)
  ctx.lineTo(-halfLength * 0.94, -halfHeight * 0.30)
  ctx.lineTo(-halfLength * 0.70, halfHeight * 0.74)
  ctx.stroke()
  ctx.strokeStyle = `rgb(${palette.bright})`
  ctx.lineWidth = Math.max(1.4, size * 0.05)
  ctx.stroke()

  // 鉄面の一筋だけが熱を返す。面全体は暗いまま残す。
  ctx.globalAlpha = 0.62
  ctx.strokeStyle = `rgb(${palette.mid})`
  ctx.lineWidth = 1.4
  ctx.beginPath()
  ctx.moveTo(-halfLength * 0.35, -halfHeight * 0.48)
  ctx.lineTo(halfLength * 0.42, -halfHeight * 0.60)
  ctx.stroke()
  ctx.restore()
}

// 榴弾の見た目玉。ActiveHit は増やさず、既存の床ハザード時計だけを読む。
// 直射弾と同じ黒鉄の塊にし、弾けない CURSE_* の灼けだけで防御正解を分ける。
// 🔵2026-08-29: 撃つ動作より先に弾が飛ぶ「因果の逆転」を直す
//   (docs/candidates/2026-08-28-executioner-cannon-wall-hug-and-spawn.md §4)。
//   見た目の出発だけを遅らせ、出発点を振り上げた砲口付近 (前10,上250) へ変える。
//   着弾の時刻 (= hazard.telegraphMs の瞬間) と着弾位置は1msも変えない = 山なりの滞空を圧縮するだけ。
// 🔵 2026-09-03 第3便 ユーザー裁定: 撃つ瞬間を450msへ（旧200）。ほぼ真上へ上がり、画面上部で
//   3つに割れて主人公中心の横3列 (exec_cannonMortar の hazardSpawns 3本) へ自由落下する。
const CANNON_MORTAR_DEPARTURE_MS = 450
// 弧の頂点の高さと上りの弾の半径 (drawGravityOrbProjectile 36)。 画面の寄せ (案C・camZoomInputOf) も、 この高さが入るまで引く。
const CANNON_MORTAR_APEX_Y = 40
const CANNON_MORTAR_SHELL_R = 36
// 🔴 2026-09-02 深夜 廃止: 出発点は EXECUTIONER_CANNON_MUZZLE_MORTAR（砲口）へ
const CANNON_MORTAR_LAUNCH_FWD_PX = 8
const CANNON_MORTAR_LAUNCH_UP_PX = 200
void CANNON_MORTAR_LAUNCH_FWD_PX
void CANNON_MORTAR_LAUNCH_UP_PX

function drawCannonMortarProjectile(
  ctx: CanvasRenderingContext2D,
  state: GameState,
): void {
  // 🔵 2026-09-03 第4便: telegraph 中だけの呼び出しから独立させたので、ここで自前にガードする。
  if (state.phase !== 'playing' || state.boss.id !== 'the-executioner') return
  const all = state.hits.filter((hit) => hit.attackId === 'exec_cannonMortar'
    && !hit.follow && hit.telegraphMs > 0 && hit.elapsedMs < hit.telegraphMs)
  if (all.length === 0) return
  // 🔵 2026-09-03 第4便: 技が 1.25 秒で終わるので、前の榴弾が落ちる前に次の榴弾が出ることがある。
  //   同じ tick に生まれた3本 (elapsedMs と originX が同じ) を1発分として、発ごとに描く。
  const groups = new Map<string, typeof all>()
  for (const h of all) {
    const key = `${Math.round(h.elapsedMs)}|${h.originX ?? 'boss'}`
    const g = groups.get(key); if (g) g.push(h); else groups.set(key, [h])
  }
  for (const hazards of groups.values()) drawCannonMortarShellGroup(ctx, state, hazards)
}

// 榴弾の空の弾 (10-29・作者の答え exec-fx-q3「空は火の尾を引く砲弾の絵」): 黒い鉄の玉＋火の尾 (Codex の絵・exec_fx_mats の shellFly)。
//   上りは長い尾、下りは短い尾。玉の半径 = r の 0.44 (直射の弾と同じくらい)。11-01 から配布版の既定 (前は光の玉で、芯が中の空いた輪の線に見えた)。
//   前の光の玉は DEV ?execMortarShell=orb。
function drawMortarShellSprite(
  ctx: CanvasRenderingContext2D, ball: { x: number; y: number }, directionRad: number, r: number, long: boolean, seed: number, timeSec: number,
): boolean {
  if (execMortarShellOrb()) return false
  preloadExecFxMats()
  if (!shellFlyReady()) return false
  const img = shellFlySprite(long, Math.floor(timeSec * 18 + seed))
  if (!img) return false
  const w = r * 0.44 / SHELL_FLY_CORE_R
  drawMat(ctx, img, ball.x, ball.y, w, w * img.naturalHeight / img.naturalWidth, SHELL_FLY_CORE_X, 0.5, 1, directionRad)
  return true
}

function drawCannonMortarShellGroup(
  ctx: CanvasRenderingContext2D,
  state: GameState,
  hazards: GameState['hits'],
): void {
  const first = hazards[0]!
  if (first.elapsedMs < CANNON_MORTAR_DEPARTURE_MS) return   // 出発前 = まだ描かない
  const boss = state.boss
  const dir = boss.facing === 'right' ? 1 : -1
  const motion = resolveBossTimelinePose(boss.id, boss)?.motion
  // 🔵 2026-09-03 第4便: 発射点はボスの「撃った瞬間」の位置 (first.originX/originDir) から取る。
  //   撃ったあとボスが次の行動へ移って動いても、弾の軌道は動かない。originX が無い (旧データ) 時だけ
  //   従来どおり boss の現在位置+motion へフォールバックする。
  const launch = first.originX !== undefined
    ? {
        x: first.originX + (first.originDir ?? dir) * EXECUTIONER_CANNON_MUZZLE_MORTAR.spawnForwardPx,
        y: ARENA.floorY - EXECUTIONER_CANNON_MUZZLE_MORTAR.spawnOffsetY,
      }
    : {
        x: boss.x + dir * (EXECUTIONER_CANNON_MUZZLE_MORTAR.spawnForwardPx + (motion?.offsetX ?? 0)),
        y: boss.y - EXECUTIONER_CANNON_MUZZLE_MORTAR.spawnOffsetY + (motion?.offsetY ?? 0),
      }
  // 3本の hazard を着弾xで並べ、真ん中 (offset0) を center とする。
  const landings = hazards
    .map((h) => ({ x: (h.xStart + h.xEnd) / 2, y: ARENA.floorY }))
    .sort((a, b) => a.x - b.x)
  const center = landings[Math.floor((landings.length - 1) / 2)]!
  // 頂点 = 発射点→中央着弾点の45%地点、画面上端付近 (ARENA に上端の定数が無いため y=40 固定・旧70)。
  const apex = { x: launch.x + (center.x - launch.x) * 0.45, y: CANNON_MORTAR_APEX_Y }
  // 弧 (src/exec_mortar_arc_1104.ts): 配布版 = low (頂点より上へ出さず、割れる所を画面の中で見せる)。?mortarArc=old で前の弧。
  const arcMode = mortarArcMode()
  const phase = mortarArcPhase(arcMode, first.elapsedMs, CANNON_MORTAR_DEPARTURE_MS, first.telegraphMs)
  const arcAt = (s: { x: number; y: number }, e: { x: number; y: number }, q: number, up: boolean) =>
    arcMode === 'now' ? mortarArcPoint(s, e, q) : mortarArcPointLow(s, e, q, up)

  if (phase.up) {
    // 上昇側: 発射点→頂点の半分の弧を1発で描く。
    const upProgress = phase.q
    const ball = arcAt(launch, apex, upProgress, true)
    const previous = arcAt(launch, apex, Math.max(0, upProgress - 0.01), true)
    const directionRad = Math.atan2(ball.y - previous.y, ball.x - previous.x)
    // 🔵 2026-09-03 第5便 ユーザー「榴弾ボムのデザインも重力弾同様、岩じゃないデザインに」: 直射と同じ紫の光の玉。?shot=rock で旧岩塊。
    if (drawMortarShellSprite(ctx, ball, directionRad, 36, true, 0, first.elapsedMs / 1000)) return
    if (cannonShotLook === 'rock') {
      drawLegacyHeatedIronProjectile(
        ctx, ball, directionRad, 38,
        { deep: CURSE_DEEP, mid: CURSE_MID, bright: CURSE_BRIGHT }, 3100, first.elapsedMs / 1000,
      )
    } else {
      drawGravityOrbProjectile(ctx, ball, directionRad, 36, 3100, first.elapsedMs / 1000, false, 'unparry')
    }
    return
  }

  // 下降側: 頂点で3つに割れ、頂点→各着弾点の半分の弧をそれぞれ描く。
  const downProgress = phase.q
  landings.forEach((landing, i) => {
    const ball = arcAt(apex, landing, downProgress, false)
    const previous = arcAt(apex, landing, Math.max(0, downProgress - 0.01), false)
    const directionRad = Math.atan2(ball.y - previous.y, ball.x - previous.x)
    if (drawMortarShellSprite(ctx, ball, directionRad, 27, false, i * 2, first.elapsedMs / 1000)) return
    if (cannonShotLook === 'rock') {
      drawLegacyHeatedIronProjectile(
        ctx, ball, directionRad, 28,
        { deep: CURSE_DEEP, mid: CURSE_MID, bright: CURSE_BRIGHT }, 3100 + i * 37, first.elapsedMs / 1000,
      )
    } else {
      drawGravityOrbProjectile(ctx, ball, directionRad, 27, 3100 + i * 37, first.elapsedMs / 1000, false, 'unparry')
    }
  })
}

function drawExecutionerCannonTell(ctx: CanvasRenderingContext2D, state: GameState): void {
  const boss = state.boss
  if (state.phase !== 'playing' || boss.id !== 'the-executioner' || boss.state !== 'telegraph') return
  const attack = boss.currentAttack
  if (!attack) return
  const muzzle = executionerCannonMuzzle(boss)
  const elapsedMs = Math.max(0, boss.stateElapsed * 1000)
  const progress = Math.max(0, Math.min(1, elapsedMs / attack.chargeMs))

  if (attack.id === 'exec_cannonShot') {
    if (cannonShotLook === 'rock') {
      drawCannonShotChargeRock(ctx, muzzle, progress, attack.castProjectile?.widthPx ?? 42)
    } else {
      drawCannonShotCharge(ctx, muzzle, progress, attack.castProjectile?.widthPx ?? 42)
    }
  } else if (attack.id === 'exec_cannonVolley') {
    const periodMs = attack.comboGapsMs?.[0]
    if (periodMs !== undefined && periodMs > 0) {
      if (cannonShotLook === 'rock') {
        drawCannonVolleyChargeRock(ctx, muzzle, elapsedMs, attack.chargeMs, periodMs)
      } else {
        drawCannonVolleyCharge(ctx, muzzle, elapsedMs, attack.chargeMs, periodMs)
      }
    }
  } else if (attack.id === 'exec_cannonMortar') {
    drawCannonMortarDrip(ctx, muzzle, elapsedMs)
  }
}

// ===== 介錯・斬撃の軌跡 (コードFX) =====
// 設計 = docs/candidates/2026-08-27-executioner-swing-trail-fx-design.md
// 絵に焼き込まれていた斬撃の弧・突きの残線をコード描画へ移す。赤・紫は使わず、
// morph glow と同じ普通合成 (additive にしない) の淡い灰白で「舞台の現象」として見せる。
type SwingTrailDef = {
  // 弧・残線の起点 = boss.x + dir*anchorFwdPx, boss.y - anchorUpPx（肩の高さ想定 ~150）
  anchorFwdPx: number
  anchorUpPx: number
  radiusPx: number
  widthPx: number
  // 角度は「画面左向き」基準のラジアン（0=前方水平、正=上）。facing right は鏡像。
  angleFromRad: number
  angleToRad: number
  // 出る窓: active 開始からの経過ms [startMs, endMs]。recovery へまたいでよい
  startMs: number
  endMs: number
  maxAlpha: number   // 0.3 前後から。焼き込みの見た目（淡い灰白）に寄せる
  // true = 弧ではなく突きの直線の残線（angleFromRad の方向へ固定）。既定 false = 弧
  thrust?: boolean
}

// 🔴 2026-08-29 退役 (実プレイ不合格・後継 = drawBossContactSmear・
//   docs/candidates/2026-08-28-executioner-swing-fx-redesign.md)。
//   呼び出し (draw() 内) は外した。定義は常時ルール4 (既存資産は削除しない) に従い残置する。
// 🎚 唯一の調整点。全キー🟨仮値 (実機で詰める・比較検分は __swingTrail / ?noSwingTrail)。
// 🔴 exec_maulDrop はここに足さない: 振り下ろしは既存の弧FX `downswing_arc` (game.ts の
//   active 突入 spawn + drawDownswingArc・票 = docs/candidates/2026-08-20-executioner-downswing-arc-fx-ticket.md)
//   が 08-20 から担当している。足すと二重に出る (2026-08-28 実表示で確認済み)。
// 🔵 2026-09-02 夜 等身 1.6 化で anchorFwdPx/anchorUpPx/radiusPx/widthPx を 0.8 倍（旧値は各エントリのコメント参照）
const EXECUTIONER_SWING_TRAILS: Record<string, SwingTrailDef> = {
  // 斬り上げ: 下→上の掬い弧 (scoop_smear の焼き込みの代替)
  exec_maulHold: {
    // 旧 anchorFwdPx 40 / anchorUpPx 150 / radiusPx 160 / widthPx 26
    anchorFwdPx: 32, anchorUpPx: 120, radiusPx: 128, widthPx: 21,
    angleFromRad: -Math.PI / 2, angleToRad: Math.PI / 2.6,
    startMs: 0, endMs: 190, maxAlpha: 0.30,
  },
  // 据えの一打: 横薙ぎ。刃が通るのは胸の高さの前方なので、前方の浅い横弧で見せる
  //   (~~144°→-18°の頭上弧~~ は 2026-08-28 実表示で「頭上の離れた場所に浮く」= 刃と無関係に見えた)。
  exec_maulSet: {
    // 旧 anchorFwdPx 20 / anchorUpPx 130 / radiusPx 150 / widthPx 30
    anchorFwdPx: 16, anchorUpPx: 104, radiusPx: 120, widthPx: 24,
    angleFromRad: Math.PI * 0.28, angleToRad: -Math.PI * 0.16,
    startMs: 0, endMs: 200, maxAlpha: 0.30,
  },
  // 据えの突き: 弧ではなく刃に沿う短い残線・alpha低め (sweep_slash の代替)
  exec_maulSetPierce: {
    // 旧 anchorFwdPx 30 / anchorUpPx 150 / radiusPx 140 / widthPx 14
    anchorFwdPx: 24, anchorUpPx: 120, radiusPx: 112, widthPx: 11,
    angleFromRad: 0, angleToRad: 0,
    startMs: 0, endMs: 140, maxAlpha: 0.18, thrust: true,
  },
  // 薙ぎ払い: 前方の浅い横弧 (horizontal_slash の焼き込みの代替。角度の根拠は exec_maulSet と同じ)
  exec_yokeSweep: {
    // 旧 anchorFwdPx 20 / anchorUpPx 130 / radiusPx 150 / widthPx 28
    anchorFwdPx: 16, anchorUpPx: 104, radiusPx: 120, widthPx: 22,
    angleFromRad: Math.PI * 0.28, angleToRad: -Math.PI * 0.16,
    startMs: 0, endMs: 165, maxAlpha: 0.28,
  },
  // 執行の咆哮・突進斬り: 前方の浅い横弧 (horizontal_slash の焼き込みの代替)
  executioner_phaseTransition: {
    // 旧 anchorFwdPx 20 / anchorUpPx 130 / radiusPx 150 / widthPx 28
    anchorFwdPx: 16, anchorUpPx: 104, radiusPx: 120, widthPx: 22,
    angleFromRad: Math.PI * 0.28, angleToRad: -Math.PI * 0.16,
    startMs: 0, endMs: 200, maxAlpha: 0.28,
  },
}

const SWING_TRAIL_COLOR = 'rgb(226,220,208)'
// 24分割 + lineCap 'butt': ~~8分割 + 'round'~~ は隣り合う丸キャップが「数珠つなぎの点」に
//   見えた (2026-08-28 実表示)。細かく割って端を平らに繋ぐと1本のリボンに読める。
const SWING_TRAIL_SEGMENTS = 24
const SWING_TRAIL_LAG = 0.55  // 弧の尾が遅れて追う量 (窓の割合)。~~0.3~~ は尾が短く「置いていかれた煙玉」に見えた (2026-08-28)

// 窓のふち (最初15%/最後35%) で 0 へフェード。型②=フェードは必ず0まで届かせる。
function swingTrailEnvelope(t: number): number {
  const fadeIn = Math.min(1, t / 0.15)
  const fadeOut = Math.min(1, (1 - t) / 0.35)
  return Math.max(0, Math.min(1, fadeIn, fadeOut))
}

function swingTrailPoint(
  anchor: { x: number; y: number }, mirror: number, radiusPx: number, angleRad: number,
): { x: number; y: number } {
  return { x: anchor.x + Math.cos(angleRad) * radiusPx * mirror, y: anchor.y - Math.sin(angleRad) * radiusPx }
}

// 太い低アルファ + 細い中アルファの2度描き (EXECUTIONER_MORPH_GLOW と同じ作法)。
function strokeSwingSegment(
  ctx: CanvasRenderingContext2D,
  from: { x: number; y: number }, to: { x: number; y: number },
  widthPx: number, alpha: number,
): void {
  if (alpha <= 0) return
  ctx.lineWidth = widthPx
  ctx.globalAlpha = alpha * 0.5
  ctx.beginPath()
  ctx.moveTo(from.x, from.y)
  ctx.lineTo(to.x, to.y)
  ctx.stroke()
  ctx.lineWidth = widthPx * 0.35
  ctx.globalAlpha = alpha
  ctx.beginPath()
  ctx.moveTo(from.x, from.y)
  ctx.lineTo(to.x, to.y)
  ctx.stroke()
}

function drawSwingArc(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: SwingTrailDef, t: number,
): void {
  const envelope = swingTrailEnvelope(t)
  if (envelope <= 0) return
  const angleAt = (progress: number): number => {
    const p = Math.max(0, Math.min(1, progress))
    return def.angleFromRad + (def.angleToRad - def.angleFromRad) * p
  }
  const currentAngle = angleAt(t)
  const laggedAngle = angleAt(t - SWING_TRAIL_LAG)
  for (let index = 0; index < SWING_TRAIL_SEGMENTS; index += 1) {
    const from = index / SWING_TRAIL_SEGMENTS
    const to = (index + 1) / SWING_TRAIL_SEGMENTS
    const p1 = swingTrailPoint(anchor, mirror, def.radiusPx, laggedAngle + (currentAngle - laggedAngle) * from)
    const p2 = swingTrailPoint(anchor, mirror, def.radiusPx, laggedAngle + (currentAngle - laggedAngle) * to)
    strokeSwingSegment(ctx, p1, p2, def.widthPx, def.maxAlpha * envelope * to)
  }
}

function drawSwingThrust(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: SwingTrailDef, t: number,
): void {
  const envelope = swingTrailEnvelope(t)
  if (envelope <= 0) return
  const tip = swingTrailPoint(anchor, mirror, def.radiusPx, def.angleFromRad)
  strokeSwingSegment(ctx, anchor, tip, def.widthPx, def.maxAlpha * envelope)
}

// DEV検分用: `?noSwingTrail` で全消し (焼き込み版の絵との比較検分)。
function swingTrailDisabledByQuery(): boolean {
  return import.meta.env.DEV && typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).has('noSwingTrail')
}

// active 開始からの通算経過ms。recovery へまたいでも通算で数える (stateElapsed は状態遷移で0リセットされるため)。
function executionerSwingTrailElapsedMs(boss: Boss, attack: AttackDef): number | null {
  if (boss.state === 'active') return boss.stateElapsed * 1000
  if (boss.state === 'recovery') return attack.activeMs + boss.stateElapsed * 1000
  return null
}

// 🔴 2026-08-29 退役につき呼び出し元ゼロ。noUnusedLocals 回避のため export だけ残す (削除しない)。
export function drawExecutionerSwingTrail(ctx: CanvasRenderingContext2D, state: GameState): void {
  const boss = state.boss
  if (state.phase !== 'playing' || boss.id !== 'the-executioner' || boss.hp <= 0) return
  if (swingTrailDisabledByQuery()) return
  const attack = boss.currentAttack
  if (!attack) return
  const base = EXECUTIONER_SWING_TRAILS[attack.id]
  if (!base) return
  // DEV ライブ・ツマミ (__poseFix と同じ流儀): __swingTrail['<attackId>'] = 部分上書き
  const devOverride = import.meta.env.DEV
    ? (globalThis as { __swingTrail?: Record<string, Partial<SwingTrailDef>> }).__swingTrail?.[attack.id]
    : undefined
  const def: SwingTrailDef = devOverride ? { ...base, ...devOverride } : base
  const elapsedMs = executionerSwingTrailElapsedMs(boss, attack)
  if (elapsedMs === null || elapsedMs < def.startMs || elapsedMs > def.endMs) return
  const t = (elapsedMs - def.startMs) / Math.max(1, def.endMs - def.startMs)
  const dir = boss.facing === 'right' ? 1 : -1
  // mirror = dir: 角度 0 が「ボスの前方」を向く (facing left なら -x)。
  //   ~~-dir~~ は前後が逆で、弧が背中側に出ていた (2026-08-28 実表示で確認)。
  const mirror = dir
  const anchor = { x: boss.x + def.anchorFwdPx * dir, y: boss.y - def.anchorUpPx }

  ctx.save()
  ctx.globalCompositeOperation = 'source-over'   // additive にしない (信号色FXと混同させない)
  ctx.strokeStyle = SWING_TRAIL_COLOR
  // 弧は 'butt' で切れ目なく繋ぐ (数珠化防止)。突きの残線は1本線なので 'round' で端を丸める。
  ctx.lineCap = def.thrust ? 'round' : 'butt'
  if (def.thrust) drawSwingThrust(ctx, anchor, mirror, def, t)
  else drawSwingArc(ctx, anchor, mirror, def, t)
  ctx.restore()
}

// ===== 介錯・接触スメア (2026-08-29 作り直し) =====
// 設計 = docs/candidates/2026-08-28-executioner-swing-fx-redesign.md。
// 発想 = 「絵がハードカットで切り替わる瞬間に、その絵専用のスメアを短寿命だけ描いて橋を架ける」。
// 🔴 2026-08-31 更新: ~~いま表示されている接触の絵そのもので引く~~ をやめた。
//   ユーザー裁定「振り下ろし (drawDownswingArc tone='steel') と同じ見た目にできないか」を受け、
//   時間構造を「絵が出たら描く」から「接触へ向けて掃き切る」へ変更 (drawBossContactSmear 参照)。
//   掃きは接触前 (構えの絵の間) から始まる必要があるため、いまは findContactKey の契約キーで引く。
export type ContactSmearArc = {
  kind: 'arc'
  anchorFwdPx: number
  anchorUpPx: number
  radiusPx: number
  // ribbon は最大幅として使用。従来の drawContactSmearSweep は `2 + 9*seg` 固定。
  widthPx: number
  // 角度は swingTrailPoint と同じ規約 (0=前方水平・正=上)。
  // fromRad = 古い側 (先に消える) / toRad = 接触の絵に写っている側 (最後まで残る)。
  angleFromRad: number
  angleToRad: number
  // ribbon は最大αとして使用。従来の掃き文法は fade (=(1-q)²) だけでαを決める。
  maxAlpha: number
  // 🔴 2026-08-31 未使用 (arc専用): 寿命は tC (=contactKey.at×activeMs) + SMEAR_FADE_MS で決まる。
  //   thrust (現在 SMEAR_ARTS に定義なし・実質未使用) だけがこのフィールドを引き続き読む。
  lifeMs: number
  // 🔵 2026-09-05 (騎士 lanceSweep 追加時): 接触の何ms前から掃き始めるか。未指定 = 従来どおり
  //   active 突入から接触まで (= tS 0)。contact キーが active 0.0 の技 (騎士の薙ぎ) は
  //   telegraph の終わりから掃く必要があるのでここで指定する。
  sweepMs?: number
  // Optional continuous, tapered silhouette. Unset entries retain their existing rendering.
  ribbon?: boolean
  // 🔵 2026-09-27 (騎士 lanceSweep キーポーズ化): 接触の絵が出た瞬間から描く掃き方。指定時は sweepMs / ribbon を読まない。
  //   09-15 ユーザー「振り始めるちょっと前にエフェクトが出ている。そこだけ直してくれれば他はいい感じ」= 接触前には出さない。
  //   fromP から先端が接触の穂先まで revealMs で伸び、holdMs 保ったあと fadeMs で古い側 (構えの穂先側) から消える。
  afterContact?: ContactSmearAfterContact
  // 色 (未指定 = PALETTE.fxSilver 1色)。core = 刃先の軌跡の線 / glow = 三日月の面とぼかし。
  coreColor?: string
  glowColor?: string
  // 🔵 2026-10-20 (剣舞 v4): 線を引かず、刃先の通った弧の上に火花を散らす (白い効果線は不採用 = 10-10 作者)。afterContact と組む。
  sparks?: boolean
  // 🔵 2026-10-20 (剣舞 v6): 当たる瞬間に刃先から刃の花びらと鏡の破片を散らす (作者の答え = B 刃の花びら・D 砕ける鏡の鋭さを混ぜる)。
  //   spread = 散る向き (down = 振った向きへ斜め下にこぼれる / side = 前へ横一列に流れる / up = 上へ舞い上がる)。sparks と組む。
  petals?: ContactSmearPetals
  // 🔵 2026-10-21 (剣舞 v6・作者「火花なのがおかしい…切っ先の軌道みたいなエフェクトを作るべき」): 剣先の通り道を帯で描く。
  //   afterimage = 帯の残像 (帯の後ろに薄い帯が2本遅れて続く) / glass = 硝子の弧 (帯の中に切子の筋)。
  //   手本 = そざい/concept/blade-trail-1021/trail_sample.png の B と C。sparks・petals より優先する。
  //   trailWidthPx = 剣先の側の帯の太さ (振り始めは細い)。
  trail?: 'afterimage' | 'glass'
  trailWidthPx?: number
  // 🔵 2026-10-23 (剣舞 v7 の2・3連撃目・作者「エフェクトが短いな」): 振り始めの側の太さ・明るさの下限 (0〜1)。
  //   未指定 = 0 (振り始めはほぼ消える)。0.35 なら振り始めでも剣先の側の 35% の重みで見える。
  trailHeadStart?: number
  // 🔵 2026-10-27 (剣舞アルレ版の引き戻し・作者「交差が分からない…表現方法を変えるべき」・開発版 ?bladePullFx=a|b|c):
  //   delayMs = 接触から何 ms 遅れて引き始めるか (<絵>#2 の2本目だけが読む・X を一画ずつ書く)。
  //   glint = 接触から atMs 後に、2本が交わる点 (足元から前・上 px) で閃く (2本の向きに沿った菱形2枚と光の芯)。
  //   ghostBlades = 帯の上に剣の形の薄い影を count 枚残す (lenPx = 影の剣の長さ・刃の向きが見える)。
  delayMs?: number
  glint?: { fwdPx: number; upPx: number; atMs: number; sizePx: number }
  ghostBlades?: { count: number; lenPx: number }
}
export type ContactSmearPetals = { spread: 'down' | 'side' | 'up'; count: number; seed: number; sizePx?: number }
export type ContactSmearAfterContact = { fromP: number; revealMs: number; holdMs: number; fadeMs: number }
type ContactSmearThrust = {
  kind: 'thrust'
  rootFwdPx: number
  rootUpPx: number
  tipFwdPx: number
  tipUpPx: number
  extendPx: number   // 刃先のさらに先まで伸ばす量
  widthPx: number
  maxAlpha: number
  lifeMs: number
}
type ContactSmearDef = ContactSmearArc | ContactSmearThrust

// 🎚 唯一の調整点。座標は票 (2026-08-28 redesign 票 §2) の実測値をそのまま使用。
//   🔴 2026-08-31: widthPx / maxAlpha は arc (kind:'arc') では読まれなくなった
//     (drawContactSmearSweep が固定式で決める・上の ContactSmearArc 型コメント参照)。
//   🟡 仮値 (票が座標を与えていない箇所・実機で詰める前提):
//   - horizontal_slash / overhead_contact の angleFromRad (「古い側」は票が言葉でしか
//     指定していない = 後方上 / 上、なので概算角で置いた)。
//   - overhead_contact の中心アンカー (票は2端点だけを与えていて中心の指定が無い。
//     他アートの「根元」に揃う位置を仮の肩ピボットとして置いた)。
//   - 全アートの widthPx / maxAlpha (票が数値を与えたのは sweep_slash の幅≈10だけ)。
//   比較検分 = __contactSmear / ?noSwingTrail (旧スメアの検分クエリを引き継ぐ)。
export const SMEAR_ARTS: Record<string, ContactSmearDef> = {
  // 🔵 2026-08-29 検収是正: 初版のアンカーはスプライト縮小版からの目測で、実機で刃から浮いた。
  //   以下は**実機のコマから実測** (横一閃 = _確認用/188_triple_06 / 斬り上げ = maulHold f027 の3点円フィット)。
  // 横一閃: 肩(前15,上122)中心・半径118 = 巻き(後方上)→刃先(前129,上88)の実軌道。
  // 🔵 2026-08-30 検収NG『煙っぽい』→ ハードエッジ層構成へ (研究出所 = docs/playtest/packs/2026-08-28-executioner-branch-art-fx-pack.md 第2回結果 B-2)。
  //   maxAlpha は不透明コア前提の値へ更新 (0.30/0.38→0.85)。他フィールドは未変更 = 検収側があとで実測チューニングする。
  horizontal_slash: {
    kind: 'arc',
    // 🔵 2026-08-30 実測是正 (_確認用/194_hard_triple_06): 旧値 (肩中心r118・end -0.29) は
    //   円が刃先の外側を通り、弧の終端が刃を通り過ぎて下で止まっていた (=浮きの正体)。
    //   中心を下げて円周を接触コマの刃先 (前88,上117・姿勢変位差引後) に通す。頂点も頭より下がる。
    // 🔵 2026-08-31 ユーザー裁定 (_確認用/208 モックシート案A): widthPx 22→5 = 細い一本線へ。
    anchorFwdPx: -20, anchorUpPx: 60, radiusPx: 122, widthPx: 5,
    angleFromRad: 2.35,       // 巻き戻し側 (後方中段・sweep_coil の刃の付近)
    angleToRad: 0.49,         // 接触コマの刃先で終わる
    maxAlpha: 0.85, lifeMs: 160,
  },
  // 斬り上げ: 引き摺りの刃先 (前100,上15) → 掬い上げの刃先 (前109,上279) を通る円。
  // 🔵 2026-08-31 ユーザー裁定 (_確認用/208 モックシート案A): widthPx 20→5 = 細い一本線へ。
  // 🔵 2026-08-31 実プレイ第2ラウンド B-2 是正 (ユーザー特定「両方・刃の1/3のところから出ている」):
  //   旧円 (中心(10,100) r120) の「掬い上げの刃先(47,214)」は実は**刃の途中**の点で、弧の先端が
  //   刃先に届かず 1/3 位置で止まっていた (_tmp/scoop_zoom_set)。接触コマの本当の刃先 (前109,上279・
  //   姿勢変位差引後) を通る円へ引き直し。単発の斬り上げと3連2段目は同じ絵ローカル定義を共有。
  scoop_smear: {
    kind: 'arc',
    // ⚠️ 1回目の引き直し (end 109,279) は画面座標→絵ローカル換算のボス位置推定がズレて
    //   刃先を前29/上42px 通り過ぎた (_確認用/221-222)。同一コマ内の「弧の先端→刃先」相対差分で補正。
    anchorFwdPx: -10, anchorUpPx: 117, radiusPx: 150, widthPx: 5,
    angleFromRad: -0.75,      // 引き摺りの刃先 (前100,上15)
    angleToRad: 0.93,         // 掬い上げの刃先 (前80,上237・同一コマ相対測定)
    maxAlpha: 0.85, lifeMs: 160,
  },
  // 斬り上げ 5キー化 (2026-09-02・?scoop=a|b): 溜めの絵が変わり、急加速の直前の刃先は**後方の地面すれすれ**
  //   (scoop_lift: bbox 中心から後ろ 513px元 ≒ 実機 113px・lift の前進 19px を差し引いて 前-94/上7)。
  //   旧 scoop_smear の弧はそこから前100px の位置で始まるので、絵と無関係な所に浮いて見えた (_tmp/scoop_strip_a3 f14)。
  //   起点を最下点に置く円 (中心 後108/上194・半径193) = 弧が床の下へ潜らない。終点は旧と同じ刃先 (前80,上237)。
  //   🟨 仮値 (実機で刃先に乗っているか確認して詰める)。3連の段1 (同じ scoop_smear) は旧定義のまま。
  scoop_smear_5key: {
    kind: 'arc',
    anchorFwdPx: -108, anchorUpPx: 194, radiusPx: 193, widthPx: 5,
    angleFromRad: -Math.PI / 2,   // 離地直前の刃先 (前-108,上1・接触キーの変位を掛ける前)
    angleToRad: 0.225,            // 掬い上げの刃先 (前80,上237)
    maxAlpha: 0.85, lifeMs: 160,
  },
  // 🔴 2026-08-31 ユーザー裁定 (_確認用/208 モックシート): 「突きはエフェクト基本無し」＝
  //   赤い呪いオーラが既に信号。sweep_slash は SMEAR_ARTS の表から外し、drawBossContactSmear
  //   の `if (!base) return` で自然に描かれなくする (ロジック変更なし・呼び出し元は未変更のまま確認済み)。
  //   瞬間移動感が出たら案D (刃先の短い糸) を最小で戻す。定義は削除せず退避として残す:
  // sweep_slash: {
  //   kind: 'thrust',
  //   // ⚠️ 1回目の是正 (root up197) は肩当ての上端を刃の根元と誤読し、筋が頭から斜めに刃を横切った
  //   //   (_確認用/201)。刃の軸の実測 = 根元(0,157)→刃先(182,137)。
  //   rootFwdPx: 0, rootUpPx: 157, tipFwdPx: 182, tipUpPx: 137, extendPx: 40,
  //   widthPx: 12, maxAlpha: 0.85, lifeMs: 140,
  // },
  // 3連の締め振り下ろし (exec_maulDrop 以外で出た時だけ)。
  //   🔵 2026-08-29 検収是正: 初版の仮アンカーは高すぎ+前すぎで接地点に届かなかった (_確認用/190)。
  //   実機コマから実測 = 振りかぶりの刃先(前10,上280)→接地の刃先(前65,上5) を通る円 (中心 後60,上120・半径170)。
  // 🔵 2026-08-31 ユーザー裁定 (_確認用/208 モックシート案A): widthPx 24→6 = 締めの大振りだけ僅かに太い一本線。
  overhead_contact: {
    kind: 'arc',
    anchorFwdPx: -60, anchorUpPx: 120, radiusPx: 170, widthPx: 6,
    angleFromRad: 1.16,       // 振りかぶりの刃先 (前10,上280)
    angleToRad: -0.74,        // 接地の刃先 (前65,上5)
    maxAlpha: 0.85, lifeMs: 160,
  },
  // 🔵 2026-09-03 第9便 (ユーザー「後ろに振りかぶって前に薙ぐ攻撃なので薙ぎのエフェクトを付けて」):
  //   砲身薙ぎ (exec_cannonSweep・砲形態)。**採用済みの横一閃 (horizontal_slash) と同じ作り** = 後ろの砲口と
  //   前の砲口を通る円の中心を低く (上40) 置き、弧は頭の高さ (頂点 上183) を通って前へ落ちる。角度もほぼ同じ
  //   (2.375→0.481 / 横一閃 2.35→0.49)。砲口の位置は絵から実測 (cannon/sweep_windup twist_a の砲口 = 後98/上139、
  //   sweep_contact = 前99/上106。換算 k = 192/1354×1.15)。後ろ側は構えの絵の変位 (x −14) と接触キーの変位
  //   (x +26) の差 40px ぶん後ろへ置いて (−130) 描画時にほぼ砲口へ乗るようにした。
  //   ✗ 最初に試した「下へ浅く撓む平らな弧」(anchor 29/430・r331・−2.07→−1.357) は体と砲身に重なってほぼ見えなかった
  //     (_tmp/sw_arc_grid.png)。比較用に kensyu の `__contactSmear` 上書きで残す (第9便 B-1)。
  //   🟨 仮値 (第9便で砲口に乗っているか・横薙ぎに見えるかをユーザーが判定)。
  sweep_contact: {
    kind: 'arc',
    anchorFwdPx: -1, anchorUpPx: 40, radiusPx: 143, widthPx: 5,
    angleFromRad: 2.375,      // 構えの砲口 (後130,上139・接触キーの変位を掛ける前)
    angleToRad: 0.481,        // 振り抜きの砲口 (前125,上106・接触キーの変位 +26 込み)
    maxAlpha: 0.85, lifeMs: 160,
  },
  // 🔵 2026-09-27 ユーザー裁定 (騎士・境界の薙ぎのキーポーズ化):「構えているところと振り終わったところは確実に必要で
  //   その間をエフェクトで埋めるような形。本来振っているはずの軌道を描くエフェクトを付けてほしい（介錯がそのようにしている）」。
  //   絵は構え (lanceSweep_windup) → 振り終わり (lanceSweep_contact) の2枚だけ。その間の穂先の通り道をこの弧が描く。
  //   形 = 介錯の横一閃と同じ「円弧の三日月 + 先端ほど太く明るい軌跡」(drawContactSmearSweep の文法)。
  //   端点は scripts/probe_reach_vs_sprite.mjs で実描画から採寸 (左右反転を戻した値・2026-09-27):
  //     構えの穂先 (溜めの膨らみ最大) = 後79.8 / 上171.3、振り終わりの穂先 = 前94〜95.6 / 上85.5。
  //     2点の弦の中点から 100px 下へ中心 (後37.4 / 上38.6)・半径139.3 = 穂先は構えの高さ (上171) から頭の少し上 (上178) を
  //     かすめて前へ斜めに落ちる = 振り下ろしでなく薙ぎに読ませる浅い弧。
  //     ✗ 最初の案 (45px 下・半径107・頂点 上195) と 75px 下 (頂点 上184) は実表示で頭上に浮いた大きな輪に見えた (09-27 ラボ撮影)。
  //     弧の終点 = 振り終わりの穂先 (前94.0) が弧の一番前 = 当たりの前端 (attacks.ts lanceSweep 95) の外へ描かない。
  //   時間 = 接触の絵へ切り替わった瞬間 (active 0) から。先端は60%地点から33msで穂先へ届き、50ms保って100msで消える
  //     (active 150ms の内側で消え切る = 拍間 beatGap へ持ち越さない。型②)。09-15 の確認版の時計 (700→730→850ms) とほぼ同じ。
  //   色 = 騎士の絵の中の色: 芯は穂先の鋼に柄の生成りを混ぜた暖かい白 / ぼかしは鎧の影の藤鼠。冷たい青白 (lance_flash 系) は使わない。
  //   09-12 版 (穂先固定の短い尾) は drawKnightSweepTrail (DEV ?knightSweep=0912)。その前の版は下の KNIGHT_SWEEP_SMEAR_V1。
  lanceSweep_contact: {
    kind: 'arc',
    anchorFwdPx: -37.4, anchorUpPx: 38.6, radiusPx: 139.3, widthPx: 8,
    angleFromRad: 1.8804,   // 構えの穂先 (後79.8 / 上171.3)
    angleToRad: 0.3397,     // 振り終わりの穂先 (前94.0 / 上85.0)
    maxAlpha: 0.85, lifeMs: 150,
    // fromP 0.35 だと接触の最初のコマに弧の出だし (頭上の後ろ) だけが薄く出て、槍と離れて見えた (09-27 ラボ撮影) → 0.6。
    afterContact: { fromP: 0.6, revealMs: 33, holdMs: 50, fadeMs: 100 },
    coreColor: '#e9e1cf',
    glowColor: '#9a8fb8',
  },
  // 🔵 2026-09-27 夜 (S-4 ユーザー原文「振ったエフェクトと絵があっていない。屈伸？しているような動きをしているのに
  //   薙ぎのいちにエフェクトが出ている」): 連の2拍目以降の薙ぎ。溜めの絵は深い低姿勢 (lanceSweep_linkWindup) で、
  //   穂先は**前の床すれすれ** (実測 前88〜91 / 上14〜15・scripts/knight_sweep_string_probe.mjs) にある。
  //   そこから振り終わり (前94 / 上85) へ穂先は**前で下から上へ**振り上がる。なのに上の lanceSweep_contact
  //   (構えの穂先 = 後ろ上 から頭上を越える弧) を出していた = 絵と無関係な所に弧が出ていた正体。
  //   この弧 = 低い構えの穂先 (前91 / 上15) → 振り終わりの穂先 (前94 / 上85) を通る円。中心は2点の弦から 150px 後ろ
  //   (後57.4 / 上56.4・半径154) = 胸の高さの後ろを軸に前へ少し膨らむ浅い振り上げ (膨らみの前端 96.6)。
  //   時間・色・太さは単発と同じ文法。出だしは穂先の近く (fromP 0.2) から = 構えの穂先と繋がって見える。
  lanceSweep_contact_link: {
    kind: 'arc',
    anchorFwdPx: -57.37, anchorUpPx: 56.42, radiusPx: 154.04, widthPx: 8,
    angleFromRad: -0.2721,  // 低い構えの穂先 (前91 / 上15)
    angleToRad: 0.1863,     // 振り終わりの穂先 (前94 / 上85)
    maxAlpha: 0.85, lifeMs: 150,
    afterContact: { fromP: 0.2, revealMs: 33, holdMs: 50, fadeMs: 100 },
    coreColor: '#e9e1cf',
    glowColor: '#9a8fb8',
  },
}

// 🔵 2026-10-01 大きさ＝兜で揃えるが既定 (ユーザー「兜で揃えた方がいい」・src/knight_helmet_scale.ts) になり、
//   接触の絵が 100/87 倍で描かれるので、上の弧 (旧の大きさの実測) は穂先より約16px 手前で止まっていた
//   (実描画の前端 93.9px ／ 穂先 109.9px・票 knight-scale-reach-walk-1001)。同じ作り方で端点だけ測り直した弧:
//   単発 = 構えの穂先 (溜めの膨らみ最大・実測 後82.6 / 上178.3) → 振り終わりの穂先 (旧 前94 / 上85 × 100/87 = 前108.0 / 上97.7)。
//     中心は弦の中点から下へ 106.7px (旧 100px × 弦の長さの比 206.95/194.05 = 同じ膨らみ方)。
//   連の2拍目以降 = 低い構えの穂先 (前91 / 上15 × 100/86) → 振り終わりの穂先 (同上)。中心は弦から後ろへ 171.9px (旧 150 × 弦の比)。
//   DEV ?knightScale=old の時は上の旧の弧のまま。
const KNIGHT_HELMET_SMEAR_ARC: Record<string, Partial<ContactSmearArc>> = {
  lanceSweep_contact: { anchorFwdPx: -28.81, anchorUpPx: 39.80, radiusPx: 148.60, angleFromRad: 1.9408, angleToRad: 0.4003 },
  lanceSweep_contact_link: { anchorFwdPx: -64.90, anchorUpPx: 62.35, radiusPx: 176.52, angleFromRad: -0.2572, angleToRad: 0.2016 },
}
export function knightSweepSmearArcDef(artName: string, helmet: boolean): ContactSmearDef | undefined {
  const base = SMEAR_ARTS[artName]
  if (!base) return undefined
  return { ...base, ...(helmet ? KNIGHT_HELMET_SMEAR_ARC[artName] : undefined) } as ContactSmearDef
}

// 騎士の薙ぎは連の2拍目以降だけ溜めの絵が違う (boss_pose_timeline.ts comboNoNeutralImage → lanceSweep_linkWindup) ので、
//   弧もその拍だけ低い構えから振り上げる形 (SMEAR_ARTS.lanceSweep_contact_link) へ替える。絵の選び方と同じ条件。
export function knightSweepSmearArt(boss: Pick<Boss, 'id' | 'currentString' | 'beatIndex'>, contactImage: string): string {
  if (boss.id !== 'vigil-knight' || contactImage !== 'lanceSweep_contact' || getKnightSweepLink() === 'windup') return contactImage
  return boss.currentString && (boss.beatIndex ?? 0) > 0 ? 'lanceSweep_contact_link' : contactImage
}

// 2026-09-05〜09-12 朝の騎士の薙ぎの弧 (接触の 90ms 前から掃く)。09-12 に drawKnightSweepTrail へ置き換え、
//   09-27 に上の lanceSweep_contact へ置き換えた。比較の記録として定義だけ残す (描画経路からは呼ばない・常時ルール4)。
export const KNIGHT_SWEEP_SMEAR_V1: ContactSmearArc = {
  kind: 'arc',
  anchorFwdPx: -18, anchorUpPx: 70, radiusPx: 111, widthPx: 8,
  angleFromRad: 2.131,
  angleToRad: 0.112,
  maxAlpha: 0.82, lifeMs: 160,
  sweepMs: 90,
  ribbon: true,
}

// SMEAR_ARTS のキーは原則「接触の絵の名前」だが、同じ絵で溜めの姿勢が違う候補 (斬り上げ5キー化) は
//   `<絵の名前>_5key` のような別名で持つ。番人テスト (tests/executioner_contact_smear.test.ts) はこれで絵の名前へ戻す。
export const SMEAR_ART_ALIAS_SUFFIXES = ['_5key', '_link'] as const
export function smearArtBaseImage(artName: string): string {
  for (const suffix of SMEAR_ART_ALIAS_SUFFIXES) {
    if (artName.endsWith(suffix)) return artName.slice(0, -suffix.length)
  }
  return artName
}

// DEV ライブ・ツマミ (__poseFix / __swingTrail と同じ流儀): __contactSmear['<artName>'] = 部分上書き。
function contactSmearOverride(art: string): (Partial<ContactSmearArc> & Partial<ContactSmearThrust>) | undefined {
  if (!import.meta.env.DEV) return undefined
  return (globalThis as {
    __contactSmear?: Record<string, Partial<ContactSmearArc> & Partial<ContactSmearThrust>>
  }).__contactSmear?.[art]
}

// active/comboGap/recovery を跨いで通算する経過ms (旧 executionerSwingTrailElapsedMs の comboGap 対応版)。
//   多段技は各段の active 突入で stateElapsed が 0 に戻る (boss.ts enterState) ため、
//   この関数は常に「直近の active (または続く comboGap/recovery) からの経過」を返す = 段ごとに引き直る。
function contactSmearElapsedMs(boss: Boss, attack: AttackDef): number | null {
  if (boss.state === 'active') return boss.stateElapsed * 1000
  if (boss.state === 'comboGap' || boss.state === 'recovery') return attack.activeMs + boss.stateElapsed * 1000
  // telegraph 中は「接触までの残り」を負値で返す (掃きが active 突入より前から始まる技のため)。
  //   chargeMs は resolveBossTimelinePose と同じものを使う (絵とFXの基準をズラさない。
  //   beat.chargeOverrideMs は絵の側も見ていないので、ここでも見ない)。
  if (boss.state === 'telegraph') return boss.stateElapsed * 1000 - attack.chargeMs
  return null
}

// ===== 接触スメアの層構成 (2026-08-30 redesign) =====
// 検収NG「煙っぽい・浮いている」の是正。研究出所 = Hollow Knight 系のハードエッジ三日月
//   (不透明コア+縁取り・フェードインなし・形の侵食で消す)。
//   出所 = docs/playtest/packs/2026-08-28-executioner-branch-art-fx-pack.md 第2回結果 B-2。
// 🔴 2026-08-31: arc (弧) はこの侵食セグメント方式から drawContactSmearSweep (掃き文法) へ移行した。
//   以下は thrust (SMEAR_ARTS に定義なし・実質未使用) の描画経路として、また
//   contactSmearVisibleSegments の純関数テストの対象として残す。
export const SMEAR_SEGMENTS = 32   // 🔵 2026-08-29 検収是正: 20分割+butt はセグメントの継ぎ目がブロック状に割れた (maulHold f027)。
export const SMEAR_HOLD_T = 0.30   // ここまでは侵食なし (全形保持)。以降は古い端 (p=0) から食われる。
const SMEAR_TAPER_FLOOR = 0.35   // 太さのみに掛ける taper の下限 (旧0.15→0.45→0.35。alphaには別途 0.4 の下限を掛ける)
const SMEAR_LINE_COLOR = '#e8e4f2'       // 薄い灰藤の一本線 (モック _確認用/208 の INK と同値)

// ===== 掃き文法 (2026-08-31・drawDownswingArc tone='steel' の移植) =====
// ユーザー裁定「振り下ろしのFXが結構いい感じ。同じようにできないの？」を受けて、arc の描画を
//   「絵が出たら描く」から「接触へ向けて掃き切る」へ変更。drawBossContactSmear / drawContactSmearArc /
//   drawContactSmearSweep がこの文法を実装する (thrust は対象外＝現状未使用のまま)。
export const SMEAR_SWEEP_N = 18   // 弧の分割数 (drawDownswingArc steel と同じ N)
export const SMEAR_FADE_MS = 190  // 掃き切り (tC) 後のフェードアウト長さ。q=(elapsed-tC)/SMEAR_FADE_MS、fade=(1-q)²

// 純関数化 (テスト用): tC (掃き切り時刻ms) と経過ms から掃き進捗 p (0..1・easeIn) と
//   減衰 fade (0..1・easeOut²) を返す。寿命 (tC+SMEAR_FADE_MS) を超えたら null (描かない)。
//   drawBossContactSmear の唯一の呼び出し元。tC<=0 (contactKey.at===0 の技) は sweep=1 で即描き切る扱い。
// 🔵 2026-09-05: 第3引数 sweepMs を追加 (騎士 lanceSweep のように contact キーが active 0.0 で、
//   掃きを telegraph の終わりから始めたい技のため)。未指定なら tS=0 で従来式と厳密に一致する
//   (elapsedMs<0 で null を返す点だけが新しいが、telegraph 中に呼ばれない旧経路では起きなかった)。
export function contactSmearSweepState(
  tC: number, elapsedMs: number, sweepMs?: number,
): { p: number; fade: number } | null {
  if (elapsedMs > tC + SMEAR_FADE_MS) return null
  const tS = sweepMs === undefined ? 0 : tC - sweepMs
  if (elapsedMs < tS) return null                       // 掃き始める前 = まだ描かない
  const sweep = tC > tS ? Math.min(1, Math.max(0, (elapsedMs - tS) / (tC - tS))) : 1
  const p = sweep * sweep
  const q = Math.max(0, (elapsedMs - tC) / SMEAR_FADE_MS)
  const fade = (1 - q) * (1 - q)
  return { p, fade }
}

// 🔵 2026-09-27 (騎士 lanceSweep): 接触の絵が出てから描く掃き方の純関数 (ContactSmearArc.afterContact)。
//   p = 先端 (0..1・円弧上の位置)、p0 = 古い側の端 (消えながら先端側へ縮む)、fade = 濃さ。
//   接触より前 (elapsedMs < tC) と寿命 (holdMs+fadeMs) 以降は null = 描かない。fade は寿命の終わりで 0 に届く (型②)。
export function contactSmearAfterContactState(
  tC: number, elapsedMs: number, a: ContactSmearAfterContact,
): { p0: number; p: number; fade: number } | null {
  const e = elapsedMs - tC
  if (!(e >= 0) || e >= a.holdMs + a.fadeMs) return null
  const r = a.revealMs > 0 ? Math.min(1, e / a.revealMs) : 1
  const p = a.fromP + (1 - a.fromP) * (1 - (1 - r) * (1 - r))   // easeOut: 最初のコマで大きく伸びる
  const q = a.fadeMs > 0 ? Math.max(0, (e - a.holdMs) / a.fadeMs) : 0
  const fade = (1 - q) * (1 - q)
  const p0 = Math.min(p, 0.9 * q)   // 消え際は古い側から食われ、最後は穂先の近くだけが残る
  return { p0, p, fade }
}

// 🔴 2026-08-31 退役: 3層ハードエッジ (縁取り+不透明コア+先端ハイライト) はユーザー検収で
//   「エフェクト過ぎ」とNG (_確認用/208 モックシート・案A「細い一本線」を採用)。
//   drawContactSmearSegments は SMEAR_LINE_COLOR の1パスへ縮小した。既存資産は削除しない
//   (常時ルール4) が、TS の noUnusedLocals がビルドを止めるためコメントアウトで残す
//   (strokeSmearLayerSegment 自体は1パス版でも使うので生かしたまま)。
// const SMEAR_RIM_COLOR = '#3a0a5a'        // 深紫の縁取り (CANNON_BRIDGE_DEEP と同値)
// const SMEAR_CORE_COLOR = '#d8d0e4'       // 明るい灰藤のコア
// const SMEAR_HIGHLIGHT_COLOR = '#f0eaf8'  // 先端ハイライト
// const SMEAR_HIGHLIGHT_ALPHA = 0.4
// const SMEAR_HIGHLIGHT_MIN_P = 0.75       // 先端寄り (p1>=0.75) のセグメントだけ光らせる
// const SMEAR_RIM_EXTRA_WIDTH = 5          // 縁取りはコア太さ+5px

type ContactSmearSegment = { p0: number; p1: number; taper: number }

// 寿命 t (0..1) から「まだ残っているセグメント」の一覧を返す純粋関数。
//   保持窓 (t<SMEAR_HOLD_T) は全32分割、以降は古い端から侵食進捗 tE ぶん食われる。
//   canvas から分離してテストしやすくしてある (drawContactSmearSegments が唯一の呼び出し元)。
export function contactSmearVisibleSegments(t: number): ContactSmearSegment[] {
  if (t >= 1) return []
  const tE = t < SMEAR_HOLD_T ? 0 : (t - SMEAR_HOLD_T) / (1 - SMEAR_HOLD_T)
  const segs: ContactSmearSegment[] = []
  for (let i = 0; i < SMEAR_SEGMENTS; i += 1) {
    const p0 = i / SMEAR_SEGMENTS
    const p1 = (i + 1) / SMEAR_SEGMENTS
    if (p1 <= tE) continue   // 古い端から消費済み = もう描かない
    const a0 = Math.max(p0, tE)
    const taper = SMEAR_TAPER_FLOOR + (1 - SMEAR_TAPER_FLOOR) * p1   // 先端 (p→1) ほど太い
    segs.push({ p0: a0, p1, taper })
  }
  return segs
}

// 単色・単太さの1ストローク。strokeSwingSegment (退役トレイル/downswing_arc 共有) とは別の
//   新ヘルパー: あちらは「太い低α+細い中α」の固定2度描きで層ごとの色分けができないため。
function strokeSmearLayerSegment(
  ctx: CanvasRenderingContext2D,
  from: { x: number; y: number }, to: { x: number; y: number },
  widthPx: number, color: string, alpha: number,
): void {
  if (alpha <= 0 || widthPx <= 0) return
  ctx.strokeStyle = color
  ctx.lineWidth = widthPx
  ctx.globalAlpha = alpha
  ctx.beginPath()
  ctx.moveTo(from.x, from.y)
  ctx.lineTo(to.x, to.y)
  ctx.stroke()
}

// 🔴 2026-08-31 退役: 縁取り→コア→先端ハイライトの3パスはユーザー検収で「エフェクト過ぎ」NG
//   (_確認用/208 モックシート・案A「細い一本線」を採用)。旧実装は削除せず残す (常時ルール4)。
// function drawContactSmearSegments3Layer(
//   ctx: CanvasRenderingContext2D,
//   widthPx: number, maxAlpha: number,
//   t: number,   // 0..1 (寿命に対する経過)
//   pointAt: (p: number) => { x: number; y: number },
// ): void {
//   const segs = contactSmearVisibleSegments(t)
//   if (segs.length === 0) return
//   ctx.globalCompositeOperation = 'source-over'
//   for (const seg of segs) {
//     const coreWidth = widthPx * seg.taper
//     strokeSmearLayerSegment(ctx, pointAt(seg.p0), pointAt(seg.p1), coreWidth + SMEAR_RIM_EXTRA_WIDTH, SMEAR_RIM_COLOR, maxAlpha)
//   }
//   for (const seg of segs) {
//     const coreWidth = widthPx * seg.taper
//     strokeSmearLayerSegment(ctx, pointAt(seg.p0), pointAt(seg.p1), coreWidth, SMEAR_CORE_COLOR, maxAlpha)
//   }
//   ctx.globalCompositeOperation = 'lighter'
//   for (const seg of segs) {
//     if (seg.p1 < SMEAR_HIGHLIGHT_MIN_P) continue
//     const coreWidth = widthPx * seg.taper
//     strokeSmearLayerSegment(ctx, pointAt(seg.p0), pointAt(seg.p1), coreWidth * 0.35, SMEAR_HIGHLIGHT_COLOR, SMEAR_HIGHLIGHT_ALPHA)
//   }
//   ctx.globalCompositeOperation = 'source-over'
// }

// 案A: 細い一本線の1パス。太さと alpha の両方に taper (=seg.p1) で勾配を掛ける
//   (面と違い線は勾配が無いと針金に見えるため、alpha にも掛ける＝3層版との違い)。
function drawContactSmearSegments(
  ctx: CanvasRenderingContext2D,
  widthPx: number, maxAlpha: number,
  t: number,   // 0..1 (寿命に対する経過)
  pointAt: (p: number) => { x: number; y: number },
): void {
  const segs = contactSmearVisibleSegments(t)
  if (segs.length === 0) return
  ctx.globalCompositeOperation = 'source-over'
  for (const seg of segs) {
    const lineWidth = widthPx * seg.taper
    const alpha = maxAlpha * (0.4 + 0.6 * seg.p1)
    strokeSmearLayerSegment(ctx, pointAt(seg.p0), pointAt(seg.p1), lineWidth, SMEAR_LINE_COLOR, alpha)
  }
}

// タイムラインの手続きチャンネル (offset/scale/rot) をスメアの描画点へ適用する変換。
//   sprites.ts drawBossSprite の CTM (translate(pivot)→scale(facingMul,1)→rotate(rotationRad)→
//   translate(-pivot)、呼び出し順は sprites.ts:2215-2227) を screen 空間の点に対して直接
//   再現したもの。facingMul の定義は SOURCE_FACING (sprites.ts:119-138) と完全に同じ規約。
//   offsetX/offsetY の向きは既存の executionerCannonMuzzle (本ファイル、dir*(前方位置+offsetX) /
//   offsetYはそのまま加算) と同じ扱いを踏襲。ピボットは足元 (boss.x, boss.y)。
export function applyPoseMotionToSmearPoint(
  pt: { x: number; y: number }, boss: Boss, motion: BossPoseMotion, dir: number,
): { x: number; y: number } {
  const pivot = { x: boss.x, y: boss.y }
  let dx = pt.x - pivot.x
  let dy = pt.y - pivot.y
  // ① スケール (画面dx/dyへ直接掛けられる: facingMulは±1なので符号と可換)
  dx *= motion.scaleX
  dy *= motion.scaleY
  // ② 回転 (sprites.ts と同じ facingMul・回転規約)
  const sourceFacing = SOURCE_FACING[boss.id] ?? 'right'
  const facingMul: 1 | -1 = boss.facing === sourceFacing ? 1 : -1
  const rad = (motion.rot * Math.PI) / 180
  const cos = Math.cos(rad)
  const sin = Math.sin(rad)
  const rx = dx * cos - facingMul * dy * sin
  const ry = facingMul * dx * sin + dy * cos
  // ③ 平行移動 (executionerCannonMuzzle と同じ規約)
  return {
    x: pivot.x + rx + dir * motion.offsetX,
    y: pivot.y + ry + motion.offsetY,
  }
}

// 弧が振りと同期して掃かれ、接触の瞬間に描き切る文法 (drawDownswingArc tone='steel'・8991行付近・
//   合格済みFX からの移植)。三日月の面 (掃いた領域のうすい残光) + 刃先の軌跡 (尾細く淡い→先端太く明るい
//   +shadowBlur)。pts/inner は呼び出し側で contact キー authored 値の姿勢変位を適用済み (FXの間じゅう固定)。
function drawContactSmearSweep(
  ctx: CanvasRenderingContext2D,
  pts: { x: number; y: number }[], inner: { x: number; y: number }[],
  totalSegments: number, fade: number,
): void {
  const k = pts.length - 1
  if (k < 1 || fade <= 0) return
  ctx.globalCompositeOperation = 'lighter'
  // 三日月の面
  ctx.globalAlpha = 0.10 * fade
  ctx.fillStyle = PALETTE.fxSilver
  ctx.beginPath()
  ctx.moveTo(pts[0]!.x, pts[0]!.y)
  for (let i = 1; i <= k; i += 1) ctx.lineTo(pts[i]!.x, pts[i]!.y)
  for (let i = k; i >= 0; i -= 1) ctx.lineTo(inner[i]!.x, inner[i]!.y)
  ctx.closePath()
  ctx.fill()
  // 刃先の軌跡
  for (let i = 0; i < k; i += 1) {
    const seg = (i + 1) / totalSegments
    ctx.globalAlpha = fade * (0.06 + 0.42 * seg)
    ctx.strokeStyle = PALETTE.fxSilver
    ctx.lineWidth = 2 + 9 * seg
    ctx.shadowColor = PALETTE.fxSilver
    ctx.shadowBlur = 10 * fade * seg
    ctx.beginPath()
    ctx.moveTo(pts[i]!.x, pts[i]!.y)
    ctx.lineTo(pts[i + 1]!.x, pts[i + 1]!.y)
    ctx.stroke()
  }
}

// 介錯の振りの跡 (2026-10-29 作者 q1「AI に任せる」): 白い線の代わりに、筆で掃いたぶれの絵 (exec_fx_mats の swing_*) を
//   弧に沿わせて置く。絵の弦 (尾→先) を弧の弦 (振り始め→いまの刃先) に重ね、膨らみは弧の外側へ向け、
//   膨らみの深さは弧の深さに合わせる。振り切るまでは濃い1コマ目、消えながら 2〜4コマ目 (ほどけて粒になる) へ。
//   弦・膨らみの値は絵から測った (scripts/slice_exec_fx_mats.py で切った swing_*_0)。
type ExecSwingKind = 'down' | 'sweep'
const EXEC_SWING_CHORD: Record<ExecSwingKind, { ax: number; ay: number; bx: number; by: number; sag: number }> = {
  // 尾 (A) = 先に消える側・頭 (B) = 最後まで残る濃い側。sag = 弦 A→B の左手側 (-dy, dx) への膨らみ ÷ 弦の長さ。
  down: { ax: 0.153, ay: 0.238, bx: 0.746, by: 0.895, sag: 0.116 },
  sweep: { ax: 0.875, ay: 0.619, bx: 0.095, by: 0.317, sag: -0.129 },
}
const EXEC_SWING_RGB = '226,230,238'
function drawExecSwingBrush(
  ctx: CanvasRenderingContext2D, kind: ExecSwingKind, pts: readonly { x: number; y: number }[],
  center: { x: number; y: number }, p: number, fade: number, alpha: number,
): void {
  if (fade <= 0) return
  const img = swingSprite(kind, p < 1 ? 0 : Math.min(3, Math.floor((1 - fade) * 4)))
  if (!img) return
  // 控えめ版 (?execSwing=lite): 三日月の厚みを前の白い弧ほどに絞り、濃さも半分ほどにする。
  const lite = execSwingLite()
  drawSwingArtOnArc(ctx, tinted(img, EXEC_SWING_RGB), img.naturalWidth, img.naturalHeight, EXEC_SWING_CHORD[kind], pts, center,
    alpha * fade * (lite ? 0.5 : 1), lite ? 0.3 : 0.55, lite ? 0.45 : 1.6, 'source-over')
}

/** 振りの跡の絵を弧に沿わせて置く (絵の弦 A→B を弧の弦 pts[0]→末尾へ・膨らみは中心から外へ・厚みは弧の深さに合わせ thickMin..thickMax)。 */
function drawSwingArtOnArc(
  ctx: CanvasRenderingContext2D, src: CanvasImageSource, w: number, h: number,
  g: { ax: number; ay: number; bx: number; by: number; sag: number },
  pts: readonly { x: number; y: number }[], center: { x: number; y: number },
  alpha: number, thickMin: number, thickMax: number, op: GlobalCompositeOperation,
): void {
  const T = pts[0]!, H = pts[pts.length - 1]!
  const fx = H.x - T.x, fy = H.y - T.y
  const chord = Math.hypot(fx, fy)
  if (chord < 12 || alpha <= 0.01) return
  const Ax = g.ax * w, Ay = g.ay * h
  const ex0 = g.bx * w - Ax, ey0 = g.by * h - Ay
  const L = Math.hypot(ex0, ey0)
  const e1x = ex0 / L, e1y = ey0 / L
  const e2x = -e1y, e2y = e1x
  const f1x = fx / chord, f1y = fy / chord
  const f2x = -f1y, f2y = f1x
  // 弧の深さ (弦の中点から弧の真ん中の点まで) と、弧の外側 (中心から離れる側) の向き。
  const mid = pts[Math.floor(pts.length / 2)]!
  const arcSag = Math.abs((mid.x - T.x) * f2x + (mid.y - T.y) * f2y)
  const outward = ((T.x + H.x) / 2 - center.x) * f2x + ((T.y + H.y) / 2 - center.y) * f2y
  const s = (g.sag >= 0 ? 1 : -1) * (outward >= 0 ? 1 : -1)
  const k = chord / L
  const thick = Math.max(thickMin, Math.min(thickMax, arcSag / Math.max(1, Math.abs(g.sag) * L * k)))
  const a = k * (f1x * e1x + thick * s * f2x * e2x)
  const c = k * (f1x * e1y + thick * s * f2x * e2y)
  const b = k * (f1y * e1x + thick * s * f2y * e2x)
  const d = k * (f1y * e1y + thick * s * f2y * e2y)
  ctx.save()
  ctx.globalCompositeOperation = op
  ctx.globalAlpha = Math.min(1, alpha)
  ctx.transform(a, b, c, d, T.x - (a * Ax + c * Ay), T.y - (b * Ax + d * Ay))
  ctx.drawImage(src, 0, 0, w, h)
  ctx.restore()
}

function drawContactSmearArc(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: ContactSmearArc, p: number, fade: number, boss: Boss, motion: BossPoseMotion,
  brush?: ExecSwingKind,
): void {
  if (fade <= 0) return
  const rawPointAt = (frac: number): { x: number; y: number } =>
    swingTrailPoint(anchor, mirror, def.radiusPx, def.angleFromRad + (def.angleToRad - def.angleFromRad) * frac)
  const k = Math.max(1, Math.round(p * SMEAR_SWEEP_N))
  const rawPts = Array.from({ length: k + 1 }, (_, i) => rawPointAt((i / k) * p))
  if (brush) {
    const pts = rawPts.map((pt) => applyPoseMotionToSmearPoint(pt, boss, motion, mirror))
    drawExecSwingBrush(ctx, brush, pts, applyPoseMotionToSmearPoint(anchor, boss, motion, mirror), p, fade, def.maxAlpha)
    return
  }
  // 内側の点列 = 各点を anchor へ45%寄せた点 (三日月の裏側)。姿勢変位を掛ける前の raw 空間で計算する。
  const rawInner = rawPts.map((pt) => ({ x: pt.x + (anchor.x - pt.x) * 0.45, y: pt.y + (anchor.y - pt.y) * 0.45 }))
  const pts = rawPts.map((pt) => applyPoseMotionToSmearPoint(pt, boss, motion, mirror))
  const inner = rawInner.map((pt) => applyPoseMotionToSmearPoint(pt, boss, motion, mirror))
  if (def.ribbon) {
    drawSweepRibbon(ctx, pts, inner, def.widthPx * Math.min(1, p * 4) * Math.sqrt(fade), def.maxAlpha * fade, PALETTE.fxSilver)
    return
  }
  // 🔵 2026-08-31 検収是正: 掃き文法 (lighter 加算) では 'round' が継ぎ目の重なりを二重に光らせ
  //   「玉の連なり」に割れた (_確認用/215)。本家 drawDownswingArc と同じ既定 (butt) に合わせる。
  //   🔴 旧「butt は継ぎ目が割れる (2026-08-29)」は通常合成の旧文法での話 = ここへは持ち出さない。
  ctx.lineCap = 'butt'
  drawContactSmearSweep(ctx, pts, inner, SMEAR_SWEEP_N, fade)
}

// 🔵 2026-09-27 (騎士 lanceSweep): afterContact の弧。drawContactSmearSweep と同じ文法 (三日月の面 + 先端ほど太く明るい
//   軌跡・加算) を、①古い側 p0 から先端 p までの区間 ②色の指定 ③先端の太さ = def.widthPx で描く。
//   太さと明るさは「弧の上の絶対位置」で決める = 消え際に古い側が食われても、太く明るいのは常に穂先側。
function drawContactSmearAfterContactArc(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: ContactSmearArc, p0: number, p: number, fade: number, boss: Boss, motion: BossPoseMotion,
): void {
  if (fade <= 0 || p - p0 <= 1e-4) return
  const k = Math.max(2, Math.round((p - p0) * SMEAR_SWEEP_N * 1.5))
  const fracs = Array.from({ length: k + 1 }, (_, i) => p0 + (p - p0) * (i / k))
  const rawPts = fracs.map((f) =>
    swingTrailPoint(anchor, mirror, def.radiusPx, def.angleFromRad + (def.angleToRad - def.angleFromRad) * f))
  // 面の裏側は anchor へ 30% 寄せた点 (横一閃の 45% より薄い = 槍は刃より細い)。
  const rawInner = rawPts.map((pt) => ({ x: pt.x + (anchor.x - pt.x) * 0.3, y: pt.y + (anchor.y - pt.y) * 0.3 }))
  const pts = rawPts.map((pt) => applyPoseMotionToSmearPoint(pt, boss, motion, mirror))
  const inner = rawInner.map((pt) => applyPoseMotionToSmearPoint(pt, boss, motion, mirror))
  const core = def.coreColor ?? PALETTE.fxSilver
  const glow = def.glowColor ?? core
  ctx.globalCompositeOperation = 'lighter'
  ctx.lineCap = 'butt'
  // 三日月の面は弧の後半 (振り終わり側・w≥0.5) にだけ薄く塗る。
  //   ✗ 区間の 35% から塗った初版は、出だしのコマで頭上に灰色の板が浮いて見えた (09-27 ラボ撮影)。
  const faceFrom = Math.max(0, fracs.findIndex((f) => f >= 0.5))
  if (faceFrom < k) {
  ctx.globalAlpha = 0.08 * fade
  ctx.fillStyle = glow
  ctx.beginPath()
  ctx.moveTo(pts[faceFrom]!.x, pts[faceFrom]!.y)
  for (let i = faceFrom + 1; i <= k; i += 1) ctx.lineTo(pts[i]!.x, pts[i]!.y)
  for (let i = k; i >= faceFrom; i -= 1) ctx.lineTo(inner[i]!.x, inner[i]!.y)
  ctx.closePath()
  ctx.fill()
  }
  // 穂先の軌跡: w = 弧の上の位置 (0=構えの穂先 / 1=振り終わりの穂先)。
  ctx.strokeStyle = core
  ctx.shadowColor = glow
  for (let i = 0; i < k; i += 1) {
    const w = fracs[i + 1]!
    ctx.globalAlpha = def.maxAlpha * fade * (0.08 + 0.92 * w * w)
    ctx.lineWidth = 1.2 + (def.widthPx - 1.2) * w * w
    ctx.shadowBlur = 9 * fade * w
    ctx.beginPath()
    ctx.moveTo(pts[i]!.x, pts[i]!.y)
    ctx.lineTo(pts[i + 1]!.x, pts[i + 1]!.y)
    ctx.stroke()
  }
  ctx.shadowBlur = 0
}

// 騎士の薙ぎの弧を筆のぶれの絵で描く比較版 (10-31・開発版 ?knightArc=brush・src/knight_arc_brush.ts)。
//   古い側 p0 から穂先 p までの区間を、介錯の横の薙ぎの絵 (sweep) で置く。置き方は drawExecSwingBrush のまま。
function drawContactSmearAfterContactBrush(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: ContactSmearArc, p0: number, p: number, fade: number, boss: Boss, motion: BossPoseMotion,
): void {
  if (fade <= 0 || p - p0 <= 1e-4) return
  drawExecSwingBrush(ctx, 'sweep', afterContactArcPoints(anchor, mirror, def, p0, p, boss, motion),
    applyPoseMotionToSmearPoint(anchor, boss, motion, mirror), p, fade, def.maxAlpha)
}

function afterContactArcPoints(
  anchor: { x: number; y: number }, mirror: number, def: ContactSmearArc, p0: number, p: number,
  boss: Boss, motion: BossPoseMotion,
): { x: number; y: number }[] {
  const k = Math.max(2, Math.round((p - p0) * SMEAR_SWEEP_N * 1.5))
  return Array.from({ length: k + 1 }, (_, i) => applyPoseMotionToSmearPoint(
    swingTrailPoint(anchor, mirror, def.radiusPx, def.angleFromRad + (def.angleToRad - def.angleFromRad) * (p0 + (p - p0) * (i / k))),
    boss, motion, mirror))
}

// 騎士の槍の跡 (10-31・作者の答え C・配布版の既定・src/knight_arc_brush.ts): Codex が描いた槍の跡の絵
//   (外の縁＝鋼の穂先の硬い刃の筋・内側＝木の柄が押しのけた灰のぶれ) を、古い側 p0 から穂先 p までの弧に沿わせて置く。
//   コマは振る間 0→1、振り切った後は消えるにつれ 1→2→3 (古い側から千切れる)。絵の厚みはほぼそのまま (弧の深さで 0.7〜1.15 倍)。
//   黒地の絵を白＋アルファにしたマスクを鋼の銀で塗り、前の弧と同じく加算で置く。
const KNIGHT_ARC_RGB = '222,228,240'
function drawContactSmearAfterContactArt(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: ContactSmearArc, p0: number, p: number, fade: number, boss: Boss, motion: BossPoseMotion,
): void {
  if (fade <= 0 || p - p0 <= 1e-4) return
  const frame = knightArcFrame(p, fade)
  const img = knightArcSprite(frame)
  if (!img) return
  drawSwingArtOnArc(ctx, tinted(img, KNIGHT_ARC_RGB), img.naturalWidth, img.naturalHeight, KNIGHT_ARC_CHORD[frame]!,
    afterContactArcPoints(anchor, mirror, def, p0, p, boss, motion), applyPoseMotionToSmearPoint(anchor, boss, motion, mirror),
    def.maxAlpha * Math.sqrt(fade), 0.7, 1.15, 'lighter')
}

// 剣舞の斬りの跡 (2026-10-20 v4): 刃先の通った弧の上に火花を散らす。線は引かない (等間隔に並べると点線に見える)。
//   粒は刃先の側に多く、古い側はまばら。消えるにつれ弧の外へ飛び、少し落ちる。
function drawContactSmearSparks(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: ContactSmearArc, p0: number, p: number, fade: number, boss: Boss, motion: BossPoseMotion,
): void {
  if (fade <= 0 || p - p0 <= 1e-4) return
  const core = def.coreColor ?? PALETTE.fxSilver
  const glow = def.glowColor ?? core
  const drift = 1 - Math.sqrt(fade)   // 0 → 1 へ、消えながら外へ飛ぶ
  const rand = (i: number, salt: number): number => { const h = Math.sin(i * salt) * 43758.5453; return h - Math.floor(h) }
  const n = def.petals ? 20 : 34   // 花びらを出す時は、弧の上の粒を減らして花びらを主役にする
  ctx.globalCompositeOperation = 'lighter'
  ctx.shadowColor = glow
  for (let i = 1; i <= n; i += 1) {
    const r1 = rand(i, 91.37), r2 = rand(i, 12.9898), r3 = rand(i, 57.31)
    const w = 1 - r1 * r1 * 0.95   // 刃先 (1) の側に多く
    if (w < p0 || w > p) continue
    const a = def.angleFromRad + (def.angleToRad - def.angleFromRad) * w
    const rad = def.radiusPx + (r2 - 0.5) * 22 * (0.4 + w) + drift * (8 + 26 * r3)
    const pt = swingTrailPoint(anchor, mirror, rad, a)
    pt.y += drift * drift * 14 * r2   // 少し落ちる
    const head = applyPoseMotionToSmearPoint(pt, boss, motion, mirror)
    const size = (1.3 + 2.8 * w * w) * (0.6 + 0.8 * r3) * (def.widthPx / 6)
    ctx.globalAlpha = def.maxAlpha * fade * (0.3 + 0.7 * w) * (0.6 + 0.4 * r2)
    ctx.shadowBlur = 7 * fade * w
    ctx.fillStyle = r3 > 0.7 ? glow : core
    ctx.beginPath()
    ctx.arc(head.x, head.y, size * 0.6, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.shadowBlur = 0
  if (def.petals) drawContactSmearPetals(ctx, anchor, mirror, def, def.petals, p, fade, boss, motion)
}

// 剣先の軌跡 (2026-10-21 剣舞 v6)。弧の外の縁 = 剣先の通り道で、帯は内側 (体の側) へ太る。
//   太さと明るさは弧の上の位置 w で決める (0 = 振り始め・細く暗い / 1 = 剣先・太く明るい)。星・火花・花びらは出さない。
function drawContactSmearTrail(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: ContactSmearArc, p0: number, p: number, fade: number, boss: Boss, motion: BossPoseMotion,
): void {
  if (fade <= 0 || p - p0 <= 1e-4) return
  const core = def.coreColor ?? PALETTE.fxSilver
  const glow = def.glowColor ?? core
  const maxW = def.trailWidthPx ?? Math.max(10, def.radiusPx * 0.16)
  const k = Math.max(4, Math.round((p - p0) * SMEAR_SWEEP_N * 2))
  const span = def.angleToRad - def.angleFromRad
  // 見た目の重み: 振り始め (w=0) でも trailHeadStart の分は残す。
  const head = def.trailHeadStart ?? 0
  const vis = (w: number): number => head + (1 - head) * w
  type Pt = { x: number; y: number }
  // lag = 弧の上で後ろへずらす量 (残像)・inset = 内側へ寄せる量 (px)・widthScale = 太さの倍率。
  const band = (lag: number, inset: number, widthScale: number): { outer: Pt[]; inner: Pt[]; ws: number[] } => {
    const outer: Pt[] = [], inner: Pt[] = [], ws: number[] = []
    for (let i = 0; i <= k; i += 1) {
      const w = Math.max(0, p0 + (p - p0) * (i / k) - lag)
      const a = def.angleFromRad + span * w
      const th = maxW * widthScale * Math.pow(vis(w), 1.6)
      outer.push(applyPoseMotionToSmearPoint(swingTrailPoint(anchor, mirror, def.radiusPx - inset, a), boss, motion, mirror))
      inner.push(applyPoseMotionToSmearPoint(swingTrailPoint(anchor, mirror, Math.max(4, def.radiusPx - inset - th), a), boss, motion, mirror))
      ws.push(w)
    }
    return { outer, inner, ws }
  }
  const fill = (b: { outer: Pt[]; inner: Pt[] }, color: string, alpha: number): void => {
    if (alpha <= 0) return
    ctx.globalAlpha = alpha
    ctx.fillStyle = color
    ctx.beginPath()
    ctx.moveTo(b.outer[0]!.x, b.outer[0]!.y)
    for (let i = 1; i <= k; i += 1) ctx.lineTo(b.outer[i]!.x, b.outer[i]!.y)
    for (let i = k; i >= 0; i -= 1) ctx.lineTo(b.inner[i]!.x, b.inner[i]!.y)
    ctx.closePath()
    ctx.fill()
  }
  const a0 = def.maxAlpha * fade
  const main = band(0, 0, 1)
  ctx.globalCompositeOperation = 'lighter'
  ctx.shadowColor = glow
  if (def.trail === 'glass') {
    ctx.shadowBlur = 12 * fade
    fill(main, glow, 0.34 * a0)
    ctx.shadowBlur = 0
    fill(band(0, maxW * 0.18, 0.55), core, 0.16 * a0)
    // 切子の筋: 外の縁と内の縁を斜めに結ぶ (剣先の側ほど濃い)。
    ctx.strokeStyle = core
    ctx.lineWidth = 1
    for (let i = 0; i < k; i += 1) {
      const w = vis(main.ws[i + 1]!)
      const from = i % 2 === 0 ? main.outer[i]! : main.inner[i]!
      const to = i % 2 === 0 ? main.inner[i + 1]! : main.outer[i + 1]!
      ctx.globalAlpha = 0.5 * a0 * w * w
      ctx.beginPath()
      ctx.moveTo(from.x, from.y)
      ctx.lineTo(to.x, to.y)
      ctx.stroke()
    }
  } else {
    // 残像: 遅れた薄い帯2本 → 本体の帯の順に重ねる。
    ctx.shadowBlur = 0
    fill(band(0.16, maxW * 0.35, 0.8), glow, 0.16 * a0)
    fill(band(0.08, maxW * 0.18, 0.9), glow, 0.24 * a0)
    ctx.shadowBlur = 14 * fade
    fill(main, glow, 0.42 * a0)
    ctx.shadowBlur = 0
    fill(band(0, 0, 0.45), core, 0.32 * a0)
  }
  if (def.ghostBlades) drawContactSmearGhostBlades(ctx, anchor, mirror, def, def.ghostBlades, p0, p, a0, boss, motion)
  // 剣先の縁: 振り始めは細く消え、剣先の側ほど太く明るい。
  ctx.strokeStyle = core
  ctx.lineCap = 'butt'
  for (let i = 0; i < k; i += 1) {
    const w = vis(main.ws[i + 1]!)
    ctx.globalAlpha = a0 * (0.05 + 0.95 * w * w)
    ctx.lineWidth = 0.8 + 2.6 * w * w
    ctx.shadowBlur = 8 * fade * w
    ctx.beginPath()
    ctx.moveTo(main.outer[i]!.x, main.outer[i]!.y)
    ctx.lineTo(main.outer[i + 1]!.x, main.outer[i + 1]!.y)
    ctx.stroke()
  }
  ctx.shadowBlur = 0
  ctx.globalCompositeOperation = 'source-over'
}

// 剣の形の影 (10-27 剣舞アルレ版の引き戻し・案 c)。剣先の通った所に、進む向きへ伸びる細い剣の形を薄く置く (新しいほど濃い)。
//   線ではなく、剣先で尖り柄の側が太い面で描く (白い効果線は不採用 = 10-10 作者)。
function drawContactSmearGhostBlades(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number, def: ContactSmearArc,
  g: { count: number; lenPx: number }, p0: number, p: number, a0: number, boss: Boss, motion: BossPoseMotion,
): void {
  const span = def.angleToRad - def.angleFromRad
  const sgn = span >= 0 ? 1 : -1
  const glow = def.glowColor ?? def.coreColor ?? PALETTE.fxSilver
  const core = def.coreColor ?? PALETTE.fxSilver
  const shape = (tip: { x: number; y: number }, hilt: { x: number; y: number }, n: { x: number; y: number }, half: number): void => {
    ctx.beginPath()
    ctx.moveTo(tip.x, tip.y)
    ctx.lineTo(hilt.x + n.x * half, hilt.y + n.y * half)
    ctx.lineTo(hilt.x - n.x * half, hilt.y - n.y * half)
    ctx.closePath()
    ctx.fill()
  }
  for (let j = 0; j < g.count; j += 1) {
    const w = p - j * 0.22
    if (w < p0 || w < 0) break
    const a = def.angleFromRad + span * w
    const tip = applyPoseMotionToSmearPoint(swingTrailPoint(anchor, mirror, def.radiusPx, a), boss, motion, mirror)
    // 進む向き (弧の接線)。引き戻しは柄が先に進み、剣先が後ろについてくる = 剣は剣先から進む向きへ伸びる。
    const dir = { x: -Math.sin(a) * sgn * mirror, y: -Math.cos(a) * sgn }
    const n = { x: -dir.y, y: dir.x }
    const hilt = { x: tip.x + dir.x * g.lenPx, y: tip.y + dir.y * g.lenPx }
    const alpha = a0 * (j === 0 ? 0.55 : j === 1 ? 0.32 : 0.18)
    ctx.globalAlpha = alpha
    ctx.fillStyle = glow
    ctx.shadowColor = glow
    ctx.shadowBlur = 10
    shape(tip, hilt, n, 3.2)
    ctx.shadowBlur = 0
    ctx.globalAlpha = alpha * 0.8
    ctx.fillStyle = core
    shape(tip, hilt, n, 1.1)
  }
}

// 2本の剣の通り道が交わる点の閃き (10-27 剣舞アルレ版の引き戻し)。光の芯がふくらんで消え、2本の向きに沿った菱形が X に開く。
//   u = 0 (閃いた瞬間) → 1 (消える)。d1・d2 = 2本の通り道の向き (画面の単位ベクトル)。
const CROSS_GLINT_MS = 180
function drawContactSmearCrossGlint(
  ctx: CanvasRenderingContext2D, at: { x: number; y: number }, d1: { x: number; y: number }, d2: { x: number; y: number },
  size: number, u: number, core: string, glow: string,
): void {
  if (u < 0 || u >= 1) return
  const bloom = 1 - u
  const go = 1 - (1 - u) * (1 - u) * (1 - u)
  ctx.globalCompositeOperation = 'lighter'
  const r = size * (0.5 + 0.7 * go)
  const grad = ctx.createRadialGradient(at.x, at.y, 0, at.x, at.y, r)
  grad.addColorStop(0, core)
  grad.addColorStop(0.35, glow)
  grad.addColorStop(1, 'rgba(0,0,0,0)')
  ctx.globalAlpha = 0.85 * bloom
  ctx.fillStyle = grad
  ctx.beginPath()
  ctx.arc(at.x, at.y, r, 0, Math.PI * 2)
  ctx.fill()
  const len = size * (0.9 + 0.9 * go)
  const half = size * 0.09 * bloom + 1
  ctx.fillStyle = core
  ctx.shadowColor = glow
  ctx.shadowBlur = 10
  for (const d of [d1, d2]) {
    const n = { x: -d.y, y: d.x }
    ctx.globalAlpha = bloom
    ctx.beginPath()
    ctx.moveTo(at.x + d.x * len, at.y + d.y * len)
    ctx.lineTo(at.x + n.x * half, at.y + n.y * half)
    ctx.lineTo(at.x - d.x * len, at.y - d.y * len)
    ctx.lineTo(at.x - n.x * half, at.y - n.y * half)
    ctx.closePath()
    ctx.fill()
  }
  ctx.shadowBlur = 0
  ctx.globalCompositeOperation = 'source-over'
}

/** 弧の上で、足元から前 fwd px に一番近い点の向き (画面の単位ベクトル)。交わる点の閃きの菱形の向きに使う。 */
function contactSmearArcDirAt(def: ContactSmearArc, mirror: number, fwdPx: number): { x: number; y: number } {
  let best = def.angleFromRad, bestD = Infinity
  for (let i = 0; i <= 64; i += 1) {
    const a = def.angleFromRad + (def.angleToRad - def.angleFromRad) * (i / 64)
    const d = Math.abs(def.anchorFwdPx + Math.cos(a) * def.radiusPx - fwdPx)
    if (d < bestD) { bestD = d; best = a }
  }
  return { x: -Math.sin(best) * mirror, y: -Math.cos(best) }
}

// 刃の花びら (2026-10-20 剣舞 v6・部品の絵 = public/fx/blade-petals/・Codex の紙 fx.png から切り出し)。
//   刃先に光の芯が一瞬咲き、花びらが散る向きへ流れ、鏡の破片が速く短く飛ぶ。色は絵の銀と藤色のまま (赤は使わない)。
const BLADE_PETAL_IMAGES = ['petal_1', 'petal_2', 'petal_3', 'petal_4', 'petal_5', 'petal_6', 'petal_7', 'petal_8']
const BLADE_SHARD_IMAGES = ['shard_1', 'shard_2', 'shard_3', 'shard_4']
const bladePetalImgCache: Record<string, HTMLImageElement> = {}
function bladePetalImg(name: string): HTMLImageElement {
  let img = bladePetalImgCache[name]
  if (!img) { img = new Image(); img.src = `/fx/blade-petals/${name}.png`; bladePetalImgCache[name] = img }
  return img
}
/** 花びらの部品を先に読み込む (剣舞 v6 が呼ぶ・最初の1発で絵が抜けないように)。 */
export function preloadBladePetals(): void {
  if (typeof Image === 'undefined') return   // テスト (node) では読み込まない
  for (const n of [...BLADE_PETAL_IMAGES, ...BLADE_SHARD_IMAGES, 'glow_1', 'glow_2', 'glint_1']) bladePetalImg(n)
}
function drawContactSmearPetals(
  ctx: CanvasRenderingContext2D, anchor: { x: number; y: number }, mirror: number,
  def: ContactSmearArc, petals: ContactSmearPetals, p: number, fade: number, boss: Boss, motion: BossPoseMotion,
): void {
  const a = def.angleFromRad + (def.angleToRad - def.angleFromRad) * p
  const tip = applyPoseMotionToSmearPoint(swingTrailPoint(anchor, mirror, def.radiusPx, a), boss, motion, mirror)
  const u = 1 - fade                          // 0 = 当たった瞬間 → 1 = 消える
  const go = 1 - (1 - u) * (1 - u) * (1 - u)  // 出だしが速く、すぐ緩む
  const rand = (i: number, salt: number): number => { const h = Math.sin((i + petals.seed * 17.3) * salt) * 43758.5453; return h - Math.floor(h) }
  // 振りの向き (前/上) と、散る向きの基準。
  const sgn = def.angleToRad >= def.angleFromRad ? 1 : -1
  const swing = { f: -Math.sin(a) * sgn, u: Math.cos(a) * sgn }
  const base = petals.spread === 'side' ? { f: 1, u: 0.05 } : petals.spread === 'up' ? { f: 0.35, u: 1 }
    : { f: swing.f * 0.7 + 0.5, u: swing.u * 0.7 - 0.35 }
  const baseAng = Math.atan2(base.u, base.f)
  const spreadRad = petals.spread === 'side' ? 0.28 : petals.spread === 'up' ? 0.55 : 0.6
  const fall = petals.spread === 'up' ? -10 : petals.spread === 'side' ? 6 : 22   // 落ちる (負 = 舞い上がる)
  const size = petals.sizePx ?? 15
  const far = size / 15   // 大きい火花ほど遠くまで散る (10-21 作者「火花が弱い・小さい」)
  const put = (img: HTMLImageElement, x: number, y: number, w: number, rot: number, alpha: number): void => {
    if (!img.complete || img.naturalWidth === 0 || alpha <= 0) return
    const h = w * img.naturalHeight / img.naturalWidth
    ctx.save()
    ctx.globalAlpha = alpha
    ctx.translate(x, y)
    ctx.scale(mirror, 1)
    ctx.rotate(rot)
    ctx.drawImage(img, -w / 2, -h / 2, w, h)
    ctx.restore()
  }
  // 光の芯: 当たった瞬間に咲いて、すぐしぼむ。
  ctx.globalCompositeOperation = 'lighter'
  const bloom = Math.max(0, 1 - u * 2.2)
  put(bladePetalImg('glow_2'), tip.x, tip.y, size * (1.6 + 1.4 * go), 0, 0.9 * bloom)
  put(bladePetalImg('glint_1'), tip.x, tip.y, size * 0.9, -a + Math.PI / 4, bloom)
  // 花びら: ゆっくり回りながら流れる。
  ctx.globalCompositeOperation = 'source-over'
  for (let i = 0; i < petals.count; i += 1) {
    const r1 = rand(i, 12.9898), r2 = rand(i, 78.233), r3 = rand(i, 39.425)
    const ang = baseAng + (r1 - 0.5) * 2 * spreadRad
    const dist = (22 + 42 * r2) * go * far
    const lf = Math.cos(ang) * dist, lu = Math.sin(ang) * dist - fall * u * u * (0.6 + 0.8 * r3)
    const x = tip.x + lf * mirror, y = tip.y - lu
    const late = Math.max(0, (u - 0.55) / 0.45)   // 後半で消える
    const img = bladePetalImg(BLADE_PETAL_IMAGES[Math.floor(r3 * BLADE_PETAL_IMAGES.length)]!)
    put(img, x, y, size * (0.75 + 0.5 * r2) * (1 - 0.3 * u), -ang + (r1 - 0.5) * 2 + u * (r2 - 0.5) * 5, def.maxAlpha * (1 - late * late) * Math.min(1, u * 12 + 0.3))
  }
  // 鏡の破片: 花びらより速く遠く、早く消える (D の鋭さ)。
  ctx.globalCompositeOperation = 'lighter'
  const shards = Math.max(2, Math.round(petals.count / 3))
  for (let i = 0; i < shards; i += 1) {
    const r1 = rand(i + 50, 12.9898), r2 = rand(i + 50, 78.233), r3 = rand(i + 50, 39.425)
    const ang = baseAng + (r1 - 0.5) * 2 * (spreadRad + 0.35)
    const dist = (40 + 50 * r2) * Math.min(1, go * 1.4) * far
    const x = tip.x + Math.cos(ang) * dist * mirror, y = tip.y - Math.sin(ang) * dist
    const img = bladePetalImg(BLADE_SHARD_IMAGES[Math.floor(r3 * BLADE_SHARD_IMAGES.length)]!)
    put(img, x, y, size * (0.55 + 0.35 * r3), -ang + r1 * 3, def.maxAlpha * Math.max(0, 1 - u * 1.7))
  }
  ctx.globalCompositeOperation = 'source-over'
}

// 🔴 2026-08-31: sweep_slash (突き) 退役で SMEAR_ARTS に thrust 定義が無く実質未使用。
//   旧 (2026-08-30) の侵食セグメント方式のまま残す (変更不要・呼び出し元だけ legacyT を計算し直す)。
function drawContactSmearThrust(
  ctx: CanvasRenderingContext2D, origin: { x: number; y: number }, mirror: number,
  def: ContactSmearThrust, t: number, boss: Boss, motion: BossPoseMotion,
): void {
  const root = { x: origin.x + def.rootFwdPx * mirror, y: origin.y - def.rootUpPx }
  const tip = { x: origin.x + def.tipFwdPx * mirror, y: origin.y - def.tipUpPx }
  const dx = tip.x - root.x, dy = tip.y - root.y
  const len = Math.hypot(dx, dy) || 1
  const end = { x: tip.x + (dx / len) * def.extendPx, y: tip.y + (dy / len) * def.extendPx }
  const rawPointAt = (p: number): { x: number; y: number } =>
    ({ x: root.x + (end.x - root.x) * p, y: root.y + (end.y - root.y) * p })
  const pointAt = (p: number): { x: number; y: number } => applyPoseMotionToSmearPoint(rawPointAt(p), boss, motion, mirror)
  ctx.lineCap = 'round'
  drawContactSmearSegments(ctx, def.widthPx, def.maxAlpha, t, pointAt)
}

// スメアを出すボス。🔴 ここに足す = そのボスの contact キーの絵名が SMEAR_ARTS にあれば描かれる、の意味。
//   art 名はボスをまたいで衝突していない (騎士 = lanceSweep_contact 等) ので表は共有のままでよい。
export const CONTACT_SMEAR_BOSSES = new Set<string>(['the-executioner', 'vigil-knight'])

// 接触の絵に同期したスメア。findContactKey の契約キーで引く (2026-08-31 掃き文法へ移行)。
//   🔴 旧方式は「いま表示されている絵」で引いていたが、掃きは接触前 (構えの絵の間) から
//   始まる必要があり間に合わない。exec_maulDrop だけは既存の downswing_arc が担当
//   (二重描画禁止・合格済み FX)。
// 介錯の弧だけ筆のぶれの絵へ替える (縦の振り = down・横の薙ぎ = sweep)。他のボス・?execSwing=line は前の白い弧。
const EXEC_SWING_ART: Record<string, ExecSwingKind> = {
  horizontal_slash: 'sweep', sweep_contact: 'sweep',
  scoop_smear: 'down', scoop_smear_5key: 'down', overhead_contact: 'down',
}
function execSwingBrushKind(boss: Boss, artName: string): ExecSwingKind | undefined {
  if (boss.id !== 'the-executioner' || !execSwingBrushOn()) return undefined
  return EXEC_SWING_ART[artName]
}

function drawBossContactSmear(ctx: CanvasRenderingContext2D, state: GameState): void {
  const boss = state.boss
  if (state.phase !== 'playing' || !CONTACT_SMEAR_BOSSES.has(boss.id) || boss.hp <= 0) return
  if (swingTrailDisabledByQuery()) return
  const attack = boss.currentAttack
  // 発勁は衝撃波だけを保つ。縦振りの仮組みが横一閃の絵を借りても、その斬撃弧は出さない。
  if (!attack || attack.id === 'exec_maulDrop' || isExecutionerFajin(attack.id)) return
  // 騎士の薙ぎ: 09-12 版 (DEV ?knightSweep=0912) だけは本体の実描画矩形から短い残光を出す (drawKnightSweepTrail)。
  //   既定 (09-27 キーポーズ版) はこの経路で SMEAR_ARTS.lanceSweep_contact の弧を描く。
  if (boss.id === 'vigil-knight' && attack.id === 'lanceSweep' && getKnightSweepVariant() === '0912') return
  // 切り下がりの払いは薙ぎの絵を借りるが、光は横に流れる帯 (drawKnightLeapSlash・10-01 夜) = 薙ぎの弧は出さない。
  if (boss.id === 'vigil-knight' && attack.id === 'lanceCross' && getKnightLeapFx() !== 'sweep') return
  if (boss.state !== 'telegraph' && boss.state !== 'active' && boss.state !== 'comboGap' && boss.state !== 'recovery') return
  const pose = resolveBossTimelinePose(boss.id, boss)
  if (!pose) return
  const contactKey = findContactKey(pose.timeline, pose.phaseProgress.hitIndex)
  if (!contactKey) return
  // 斬り上げの5キー版 (?scoop=a|b) は溜めの刃先が後方なので、同じ接触の絵でも弧の起点が違う (SMEAR_ARTS 参照)。
  const artName = attack.id === 'exec_maulHold' && contactKey.image === 'scoop_smear'
    && getExecutionerScoopVariant() !== 'old' ? 'scoop_smear_5key' : knightSweepSmearArt(boss, contactKey.image)
  const base = SMEAR_ARTS[artName]
  if (!base) return
  const elapsedMs = contactSmearElapsedMs(boss, attack)
  if (elapsedMs === null) return
  const def = { ...base, ...(boss.id === 'vigil-knight' && knightHelmetScaleEnabled() ? KNIGHT_HELMET_SMEAR_ARC[artName] : undefined),
    ...contactSmearOverride(artName) } as ContactSmearDef

  // tC = 掃き切り時刻 (旧 startMs と同じ式・意味だけ「接触まで掃く目標時刻」へ変わった)。
  const tC = contactKey.at * attack.activeMs
  const dir = boss.facing === 'right' ? 1 : -1
  // 姿勢変位は contact キー自身の authored 値で固定 (毎フレーム pose.motion を使うと、絵が
  //   接触の絵へ切り替わる瞬間に弧が跳ぶ)。scale は 1 固定でよい (票の指示どおり)。
  const motion: BossPoseMotion = {
    offsetX: contactKey.offset?.x ?? 0, offsetY: contactKey.offset?.y ?? 0,
    scaleX: 1, scaleY: 1, rot: contactKey.rot ?? 0,
  }
  // 接触の絵が出てから描く掃き方 (騎士の薙ぎ 2026-09-27)。接触前・寿命後は描かない。
  if (def.kind === 'arc' && def.afterContact) {
    const st = contactSmearAfterContactState(tC, elapsedMs, def.afterContact)
    // 二刀で2本の剣が別の線を通る一撃 (剣舞アルレ版の引き戻し・10-27) は、<接触の絵>#2 に2本目の弧を置く。
    //   同じ時刻で描く (delayMs があればそのぶん遅れて引き始め、1本目が消えた後も描き切る)。
    const second = SMEAR_ARTS[`${artName}#2`]
    const def2 = second?.kind === 'arc' ? second : null
    const st2 = def2 ? contactSmearAfterContactState(tC + (def2.delayMs ?? 0), elapsedMs, def2.afterContact ?? def.afterContact) : null
    const glint = def2?.glint ?? def.glint
    const glintU = glint ? (elapsedMs - tC - glint.atMs) / CROSS_GLINT_MS : -1
    const glinting = glintU >= 0 && glintU < 1
    if (!st && !st2 && !glinting) return
    // DEV: 弧を描いたコマの記録 (scripts/knight_sweep_string_probe.mjs が読む・描画には影響しない)。
    if (import.meta.env.DEV && st) (globalThis as { __contactSmearProbe?: unknown }).__contactSmearProbe = { art: artName, ...st }
    if (boss.id === 'vigil-knight') preloadKnightArc()
    ctx.save()
    if (st) {
      const draw = def.trail ? drawContactSmearTrail : def.sparks ? drawContactSmearSparks
        : boss.id === 'vigil-knight' && knightArcLook() === 'art' && knightArcReady() ? drawContactSmearAfterContactArt
        : boss.id === 'vigil-knight' && knightArcLook() === 'brush' && swingReady() ? drawContactSmearAfterContactBrush : drawContactSmearAfterContactArc
      draw(ctx, { x: boss.x + def.anchorFwdPx * dir, y: boss.y - def.anchorUpPx },
        dir, def, st.p0, st.p, st.fade, boss, motion)
    }
    if (def2 && st2) {
      const draw2 = def2.trail ? drawContactSmearTrail : def2.sparks ? drawContactSmearSparks : drawContactSmearAfterContactArc
      draw2(ctx, { x: boss.x + def2.anchorFwdPx * dir, y: boss.y - def2.anchorUpPx },
        dir, def2, st2.p0, st2.p, st2.fade, boss, motion)
    }
    if (glint && glinting) {
      const at = applyPoseMotionToSmearPoint({ x: boss.x + glint.fwdPx * dir, y: boss.y - glint.upPx }, boss, motion, dir)
      const d1 = contactSmearArcDirAt(def, dir, glint.fwdPx)
      const d2 = def2 ? contactSmearArcDirAt(def2, dir, glint.fwdPx) : { x: -d1.y, y: d1.x }
      drawContactSmearCrossGlint(ctx, at, d1, d2, glint.sizePx, glintU,
        def.coreColor ?? PALETTE.fxSilver, def2?.glowColor ?? def.glowColor ?? PALETTE.fxSilver)
    }
    ctx.restore()
    return
  }
  const sweepState = contactSmearSweepState(tC, elapsedMs, def.kind === 'arc' ? def.sweepMs : undefined)
  if (!sweepState) return   // 寿命切れ
  const { p, fade } = sweepState

  ctx.save()
  if (def.kind === 'arc') {
    const anchor = { x: boss.x + def.anchorFwdPx * dir, y: boss.y - def.anchorUpPx }
    drawContactSmearArc(ctx, anchor, dir, def, p, fade, boss, motion, execSwingBrushKind(boss, artName))
  } else {
    // 🔴 sweep_slash 退役で実質未使用 (SMEAR_ARTS に thrust 定義が無い)。旧 t/lifeMs 方式のまま。
    ctx.globalCompositeOperation = 'source-over'   // additive にしない (信号色FXと混同させない)
    const legacyT = (elapsedMs - tC) / def.lifeMs
    drawContactSmearThrust(ctx, { x: boss.x, y: boss.y }, dir, def, legacyT, boss, motion)
  }
  ctx.restore()
}

// 本体の穂先アンカーに固定。前の版の独立した大円弧は騎士では使わない。
function drawKnightSweepTrail(ctx: CanvasRenderingContext2D, state: GameState, placement: BossSpritePlacement | null): void {
  const b = state.boss
  // 2026-09-27: 既定はキーポーズ版 (SMEAR_ARTS.lanceSweep_contact の弧)。この穂先固定の尾は DEV ?knightSweep=0912 の比較用だけ。
  if (getKnightSweepVariant() !== '0912') return
  if (!placement || state.phase !== 'playing' || b.id !== 'vigil-knight' || b.hp <= 0
    || b.currentAttack?.id !== 'lanceSweep' || swingTrailDisabledByQuery()) return
  const art = KNIGHT_SWEEP_ART[placement.imageKey]
  if (!art?.tip || !art.tail) return
  const chargeMs = b.currentString?.beats[b.beatIndex ?? 0]?.chargeOverrideMs ?? b.currentAttack.chargeMs
  const alpha = knightSweepTrailAlpha(placement.imageKey, b.state, b.stateElapsed * 1000, chargeMs)
  if (alpha <= 0) return
  const tip = projectBossSpriteRelativePoint(placement, art.tip)
  const scale = bossTelegraphSwell(b) * bossDisplayHeightFor(b.id) / 216
  const dx = art.tail[0] * placement.facingMul * scale
  const dy = art.tail[1] * scale
  // 古い側を短くしながら薄くする。先端は常に実際の穂先で止まる。
  const tailLength = Math.sqrt(alpha / 0.72)
  const pts = Array.from({ length: 19 }, (_, i) => {
    const u = (1 - i / 18) * tailLength
    return { x: tip.x + dx * u, y: tip.y + dy * (0.45 * u + 0.55 * u * u) }
  })
  const inner = pts.map(pt => ({ x: pt.x - dy * 0.2, y: pt.y + dx * 0.2 }))
  drawSweepRibbon(ctx, pts, inner, 5 * scale * tailLength, alpha, PALETTE.fxSilver)
}

// ===== 斬り上げ: 引きずりの火花 (2026-09-02) =====
// 設計 = docs/candidates/2026-09-01-executioner-drag-scoop-motion-spec.md (ChatGPT 壁打ちの「画像だけでは
//   表現しない要素」): KEY02〜KEY03 (接地→遅れ最大) で刃先が地面を擦る。人物画像には火花を焼き込まないので、
//   接地点に沿った**短い**火花と細かい破片をここで出す。長い尾を引かせない (ガリガリ区間が長い攻撃に見える)。
//   KEY03→KEY04 では火花が**途切れる**だけ (派手な解放エフェクトは魔法的に見えるので出さない)。
// 位置 = 溜めの絵 (scoop_touch/lag) の刃先。ボスの後方 (足元より後ろ) の地面。
//   🟨 仮値 (絵ローカル→実機換算の目測。ラボで刃先に乗っているか確認して詰める)。
//   DEV ツマミ: __dragSparks = { backPx, upPx, startP, endP, alpha }
// 🔵 2026-09-02 ユーザー裁定 (ラボで scoop_lift を見て): 「ここまで火花を出してほしい。まだ接地していることに
//   したいので。このフレームになったら火花の色をオレンジに。それ以外は今の白でOK」
//   → 蒔く区間 = 絵が KEY02〜KEY04 (scoop_touch / scoop_lag / scoop_lift) のあいだ。接触の絵に変わったら止める
//     (active に入っても scoop_lift が出ている 0〜57ms は蒔き続ける)。色 = scoop_lift の間だけオレンジ。
const DRAG_SPARKS = {
  backPx: 105,       // ボスの接地点から後方へ (刃先の x)
  upPx: 4,           // 地面からの高さ
  startP: 0.667,     // telegraph 進捗 (= 1100ms / 1650ms・KEY02 接地)。これより前は絵が KEY01 なので蒔かない
  sowImages: ['scoop_touch', 'scoop_lag', 'scoop_lift'] as readonly string[],   // 蒔く絵 (刃先が地面にある絵)
  orangeImage: 'scoop_lift',   // この絵の間だけオレンジ
  sliceMs: 45,       // この間隔で新しい粒を蒔く
  lifeMs: 95,
  alpha: 0.9,
  warm: '#ffe9b8',   // PALETTE.parrySparkWarm と同色 (弾ける技の信号色に寄せる)
  core: '#fff8ea',
  orange: '#ff9a3c',
  orangeCore: '#ffd28a',
}

function dragSparksOverride(): Partial<typeof DRAG_SPARKS> | undefined {
  if (!import.meta.env.DEV) return undefined
  return (globalThis as { __dragSparks?: Partial<typeof DRAG_SPARKS> }).__dragSparks
}

function drawExecutionerDragSparks(ctx: CanvasRenderingContext2D, state: GameState): void {
  const boss = state.boss
  if (state.phase !== 'playing' || boss.id !== 'the-executioner' || boss.hp <= 0) return
  if (swingTrailDisabledByQuery()) return
  const attack = boss.currentAttack
  if (!attack || attack.id !== 'exec_maulHold') return
  if (boss.state !== 'telegraph' && boss.state !== 'active') return
  const pose = resolveBossTimelinePose(boss.id, boss)
  if (!pose || !pose.frame) return
  const def = { ...DRAG_SPARKS, ...dragSparksOverride() }
  const image = pose.frame.current.image
  const sowing = def.sowImages.includes(image)
  // 技の頭からの通算 ms (telegraph → active と跨ぐ)。
  const nowMs = (boss.state === 'active' ? attack.chargeMs : 0) + boss.stateElapsed * 1000
  const startMs = def.startP * attack.chargeMs
  if (nowMs < startMs) return
  // 蒔き終わり = 絵が接触へ変わった時刻 (contact キーの at)。まだ蒔く絵なら「いま」。
  let sowUntilMs = nowMs
  if (!sowing) {
    if (boss.state !== 'active') return
    const contactKey = findContactKey(pose.timeline, pose.phaseProgress.hitIndex)
    if (!contactKey) return
    sowUntilMs = attack.chargeMs + contactKey.at * attack.activeMs
    if (nowMs - sowUntilMs >= def.lifeMs) return   // 尾も消えた
  }
  const isOrange = image === def.orangeImage
  const colorMain = isOrange ? def.orange : def.warm
  const colorCore = isOrange ? def.orangeCore : def.core

  const dir = boss.facing === 'right' ? 1 : -1
  const tipX = boss.x + dir * (-def.backPx + pose.motion.offsetX)
  const tipY = boss.y - def.upPx + pose.motion.offsetY
  // 直近 lifeMs ぶんのスライスだけ描く (状態を持たない = 巻き戻しても同じ絵)。
  const firstSlice = Math.max(0, Math.floor((nowMs - def.lifeMs) / def.sliceMs))
  const lastSlice = Math.floor(Math.min(nowMs, sowUntilMs) / def.sliceMs)
  ctx.save()
  for (let s = firstSlice; s <= lastSlice; s++) {
    const bornMs = s * def.sliceMs
    if (bornMs < startMs) continue
    const age = nowMs - bornMs
    if (age < 0 || age >= def.lifeMs) continue
    const t = age / def.lifeMs
    const fade = (1 - t) * def.alpha
    const seed = 9100 + s * 17
    // 破片は「刃が前へ進む」反作用で後方上へ飛ぶ。3〜4本の短い筋 + 光点。
    // 🟨 粒の数・長さ・明るさは仮値。1回目のラボ撮影 (_tmp/scoop_strip_a3) で「刃先に点が1つ」程度にしか
    //   見えなかったので一段強めた (粒 3〜4 → 5〜7・筋 4〜13px → 6〜20px・幅 2.2 → 3)。長い尾は引かせない。
    const n = 5 + Math.floor(hash01(seed) * 3)
    for (let i = 0; i < n; i++) {
      const h = hash01(seed + i * 7)
      const ang = (0.45 + h * 1.0)                         // 上向き 26°〜83° (rad)
      const vx = -dir * Math.cos(ang) * (90 + hash01(seed + i + 3) * 120)  // 後方へ
      const vy = -Math.sin(ang) * (110 + hash01(seed + i + 5) * 160)       // 上へ
      const ageS = age / 1000
      const px = tipX + vx * ageS + dir * (hash01(seed + i + 11) - 0.5) * 8
      const py = tipY + vy * ageS + 300 * ageS * ageS                       // 重力で落ちる
      const len = 6 + hash01(seed + i + 13) * 14 * (1 - t)
      taperStreak(ctx, px, py, -vx, -vy - 300 * ageS, len, 3, colorMain, fade)
      glowMote(ctx, px, py, 3.2 * (1 - t * 0.5), colorCore, fade)
    }
    // 接地点そのものの小さな熱 (擦っている間だけ)
    if (bornMs <= sowUntilMs) glowMote(ctx, tipX, tipY, 9, colorMain, fade * 0.5)
  }
  ctx.restore()
}

// ===== 斬り上げ 候補 a3: 振り抜きの弧 (2026-09-02 夜) =====
// ユーザー「接触の絵→振り抜きの絵でカックンと引っかかる」への候補の1つ。接触の刃先 (前64,上190) から
//   振り抜きの絵の刃先 (scoop_through: bbox 中心から後ろ 456px元・上 1253px元 ≒ 実機 前-80/上221) まで、
//   頭上を通る短い弧を接触の瞬間から sweepMs で掃き、fadeMs で消す。接触スメア (drawBossContactSmear) の
//   続きとして同じ掃き文法 (drawContactSmearSweep・銀・lighter) で描く。🟨 全部仮値。?scoop=a3 の時だけ。
// 🔵 2026-09-02 夜 等身 1.6 化で anchorFwdPx/anchorUpPx/radiusPx を 0.8 倍（旧 -23/198/110）
const SCOOP_FOLLOW_ARC = {
  anchorFwdPx: -18, anchorUpPx: 158, radiusPx: 88,
  angleFromRad: 0.365,   // 接触の刃先 (前64,上190)
  angleToRad: 2.35,      // 振り抜きの刃先 (前-80,上221)
  sweepMs: 110, fadeMs: 150,
}

function drawExecutionerScoopFollowArc(ctx: CanvasRenderingContext2D, state: GameState): void {
  const boss = state.boss
  if (state.phase !== 'playing' || boss.id !== 'the-executioner' || boss.hp <= 0) return
  if (swingTrailDisabledByQuery()) return
  if (getExecutionerScoopVariant() !== 'a3') return
  const attack = boss.currentAttack
  if (!attack || attack.id !== 'exec_maulHold') return
  if (boss.state !== 'active' && boss.state !== 'recovery') return
  const pose = resolveBossTimelinePose(boss.id, boss)
  if (!pose) return
  const contactKey = findContactKey(pose.timeline, pose.phaseProgress.hitIndex)
  if (!contactKey) return
  const elapsedMs = contactSmearElapsedMs(boss, attack)
  if (elapsedMs === null) return
  const def = SCOOP_FOLLOW_ARC
  const t = elapsedMs - contactKey.at * attack.activeMs
  if (t < 0) return
  const p = Math.min(1, t / def.sweepMs)
  const fade = t <= def.sweepMs ? 1 : Math.max(0, 1 - (t - def.sweepMs) / def.fadeMs)
  if (fade <= 0) return

  const dir = boss.facing === 'right' ? 1 : -1
  const motion: BossPoseMotion = {
    offsetX: contactKey.offset?.x ?? 0, offsetY: contactKey.offset?.y ?? 0,
    scaleX: 1, scaleY: 1, rot: contactKey.rot ?? 0,
  }
  const anchor = { x: boss.x + def.anchorFwdPx * dir, y: boss.y - def.anchorUpPx }
  const k = Math.max(1, Math.round(p * SMEAR_SWEEP_N))
  const rawPts = Array.from({ length: k + 1 }, (_, i) =>
    swingTrailPoint(anchor, dir, def.radiusPx, def.angleFromRad + (def.angleToRad - def.angleFromRad) * (i / k) * p))
  const rawInner = rawPts.map((pt) => ({ x: pt.x + (anchor.x - pt.x) * 0.45, y: pt.y + (anchor.y - pt.y) * 0.45 }))
  const pts = rawPts.map((pt) => applyPoseMotionToSmearPoint(pt, boss, motion, dir))
  const inner = rawInner.map((pt) => applyPoseMotionToSmearPoint(pt, boss, motion, dir))
  ctx.save()
  ctx.lineCap = 'butt'
  drawContactSmearSweep(ctx, pts, inner, SMEAR_SWEEP_N, fade)
  ctx.restore()
}

// ===== 腕砲: 発射のワープへ橋を架ける繋ぎFX (2026-08-29) =====
// 設計 = docs/candidates/2026-08-28-executioner-cannon-wall-hug-and-spawn.md §4。
// 直射/速射は構え砲口 (EXECUTIONER_CANNON_MUZZLE_AIM) → 発射砲口 (EXECUTIONER_CANNON_MUZZLE) が
// キーポーズのハードカットで瞬間移動して見える。淡い深紫の残像玉+短い尾で経路を滑らせ、
// 発射砲口に逆光風マズルフラッシュを添えて繋ぐ (弾の軌道・当たり判定は一切変えない・見た目だけ)。
const CANNON_BRIDGE_DEEP = '#3a0a5a'     // CHARGE_DEEP と同じ深紫 (くすんだ黒紫)
const CANNON_BRIDGE_BRIGHT = '#a05ad7'   // CHARGE_BRIGHT / 砲チャージ既存グロー (line ~2337) と同色
const CANNON_BRIDGE_CORE = '#c8b0ec'     // PALETTE.fxVioletBright と同色 (中心の淡光)
const CANNON_GHOST_SLIDE_MS = 80
const CANNON_MUZZLE_FLASH_MS = 100
const CANNON_RETURN_GHOST_MS = 60

function drawExecutionerCannonGhostSlide(
  ctx: CanvasRenderingContext2D,
  from: { x: number; y: number }, to: { x: number; y: number },
  t: number, alphaMul: number,
): void {
  const p = Math.max(0, Math.min(1, t))
  const fade = (1 - p) * alphaMul
  if (fade <= 0.01) return
  const pos = { x: from.x + (to.x - from.x) * p, y: from.y + (to.y - from.y) * p }
  const dx = to.x - from.x, dy = to.y - from.y
  const dist = Math.hypot(dx, dy) || 1
  glowMote(ctx, pos.x, pos.y, 15, et('parry', CANNON_BRIDGE_BRIGHT), fade * 0.55)
  taperStreak(ctx, pos.x, pos.y, -dx / dist, -dy / dist, dist * 0.32, 13, et('parry', CANNON_BRIDGE_BRIGHT), fade * 0.42)
}

function drawExecutionerCannonMuzzleFlash(
  ctx: CanvasRenderingContext2D, at: { x: number; y: number }, t: number, dirX: number,
): void {
  const p = Math.max(0, Math.min(1, t))
  const fade = (1 - p) * (1 - p)
  if (fade <= 0.01) return
  glowMote(ctx, at.x, at.y, 46, et('parry', CANNON_BRIDGE_DEEP), fade * 0.30)   // 深紫の背光 (逆光)
  glowMote(ctx, at.x, at.y, 16, et('parry', CANNON_BRIDGE_CORE), fade * 0.5)    // 中心の淡光
  // 2026-09-03 第4便: 放出を強める。白紫の芯+前方向へ伸びる尾。
  glowMote(ctx, at.x, at.y, 24, et('parry', CANNON_BRIDGE_CORE), fade * 0.85)
  taperStreak(ctx, at.x, at.y, dirX, 0, 70 * (1 - p * 0.5), 14, et('parry', CANNON_BRIDGE_BRIGHT), fade * 0.6)
}

function drawExecutionerCannonMuzzleBridge(ctx: CanvasRenderingContext2D, state: GameState): void {
  const boss = state.boss
  if (state.phase !== 'playing' || boss.id !== 'the-executioner' || boss.hp <= 0) return
  const attack = boss.currentAttack
  if (!attack || (attack.id !== 'exec_cannonShot' && attack.id !== 'exec_cannonVolley')) return
  const dir = boss.facing === 'right' ? 1 : -1
  const motion = resolveBossTimelinePose(boss.id, boss)?.motion
  const aimPoint = {
    x: boss.x + dir * (EXECUTIONER_CANNON_MUZZLE_AIM.spawnForwardPx + (motion?.offsetX ?? 0)),
    y: boss.y - EXECUTIONER_CANNON_MUZZLE_AIM.spawnOffsetY + (motion?.offsetY ?? 0),
  }
  const firePoint = {
    x: boss.x + dir * (EXECUTIONER_CANNON_MUZZLE.spawnForwardPx + (motion?.offsetX ?? 0)),
    y: boss.y - EXECUTIONER_CANNON_MUZZLE.spawnOffsetY + (motion?.offsetY ?? 0),
  }

  if (boss.state === 'active') {
    const elapsedMs = boss.stateElapsed * 1000
    if (elapsedMs <= CANNON_GHOST_SLIDE_MS) {
      drawExecutionerCannonGhostSlide(ctx, aimPoint, firePoint, elapsedMs / CANNON_GHOST_SLIDE_MS, 1)
    }
    if (execShotFxOn()) {
      // 10-20 手本 C: 砲口から紫の炎が噴く (src/exec_fx.ts)。前の光すじは ?execShot=old。
      if (elapsedMs < SHOT_MUZZLE_FLAME_MS) drawShotMuzzleFlame(ctx, firePoint, elapsedMs / SHOT_MUZZLE_FLAME_MS, dir, state.time)
    } else if (elapsedMs <= CANNON_MUZZLE_FLASH_MS) {
      drawExecutionerCannonMuzzleFlash(ctx, firePoint, elapsedMs / CANNON_MUZZLE_FLASH_MS, dir)
    }
  } else if (boss.state === 'comboGap' && attack.id === 'exec_cannonVolley') {
    // 速射だけ: 発射→構えへ戻る側にも淡い上向き残像 (同じ経路の逆走・αは半分)。
    const elapsedMs = boss.stateElapsed * 1000
    if (elapsedMs <= CANNON_RETURN_GHOST_MS) {
      drawExecutionerCannonGhostSlide(ctx, firePoint, aimPoint, elapsedMs / CANNON_RETURN_GHOST_MS, 0.5)
    }
  }
}

function drawRockReflectionBurst(
  ctx: CanvasRenderingContext2D,
  center: { x: number; y: number },
  ageSec: number,
  seedBase: number,
): void {
  const lifeSec = 0.25
  if (ageSec < 0 || ageSec >= lifeSec) return
  const progress = ageSec / lifeSec
  const fade = (1 - progress) * (1 - progress)
  for (let i = 0; i < 7; i += 1) {
    const seed = seedBase + 820 + i * 13.17
    const angle = hash01(seed) * Math.PI * 2
    const distance = progress * (24 + hash01(seed + 1.9) * 34)
    const x = center.x + Math.cos(angle) * distance
    const y = center.y + Math.sin(angle) * distance + progress * progress * 7
    drawIronRockFacet(ctx, x, y, 2.5 + hash01(seed + 3.1) * 3.8, seed, fade)
  }
}

// 腕砲の弾 (orb版): 紫の光の玉。暗い芯+明るい紫の縁+光の尾 (エルデンリング重力弾のような読ませ方)。
// 2026-09-03 第4便 ユーザー裁定: 岩塊ではなく紫の光の玉。色はCHARGE_*とCANNON_BRIDGE_COREのみ使う。
function drawGravityOrbProjectile(
  ctx: CanvasRenderingContext2D,
  center: { x: number; y: number },
  directionRad: number,
  size: number,
  seedBase: number,
  timeSec: number,
  reflected = false,
  // 紫の技を替える比較版 (DEV ?purpleSwap・src/purple_swap.ts) で写す先。直射・速射は弾ける ('parry')、山なり榴弾は弾けない ('unparry')。
  role: PurpleSwapRole = 'parry',
): void {
  const dirX = Math.cos(directionRad)
  const dirY = Math.sin(directionRad)
  const normalX = -dirY
  const normalY = dirX
  const bodySize = size * (reflected ? 0.75 : 1)

  for (let i = 0; i < 6; i += 1) {
    const seed = seedBase + 900 + i * 8.13
    const life = (timeSec * (1.6 + hash01(seed) * 0.5) + hash01(seed + 1.3)) % 1
    const back = bodySize * (0.5 + life * 1.6)
    const side = (hash01(seed + 2.7) - 0.5) * bodySize * (0.5 + life * 0.3)
    const x = center.x - dirX * back + normalX * side
    const y = center.y - dirY * back + normalY * side
    const moteRadius = 2 + hash01(seed + 5.1) * 2.5
    glowMote(ctx, x, y, moteRadius, et(role, '#a05ad7'), (0.35 + hash01(seed + 6.7) * 0.3) * (1 - life))
  }

  // 外側の靄 (加算)。
  // 🔵 2026-09-03 実画面で「細い輪」にしか見えなかったので、モック (266 A 放出) の玉の大きさへ寄せた
  glowMote(ctx, center.x, center.y, bodySize * 1.3, et(role, '#3a0a5a'), 0.30)
  glowMote(ctx, center.x, center.y, bodySize * 0.85, et(role, '#a05ad7'), 0.55)

  // 暗い芯 (重力弾の黒) + 明るい紫の縁。反射後は芯が白紫に変わる。
  const coreRadius = bodySize * 0.40 * (1 + 0.06 * Math.sin(timeSec * 14 + seedBase * 0.07))
  ctx.beginPath()
  ctx.arc(center.x, center.y, coreRadius, 0, Math.PI * 2)
  ctx.fillStyle = reflected ? `rgba(${et(role, '200,176,236')},0.95)` : `rgba(${et(role, '30,10,45')},0.92)`
  ctx.fill()
  ctx.strokeStyle = reflected ? et(role, '#a05ad7') : et(role, '#c8b0ec')
  ctx.lineWidth = Math.max(1.2, bodySize * 0.05)
  ctx.stroke()
}

// 腕砲の水平飛翔体。既定 = 紫の光の玉 (drawGravityOrbProjectile)。?shot=rock で旧・黒鉄の岩塊へ切替。
// 怨念 (大暴れ第5案・仮の見た目)。出てすぐ (無害の間) は点線の薄い玉、動き出すと紫の玉、返弾は黄緑。
//   弾けない怨念は赤 (全ボス共通の視覚言語: 赤=弾けない・避ける)。
//   進行方向に短い線。射程の終わり40pxで薄れて消える。完成の見た目は駅3。
function drawSpirit(ctx: CanvasRenderingContext2D, hit: ActiveHit, time: number): void {
  // 床技の衝撃波: 見た目は `awoken_rampage_fx.ts` (3案を `?waveFx=` で切替)。
  if (hit.spirit!.wave) { drawRampageWave(ctx, hit, time); return }
  // 怨念: 見た目は `awoken_rampage_fx.ts` (3案を `?spiritFx=` で切替)。
  drawRampageSpirit(ctx, hit, time)
}

function isEmberShot(attackId: string): boolean {
  return execShotFxOn() && (attackId === 'exec_cannonShot' || attackId === 'exec_cannonVolley')
}

function drawCastProjectiles(ctx: CanvasRenderingContext2D, state: GameState): void {
  const fajinLook = getFajinLook()
  drawFajinWindFrame(ctx, state, fajinLook)
  for (const hit of state.hits) {
    if (hit.follow !== 'travel' || hit.consumed || hit.x === undefined || hit.y === undefined
      || hit.vx === undefined || hit.widthPx === undefined) continue
    if (hit.spirit) { drawSpirit(ctx, hit, state.time); continue }
    // 花嫁の返しの一閃のハート (開発版 src/bride_kaeshi.ts) は下の drawBrideKaeshi が描く。
    if (hit.attackId === 'veilSweepLink' && brideKaeshiOn()) continue
    // 剣舞の暗器投げの小刀 (開発版 ?bladeThrow=1・src/blade_dancer_throw_knife.ts)。
    if (hit.attackId === BLADE_THROW_ID) { drawBladeKnife(ctx, hit); continue }
    // 千日手の軍配者たちの鈴・行軍の駒 (開発版 src/twins_fight.ts) は drawTwinsFight が描く。
    if (hit.attackId.startsWith('twins_')) continue
    const seedBase = hit.id * 19.13
    const directionRad = cannonProjectileDrawAngle(hit)
    if (isExecutionerFajin(hit.attackId) && (fajinLook === 'e' || fajinLook === 'f' || fajinLook === 'g' || fajinLook === 'h' || fajinLook === 'i' || fajinLook === 'j')) continue
    if (isExecutionerFajin(hit.attackId) && fajinLook !== 'old') {
      drawFajinWave(ctx, hit, state.time, fajinLook)
    } else if (isEmberShot(hit.attackId) && cannonShotLook !== 'rock') {
      // 10-20 作者の手本 C「紫の残り火」(src/exec_fx.ts)。前の紫の光の玉は ?execShot=old。
      drawEmberShot(ctx, { x: hit.x, y: hit.y }, directionRad, hit.widthPx, seedBase, hit.elapsedMs, state.time,
        hit.reflected === true)
    } else if (cannonShotLook === 'rock') {
      drawHeatedIronProjectile(
        ctx,
        { x: hit.x, y: hit.y },
        directionRad,
        hit.widthPx,
        { deep: CHARGE_DEEP, mid: CHARGE_MID, bright: CHARGE_BRIGHT },
        seedBase,
        state.time,
        hit.reflected === true,
      )
    } else {
      drawGravityOrbProjectile(
        ctx,
        { x: hit.x, y: hit.y },
        directionRad,
        hit.widthPx,
        seedBase,
        state.time,
        hit.reflected === true,
      )
    }

    if (hit.reflected) {
      const spark = [...state.fx].reverse().find((fx) => fx.kind === 'parry_spark'
        && state.time - fx.t >= 0 && state.time - fx.t < 0.25)
      if (spark?.kind === 'parry_spark') {
        const ageSec = state.time - spark.t
        // 反射後に進んだ距離を戻し、既存 parry_spark の発生時刻における弾の位置へ固定する。
        const origin = { x: hit.x - hit.vx * ageSec, y: hit.y }
        const nearSpark = Math.hypot(origin.x - spark.x, origin.y - spark.y) < 110
        if (nearSpark && isEmberShot(hit.attackId) && cannonShotLook !== 'rock') drawEmberShotBreak(ctx, origin, ageSec, seedBase)
        else if (nearSpark) drawRockReflectionBurst(ctx, origin, ageSec, seedBase)
      }
    }
  }
  drawBrideKaeshi(ctx, state.hits, state.fx, state.time)
  // 覚醒王の床の割れ: 波の当たりが消えた後も、最後に通った所の石を沈め切る (awoken_wave_rift_fx.ts)。
  drawAwokenWaveRemnants(ctx, state.time)
}

// 榴弾の着弾範囲は床に寝た面として見せる。完全楕円の輪郭は引かず、
// 既存の床遠近 GROUND_FORESHORTEN で潰した面の内側へ粒を散らす。
function drawCannonMortarLandingPlane(
  ctx: CanvasRenderingContext2D,
  hazard: ActiveHit,
  progress: number,
): void {
  const centerX = (hazard.xStart + hazard.xEnd) / 2
  const radiusX = (hazard.xEnd - hazard.xStart) / 2
  const radiusY = radiusX * GROUND_FORESHORTEN
  for (let i = 0; i < 120; i += 1) {
    const seed = hazard.xStart * 0.031 + i * 7.13
    const u = hash01(seed) * 2 - 1
    const v = hash01(seed + 2.9) * 2 - 1
    if (u * u + v * v > 1) continue
    const depth = (v + 1) / 2
    const edgeFade = Math.max(0.12, 1 - (u * u + v * v))
    const radius = (1.6 + hash01(seed + 4.7) * 4.8) * (0.72 + depth * 0.42)
    const color = hash01(seed + 6.1) > 0.72 ? '#ff9a68' : '#9c302d'
    const alpha = (0.10 + progress * 0.28) * edgeFade * (0.55 + depth * 0.45)
    glowMote(ctx, centerX + u * radiusX, ARENA.floorY + v * radiusY, radius, color, alpha)
  }
}

//   melee (ボス追従) ヒットは描かない = ボスの攻撃モーション自体が予告。
export function quakeTelegraphWidthProgress(attackId: string, progress: number): number {
  const p = Math.max(0, Math.min(1, progress))
  // 榴弾は着弾予定の全幅を最初から見せ、明るさだけを後段の progress で立ち上げる。
  // 刃の地割り (突き立て) は従来どおり中心から亀裂が伸びる。
  return attackId === 'exec_cannonMortar' ? 1 : 1 - (1 - p) * (1 - p)
}

// 地割り (quake_fx) に渡す「刃が床を打った位置」。hazard の originX は飛び退く前の boss.x なので、
//   攻撃の telegraphBackstepPx ぶん戻し、spawnZoneHits と同じ壁クランプを掛ける。
function quakeFxContext(hz: ActiveHit): QuakeFxContext {
  const hop = getAttack(hz.attackId).telegraphBackstepPx ?? 0
  const dir = hz.originDir ?? 1
  const raw = (hz.originX ?? (hz.xStart + hz.xEnd) / 2) - dir * hop
  const walls = arenaWalls()
  return { impactX: Math.max(walls.leftWall, Math.min(walls.rightWall, raw)) }
}

function drawHazards(ctx: CanvasRenderingContext2D, state: GameState): void {
  const t = state.time
  // 花嫁の薔薇の茨 (既定・DEV の ?thornLook=now で旧の結晶) の、当たりが終わった後のしおれ。帯が消えた後も描く・薔薇の時だけ (src/bride_rose_thorns.ts)。
  drawBrideRoseWithers(ctx, state.hits, state.time * 1000, ARENA.floorY, state.boss ? state.boss.x : null)
  for (const hz of state.hits) {
    if (hz.follow) continue   // melee ヒットはゾーン描画しない
    if (hz.airWave) continue  // 空気の衝撃波 (既定。旧は DEV ?roarAir=0) は床の帯を描かない (src/exec_roar_air_fx.ts が描く)
    const w = hz.xEnd - hz.xStart
    if (w <= 0) continue
    const inTelegraph = hz.elapsedMs < hz.telegraphMs
    drawFloorWarnUnder(ctx, hz, t, state.boss ? state.boss.x : null)   // 床の技の予告の技ごとの見せ方 (src/floor_warn_vis.ts・配布版は割れ目と裾払いの刃の先)
    // 鶏の暁呼びの羽根 (比較版 DEV ?roosterFx=v1・src/rooster_fx.ts): 下の半透明の壁と姫の光の柱の代わりに、落ちて刺さる白い羽根。
    if (roosterFx() === 'v1' && isRoosterFeatherHit(hz)) {
      if (inTelegraph) drawRoosterFeatherTelegraph(ctx, hz, ARENA.floorY)
      else drawRoosterFeatherActive(ctx, hz, t, ARENA.floorY)
      continue
    }
    if (inTelegraph) {
      // buttTrap: 共通の半透明壁でなく、低い赤い床亀裂で予兆を描く。
      if (hz.kind === 'buttTrap' && getKnightButtFx() !== 'now') {
        // 石突の割れ目 (10-08 ユーザー採用＝配布版の既定・旧は DEV ?knightButtFx=now・src/knight_lance_fx.ts): 赤黒い煙がにじみ、終盤に石畳が浮く。
        drawButtCrackTelegraph(ctx, hz, t, knightButtImpactX(state, hz))
        continue
      }
      if (hz.kind === 'buttTrap') {
        const progress = hz.elapsedMs / hz.telegraphMs
        const lateCue = progress >= 0.7
        const blink = 0.5 + 0.5 * Math.sin(t * (lateCue ? 20 : 10))
        const a = (0.35 + 0.45 * progress) * (0.65 + 0.35 * blink)
        const cx = (hz.xStart + hz.xEnd) / 2
        ctx.save()
        // 床面の薄い赤い危険フットプリント (壁にしすぎない・低く抑える)
        const gradH = 24 * progress
        const grad = ctx.createLinearGradient(0, ARENA.floorY - gradH, 0, ARENA.floorY)
        grad.addColorStop(0, `rgba(220,30,45,0)`)
        grad.addColorStop(1, `rgba(220,30,45,${(a * 0.42).toFixed(3)})`)
        ctx.fillStyle = grad
        ctx.fillRect(hz.xStart, ARENA.floorY - gradH, w, gradH)
        // 亀裂ライン (ジグザグ・床スレスレ)
        ctx.strokeStyle = lateCue ? '#ff2035' : '#b82030'
        ctx.lineWidth = 1.5 + 2.0 * progress
        ctx.globalAlpha = a
        ctx.beginPath()
        ctx.moveTo(hz.xStart + 5, ARENA.floorY - 2)
        ctx.lineTo(cx - 6, ARENA.floorY - 5)
        ctx.lineTo(cx, ARENA.floorY - 2)
        ctx.lineTo(cx + 6, ARENA.floorY - 6)
        ctx.lineTo(hz.xEnd - 5, ARENA.floorY - 2)
        ctx.stroke()
        // 終盤: 亀裂の底から赤い光が滲む
        if (lateCue) {
          ctx.globalCompositeOperation = 'lighter'
          ctx.globalAlpha = a * 0.38
          ctx.fillStyle = '#ff1828'
          ctx.fillRect(hz.xStart + 2, ARENA.floorY - 5, w - 4, 5)
        }
        ctx.restore()
        continue
      }
      // shock kind: 汎用の紫壁でなく「儀式の境界線」 (亡霊の shadeRipple だけ霊気の揺らぎへ差し替え・チケットE)
      if (hz.kind === 'shock' && isShadeRippleHazard(hz)) {
        // 「床をすべる霧と柱」(既定・DEV の ?shadeWaveLook=now で旧・src/shade_wave_mist_fx.ts)。材料が未読み込みなら旧の見た目。
        if (shadeMistLookOn() && drawShadeWaveMist(ctx, hz, t, state.boss?.x ?? hz.xEnd)) continue
        drawShadeRippleTelegraph(ctx, hz, t)
        // src/shade_wave_sync.ts (既定 on・2026-10-10 ユーザー採用。DEV の ?shadeWaveSync=0 で旧): 当たりの 100ms 前から噴き上がりを重ねる。
        if (rippleSyncOn()) {
          const early = rippleBurstRise(hz.elapsedMs, hz.telegraphMs)
          if (early > 0) drawShadeRippleActive(ctx, hz, t, early, 1)
        }
        continue
      }
      // 🔴 予告の間、 獣は空中にいる (rampage の telegraph = 跳ね上がり)。 そこで塊が既に噴いていると
      //    「何が噴かせたのか」が絵として通らない (2026-08-11 ユーザー指摘)。
      //    → 予告は**床だけ**。 面が灼けて怨嗟が集まっていく。 噴出は着地 (active = rampage_slam) の瞬間から。
      //    ⚠️ 予告を消すのではない。 危険な帯がどこかは床の灼けで最初から出続ける (この作品の判断軸)。
      if (hz.kind === 'shock' && isRampageHazard(hz)) {
        const progress = Math.max(0, Math.min(1, hz.elapsedMs / hz.telegraphMs))
        const pulse = progress >= 0.7 ? 1 + 0.18 * Math.sin(t * 14) : 1
        const alpha = (0.30 + 0.70 * progress) * pulse
        if (drawRampageGrudge(ctx, hz, 1, alpha, 0)) continue
      }
      // めくれる床 (10-20 作者の選択 B＝配布版の既定・src/hound_roar_floor.ts): 床石が震えて浮き、灰が這う。
      if (hz.kind === 'shock' && hz.attackId === 'houndRoar' && getHoundRoarFx() === 'floor'
        && drawHoundRoarTelegraph(ctx, hz, t, ARENA.floorY)) continue
      if (hz.kind === 'shock') {
        const progress = hz.elapsedMs / hz.telegraphMs
        const lateCue = progress >= 0.7
        const blink = 0.5 + 0.5 * Math.sin(t * (lateCue ? 18 : 9))
        const baseA = (0.3 + 0.5 * progress) * (0.7 + 0.3 * blink)
        const stakeH = 56 * progress          // 端のステーク(杭)が立ち上がる高さ
        const lineY = ARENA.floorY - 3
        ctx.save()
        // 境界線 (白金〜冷青紫の細いライン)
        ctx.globalAlpha = Math.min(0.9, baseA)
        ctx.strokeStyle = lateCue ? '#b8d4f8' : '#a0b8e0'
        ctx.lineWidth = lateCue ? 2 : 1.5
        ctx.setLineDash(lateCue ? [] : [8, 4])
        ctx.beginPath()
        ctx.moveTo(hz.xStart, lineY)
        ctx.lineTo(hz.xEnd, lineY)
        ctx.stroke()
        ctx.setLineDash([])
        // 端の縦杭 (左右2本ずつ)
        ctx.lineWidth = lateCue ? 2.5 : 2
        for (const sx of [hz.xStart, hz.xStart + 6, hz.xEnd - 6, hz.xEnd]) {
          ctx.globalAlpha = Math.min(0.85, baseA * 0.9)
          ctx.strokeStyle = lateCue ? '#d0e8ff' : '#90a8cc'
          ctx.shadowColor = lateCue ? '#90c0ff' : '#6080a0'
          ctx.shadowBlur = lateCue ? 5 : 2
          ctx.beginPath()
          ctx.moveTo(sx, lineY)
          ctx.lineTo(sx, lineY - stakeH)
          ctx.stroke()
          ctx.shadowBlur = 0
        }
        // 境界線の淡い冷光グロー (加算)
        ctx.globalCompositeOperation = 'lighter'
        ctx.globalAlpha = 0.06 * progress
        const glowG = ctx.createLinearGradient(0, lineY - 18, 0, lineY + 6)
        glowG.addColorStop(0, 'rgba(160,200,255,0)')
        glowG.addColorStop(0.6, 'rgba(160,200,255,0.5)')
        glowG.addColorStop(1, 'rgba(160,200,255,0)')
        ctx.fillStyle = glowG
        ctx.fillRect(hz.xStart, lineY - 18, w, 24)
        ctx.restore()
        continue
      }
      // 花嫁「ヴェールの招待」(veilInvitation) の telegraph だけ、婚礼ヴェールの壁 (drawVeilWall・
      //   procedural-only + 下から上へclip reveal) を出す (2026-07-10 Codex監査回答で再設計)。
      //   attackId で限定するのは、 kind:'veil' を剣舞 hemSweep / 先代の姫 curtainSweep も
      //   共有しているため (audit-answer.md §7・限定しないと他ボスへ花嫁固有の意味が漏れる)。
      //   タイミング (audit-answer.md §4): 0〜15%=床線+低い根元光のみ(reveal=0) /
      //   15〜75%=reveal を ease-out で 0→1 / 75〜100%=全高保持+弱いpulse。
      // 影の手 (10-20 作者の選択 C＝配布版の既定・src/bride_veil_hands.ts): 床に影だまりが広がり、指先が覗く。
      //   絵が読めていない時と DEV ?brideVeilFx=wall は下の婚礼ヴェールの壁。
      if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && isVeilHandsFx(getBrideVeilFx())
        && drawVeilHandsTelegraph(ctx, hz, t, ARENA.floorY)) continue
      // 布のヴェール (10-23・DEV ?brideVeilFx=cloth|cloth2・src/bride_veil_cloth.ts): 裾が床に溜まってさざめく。
      const veilFxNow = getBrideVeilFx()
      // 両側から挟むヴェールの津波 (10-23・DEV ?brideVeilFx=tsunami…・src/bride_veil_tsunami.ts): 帯ごとに1枚、隙間の側へ巻き込む。
      if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && (VEIL_TSUNAMI_KINDS as readonly string[]).includes(veilFxNow)) {
        drawVeilTsunamiTelegraph(ctx, veilFxNow as VeilTsunamiKind, hz, t, ARENA.floorY, veilTsunamiDir(hz, state.hits, state.player.x, state.boss?.x ?? state.player.x))
        continue
      }
      // 両側から押し寄せて覆いかぶさるヴェール (10-23・DEV ?brideVeilFx=sides / sides-tulle・src/bride_veil_sides.ts): 帯の外から寄せ、波頭が内へ巻く。
      if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && isVeilSidesKind(veilFxNow)
        && drawVeilSidesTelegraph(ctx, veilFxNow, hz, t, ARENA.floorY, veilTsunamiDir(hz, state.hits, state.player.x, state.boss?.x ?? state.player.x))) continue
      // 床から生えて重力で落ちるヴェール (10-23・DEV ?brideVeilFx=rise…・src/bride_veil_rise.ts): 床から柱が生えてくる。
      if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && (VEIL_RISE_KINDS as readonly string[]).includes(veilFxNow)) {
        drawVeilRiseTelegraph(ctx, veilFxNow as VeilRiseKind, hz, t, ARENA.floorY, veilTsunamiDir(hz, state.hits, state.player.x, state.boss?.x ?? state.player.x))
        continue
      }
      if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && (veilFxNow === 'cloth' || veilFxNow === 'cloth2')) {
        drawVeilClothTelegraph(ctx, veilFxNow, hz, t, ARENA.floorY)
        continue
      }
      // 剣舞「裾払い」の板と刃の花 (10-20・DEV ?bladeHemFx=bloom・src/blade_hem_bloom.ts): 床に割れ目が走り、刃先が覗く。
      if (hz.kind === 'veil' && hz.attackId === 'hemSweep' && getBladeHemFx() === 'bloom'
        && drawBladeHemTelegraph(ctx, hz, t, ARENA.floorY, state.boss?.x ?? (hz.xStart + hz.xEnd) / 2)) continue
      if (hz.kind === 'veil' && hz.attackId === 'veilInvitation') {
        const progress = hz.elapsedMs / hz.telegraphMs
        let reveal: number
        if (progress < 0.15) reveal = 0
        else if (progress < 0.75) {
          const p = (progress - 0.15) / 0.6
          reveal = 1 - (1 - p) * (1 - p)   // ease-out
        } else {
          reveal = 1
        }
        const lateCue = progress >= 0.75
        const pulse = lateCue ? 1 + 0.15 * Math.sin(performance.now() / 1000 * 14) : 1
        // 発火直前の警告 (§4): 予告後半で menace を上げる = 「呪いが満ちる・来るぞ」。
        const menace = Math.max(0, (progress - 0.55) / 0.45)
        // wall-cloth (10-23・DEV): 同じ壁の動きのまま、布の塗りだけヴェールの絵 (src/bride_veil_wallcloth.ts)。
        drawVeilWall(ctx, hz.xStart, w, ARENA.floorY, reveal, (0.4 + 0.5 * progress) * pulse, t, menace,
          veilFxNow === 'wall-cloth' ? brideVeilCurtain() : null)
        continue
      }
      // 花嫁 thorns の telegraph、および他ボスの kind:'veil' (剣舞 hemSweep / 先代の姫 curtainSweep)
      //   の telegraph は共通で v3 poison_mist_v3 透過 PNG (呪詛が湧く塊) を使う
      //   (= 2026-07-10 婚礼ヴェールの壁を導入する branch 着手前の既存表示・audit-answer.md §7)。
      //   実装型 = fxlab v3 rev2 の drawHazardSpriteCentered (poison_mist 経路)。
      //   crop: 素材両端 6% はフェード = drop して濃い部分 (中央 88%) だけを判定幅全体に scaleX で伸ばす
      //         = 「絵として見えてる範囲 = 判定範囲」 の一致 (2026-07-01 ユーザー指摘対応)
      //   lateCue: 赤帯は UI 図形読みで安っぽいので削除。 脈動 (pulse) + alpha ブーストのみで警告表現。
      //   fallback = 元の generic 半透明壁 (embrace/light 等の他 kind 用に残す)。
      // 花嫁 thorns の溜めは src/bride_thorn_rise.ts が描く (中身は下の poison_mist と同じ。既定 early (2026-10-10 ユーザー採用・DEV の ?thornRise=off で旧)=
      //   溜めの最後 90ms で当たりの結晶を先に伸ばし始める・2026-10-10)。溜めの絵が未読込みの時だけ下のフォールバックへ落ちる。
      if (hz.kind === 'thorns') {
        const mist = getBrideHazard('poison_mist')
        if (mist && mist.complete && mist.naturalWidth > 0) {
          const growthImg = getBrideHazard('thorn_growth')
          drawThornAisle(ctx, hz, w, ARENA.floorY, performance.now(),
            { mist, growth: growthImg && growthImg.complete && growthImg.naturalWidth > 0 ? growthImg : null },
            { mist: HAZARD_CROP_FRAC.poison_mist, growth: HAZARD_CROP_FRAC.thorn_growth })
          continue
        }
      }
      if (hz.kind === 'thorns' || (hz.kind === 'veil' && hz.attackId !== 'veilInvitation')) {
        const progress = hz.elapsedMs / hz.telegraphMs
        const lateCue = progress >= 0.7
        // lateCue で脈動 (色でなく強度・呼吸で警告)
        const pulse = lateCue ? 1 + 0.18 * Math.sin(performance.now() / 1000 * 14) : 1
        const alphaMax = Math.min(1, 0.4 + 1.5 * progress) * pulse
        const img = getBrideHazard('poison_mist')
        if (img && img.complete && img.naturalWidth > 0) {
          const dh = 140
          const dyTop = ARENA.floorY - dh
          const crop = HAZARD_CROP_FRAC.poison_mist
          const srcX = img.naturalWidth * crop
          const srcW = img.naturalWidth * (1 - crop * 2)
          ctx.save()
          ctx.globalCompositeOperation = 'source-over'
          ctx.globalAlpha = Math.max(0, Math.min(1, alphaMax))
          ctx.drawImage(img, srcX, 0, srcW, img.naturalHeight, hz.xStart, dyTop, w, dh)
          ctx.restore()
          continue
        }
        // sprite 未読み込み時のフォールバック = 極薄の紫床線 (安全側で下に描画)
        ctx.save()
        ctx.globalAlpha = 0.35 + 0.35 * progress
        ctx.fillStyle = PALETTE.fxViolet
        ctx.fillRect(hz.xStart, ARENA.floorY - 6, w, 6)
        ctx.restore()
        continue
      }
      // quake (処刑人 E10 地割り): 暗い床でも危険幅を読めるよう、中心から走る亀裂の底へ
      //   unblockable の共通言語である赤い呪い光を足す。UI帯や魔法陣ではなく、石の下の灼熱。
      if (hz.kind === 'quake') {
        const progress = Math.max(0, Math.min(1, hz.elapsedMs / hz.telegraphMs))
        if (hz.attackId === 'exec_cannonMortar') {
          // 照準の輪 (10-20・src/exec_floor_fx.ts)。?execFloorFx=old で前の赤い光の粒の面。
          if (!drawMortarRingTelegraph(ctx, hz, t, ARENA.floorY)) drawCannonMortarLandingPlane(ctx, hz, progress)
          continue
        }
        // 🔵 2026-09-03 第5便: 地割りの床の演出 3案 (src/quake_fx.ts)。'old' の時だけ下の旧描画へ落ちる。
        if (getQuakeLook() !== 'old') {
          drawQuakeTelegraph(ctx, hz, t, quakeFxContext(hz), getQuakeLook())
          continue
        }
        const reveal = quakeTelegraphWidthProgress(hz.attackId, progress)
        const lateCueQ = progress >= 0.75
        const pulseQ = lateCueQ ? 0.88 + 0.12 * Math.sin(t * 18) : 1
        const floorY = ARENA.floorY
        const cx = (hz.xStart + hz.xEnd) / 2
        const crackHalf = Math.max(4, (w * 0.5 - 2) * reveal)
        const visibleStart = cx - crackHalf
        const visibleEnd = cx + crackHalf
        const traceCrack = (): void => {
          ctx.beginPath()
          for (let i = 0; i <= 8; i += 1) {
            const u = i / 8
            const x = visibleStart + (visibleEnd - visibleStart) * u
            const jag = (hash01(hz.xStart * 0.071 + i * 7.13) - 0.5) * (5 + 3 * progress)
            const y = floorY - 3 - Math.abs(jag)
            if (i === 0) ctx.moveTo(x, y)
            else ctx.lineTo(x, y)
          }
        }
        ctx.save()
        // 割れ目の底から漏れる加算光。既存の亀裂と同じ path・同じ危険幅だけを使い、
        //   外へ広げず、暗線の形を下から持ち上げる。色は本体の curse aura と完全に共通。
        ctx.save()
        ctx.beginPath()
        ctx.rect(hz.xStart, floorY - 26, w, 28)
        ctx.clip()
        ctx.globalCompositeOperation = 'lighter'
        ctx.lineCap = 'round'
        ctx.lineJoin = 'round'
        // ⚠️ 裾を 16px より広げると、clip の直線でスパッと切れて「赤い長方形」が床に乗る
        //   (2026-07-31 実機で確認)。広げるなら clip も一緒に見直すこと。
        ctx.globalAlpha = (0.18 + 0.24 * progress) * pulseQ
        ctx.strokeStyle = `rgb(${CURSE_DEEP})`
        ctx.lineWidth = 16 + 2 * progress
        traceCrack()
        ctx.stroke()
        ctx.globalAlpha = (0.24 + 0.34 * progress) * pulseQ
        ctx.strokeStyle = `rgb(${CURSE_MID})`
        ctx.lineWidth = 9 + 2 * progress
        traceCrack()
        ctx.stroke()
        ctx.globalAlpha = (0.16 + 0.2 * progress) * pulseQ
        ctx.strokeStyle = `rgb(${CURSE_BRIGHT})`
        ctx.lineWidth = 3 + progress
        traceCrack()
        ctx.stroke()
        ctx.restore()
        ctx.globalCompositeOperation = 'source-over'
        // 割れ目の底。太い暗線で暗い床からも輪郭を分離する。
        ctx.globalAlpha = (0.58 + 0.32 * progress) * pulseQ
        ctx.strokeStyle = '#08090b'
        ctx.lineWidth = 5 + 2 * progress
        ctx.lineCap = 'round'
        ctx.lineJoin = 'miter'
        traceCrack()
        ctx.stroke()
        // 上側の欠けた石縁。冷たい灰色の細線で「床の線が裂けた」と読ませる。
        ctx.globalAlpha = (0.42 + 0.36 * progress) * pulseQ
        ctx.strokeStyle = lateCueQ ? '#8a857e' : '#67635f'
        ctx.lineWidth = lateCueQ ? 2 : 1.4
        traceCrack()
        ctx.stroke()
        // 暗い底の隙間から灼熱を覗かせる。⚠️ ここを太く・明るくすると、暗線が塗り潰されて
        //   「光る管」になり、割れ目に見えなくなる (2026-07-31 実機で確認)。細く低くが正。
        ctx.globalCompositeOperation = 'lighter'
        ctx.globalAlpha = (0.16 + 0.26 * progress) * pulseQ
        ctx.strokeStyle = `rgb(${lateCueQ ? CURSE_BRIGHT : CURSE_MID})`
        ctx.lineWidth = 0.75 + 0.45 * progress
        traceCrack()
        ctx.stroke()
        ctx.globalCompositeOperation = 'source-over'
        // 本線から伸びる枝亀裂。面では塗らず、危険幅の両端まで線の密度で示す。
        ctx.globalAlpha = (0.36 + 0.42 * progress) * pulseQ
        ctx.strokeStyle = '#242326'
        ctx.lineWidth = 2
        for (let i = 1; i <= 5; i += 1) {
          const u = i / 6
          const bx = visibleStart + (visibleEnd - visibleStart) * u
          const by = floorY - 4 - hash01(hz.xStart * 0.043 + i * 3.71) * 4
          const dir = i % 2 === 0 ? 1 : -1
          const branchW = (7 + hash01(i * 9.17 + hz.xStart) * 9) * reveal
          const branchRise = (4 + hash01(i * 2.83 + hz.xEnd) * 4) * reveal
          ctx.beginPath()
          ctx.moveTo(bx, by)
          ctx.lineTo(bx + dir * branchW * 0.45, by - branchRise - branchW * 0.18)
          ctx.lineTo(bx + dir * branchW, by - branchRise * 0.55 - branchW * 0.08)
          ctx.stroke()
        }
        // 終盤だけ、亀裂からこぼれた細かな石粉が跳ねる。光ではなく粒で発火直前を強める。
        if (lateCueQ) {
          ctx.globalAlpha = (0.28 + 0.18 * pulseQ) * progress
          ctx.fillStyle = '#8b857c'
          for (let i = 0; i < 7; i += 1) {
            const px = visibleStart + hash01(hz.xStart * 0.019 + i * 5.31) * (visibleEnd - visibleStart)
            const py = floorY - 7 - hash01(i * 7.77 + hz.xEnd) * 8
            const size = 1 + hash01(i * 4.29) * 1.5
            ctx.beginPath()
            ctx.arc(px, py, size, 0, Math.PI * 2)
            ctx.fill()
          }
        }
        ctx.restore()
        continue
      }
      // roarWave (処刑人 G11 咆哮波): telegraph 中は「空気がかすかに震える」縦の淡いかすみだけ。
      //   ⚠️ 床ラインは描かない (咆哮は床から出ない)。 危険域 x は縦の薄いグローで示す。
      if (hz.kind === 'roarWave') {
        // 比較版 (DEV ?roarTell=v2・src/exec_roar_tell.ts): 床の明るみ＋床すれすれのほこりを、その帯の波が噴く 600ms 前から (目地の光は背景の層)。
        if (import.meta.env.DEV && roarTellOn()) { drawRoarTellBand(ctx, hz, t); continue }
        const progress = hz.elapsedMs / hz.telegraphMs
        const lateCueR = progress >= 0.7
        const pulseR = lateCueR ? 0.55 + 0.45 * Math.sin(t * 18) : 0.4
        const alphaR = (0.2 + 0.4 * progress) * pulseR
        const bh = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[state.boss.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
        const cyR = ARENA.floorY - bh * 0.5
        ctx.save()
        ctx.globalCompositeOperation = 'lighter'
        // 縦の淡いかすみ (空気の震え・危険域を示すが床には張り付かない)
        ctx.globalAlpha = alphaR
        const g = ctx.createLinearGradient(hz.xStart, 0, hz.xEnd, 0)
        g.addColorStop(0, 'rgba(232,228,220,0)')
        g.addColorStop(0.5, 'rgba(240,236,228,0.5)')
        g.addColorStop(1, 'rgba(232,228,220,0)')
        ctx.fillStyle = g
        ctx.fillRect(hz.xStart, cyR - bh * 0.5, w, bh)
        ctx.restore()
        continue
      }
      // 他 kind (embrace/light 等): ⚠️仮ビジュアル (立ち上がる半透明壁) を残す。
      //   薄い床線では範囲が見えず回避不能だったため、 危険域を「立ち上がる半透明の壁」で明示する。
      const progress = hz.elapsedMs / hz.telegraphMs
      const lateCue = progress >= 0.7   // 残り30%で色が変わる (既存 TELEGRAPH.cueAtPercent と同じ読み)
      const blink = 0.5 + 0.5 * Math.sin(t * (lateCue ? 22 : 11))
      const alpha = (0.4 + 0.35 * progress) * (0.72 + 0.28 * blink)   // 開始から濃く・終盤さらに濃く
      // 紫の技を替える比較版 (DEV ?purpleSwap・src/purple_swap.ts): 弾けない床の技なので通常の紫を 'unparry' へ。終盤の赤はそのまま。
      const col = lateCue ? '255,90,138' : swc('unparry', '156,124,200')              // 終盤=赤/通常=紫
      const edge = lateCue ? PALETTE.danger : swc('unparry', PALETTE.fxViolet)
      const previewH = 70                                             // 床から立ち上がる半透明壁の高さ
      ctx.save()
      // 危険フットプリント: 床ほど濃い半透明の壁 (どこが危険か一目で / 隙間=無塗り部分)
      const grad = ctx.createLinearGradient(0, ARENA.floorY - previewH, 0, ARENA.floorY)
      grad.addColorStop(0, `rgba(${col},0)`)
      grad.addColorStop(1, `rgba(${col},${(alpha * 0.5).toFixed(3)})`)
      ctx.fillStyle = grad
      ctx.fillRect(hz.xStart, ARENA.floorY - previewH, w, previewH)
      // 床の濃い基線 (確実に見える)
      ctx.fillStyle = `rgba(${col},${Math.min(0.9, alpha).toFixed(3)})`
      ctx.fillRect(hz.xStart, ARENA.floorY - 6, w, 12)
      // 太い外枠 (左右端＝危険と安全の境界をクッキリ)
      ctx.globalAlpha = Math.min(1, alpha + 0.25)
      ctx.strokeStyle = edge
      ctx.lineWidth = 3
      ctx.strokeRect(hz.xStart + 1.5, ARENA.floorY - previewH, w - 3, previewH + 6)
      ctx.restore()
      continue
    }
    // active: kind 別の実体
    const activeElapsed = hz.elapsedMs - hz.telegraphMs
    const aProg = Math.min(1, activeElapsed / hz.activeMs)
    const rise = Math.min(1, activeElapsed / 90)          // 立ち上がり 90ms
    const fade = aProg > 0.85 ? (1 - aProg) / 0.15 : 1    // 終わり際フェード
    ctx.save()
    if (hz.kind === 'thorns') {
      // 花嫁 thorns active: 呪詛の茨/蔓が下から生える (v3 rev2)。
      //   実装 = fxlab v3 rev2 の drawHazardSpriteCentered (thorns 経路): rise で描画高さが 0→dhMax
      //   素材下部から順に露出 (最初は根元の煤 → rise 進行で棘が出てくる) = 実機 h = 64 * rise の再現。
      //   描くのは src/bride_thorn_rise.ts (既定 early = 当たりの開始で伸びきっている・旧 off は高さ 180 × rise・不透明度 fade)。
      //   DEV の ?thornRise=keep = 伸びきるまで溜めの結晶を重ねて消す / =off = 旧 (2026-10-10・見た目だけ)。
      const img = getBrideHazard('thorn_growth')
      if (img && img.complete && img.naturalWidth > 0) {
        const mist = getBrideHazard('poison_mist')
        drawThornAisle(ctx, hz, w, ARENA.floorY, performance.now(),
          { mist: mist && mist.complete && mist.naturalWidth > 0 ? mist : null, growth: img },
          { mist: HAZARD_CROP_FRAC.poison_mist, growth: HAZARD_CROP_FRAC.thorn_growth })
      } else {
        // sprite 未読込み時のフォールバック: 旧 zigzag 三角列 (最悪でも判定範囲は見える)
        const h = 64 * rise
        ctx.globalAlpha = 0.92 * fade
        const step = 26
        ctx.fillStyle = '#241433'
        ctx.beginPath()
        ctx.moveTo(hz.xStart, ARENA.floorY)
        for (let x = hz.xStart; x < hz.xEnd; x += step) {
          const peakX = Math.min(hz.xEnd, x + step / 2)
          const jitter = 0.7 + 0.3 * Math.abs(Math.sin(x * 12.9898))
          ctx.lineTo(peakX, ARENA.floorY - h * jitter)
          ctx.lineTo(Math.min(hz.xEnd, x + step), ARENA.floorY)
        }
        ctx.closePath()
        ctx.fill()
      }
    } else if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && isVeilHandsFx(getBrideVeilFx())
      && drawVeilHandsActive(ctx, hz, t, ARENA.floorY)) {
      // 影の手 (10-20・src/bride_veil_hands.ts): 腕が伸びて掴み、終わり際に崩れる。描くのは条件の中の関数。
    } else if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && isVeilSidesKind(getBrideVeilFx())
      && drawVeilSidesActive(ctx, getBrideVeilFx() as VeilSidesKind, hz, t, ARENA.floorY, veilTsunamiDir(hz, state.hits, state.player.x, state.boss?.x ?? state.player.x))) {
      // 両側から押し寄せるヴェール (10-23・DEV・src/bride_veil_sides.ts): 波頭が帯の上へ崩れ落ち、終わると床へ崩れて薄れる。
    } else if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && (VEIL_TSUNAMI_KINDS as readonly string[]).includes(getBrideVeilFx())) {
      // ヴェールの津波 (10-23・DEV・src/bride_veil_tsunami.ts): 巻いた波頭が帯の上へ崩れ落ち、終わると跳ね上がって垂れ落ちる。
      drawVeilTsunamiActive(ctx, getBrideVeilFx() as VeilTsunamiKind, hz, t, ARENA.floorY, veilTsunamiDir(hz, state.hits, state.player.x, state.boss?.x ?? state.player.x))
    } else if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && (VEIL_RISE_KINDS as readonly string[]).includes(getBrideVeilFx())) {
      // 床から生えたヴェール (10-23・DEV・src/bride_veil_rise.ts): 伸び切って立ち、終わると重力で落ちる。
      drawVeilRiseActive(ctx, getBrideVeilFx() as VeilRiseKind, hz, t, ARENA.floorY, veilTsunamiDir(hz, state.hits, state.player.x, state.boss?.x ?? state.player.x))
    } else if (hz.kind === 'veil' && hz.attackId === 'veilInvitation' && (getBrideVeilFx() === 'cloth' || getBrideVeilFx() === 'cloth2')) {
      // 布のヴェール (10-23・DEV・src/bride_veil_cloth.ts): 薄い布が立ち上がって波打つ。
      drawVeilClothActive(ctx, getBrideVeilFx() as 'cloth' | 'cloth2', hz, t, ARENA.floorY)
    } else if (hz.kind === 'veil' && hz.attackId === 'hemSweep' && getBladeHemFx() === 'bloom'
      && drawBladeHemActive(ctx, hz, t, ARENA.floorY, state.boss?.x ?? (hz.xStart + hz.xEnd) / 2)) {
      // 裾払いの板と刃の花 (10-20・DEV・src/blade_hem_bloom.ts): 板が順に跳ね上がり、隙間から刃の花びらが開く。
    } else if (hz.kind === 'veil' && hz.attackId === 'veilInvitation') {
      // 花嫁「ヴェールの招待」active (2026-07-10 Codex監査回答で再設計):
      //   技=腕から翻ったヴェールが背後を囲って閉じる。安全=彼女の懐(前)。
      //   telegraph 終端と同じ全高 (reveal=1)・同じ位置で発火 = 形をジャンプさせない (audit-answer.md §4)。
      //   最初 90ms の rise は高さでなく、根元光の小さな衝撃 (alpha ブースト) だけに使う。
      //   active 中は menace=1 (呪いが最大・立入禁止が最も強く読める)。
      drawVeilWall(ctx, hz.xStart, w, ARENA.floorY, 1, fade, t, 1, getBrideVeilFx() === 'wall-cloth' ? brideVeilCurtain() : null)
      if (rise < 1) {
        const kick = (1 - rise) * fade
        ctx.save()
        ctx.globalCompositeOperation = 'lighter'
        // 根元の衝撃フラッシュ (発火の瞬間だけ根元が菫に脈打つ・高さ変化なし)
        ctx.globalAlpha = kick * 0.5
        const impactG = ctx.createLinearGradient(0, ARENA.floorY - 90, 0, ARENA.floorY)
        impactG.addColorStop(0, `rgba(${swc('unparry', '182,144,232')},0)`)
        impactG.addColorStop(1, `rgba(${swc('unparry', '196,158,244')},0.7)`)
        ctx.fillStyle = impactG
        ctx.fillRect(hz.xStart, ARENA.floorY - 90, w, 90)
        // ※旧「上端の白い直線ライン」は撤去 (2026-07-10 ユーザー指摘=発火時に白線がちらつく・硬すぎ)。
        ctx.restore()
      }
      // 締まり (§4): 発火直後の 220ms、両端から菫の光帯が内へ収束 = 「罠が閉じる/きゅっと締まる」。
      //   ゆらゆら揺れてるだけ → 閉じ込める動き へ。 高さ変化はさせない (形は飛ばさない)。
      const cinchP = Math.min(1, activeElapsed / 220)
      if (cinchP < 1) {
        const ca = (1 - cinchP) * fade
        const bandW = w * 0.16
        const inset = (w * 0.5 - bandW) * (cinchP * cinchP)   // 端 → 中央へ加速して寄る
        ctx.save()
        ctx.globalCompositeOperation = 'lighter'
        for (const ex of [hz.xStart + inset, hz.xEnd - inset - bandW]) {
          const cg = ctx.createLinearGradient(ex, 0, ex + bandW, 0)
          cg.addColorStop(0, `rgba(${swc('unparry', '214,158,255')},0)`)
          cg.addColorStop(0.5, `rgba(${swc('unparry', '222,170,255')},${(0.5 * ca).toFixed(3)})`)
          cg.addColorStop(1, `rgba(${swc('unparry', '214,158,255')},0)`)
          ctx.fillStyle = cg
          ctx.fillRect(ex, ARENA.floorY - 246, bandW, 246)
        }
        ctx.restore()
      }
    } else if (hz.kind === 'veil') {
      // 剣舞 hemSweep / 先代の姫 curtainSweep 等 (branch 着手前の既存表示・audit-answer.md §7):
      //   布が判定幅へ静的に敷かれ、 waveX の光が左→右へ抜ける (fxlab v3 rev2 veil 経路)。
      //   婚礼ヴェールの壁 (drawVeilWall) は出さない = 花嫁固有の意味を他ボスへ漏らさない。
      const img = getBrideHazard('veil_stream')
      if (img && img.complete && img.naturalWidth > 0) {
        const dh = 160
        const dyTop = ARENA.floorY - 64 - dh / 2
        const crop = HAZARD_CROP_FRAC.veil_stream
        const srcX = img.naturalWidth * crop
        const srcW = img.naturalWidth * (1 - crop * 2)
        // 1) 静的な布の敷き (crop 済素材を判定幅全体に scaleX)
        ctx.globalCompositeOperation = 'source-over'
        ctx.globalAlpha = 0.6 * rise * fade
        ctx.drawImage(img, srcX, 0, srcW, img.naturalHeight, hz.xStart, dyTop, w, dh)
        // 2) waveX 光の走り (左→右へ抜ける・幅 dw の 35% が明るく走る)
        ctx.save()
        const runW = w * 0.35
        const runX = hz.xStart - runW + (w + runW) * Math.min(1, aProg / 0.9)
        ctx.beginPath()
        ctx.rect(Math.max(hz.xStart, runX - runW / 2), dyTop - 4, Math.min(w, runW), dh + 8)
        ctx.clip()
        ctx.globalCompositeOperation = 'lighter'
        ctx.globalAlpha = 0.55 * rise * fade
        ctx.drawImage(img, srcX, 0, srcW, img.naturalHeight, hz.xStart, dyTop, w, dh)
        ctx.restore()
      } else {
        // sprite 未読込み時のフォールバック: 旧 fillRect 帯
        ctx.globalCompositeOperation = 'lighter'
        const bandY = ARENA.floorY - 64
        const bandH = 58
        ctx.globalAlpha = 0.3 * rise * fade
        ctx.fillStyle = '#cfc4e6'
        ctx.fillRect(hz.xStart, bandY - bandH / 2, w, bandH)
      }
    } else if (hz.kind === 'shock' && isRampageHazard(hz)
      && drawRampageGrudge(ctx, hz, 1, aProg > 0.6 ? (1 - aProg) / 0.4 : 1,
        // 着地 (rampage_slam) の瞬間に噴き上がる。 90ms で全開 = 踏み砕いた勢いに見せる。
        Math.min(1, (aProg * hz.activeMs) / 90))) {
      // 覚醒王「大暴れ」active: 噴出→ activeMs 後半で素早く消える。
    } else if (hz.kind === 'shock' && isShadeRippleHazard(hz)
      && shadeMistLookOn() && drawShadeWaveMist(ctx, hz, t, state.boss?.x ?? hz.xEnd)) {
      // 「床をすべる霧と柱」の当たり (柱が立ちきり、細って消える・src/shade_wave_mist_fx.ts)
    } else if (hz.kind === 'shock' && isShadeRippleHazard(hz)) {
      // 亡霊の波 (shadeRipple) active: 儀式境界線でなく霊気バーストへ差し替え (チケットE)
      //   shadeWaveSync (既定 on): 溜めの終わりから立ち上げ済みなので、当たりの開始で全開 (src/shade_wave_sync.ts)。
      const rippleRise = rippleSyncOn()
        ? Math.min(1, (activeElapsed + RIPPLE_SYNC_LEAD_MS) / RIPPLE_RISE_MS) : rise
      drawShadeRippleActive(ctx, hz, t, rippleRise, fade)
    } else if (hz.kind === 'shock' && hz.attackId === 'houndRoar' && getHoundRoarFx() === 'floor'
      && drawHoundRoarActive(ctx, hz, t, ARENA.floorY)) {
      // めくれる床 (10-20・src/hound_roar_floor.ts): 獣の側から床石がめくれ、前へ転がり跳ねる。描くのは条件の中の関数。
    } else if (hz.kind === 'shock') {
      // shock: 床に刻まれた境界線。 白金の細ライン + 端の縦柱 + 広がる縁エッジ。
      // 汎用 gold rect → 冷青紫の境界刻印 (赤・金禁止)
      const lineY = ARENA.floorY - 2
      // 境界線本体 (白金・細)
      ctx.globalAlpha = 0.85 * rise * fade
      ctx.strokeStyle = '#c8d8f0'
      ctx.lineWidth = 2
      ctx.beginPath()
      ctx.moveTo(hz.xStart, lineY)
      ctx.lineTo(hz.xEnd, lineY)
      ctx.stroke()
      // 端柱 (左右に高さのある縦ポスト)
      const postH = 40 * rise
      ctx.lineWidth = 2.5
      ctx.shadowColor = '#90b8e0'
      ctx.shadowBlur = 6
      for (const sx of [hz.xStart, hz.xEnd]) {
        ctx.beginPath()
        ctx.moveTo(sx, lineY)
        ctx.lineTo(sx, lineY - postH)
        ctx.stroke()
      }
      ctx.shadowBlur = 0
      // 広がるエッジ輝線 (活性化した「刻印が焼ける」瞬間を走る光)
      ctx.globalCompositeOperation = 'lighter'
      const edgeFrac = Math.min(1, activeElapsed / Math.max(1, hz.activeMs * 0.5))
      const edgeX = hz.xStart + w * edgeFrac
      ctx.globalAlpha = 0.6 * rise * fade * (1 - edgeFrac * 0.6)
      ctx.strokeStyle = '#e0f0ff'
      ctx.lineWidth = 4
      ctx.shadowColor = '#b0d8ff'
      ctx.shadowBlur = 8
      ctx.beginPath()
      ctx.moveTo(hz.xStart, lineY)
      ctx.lineTo(edgeX, lineY)
      ctx.stroke()
      ctx.shadowBlur = 0
      // 判定域の極薄フロア光 (「床が冷たく光る」)
      ctx.globalAlpha = 0.07 * rise * fade
      const floorGlow = ctx.createLinearGradient(0, lineY - 14, 0, lineY + 4)
      floorGlow.addColorStop(0, 'rgba(180,220,255,0)')
      floorGlow.addColorStop(0.7, 'rgba(180,220,255,0.7)')
      floorGlow.addColorStop(1, 'rgba(180,220,255,0)')
      ctx.fillStyle = floorGlow
      ctx.fillRect(hz.xStart, lineY - 14, w, 18)
    } else if (hz.kind === 'buttTrap' && getKnightButtFx() !== 'now') {
      // 石突の割れ目 (10-08 ユーザー採用＝配布版の既定): 石突の着点から割れ目が走り (約2コマ)、帯で石の板が持ち上がって砕ける。
      drawButtCrackActive(ctx, hz, t, knightButtImpactX(state, hz))
    } else if (hz.kind === 'buttTrap') {
      // lanceButt 床隆起: 判定 0ms から石畳が割れて持ち上がっている。
      // Y 移動なし。scaleY 1.04→1.0 (60ms) で衝撃の「弾け」を表現。
      // fade は aProg > 0.85 の終わり際のみ (active 70%超まではっきり表示)。
      const cx = (hz.xStart + hz.xEnd) / 2
      const eruption = getLanceButtEruption()
      const impact = Math.min(1, activeElapsed / 60)
      const impactScale = 1 + 0.04 * (1 - impact)  // scaleY 1.04→1.0 (60ms)
      const burstFade = Math.max(0, 1 - activeElapsed / 80)  // 衝撃演出の強度
      // active 0ms から 0.95。aProg > 0.85 の最後15%だけフェードアウト
      const spriteAlpha = aProg > 0.85 ? 0.95 * (1 - aProg) / 0.15 : 0.95
      if (eruption) {
        const displayH = 44
        // 判定幅 100px に対して表示幅 130px に固定 (スプライト比率ではなく中央クロップで対応)
        const displayW = 130
        // スプライト中央 50% だけ描く (1248x202 素材の両端余白を省く)
        const srcCropX = eruption.naturalWidth * 0.25
        const srcCropW = eruption.naturalWidth * 0.5
        const sx = cx - displayW / 2
        const sy = ARENA.floorY - displayH  // 接地位置固定・Y移動なし

        // scaleY: 底面 floorY 固定・上方向だけ 1.04→1.0 で弾く
        ctx.save()
        ctx.translate(cx, ARENA.floorY)
        ctx.scale(1, impactScale)
        ctx.translate(-cx, -ARENA.floorY)
        ctx.globalAlpha = spriteAlpha
        ctx.drawImage(eruption, srcCropX, 0, srcCropW, eruption.naturalHeight, sx, sy, displayW, displayH)
        ctx.restore()

        // 亀裂底の赤い閃光: active 0ms から最大、以降も薄く持続
        ctx.globalCompositeOperation = 'lighter'
        ctx.globalAlpha = (0.50 * burstFade + 0.15) * spriteAlpha
        const crackGrad = ctx.createLinearGradient(0, ARENA.floorY - 12, 0, ARENA.floorY)
        crackGrad.addColorStop(0, 'rgba(255,40,20,0)')
        crackGrad.addColorStop(1, 'rgba(255,70,30,0.9)')
        ctx.fillStyle = crackGrad
        ctx.fillRect(hz.xStart - 14, ARENA.floorY - 12, w + 28, 12)

        // 粉塵ラジアル: active 0ms から最大、以降も薄く持続
        ctx.globalAlpha = (0.22 * burstFade + 0.06) * spriteAlpha
        const dustGrad = ctx.createRadialGradient(cx, ARENA.floorY, 0, cx, ARENA.floorY, displayW * 0.65)
        dustGrad.addColorStop(0, 'rgba(200,150,100,0.7)')
        dustGrad.addColorStop(1, 'rgba(180,90,50,0)')
        ctx.fillStyle = dustGrad
        ctx.fillRect(hz.xStart - 20, ARENA.floorY - 16, w + 40, 20)

        // 小石の飛沫: 衝撃時のみ
        if (burstFade > 0) {
          ctx.globalCompositeOperation = 'source-over'
          ctx.globalAlpha = 0.55 * burstFade * spriteAlpha
          ctx.fillStyle = '#8a7a6a'
          for (let i = 0; i < 5; i++) {
            const px = hz.xStart + (w / 5) * (i + 0.5)
            const ph = (5 + 8 * Math.abs(Math.sin(px * 3.7))) * burstFade
            ctx.beginPath()
            ctx.moveTo(px - 3, ARENA.floorY)
            ctx.lineTo(px, ARENA.floorY - ph)
            ctx.lineTo(px + 3, ARENA.floorY)
            ctx.closePath()
            ctx.fill()
          }
        }
      } else {
        // フォールバック: スプライト未ロード → 位置固定の低い灰色隆起 (0ms から表示)
        ctx.globalAlpha = 0.8 * spriteAlpha
        ctx.fillStyle = '#4a3858'
        ctx.fillRect(hz.xStart, ARENA.floorY - 20, w, 20)
        ctx.globalCompositeOperation = 'lighter'
        ctx.globalAlpha = (0.55 * burstFade + 0.20) * spriteAlpha
        ctx.fillStyle = '#ff2820'
        ctx.fillRect(hz.xStart, ARENA.floorY - 10, w, 10)
      }
    } else if (hz.kind === 'quake' && getQuakeLook() !== 'old' && (hz.attackId === 'exec_maulQuake' || hz.attackId === 'exec_cannonMortar')
      && drawExecFloorActive(ctx, hz, t, quakeFxContext(hz), ARENA.floorY)) {
      // 地割り＝石柱・榴弾＝爆炎と石の柱 (10-20・src/exec_floor_fx.ts)。?execFloorFx=old で下の前の見た目。
    } else if (hz.kind === 'quake' && getQuakeLook() !== 'old') {
      // 🔵 2026-09-03 第5便: 地割りの噴出 3案 (src/quake_fx.ts)。
      drawQuakeActive(ctx, hz, t, quakeFxContext(hz), getQuakeLook())
    } else if (hz.kind === 'quake') {
      // 処刑人 E10 地割り: telegraph の亀裂が開き、そこから石板・石片・土埃が噴き上がる。
      //   ⚠️ 判定/秒数は不変。派手発光・熱色・魔法陣を使わず、冷たい灰王城の石と埃だけで作る。
      const floorY = ARENA.floorY
      const cx = (hz.xStart + hz.xEnd) / 2
      const peakH = Math.min(68, Math.max(58, w * 0.62)) // 旧28pxでは240pxの刑吏に負けたため約2.2倍
      // 石板の高さカーブ (activeMs 250ms 想定): 0→45ms 急上昇 / 45→165ms 保持 / 残りで沈む
      let bumpH: number
      if (activeElapsed < 45) {
        const p = activeElapsed / 45
        bumpH = peakH * (1 - (1 - p) * (1 - p))
      } else if (activeElapsed < 165) {
        bumpH = peakH
      } else {
        const p = Math.max(0, Math.min(1, (activeElapsed - 165) / Math.max(1, hz.activeMs - 165)))
        bumpH = peakH * (1 - p)
      }
      const bumpAlpha = aProg < 0.9 ? 1 : Math.max(0, 1 - (aProg - 0.9) / 0.1)
      const burst = Math.max(0, 1 - activeElapsed / 145)

      // ① telegraph から連続する裂け口。床面を暗く開き、灰色の欠け縁で位置と幅を残す。
      ctx.globalCompositeOperation = 'source-over'
      ctx.globalAlpha = bumpAlpha
      ctx.fillStyle = '#08090b'
      ctx.beginPath()
      ctx.moveTo(hz.xStart - 8, floorY - 3)
      ctx.lineTo(cx - w * 0.28, floorY - 11 - 5 * burst)
      ctx.lineTo(cx, floorY - 7)
      ctx.lineTo(cx + w * 0.3, floorY - 12 - 4 * burst)
      ctx.lineTo(hz.xEnd + 8, floorY - 2)
      ctx.lineTo(cx + w * 0.34, floorY + 4)
      ctx.lineTo(cx - w * 0.32, floorY + 3)
      ctx.closePath()
      ctx.fill()
      ctx.globalAlpha = 0.8 * bumpAlpha
      ctx.strokeStyle = '#77716a'
      ctx.lineWidth = 2
      ctx.beginPath()
      ctx.moveTo(hz.xStart - 5, floorY - 4)
      ctx.lineTo(cx - w * 0.28, floorY - 11 - 5 * burst)
      ctx.lineTo(cx, floorY - 7)
      ctx.lineTo(cx + w * 0.3, floorY - 12 - 4 * burst)
      ctx.lineTo(hz.xEnd + 5, floorY - 3)
      ctx.stroke()

      // ② 一枚の丸い隆起ではなく、割れた石板5枚が裂け口から別々にせり上がる。
      if (bumpH > 1) {
        const stoneGrad = ctx.createLinearGradient(0, floorY - bumpH, 0, floorY)
        stoneGrad.addColorStop(0, '#66615c')
        stoneGrad.addColorStop(0.48, '#3d3a38')
        stoneGrad.addColorStop(1, '#171719')
        for (let i = 0; i < 5; i += 1) {
          const u0 = i / 5
          const u1 = (i + 1) / 5
          const x0 = hz.xStart + w * u0 - 4
          const x1 = hz.xStart + w * u1 + 4
          const mid = (x0 + x1) / 2
          const localH = bumpH * (0.78 + 0.25 * hash01(hz.xStart * 0.031 + i * 8.13))
          const lean = (hash01(i * 4.17 + hz.xEnd) - 0.5) * 10
          ctx.globalAlpha = bumpAlpha
          ctx.fillStyle = stoneGrad
          ctx.beginPath()
          ctx.moveTo(x0, floorY)
          ctx.lineTo(mid - (x1 - x0) * 0.32 + lean, floorY - localH * 0.82)
          ctx.lineTo(mid + lean, floorY - localH)
          ctx.lineTo(mid + (x1 - x0) * 0.3 + lean, floorY - localH * 0.76)
          ctx.lineTo(x1, floorY)
          ctx.closePath()
          ctx.fill()
          ctx.globalAlpha = 0.55 * bumpAlpha
          ctx.strokeStyle = '#827c75'
          ctx.lineWidth = 1.2
          ctx.stroke()
        }
      }

      // ③ 土埃の柱。床に寝る小さな霞ではなく、亀裂から上へ噴き出してから横へほどける。
      const dustP = Math.min(1, activeElapsed / 110)
      const dustFade = Math.max(0, 1 - activeElapsed / Math.max(1, hz.activeMs))
      ctx.globalCompositeOperation = 'source-over'
      for (let i = 0; i < 5; i += 1) {
        const spread = (i - 2) * w * 0.16
        const drift = (hash01(hz.xStart * 0.013 + i * 6.7) - 0.5) * 18
        const dustY = floorY - 16 - dustP * (28 + hash01(i * 3.9) * 38)
        const radius = 22 + hash01(i * 5.4 + hz.xEnd) * 14
        const dustGrad = ctx.createRadialGradient(
          cx + spread + drift * dustP, dustY, 0,
          cx + spread + drift * dustP, dustY, radius,
        )
        dustGrad.addColorStop(0, 'rgba(146,140,132,0.58)')
        dustGrad.addColorStop(0.5, 'rgba(112,108,103,0.30)')
        dustGrad.addColorStop(1, 'rgba(82,80,78,0)')
        ctx.globalAlpha = (0.22 + 0.38 * burst) * dustFade
        ctx.fillStyle = dustGrad
        ctx.fillRect(
          cx + spread + drift * dustP - radius,
          dustY - radius,
          radius * 2,
          radius * 2,
        )
      }

      // ④ 大小の石片を裂け口から放射。円粒ではなく角のある欠片を回転させる。
      if (activeElapsed < 180) {
        const chunkP = Math.max(0, Math.min(1, activeElapsed / 180))
        const lift = Math.sin(Math.PI * chunkP)
        ctx.globalCompositeOperation = 'source-over'
        ctx.globalAlpha = 0.95 * (1 - chunkP * 0.65)
        for (let i = 0; i < 10; i += 1) {
          const seed = hz.xStart * 0.017 + i * 7.31
          const dir = i % 2 === 0 ? 1 : -1
          const startX = cx + (hash01(seed) - 0.5) * w * 0.45
          const lateral = dir * (24 + hash01(seed + 1) * 48)
          const px = startX + lateral * chunkP
          const py = floorY - 8 - lift * (45 + hash01(seed + 2) * 48) + chunkP * 12
          const size = 3.5 + hash01(seed + 3) * 5
          ctx.save()
          ctx.translate(px, py)
          ctx.rotate((hash01(seed + 4) - 0.5) * 1.2 + dir * chunkP * 2.6)
          ctx.fillStyle = i % 3 === 0 ? '#716b64' : '#4e4a47'
          ctx.beginPath()
          ctx.moveTo(-size, -size * 0.35)
          ctx.lineTo(-size * 0.15, -size)
          ctx.lineTo(size, -size * 0.2)
          ctx.lineTo(size * 0.35, size)
          ctx.lineTo(-size * 0.8, size * 0.55)
          ctx.closePath()
          ctx.fill()
          ctx.restore()
        }
      }

      // ⑤ 沈み際に落ちる細粒。裂け口へ戻る方向を残し、末尾は bumpAlpha と共に0まで消す。
      if (aProg > 0.45 && bumpAlpha > 0) {
        ctx.globalCompositeOperation = 'source-over'
        ctx.globalAlpha = 0.48 * bumpAlpha
        ctx.fillStyle = '#625d57'
        for (let i = 0; i < 7; i += 1) {
          const seed = i * 5.3 + hz.xStart * 0.01
          const px = cx + (hash01(seed) - 0.5) * w * 0.8
          const fallP = ((activeElapsed - 70) / 70 + hash01(seed + 1)) % 1
          const py = floorY - bumpH * 0.8 + fallP * Math.max(12, bumpH * 0.9)
          const size = 1 + hash01(seed + 2) * 1.8
          ctx.beginPath()
          ctx.arc(px, py, size, 0, Math.PI * 2)
          ctx.fill()
        }
      }
    } else if (hz.kind === 'roarWave') {
      // 処刑人 G11 咆哮波: 口から広がる音波バンド ")))" + 空気の歪み (スタイル 1+7・2026-07-03)。
      //   ⚠️ 床/縦壁は描かない = 咆哮は口から空気を伝わって広がる。 boss の顔の高さを中心に
      //     同心の弧が外へ膨らむ (sin ゆらぎで歪ませ「空気が震える」)。
      const floorY = ARENA.floorY
      const cx = (hz.xStart + hz.xEnd) / 2
      const bossX = state.boss.x
      const bh = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[state.boss.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
      const ringCenterY = floorY - bh * 0.5      // 円の中心 = ボスの胴
      // peak カーブ: 0→50ms 急上昇 / 50→130ms ホールド / 130→250ms 減衰
      let peak: number
      if (activeElapsed < 50) peak = (activeElapsed / 50)
      else if (activeElapsed < 130) peak = 1
      else peak = Math.max(0, 1 - (activeElapsed - 130) / 120)

      // 比較版 (DEV ?roarTell=v2): 噴いた瞬間も帯の中の光とほこりで見せる。&roarRing=keep の時だけ下の輪も重ねる。
      if (import.meta.env.DEV && roarTellOn()) drawRoarTellBand(ctx, hz, t)
      const ringsHidden = import.meta.env.DEV && roarRingsHidden()
      // この波の半径 = boss 中心からバンド中心までの距離。 左右バンドは対称なので
      //   右側 (cx>=bossX) のバンドでだけ全円を1回描く (二重描画を避ける・円は両側を覆う)。
      if (cx >= bossX && !ringsHidden) {
        // 輪の半径 = 帯の中心まで。DEV ?roarParry=1&roarEscape=none で帯を広げた時だけ、今と同じ半径 (ringRadiusPx) で描く。
        const R = Math.max(20, hz.ringRadiusPx ?? (cx - bossX))
        const rx = R
        const ry = R * 0.72                       // わずかに縦を潰した円 (見上げ視点)
        // active 中に少し外へ膨らむ (音が広がる)
        const spread = 1 + 0.18 * Math.min(1, activeElapsed / 250)
        ctx.save()
        ctx.globalCompositeOperation = 'lighter'
        // 同心の歪む円 3 本 (太→細)。 sin ゆらぎで空気が震える。
        for (let ri = 0; ri < 3; ri += 1) {
          const off = (ri - 1) * 9              // -9 / 0 / +9 で3重
          const wob = 0.04 + ri * 0.015
          const phase = t * 6 + ri * 1.3
          const a = peak * (0.55 - ri * 0.12)
          const col = ri === 1 ? '#ffffff' : (ri === 0 ? '#f0ece2' : '#d0c8bc')
          drawSoundRing(ctx, bossX, ringCenterY, (rx + off) * spread, (ry + off * 0.72) * spread,
            wob, phase, col, 2.2 - ri * 0.5, a)
        }
        ctx.restore()
      }
    } else if (hz.kind === 'light') {
      // 姫の舞台フェーズ: 落ちる照明の光柱 (天から床までの縦帯)
      ctx.globalCompositeOperation = 'lighter'
      const grad = ctx.createLinearGradient(0, 0, 0, ARENA.floorY)
      grad.addColorStop(0, 'rgba(255,244,205,0.55)')
      grad.addColorStop(1, 'rgba(255,244,205,0.12)')
      ctx.globalAlpha = 0.8 * rise * fade
      ctx.fillStyle = grad
      ctx.fillRect(hz.xStart, 0, w, ARENA.floorY)
      // 床の輪 (光が当たっている範囲を明示)
      ctx.globalAlpha = 0.7 * rise * fade
      ctx.strokeStyle = '#ffe9a8'
      ctx.lineWidth = 3
      ctx.beginPath()
      ctx.ellipse((hz.xStart + hz.xEnd) / 2, ARENA.floorY, w / 2, 8, 0, 0, Math.PI * 2)
      ctx.stroke()
    } else {
      // embrace: 閉じる腕の影 (半透明の白い弧・内へ縮む)
      const cx = (hz.xStart + hz.xEnd) / 2
      const r = (w / 2) * (1 - 0.25 * aProg)
      ctx.globalAlpha = 0.4 * rise * fade
      ctx.strokeStyle = '#e8e0f0'
      ctx.lineWidth = 10 * (1 - 0.4 * aProg)
      ctx.beginPath()
      ctx.arc(cx, ARENA.floorY - 52, r, Math.PI * 0.05, Math.PI * 0.95, false)
      ctx.stroke()
      ctx.globalAlpha = 0.18 * rise * fade
      ctx.fillStyle = '#cdb8e0'
      ctx.beginPath()
      ctx.arc(cx, ARENA.floorY - 52, r, 0, Math.PI * 2)
      ctx.fill()
    }
    ctx.restore()
  }
  // 石突の割れ目 (10-08 2版＝配布版の既定): 当たりが消えた後も土煙と石くずを少し残してから晴らす (描くだけ)。
  if (getKnightButtFx() !== 'now') drawButtCrackLinger(ctx, t, state.hits)
  // 影の手 (10-20): 当たりが消えた後、腕のかけらとヴェールの切れ端が舞い、影だまりが引く (描くだけ)。
  if (isVeilHandsFx(getBrideVeilFx())) drawVeilHandsLinger(ctx, t, state.hits, ARENA.floorY)
  // 布のヴェール (10-23・DEV): 当たりが消えた後も波打ったまま垂れ、上から薄れて消える (描くだけ)。
  else if ((VEIL_TSUNAMI_KINDS as readonly string[]).includes(getBrideVeilFx())) drawVeilTsunamiLinger(ctx, t, state.hits, ARENA.floorY)
  else if ((VEIL_RISE_KINDS as readonly string[]).includes(getBrideVeilFx())) drawVeilRiseLinger(ctx, t, state.hits, ARENA.floorY)
  else if (isVeilSidesKind(getBrideVeilFx())) drawVeilSidesLinger(ctx, t, state.hits, ARENA.floorY)
  else if (getBrideVeilFx() !== 'wall-cloth') drawVeilClothLinger(ctx, t, state.hits, ARENA.floorY)   // wall-cloth は前の壁と同じく残りを描かない
  // 裾払いの板と刃の花 (10-20・DEV): 当たりが消えた後、刃と木のかけらが落ち、板が倒れて照りが引く (描くだけ)。
  if (getBladeHemFx() === 'bloom') drawBladeHemLinger(ctx, t, state.hits, ARENA.floorY)
  // めくれる床 (10-20): 当たりが消えた後、板が床で薄れ、灰が沈んで晴れる (描くだけ)。
  if (getHoundRoarFx() === 'floor') drawHoundRoarLinger(ctx, t, state.hits, ARENA.floorY)
  // 介錯の石柱・榴弾 (10-20): 当たりが消えた後、柱が沈み、煙が昇り、瓦礫が薄れる (描くだけ)。
  drawExecFloorLinger(ctx, t, state.hits, ARENA.floorY)
  if (roosterFx() === 'v1') drawRoosterFeatherLinger(ctx, t, state.hits, ARENA.floorY)
}

// ============== プレイヤー ==============

// drawPlayer 内で使用される動作別アニメフレーム描画の共通ロジック抽出
// ============== プレイヤーの縁取り/リム合成 ==============
// 切り抜きキャラが背景に「貼り付け」て見えるのを防ぐため、 本体を一旦オフスクリーンに
// 描き、 シルエットを単色化して 全周(薄い暗縁) or 片側(月光リム) に敷いてから本体を重ねる。
// (ENDER LILIES 等の 2D 切り抜き系が背景と馴染ませるのに使う手法。)
//   'dark' = 薄い暗い縁取り / 'rim' = 月光のクールなリム / 'off' = 無し(従来通り直接描画)
const OUTLINE_MODE: 'dark' | 'rim' | 'off' = 'dark'
type OutlineBuf = { canvas: HTMLCanvasElement; ctx: CanvasRenderingContext2D }
type OutlinePair = { buf: OutlineBuf; silh: OutlineBuf }
const outlineBufs: Record<string, OutlinePair> = {}
// 主人公・ボス共用の縁取り用オフスクリーン (key ごとに 本体バッファ + シルエットバッファ)。
function getOutlineBuffers(key: string): OutlinePair | null {
  if (typeof document === 'undefined') return null
  let pair = outlineBufs[key]
  if (!pair) {
    const w = Math.round(ARENA.width * renderScale()), h = Math.round(ARENA.height * renderScale())
    const mk = (): OutlineBuf | null => {
      const c = document.createElement('canvas'); c.width = w; c.height = h
      const x = c.getContext('2d'); if (x) compensateShadowBlur(x); return x ? { canvas: c, ctx: x } : null
    }
    const buf = mk(); const silh = mk()
    if (!buf || !silh) return null
    pair = { buf, silh }
    outlineBufs[key] = pair
  }
  return pair
}

// バッファに描いた本体を、 薄い暗縁(or 月光リム)付きで ctx へ合成 (主人公・ボス共通)。
// content は ARENA 座標・内部解像度 RENDER_SCALE 倍で描かれている前提。
function compositeWithOutline(ctx: CanvasRenderingContext2D, bufs: OutlinePair): void {
  const sctx = bufs.silh.ctx
  const W = bufs.silh.canvas.width, H = bufs.silh.canvas.height
  sctx.setTransform(1, 0, 0, 1, 0, 0)
  sctx.globalCompositeOperation = 'source-over'
  sctx.clearRect(0, 0, W, H)
  sctx.drawImage(bufs.buf.canvas, 0, 0)
  sctx.globalCompositeOperation = 'source-in'
  sctx.fillStyle = OUTLINE_MODE === 'rim' ? 'rgba(196,186,228,1)' : 'rgba(6,4,12,1)'
  sctx.fillRect(0, 0, W, H)
  sctx.globalCompositeOperation = 'source-over'

  // バッファは画面座標で描かれている → 世界座標系では カメラ分ずらした位置へ合成する (drawBufferToWorld)。
  ctx.save()
  if (OUTLINE_MODE === 'rim') {
    ctx.globalAlpha = 0.5
    drawBufferToWorld(ctx, bufs.silh.canvas, -1.2, -1.6)
    drawBufferToWorld(ctx, bufs.silh.canvas, 1.2, -1.6)
  } else {
    ctx.globalAlpha = 0.34
    const o = 1.3
    for (let i = 0; i < 8; i += 1) {
      const a = (i / 8) * Math.PI * 2
      drawBufferToWorld(ctx, bufs.silh.canvas, Math.cos(a) * o, Math.sin(a) * o)
    }
  }
  ctx.restore()
  drawBufferToWorld(ctx, bufs.buf.canvas)
}

// Spine 経路で描く PlayerVisualState の一覧。
//   🔴 ここへ入れ忘れた state は、黙って旧 frame-by-frame 経路へ落ちる。
//      2026-07-20 に 'guarding' で実際に起きた事故:
//        ①承認済みの姿 (案C) が出ない ②Spine 経路の中でしか呼ばれない overlay
//        ガード専用の描画が一度も実行されなかった (当時は体幹連動の持続光。 2026-07-20 に撤去済み)。
//      しかも見た目が「別の絵で普通に描かれる」ため、静止画では正常に見えてしまう。
//   新しい PlayerVisualState を足したら、必ずここも見ること (tests/spine_path_states.test.ts が守る)。
const SPINE_PATH_STATES = new Set<PlayerVisualState>([
  'idle', 'walking', 'walking_back', 'attacking', 'counter', 'parrying', 'stepping',
  'guarding', 'executing', 'stunned', 'defeat',
  // 掴み拘束 (処刑人 D8/D9): 専用アニメ未 author = resolveSpineAnimation が stunned を代用返却する。
  'grabbed',
])

export function usesSpinePath(s: PlayerVisualState): boolean {
  return SPINE_PATH_STATES.has(s)
}

// 回避 d (10-07): 当たりの位置は等速のまま、描く位置だけ「一瞬で出て減速する」滑りに見せる。 体の芯を通る回避 (coreStepLanding) は別の動き方なので触らない
function playerDodgeVisualLead(p: GameState['player']): number {
  if (p.state !== 'stepping' || p.coreStepLanding) return 0
  return dodgeVisualLeadPx(p.stateElapsed, p.stepDir ?? 0)
}

// 止め (アリスの技を手本にした版・DEV ?lunaExec=swap・src/luna_exec_swap.ts): 描く位置だけ相手の向こうへ駆け抜ける。ゲームの位置は動かさない。
function aliceDashPush(state: GameState): number {
  const clock = aliceClockMs(state)
  if (clock === null) return 0
  return aliceDashOffsetPx(clock, state.player, state.boss, arenaBoundsFor(state.boss.id))
}

// deathRim (0..1): DEV ?deathFront=1 の死の一拍〜負け画面だけ、暗い縁取りの代わりに薄い月光の縁を付ける濃さ。配布版は常に 0 (従来どおり)。
function drawPlayer(ctx: CanvasRenderingContext2D, state: GameState, deathRim = 0): void {
  const p = state.player
  const impactPush = guardImpactVisualPush(state) + playerDodgeVisualLead(p) + aliceDashPush(state)

  // 足元の接地影 (縁取り対象外なので main に直接、 キャラより先に敷く)
  ctx.save()
  ctx.translate(p.x + impactPush, p.y)
  ctx.globalAlpha = 0.42
  ctx.fillStyle = 'rgba(4,2,10,1)'
  ctx.beginPath(); ctx.ellipse(0, -2, 34, 9, 0, 0, Math.PI * 2); ctx.fill()
  ctx.restore()

  const bufs = OUTLINE_MODE === 'off' ? null : getOutlineBuffers('player')
  if (!bufs) { renderPlayerInto(ctx, state); drawCounterSignalOverlay(ctx, state); return }

  // キャラ本体をバッファへ描き (ARENA 座標・内部解像度 RENDER_SCALE 倍) → 暗縁付きで合成
  const bctx = bufs.buf.ctx
  resetOutlineBuffer(bctx)
  renderPlayerInto(bctx, state)
  // 回避反撃「影抜き」(DEV ?counterLook=shadow): 回避を始めた最初のコマの姿を、見切った時に残す影として写しておく。
  if (counterLookShadow() && p.state === 'stepping') {
    captureDodgeStartShadow(bufs.buf.canvas, renderScale() * ARENA.width / bufferRect().w, bufferRect().x, p.lastStepStartMs, p.x + impactPush, p.y, bufferRect().y)
  }
  drawDodgeTrail(ctx, bufs.buf.canvas, state)
  // 重なった主人公を読みやすくする rim (配布版・src/overlap_read_1104.ts): 獣と重なった間だけ同じ月光の縁。?overlapRead=old で 0。
  const overlapRim = state.phase === 'playing' ? overlapRimStrength(state.boss?.id, p.x, state.boss?.x ?? 0) : 0
  if (deathRim > 0) compositeWithDeathRim(ctx, bufs, deathRim)
  else if (overlapRim > 0) compositeWithDeathRim(ctx, bufs, overlapRim)
  else compositeWithOutline(ctx, bufs)
  drawCounterSignalOverlay(ctx, state)
}

// 回避反撃「影抜き」(DEV ?counterLook=shadow・10-09 ユーザー dodge.signal「出す」): 「いま反撃できる」合図をレイピアの上に出す。
//   🔴 Spine で描いた時も必ず通る場所 (drawPlayer の合成の後) に置く。 今の金の足元の光 (drawCounterAura) と剣先の金は
//      素材を使わない予備の描き方の中でしか呼ばれず、Spine で描ける時は手前で戻るので配布版の画面に出ていない (10-09 夜の点検)。
//   色は銀白 (金はジャストパリィだけの色)。 tests/dodge_counter_look.test.ts が呼ぶ場所を見張る。
function drawCounterSignalOverlay(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (!counterLookShadow()) return
  const p = state.player
  const strength = counterSignalStrength(p.counterWindow)
  if (strength <= 0) return
  const sinceOpen = PLAYER.counterWindowMs / 1000 - p.counterWindow
  drawCounterSignal(ctx, playerBladePoints(state), sinceOpen, strength, state.time)
}

// 主人公を描いた足元と向き (renderPlayerInto と同じ位置・「毛先の紫」の比較版が髪と宝石の位置に使う)。
function playerFoot(state: GameState): PlayerFoot {
  const p = state.player
  return { x: p.x + guardImpactVisualPush(state) + playerDodgeVisualLead(p), y: p.y, facing: p.facing === 'right' ? 1 : -1 }
}

// レイピアの根元と剣先 (世界座標)。 Spine で描いていれば骨から、まだ読み込み前なら予備の描き方の槍の位置。
function playerBladePoints(state: GameState): BladePoints {
  const p = state.player
  const f = p.facing === 'right' ? 1 : -1
  const footX = p.x + guardImpactVisualPush(state) + playerDodgeVisualLead(p)
  const bone = spinePlayerRapierPoints()
  if (bone) {
    return {
      grip: { x: footX + f * bone.grip.x, y: p.y - bone.grip.y },
      tip: { x: footX + f * bone.tip.x, y: p.y - bone.tip.y },
    }
  }
  return { grip: { x: footX + f * 9, y: p.y - 44 }, tip: { x: footX + f * 65, y: p.y - 51 } }
}

// 見切った所に残る影 (ボスより先に描く)。 見切りの瞬間 = perfect_dodge の時刻。
function drawMikiriShadowLayer(ctx: CanvasRenderingContext2D, state: GameState): void {
  const p = state.player
  resetMikiriShadowIfRewound(state.time)
  for (const f of state.fx) {
    if (f.kind === 'perfect_dodge' && state.time - f.t >= 0 && state.time - f.t < 0.2) noteMikiri(f.t, p.lastStepStartMs)
  }
  const inCounter = p.state === 'attacking' && p.attackIsCounter
  drawMikiriShadow(ctx, state.time, {
    x: p.x, y: p.y, dir: p.facing === 'right' ? 1 : -1,
    counterStartT: inCounter ? state.time - p.stateElapsed : null,
  })
}

// DEV ?deathFront=1 (10-09 R2) の縁の光: 本体の形を薄い月光色に塗り、全周 8 方向へ 1.6px ずらして敷いてから本体を重ねる。
//   暗い獣の胸・前脚に重なった暗い服の主人公を、形だけ浮かせる (明るく光らせない = 加算にしない)。
function compositeWithDeathRim(ctx: CanvasRenderingContext2D, bufs: OutlinePair, strength: number): void {
  const sctx = bufs.silh.ctx
  const W = bufs.silh.canvas.width, H = bufs.silh.canvas.height
  sctx.setTransform(1, 0, 0, 1, 0, 0)
  sctx.globalCompositeOperation = 'source-over'
  sctx.clearRect(0, 0, W, H)
  sctx.drawImage(bufs.buf.canvas, 0, 0)
  sctx.globalCompositeOperation = 'source-in'
  sctx.fillStyle = 'rgba(206,196,236,1)'
  sctx.fillRect(0, 0, W, H)
  sctx.globalCompositeOperation = 'source-over'
  ctx.save()
  ctx.globalAlpha = 0.5 * Math.max(0, Math.min(1, strength))
  const o = 1.6
  for (let i = 0; i < 8; i += 1) {
    const a = (i / 8) * Math.PI * 2
    drawBufferToWorld(ctx, bufs.silh.canvas, Math.cos(a) * o, Math.sin(a) * o)
  }
  ctx.restore()
  drawBufferToWorld(ctx, bufs.buf.canvas)
}

// 回避の残像 (DEV ?dodgeTrail=1|plain|dark|violet|white・2026-10-06 見本 D4 ゼンゼロの回避の「青い残像」)。 本体の今の絵を染め、
//   少し前に居た位置へ薄く重ねる (本体より先に描く = 後ろに出る)。 滑っている間 (dodgeTravelMs) に出し、止まったら消える。
//   滑る間は姿勢がほとんど変わらないので、 今の絵を写しても残像として読める。
const dodgeTrailHistory: { t: number; x: number }[] = []
let dodgeTrailStepId = -1
let dodgeTrailTint: HTMLCanvasElement | null = null
function drawDodgeTrail(ctx: CanvasRenderingContext2D, body: HTMLCanvasElement, state: GameState): void {
  const p = state.player
  if (!dodgeTrailOn() || p.state !== 'stepping') { dodgeTrailHistory.length = 0; return }
  // 影抜き (DEV ?counterLook=shadow): 見切った回避では残像を出さない = 残る影は1体だけ (残像 = 移動の跡・影 = 見切った瞬間の姿)。
  if (counterLookShadow() && mikiriShadowStepId(state.time) === p.lastStepStartMs) return
  if (dodgeTrailStepId !== p.lastStepStartMs) { dodgeTrailStepId = p.lastStepStartMs; dodgeTrailHistory.length = 0 }
  const drawnX = p.x + playerDodgeVisualLead(p)
  dodgeTrailHistory.push({ t: p.stateElapsed, x: drawnX })
  const fadeSec = 0.12
  const life = 1 - Math.max(0, p.stateElapsed - dodgeTravelMs() / 1000) / fadeSec
  if (life <= 0) return
  if (!dodgeTrailTint) dodgeTrailTint = document.createElement('canvas')
  if (dodgeTrailTint.width !== body.width || dodgeTrailTint.height !== body.height) {
    dodgeTrailTint.width = body.width; dodgeTrailTint.height = body.height
  }
  const tctx = dodgeTrailTint.getContext('2d')
  if (!tctx) return
  // 色 (10-07 ユーザー「青いのはへんだな」→ 候補を並べる)。 tint = 本体に重ねる色 (null = 本体の色のまま)・
  //   add = 光として足す (明るい色) か、普通に重ねる (影・本体の色)・alpha = 一番新しい残像の濃さ
  const style = dodgeTrailStyle()
  const look = {
    blue: { tint: 'rgba(150,205,255,0.78)', add: true, alpha: 0.34 },
    plain: { tint: null, add: false, alpha: 0.42 },
    dark: { tint: 'rgba(12,6,22,0.88)', add: false, alpha: 0.45 },
    violet: { tint: 'rgba(176,96,236,0.74)', add: true, alpha: 0.36 },
    white: { tint: 'rgba(238,236,255,0.8)', add: true, alpha: 0.3 },
  }[style]
  tctx.globalCompositeOperation = 'source-over'
  tctx.clearRect(0, 0, body.width, body.height)
  tctx.drawImage(body, 0, 0)
  if (look.tint) {
    tctx.globalCompositeOperation = 'source-atop'
    tctx.fillStyle = look.tint
    tctx.fillRect(0, 0, body.width, body.height)
    tctx.globalCompositeOperation = 'source-over'
  }
  const at = (lagSec: number): number => {
    const want = p.stateElapsed - lagSec
    let x = dodgeTrailHistory[0].x
    for (const h of dodgeTrailHistory) if (h.t <= want) x = h.x
    return x
  }
  ctx.save()
  if (look.add) ctx.globalCompositeOperation = 'lighter'
  for (const [lag, share] of [[0.1, 0.47], [0.066, 0.7], [0.033, 1]] as const) {
    const dx = at(lag) - drawnX
    if (Math.abs(dx) < 2) continue
    ctx.globalAlpha = look.alpha * share * life
    drawBufferToWorld(ctx, dodgeTrailTint, dx)
  }
  ctx.restore()
}

// 主人公の致命の新しい版 (DEV ?lunaFinisher=new・src/luna_finisher.ts): ボスの絵だけ、抜かれてから起き上がる。
//   普段の致命: 3発目 (抜く) でボスの状態は待機へ戻るが、絵は EXEC_V2.bossRiseAtMs まで崩れ姿・そこから 150ms で立ち姿へ混ぜる。
//   最後の一撃: 止めが明けて剣が抜けるまで、崩れ姿のまま刺されている (撃破の絵へは抜いた瞬間に移る)。ゲームの状態は変えない。
// 崩れから立ち上がる2枚 (2026-10-30・src/boss_rise.ts): 崩れ姿を描いた後に待機へ戻ったら rise1 → rise2 を挟む。
function bossDrawState(state: GameState): GameState {
  const drawn = bossDrawStateInner(state)
  advanceBossRise(state.boss, drawn.boss.state === 'staggered' && drawn.boss.hp > 0, state.time)
  return drawn
}
function bossDrawStateInner(state: GameState): GameState {
  // 止め (アリスの技・?lunaExec=swap): 裂け目が弾けるまで崩れた姿のまま立たせる (倒れた後の空の場所に裂け目が掛からないように)。
  if (lunaExecSwapOn() && state.finisher && state.finisher.elapsedMs < aliceBurstAtClock()) {
    return { ...state, boss: { ...state.boss, state: 'staggered', stateElapsed: 1, currentAttack: null, hp: 1 },
      bossSprite: { ...state.bossSprite, currKey: 'staggered', prevKey: 'staggered', transitionRemainingSec: 0, defeatElapsedSec: 0 } }
  }
  // 普段の致命 (配布版 lamp・10-29 作者の答え): 刺されている間と抜いた後しばらくは崩れ姿のまま (src/luna_exec_swap.ts LAMP_EXEC)。
  if (lampExecBossHold(state.player, state.boss)) {
    // 両手で刺して引き抜く版 (配布版・指定なし) だけ: 刺されて押され、えぐられて跳ね、抜かれる時に剣へ引かれる (描画だけ・数 px)
    const p = state.player
    const jolt = p.state === 'executing' && pullTimingOn(p) ? pullBossJoltPx(p.stateElapsed * 1000) * Math.sign(state.boss.x - p.x || 1) : 0
    return { ...state, boss: { ...state.boss, x: state.boss.x + jolt, state: 'staggered', stateElapsed: 1, currentAttack: null },
      bossSprite: { ...state.bossSprite, currKey: 'staggered', prevKey: 'staggered', transitionRemainingSec: 0 } }
  }
  if (!finisherV2On()) return state
  const b = state.boss
  const staggerBoss = (): GameState['boss'] => ({ ...b, state: 'staggered', stateElapsed: 1, currentAttack: null })
  if (state.finisher) {
    if (state.finisher.elapsedMs >= finisherProfileFor(b.id).pullAtMs) return state
    return { ...state, boss: { ...staggerBoss(), hp: 1 },
      bossSprite: { ...state.bossSprite, currKey: 'staggered', prevKey: 'staggered', transitionRemainingSec: 0, defeatElapsedSec: 0 } }
  }
  const hold = execBossStaggerHold(state.player, b.hp)
  if (!hold) return state
  if (hold.hold) {
    return { ...state, boss: staggerBoss(), bossSprite: { ...state.bossSprite, currKey: 'staggered', prevKey: 'staggered', transitionRemainingSec: 0 } }
  }
  return { ...state, bossSprite: { ...state.bossSprite, prevKey: 'staggered', currKey: 'idle', transitionRemainingSec: Math.min(EXEC_V2.bossRiseMixSec, hold.riseRemainSec) } }
}

// 止めの裂け目を伏せた体に乗せる (10-21・docs/research/2026-10-21-hound-exec-crack-position.md)。
//   前は中心が足元から丈の 0.36 (立ち姿の比率)・裂け目の並びは縦に ±55*scale と線の長さの分だけ広がり、
//   伏せた戴冠獣 (崩れ姿の不透明部分が高さの 2 倍より横長) では背中の上の空中に出ていた。
//   今は横長の崩れ姿の時だけ、中心を不透明部分の縦 ALICE_RIFT_LYING_DEPTH へ置き、並びを縦に縮めて枠の内側 ALICE_RIFT_LYING_FILL に収める。
//   それ以外 (立ち姿・縦長の崩れ姿・回した絵) は前のまま。弾けた後は崩れ姿の時の値で止める。DEV ?execCrackPos=old = 前の位置。
const ALICE_RIFT_LYING_ASPECT = 2
const ALICE_RIFT_LYING_DEPTH = 0.55
const ALICE_RIFT_LYING_FILL = 0.85
let lastBossBodyPlacement: BossSpritePlacement | null = null
// 一突きの版 (DEV ?lunaExec=pierce・src/luna_pierce_fx.ts) のボスの体。膝をついた姿のまま、刺した胸から常夜燈の光が体の中へ広がり、体は光になって薄れる。
//   光は体の絵の明るい所ほど強く出る (絵 × 光の色) = 鎧の縁・継ぎ目から漏れて見える。体の外へは出さない (外の光は drawPierceFx)。
//   体の形の点は撃破ごとに一度だけ拾い、昇る粒の生まれる所に使う。
let pierceSil: { sil: PierceSilhouette; lastSinceHitMs: number } | null = null
const LAMP_RGB = { core: '214,234,255', mid: '170,205,255', deep: '96,142,228' } as const
/** 刺した胸。崩れ姿の絵の不透明な所の中ほど (膝をついた騎士の胸当て)。 */
function pierceWound(b: Boss, fallbackY: number): { x: number; y: number } {
  const pl = lastBossBodyPlacement
  if (!pl || !pl.imageKey.startsWith('staggered')) return { x: b.x, y: fallbackY }
  const r = pl.opaqueRect
  // 膝をついた絵の中の胸の位置 (絵の不透明な範囲に対する割合・fx は左を向いた時の左端から測る)。槍・外套が範囲を広げるのでボスごとに合わせる。
  const a = PIERCE_WOUND_BY_BOSS[b.id] ?? { fx: 0.45, fy: 0.5 }
  const fx = b.facing === 'left' ? a.fx : 1 - a.fx
  return { x: r.x + r.width * fx, y: r.y + r.height * a.fy }
}
const PIERCE_WOUND_BY_BOSS: Record<string, { fx: number; fy: number }> = {
  'vigil-knight': { fx: 0.3, fy: 0.57 },   // 2026-10-30 撮影で測った (槍の穂先が上へ・外套が背中側へ伸びる)
}
function samplePierceSilhouette(canvas: HTMLCanvasElement, m: DOMMatrix): PierceSilhouette | null {
  const c = canvas.getContext('2d')
  if (!c) return null
  const W = canvas.width, H = canvas.height
  const data = c.getImageData(0, 0, W, H).data
  const pts: { x: number; y: number }[] = []
  const step = Math.max(2, Math.round(m.a * 2))
  let top = Infinity, bottom = -Infinity, minX = Infinity, maxX = -Infinity
  for (let y = 0; y < H; y += step) {
    for (let x = 0; x < W; x += step) {
      if (data[(y * W + x) * 4 + 3] < 140) continue
      const wx = (x - m.e) / m.a, wy = (y - m.f) / m.d
      pts.push({ x: wx, y: wy })
      top = Math.min(top, wy); bottom = Math.max(bottom, wy); minX = Math.min(minX, wx); maxX = Math.max(maxX, wx)
    }
  }
  if (pts.length === 0) return null
  return { pts, top, bottom, cx: (minX + maxX) / 2, halfW: Math.max(1, (maxX - minX) / 2) }
}
function drawPierceBossBody(ctx: CanvasRenderingContext2D, drawBody: (c: CanvasRenderingContext2D) => void,
  sinceHitMs: number, wound: { x: number; y: number }, bodyH: number, outline = true): void {
  const bodyA = pierceBodyAlpha(sinceHitMs)
  const bufs = getOutlineBuffers('boss')
  if (!bufs) {
    if (bodyA > 0.005) { ctx.save(); ctx.globalAlpha = bodyA; drawBody(ctx); ctx.restore() }
    return
  }
  const bctx = bufs.buf.ctx
  resetOutlineBuffer(bctx)
  drawBody(bctx)
  const m = bctx.getTransform()
  if (!pierceSil || sinceHitMs < pierceSil.lastSinceHitMs) {
    const sil = samplePierceSilhouette(bufs.buf.canvas, m)
    pierceSil = sil ? { sil, lastSinceHitMs: sinceHitMs } : null
  } else pierceSil.lastSinceHitMs = sinceHitMs
  // 体は全体を薄めず、上から欠けて消える (粒が同じ所・同じ時刻に生まれる = 光の裏で消える・作者 10-30)。
  if (bodyA < 0.999 && pierceSil) {
    const sil = pierceSil.sil
    const prog = 1 - bodyA, span = Math.max(1, sil.bottom - sil.top)
    const cell = 5
    bctx.save()
    bctx.globalCompositeOperation = 'destination-out'
    for (let gy = sil.top - cell; gy < sil.bottom + cell; gy += cell) {
      const yn = Math.max(0, Math.min(1, (gy - sil.top) / span))
      for (let gx = sil.cx - sil.halfW - cell; gx < sil.cx + sil.halfW + cell; gx += cell) {
        const th = pierceCrumbleThreshold(yn, hash01(gx * 12.97 + gy * 7.13))
        if (prog > th) {
          bctx.globalAlpha = Math.min(1, (prog - th) / 0.08)
          bctx.fillRect(gx, gy, cell, cell)
        }
      }
    }
    bctx.restore()
  }
  if (bodyA >= 0.999 && outline) compositeWithOutline(ctx, bufs)
  else if (bodyA > 0.005) drawBufferToWorld(ctx, bufs.buf.canvas)
  else return
  const spill = pierceSpill(sinceHitMs)
  if (spill.amount <= 0.005) return
  // 体の形を写しておく (光を体の内側だけに収める型)
  const sctx = bufs.silh.ctx
  sctx.setTransform(1, 0, 0, 1, 0, 0)
  sctx.globalCompositeOperation = 'copy'
  sctx.drawImage(bufs.buf.canvas, 0, 0)
  sctx.globalCompositeOperation = 'source-over'
  const R = Math.max(8, bodyH * (0.1 + 0.45 * spill.reach))
  const r = bufferRect()
  // 1) 絵 × 光の色: 明るい所 (鎧の縁・継ぎ目) ほど光る
  bctx.save()
  bctx.globalCompositeOperation = 'multiply'
  const g = bctx.createRadialGradient(wound.x, wound.y, 0, wound.x, wound.y, R)
  g.addColorStop(0, 'rgb(255,255,255)'); g.addColorStop(0.35, `rgb(${LAMP_RGB.mid})`); g.addColorStop(0.75, `rgb(${LAMP_RGB.deep})`); g.addColorStop(1, 'rgb(0,0,0)')
  bctx.fillStyle = g
  bctx.fillRect(r.x, r.y, r.w, r.h)
  bctx.setTransform(1, 0, 0, 1, 0, 0)
  bctx.globalCompositeOperation = 'destination-in'
  bctx.drawImage(bufs.silh.canvas, 0, 0)
  bctx.restore()
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = spill.amount * 0.5
  drawBufferToWorld(ctx, bufs.buf.canvas)
  ctx.restore()
  // 2) 芯: 傷の近くは体の色によらず光で満ちる (体の形の内側だけ)
  bctx.save()
  bctx.setTransform(1, 0, 0, 1, 0, 0)
  bctx.globalCompositeOperation = 'copy'
  bctx.drawImage(bufs.silh.canvas, 0, 0)
  bctx.setTransform(m)
  bctx.globalCompositeOperation = 'source-in'
  const g2 = bctx.createRadialGradient(wound.x, wound.y, 0, wound.x, wound.y, R * 0.4)
  g2.addColorStop(0, `rgba(${LAMP_RGB.core},0.95)`); g2.addColorStop(0.4, `rgba(${LAMP_RGB.mid},0.45)`); g2.addColorStop(1, `rgba(${LAMP_RGB.deep},0)`)
  bctx.fillStyle = g2
  bctx.fillRect(r.x, r.y, r.w, r.h)
  bctx.restore()
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = spill.amount * 0.6
  drawBufferToWorld(ctx, bufs.buf.canvas)
  ctx.restore()
}

let aliceRiftLyingFit: { y: number, squashY: number } | null = null
function aliceRiftFit(b: Boss, bh: number, scale: number): { y: number, squashY: number } {
  const old = { y: bossFootY(b) - bh * 0.36, squashY: 1 }
  if (execCrackPosOld()) return old
  const pl = lastBossBodyPlacement
  if (pl && pl.imageKey.startsWith('staggered')) {
    const r = pl.opaqueRect
    aliceRiftLyingFit = null
    if (!pl.rotationRad && r.width >= r.height * ALICE_RIFT_LYING_ASPECT) {
      const y = r.y + r.height * ALICE_RIFT_LYING_DEPTH
      const e = aliceLampSeamExtentY(scale)
      const squashY = Math.min(1, (y - r.y) * ALICE_RIFT_LYING_FILL / -e.top, (r.y + r.height - y) * ALICE_RIFT_LYING_FILL / e.bottom)
      aliceRiftLyingFit = { y, squashY }
    }
  }
  return aliceRiftLyingFit ?? old
}

function renderPlayerInto(ctx: CanvasRenderingContext2D, state: GameState): void {
  const p = state.player
  const facingMul = p.facing === 'right' ? 1 : -1
  const impactPush = guardImpactVisualPush(state) + playerDodgeVisualLead(p) + aliceDashPush(state)
  ctx.save()
  ctx.translate(p.x + impactPush, p.y)
  ctx.scale(facingMul, 1)

  // Spine 経路: idle / attacking / parrying / stepping は骨格アニメで描く。
  // resolveSpineAnimation が parrying→parry, stepping→dodge を解決する (アニメ実在)。
  // ※ 以前は idle/attacking のみ Spine 経路で、parrying/stepping は旧 canvas/立ち絵に
  //   落ちていた (実機で parry/dodge の Spine アニメが一度も再生されない既知バグ)。
  //   2026-05-30 多角レビューで発覚し、ここで接続した (roadmap §6 A-0)。
  // ※ executing は variant で execute / execute_finisher を再生する。 ただし Spine 側に
  //   そのアニメが未実装の間は drawSpinePlayer が false を返し、 下の既存 frame-by-frame
  //   致命描画へ委ねる (idle 退行＝棒立ち呼吸にしない)。 2アニメ書き出し後は自動で点灯する。
  // drawSpinePlayer は内部で読み込み完了を見て初回に rig を構築する。
  // 読み込み未完了なら false が返り、既存 frame-by-frame / canvas path に fallback。
  // 注: isSpinePlayerReady() を条件にしてはいけない (rig 構築は drawSpinePlayer 内で起きるため
  //     ready 条件だと永久に呼ばれずデッドロックする)。state だけで分岐する。
  // 致命トドメの魂吸収中 (state.finisher) は executing をロックし続ける。
  //   impact 中 (elapsedMs < T_PULL) は execute_finisher で F17 命中~刺し保持 (鋭さを保つ)。
  //   pull 以降は execute_finisher_afterglow へ切替: 刺し保持から静かに剣を引き、 上体を起こし、
  //   終幕姿勢へ。 afterglow は非ループなので完走後は最終フレームを保持し、 silence 中も
  //   idle 呼吸へ戻らない (「清く終わらせたつもりの、わずかな残響」)。 F0=刺し保持コピーのため
  //   execute_finisher→afterglow の mix は視覚的に no-op で F17 の鋭さを損なわない。
  //   spineDt は state.time (= elapsedMs と同じ sim-time) 差分なので afterglow は FX ビートへ同期する。
  //   ※ executing 終了で executeVariant は normal にリセットされるため variant は finisher を明示。
  // フレーム dt と移動検出を Spine ゲートより前に「1回だけ」計算する。
  //   updatePlayerAnimState は内部 state を持つので二重呼び出し禁止 (= 旧 frame-by-frame 経路の
  //   後段呼び出しは削除し、 ここで得た animState を共有する)。 prevPlayerDrawTime もここで一括更新。
  // 🔴 state.time の巻き戻り (再演/タイトルへ戻る/ボス切替) を必ず検知すること。
  //   createInitialState で time が 0 へ戻るのに対し prevPlayerDrawTime はモジュール変数として
  //   前の戦闘の終了時刻 (例 8.9s) を保持し続ける。 Math.max(0, …) で潰すと **前回の戦闘が
  //   続いた秒数のあいだ frameDt = 0** になり、 Spine の state.update(0) が一切進まない。
  //   結果 = 保持していた defeat (伏した姿) から mix が 1mm も進まず、 次の戦闘が
  //   「LUNAIRE が倒れたまま始まる」 (2026-07-22 ユーザー実機報告・再現済み)。
  //   巻き戻ったら描画側の持ち越し (hurt nonce / ガードの尾 / 歩き検出) を全部捨て、
  //   1 フレームぶんだけ進めて通常の mix に乗せる。
  // 🔴 時計は playerDrawClock (= bossIntroMs + time)。 名乗りの「間」は state.time が止まるので、
  //   time だけを見ると名乗りの 1.8 秒ぶん Spine が固まる (= 伏せたまま次の戦闘が始まる)。
  const playerClock = playerDrawClock(state.time, state.bossIntroMs)
  const { dt: frameDt, rewound: timeRewound } = playerDrawDt(playerClock, prevPlayerDrawTime)
  if (timeRewound) {
    prevPlayerHurtNonce = p.hurtNonce
    guardTailUntil = -1
    prevPlayerWasGuarding = false
    attackSettleUntil = -1
    prevPlayerAttack = null
    prevPlayerWasHeavy = false
    heavyTailUntil = -1
    resetPlayerAnimState()
    resetWalkNewDraw()
  }
  prevPlayerDrawTime = playerClock
  // 歩きの比較版 (DEV ?lunaWalk=new|newslow・src/player_walk_new_draw.ts) は体の速さで歩きを決める (止まった後に足だけ歩き続けない)
  const animState = { ...updatePlayerAnimState(p.x, frameDt), ...walkNewAnimState(p) }

  // guarding は dev WIP の承認案C (guard_c) を再生する。清書前の本番 skeleton に無い環境は
  // drawSpinePlayer が idle へ安全に戻すので、既定OFFのゲーム進行を壊さない。
  let spineState: PlayerVisualState = p.state
  let spineVariant = p.executeVariant
  let spineOverride: string | undefined
  let spineForceRestart = false
  // 被弾して始まった空振りパリィを隠しているか (1回だけ計算・分岐条件と syncTime の両方で使う)。
  //   二重評価しない。 whiffedParryHiddenByFlinch のコメント参照。
  const hidingWhiffedParry = whiffedParryHiddenByFlinch(
    state.time, p.state, p.stateElapsed, p.hurtVisualUntil)
  // 被弾の窓の内側で始まったパリィが長押しでガードへ化けた姿を隠しているか。
  //   guardPoseHiddenByFlinch のコメント参照 (2026-07-23 バタバタ3度目)。
  const hidingGuardPose = guardPoseHiddenByFlinch(
    state.time, p.state, p.stateElapsed, p.hurtVisualUntil, p.parryActiveMsEffective)
  if (state.deathBeat || state.phase === 'defeat') {
    // 死の一拍〜YOU DIED: プレイヤーは崩れ落ちたまま (最優先・非ループ・最終フレーム=伏した姿を保持)。
    //   中腰 stunned のまま死ぬ違和感を解消。 ボスの致命演技と並行で LUNAIRE が沈み、 暗転後も伏したまま。
    //   ※ phase==='defeat' は必ずプレイヤー死亡 (ボス撃破は victory/cleared) なので defeat 固定で正しい。
    spineState = 'defeat'
  } else if (state.finisher) {
    spineState = 'executing'
    spineVariant = 'finisher'
    if (lunaExecSwapOn() && hasSpinePlayerAnimation(ALICE.anim)) {
      // 止め (アリスの技を手本にした版・DEV ?lunaExec=swap): 背を向けた残心を最後まで (抜いて立つ絵へは替えない)。
      spineOverride = ALICE.anim
    } else if (finisherV2On() && hasSpinePlayerAnimation(FINISHER_V2_ANIM.pull)) {
      // 新しい版 (DEV ?lunaFinisher=new・src/luna_finisher.ts): 止めの間は刺した姿のまま、明けたら抜く → 立つ。
      spineOverride = state.finisher.elapsedMs > 0 ? FINISHER_V2_ANIM.pull : FINISHER_V2_ANIM.windup
    } else if (state.finisher.elapsedMs >= T_PULL) {
      spineOverride = 'execute_finisher_afterglow'
    }
  } else if (hidingWhiffedParry || hidingGuardPose) {
    // 被弾して始まった空振りパリィ、 またはそこから化けたガード: 化けた姿は出さない
    // (whiffedParryHiddenByFlinch / guardPoseHiddenByFlinch のコメント参照)。
    //   のけぞりの窓の内 = のけぞり / 窓を過ぎたら = 中立へ戻す (「立て直す」)。
    //   ⚠️ ここで idle へ倒さないと、のけぞりが最終フレームを保持したまま固まる。
    //   ガードの場合、 窓が明けた瞬間 hidingGuardPose 自体が false になる (state は guarding のまま
    //   この分岐から抜ける) ので、 このelse (idle強制) は実質パリィ側の尻尾処理のみを担う。
    if (hurtFlinchVisible(state.time, p.hurtVisualUntil)) {
      spineOverride = 'hurt'
      if (p.hurtNonce !== prevPlayerHurtNonce) {
        spineForceRestart = true
        prevPlayerHurtNonce = p.hurtNonce
      }
    } else {
      spineState = 'idle'
    }
  } else if (hurtFlinchVisible(state.time, p.hurtVisualUntil) && p.state === 'idle') {
    // 被弾フリンチ (visual-only オーバーレイ)。 finisher の「下」= finisher 中は出さない。
    //   中立(idle)時のみ上描き = executing/parrying/stepping/stunned はそれぞれのアニメ優先で hurt に負けない
    //   (それらの state では p.state が idle でないのでこの分岐に入らない)。 hurt は非ループ・0.4s で
    //   1周→最終フレーム保持→hurtVisualUntil 経過で idle へ自然復帰 (defaultMix で軽くクロスフェード)。
    //   被弾して始まった空振りパリィは**手前の分岐 (whiffedParryHiddenByFlinch)** で処理される。
    spineOverride = 'hurt'
    // 多段2発目: hurtNonce が変わった時だけ hurt track を頭から強制リスタート (途中再生にしない)。
    if (p.hurtNonce !== prevPlayerHurtNonce) {
      spineForceRestart = true
      prevPlayerHurtNonce = p.hurtNonce
    }
  }
  // 致命を弾ける仕組み (既定・旧は DEV ?execParry=off・src/exec_parry.ts): 崩れ中にパリィを押したら、受付の1回分だけパリィの姿を出す
  //   (押したことが見える・空振りなら崩れ姿へ戻る)。弾けた時は player.state が parrying へ移り、同じ経過のまま続く。
  const stunParrySec = !state.deathBeat && !state.finisher && state.phase !== 'defeat'
    ? stunParryPoseElapsedSec(p, state.time) : undefined
  if (stunParrySec !== undefined) {
    spineState = 'parrying'
    spineOverride = undefined
    if (stunParrySec < FIXED_DT * 1.5) spineForceRestart = true
  }
  // 致命を弾いて押されている間 (DEV ?execPush=new・src/exec_parry.ts): 重い受けの姿 (parry_heavy・腰を落とし上体を反らして踏ん張る)。
  //   時計は止め明けからの経過 (止めの間は parry の当たった瞬間の姿のまま止まる)。滑り終わって受けた姿が解けたら、
  //   操作しない間だけ parry_heavy_out (ほどき) を流す (ガード解除の尾と同じ・歩き・攻撃・回避・被弾で即やめる)。
  const heavySec = !state.deathBeat && !state.finisher && state.phase !== 'defeat' && hasSpinePlayerAnimation('parry_heavy')
    ? execHeavyPoseSec(p) : undefined
  if (heavySec !== undefined) {
    spineState = 'parrying'
    spineOverride = 'parry_heavy'
    prevPlayerWasHeavy = true
    heavyTailUntil = -1
  } else if (prevPlayerWasHeavy) {
    prevPlayerWasHeavy = false
    if (p.state === 'idle' && hasSpinePlayerAnimation('parry_heavy_out')) heavyTailUntil = state.time + PARRY_HEAVY_OUT_SEC
  }
  if (heavyTailUntil > 0 && state.time < heavyTailUntil && spineState === 'idle' && !spineOverride && !animState.isWalking) {
    spineOverride = 'parry_heavy_out'
  } else if (heavyTailUntil > 0 && (spineState !== 'idle' || animState.isWalking || state.time >= heavyTailUntil)) {
    heavyTailUntil = -1
  }
  // 受け身 (10-21・src/ukemi.ts・前の版 DEV ?ukemi=off): 弾いたら parry_ukemi (重い技は _heavy) を弾いた瞬間から流す
  //   (光の下で姿が切り替わる)。 パリィの残りと、操作しない間の素立ちへ戻るまで流し切る (歩き・攻撃・回避・被弾・ガードで捨てる)。
  //   次のパリィを押したら (連続弾き) 捨てて parry を頭から・次に弾いた所でまた頭から。 ガードで受けたら guard_hit → guard のループ。
  const ukemiWalked = walkedByInput(p)
  const ukemiSec = ukemiPose(p, state, spineState, heavySec !== undefined || stunParrySec !== undefined || !!spineOverride || (animState.isWalking && ukemiWalked))
  if (ukemiSec !== undefined) {
    spineOverride = ukemiSec.anim
    if (ukemiSec.restart) spineForceRestart = true
  }
  // 移動中 (中立=idle のまま x が動いている) は walk ループへ昇格。
  //   finisher / hurt override 中は出さない (それぞれのアニメ優先)。 戦闘 state(attack 等) は
  //   p.state が idle でないのでここに来ない。 walk が未 author の場合は drawSpinePlayer の
  //   fallback で idle に倒れる。
  // 移動中の昇格: facing は常にボス側固定 (player.ts)。 移動方向(dirSign)が facing と一致 =
  //   ボスへ前進 = walk / 逆 = ボスから離れる後退 = walk_back (専用バックシャッセ)。
  //   前進walkの逆再生は邪道 (ムーンウォーク/runtime で凍る) なので後退は別アニメを当てる。
  if (spineState === 'idle' && !spineOverride && animState.isWalking) {
    const facingSign = p.facing === 'right' ? 1 : -1
    spineState = animState.dirSign === facingSign ? 'walking' : 'walking_back'
  }
  // ガード解除の尾: 保持していた parry の続き (ほどき) を流し切ってから中立へ戻す。
  //   中立 (idle/歩き) の時だけ。 攻撃・回避・被弾へ移った時は尾を捨てる = 操作の即応性を損なわない。
  //   ⚠️ hidingGuardPose 中 (guard_in を一度も見せていない) は prevPlayerWasGuarding を立てない。
  //   ここを p.state だけで判定すると、 のけぞりの窓の内側でガードへ化けて即座に離した場合、
  //   guard_in を一度も描いていないのに離した瞬間 guard_out (ほどき) が hurt から直接混ざって
  //   出てしまう (probe HOLD_MS=250 実測で発覚・2026-07-23)。
  if (p.state === 'guarding' && !hidingGuardPose) {
    prevPlayerWasGuarding = true
    guardTailUntil = -1
  } else if (prevPlayerWasGuarding) {
    prevPlayerWasGuarding = false
    guardTailUntil = state.time + PARRY_TAIL_SEC
  }
  const inNeutral = spineState === 'idle' || spineState === 'walking' || spineState === 'walking_back'
  if (guardTailUntil > 0 && state.time < guardTailUntil && inNeutral && !spineOverride) {
    // 受け姿からほどく専用アニメ (parry の 0.2s 以降を写したもの)。 F0 = 受け姿なので跳ねない。
    spineOverride = 'guard_out'
  } else if (guardTailUntil > 0 && (!inNeutral || state.time >= guardTailUntil)) {
    guardTailUntil = -1
  }
  // 連撃をやめた時の戻り: 攻撃 (1・2段目) を振り切って idle へ戻った時だけ。 パリィ・回避で取り消した時は
  //   その状態へ移るので尾は出ない。 歩き出した・次の段を押した・被弾した時は尾を捨てる (操作の即応性を損なわない)。
  if (p.state === 'attacking') {
    prevPlayerAttack = { step: p.attackComboStep ?? 0, isCounter: p.attackIsCounter }
    attackSettleUntil = -1
  } else if (prevPlayerAttack) {
    if (p.state === 'idle' && needsAttackSettle(prevPlayerAttack.step, prevPlayerAttack.isCounter, playerComboEnabled())
      && hasSpinePlayerAnimation('attack_settle')) {
      attackSettleUntil = state.time + ATTACK_SETTLE_SEC
    }
    prevPlayerAttack = null
  }
  if (attackSettleUntil > 0 && state.time < attackSettleUntil && spineState === 'idle' && !spineOverride) {
    spineOverride = 'attack_settle'
  } else if (attackSettleUntil > 0 && (spineState !== 'idle' || state.time >= attackSettleUntil)) {
    attackSettleUntil = -1
  }
  // 回避 d (10-07): 動けない時間は 260ms で終わるが、何も操作しなければ「低く止まって立つ」残りを描き続ける。
  //   歩き出した・攻撃・パリィ・次の回避・被弾で即やめる (spineState が idle でなくなる)。 新しい回避は頭から描き直す。
  if (p.state === 'stepping') {
    prevPlayerWasStepping = true
    dodgeSettleUntil = -1
    if (p.stateElapsed < FIXED_DT * 1.5) spineForceRestart = true
  } else if (prevPlayerWasStepping) {
    prevPlayerWasStepping = false
    if (p.state === 'idle' && dodgeSettleMs() > 0) dodgeSettleUntil = state.time + dodgeSettleMs() / 1000
  }
  if (dodgeSettleUntil > 0 && state.time < dodgeSettleUntil && spineState === 'idle' && !spineOverride) {
    spineState = 'stepping'
  } else if (dodgeSettleUntil > 0 && (spineState !== 'idle' || state.time >= dodgeSettleUntil)) {
    dodgeSettleUntil = -1
  }
  // 途中の致命の「間合いを取る1拍」(DEV ?execGap=1・src/execute_spacing.ts): 経過が負の間だけ、回避と同じ低い姿で後ろへ滑る。
  //   経過が 0 を越えた所で execute を頭から再生する (3発の時計と揃う)。配布版は経過が負にならない = 通らない。
  // 主人公の致命の新しい版 (DEV ?lunaFinisher=new・src/luna_finisher.ts): 刺す→押し込む→抜く (execute_v2) と、最後の一撃の溜め→刺す (execute_finisher_v2)。
  if (spineState === 'executing' && !state.finisher && !spineOverride && finisherV2On() && hasSpinePlayerAnimation(execV2AnimName(p.executeVariant))) {
    spineOverride = execV2AnimName(p.executeVariant)
  }
  // 致命の入れ替え (DEV ?lunaExec=swap・src/luna_exec_swap.ts): 普段の致命 = 今の止めの「深く一突き」・止め = アリスの技を手本にした新しい動き。
  if (spineState === 'executing' && !state.finisher && !spineOverride && lunaExecSwapOn()) {
    // 直した版 (?lunaExec=swap2) の普段の致命 = 作り直した一突き (THRUST)。
    const want = p.executeVariant === 'finisher' ? ALICE.anim : thrustTimingOn(p) ? THRUST.anim : normalExecAnim()
    if (hasSpinePlayerAnimation(want)) spineOverride = want
  }
  if (spineState === 'executing' && !state.finisher && p.stateElapsed < 0) {
    spineOverride = currentDodgeVariant().anim
    if (p.stateElapsed < -(p.executePrepMs ?? 0) / 1000 + FIXED_DT * 1.5) spineForceRestart = true
  }
  // 見切りカウンター: attacking のうち counterWindow 中に出した突き (attackIsCounter) だけ専用の
  //   counter アニメ (沈み込む深い刺突) へ振る。 通常攻撃は attack のまま。 override 群の後・gate の前。
  if (spineState === 'attacking' && p.attackIsCounter) spineState = 'counter'
  // 通常突きは接触までは既存 attack のまま。接触結果が決まった瞬間だけ、同じ前半を持つ
  // コピーへ同時刻で切り替え、戻りを「弾かれ / 浅い / 深い」で描き分ける。
  //   連撃を試す間 (?comboTrial=1) は段ごとに attack_1 / attack_2 / attack_3 (と接触別) を優先し、未作成なら旧の attack 系へ落ちる。
  if (spineState === 'attacking' && !spineOverride && !p.attackIsCounter) {
    const name = playerAttackAnimationCandidates(p.attackComboStep ?? 0, p.attackContactKind, playerComboEnabled())
      .find((candidate) => hasSpinePlayerAnimation(candidate))
    spineOverride = name === 'attack' ? undefined : name
  }
  // パリィのアニメをゲーム側の経過へ厳密に合わせる (2026-07-20 実機FB「レイピアがカクッとする」の根治)。
  //   放っておくと、アニメ開始フレームで setAnimation → update(dt) の順に走るぶん、
  //   **アニメがゲームより 1 コマ (約17ms) 先行する**。 弾き判定が切れる 200ms は parry が
  //   受け姿を保っている最後の瞬間なので、17ms 先行しているとその1コマだけ「ほどき」に入り、
  //   剣が 2 度動いてから guard_in に引き戻される = 細長い刃の先端で数px の跳ねになっていた。
  //   → 開始時に track を stateElapsed へ合わせ、以降は同じ dt で進むので合ったままになる。
  //   連続弾き (deflect chain) で parrying に入り直した時もアニメを貼り直す (同名だと素通りするため)。
  // 通常攻撃 (連撃3段) は描いたコマで出す (2026-10-02 ユーザー「一番動きとしてよいのは書いたコマのやつだな」)。
  //   描いたコマは開発中の ?playerAttackArt=frames の時だけ (既定は下の Spine attack_1/2/3)。
  if (spineState === 'attacking' && !p.attackIsCounter
    && drawPlayerAttackFrame(ctx, p.attackComboStep ?? 0, p.stateElapsed * 1000)) {
    ctx.restore()
    return
  }
  const parryJustStarted = p.state === 'parrying' && p.stateElapsed < FIXED_DT * 1.5
  // 空振りパリィを隠している間 (spineOverride === 'hurt') はこの強制リスタートを発火させない。
  //   隠している最中は hurt を出しているので、頭へ巻き戻すと のけぞりの track が壊れる。
  if (parryJustStarted && spineOverride !== 'hurt' && heavySec === undefined && ukemiSec === undefined) spineForceRestart = true
  if (usesSpinePath(spineState)) {
    //   ⚠️ のけぞりを出している間 (spineOverride === 'hurt') は同期しない。 hurt の trackTime に
    //      パリィの経過 (p.stateElapsed) が入り、のけぞりが途中から再生されてしまう。
    //   ⚠️ 空振りパリィ/化けたガードを隠している間 (hidingWhiffedParry / hidingGuardPose) も
    //      同期しない。 のけぞりの窓を過ぎて spineState を 'idle' に倒す枝は spineOverride が
    //      undefined のままなので、 上の条件だけでは漏れる → idle の trackTime にパリィの経過が
    //      入り、 立て直した時の呼吸の位相がパリィの長さで揺れてしまう (実測で発覚)。
    const syncTime = (spineOverride === 'hurt' || hidingWhiffedParry || hidingGuardPose)
      ? undefined
      : ukemiSec?.sec ?? heavySec ?? stunParrySec ?? (p.state === 'attacking' || p.state === 'parrying' ? p.stateElapsed : undefined)
    prepareWalkNewDraw(p, (spineState === 'walking' || spineState === 'walking_back') && !spineOverride,
      spineState === 'idle' && !spineOverride, frameDt)
    // 受け身の間は止めの間も進む時計で人形を進める (止めの間は frameDt = 0 で、光の下で姿が切り替わらなかった)。
    const ukemiDt = ukemiSec && !ukemiSec.restart && ukemiPrevClock !== undefined ? Math.max(0, ukemiSec.clock - ukemiPrevClock) : undefined
    ukemiPrevClock = ukemiSec?.clock
    if (drawSpinePlayer(ctx, spineState, ukemiDt ?? frameDt, spineVariant, spineOverride, spineForceRestart, syncTime,
      { x: p.x + impactPush, y: p.y, facing: facingMul })) {
      ctx.restore()
      // 崩れ (stunned) も overlay を出す (2026-07-26・友達FB 3-5)。 旧コメントは「崩れアニメが
      //   雄弁だから overlay 不要」だったが、 実表示で並べると同時に出る画面端の赤ヴィネットの方が
      //   強く、 前傾姿勢だけでは「自分が崩された」が読めていなかった (棚卸し §3)。
      if (p.state === 'stunned') drawStunEffect(ctx, p, state.time)
      return
    }
  }

  const bob = p.state === 'idle' ? Math.sin(state.time * 3) * 1.2 : 0
  const shake = p.state === 'stunned' ? Math.sin(state.time * 60) * 2.5 : 0
  // 致命の一撃中は各ヒットでわずかに前進、振り上げで上下動
  let executeOffsetX = 0
  let executeOffsetY = 0
  if (p.state === 'executing') {
    const phaseStart = p.executeHitIndex * EXECUTE.perHitDurationMs
    // 間合いを取る1拍 (DEV ?execGap=1 の時だけ経過が負) の間は前へ出さない。配布版は経過が負にならない = 今と同じ。
    const phaseProgress = Math.max(0, Math.min(1, ((p.stateElapsed * 1000) - phaseStart) / EXECUTE.perHitDurationMs))
    // 各ヒットで微妙に前進し、ヒット後に戻る
    const lunge = Math.sin(phaseProgress * Math.PI) * 12
    executeOffsetX = lunge
    // hit 2 (振り上げ) はジャンプ風の上下動
    if (p.executeHitIndex === 2) {
      executeOffsetY = -Math.sin(phaseProgress * Math.PI) * 10
    }
  }
  ctx.translate(shake + executeOffsetX, bob + executeOffsetY)

  // 🔴 旧 LUNAIRE スプライト経路 (lunaire-v2 の 1枚絵 / 動作別フレーム) は
  //   2026-07-28 に撤去した。 Spine (lunaire-doll) に全アニメが author 済で、
  //   通信を遮断して実測しても一度も描画されなかった (到達しない保険だった)。
  //   素材は public/sprites/archived/lunaire-v2/ にある。
  //   ここから下の Canvas パスは**素材を1つも使わない最終保険**なので残す。
  fillPath(ctx, PALETTE.playerDress, () => {
    ctx.moveTo(-9, -34)
    ctx.lineTo(9, -34)
    ctx.lineTo(16, -2)
    ctx.lineTo(-16, -2)
    ctx.closePath()
  })
  strokePath(ctx, PALETTE.playerDressTrim, 1.2, () => {
    ctx.moveTo(-16, -2); ctx.lineTo(16, -2)
  })
  strokePath(ctx, PALETTE.playerHair, 5, () => {
    ctx.moveTo(-6, -2); ctx.lineTo(-6, -1)
    ctx.moveTo(6, -2);  ctx.lineTo(6, -1)
  })
  fillPath(ctx, PALETTE.playerDress, () => {
    ctx.moveTo(-9, -55); ctx.lineTo(9, -55)
    ctx.lineTo(8, -34); ctx.lineTo(-8, -34); ctx.closePath()
  })
  fillPath(ctx, PALETTE.playerSpearTip, () => {
    drawStar(ctx, 0, -48, 2, 4)
  })
  fillPath(ctx, PALETTE.playerSkin, () => { ctx.fillRect(-2, -58, 4, 3) })
  fillPath(ctx, PALETTE.playerHair, () => {
    ctx.moveTo(-10, -58); ctx.lineTo(10, -58)
    ctx.lineTo(10, -68); ctx.lineTo(0, -74); ctx.lineTo(-10, -68); ctx.closePath()
  })
  fillPath(ctx, PALETTE.playerSkin, () => { ctx.arc(0, -64, 7, 0, Math.PI * 2) })
  fillPath(ctx, PALETTE.playerHair, () => {
    ctx.moveTo(-7, -70)
    ctx.quadraticCurveTo(0, -76, 7, -70)
    ctx.lineTo(7, -64)
    ctx.quadraticCurveTo(2, -67, 0, -65)
    ctx.quadraticCurveTo(-3, -67, -7, -64)
    ctx.closePath()
  })
  fillPath(ctx, PALETTE.playerHairHi, () => {
    ctx.moveTo(-3, -73); ctx.lineTo(3, -73)
    ctx.lineTo(2, -68); ctx.lineTo(-2, -68); ctx.closePath()
  })
  fillPath(ctx, PALETTE.playerHair, () => {
    ctx.moveTo(-8, -64)
    ctx.quadraticCurveTo(-18, -56, -14, -42)
    ctx.lineTo(-10, -42)
    ctx.quadraticCurveTo(-12, -52, -7, -60)
    ctx.closePath()
  })
  fillPath(ctx, PALETTE.playerHair, () => {
    ctx.moveTo(8, -64)
    ctx.quadraticCurveTo(18, -56, 14, -42)
    ctx.lineTo(10, -42)
    ctx.quadraticCurveTo(12, -52, 7, -60)
    ctx.closePath()
  })
  fillPath(ctx, '#1c0d2e', () => {
    ctx.fillRect(-3.5, -65, 1.2, 2)
    ctx.fillRect(2.3, -65, 1.2, 2)
  })

  drawDreamLance(ctx, p, state.time)
  ctx.restore()

  if (p.state === 'parrying') drawParryRing(ctx, p, state.time)
  // 影抜き (DEV ?counterLook=shadow) の時は金の足元の光を出さない (合図は drawPlayer の合成の後で描く銀白)。
  if (p.counterWindow > 0 && !counterLookShadow()) drawCounterAura(ctx, p, state.time)
  if (p.state === 'stunned') drawStunEffect(ctx, p, state.time)
  if (p.state === 'executing') drawExecuteAura(ctx, p, state.time)
}

// 致命の一撃中: プレイヤーを包む強烈な暖色オーラ + ヒット時のフラッシュ
function drawExecuteAura(ctx: CanvasRenderingContext2D, p: Player, t: number): void {
  const footY = p.y
  const cx = p.x
  const phaseStart = p.executeHitIndex * EXECUTE.perHitDurationMs
  const phaseProgress = Math.min(1, ((p.stateElapsed * 1000) - phaseStart) / EXECUTE.perHitDurationMs)
  // active 中 (0.25-0.55) はオーラ最大
  const flash = phaseProgress > 0.25 && phaseProgress < 0.55 ? 1.0 : 0.55

  // 足元の縦グラデ金グロー (低く薄く)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const glowH = 28
  const grad = ctx.createLinearGradient(0, footY - glowH, 0, footY)
  grad.addColorStop(0, 'rgba(0,0,0,0)')
  grad.addColorStop(1, PALETTE.parrySparkWarm)
  ctx.globalAlpha = flash * 0.20
  ctx.fillStyle = grad
  ctx.fillRect(cx - 20, footY - glowH, 40, glowH)
  ctx.restore()

  // 足元から立ち上る魂火 (flash で粒子数を上下)
  const count = flash >= 1.0 ? 10 : 6
  emberRise(ctx, cx, footY, count, PALETTE.parrySparkWarm, t, 31, 45, 36)
}

// 疲労エフェクト (drawExhaustedEffect) は 2026-07-27 に撤去。
//   スタミナ/息切れの概念ごと廃止したため呼び出し元が消えた。実装は git 履歴にある。

// ガード中の持続光は **置かない** (2026-07-20 ユーザー裁定「エフェクトはなしでOK」)。
//   調査 (SEKIRO / ソウル系) でもガード中に持続オーラを出すゲームは無く、読ませ方は
//   ①構え (Spine の guard_in/guard) ②受けた瞬間 (drawPlayerGuardImpact) ③UIゲージ (自体幹バー) の3つ。
//   体と足元の霧・刃に宿す光の順に試し、どちらも「意味が分からない/二重表示」で不採用。
//   経緯と実装は git 履歴 (f2352b3 とその親) / docs/rejected/README.md。

// 受け身の姿 (10-21・src/ukemi.ts)。 出す時は名前と、頭から出し直す時の時計 (弾いて/受けてからの秒・止めの間も数える)。
//   blocked = 他の姿が優先される時 (致命を弾いた重い姿・崩れ中のパリィ・被弾など・歩き)。
function ukemiPose(p: Player, state: GameState, spineState: PlayerVisualState, blocked: boolean):
  { anim: string; sec: number; restart: boolean; clock: number } | undefined {
  if (!ukemiOn() || state.deathBeat || state.finisher) { ukemiAnim = undefined; ukemiGuardShowing = false; return undefined }
  // ガードで受けた: guard_hit → guard のループ (spine_anim_map.ts OVERRIDE_THEN)。 受け構えの間ずっと名前を保つ (戻すと guard_in が頭から出る)。
  if (spineState === 'guarding' && !blocked && hasSpinePlayerAnimation(UKEMI.anim.guard)) {
    let hit: FxEvent | undefined
    for (const f of state.fx) if (f.kind === 'player_guard_impact' && f.t <= state.time && (!hit || f.t >= hit.t)) hit = f
    const fresh = !!hit && hit.t !== ukemiGuardT
    if (hit && fresh) { ukemiGuardT = hit.t; ukemiGuardShowing = true }
    if (ukemiGuardShowing) {
      const clock = hit ? ukemiSince(hit, state.time, state.hitStopRemaining) : 0
      return { anim: UKEMI.anim.guard, sec: fresh ? clock : 0, restart: fresh, clock }
    }
  } else ukemiGuardShowing = false
  let spark: Extract<FxEvent, { kind: 'parry_spark' }> | undefined
  for (const f of state.fx) if (f.kind === 'parry_spark' && !f.exec && f.t <= state.time && (!spark || f.t >= spark.t)) spark = f
  if (!spark || blocked) { ukemiAnim = undefined; return undefined }
  const since = ukemiSince(spark, state.time, state.hitStopRemaining)
  const fresh = spark.t !== ukemiSparkT
  // 弾いた後に押し直したパリィ (連続弾き) = parry を頭から (次に弾いた所でまた受け身へ)。
  const repressed = p.state === 'parrying' && p.stateElapsed + 1e-6 < state.time - spark.t
  const where = p.state === 'parrying' || (p.state === 'idle' && spineState === 'idle')
  if (since < UKEMI.parrySec && where && !repressed && (fresh ? p.state === 'parrying' : ukemiAnim !== undefined)) {
    if (fresh) {
      ukemiSparkT = spark.t
      const name = UKEMI.anim[ukemiKind(spark.weight)]
      ukemiAnim = hasSpinePlayerAnimation(name) ? name : undefined
    }
    if (ukemiAnim) return { anim: ukemiAnim, sec: since, restart: fresh, clock: since }
    return undefined
  }
  if (fresh && p.state !== 'parrying') ukemiSparkT = spark.t
  ukemiAnim = undefined
  return undefined
}

// FXイベントから求める描画専用の押し返し。Player.x を一切書き換えない。
function guardImpactVisualPush(state: GameState): number {
  // 受け身 (10-21・src/ukemi.ts) は本当に半歩下がる (hits.ts) ので、描画だけの押し返しは重ねない。
  if (ukemiOn()) return 0
  const impact = state.fx.find((f) => f.kind === 'player_guard_impact' && state.time - f.t >= 0 && state.time - f.t < 0.18)
  if (!impact || impact.kind !== 'player_guard_impact') return 0
  const u = (state.time - impact.t) / 0.18
  // 押し返しの深さも体幹で変える (2026-07-20 案1)。 追い詰められるほど耐えきれず大きく下がる。
  //   ※ 描画だけ。 Player.x も判定も動かさないので戦闘コアには触れない。
  const strain = impact.postureRatio * impact.postureRatio * (3 - 2 * impact.postureRatio)
  return -impact.dir * Math.sin(u * Math.PI) * (7 + strain * 9) * guardPushMul()
}

// 弾き崩し A+B (2026-10-05)。A＝画面 (世界の層だけ) の色が抜けてぼやける・B＝その上に朱の火の粉が色付きで残る。
//   止めの間は state.time が進まない＝色が抜けたまま止まる。ctx.filter の無い環境では色は抜けず、朱の光だけ出る。
let parryBreakScratch: HTMLCanvasElement | null = null
function drawParryBreakScreen(ctx: CanvasRenderingContext2D, state: GameState, ox: number, oy: number): void {
  if (getParryBreakLook() !== 'ab') return
  const f = state.fx.find((e) => e.kind === 'parry_break' && state.time - e.t >= 0)
  if (!f || f.kind !== 'parry_break') return
  const age = state.time - f.t
  const d = parryBreakDesat(age)
  const cv = ctx.canvas
  if (d > 0.003 && 'filter' in ctx && typeof document !== 'undefined' && cv.width > 0) {
    if (!parryBreakScratch) parryBreakScratch = document.createElement('canvas')
    const sc = parryBreakScratch
    if (sc.width !== cv.width || sc.height !== cv.height) { sc.width = cv.width; sc.height = cv.height }
    const sctx = sc.getContext('2d')
    if (sctx) {
      sctx.setTransform(1, 0, 0, 1, 0, 0); sctx.clearRect(0, 0, sc.width, sc.height); sctx.drawImage(cv, 0, 0)
      const scale = cv.width / ARENA.width
      ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.filter = `grayscale(${0.9 * d}) blur(${2.2 * d * scale / 2}px) brightness(${1 - 0.12 * d})`
      ctx.drawImage(sc, 0, 0)
      ctx.restore()
    }
  }
  ctx.save(); applyCamZoomTransform(ctx); applyFarView(ctx); ctx.translate(ox, oy)
  drawParryBreakAB(ctx, f.x, f.y, f.dir, age)
  ctx.restore()
}

// 気絶エフェクト: 頭上で乱れる白っぽい灰の火 + 暗い灰の縦ノイズ + 淡い赤の危険感 (10-11 purple-stun-mote=②: 旧は紫 PALETTE.fxViolet。 紫はボスの溜めだけ)
// 「無防備=危険」が一目で分かることを最優先に維持する
export function drawStunEffect(ctx: CanvasRenderingContext2D, p: Player, t: number): void {
  const headX = p.x
  // ⚠️ 2026-07-26 修正: 基準を PLAYER.height (=70・当たり判定の高さ) から実表示の高さへ。
  //   人形の絵は PLAYER_DISPLAY_HEIGHT=120 で描かれるので、 70 基準だと「頭上の乱れた魂火」が
  //   胸のあたりに乗り、 衣装の飾りにしか見えなかった (棚卸し §3 で実表示確認)。
  const headY = p.y - PLAYER_DISPLAY_HEIGHT + 8

  // a) 頭上に乱れた魂火 (白っぽい灰 glowMote ×5 — きれいに回転させない・不安定に揺れる)
  for (let i = 0; i < 5; i++) {
    const jx = (hash01(i * 7.3) - 0.5) * 30 + Math.sin(t * (9 + i * 3.1) + i) * 5
    const jy = -(8 + hash01(i * 4.1) * 16) + Math.sin(t * (11 + i * 2.7) + i * 1.3) * 4
    const r = 6 + hash01(i * 11.7) * 7
    const a = Math.max(0, 0.5 + hash01(i * 5.9) * 0.3 + Math.sin(t * (14 + i * 3.3)) * 0.18)
    glowMote(ctx, headX + jx, headY + jy, r, STUN_ASH.light, a)
  }

  // b) 暗い灰の縦ノイズすじ: taperStreak (禁止) を縦列 glowMote ×7粒に置換
  //    各列を7粒の縦散布で「煤の列」として読ませる (3粒以下だと点線=線読みになる)
  for (let i = 0; i < 3; i++) {
    const nx = headX + (hash01(i * 6.1) - 0.5) * 26
    const flickA = 0.18 + 0.14 * Math.abs(Math.sin(t * (18 + i * 4.7) + i * 2.1))
    const colCount = 7
    for (let j = 0; j < colCount; j++) {
      const jy = headY - 2 - hash01(i * 9.3 + j * 2.11) * 32    // 0〜32px 上方向に散らす
      const jx = nx + (hash01(i * 4.7 + j * 3.17) - 0.5) * 5    // 横にわずかなジッター
      const pr = 1.8 + hash01(i * 7.3 + j * 1.91) * 2.2          // 1.8-4.0px
      const pa = flickA * (0.5 + hash01(i * 5.5 + j * 0.97) * 0.6)
      glowMote(ctx, jx, jy, pr, STUN_ASH.dark, pa)
    }
  }

  // c) 最小限のダメージ感 — 無防備=危険を伝える淡い赤の滲み (旧の濃いベタ塗りは出さない)
  glowMote(ctx, p.x, p.y - PLAYER_DISPLAY_HEIGHT / 2, 26, PALETTE.danger,
    0.20 + Math.abs(Math.sin(t * 6)) * 0.10)
}

function drawDreamLance(ctx: CanvasRenderingContext2D, p: Player, t: number): void {
  const handX = 9, handY = -44
  let angle = -0.12 + Math.sin(t * 2) * 0.04
  let length = 56
  const isCounterThrust = p.state === 'attacking' && p.attackIsCounter
  const isExecuting = p.state === 'executing'

  if (p.state === 'attacking') {
    const ms = p.stateElapsed * 1000
    if (ms < PLAYER.attackActiveEndMs) {
      angle = 0.04
      // 突進カウンターはランスがさらに長く伸びる (当たり判定 counterThrustRange に合わせる)
      length = isCounterThrust ? 115 : 64
    } else {
      angle = -0.4
    }
  } else if (p.state === 'parrying') {
    const ms = p.stateElapsed * 1000
    if (ms < p.parryActiveMsEffective) { angle = -0.65; length = 50 }
    else angle = -0.35
  } else if (p.state === 'stepping') {
    angle = -0.1; length = 56
  } else if (p.state === 'stunned') {
    angle = 0.3; length = 56
  } else if (p.state === 'executing') {
    // 致命の一撃: 3ヒットそれぞれ異なるランスポーズ
    //  hit 0: 大きく前に突き (counterThrust 並みのリーチ)
    //  hit 1: 横薙ぎ (フェーズ中に角度が -1.0 → +0.6 に振れる)
    //  hit 2: 振りかぶって叩き落とす (-1.2 → 0.6)
    const elapsedMs = p.stateElapsed * 1000
    const phaseStart = p.executeHitIndex * EXECUTE.perHitDurationMs
    const phaseProgress = Math.min(1, (elapsedMs - phaseStart) / EXECUTE.perHitDurationMs)
    if (p.executeHitIndex === 0) {
      angle = 0.0; length = 110
    } else if (p.executeHitIndex === 1) {
      angle = -1.0 + phaseProgress * 1.6
      length = 78
    } else {
      angle = -1.2 + phaseProgress * 1.8
      length = 88
    }
  }
  const tipX = handX + Math.cos(angle) * length
  const tipY = handY + Math.sin(angle) * length
  const baseX = handX - Math.cos(angle) * 8
  const baseY = handY - Math.sin(angle) * 8

  // 突進中・致命中はランスの軌跡 (光る尾) を引く
  if (isCounterThrust || isExecuting) {
    // 影抜き (DEV ?counterLook=shadow) の時、反撃の突きだけ金→銀白 (致命は金のまま)。
    const trailCol = isCounterThrust ? counterAccentColor(PALETTE.parrySparkWarm) : PALETTE.parrySparkWarm
    ctx.save()
    ctx.strokeStyle = trailCol
    ctx.shadowColor = trailCol
    ctx.shadowBlur = isExecuting ? 26 : 20
    ctx.lineWidth = isExecuting ? 5 : 4
    ctx.globalAlpha = isExecuting ? 0.8 : 0.65
    ctx.beginPath()
    ctx.moveTo(baseX, baseY); ctx.lineTo(tipX, tipY)
    ctx.stroke()
    ctx.restore()
  }

  strokePath(ctx, PALETTE.playerSpear, (isCounterThrust || isExecuting) ? 3 : 2, () => {
    ctx.moveTo(baseX, baseY); ctx.lineTo(tipX, tipY)
  })
  strokePath(ctx, PALETTE.playerHairHi, 1.5, () => {
    ctx.moveTo(handX, handY)
    ctx.lineTo(handX - 3, handY + 6)
    ctx.lineTo(handX + 2, handY + 10)
  })
  ctx.save()
  const tipColor = isExecuting ? PALETTE.parrySparkWarm
    : (p.counterWindow > 0 || isCounterThrust) ? counterAccentColor(PALETTE.parrySparkWarm) : PALETTE.playerSpearTip
  ctx.shadowColor = tipColor
  ctx.shadowBlur = isExecuting ? 34 : isCounterThrust ? 30 : (p.state === 'parrying' ? 18 : (p.counterWindow > 0 ? 20 : 10))
  fillPath(ctx, tipColor, () => {
    const dx = Math.cos(angle), dy = Math.sin(angle)
    const px = -dy, py = dx
    const tx = tipX, ty = tipY
    const tipSize = isExecuting ? 9 : isCounterThrust ? 8 : 6
    ctx.moveTo(tx + dx * tipSize, ty + dy * tipSize)
    ctx.lineTo(tx + px * 4.5, ty + py * 4.5)
    ctx.lineTo(tx - dx * 4, ty - dy * 4)
    ctx.lineTo(tx - px * 4.5, ty - py * 4.5)
    ctx.closePath()
  })
  ctx.restore()
}

function drawParryRing(ctx: CanvasRenderingContext2D, p: Player, t: number): void {
  const ms = p.stateElapsed * 1000
  const active = ms < p.parryActiveMsEffective
  const fwd = p.facing === 'right' ? 1 : -1

  // 前方・胸高あたりの基点
  const bx = p.x + fwd * 14
  const by = p.y - PLAYER.height * 0.55

  // fwd 方向への基準角
  const fwdAng = fwd > 0 ? 0 : Math.PI

  if (active) {
    // 受付中: taperStreak ×3 (禁止) を前方扇形 spread の glowMote ×8 に置換
    //   扇角 ±25° (0.44 rad) で「弾けるよ」のベクトル感を維持
    const flicker = 0.75 + 0.25 * Math.abs(Math.sin(t * 38))
    const a = 0.85 * flicker
    const spread = 0.44   // ±25° in radians
    const N = 8
    for (let i = 0; i < N; i++) {
      const ang = fwdAng + (hash01(i * 3.71 + t * 0.4) - 0.5) * spread * 2
      const dist = 8 + hash01(i * 1.97) * 28           // 8-36px
      const px = bx + Math.cos(ang) * dist
      const py = by + Math.sin(ang) * dist
      const pr = 2.5 + hash01(i * 2.33) * 3.0          // 2.5-5.5px
      const col = hash01(i * 5.11) > 0.5 ? '#f2f7ff' : '#cfe0f5'
      const pa = a * 0.7 * (0.5 + hash01(i * 4.17) * 0.5)
      glowMote(ctx, px, py, pr, col, pa)
    }
    glowMote(ctx, bx, by, 12, '#f2f7ff', a * 0.6)   // 核は維持
  } else {
    // 受付切れ: 同じ spread だが粒子数 ×3、alpha 0.18 まで落とす
    const N = 6
    const spread = 0.44
    for (let i = 0; i < N; i++) {
      const ang = fwdAng + (hash01(i * 3.71) - 0.5) * spread * 2
      const dist = 6 + hash01(i * 1.97) * 18
      const px = bx + Math.cos(ang) * dist
      const py = by + Math.sin(ang) * dist
      const pr = 2.0 + hash01(i * 2.33) * 2.0
      const col = hash01(i * 5.11) > 0.5 ? '#cfe0f5' : '#f2f7ff'
      glowMote(ctx, px, py, pr, col, 0.18 * (0.5 + hash01(i * 4.17) * 0.5))
    }
    glowMote(ctx, bx, by, 7, '#cfe0f5', 0.11)        // 核は維持
  }
}

function drawCounterAura(ctx: CanvasRenderingContext2D, p: Player, t: number): void {
  const cx = p.x
  const footY = p.y
  const a = Math.min(1, p.counterWindow * 2.5) * 0.85
  if (a <= 0.01) return

  // 足元の縦グラデ金グロー (低く薄く)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const glowH = 30
  const grad = ctx.createLinearGradient(0, footY - glowH, 0, footY)
  grad.addColorStop(0, 'rgba(0,0,0,0)')
  grad.addColorStop(1, PALETTE.parrySparkWarm)
  ctx.globalAlpha = a * 0.22
  ctx.fillStyle = grad
  ctx.fillRect(cx - 22, footY - glowH, 44, glowH)
  ctx.restore()

  // 足元から立ち上る金の魂火 (「今カウンターできる」=金の発光)
  emberRise(ctx, cx, footY, Math.round(6 + a * 6), PALETTE.parrySparkWarm, t, 53, 48, 38)
}

// ============== ボス (ID で分岐) ==============
// スプライトを持つボスは drawBossFromSprite に流す。それ以外は procedural 描画
function drawBoss(ctx: CanvasRenderingContext2D, state: GameState, opts?: RenderOptions): void {
  // 実験フラグ (2026-09-01・王/dream-hound限定): houndBite だけ Spine 骨格アニメで描く経路の検証。
  //   🔴 **実験は 2026-09-01 に不採用で終了** (ボスはキーフレームの絵の切り替えで作る・ユーザー裁定)。
  //   この分岐はラボ専用の残骸で、**渡すのは boss_motion_lab.ts だけ**。ゲーム本体は通らない。
  //   🔴 **他のボスへ広げない。** 理由 = docs/reports/2026-09-01-boss-spine-mesh-experiment-closeout.md
  //   既定 (opts?.bossSpine 未指定) では1画素も変わらない。対象外の技/phase では
  //   drawBossSpineIfReady が false を返し、下の既存経路 (drawHound) へそのまま続く。
  const b = state.boss
  if (opts?.bossSpine && b.id === 'dream-hound') {
    const facingMul = b.facing === 'right' ? -1 : 1 // このスケルトンは SOURCE_FACING と同じ「左向き」で作成
    ctx.save()
    ctx.translate(b.x, bossFootY(b))
    ctx.scale(facingMul, 1)
    const drew = drawBossSpineIfReady(ctx, b)
    ctx.restore()
    if (drew) return
  }
  // 花嫁: 2026-06-14 本番絵モーション Tier1 配線済 → hasBossSprite 経路へ (固定 return 撤去)。
  //   27枚の本番絵 + BOSS_ATTACK_TIMELINES['bride'] で windup→contact→recovery が読める。
  //   ⚠️ drawBride 関数は hollow-actor の借り衣装 (drawCostumeSprite・H1926) で使うため残す (削除しない)。
  if (state.boss.id === 'nameless-shade') return drawShade(ctx, state)
  // vigil-knight: E-1 で本番スプライトへ移行 → 下の hasBossSprite 経路へ
  //   (drawKnight 自体は hollow-actor の衣装借用で流用継続するため残す)
  // the-executioner / former-princess: E-3/E-2 で本番スプライトへ移行 → hasBossSprite 経路へ
  //   (drawExecutioner / drawPrincess は将来の衣装借用・参照用に残置)
  // crowned-king-awoken: E-6 で本番スプライトへ移行 → hasBossSprite 経路へ
  //   (drawAwokenKing は将来の衣装借用・参照用に残置)
  // inverted-jester / blade-dancer: E-4/E-5 で本番スプライトへ移行 → hasBossSprite 経路へ
  //   (drawDancer は将来の衣装借用・参照用に残置。道化の drawJester は 10-29 に LUNAIRE-notes へ退避)
  if (state.boss.id === 'hollow-actor') return drawHollowActor(ctx, state)
  if (hasBossSprite(state.boss.id)) {
    // 騎士のすり足の床の砂は床の層 = 騎士の絵より先 (足が砂に被さる)。砂を足すのはすり足の動き (src/knight_suri_dust.ts)。
    if (state.boss.id === 'vigil-knight' && state.phase === 'playing') knightSuriDust.render(ctx, state.time * 1000)
    // 覚醒王の回転: 尾の弧の奥側は体より先、手前側と土煙は体の後 (src/awoken_spin_fx.ts・状態を持たない)。
    const spinFx = state.boss.id === 'crowned-king-awoken' && state.boss.currentAttack?.id === AWOKEN_SPIN_ID
      && state.phase === 'playing'
    const spinH = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[state.boss.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
    if (spinFx) drawAwokenSpinArc(ctx, state.boss, spinH, bossFootY(state.boss), 'back')
    // 覚醒王の後ろ跳び: 引っかき跡は床の層 (体より先)、粉・小石・煙は体の後 (src/awoken_hop_fx.ts)。
    const hopFx = state.boss.id === 'crowned-king-awoken' && state.phase === 'playing'
    if (hopFx) awokenHopFx.drawFloor(ctx, state.time * 1000)
    // 花嫁の回る連撃の白い風と一緒に回る紫の帯 (DEV ?brideSpin=c|bc・10-08/09 試作): 奥の半分は体より先、手前の半分は体の後 (src/bride_spin_fx.ts)。
    const brideWind = state.boss.id === 'bride' && state.phase === 'playing' && brideSpinLayersOn()
    if (brideWind) drawBrideSpinLayers(ctx, state.boss, state.boss.x, bossFootY(state.boss), spinH, 'back')
    // 剣舞の回って終わる連の白い風と薄紫の帯 (src/blade_dancer_spin_fx.ts) は 10-28 に呼ぶのを止めた。
    //   作者「花嫁のエフェクトを付けてほしいわけではない」。回転は効果でなく、回る専用の絵の切り替えで見せる。戻すならここで back / front の2か所を呼ぶ。
    // 鶏の「弾くほど加速」の合図 (src/rooster_rush.ts): 配布版は遅れがある間ずっと体を小刻みに震わせる (遅れに比例・最大 3.2px)。
    //   合図の比較 DEV ?roosterRushCue=fluff|hurry|none (11-03)。fluff は震えの代わりに綿毛を散らす (src/rooster_fx.ts)。
    const rushJitter = state.phase === 'playing' ? roosterRushJitterPx(state.boss, state.time) : 0
    if (rushJitter !== 0) { ctx.save(); ctx.translate(rushJitter, 0) }
    drawBossFromSprite(ctx, state)
    if (rushJitter !== 0) ctx.restore()
    if (state.boss.id === 'inverted-jester' && state.phase === 'playing' && roosterRushCue() === 'fluff') {
      drawRoosterRushFluff(ctx, state.boss, state.time, bossFootY(state.boss), spinH)
    }
    // 鶏の「焦り狂い」の段の合図 (配布版・src/rooster_frenzy.ts): 羽毛を段に合わせて逆立てる。開発版 &roosterFrenzyHud=1 の時だけ頭の上に段の名を出す。
    if (state.phase === 'playing' && roosterFrenzyOn(state.boss)) {
      const stage = roosterFrenzyStage(state.boss)
      drawRoosterFrenzyCue(ctx, state.boss, state.time, bossFootY(state.boss), spinH, stage, roosterFrenzyBreathing(state.boss))
      if (roosterFrenzyHud()) {
        ctx.save()
        ctx.font = 'bold 14px sans-serif'
        ctx.textAlign = 'center'
        ctx.fillStyle = 'rgba(230,232,245,0.85)'
        ctx.fillText(`段${stage} ${FRENZY_STAGES[stage].name}${roosterFrenzyBreathing(state.boss) ? '・息切れ' : ''}`, state.boss.x, bossFootY(state.boss) - spinH - 14)
        ctx.restore()
      }
    }
    if (brideWind) drawBrideSpinLayers(ctx, state.boss, state.boss.x, bossFootY(state.boss), spinH, 'front')
    if (hopFx) awokenHopFx.draw(ctx, state.time * 1000, state.boss.id)
    if (spinFx) {
      drawAwokenSpinArc(ctx, state.boss, spinH, bossFootY(state.boss), 'front')
      drawAwokenSpinDust(ctx, state.boss, spinH, bossFootY(state.boss))
    }
    // 歩きの床の砂 (src/knight_step_dust.ts)。見本どおり足先に少し被さるよう、騎士の絵の後に描く (低いので脛より上は覆わない)。
    if (state.boss.id === 'vigil-knight' && state.phase === 'playing') knightStepDust.render(ctx, state.time * 1000)
    if (state.boss.id === 'vigil-knight' && state.phase === 'playing') knightFloorScrape.draw(ctx, state.time * 1000, state.boss.id)
    return
  }
  switch (state.boss.id) {
    case 'neon-harpy':     return drawHarpy(ctx, state)
    case 'masked-acrobats': return drawAcrobats(ctx, state)
    case 'dream-hound':
    default:               return drawHound(ctx, state)
  }
}

// drawPrincess / drawExecutioner: E-2/E-3 で sprite 経路へ移行したため通常描画では休止。
// drawDancer: E-5 で sprite 経路へ移行したため通常描画では休止。
// drawAwokenKing: E-6 で sprite 経路へ移行したため通常描画では休止。
//   旧手続き描画は将来の衣装借用 (hollow-actor) ・緊急フォールバック・参照用に残置する
//   (§2.1 既存資産は破棄しない)。 下記 void で「意図的に未呼び出し保持」を明示 (tsc 未使用検出回避)。
void drawPrincess
void drawExecutioner
void drawDancer
void drawAwokenKing

// 名も無き亡霊: 本番スプライト (E-8→チケットC 10カット拡張)。 上=実体/下=霧に溶ける半透明を、
//   全体α0.82の幽霊として描く。 custom 描画なので標準スプライト系を通さず個別ロード+先読み
//   (未ロードは旧3键→procedural の二段フォールバック)。
type ShadeLegacyKey = 'idle' | 'active' | 'defeat'
export type ShadePoseKey = ShadeLegacyKey
  | 'staggered' | 'parried'
  | 'slash_windup' | 'slash_precontact' | 'slash_contact' | 'slash_follow'
  | 'thrust_windup' | 'thrust_precontact' | 'thrust_contact' | 'thrust_follow'
  | 'grab_windup' | 'grab_precontact' | 'grab_contact' | 'grab_follow'
  | 'ripple_windup' | 'ripple_cast' | 'ripple_follow'
  | ShadeSlashStepKey
  | 'rise1' | 'rise2'

// 先読みリスト。 'parried' は選択廃止 (弾かれ=recoil 表現・2026-07-05) につき先読みから除外
//   (画像資産 parried.png は残置 = 将来半透明 overlay 方式に戻す選択肢を保つ)。
const SHADE_POSE_KEYS: ShadePoseKey[] = [
  'idle', 'active', 'defeat', 'staggered',
  'slash_windup', 'slash_precontact', 'slash_contact', 'slash_follow',
  'thrust_windup', 'thrust_precontact', 'thrust_contact', 'thrust_follow',
  'grab_windup', 'grab_precontact', 'grab_contact', 'grab_follow',
  'ripple_windup', 'ripple_cast', 'ripple_follow',
]

// 攻撃 id → 溜め/予兆終盤/接触/後続 ポーズ键。 亡霊以外の攻撃 id は乗らない (goal: 亡霊限定の絵)。
//   ripple だけ precontact 無し (波は windup を予兆終盤まで継続=チケットF仕様)。
const SHADE_WINDUP_KEY: Record<string, ShadePoseKey> = {
  shadeSlash: 'slash_windup',
  // 稽古の比較版 (DEV ?tutFocus・src/tut_focus.ts) の三連の斬りと決め技は、斬りの4枚を使い回す。
  shadeGuardChain: 'slash_windup',
  shadeExecution: 'slash_windup',
  shadeThrust: 'thrust_windup',
  shadeGrab: 'grab_windup',
  shadeRipple: 'ripple_windup',
}
const SHADE_PRECONTACT_KEY: Record<string, ShadePoseKey> = {
  shadeSlash: 'slash_precontact',
  shadeGuardChain: 'slash_precontact',
  shadeExecution: 'slash_precontact',
  shadeThrust: 'thrust_precontact',
  shadeGrab: 'grab_precontact',
  // shadeRipple: 意図的に未登録 (precontact 無し・windup 継続)
}
const SHADE_CONTACT_KEY: Record<string, ShadePoseKey> = {
  shadeSlash: 'slash_contact',
  shadeGuardChain: 'slash_contact',
  shadeExecution: 'slash_contact',
  shadeThrust: 'thrust_contact',
  shadeGrab: 'grab_contact',
  shadeRipple: 'ripple_cast',
}
const SHADE_FOLLOW_KEY: Record<string, ShadePoseKey> = {
  shadeSlash: 'slash_follow',
  shadeGuardChain: 'slash_follow',
  shadeExecution: 'slash_follow',
  shadeThrust: 'thrust_follow',
  shadeGrab: 'grab_follow',
  shadeRipple: 'ripple_follow',
}

// telegraph 進行度がこの値以上で precontact (溜め終盤) へ切り替え。 ripple は対象外 (windup 継続)。
const SHADE_PRECONTACT_THRESHOLD = 0.8

// ポーズ键選択 (純関数・単体テスト対象=tests/shade_pose.test.ts)。
//   telegraphProgress = telegraph 中の溜め進行度 0-1 (telegraph 以外は無視してよい。render.ts の
//   telegraphProgress(b) ヘルパの戻り値をそのまま渡す想定)。
//   ★弾かれ (パリィ直後) はポーズを差し替えない (2026-07-05 ユーザー指摘で廃止):
//     攻撃モーションの state machine は中断されないので、ハード差し替えすると
//     「攻撃→のけぞり絵→振り抜き絵」と再生されて矛盾する。 弾かれ表現は騎士方式
//     = recoil オフセット (drawShadeBody 内・体ごと後退) で出す。 parried.png は資産として残置。
export function selectShadePoseKey(
  b: { hp: number; state: Boss['state']; currentAttack: Boss['currentAttack'] },
  telegraphProgress = 0,
): ShadePoseKey {
  if (b.hp <= 0) return 'defeat'
  if (b.state === 'staggered') return 'staggered'
  const atkId = b.currentAttack?.id
  if (b.state === 'telegraph' && atkId) {
    if (telegraphProgress >= SHADE_PRECONTACT_THRESHOLD && SHADE_PRECONTACT_KEY[atkId]) {
      return SHADE_PRECONTACT_KEY[atkId]
    }
    if (SHADE_WINDUP_KEY[atkId]) return SHADE_WINDUP_KEY[atkId]
  }
  // 三連の斬り (比較版 DEV ?tutFocus) の段の間は、振りかぶり直す (接触の絵のまま次の段が出ると、溜め無しで当たって見える)。
  if (b.state === 'comboGap' && atkId === 'shadeGuardChain') return 'slash_precontact'
  if (
    (b.state === 'active' || b.state === 'comboGap' || b.state === 'beatGap') &&
    atkId && SHADE_CONTACT_KEY[atkId]
  ) return SHADE_CONTACT_KEY[atkId]
  if (b.state === 'recovery' && atkId && SHADE_FOLLOW_KEY[atkId]) return SHADE_FOLLOW_KEY[atkId]
  return 'idle'
}

const shadeImgCache: Record<string, HTMLImageElement> = {}
function shadeImg(name: ShadePoseKey): HTMLImageElement | null {
  if (typeof Image === 'undefined') return null
  let img = shadeImgCache[name]
  // 亡霊は SPRITE_BOSSES 経路を通らない (drawShade が独自に読む) ので、拡張子もここで引く。
  // 出所 = docs/candidates/2026-08-04-sprite-webp-ticket.md / docs/backlog.md（旧 sweep-queue）
  if (!img) {
    const ext = SPRITE_EXT_BY_BOSS['nameless-shade'] ?? 'png'
    img = new Image(); img.src = `/sprites/bosses/nameless-shade/${name}.${ext}`; shadeImgCache[name] = img
  }
  return img.complete && img.naturalWidth > 0 ? img : null
}
const SHADE_H = 230            // 霧の裾込みの表示高 → 実体部≈130。 実機で微調整
const SHADE_FOOT_OFFSET = 12   // 霧の裾を床のやや下まで

// windup 键 → precontact 键への画像フォールバック逆引き (precontact 未ロード → windup へ後退)。
const SHADE_PRECONTACT_FALLBACK: Partial<Record<ShadePoseKey, ShadePoseKey>> = {
  slash_precontact: 'slash_windup',
  thrust_precontact: 'thrust_windup',
  grab_precontact: 'grab_windup',
}
// follow 键 → contact 键への画像フォールバック (follow 未ロード → contact へ後退)。
const SHADE_FOLLOW_FALLBACK: Partial<Record<ShadePoseKey, ShadePoseKey>> = {
  slash_follow: 'slash_contact',
  thrust_follow: 'thrust_contact',
  grab_follow: 'grab_contact',
  ripple_follow: 'ripple_cast',
  // 段の絵 (比較版) が未ロードなら振り抜きのまま。
  slash_step_a: 'slash_follow',
  slash_step_b: 'slash_follow',
}

// 中間コマ (precontact/follow) の画像フォールバック先を返す純関数 (単体テスト対象)。
//   対象外の键 (windup/contact/idle/staggered/parried/defeat 等) は undefined = フォールバック無し。
//   drawShade はこの戻り値が undefined の時、旧3键ロジック (idle/active/defeat) へ後退する。
export function shadeMidFallbackPoseKey(desired: ShadePoseKey): ShadePoseKey | undefined {
  return SHADE_PRECONTACT_FALLBACK[desired] ?? SHADE_FOLLOW_FALLBACK[desired]
}

// bob (idle 浮遊揺らぎ) をフル適用する键。 windup 系のみ (idle も含む)。
const SHADE_BOB_FULL_KEYS = new Set<ShadePoseKey>([
  'idle', 'slash_windup', 'thrust_windup', 'grab_windup', 'ripple_windup',
])
const SHADE_BOB_BLEND_SEC = 0.2   // bob 係数 1→0 の遷移時間 (precontact/contact/follow 突入時)
const SHADE_STAGGER_SINK_SEC = 0.3 // staggered 沈み込みのイーズイン時間
const SHADE_STAGGER_SINK_PX = 12
// rise2 の絵は足が床に着くが、構え (idle) の絵は 13px 浮いて描かれる (10-30 測定)。
const SHADE_RISE2_LIFT_PX = 13

// 純関数 (単体テスト対象=tests/shade_pose.test.ts): idle 浮遊揺らぎ + staggered 沈み込みの
//   縦オフセット (px・下が正)。 段差禁止=常に時間補間でなめらかに繋ぐ (design_procedural_motion_must_be_smooth)。
//   t = state.time (絶対秒。 sin の位相用) / poseKey = 現在のポーズ键 / stateElapsed = b.stateElapsed
//   (現 state に入ってからの経過秒。 bob 係数のブレンド・staggered イーズインの起算に使う)。
export function shadeBobOffset(t: number, poseKey: ShadePoseKey, stateElapsed: number): number {
  if (poseKey === 'defeat') return 0   // 既存の撃破フェードのまま (bob 0)
  // 立ち上がり (10-30): rise1 は沈んだ崩れと同じ深さから、rise2 は浮いた構えと同じ高さで描く (溶け替わりで上下に二重に見えないように)。
  if (poseKey === 'rise1' && bossRiseFitOn()) return SHADE_STAGGER_SINK_PX
  if (poseKey === 'rise2' && bossRiseFitOn()) return -SHADE_RISE2_LIFT_PX
  const bob = Math.sin(t * 1.6) * 2.5
  if (poseKey === 'staggered') {
    // bob 0 + 沈み込み +12px へ 0.3 秒でイーズイン (スナップ禁止)
    const k = Math.min(1, Math.max(0, stateElapsed / SHADE_STAGGER_SINK_SEC))
    const eased = 1 - (1 - k) * (1 - k)   // ease-out (滑らかに沈み切る)
    return eased * SHADE_STAGGER_SINK_PX
  }
  // bob 係数: フル適用键=1、 それ以外=0。 键切替時刻 (stateElapsed) から 0.2 秒で滑らかに補間。
  const targetCoef = SHADE_BOB_FULL_KEYS.has(poseKey) ? 1 : 0
  const k = Math.min(1, Math.max(0, stateElapsed / SHADE_BOB_BLEND_SEC))
  const eased = k * k * (3 - 2 * k)   // smoothstep (立ち上がり/立ち下がり共になめらか)
  // stateElapsed=0 の瞬間は「直前の键から今の键へ移った直後」= 前の係数から補間開始したいが、
  // 前状態の係数を持ち回らない設計 (呼び出し側は poseKey 単位の純関数として呼ぶ) なので、
  // windup系へ入る時は 0→1、非windup系へ入る時は 1→0 として扱う (どちら方向でも smoothstep で滑らか)。
  const startCoef = targetCoef === 1 ? 0 : 1
  const coef = startCoef + (targetCoef - startCoef) * eased
  return bob * coef
}

const SHADE_GHOST_ALPHA = 0.82

// 本体画像を1枚描く (drawShade 本描画と bakeCurseSilhouette=赤呪いオーラのシルエット焼きの共通部)。
//   姿勢選択+二段フォールバック+左右反転+浮遊bob に加え、 溜め tension (telegraph 進行で最大5%
//   じわっと拡大 + ±1.2px 微振動) を含む = sprites.ts Case-A (騎士たちスプライト共通) と同じプログラム。
//   カスタム描画の亡霊だけ「溜めてる感じ」が抜けていた穴を塞ぐ (2026-07-05 ユーザー指摘)。
//   alpha は掛けない (呼び出し側: 本描画=幽霊0.82 / シルエット焼き=1)。 戻り値 false = 画像未ロード。
function drawShadeBody(ctx: CanvasRenderingContext2D, state: GameState): boolean {
  const b = state.boss
  const progress = b.state === 'telegraph' ? telegraphProgress(b) : 0
  // src/shade_wave_sync.ts (既定 on・DEV の ?shadeWaveSync=0 で旧): 波は溜めの残り 100ms で「放つ」絵へ (当たりの開始より前に出す)。
  const rippleEarly = rippleCastEarly(b)
  // 斬りの戻り (src/shade_slash_smooth_1028.ts): 後半は段の絵 (振り抜き→段A→段B→待機)。?shadeSlashSmooth=old は null で前の配布版。
  //   既定 1029 は絵を溶かしながら替える (shadeSlashBlend)。
  const blend = rippleEarly ? null : shadeSlashBlend(b)
  // 崩れから立ち上がる2枚 (2026-10-30・src/boss_rise.ts)。亡霊はほかのボスの絵の選び方を通らないので、ここで挟む。
  const rise = b.hp > 0 ? bossRiseKey() as ShadePoseKey | null : null
  const desired: ShadePoseKey = rise ?? (rippleEarly ? 'ripple_cast' : blend?.key ?? shadeSlashStepKey(b) ?? selectShadePoseKey(b, progress))
  let poseKey: ShadePoseKey = desired
  let img = shadeImg(desired)
  if (!img) {
    // 中間コマ (precontact/follow) が未ロード/欠損 → 対応する現行键 (windup/contact) へ後退
    const midFallback = shadeMidFallbackPoseKey(desired)
    if (midFallback) {
      poseKey = midFallback
      img = shadeImg(midFallback)
    }
  }
  if (!img) {
    // それでも無ければ旧3键ロジックへ後退 (安全網。procedural は更にその下)
    let legacyKey: ShadeLegacyKey = 'idle'
    if (b.hp <= 0) legacyKey = 'defeat'
    else if (b.state === 'active' || b.state === 'comboGap' || b.state === 'beatGap' || b.state === 'recovery') legacyKey = 'active'
    poseKey = legacyKey
    img = shadeImg(legacyKey)
  }
  if (!img) return false
  const bobY = shadeBobOffset(state.time, poseKey, ripplePoseElapsedSec(b))
  // 溜め tension: sprites.ts の telegraph tension と同値 (prog で 5% 拡大 + prog*1.2px 微振動)。
  //   shadeWaveSync (既定 on) で放つ絵へ前倒しした後は、溜めが解けたので膨らみ・震えを掛けない。
  let scaleK = 1, shakeX = 0, shakeY = 0
  if (b.state === 'telegraph' && b.currentAttack && !rippleEarly) {
    scaleK = 1 + progress * 0.05
    const trembleAmp = progress * 1.2
    shakeX = (Math.random() - 0.5) * trembleAmp
    shakeY = (Math.random() - 0.5) * trembleAmp
  }
  // パリィで弾かれた怯み (recoil): 騎士方式 = ポーズ差し替えでなく体ごと後方へのけぞって戻る。
  //   sprites.ts の共通 recoil と同プログラム・overlay 無しボスの標準値 20px (騎士=11 は壁流れ防止の特例)。
  //   モーションは中断されない前提なので、絵は攻撃の続きのまま体だけ弾かれる = 物理として矛盾しない。
  let recoilX = 0, recoilY = 0
  if (state.bossSprite.parryOverlayRemainingSec > 0) {
    const p = state.bossSprite.parryOverlayRemainingSec / PARRY_OVERLAY_DURATION_SEC  // 1=impact → 0
    const recoil = p * p                                    // 鋭く入って戻る
    const awayScreen = b.facing === 'left' ? 1 : -1         // 後方 = facing の逆 (画面空間)
    recoilX = awayScreen * 20 * recoil
    recoilY = -5 * recoil                                   // 軽く浮く
  }
  // 描くのはほかのボスと同じ描く段 (sprites.ts drawShadeSprite = 置き場所・曲げ描き・止まった戻りの動き・撮影の口を通す)。
  //   素材は画面左向き基準 (facing==='right' の時だけ反転)・拡大は足元基準 (上と横へ膨らむ=浮遊体が昂る)・recoil は画面空間。
  // 斬りの踏み込み (src/shade_slash_smooth_1028.ts): 減速して止まる見た目にする。?shadeSlashSmooth=old は 0 で前の配布版。
  //   既定 1029 は戻りの間も体を流す (止まった絵を3枚並べない)。
  recoilX += shadeSlashDx(b)
  recoilY += shadeSlashDy(b)
  const baseAlpha = ctx.globalAlpha
  const fromImg = blend?.from && poseKey === desired ? shadeImg(blend.from) : null
  if (blend?.from && fromImg) {
    ctx.globalAlpha = baseAlpha * blend.fromAlpha
    drawShadeSprite(ctx, b, fromImg, blend.from, { bobY: shadeBobOffset(state.time, blend.from, ripplePoseElapsedSec(b)), shakeX, shakeY, scaleK,
      recoilX: recoilX + blend.fromDx, recoilY: recoilY + blend.fromDy },
      SHADE_H, SHADE_FOOT_OFFSET, state.time, (k) => shadeImg(k as ShadePoseKey))
    ctx.globalAlpha = baseAlpha * blend.toAlpha
    recoilX += blend.toDx
    recoilY += blend.toDy
  }
  // 立ち上がりの溶け替わり (DEV ?bossRiseSmooth=blend|both・src/boss_rise.ts)。
  const riseBlend = !blend?.from && b.hp > 0 ? bossRiseBlend() : null
  const riseFromImg = riseBlend ? shadeImg(riseBlend.from as ShadePoseKey) : null
  if (riseBlend && riseFromImg) {
    ctx.globalAlpha = baseAlpha * Math.min(1, 1.4 * (1 - riseBlend.t))
    drawShadeSprite(ctx, b, riseFromImg, riseBlend.from, { bobY: shadeBobOffset(state.time, riseBlend.from as ShadePoseKey, ripplePoseElapsedSec(b)), shakeX, shakeY, scaleK, recoilX, recoilY },
      SHADE_H, SHADE_FOOT_OFFSET, state.time, (k) => shadeImg(k as ShadePoseKey))
    ctx.globalAlpha = baseAlpha * Math.min(1, 1.4 * riseBlend.t)
  }
  drawShadeSprite(ctx, b, img, poseKey, { bobY, shakeX, shakeY, scaleK, recoilX, recoilY },
    SHADE_H, SHADE_FOOT_OFFSET, state.time, (k) => shadeImg(k as ShadePoseKey))
  ctx.globalAlpha = baseAlpha
  return true
}

function drawShade(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  for (const k of SHADE_POSE_KEYS) void shadeImg(k)   // 先読み
  if (bossRiseHoldMs(b.id) > 0) { void shadeImg('rise1'); void shadeImg('rise2') }
  if (shadeSlashSmoothMode() !== 'old') for (const k of SHADE_SLASH_STEP_KEYS) void shadeImg(k)

  // 可視度制御 = drawBossFromSprite (騎士の制御) と同一。 旧: 均一 alpha フェードのみ →
  //   致命トドメの「セル単位に灰へ崩れる」disintegration が亡霊だけ抜けていた (2026-07-05 ユーザー指摘)。
  const fElapsedBody = finisherBodyElapsedMs(state)
  const fbeat = state.finisher ? finisherBeat(fElapsedBody) : null
  const dissolveA = !state.finisher ? 1
    : fbeat === 'pull' ? 1 - beatProgress(fElapsedBody)
    : (fbeat === 'dissolve' || fbeat === 'absorb' || fbeat === 'silence') ? 0
    : 1
  // 撃破フェード (finisher 非経由の HP ゼロ直行用)。 0.9s→1.0s へ他ボスと統一。
  //   phase≠playing は強制0 (victory 暗幕越しの黒シルエット残留バグ対策・drawBossFromSprite と同じ)。
  const rawDefeatA = b.hp <= 0 ? Math.max(0, 1 - state.bossSprite.defeatElapsedSec / 1.0) : 1
  // 🔵 2026-10-02 AI点検の候補4: 主人公が負けた画面 (defeat) で生きているボスまで消えていた (負けた瞬間にボスがパッと消える)。
  //   負け画面では生きているボスを立たせる (他の画面＝勝利・幕間などは従来どおり強制 0)。
  const defeatA = state.phase === 'playing' || (state.phase === 'defeat' && b.hp > 0) ? rawDefeatA : 0
  const bossVisibility = dissolveA * defeatA
  if (bossVisibility <= 0.01) return

  // 最後の一撃・一突きの版 (配布版の既定・11-01): 騎士たちと同じく刺した胸から光になり、上から欠けて消える。
  //   これが無いと aliceBurstAtClock()=∞ で上の崩落時計が 0 のまま=亡霊だけ暗幕まで立ち続けていた (2026-11-02 6戦の撮影で発見)。
  //   亡霊は普段から暗縁を付けないので outline=false。
  const pierceClock = state.finisher && lunaExecPierceOn() ? aliceClockMs(state) : null
  if (pierceClock !== null) {
    ctx.save()
    ctx.globalAlpha = SHADE_GHOST_ALPHA
    drawPierceBossBody(ctx, (c) => { drawShadeBody(c, state) }, pierceSinceHitMs(pierceClock),
      pierceWound(b, bossFootY(b) - bossDisplayHeightFor(b.id) * 0.36), bossDisplayHeightFor(b.id), false)
    ctx.restore()
    return
  }

  const dissolving = !!state.finisher && dissolveA > 0 && dissolveA < 1
  if (dissolving) {
    const bufs = getOutlineBuffers('boss')
    if (bufs) {
      const bctx = bufs.buf.ctx
      resetOutlineBuffer(bctx)
      if (!drawShadeBody(bctx, state)) { drawShadeProcedural(ctx, state); return }
      // 崩落マスク: 騎士と同じセル欠け (hash 閾値+上ほど先に崩れる=フードから霧へ)。
      const prog = 1 - dissolveA
      const bw = SHADE_H * 1.1
      const footY = b.y + SHADE_FOOT_OFFSET
      const topY = footY - SHADE_H, leftX = b.x - bw / 2
      const cell = 7
      bctx.save()
      bctx.globalCompositeOperation = 'destination-out'
      for (let gy = topY; gy < footY + 4; gy += cell) {
        const yn = Math.max(0, Math.min(1, (gy - topY) / SHADE_H))
        for (let gx = leftX; gx < leftX + bw; gx += cell) {
          const th = hash01(gx * 12.97 + gy * 7.13) * 0.62 + yn * 0.42  // 上=低閾値=先に崩れる
          if (prog > th) {
            const k = Math.min(1, (prog - th) / 0.14)   // セルが柔らかく欠ける
            bctx.globalAlpha = k
            bctx.fillRect(gx, gy, cell, cell)
          }
        }
      }
      bctx.restore()
      ctx.save()
      ctx.globalAlpha = SHADE_GHOST_ALPHA
      drawBufferToWorld(ctx, bufs.buf.canvas)
      ctx.restore()
      return
    }
    // バッファ不可 (テスト環境等) → 均一フェードで後退
  }
  ctx.save()
  ctx.globalAlpha = SHADE_GHOST_ALPHA * bossVisibility
  const ok = drawShadeBody(ctx, state)
  ctx.restore()
  if (!ok) drawShadeProcedural(ctx, state)
}

// --- 名も無き亡霊 (手続きフォールバック・未ロード時のみ) ---
// 半透明の灰白の人型。 足元は霧に溶ける。 3攻撃のポーズを大きく描き分けて
// 「斬り=振りかぶり / 突き=まっすぐ構え / 掴み=両手を開く」の読みを教える。
function drawShadeProcedural(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const t = state.time
  const dir = b.facing === 'right' ? 1 : -1
  const H = 130
  const cp = b.state === 'telegraph' ? telegraphProgress(b) : 0
  const atkId = b.currentAttack?.id ?? ''
  const inAttack = b.state === 'telegraph' || b.state === 'active'
  const lateCue = b.state === 'telegraph' && cp >= 0.7

  let alpha = 0.82
  if (b.hp <= 0) alpha *= Math.max(0, 1 - state.bossSprite.defeatElapsedSec / 0.9)
  if (alpha <= 0.01) return
  const breath = Math.sin(t * 1.6) * 2.5
  const stagSink = b.state === 'staggered' ? 12 : 0

  const x = b.x
  const footY = b.y
  const topY = footY - H + breath + stagSink
  const headR = H * 0.1
  const headY = topY + headR
  const shoulderY = topY + H * 0.24

  ctx.save()
  ctx.globalAlpha = alpha * 0.5
  // 体: 上は実体・下は霧に溶けるローブ (グラデーション)
  const g = ctx.createLinearGradient(0, topY, 0, footY)
  g.addColorStop(0, 'rgba(214,210,224,0.9)')
  g.addColorStop(0.7, 'rgba(180,176,196,0.5)')
  g.addColorStop(1, 'rgba(150,146,170,0)')
  ctx.fillStyle = g
  ctx.beginPath()
  ctx.moveTo(x - H * 0.16, footY)
  ctx.quadraticCurveTo(x - H * 0.17, shoulderY, x - H * 0.085, shoulderY - 6)
  ctx.lineTo(x + H * 0.085, shoulderY - 6)
  ctx.quadraticCurveTo(x + H * 0.17, shoulderY, x + H * 0.16, footY)
  ctx.closePath()
  ctx.fill()
  // 頭 (フード)
  ctx.globalAlpha = alpha * 0.7
  ctx.fillStyle = '#cfcbdd'
  ctx.beginPath()
  ctx.arc(x, headY, headR, 0, Math.PI * 2)
  ctx.fill()
  // 目: 淡く灯る2点 (telegraph 終盤は赤みに)
  ctx.fillStyle = lateCue ? '#ff8aa8' : '#aab4d8'
  ctx.beginPath()
  ctx.arc(x + dir * headR * 0.35 - 3, headY, 2, 0, Math.PI * 2)
  ctx.arc(x + dir * headR * 0.35 + 3, headY, 2, 0, Math.PI * 2)
  ctx.fill()

  // 腕: 攻撃ごとのポーズ (淡い光の線)
  ctx.strokeStyle = 'rgba(225,221,238,0.85)'
  ctx.lineWidth = 4.5
  ctx.lineCap = 'round'
  ctx.globalAlpha = alpha * 0.85
  const armY = shoulderY + 4
  if (atkId === 'shadeSlash' && inAttack) {
    // 振りかぶり → 振り下ろし (頭上の弧 = 弾ける斬撃の形)
    const swing = b.state === 'active' ? 1 : cp
    const a0 = -Math.PI * 0.75
    const a1 = b.state === 'active' ? Math.PI * 0.2 : -Math.PI * 0.35 + cp * 0.25
    const r = H * 0.42
    ctx.beginPath()
    ctx.moveTo(x, armY)
    ctx.lineTo(x + dir * Math.cos(a0 + (a1 - a0) * swing) * r, armY + Math.sin(a0 + (a1 - a0) * swing) * r)
    ctx.stroke()
  } else if (atkId === 'shadeThrust' && inAttack) {
    // まっすぐ前へ構える (突き = 横に伸びる直線)
    const reach = H * (0.2 + (b.state === 'active' ? 0.55 : cp * 0.3))
    ctx.beginPath()
    ctx.moveTo(x, armY + 6)
    ctx.lineTo(x + dir * reach, armY + 6)
    ctx.stroke()
  } else if (atkId === 'shadeGrab' && inAttack) {
    // 両手を開いて迫る (掴み = 2本の開いた腕)
    const open = H * (0.16 + (b.state === 'active' ? 0.3 : cp * 0.22))
    ctx.beginPath()
    ctx.moveTo(x, armY)
    ctx.lineTo(x + dir * open, armY - open * 0.5)
    ctx.moveTo(x, armY + 8)
    ctx.lineTo(x + dir * open, armY + 8 + open * 0.4)
    ctx.stroke()
  }

  // 体幹崩し中の合図
  if (b.state === 'staggered') {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = alpha * (0.22 + 0.12 * Math.sin(t * 18))
    ctx.fillStyle = PALETTE.fxGold
    ctx.beginPath()
    ctx.ellipse(x, footY - H * 0.5, H * 0.26, H * 0.5, 0, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.restore()
}

// --- 主なき近衛騎士 (仮ビジュアル・手続きシルエット) ---
// ユーザー設計 (2026-06-11 たたき台): 半壊した近衛鎧 + 長槍。 槍 = 境界線。
//   荒々しさではなく「静かな圧と正確な型」。 攻撃ごとに槍の構えだけで読みを描き分ける:
//   宣告の突き (lanceThrust)  = 槍を水平に構えて引き絞る → 鋭く伸びる
//   境界の薙ぎ (lanceSweep)  = 槍を斜め上に立てる → 薙ぎ払う
//   撃破時 = 兜が落ちて中が空だとわかり、 槍を支えに寝室の方 (右) を向いて膝をつく
function drawKnight(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const t = state.time
  const H = 155
  const x = b.x
  const footY = b.y

  if (b.hp <= 0) { drawKnightDefeat(ctx, state, H); return }

  const dir = b.facing === 'right' ? 1 : -1
  const cp = telegraphProgress(b)
  const atkId = b.currentAttack?.id ?? ''
  const inAttack = b.state === 'telegraph' || b.state === 'active' || b.state === 'comboGap' || b.state === 'beatGap'
  const lateCue = b.state === 'telegraph' && cp >= 0.7

  // 疲れ切った呼吸 (遅く深い) + 体幹崩しの沈み
  const breath = Math.sin(t * 1.1) * 2
  const stagSink = b.state === 'staggered' ? 16 : 0
  const topY = footY - H + breath + stagSink
  const shoulderY = topY + H * 0.26
  const hipY = footY - H * 0.42 + stagSink * 0.5

  ctx.save()

  // 背中の破れた近衛布 (後方へ・ぼろぼろの裾)。 寝室を守る者だった痕跡 (設計txt)
  ctx.globalAlpha = 0.85
  ctx.fillStyle = '#3d3260'
  ctx.beginPath()
  ctx.moveTo(x - dir * 6, shoulderY - 4)
  ctx.lineTo(x - dir * (26 + Math.sin(t * 1.7) * 4), shoulderY + H * 0.18)
  // 破れた裾 (ジグザグ)
  for (let i = 0; i < 4; i += 1) {
    const fy = shoulderY + H * (0.28 + i * 0.1)
    ctx.lineTo(x - dir * (30 - (i % 2) * 12 + Math.sin(t * 1.9 + i) * 3), fy)
  }
  ctx.lineTo(x - dir * 4, hipY + 8)
  ctx.closePath()
  ctx.fill()

  // 脚 (儀礼的に揃った立ち姿)
  ctx.strokeStyle = '#8b90a6'
  ctx.lineCap = 'round'
  ctx.lineWidth = 7
  ctx.beginPath()
  ctx.moveTo(x - 7, hipY); ctx.lineTo(x - 8, footY)
  ctx.moveTo(x + 7, hipY); ctx.lineTo(x + 9, footY)
  ctx.stroke()

  // 胴 (近衛鎧・上半身は背筋が伸びている)
  ctx.fillStyle = '#9aa0b4'
  ctx.beginPath()
  ctx.moveTo(x - H * 0.11, shoulderY)
  ctx.lineTo(x + H * 0.11, shoulderY)
  ctx.lineTo(x + H * 0.085, hipY)
  ctx.lineTo(x - H * 0.085, hipY)
  ctx.closePath()
  ctx.fill()
  // 半壊の欠け (左肩〜脇腹の暗い欠損。 ボロボロにはしない=設計txt)
  ctx.fillStyle = '#1c1828'
  ctx.beginPath()
  ctx.moveTo(x - dir * H * 0.11, shoulderY + 4)
  ctx.lineTo(x - dir * H * 0.02, shoulderY + H * 0.1)
  ctx.lineTo(x - dir * H * 0.1, shoulderY + H * 0.16)
  ctx.closePath()
  ctx.fill()
  // 擦り切れた紋章 (胸の淡い金)
  ctx.globalAlpha = 0.5
  ctx.fillStyle = PALETTE.fxGold
  ctx.beginPath()
  ctx.arc(x + dir * 3, shoulderY + H * 0.1, 4.5, 0, Math.PI * 2)
  ctx.fill()
  ctx.globalAlpha = 1

  // 肩当て (両肩・近衛の品)
  ctx.fillStyle = '#aab0c4'
  ctx.beginPath()
  ctx.ellipse(x - H * 0.12, shoulderY + 2, 9, 6, 0, 0, Math.PI * 2)
  ctx.ellipse(x + H * 0.12, shoulderY + 2, 9, 6, 0, 0, Math.PI * 2)
  ctx.fill()

  // 兜 (中は真っ暗・顔は見えない)
  const headY = topY + H * 0.1
  ctx.fillStyle = '#9aa0b4'
  ctx.beginPath()
  ctx.arc(x, headY, H * 0.095, Math.PI * 0.95, Math.PI * 2.05)
  ctx.lineTo(x + H * 0.085, headY + H * 0.07)
  ctx.lineTo(x - H * 0.085, headY + H * 0.07)
  ctx.closePath()
  ctx.fill()
  // 面頬のスリット: 真っ暗。 telegraph 終盤だけ冷たく光る
  ctx.fillStyle = '#05040a'
  ctx.fillRect(x - H * 0.07, headY - 1, H * 0.14, 5)
  if (inAttack) {
    ctx.fillStyle = lateCue ? '#ff8aa8' : '#9db4e8'
    ctx.globalAlpha = lateCue ? 0.95 : 0.5
    ctx.fillRect(x + dir * 2 - 4, headY, 8, 2.5)
    ctx.globalAlpha = 1
  }

  // ===== 槍 (境界線)。 構えだけで攻撃を読ませる =====
  const spearL = H * 1.15
  // grip = 持ち手の位置 / angle = 槍の向き (0=前方水平, -PI/2=垂直・穂先上)
  let gripX = x + dir * H * 0.13
  let gripY = shoulderY + H * 0.12
  let angle = -Math.PI / 2 + dir * 0.06   // 常态: ほぼ垂直に立てて持つ (儀礼)
  let tipFlash = false

  if ((atkId === 'lanceThrust' || atkId === 'knightExecution') && inAttack) {
    // 水平に構え、 引き絞り → 鋭く伸ばす。
    angle = 0
    const stanceY = H * 0.16
    if (b.state === 'telegraph') {
      gripX = x - dir * (H * 0.05 + cp * 26)
      gripY = shoulderY + stanceY
      tipFlash = lateCue
    } else {
      gripX = x + dir * H * 0.3                        // 突き出す
      gripY = shoulderY + stanceY
      tipFlash = true
    }
  } else if (atkId === 'lanceSweep' && inAttack) {
    // 斜めに立てる → 薙ぎ下ろす
    if (b.state === 'telegraph') {
      angle = -Math.PI * 0.65 - cp * 0.25              // 後方上段へ引く
      gripY = shoulderY + H * 0.1
    } else {
      const sp = Math.min(1, (b.stateElapsed * 1000) / Math.max(1, b.currentAttack!.activeMs))
      angle = -Math.PI * 0.9 + sp * Math.PI * 0.85     // 上段 → 前方下段へ振り抜く
      gripY = shoulderY + H * 0.1
    }
  } else if (atkId === 'lanceButt' && inAttack) {
    // 高く掲げる → 床へ突き立てる (穂先は下)。 lanceButt (石突の返し) も同じ型 —
    //   帯の telegraph 描画 (位置) が両者の読みの差を見せる
    if (b.state === 'telegraph') {
      angle = Math.PI / 2                              // 穂先 真下
      gripY = shoulderY - H * (0.05 + cp * 0.22)       // 掲げる
      gripX = x + dir * H * 0.1
    } else {
      angle = Math.PI / 2
      gripX = x + dir * H * 0.1
      gripY = footY - spearL + H * 0.18                // 突き立てた (穂先が床)
      tipFlash = true
    }
  } else if (b.state === 'staggered') {
    angle = -Math.PI / 2 + dir * 0.5                   // 型が崩れ、 槍が傾く
    gripY += 10
  }

  // 槍の描画: 石突 → 柄 → 穂先
  const dxA = Math.cos(angle) * dir
  const dyA = Math.sin(angle)
  const buttX = gripX - dxA * spearL * 0.35
  const buttY = gripY - dyA * spearL * 0.35
  const tipX = gripX + dxA * spearL * 0.65
  const tipY = gripY + dyA * spearL * 0.65
  ctx.strokeStyle = '#c9c2ae'
  ctx.lineWidth = 4
  ctx.beginPath()
  ctx.moveTo(buttX, buttY)
  ctx.lineTo(tipX, tipY)
  ctx.stroke()
  // 穂先 (菱形)
  ctx.fillStyle = tipFlash ? '#fff3c4' : '#d8dbe8'
  ctx.save()
  ctx.translate(tipX, tipY)
  ctx.rotate(Math.atan2(dyA, dxA))
  ctx.beginPath()
  ctx.moveTo(14, 0); ctx.lineTo(0, -4.5); ctx.lineTo(-3, 0); ctx.lineTo(0, 4.5)
  ctx.closePath()
  ctx.fill()
  ctx.restore()
  // 腕 (持ち手へ伸ばす・型の美しさ = まっすぐ)
  ctx.strokeStyle = '#8b90a6'
  ctx.lineWidth = 5.5
  ctx.beginPath()
  ctx.moveTo(x + dir * H * 0.1, shoulderY + 6)
  ctx.lineTo(gripX, gripY)
  ctx.stroke()

  // 体幹崩し中の合図 (共通の金色明滅)
  if (b.state === 'staggered') {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = 0.22 + 0.12 * Math.sin(t * 18)
    ctx.fillStyle = PALETTE.fxGold
    ctx.beginPath()
    ctx.ellipse(x, footY - H * 0.5, H * 0.28, H * 0.52, 0, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.restore()
}

// 騎士の撃破演出 (設計txt): 兜が脱げ落ち「中身が空」だとわかる。
//   騎士は槍だけを支えに膝をつき、 それでも寝室の方 (画面右) を向き続ける。
//   「敵を倒した」ではなく「役目が終わってしまった」を出す。 フェードで消さない。
function drawKnightDefeat(ctx: CanvasRenderingContext2D, state: GameState, H: number): void {
  const b = state.boss
  const t = state.time
  const e = state.bossSprite.defeatElapsedSec
  const x = b.x
  const footY = b.y
  const sink = Math.min(1, e / 0.9)            // 0.9s かけて膝をつく
  const ease = 1 - (1 - sink) * (1 - sink)
  const bodyH = H * (1 - 0.38 * ease)          // 立ち姿 → 膝つき
  const dir = 1                                 // 寝室 = 画面右。 倒れても向き続ける

  ctx.save()
  // 槍 (垂直・床に立てて両手で支える)
  const spearX = x + dir * 22
  ctx.strokeStyle = '#c9c2ae'
  ctx.lineWidth = 4
  ctx.beginPath()
  ctx.moveTo(spearX, footY)
  ctx.lineTo(spearX, footY - H * 1.0)
  ctx.stroke()
  ctx.fillStyle = '#d8dbe8'
  ctx.beginPath()
  ctx.moveTo(spearX, footY - H * 1.0 - 12)
  ctx.lineTo(spearX - 4.5, footY - H * 1.0)
  ctx.lineTo(spearX + 4.5, footY - H * 1.0)
  ctx.closePath()
  ctx.fill()

  // 膝をついた体 (前傾・頭は無い)
  const topY = footY - bodyH
  const shoulderY = topY + bodyH * 0.2
  // 布 (静かに垂れる)
  ctx.globalAlpha = 0.85
  ctx.fillStyle = '#3d3260'
  ctx.beginPath()
  ctx.moveTo(x - dir * 4, shoulderY)
  ctx.lineTo(x - dir * 22, footY - 8)
  ctx.lineTo(x - dir * 2, footY)
  ctx.closePath()
  ctx.fill()
  ctx.globalAlpha = 1
  // 脚: 片膝立ち
  ctx.strokeStyle = '#8b90a6'
  ctx.lineCap = 'round'
  ctx.lineWidth = 7
  ctx.beginPath()
  ctx.moveTo(x - 4, footY - bodyH * 0.34); ctx.lineTo(x - 14, footY)               // ついた膝
  ctx.moveTo(x + 4, footY - bodyH * 0.34); ctx.lineTo(x + 16, footY - bodyH * 0.18); ctx.lineTo(x + 16, footY) // 立て膝
  ctx.stroke()
  // 胴 (前傾)
  ctx.fillStyle = '#9aa0b4'
  ctx.beginPath()
  ctx.moveTo(x - H * 0.1, shoulderY)
  ctx.lineTo(x + H * 0.12, shoulderY + 6 * ease)
  ctx.lineTo(x + H * 0.08, footY - bodyH * 0.3)
  ctx.lineTo(x - H * 0.08, footY - bodyH * 0.3)
  ctx.closePath()
  ctx.fill()
  // 首元: 空洞 (中身はない)。 うっすら暗い靄が立ち上る
  ctx.fillStyle = '#05040a'
  ctx.beginPath()
  ctx.ellipse(x + dir * 2, shoulderY - 2, 8, 4.5, 0, 0, Math.PI * 2)
  ctx.fill()
  if (sink >= 1) {
    ctx.globalAlpha = 0.18 + 0.08 * Math.sin(t * 2.3)
    ctx.fillStyle = '#6a6486'
    ctx.beginPath()
    ctx.ellipse(x + dir * 2, shoulderY - 14 - Math.sin(t * 1.4) * 3, 5, 10, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.globalAlpha = 1
  }
  // 両腕: 槍を支えに
  ctx.strokeStyle = '#8b90a6'
  ctx.lineWidth = 5.5
  ctx.beginPath()
  ctx.moveTo(x + dir * 6, shoulderY + 4)
  ctx.lineTo(spearX, footY - bodyH * 0.52)
  ctx.moveTo(x + dir * 2, shoulderY + 8)
  ctx.lineTo(spearX, footY - bodyH * 0.4)
  ctx.stroke()

  // 兜: 放物線で落ちて転がる (0.35s 後に落ち始め、 床で止まる)
  const hf = Math.max(0, Math.min(1, (e - 0.35) / 0.7))
  const helmX = x + dir * (10 + hf * 34)
  const helmY = (footY - bodyH * 0.92) * (1 - hf) + (footY - 7) * hf - Math.sin(hf * Math.PI) * 26
  const roll = hf * 2.6
  ctx.save()
  ctx.translate(helmX, helmY)
  ctx.rotate(roll)
  ctx.fillStyle = '#9aa0b4'
  ctx.beginPath()
  ctx.arc(0, 0, H * 0.09, Math.PI * 0.95, Math.PI * 2.05)
  ctx.lineTo(H * 0.08, H * 0.065)
  ctx.lineTo(-H * 0.08, H * 0.065)
  ctx.closePath()
  ctx.fill()
  ctx.fillStyle = '#05040a'   // 転がった兜の中も、 暗いだけ
  ctx.fillRect(-H * 0.065, -1, H * 0.13, 4.5)
  ctx.restore()
  ctx.restore()
}

// --- 覚醒王 (王の再登場・暴走) ---
// 第1ボス「王」と同じ獣のシルエットを流用し、 くすんだ紫黒/滲む黒紅のオーラと残光で「同じ獣が、
//   壊れて戻ってきた」を一目で伝える。 速度はデータ側 (溜め短縮+歩速1.15) が担う。
// ⚠️ 2026-06-14 裁定 7-3: 旧「真紅 (255,64,88)・速いパルス」を**くすんだ紫黒/滲む黒紅・静か・低明度**へ
//   (常時オーラ=静か/低明度 ⇔ 裁定C「弾けない=赤黒い呪いオーラ」=高明度/脈打つ で見分けを付ける)。
//   ※本番スプライトに赤が焼き込まれている分の再生成はアート部 (紫黒オーラ前提)。 ここはコード側オーラ色のみ。
function drawAwokenKing(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const t = state.time
  // くすんだ紫黒/滲む黒紅のオーラ (本体の後ろ・加算)。 常時=静か・低明度 (裁定C赤との差別化)
  if (b.hp > 0 && b.state !== 'blink') {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    const pulse = 0.18 + 0.05 * Math.sin(t * 3.0)   // 静か・ゆっくり・低明度
    const g = ctx.createRadialGradient(b.x, b.y - 48, 8, b.x, b.y - 48, 130)
    g.addColorStop(0, `rgba(104,38,74,${pulse})`)    // 滲む黒紅 (くすんだ紫黒寄り)
    g.addColorStop(1, 'rgba(104,38,74,0)')
    ctx.fillStyle = g
    ctx.fillRect(b.x - 140, b.y - 185, 280, 195)
    // 立ち上る黒紅の火の粉 (決定的: 時間ハッシュで揺らす)。 静かに少なく
    ctx.fillStyle = '#5e2c4c'
    for (let i = 0; i < 7; i += 1) {
      const ph = (t * 0.5 + i * 0.143) % 1
      const px = b.x + Math.sin(i * 12.9898 + t * 1.7) * 55
      const py = b.y - 10 - ph * 120
      ctx.globalAlpha = 0.34 * (1 - ph)
      ctx.fillRect(px, py, 3, 3)
    }
    // 床に滲む黒紅
    ctx.globalAlpha = 0.42
    ctx.fillStyle = `rgba(96,34,68,${pulse})`
    ctx.beginPath()
    ctx.ellipse(b.x, b.y, 76, 8, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
  }
  drawHound(ctx, state)
}

// --- 先代の姫 (ラスボス・仮ビジュアル) ---
// 主題「鏡」: プレイヤーとほぼ同じ背格好 (H125・人間サイズ) の、 灰白の残像のような姫。
//   君が黒なら彼女は白 — 色だけが反転した鏡。 細剣の術理も君の写し:
//   鏡映の斬撃 = 振りかぶり / 鏡映の突き = 低い構えからの刺突 / 円舞 = 2連の剣閃
//   部屋3の舞台技 (照明/緞帳/鐘) は腕を掲げて「舞台に命じる」所作で読みを出す。
//   撃破 = 膝をつき、 灰の光の粒になって静かに昇っていく (ティアラだけが床に残る)。
function drawPrincess(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const t = state.time
  const H = 125
  const x = b.x
  const footY = b.y
  const dir = b.facing === 'right' ? 1 : -1
  const cp = telegraphProgress(b)
  const atkId = b.currentAttack?.id ?? ''
  const inAttack = b.state === 'telegraph' || b.state === 'active' || b.state === 'comboGap' || b.state === 'beatGap'
  const lateCue = b.state === 'telegraph' && cp >= 0.7
  const defeated = b.hp <= 0
  const e = defeated ? state.bossSprite.defeatElapsedSec : 0
  const sink = defeated ? Math.min(1, e / 1.0) : 0

  // 撃破: 本体は徐々に薄れ、 光の粒が昇る。 ティアラは床へ
  let alpha = 1
  if (defeated) {
    alpha = Math.max(0, 1 - e / 2.6)
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    for (let i = 0; i < 12; i += 1) {
      const ph = (e * 0.5 + i * 0.083) % 1
      ctx.globalAlpha = 0.7 * (1 - ph) * Math.min(1, e / 0.5)
      ctx.fillStyle = '#efe9d8'
      ctx.fillRect(x + Math.sin(i * 7.31 + t) * 30, footY - 20 - ph * 150, 2.5, 2.5)
    }
    // ティアラ (床に残る)
    ctx.globalCompositeOperation = 'source-over'
    const tf = Math.min(1, Math.max(0, (e - 0.4) / 0.7))
    if (tf > 0) {
      ctx.globalAlpha = 1
      ctx.strokeStyle = '#d8c878'
      ctx.lineWidth = 2.5
      ctx.beginPath()
      ctx.arc(x + dir * (6 + tf * 18), footY - 4, 7, Math.PI, Math.PI * 2)
      ctx.stroke()
    }
    ctx.restore()
    if (alpha <= 0.01) return
  }

  const breath = defeated ? 0 : Math.sin(t * 1.5) * 2
  const stagSink = b.state === 'staggered' ? 12 : 0
  const bodyH = H * (1 - 0.32 * sink)   // 撃破: 膝をつく
  const topY = footY - bodyH + breath + stagSink
  const shoulderY = topY + bodyH * 0.24
  const hipY = footY - bodyH * 0.44

  ctx.save()
  ctx.globalAlpha = alpha

  // 長い髪 (君と同じ形・色だけ灰白)
  ctx.strokeStyle = '#ddd6c8'
  ctx.lineCap = 'round'
  ctx.lineWidth = 5
  ctx.beginPath()
  ctx.moveTo(x - dir * 4, topY + bodyH * 0.06)
  ctx.quadraticCurveTo(
    x - dir * (18 + Math.sin(t * 2.1) * 5), topY + bodyH * 0.3,
    x - dir * (14 + Math.sin(t * 1.7) * 7), topY + bodyH * 0.62)
  ctx.stroke()

  // スカート (淡い白のドレス)
  ctx.fillStyle = '#cfc8ba'
  ctx.beginPath()
  ctx.moveTo(x - 6, hipY)
  ctx.lineTo(x + 6, hipY)
  ctx.lineTo(x + H * 0.16, footY)
  ctx.lineTo(x - H * 0.16, footY)
  ctx.closePath()
  ctx.fill()
  // 胴
  ctx.fillStyle = '#e4ddd0'
  ctx.beginPath()
  ctx.moveTo(x - H * 0.07, shoulderY)
  ctx.lineTo(x + H * 0.07, shoulderY)
  ctx.lineTo(x + H * 0.055, hipY)
  ctx.lineTo(x - H * 0.055, hipY)
  ctx.closePath()
  ctx.fill()
  // 頭 + ティアラ (撃破前)
  const headY = topY + bodyH * 0.08
  ctx.fillStyle = '#efe9dd'
  ctx.beginPath()
  ctx.arc(x, headY, H * 0.065, 0, Math.PI * 2)
  ctx.fill()
  if (!defeated || e < 0.4) {
    ctx.strokeStyle = '#d8c878'
    ctx.lineWidth = 2
    ctx.beginPath()
    ctx.arc(x, headY - H * 0.045, H * 0.05, Math.PI * 1.1, Math.PI * 1.9)
    ctx.stroke()
  }
  // 目元: 静かな2点 (telegraph 終盤は赤く)
  ctx.fillStyle = lateCue ? '#ff8aa8' : '#8a93b4'
  ctx.beginPath()
  ctx.arc(x + dir * 3, headY + 1, 1.6, 0, Math.PI * 2)
  ctx.fill()

  // ===== 細剣 (君の写し) =====
  const bladeL = H * 0.6
  let gripX = x + dir * H * 0.1
  let gripY = shoulderY + 6
  let angle = -0.45
  let flash = false
  const isStage = atkId === 'lightsFall' || atkId === 'curtainSweep' || atkId === 'bellToll'

  if (atkId === 'mirrorSlash' && inAttack) {
    if (b.state === 'telegraph') { angle = -Math.PI * 0.6 - cp * 0.25; flash = lateCue }
    else { angle = 0.35; gripX = x + dir * H * 0.16; flash = true }
  } else if (atkId === 'mirrorThrust' && inAttack) {
    if (b.state === 'telegraph') { angle = 0; gripX = x - dir * (4 + cp * 20); gripY = shoulderY + 12; flash = lateCue }
    else { angle = 0; gripX = x + dir * H * 0.22; gripY = shoulderY + 12; flash = true }
  } else if ((atkId === 'mirrorWaltz' || atkId === 'princessExecution') && inAttack) {
    if (b.state === 'telegraph') { angle = -Math.PI * 0.5 - cp * 0.2; flash = lateCue }
    else {
      const hitAngles = [0.1, -0.35]
      angle = hitAngles[Math.min(b.comboHitIndex, 1)]!
      gripX = x + dir * H * 0.15
      flash = true
    }
  } else if (isStage && inAttack) {
    // 舞台に命じる: 剣を持たない側の腕を高く掲げる (剣は下段へ)
    angle = 0.9
    ctx.strokeStyle = '#d8d2c4'
    ctx.lineWidth = 4
    ctx.beginPath()
    ctx.moveTo(x - dir * 3, shoulderY + 4)
    ctx.lineTo(x - dir * H * 0.06, shoulderY - H * (0.16 + cp * 0.1))
    ctx.stroke()
    // 掲げた手の先に光 (lightsFall=金 / curtain=紫 / bell=白)
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = (0.3 + cp * 0.6) * alpha
    ctx.fillStyle = atkId === 'lightsFall' ? '#ffe9a8' : atkId === 'curtainSweep' ? '#b9a3d9' : '#e8e4f0'
    ctx.beginPath()
    ctx.arc(x - dir * H * 0.06, shoulderY - H * (0.16 + cp * 0.1) - 6, 5 + cp * 4, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
  } else if (b.state === 'staggered') {
    angle = 1.2
    gripY += 10
  } else if (defeated) {
    angle = 1.3
    gripY = footY - 24
  }

  const dxA = Math.cos(angle) * dir
  const dyA = Math.sin(angle)
  ctx.strokeStyle = flash ? '#fff4f0' : '#d8dbe8'
  ctx.lineWidth = 2.5
  ctx.beginPath()
  ctx.moveTo(gripX, gripY)
  ctx.lineTo(gripX + dxA * bladeL, gripY + dyA * bladeL)
  ctx.stroke()
  // 腕
  ctx.strokeStyle = '#d8d2c4'
  ctx.lineWidth = 4
  ctx.beginPath()
  ctx.moveTo(x + dir * 3, shoulderY + 4)
  ctx.lineTo(gripX, gripY)
  ctx.stroke()

  // 体幹崩し中の合図
  if (b.state === 'staggered') {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = alpha * (0.22 + 0.12 * Math.sin(t * 18))
    ctx.fillStyle = PALETTE.fxGold
    ctx.beginPath()
    ctx.ellipse(x, footY - bodyH * 0.5, H * 0.22, bodyH * 0.52, 0, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.restore()
}

// --- hollow-actor の前の版 (総集編・姿を借りる・開発版 &twins=old) ---
// 部屋 (=演目) ごとに過去ボスの描画関数へ委譲する: 第1幕=王 / 第2幕=花嫁 / 第3幕=騎士 /
//   終幕=混演 (現在の攻撃の sourceBossId の姿。 待機中は素のマネキン)。
//   常に「借り物」マーカー (頭上の白いマスク + 灰の靄) を重ねて正体を示す。
//   素体マネキン/浮遊マスク/撃破は本番スプライト (E-7)。 custom 描画なので標準スプライト系を
//   通さず個別ロードし、 未ロード時は手続き drawHollowShell へフォールバックする。
const hollowImgCache: Record<string, HTMLImageElement> = {}
function hollowImg(name: 'idle' | 'mask' | 'defeat'): HTMLImageElement | null {
  if (typeof Image === 'undefined') return null
  let img = hollowImgCache[name]
  if (!img) { img = new Image(); img.src = `/sprites/bosses/hollow-actor/${name}.png`; hollowImgCache[name] = img }
  return img.complete && img.naturalWidth > 0 ? img : null
}
function hollowDrawFoot(ctx: CanvasRenderingContext2D, img: HTMLImageElement, cx: number, footY: number, h: number): void {
  const w = h * (img.naturalWidth / img.naturalHeight)
  ctx.drawImage(img, cx - w / 2, footY - h, w, h)
}
function hollowDrawCentered(ctx: CanvasRenderingContext2D, img: HTMLImageElement, cx: number, cy: number, h: number): void {
  const w = h * (img.naturalWidth / img.naturalHeight)
  ctx.drawImage(img, cx - w / 2, cy - h / 2, w, h)
}
const HOLLOW_SHELL_H = 220    // 素体スプライト(マスク込み)の表示高 → マネキン本体≈150。 実機で微調整
const HOLLOW_DEFEAT_H = 120
const HOLLOW_MASK_H = 46

// E-7-B: 前の版が借りる衣装を「本物のボススプライト」で着る (4衣装とも本番スプライト化済)。
//   各ボスの等身 (BOSS_HEIGHT_RATIO) で描き、 未ロード時のみ手続き描画へフォールバック。
const HOLLOW_COSTUME_BOSS: Record<'hound' | 'bride' | 'knight' | 'dancer', string> = {
  hound: 'dream-hound', bride: 'bride', knight: 'vigil-knight', dancer: 'blade-dancer',
}
function drawCostumeSprite(ctx: CanvasRenderingContext2D, state: GameState, costume: 'hound' | 'bride' | 'knight' | 'dancer'): void {
  const b = state.boss
  const id = HOLLOW_COSTUME_BOSS[costume]
  if (bossSpriteReady(id)) {
    const h = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
    drawBossSprite(ctx, id, b, state.bossSprite, b.x, b.y, h, state.time)
  } else if (costume === 'hound') drawHound(ctx, state)
  else if (costume === 'bride') drawBride(ctx, state)
  else if (costume === 'knight') drawKnight(ctx, state)
  else drawDancer(ctx, state)
}

function drawHollowActor(ctx: CanvasRenderingContext2D, state: GameState): void {
  // 千日手の軍配者たち (二人と装置)。
  if (twinsFightOn(state.boss) && drawTwinsFight(ctx, state)) return
  const b = state.boss
  const t = state.time
  // 3枚を先読み (素体/撃破は終盤・死亡で初めて要るので、 戦闘開始から温めて初回フラッシュを防ぐ)
  void hollowImg('idle'); void hollowImg('mask'); void hollowImg('defeat')
  // E-7-B: 借りる4衣装のスプライトも温める (本物の姿で着るため)
  preloadBossSprites('dream-hound'); preloadBossSprites('bride')
  preloadBossSprites('vigil-knight'); preloadBossSprites('blade-dancer')

  if (b.hp <= 0) {
    const di = hollowImg('defeat')
    if (di) hollowDrawFoot(ctx, di, b.x, b.y, HOLLOW_DEFEAT_H)   // 本番: 脱げた衣装の山+転がるマスク
    else drawHollowShell(ctx, state, 1)
    return
  }

  // 演目 → 借りる姿
  const act = Math.min(3, b.executesTaken)
  let costume: 'hound' | 'bride' | 'knight' | 'dancer' | 'none' = 'none'
  if (act === 0) costume = 'hound'
  else if (act === 1) costume = 'bride'
  else if (act === 2) costume = 'knight'
  else {
    const src = b.currentAttack?.sourceBossId
    costume = src === 'dream-hound' ? 'hound'
      : src === 'bride' ? 'bride'
      : src === 'vigil-knight' ? 'knight'
      : src === 'blade-dancer' ? 'dancer'
      : 'none'
  }

  // 灰の靄 (借り物の輪郭が揺らぐ)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  for (let i = 0; i < 5; i += 1) {
    const ph = (t * 0.4 + i * 0.2) % 1
    ctx.globalAlpha = 0.12 * (1 - ph)
    ctx.fillStyle = '#9a96aa'
    ctx.beginPath()
    ctx.ellipse(b.x + Math.sin(i * 9.17 + t * 1.3) * 40, b.y - 20 - ph * 110, 14, 7, 0, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.restore()

  // 素体スプライト (マスク込み)。 衣装中は各ボスの手続き描画を流用 (B=花嫁の後に本番スプライト化予定)。
  const bareShell = costume === 'none' ? hollowImg('idle') : null
  if (costume !== 'none') drawCostumeSprite(ctx, state, costume)   // E-7-B: 借り衣装は本物のスプライト
  else if (bareShell) hollowDrawFoot(ctx, bareShell, b.x, b.y, HOLLOW_SHELL_H)
  else drawHollowShell(ctx, state, 0)

  // 借り物マーカー: 頭上に浮かぶ無地の白マスク (これだけが役者本人)。
  //   ※素体スプライトはマスクを内包するので、 そのときは重ねない。
  if (!bareShell) {
    const my = b.y - 195 + Math.sin(t * 1.8) * 6
    const mk = hollowImg('mask')
    if (mk) {
      ctx.save(); ctx.globalAlpha = 0.9
      hollowDrawCentered(ctx, mk, b.x, my, HOLLOW_MASK_H)
      ctx.restore()
    } else {
      ctx.save()
      ctx.globalAlpha = 0.85
      ctx.fillStyle = '#e8e2d8'
      ctx.beginPath(); ctx.ellipse(b.x, my, 9, 12, 0, 0, Math.PI * 2); ctx.fill()
      ctx.fillStyle = '#1a1626'
      ctx.beginPath()  // 目も口もない。 ただの楕円のくぼみ2つ
      ctx.ellipse(b.x - 3.5, my - 2, 1.6, 2.4, 0, 0, Math.PI * 2)
      ctx.ellipse(b.x + 3.5, my - 2, 1.6, 2.4, 0, 0, Math.PI * 2)
      ctx.fill()
      ctx.restore()
    }
  }
}

// 素のマネキン (終幕の待機 / 撃破)。 defeated=1 で衣装が脱げ落ちた山 + 転がるマスク。
function drawHollowShell(ctx: CanvasRenderingContext2D, state: GameState, defeated: 0 | 1): void {
  const b = state.boss
  const t = state.time
  const x = b.x
  const footY = b.y
  const H = 150

  ctx.save()
  if (defeated) {
    // phase≠playing では updateBossSpriteRuntime が止まり defeatElapsedSec が凍結する
    // (騎士の縦長シルエット残留 2026-06-24 と同型)。 victory 等では「沈み切った山+転がり終えたマスク」
    // = アニメ完了値に倒す (0 に倒すと山が立ち上がって見えるため終端側へ)。
    const e = state.phase === 'playing' ? state.bossSprite.defeatElapsedSec : 1.2
    const sink = Math.min(1, e / 1.0)
    // 脱げ落ちた衣装の山 (どの役の色でもない灰)
    ctx.fillStyle = '#4a4458'
    ctx.beginPath()
    ctx.ellipse(x, footY - 10 * (1 - sink) - 8, H * 0.22, 16 + 6 * sink, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.fillStyle = '#5a5468'
    ctx.beginPath()
    ctx.ellipse(x - 14, footY - 6, H * 0.1, 9, 0.4, 0, Math.PI * 2)
    ctx.fill()
    // マスクが転がって、 こちらを向いて止まる
    const mf = Math.min(1, Math.max(0, (e - 0.3) / 0.8))
    ctx.translate(x + 30 + mf * 26, footY - 8 - Math.sin(mf * Math.PI) * 30)
    ctx.rotate(mf * 3.0)
    ctx.fillStyle = '#e8e2d8'
    ctx.beginPath()
    ctx.ellipse(0, 0, 9, 12, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.fillStyle = '#1a1626'
    ctx.beginPath()
    ctx.ellipse(-3.5, -2, 1.6, 2.4, 0, 0, Math.PI * 2)
    ctx.ellipse(3.5, -2, 1.6, 2.4, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
    return
  }

  // 待機マネキン: 灰一色の人型 (顔なし・特徴なし)
  const breath = Math.sin(t * 1.4) * 2.5
  const topY = footY - H + breath
  ctx.fillStyle = '#6a6478'
  ctx.beginPath()
  ctx.moveTo(x - H * 0.1, footY)
  ctx.quadraticCurveTo(x - H * 0.12, topY + H * 0.3, x, topY + H * 0.12)
  ctx.quadraticCurveTo(x + H * 0.12, topY + H * 0.3, x + H * 0.1, footY)
  ctx.closePath()
  ctx.fill()
  ctx.fillStyle = '#7a7488'
  ctx.beginPath()
  ctx.arc(x, topY + H * 0.07, H * 0.07, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()
}

// --- 剣舞の役者 (仮ビジュアル・手続きシルエット) ---
// 細身の踊り手 + 細剣。 リズムボスなので「拍」を見せる:
//   円舞連斬/終舞 (連撃) = 高い構えから、 ヒットごとに剣閃の角度が変わる
//   旋回突き = 回転の残像円 → まっすぐ伸びる刺突
//   裾払い = 低く沈み裾が床に広がる
//   撃破 = 最後に深いお辞儀をして、 そのまま膝から崩れる
function drawDancer(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const t = state.time
  const H = 150
  const x = b.x
  const footY = b.y
  const dir = b.facing === 'right' ? 1 : -1
  const cp = telegraphProgress(b)
  const atkId = b.currentAttack?.id ?? ''
  const inAttack = b.state === 'telegraph' || b.state === 'active' || b.state === 'comboGap' || b.state === 'beatGap'
  const lateCue = b.state === 'telegraph' && cp >= 0.7
  const defeated = b.hp <= 0
  const sink = defeated ? Math.min(1, state.bossSprite.defeatElapsedSec / 1.2) : 0
  const bowEase = 1 - (1 - sink) * (1 - sink)

  // つま先立ちの上下 (踊りの呼吸・3拍子)
  const lilt = defeated ? 0 : Math.abs(Math.sin(t * 3.6)) * 4
  const stagSink = b.state === 'staggered' ? 14 : 0
  const bodyH = H * (1 - 0.34 * bowEase)
  const topY = footY - bodyH - lilt + stagSink
  const shoulderY = topY + bodyH * 0.22
  const hipY = footY - bodyH * 0.46

  // 裾払い/旋回中の低い沈み
  const low = (atkId === 'hemSweep' && inAttack) ? bodyH * 0.16 : 0

  ctx.save()

  // 長いスカート裾 (流れる三角・裾払い時は床いっぱいに開く)
  const hemSpread = (atkId === 'hemSweep' && inAttack)
    ? H * (0.3 + (b.state === 'active' ? 0.45 : cp * 0.3))
    : H * 0.2
  ctx.fillStyle = '#5e3a52'
  ctx.beginPath()
  ctx.moveTo(x - 6, hipY + low)
  ctx.lineTo(x + 6, hipY + low)
  ctx.quadraticCurveTo(x + hemSpread * 0.9, footY - 8, x + hemSpread + Math.sin(t * 2.8) * 5, footY)
  ctx.lineTo(x - hemSpread - Math.sin(t * 2.2) * 5, footY)
  ctx.closePath()
  ctx.fill()

  // 脚 (つま先立ち)
  ctx.strokeStyle = '#cab6c4'
  ctx.lineCap = 'round'
  ctx.lineWidth = 4
  ctx.beginPath()
  ctx.moveTo(x - 4, hipY + low); ctx.lineTo(x - 6, footY - 3); ctx.lineTo(x - 4, footY)
  ctx.moveTo(x + 4, hipY + low); ctx.lineTo(x + 7, footY - 3); ctx.lineTo(x + 9, footY)
  ctx.stroke()

  // 胴 (細く、 背筋の伸びた踊り手。 撃破時は深いお辞儀へ折れる)
  const bowLean = bowEase * H * 0.22
  ctx.fillStyle = '#7e4a66'
  ctx.beginPath()
  ctx.moveTo(x - H * 0.06, shoulderY + low)
  ctx.lineTo(x + H * 0.06 + dir * bowLean * 0.4, shoulderY + low + bowLean * 0.3)
  ctx.lineTo(x + H * 0.05, hipY + low)
  ctx.lineTo(x - H * 0.05, hipY + low)
  ctx.closePath()
  ctx.fill()

  // 頭 (小さく、 リボンが流れる)
  const headX = x + dir * bowLean
  const headY = shoulderY + low - H * 0.07 + bowLean * 0.5
  ctx.fillStyle = '#e0d4ce'
  ctx.beginPath()
  ctx.arc(headX, headY, H * 0.06, 0, Math.PI * 2)
  ctx.fill()
  // 髪リボン (動きの軌跡)
  ctx.strokeStyle = '#c4607a'
  ctx.lineWidth = 3
  ctx.beginPath()
  ctx.moveTo(headX - dir * 4, headY - 4)
  ctx.quadraticCurveTo(
    headX - dir * (20 + Math.sin(t * 3.1) * 8), headY - 14 - Math.cos(t * 2.7) * 6,
    headX - dir * (34 + Math.sin(t * 2.3) * 10), headY - 4 - Math.sin(t * 3.4) * 10)
  ctx.stroke()

  // ===== 細剣 =====
  const bladeL = H * 0.62
  let gripX = x + dir * H * 0.1
  let gripY = shoulderY + low + 6
  let angle = -0.5   // 常态: 斜め上に軽く構える
  let flash = false

  const isFlurry = (atkId === 'waltzFlurry' || atkId === 'crescendo') && inAttack
  if (isFlurry) {
    // 連撃: 高い構え → ヒット番号で剣閃の角度が変わる (拍を見せる)
    if (b.state === 'telegraph') {
      angle = -Math.PI * 0.55 - cp * 0.2
      gripY -= cp * 8
      flash = lateCue
    } else {
      const hitAngles = [-0.15, 0.45, -0.4, 0.6, 0.1]
      angle = hitAngles[Math.min(b.comboHitIndex, hitAngles.length - 1)]!
      flash = b.state === 'active'
      gripX = x + dir * H * 0.16
    }
  } else if (atkId === 'pirouette' && inAttack) {
    if (b.state === 'telegraph') {
      // 回転の残像円
      ctx.save()
      ctx.globalCompositeOperation = 'lighter'
      ctx.globalAlpha = 0.2 + cp * 0.4
      ctx.strokeStyle = lateCue ? '#ff8aa8' : '#d8b9c9'
      ctx.lineWidth = 2
      ctx.beginPath()
      ctx.ellipse(x, shoulderY + low + 8, H * 0.24, H * 0.07, 0, 0, Math.PI * 2)
      ctx.stroke()
      ctx.restore()
      angle = Math.PI * (cp * 2)      // ぐるぐる回って見える
      flash = lateCue
    } else {
      angle = 0                        // まっすぐ伸びる刺突
      gripX = x + dir * H * 0.2
      flash = true
    }
  } else if (atkId === 'hemSweep' && inAttack) {
    angle = 0.9                        // 低く下段へ
    gripY = hipY
  } else if (atkId === 'dancerExecution' && inAttack) {
    angle = b.state === 'telegraph' ? -Math.PI * 0.6 : 0.05
    gripX = x + dir * H * 0.18
    flash = b.state === 'active'
  } else if (b.state === 'staggered') {
    angle = 1.2                        // 剣先が床へ落ちる
    gripY += 12
  } else if (defeated) {
    angle = 1.35                       // お辞儀: 剣は床へ
    gripX = x + dir * H * 0.06
    gripY = footY - 20
  }

  const dxA = Math.cos(angle) * dir
  const dyA = Math.sin(angle)
  ctx.strokeStyle = flash ? '#fff0f4' : '#d8dbe8'
  ctx.lineWidth = 2.5
  ctx.beginPath()
  ctx.moveTo(gripX, gripY)
  ctx.lineTo(gripX + dxA * bladeL, gripY + dyA * bladeL)
  ctx.stroke()
  // 腕
  ctx.strokeStyle = '#cab6c4'
  ctx.lineWidth = 4
  ctx.beginPath()
  ctx.moveTo(x + dir * 4, shoulderY + low + 5)
  ctx.lineTo(gripX, gripY)
  ctx.stroke()
  // 連撃 active 中: 剣閃の残像 (1拍前の角度を薄く残す)
  if (isFlurry && b.state === 'active' && b.comboHitIndex > 0) {
    const hitAngles = [-0.15, 0.45, -0.4, 0.6, 0.1]
    const prev = hitAngles[Math.min(b.comboHitIndex - 1, hitAngles.length - 1)]!
    ctx.globalAlpha = 0.3
    ctx.strokeStyle = '#d8b9c9'
    ctx.lineWidth = 2
    ctx.beginPath()
    ctx.moveTo(gripX, gripY)
    ctx.lineTo(gripX + Math.cos(prev) * dir * bladeL, gripY + Math.sin(prev) * bladeL)
    ctx.stroke()
    ctx.globalAlpha = 1
  }

  // 体幹崩し中の合図
  if (b.state === 'staggered') {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = 0.22 + 0.12 * Math.sin(t * 18)
    ctx.fillStyle = PALETTE.fxGold
    ctx.beginPath()
    ctx.ellipse(x, footY - bodyH * 0.5, H * 0.24, bodyH * 0.52, 0, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.restore()
}

// --- 処刑人 (仮ビジュアル・手続きシルエット) ---
// 巨体 + フード + 大斧。 主題「同じ構え・違う溜め」のため、 断頭2種 (A/B) は意図的に
//   完全に同じポーズで描く (溜めの長さだけが違う)。 読み分けは時間で行わせる。
//   断頭 = 斧を頭上に掲げる / 胴薙ぎ = 斧を腰だめに引く / 掴み = 空いた手を前へ
function drawExecutioner(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const t = state.time
  const H = 185                       // 騎士(155)より大きい威圧
  const x = b.x
  const footY = b.y
  const dir = b.facing === 'right' ? 1 : -1
  const cp = telegraphProgress(b)
  const inAttack = b.state === 'telegraph' || b.state === 'active' || b.state === 'comboGap' || b.state === 'beatGap'
  const lateCue = b.state === 'telegraph' && cp >= 0.7

  // 撃破でも消えない (頽れて残る)。 暗色ボディは下げすぎると背景に溶けるため 0.8 止まり。
  let alpha = 1
  if (b.hp <= 0) alpha = Math.max(0.8, 1 - state.bossSprite.defeatElapsedSec * 0.2)
  const breath = Math.sin(t * 0.9) * 2.5      // 重く遅い呼吸
  const stagSink = b.state === 'staggered' ? 20 : 0
  const sink = b.hp <= 0 ? Math.min(1, state.bossSprite.defeatElapsedSec / 1.1) : 0
  const bodyH = H * (1 - 0.3 * sink)          // 撃破: 崩れ落ちて座り込む
  const topY = footY - bodyH + breath + stagSink
  const shoulderY = topY + bodyH * 0.22
  const hipY = footY - bodyH * 0.36

  ctx.save()
  ctx.globalAlpha = alpha

  // 体: 前屈みの巨躯 (フードから背中へかけた暗布のかたまり)
  ctx.fillStyle = '#2a2433'
  ctx.beginPath()
  ctx.moveTo(x - H * 0.2, footY)
  ctx.quadraticCurveTo(x - H * 0.24, hipY, x - H * 0.16, shoulderY + 4)
  ctx.quadraticCurveTo(x - H * 0.04, topY - 6, x + dir * H * 0.1, topY + 4)   // 前屈みの首
  ctx.quadraticCurveTo(x + H * 0.2, shoulderY + 10, x + H * 0.18, hipY)
  ctx.lineTo(x + H * 0.16, footY)
  ctx.closePath()
  ctx.fill()
  // 胸の褪せた刺繍帯 (元は式典の正装だった痕跡)
  ctx.globalAlpha = alpha * 0.45
  ctx.fillStyle = '#6e5a8e'
  ctx.fillRect(x - H * 0.1, shoulderY + 8, H * 0.2, 6)
  ctx.globalAlpha = alpha

  // フードの奥: 暗闇だけ。 telegraph 終盤に赤くにじむ
  const hoodX = x + dir * H * 0.08
  const hoodY = topY + bodyH * 0.07
  ctx.fillStyle = '#0a0810'
  ctx.beginPath()
  ctx.ellipse(hoodX, hoodY, H * 0.075, H * 0.06, 0, 0, Math.PI * 2)
  ctx.fill()
  if (inAttack && lateCue) {
    ctx.globalAlpha = alpha * 0.85
    ctx.fillStyle = '#ff8aa8'
    ctx.beginPath()
    ctx.arc(hoodX + dir * 4, hoodY, 2.6, 0, Math.PI * 2)
    ctx.fill()
    ctx.globalAlpha = alpha
  }

  // ===== 大斧 =====
  // grip 位置と角度で構えを描き分ける。 angle 0=前方水平 / -PI/2=頭上
  const shaftL = H * 0.95
  let gripX = x + dir * H * 0.14
  let gripY = hipY - 6
  let angle = -Math.PI * 0.12          // 常态: 刃を床へ引きずる (重さの表現)
  let edgeFlash = false

  if (b.state === 'staggered') {
    angle = Math.PI * 0.3               // 斧が手から落ちかける
    gripY += 14
  } else if (b.hp <= 0) {
    angle = Math.PI * 0.46              // 撃破: 斧は床へ落ちた
    gripX = x + dir * H * 0.1
    gripY = footY - 16
  }

  // 柄
  const dxA = Math.cos(angle) * dir
  const dyA = Math.sin(angle)
  const buttX = gripX - dxA * shaftL * 0.25
  const buttY = gripY - dyA * shaftL * 0.25
  const headX = gripX + dxA * shaftL * 0.75
  const headY2 = gripY + dyA * shaftL * 0.75
  ctx.strokeStyle = '#5a4f44'
  ctx.lineWidth = 6
  ctx.lineCap = 'round'
  ctx.beginPath()
  ctx.moveTo(buttX, buttY)
  ctx.lineTo(headX, headY2)
  ctx.stroke()
  // 刃 (大きな半月)
  ctx.save()
  ctx.translate(headX, headY2)
  ctx.rotate(Math.atan2(dyA, dxA))
  ctx.fillStyle = edgeFlash ? '#f3ead0' : '#aab0bd'
  ctx.beginPath()
  ctx.moveTo(-6, 0)
  ctx.quadraticCurveTo(26, -34 * dir, 44, -6 * dir)
  ctx.quadraticCurveTo(26, -10 * dir, -6, 14 * dir)
  ctx.closePath()
  ctx.fill()
  ctx.restore()
  // 両腕 (柄へ)
  ctx.strokeStyle = '#4a4258'
  ctx.lineWidth = 9
  ctx.beginPath()
  ctx.moveTo(x + dir * H * 0.04, shoulderY + 8)
  ctx.lineTo(gripX, gripY)
  ctx.moveTo(x - dir * H * 0.02, shoulderY + 14)
  ctx.lineTo(gripX - dxA * 18, gripY - dyA * 18)
  ctx.stroke()

  // 体幹崩し中の合図
  if (b.state === 'staggered') {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = alpha * (0.22 + 0.12 * Math.sin(t * 18))
    ctx.fillStyle = PALETTE.fxGold
    ctx.beginPath()
    ctx.ellipse(x, footY - bodyH * 0.5, H * 0.3, bodyH * 0.52, 0, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.restore()
}

// ボス開幕タイトルカード (ブラッシュアップ 2026-06-11)。 戦闘開始 ~3.4 秒、 画面上部に
//   ボス名 (明朝・大) + 英題 + 細い罫線をフェードで見せる。 死にゲーの「対戦相手の名乗り」。
//   導入戦 (名も無き亡霊) は静かに始めたいので出さない。 再演 (リトライ) のたびに出るのは
//   「何度でも幕が上がる」演出として正。
const bossTitleShown = import.meta.env.DEV && typeof window !== 'undefined'
  && new URLSearchParams(window.location.search).get('bossTitle') === 'on'

function drawBossIntroCard(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (state.phase !== 'playing' || !bossIntroCardShown(state.boss.id)) return
  // カードの時計 = 「名乗りの間 (戦闘停止中)」+「戦闘開始後の経過」。
  //   停止中は state.time が進まず bossIntroMs が進み、 解除後は bossIntroMs が止まって
  //   state.time が進む → 和は必ず連続して進む (2026-07-19: 停止導入に伴う変更)。
  const T = state.bossIntroMs / 1000 + state.time
  if (T > 3.4) return
  const a = T < 0.5 ? T / 0.5 : T > 2.6 ? Math.max(0, 1 - (T - 2.6) / 0.8) : 1
  if (a <= 0.01) return
  const def = getBossDefinitionById(state.boss.id)
  const cx = ARENA.width / 2
  const y = ARENA.height * 0.17
  ctx.save()
  ctx.textAlign = 'center'
  // 名前 (大・明朝)
  ctx.font = `600 34px ${UI_SERIF}`
  ctx.strokeStyle = `rgba(8,6,16,${a * 0.85})`
  ctx.lineWidth = 6
  ctx.strokeText(state.boss.displayName || def?.name || '', cx, y)
  ctx.fillStyle = `rgba(232,224,240,${a * 0.95})`
  ctx.fillText(state.boss.displayName || def?.name || '', cx, y)
  // 罫線 (中央から左右へ伸びる)
  const lw = 150 * Math.min(1, T / 0.9)
  ctx.strokeStyle = `rgba(216,200,120,${a * 0.7})`
  ctx.lineWidth = 1
  ctx.beginPath()
  ctx.moveTo(cx - lw, y + 12); ctx.lineTo(cx + lw, y + 12)
  ctx.stroke()
  // 英題 (小・イタリック)
  if (bossTitleShown && def?.title) {
    ctx.font = `italic 13px ${uiSans()}`
    ctx.fillStyle = `rgba(190,178,210,${a * 0.85})`
    ctx.fillText(def.title, cx, y + 30)
  }
  ctx.restore()
}

// 稽古モードの掲示 (tutorialLessons を持つボス限定・HUDレイヤ)。
// 「死にゲーは自分で気づく」を壊さないため、 本編ボスでは一切出さない。
//   稽古: 「稽古 n/6 ― 技名」+ やること + 成功カウント (●●○)。
//   仕上げ: 斬って追い詰める→崩れ落ちたら致命の一撃を促す (2026-07-05 リワーク・spec §2.5)。
// 稽古掲示を隠すべきか (2026-07-24: 致命後に文字が重なる実機FBの修正・票=terminology-parry-guard-copy)。
//   playing 以外 / 致命演出中(finisher) / 致命の自動3連撃中(player.state==='executing') は非表示。
export function tutorialPromptsHidden(state: GameState): boolean {
  return state.phase !== 'playing' || !!state.finisher || state.player.state === 'executing'
}

function drawTutorialPrompts(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (tutorialPromptsHidden(state)) return
  // 止めて照らしている間 (比較版 DEV ?tutFocus・src/tut_focus.ts) は上の掲示を消す (止めの一言と重ねない・見る所を1つにする)。
  if (state.tutorial?.focus) return
  const tut = state.tutorial
  // 比較版 (DEV ?tutFocus) の時だけ課題の並びが替わる (src/tut_focus.ts)。指定なしは bosses.ts の表のまま。
  const lessons = tutorialLessonsFor(getBossDefinitionById(state.boss.id))
  if (!tut || !lessons) return
  const cx = ARENA.width / 2

  ctx.save()
  ctx.textAlign = 'center'

  // 稽古の6点の比較版 ① (DEV ?tut6): 抜けた直後の一拍は、抜けた課題を印が埋まった姿で見せる。
  const cleared = tut.cleared && state.time - tut.cleared.at < (tutVoiceLook() ? VOICE_CLEAR_SHOW_SEC : TUT_SIX.clearShowSec) ? tut.cleared : null
  const shown = cleared ? cleared.lesson : tut.lesson
  const inFinale = shown >= lessons.length
  const b = state.boss
  let header: string
  let goal: string
  let total: number = TUTORIAL.successesPerLesson
  if (inFinale) {
    header = '仕上げ'
    goal = b.state === 'staggered'
      ? '崩れ落ちた亡霊へ近づき、攻撃で「致命の一撃」を'
      : '斬って追い詰め、パリィで体幹を崩せ'
  } else {
    const lesson = lessons[shown]!
    const atk = getAttack(lesson.attackId)
    header = `稽古 ${shown + 1} / ${lessons.length} ― ${lesson.label ?? atk.label}`
    total = lesson.count ?? TUTORIAL.successesPerLesson
    // 掲示文言は goal 明示 (game.ts updateTutorial と同じ分岐)。 一字も変えない確定値=spec §2.5
    //   (2026-07-24: 旧パッド表記が事実と食い違ったための正誤同期・文の構造は不変=トークン化のみ)。
    if (lesson.goal === 'parry') {
      goal = '{parry} でパリィ'
    } else if (lesson.goal === 'just_parry') {
      goal = '当たる直前にパリィ ― 白い火花が散れば成功'
    } else if (lesson.goal === 'guard') {
      goal = '{parry} を長押しして、斬撃をガードで受け止めろ'
    } else if (lesson.goal === 'exec_parry') {
      goal = '{parry} を長押しして受け続けろ ― 崩れたら、紫に光る一撃を {parry} で弾け'
    } else if (lesson.goal === 'zone_evade') {
      goal = '波の外へ歩いて逃げ切れ'
    } else if (lesson.goal === 'combo3') {
      // 配布版の稽古に入る課題 (DEV ?combo3rd=off の時だけ入らない・src/tut_focus.ts SHADE_COMBO3_LESSONS)。
      goal = '{attack} を続けて押し、3段目まで当てろ'
    } else {
      goal = tutSix(2) ? TUT_SIX.counterGoal : '赤黒いオーラの攻撃はパリィできない ― {step} で回避して、直後に攻撃で回避カウンター'
    }
    goal = resolveInputText(goal, inputDeviceView())
  }

  // ボスの攻撃中は点滅で緊張感、 それ以外は静かに常時表示
  const inAttack = b.state === 'telegraph' || b.state === 'active' || b.state === 'comboGap' || b.state === 'beatGap'
  // 声が語る比較版 (DEV ?tutVoice・src/tut_voice.ts)。text は文だけ声に替えて今の掲示で描く。a〜d は掲示ごと src/tut_voice_view.ts が描く。
  const voice = tutVoiceLook()
  if (voice) {
    const key = inFinale ? (b.state === 'staggered' ? 'finale_staggered' : 'finale') : voiceGoalKey(lessons[shown]!.goal)
    goal = resolveInputText((cleared && VOICE_CLEAR[key]) || VOICE_GOAL[key]!, inputDeviceView())
    if (voice !== 'text') {
      const lesson = inFinale ? null : lessons[shown]!
      const label = lesson ? (lesson.label ?? getAttack(lesson.attackId).label) : null
      ctx.restore()
      drawVoiceBanner(ctx, { look: voice, header: voiceHeader(shown + 1, lessons.length, label), text: goal, total,
        filled: cleared ? total : tut.successes, showCount: !inFinale, age: voiceBannerAge(goal, state.time), inAttack: inAttack && !inFinale, time: state.time })
      return
    }
  }
  const blink = inAttack && !inFinale ? 0.7 + 0.3 * Math.sin(state.time * 8) : 0.95
  ctx.strokeStyle = 'rgba(10,6,18,0.8)'
  ctx.lineWidth = 4
  ctx.font = `600 17px ${uiSans()}`
  ctx.fillStyle = `rgba(196,176,236,${blink * 0.95})`
  ctx.strokeText(header, cx, 96)
  ctx.fillText(header, cx, 96)
  ctx.font = `600 19px ${uiSans()}`
  ctx.fillStyle = `rgba(232,216,255,${blink})`
  ctx.strokeText(goal, cx, 122)
  ctx.fillText(goal, cx, 122)

  // 成功カウント (●●○) ― 仕上げ中は出さない
  if (!inFinale) {
    const r = 5
    const gap = 22
    const x0 = cx - ((total - 1) * gap) / 2
    for (let i = 0; i < total; i += 1) {
      ctx.beginPath()
      ctx.arc(x0 + i * gap, 142, r, 0, Math.PI * 2)
      if (cleared || i < tut.successes) {
        ctx.fillStyle = PALETTE.fxGold
        ctx.fill()
      } else {
        ctx.strokeStyle = 'rgba(200,186,228,0.6)'
        ctx.lineWidth = 1.5
        ctx.stroke()
      }
    }
  }
  ctx.restore()
}

// ===== 稽古の「止めて、照らして、教える」(比較版 DEV ?tutFocus=1|2|3・src/tut_focus.ts・2026-10-11) =====
// 時間が止まっている間だけ描く。画面を暗くし、見てほしい所だけを柔らかい穴で明るく残す。
//   何を照らすか・一言・押すボタン・札の置き場所・線を引く先 = src/tut_focus.ts FOCUS_STEPS (データ)。ここは見た目だけ。
//   止める・抜けるの判断は game.ts と src/tut_focus.ts。指定なしでは state.tutorial.focus が立たない = 何も描かない。
// 見た目 = 10-11 ユーザーの答え tut-focus-ui「A」(真鍮の札と額・見本 そざい/concept/tut-focus-ui-1011/tut_focus_ui_A_plate_v1.png):
//   一言 = 横長の黒い鉄＋退色した真鍮の額の札 (地は墨・文字は象牙の明朝・左右端と上下中央に茨の尖った飾り)。
//   ボタン = 真鍮縁の横長の刻印板に浮き彫りの文字・右に象牙の小さな明朝 (「いま」)。
//   照らし = 細い真鍮の輪・上下左右4か所に茨の尖った飾り・輪の内は明るく外は暗い。印から照らしへ真鍮の細い線1本 (点線にしない・途中に小さな菱形)。
//   色は 退色した真鍮・くすんだ金・黒い鉄・象牙・墨 だけ (赤・青・紫は使わない)。真鍮は幕の印 (drawActMarkDot) の受け座と同じ値。
//   全部を手続きで描く (画像の部品は使っていない・茨の飾りは4つの尖りの星 + 根元の小さな巻き)。
type FocusHole = { x: number; y: number; rx: number; ry: number; shape?: 'rect'; tone?: 'frost' }
let focusDimCanvas: HTMLCanvasElement | null = null

const FOCUS_BRASS = {
  hi: (a: number) => `rgba(255,236,190,${a.toFixed(3)})`,     // 上から光の当たった縁
  main: (a: number) => `rgba(206,176,116,${a.toFixed(3)})`,   // 退色した真鍮 (幕の印の受け座・点いた側)
  dull: (a: number) => `rgba(138,120,86,${a.toFixed(3)})`,    // くすんだ真鍮 (幕の印の受け座・消えた側)
  deep: (a: number) => `rgba(92,72,44,${a.toFixed(3)})`,      // 真鍮の陰
  iron: (a: number) => `rgba(26,18,10,${a.toFixed(3)})`,      // 黒い鉄
  ink: (a: number) => `rgba(16,13,12,${a.toFixed(3)})`,       // 墨の地
  ivory: (a: number) => `rgba(240,230,208,${a.toFixed(3)})`,  // 象牙の文字
}
const FOCUS_FONT = UI_SERIF

/** 照らす所 (画面座標)。FOCUS_STEPS の targets を順に位置へ直す。純関数 (テスト・撮影の位置合わせ用に外へ出す)。 */
export function tutorialFocusHoles(state: GameState, id: TutorialFocusStepId, camX: number): FocusHole[] {
  return FOCUS_STEPS[id].targets.map((t) => keepHoleOnScreen(focusTargetHole(state, t, camX)))
}

/** 世界の中の照らし (体・手・床) を、画面の寄せ (camZoom) と縮め (far) を掛けた後の画面座標へ。
 *  照らしは寄せの後に描くので、掛けないと体から外れた所を囲う (10-31 作者「何を指しているのか全くわからない」)。 */
function worldFocusHole(h: FocusHole): FocusHole {
  const z = camZoomView().z * farNow
  return { ...h, x: camZoomX(farX(h.x)), y: camZoomY(farY(h.y)), rx: h.rx * z, ry: h.ry * z }
}

/** 体を囲う丸い輪が画面の左右で切れないよう、中心を内へ寄せる (10-28 初見の試遊「輪が左端で切れる」)。四角の枠はそのまま。 */
function keepHoleOnScreen(h: FocusHole): FocusHole {
  if (h.shape === 'rect') return h
  const m = 14
  const x = Math.min(Math.max(h.x, h.rx + m), ARENA.width - h.rx - m)
  return x === h.x ? h : { ...h, x }
}

function focusTargetHole(state: GameState, t: FocusTargetId, camX: number): FocusHole {
  const p = state.player, b = state.boss
  switch (t) {
    // 左上の命の灯 (drawLifeLamps: x32 y24・5灯) と体幹のゲージ (drawPlayerHud: x32 y66 幅120 高さ8)。
    case 'hud_self': return { x: 92, y: 48, rx: 78, ry: 38, shape: 'rect' }
    case 'hud_self_posture': return { x: 32 + 60, y: 70, rx: 100, ry: 30 }
    // 下のボスの名札・体幹・体力 (boss_hud_view.ts silverHudLayout: 紋章の上端 ≈ 446・体幹 y505・体力 y526)。
    //   横幅は体幹の溝の半分 (今 220) + 余白。DEV の横幅の比較版 (?bossHud=wide60 等) でも帯を囲う。
    case 'hud_boss': return { x: ARENA.width / 2, y: 497, rx: silverHudLayout(ARENA.width).posture.w / 2 + 24, ry: 46, shape: 'rect' }
    case 'hud_boss_posture': return { x: ARENA.width / 2, y: 512, rx: silverHudLayout(ARENA.width).posture.w / 2 + 18, ry: 17, shape: 'rect' }
    // 体幹の溝だけ (3段目の課題・10-28)。溝の外にちょうど 6px 余らせる。冷たい銀の輪 (帯の金と分ける) で、茨は左右だけ (上下は名札と体力の帯に重なる)。
    case 'hud_boss_posture_bar': {
      const P = silverHudLayout(ARENA.width).posture
      return { x: P.x + P.w / 2, y: P.y + P.h / 2, rx: P.w / 2 + 6, ry: P.h / 2 + 6, shape: 'rect', tone: 'frost' }
    }
    // 名前の横の幕の玉 (稽古の最後の致命・?tutActs=old 以外)。位置は drawActMarks が毎コマ残す (actMarksAt)。
    case 'hud_boss_acts': {
      const A = actMarksAt.ok ? actMarksAt : { x: ARENA.width / 2 + 60, y: 486, w: 10 }
      return { x: A.x + A.w / 2, y: A.y - 6, rx: A.w / 2 + 12, ry: 13, shape: 'rect' }
    }
    case 'boss_body': return worldFocusHole({ x: b.x - camX, y: bossFootY(b) - auraBaseHeight(b) * 0.5, rx: 104, ry: 118 })
    case 'player_body': return worldFocusHole({ x: p.x - camX, y: p.y - PLAYER_DISPLAY_HEIGHT * 0.5, rx: 78, ry: 92 })
    case 'player_hand': {
      const grip = playerBladePoints(state).grip
      return worldFocusHole({ x: grip.x - camX, y: grip.y, rx: 58, ry: 58 })
    }
    case 'floor_hazard': {
      const lesson = currentLesson(state.tutorial, tutorialLessonsFor(getBossDefinitionById(b.id)))
      const hz = state.hits.find((h) => h.attackId === lesson?.attackId && h.follow === undefined)
      if (!hz) return worldFocusHole({ x: p.x - camX, y: p.y - 16, rx: 90, ry: 30, shape: 'rect' })
      return worldFocusHole({ x: (hz.xStart + hz.xEnd) / 2 - camX, y: p.y - 16, rx: (hz.xEnd - hz.xStart) / 2 + 10, ry: 30, shape: 'rect' })
    }
  }
}

/** 茨の尖った飾り: 4つの尖り (縦長) の星と、根元の小さな巻き。(x,y) が中心。angle = 0 で縦の尖りが上下。 */
function drawFocusThorn(ctx: CanvasRenderingContext2D, x: number, y: number, size: number, alpha: number, angle = 0, long = 1): void {
  ctx.save()
  ctx.translate(x, y)
  ctx.rotate(angle)
  const L = size * long, W = size * 0.62, n = size * 0.16
  const star = () => {
    ctx.beginPath()
    ctx.moveTo(0, -L)
    ctx.quadraticCurveTo(n, -n, W, 0)
    ctx.quadraticCurveTo(n, n, 0, L * 0.82)
    ctx.quadraticCurveTo(-n, n, -W, 0)
    ctx.quadraticCurveTo(-n, -n, 0, -L)
    ctx.closePath()
  }
  // 黒い鉄の縁取り → 真鍮の面 (上が明るい)。
  ctx.lineJoin = 'miter'
  star()
  ctx.strokeStyle = FOCUS_BRASS.iron(0.9 * alpha)
  ctx.lineWidth = 2.2
  ctx.stroke()
  const g = ctx.createLinearGradient(0, -L, 0, L)
  g.addColorStop(0, FOCUS_BRASS.hi(alpha))
  g.addColorStop(0.45, FOCUS_BRASS.main(alpha))
  g.addColorStop(1, FOCUS_BRASS.deep(alpha))
  ctx.fillStyle = g
  star(); ctx.fill()
  // 根元の小さな巻き (左右対称)。
  ctx.strokeStyle = FOCUS_BRASS.main(0.85 * alpha)
  ctx.lineWidth = 0.9
  for (const s of [-1, 1]) {
    ctx.beginPath()
    ctx.arc(s * size * 0.36, -size * 0.3, size * 0.2, Math.PI * (s > 0 ? 0.6 : 0.4), Math.PI * (s > 0 ? 1.7 : -0.7), s < 0)
    ctx.stroke()
    ctx.beginPath()
    ctx.arc(s * size * 0.36, size * 0.3, size * 0.2, Math.PI * (s > 0 ? -0.6 : 1.6), Math.PI * (s > 0 ? 0.3 : 0.7), s > 0)
    ctx.stroke()
  }
  // 芯の菱形 (墨) と真鍮の点。
  ctx.fillStyle = FOCUS_BRASS.iron(0.95 * alpha)
  ctx.beginPath(); ctx.moveTo(0, -n * 1.4); ctx.lineTo(n, 0); ctx.lineTo(0, n * 1.4); ctx.lineTo(-n, 0); ctx.closePath(); ctx.fill()
  ctx.fillStyle = FOCUS_BRASS.hi(alpha)
  ctx.beginPath(); ctx.arc(0, 0, Math.max(0.8, n * 0.4), 0, Math.PI * 2); ctx.fill()
  ctx.restore()
}

/** 照らしの輪 (細い真鍮・上下左右に茨)。 */
function drawFocusRing(ctx: CanvasRenderingContext2D, h: FocusHole, alpha: number, pulse: number): void {
  if (h.tone === 'frost') { drawFocusFrostRing(ctx, h, alpha, pulse); return }
  const sc = 0.9 + 0.015 * pulse
  const rx = h.rx * sc, ry = h.ry * sc
  const path = () => {
    ctx.beginPath()
    if (h.shape === 'rect') ctx.roundRect(h.x - rx, h.y - ry, rx * 2, ry * 2, 6)
    else ctx.ellipse(h.x, h.y, rx, ry, 0, 0, Math.PI * 2)
  }
  ctx.save()
  path(); ctx.strokeStyle = FOCUS_BRASS.iron(0.85 * alpha); ctx.lineWidth = 3.4; ctx.stroke()
  path(); ctx.strokeStyle = FOCUS_BRASS.main((0.82 + 0.12 * pulse) * alpha); ctx.lineWidth = 1.5; ctx.stroke()
  // 上縁だけ明るく (光は上から)。
  if (h.shape !== 'rect') {
    ctx.beginPath(); ctx.ellipse(h.x, h.y, rx, ry, 0, Math.PI * 1.15, Math.PI * 1.85)
    ctx.strokeStyle = FOCUS_BRASS.hi(0.55 * alpha); ctx.lineWidth = 0.8; ctx.stroke()
  }
  const size = Math.max(7, Math.min(12, Math.min(rx, ry) * 0.16))
  drawFocusThorn(ctx, h.x, h.y - ry, size, alpha)
  drawFocusThorn(ctx, h.x, h.y + ry, size, alpha)
  drawFocusThorn(ctx, h.x - rx, h.y, size, alpha, Math.PI / 2)
  drawFocusThorn(ctx, h.x + rx, h.y, size, alpha, Math.PI / 2)
  ctx.restore()
}

/** 冷たい銀の輪 (体幹の溝をぴったり囲う・縮めない)。帯の金と色を分け、帯の霜 (boss_hud_view.ts drawPostureFrost) と揃える。 */
const FOCUS_FROST = {
  hi: (a: number) => `rgba(236,246,255,${a.toFixed(3)})`,
  main: (a: number) => `rgba(170,214,250,${a.toFixed(3)})`,
  glow: (a: number) => `rgba(120,190,255,${a.toFixed(3)})`,
}
function drawFocusFrostRing(ctx: CanvasRenderingContext2D, h: FocusHole, alpha: number, pulse: number): void {
  const x = h.x - h.rx, y = h.y - h.ry, w = h.rx * 2, hh = h.ry * 2
  const path = () => { ctx.beginPath(); ctx.roundRect(x, y, w, hh, 4) }
  ctx.save()
  path(); ctx.strokeStyle = FOCUS_BRASS.iron(0.9 * alpha); ctx.lineWidth = 4; ctx.stroke()
  ctx.shadowColor = FOCUS_FROST.glow((0.7 + 0.3 * pulse) * alpha); ctx.shadowBlur = 20
  path(); ctx.strokeStyle = FOCUS_FROST.main((0.85 + 0.15 * pulse) * alpha); ctx.lineWidth = 2; ctx.stroke()
  ctx.shadowBlur = 0
  ctx.beginPath(); ctx.moveTo(x + 4, y + 0.5); ctx.lineTo(x + w - 4, y + 0.5)
  ctx.strokeStyle = FOCUS_FROST.hi(0.8 * alpha); ctx.lineWidth = 0.8; ctx.stroke()
  // 左右の端に氷の楔 (外向き)。帯の先端の印を留め金から替えた比較版 (DEV ?postureHoldTip=・10-31) では描かない (作者「矢印が突くのダサい」)。
  if (postureHoldTip() === 'clasp') {
    ctx.fillStyle = FOCUS_FROST.hi(0.95 * alpha)
    ctx.shadowColor = FOCUS_FROST.glow(alpha); ctx.shadowBlur = 16
    for (const sx of [-1, 1] as const) {
      const ex = sx < 0 ? x : x + w
      ctx.beginPath(); ctx.moveTo(ex, h.y - 6); ctx.lineTo(ex + sx * 12, h.y); ctx.lineTo(ex, h.y + 6); ctx.closePath(); ctx.fill()
    }
  }
  ctx.restore()
}

/** 一言の札: 黒い鉄と退色した真鍮の額・墨の地・象牙の明朝。(x,y) = 札の左上。 */
function drawFocusPlate(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, text: string, fontPx: number, alpha: number): void {
  ctx.save()
  ctx.globalAlpha = alpha
  // 影 (札を画面から浮かせる)。
  ctx.fillStyle = 'rgba(0,0,0,0.5)'
  ctx.fillRect(x + 2, y + 4, w, h)
  // 黒い鉄の外枠。
  ctx.fillStyle = FOCUS_BRASS.iron(1)
  ctx.fillRect(x, y, w, h)
  // 墨の地 (上がわずかに明るい)。
  const g = ctx.createLinearGradient(0, y, 0, y + h)
  g.addColorStop(0, 'rgba(34,29,26,1)')
  g.addColorStop(0.5, FOCUS_BRASS.ink(1))
  g.addColorStop(1, 'rgba(10,8,8,1)')
  ctx.fillStyle = g
  ctx.fillRect(x + 6, y + 6, w - 12, h - 12)
  // 地の斑 (古い漆の擦れ・決まった並び)。
  ctx.fillStyle = 'rgba(70,60,52,0.12)'
  for (let i = 0; i < 9; i += 1) {
    const fx = x + 10 + ((i * 97) % Math.max(1, w - 30)), fy = y + 9 + ((i * 53) % Math.max(1, h - 20))
    ctx.beginPath(); ctx.ellipse(fx, fy, 9 + (i % 3) * 5, 3 + (i % 2) * 2, 0.3 * (i % 4), 0, Math.PI * 2); ctx.fill()
  }
  // 真鍮の二重罫 (外の太い線・内の細い線)。
  ctx.strokeStyle = FOCUS_BRASS.main(1); ctx.lineWidth = 1.6
  ctx.strokeRect(x + 2.5, y + 2.5, w - 5, h - 5)
  ctx.strokeStyle = FOCUS_BRASS.dull(0.95); ctx.lineWidth = 0.9
  ctx.strokeRect(x + 6.5, y + 6.5, w - 13, h - 13)
  // 上縁の照り。
  ctx.strokeStyle = FOCUS_BRASS.hi(0.7); ctx.lineWidth = 0.8
  ctx.beginPath(); ctx.moveTo(x + 4, y + 1.6); ctx.lineTo(x + w - 4, y + 1.6); ctx.stroke()
  // 四隅の細い茨の巻き。
  ctx.strokeStyle = FOCUS_BRASS.main(0.75); ctx.lineWidth = 0.9
  for (const [cx, cy, sx, sy] of [[x + 7, y + 7, 1, 1], [x + w - 7, y + 7, -1, 1], [x + 7, y + h - 7, 1, -1], [x + w - 7, y + h - 7, -1, -1]] as const) {
    ctx.beginPath()
    ctx.moveTo(cx, cy + sy * 12)
    ctx.quadraticCurveTo(cx + sx * 2, cy + sy * 2, cx + sx * 12, cy)
    ctx.moveTo(cx + sx * 3, cy + sy * 8)
    ctx.quadraticCurveTo(cx + sx * 8, cy + sy * 8, cx + sx * 8, cy + sy * 3)
    ctx.stroke()
  }
  ctx.restore()
  // 左右端 (外へ尖る) と上下の中央の茨。
  const midY = y + h / 2
  drawFocusThorn(ctx, x - 2, midY, 10, alpha, Math.PI / 2, 1.9)
  drawFocusThorn(ctx, x + w + 2, midY, 10, alpha, Math.PI / 2, 1.9)
  drawFocusThorn(ctx, x + w / 2, y - 1, 9, alpha)
  drawFocusThorn(ctx, x + w / 2, y + h + 1, 9, alpha)
  // 象牙の明朝。
  ctx.save()
  ctx.globalAlpha = alpha
  ctx.font = `600 ${fontPx}px ${FOCUS_FONT}`
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = 'rgba(0,0,0,0.7)'
  ctx.fillText(text, x + w / 2 + 1, midY + 2)
  ctx.fillStyle = FOCUS_BRASS.ivory(1)
  ctx.fillText(text, x + w / 2, midY + 1)
  ctx.restore()
}

/** ボタンの刻印板: 真鍮の面に浮き彫りの文字・左右に小さな茨。(x,y) = 板の左上。 */
function drawFocusKeyPlate(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, label: string, alpha: number, scale: number): void {
  ctx.save()
  ctx.translate(x + w / 2, y + h / 2)
  ctx.scale(scale, scale)
  ctx.translate(-w / 2, -h / 2)
  ctx.globalAlpha = alpha
  const bevel = 5
  const plate = (inset: number) => {
    const b = Math.max(1, bevel - inset * 0.5)
    ctx.beginPath()
    ctx.moveTo(inset + b, inset); ctx.lineTo(w - inset - b, inset); ctx.lineTo(w - inset, inset + b)
    ctx.lineTo(w - inset, h - inset - b); ctx.lineTo(w - inset - b, h - inset); ctx.lineTo(inset + b, h - inset)
    ctx.lineTo(inset, h - inset - b); ctx.lineTo(inset, inset + b); ctx.closePath()
  }
  ctx.fillStyle = 'rgba(0,0,0,0.5)'
  ctx.save(); ctx.translate(1.5, 3); plate(0); ctx.fill(); ctx.restore()
  plate(0); ctx.fillStyle = FOCUS_BRASS.iron(1); ctx.fill()
  // 真鍮の面 (くすんだ金・上が明るい)。
  const g = ctx.createLinearGradient(0, 0, 0, h)
  g.addColorStop(0, 'rgba(214,190,140,1)')
  g.addColorStop(0.5, 'rgba(176,150,104,1)')
  g.addColorStop(1, 'rgba(120,98,64,1)')
  plate(2.5); ctx.fillStyle = g; ctx.fill()
  // 内の細い罫と面の擦れ。
  plate(4.5); ctx.strokeStyle = FOCUS_BRASS.deep(0.8); ctx.lineWidth = 0.8; ctx.stroke()
  plate(2.5); ctx.strokeStyle = FOCUS_BRASS.hi(0.75); ctx.lineWidth = 0.8; ctx.stroke()
  ctx.fillStyle = 'rgba(90,72,46,0.18)'
  for (let i = 0; i < 5; i += 1) {
    ctx.beginPath(); ctx.ellipse(8 + ((i * 37) % Math.max(1, w - 16)), 7 + ((i * 11) % Math.max(1, h - 12)), 6, 2, 0.4, 0, Math.PI * 2); ctx.fill()
  }
  // 浮き彫りの文字 (下に明るい照り・上に暗い字)。
  ctx.font = `700 ${Math.round(h * 0.6)}px ${FOCUS_FONT}`
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = 'rgba(255,240,206,0.55)'
  ctx.fillText(label, w / 2, h / 2 + 2)
  ctx.fillStyle = 'rgba(30,22,14,1)'
  ctx.fillText(label, w / 2, h / 2 + 1)
  ctx.restore()
  drawFocusThorn(ctx, x - 1, y + h / 2, 6, alpha, Math.PI / 2, 1.7)
  drawFocusThorn(ctx, x + w + 1, y + h / 2, 6, alpha, Math.PI / 2, 1.7)
}

/** 照らしの縁の上で、点 (sx,sy) の方を向いた所。 */
function focusHoleEdgeToward(h: FocusHole, sx: number, sy: number): { x: number; y: number } {
  const sc = 0.9
  if (h.shape === 'rect') {
    const ex = Math.max(h.x - h.rx * sc, Math.min(h.x + h.rx * sc, sx))
    return { x: ex, y: sy < h.y ? h.y - h.ry * sc : h.y + h.ry * sc }
  }
  const a = Math.atan2((sy - h.y) / h.ry, (sx - h.x) / h.rx)
  return { x: h.x + Math.cos(a) * h.rx * sc, y: h.y + Math.sin(a) * h.ry * sc }
}

/** 印から照らしへ、真鍮の細い線1本 (少し弧を描く・途中に小さな菱形)。 */
function drawFocusLeader(ctx: CanvasRenderingContext2D, sx: number, sy: number, ex: number, ey: number, alpha: number): void {
  const mx = (sx + ex) / 2, my = (sy + ey) / 2
  const dx = ex - sx, dy = ey - sy
  const len = Math.max(1, Math.hypot(dx, dy))
  const bend = Math.min(40, len * 0.18) * (dx >= 0 ? 1 : -1)
  const cx = mx - (dy / len) * bend, cy = my + (dx / len) * bend
  ctx.save()
  ctx.globalAlpha = alpha
  ctx.lineCap = 'round'
  const curve = () => { ctx.beginPath(); ctx.moveTo(sx, sy); ctx.quadraticCurveTo(cx, cy, ex, ey) }
  curve(); ctx.strokeStyle = FOCUS_BRASS.iron(0.8); ctx.lineWidth = 2.6; ctx.stroke()
  curve(); ctx.strokeStyle = FOCUS_BRASS.main(0.95); ctx.lineWidth = 1.1; ctx.stroke()
  // 途中の菱形 (曲線の真ん中・向きは線に沿う)。
  const t = 0.5
  const px = (1 - t) * (1 - t) * sx + 2 * (1 - t) * t * cx + t * t * ex
  const py = (1 - t) * (1 - t) * sy + 2 * (1 - t) * t * cy + t * t * ey
  const ang = Math.atan2(ey - sy, ex - sx)
  ctx.translate(px, py); ctx.rotate(ang)
  ctx.beginPath(); ctx.moveTo(-6, 0); ctx.lineTo(0, -3.6); ctx.lineTo(6, 0); ctx.lineTo(0, 3.6); ctx.closePath()
  ctx.fillStyle = FOCUS_BRASS.iron(1); ctx.fill()
  ctx.strokeStyle = FOCUS_BRASS.main(1); ctx.lineWidth = 1; ctx.stroke()
  ctx.fillStyle = FOCUS_BRASS.hi(1)
  ctx.beginPath(); ctx.arc(0, 0, 1, 0, Math.PI * 2); ctx.fill()
  ctx.restore()
}

/** 暗幕に柔らかい穴を開ける (別の器で塗ってから重ねる)。楕円は放射の濃淡、四角は少しずつ広げた角丸を重ねて縁をぼかす。 */
function drawFocusDim(ctx: CanvasRenderingContext2D, holes: FocusHole[], ease: number): void {
  if (typeof document === 'undefined') return
  const src = ctx.canvas
  if (!focusDimCanvas) focusDimCanvas = document.createElement('canvas')
  if (focusDimCanvas.width !== src.width || focusDimCanvas.height !== src.height) {
    focusDimCanvas.width = src.width; focusDimCanvas.height = src.height
  }
  const d = focusDimCanvas.getContext('2d')
  if (!d) return
  d.setTransform(1, 0, 0, 1, 0, 0)
  d.globalCompositeOperation = 'source-over'
  d.clearRect(0, 0, focusDimCanvas.width, focusDimCanvas.height)
  d.setTransform(ctx.getTransform())
  d.fillStyle = `rgba(4, 3, 6, ${(0.74 * ease).toFixed(3)})`
  d.fillRect(0, 0, ARENA.width, ARENA.height)
  d.globalCompositeOperation = 'destination-out'
  // 穴は開きながら少し縮む (外から絞って寄せる)。
  const open = 1.35 - 0.35 * ease
  for (const h of holes) {
    if (h.shape === 'rect') {
      const steps = 7
      for (let i = 0; i < steps; i += 1) {
        const grow = (steps - 1 - i) * 3
        d.fillStyle = 'rgba(0,0,0,0.32)'
        d.beginPath()
        d.roundRect(h.x - h.rx * open - grow, h.y - h.ry * open - grow, (h.rx * open + grow) * 2, (h.ry * open + grow) * 2, 8 + grow)
        d.fill()
      }
      continue
    }
    d.save()
    d.translate(h.x, h.y)
    d.scale(1, h.ry / h.rx)
    const r = h.rx * open
    const g = d.createRadialGradient(0, 0, r * 0.55, 0, 0, r)
    g.addColorStop(0, 'rgba(0,0,0,1)')
    g.addColorStop(1, 'rgba(0,0,0,0)')
    d.fillStyle = g
    d.beginPath(); d.arc(0, 0, r, 0, Math.PI * 2); d.fill()
    d.restore()
  }
  ctx.save()
  ctx.setTransform(1, 0, 0, 1, 0, 0)
  ctx.drawImage(focusDimCanvas, 0, 0)
  ctx.restore()
}

/** 札と印の置き場所 (札の中心 x・上端 y・印の左端の決め方)。 */
function focusTextLayout(pos: FocusTextPos, plateW: number, plateH: number, rowW: number): { px: number; py: number; bx: number; by: number } {
  // 左上: 体幹のゲージの照らし (下端 ≈ y100) と札の上の茨が重ならない高さ。
  if (pos === 'top_left') return { px: 26, py: 110, bx: 34, by: 110 + plateH + 12 }
  const cx = ARENA.width / 2
  const py = pos === 'above_boss_hud' ? 352 : 96
  return { px: cx - plateW / 2, py, bx: cx - rowW / 2, by: py + plateH + 12 }
}

function drawTutorialFocus(ctx: CanvasRenderingContext2D, state: GameState): void {
  const demo = import.meta.env.DEV && DEV_COLLAPSE_FOCUS?.active && state.boss.id === 'nameless-shade'
    ? DEV_COLLAPSE_FOCUS : null
  const focus = state.tutorial?.focus
  if ((!focus && !demo) || state.phase !== 'playing' || state.paused) return
  const spec = demo ? demo.spec : FOCUS_STEPS[focus!.id]
  const ms = demo ? demo.ms : focus!.ms
  const k = Math.min(1, ms / TUT_FOCUS.fadeMs)
  const ease = 1 - (1 - k) * (1 - k)
  const holes = demo ? spec.targets.map((t) => focusTargetHole(state, t, cameraX)) : tutorialFocusHoles(state, focus!.id, cameraX)
  const ready = Math.min(1, ms / spec.minShowMs)
  const pulse = 0.5 + 0.5 * Math.sin((ms / 1000) * Math.PI * 2 * 1.2)

  // 声が語る比較版 (DEV ?tutVoice・src/tut_voice.ts): 一言を声の台本に替える。a〜d は輪・札・印・線を src/tut_voice_view.ts が描く (霜の輪と暗幕は今のまま)。
  const voice = demo ? null : tutVoiceLook()
  const line = voice ? VOICE_FOCUS[focus!.id].line : spec.line

  // 1) 暗幕と照らしの穴。2) 細い真鍮の輪。
  drawFocusDim(ctx, holes, ease)
  for (const h of holes) if (!voice || voice === 'text' || h.tone === 'frost') drawFocusRing(ctx, h, ease, pulse)

  // 3) 一言の札・押すボタンの印・印から照らしへの線。
  const view = inputDeviceView()
  const badge = resolveInputText(spec.badge, view)
  let hint = (voice && VOICE_FOCUS[focus!.id].hint) || spec.hint || ''
  if (!demo && focus?.id === 'zone_walk' && focus.dirs?.length === 1) hint = focus.dirs[0]! < 0 ? 'で 左の外へ' : 'で 右の外へ'
  if (voice && voice !== 'text') {
    drawVoiceFocus(ctx, { look: voice, line, badge, hint, ms, ease, ready, pulse, holes, textPos: spec.textPos, leaderTo: spec.leaderTo, edgeToward: focusHoleEdgeToward })
    return
  }
  const fontPx = 22
  ctx.save()
  ctx.font = `600 ${fontPx}px ${FOCUS_FONT}`
  const plateW = Math.ceil(ctx.measureText(line).width) + 76
  const plateH = 44
  const keyH = 28
  ctx.font = `700 ${Math.round(keyH * 0.6)}px ${FOCUS_FONT}`
  const keyW = Math.ceil(ctx.measureText(badge).width) + 30
  ctx.font = `500 17px ${FOCUS_FONT}`
  const hintW = hint ? Math.ceil(ctx.measureText(hint).width) + 12 : 0
  ctx.restore()
  const L = focusTextLayout(spec.textPos, plateW, plateH, keyW + hintW)
  drawFocusPlate(ctx, L.px, L.py, plateW, plateH, line, fontPx, ease)

  // ボタンの印: 押せるようになると濃くなり、少し脈打つ。
  const keyAlpha = ease * (0.45 + 0.55 * ready)
  drawFocusKeyPlate(ctx, L.bx, L.by, keyW, keyH, badge, keyAlpha, 1 + (ready >= 1 ? 0.05 * pulse : 0))
  if (hint) {
    ctx.save()
    ctx.globalAlpha = keyAlpha
    ctx.font = `500 17px ${FOCUS_FONT}`
    ctx.textAlign = 'left'
    ctx.textBaseline = 'middle'
    ctx.fillStyle = 'rgba(0,0,0,0.7)'
    ctx.fillText(hint, L.bx + keyW + 13, L.by + keyH / 2 + 2)
    ctx.fillStyle = FOCUS_BRASS.ivory(1)
    ctx.fillText(hint, L.bx + keyW + 12, L.by + keyH / 2 + 1)
    ctx.restore()
  }
  const target = spec.leaderTo !== undefined ? holes[spec.leaderTo] : undefined
  if (target) {
    const sx = L.bx + keyW / 2, sy = L.by + keyH + 3
    const e = focusHoleEdgeToward(target, sx, sy)
    drawFocusLeader(ctx, sx, sy, e.x, e.y, ease * 0.9)
  }
}

// --- 待宵の花嫁 (仮ビジュアル・手続きシルエット) ---
// 白いドレスの釣鐘シルエット + ヴェール。 攻撃ごとに別の絵に見えることを最優先 (spec §3):
//   弾き (veilSweep)      = ヴェールを翼のように左右全開
//   見切り (veilInvitation) = 片腕とヴェールを前方へ差し伸べる
//   躱し (vowEmbrace)      = 両腕を大きく開いて閉じる
//   位置取り (thornAisle)   = 深く身を屈め床に手を添える
//   致命 (brideExecution)   = 高く立ち上がり覆いかぶさる
function drawBride(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const t = state.time
  const dir = b.facing === 'right' ? 1 : -1   // 前方向
  const H = 165                                // 表示高さ (主人公120の約1.38倍)
  const cp = b.state === 'telegraph' ? telegraphProgress(b) : 0
  const phase = attackPhase(b)                 // 0..1=telegraph, 1..2=active
  const atkId = b.currentAttack?.id ?? ''
  const lateCue = b.state === 'telegraph' && cp >= 0.7

  // 撃破フェード / 宵渡りの消失・再出現 / 気絶の沈み / 呼吸
  let alpha = 1
  if (b.hp <= 0) alpha = Math.max(0, 1 - state.bossSprite.defeatElapsedSec / 0.9)
  if (b.state === 'blink') {
    // 渦になって解けていく: フェードアウト + 花弁が散る
    const prog = Math.min(1, (b.stateElapsed * 1000) / 420)
    alpha *= Math.max(0, 1 - prog * 1.25)
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    for (let i = 0; i < 10; i += 1) {
      const a = i * 2.4 + t * 3.2
      const r = 20 + prog * 90 + (i % 3) * 8
      ctx.globalAlpha = (1 - prog) * 0.5
      ctx.fillStyle = '#e8ddf5'
      ctx.beginPath()
      ctx.arc(b.x + Math.cos(a) * r, b.y - 80 + Math.sin(a) * r * 0.6, 2.6, 0, Math.PI * 2)
      ctx.fill()
    }
    ctx.restore()
  } else if (b.state === 'reappear') {
    // 結び直る: フェードイン + 白い閃光リング (再出現を必ず見せる・spec §4)
    const prog = Math.min(1, (b.stateElapsed * 1000) / 470)
    alpha *= Math.min(1, prog * 2)
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = Math.max(0, 0.7 - prog * 0.7)
    ctx.strokeStyle = '#f2ecfd'
    ctx.lineWidth = 3
    ctx.beginPath()
    ctx.arc(b.x, b.y - 80, 30 + prog * 80, 0, Math.PI * 2)
    ctx.stroke()
    ctx.restore()
  }
  if (alpha <= 0.01) return
  const breath = Math.sin(t * 1.3) * 2.2
  const stagSink = b.state === 'staggered' ? 14 + Math.sin(t * 9) * 1.5 : 0
  // 攻撃ポーズの寄与
  const isExec = atkId === 'brideExecution'
  const bow = atkId === 'thornAisle' ? cp * 26 : 0                       // 屈み
  const riseUp = isExec ? cp * 22 : 0                                    // 致命の立ち上がり
  const lungeLean = b.state === 'active' && isExec ? 10 : 0

  const x = b.x
  const footY = b.y
  const headR = H * 0.085
  const topY = footY - H + breath + stagSink + bow - riseUp              // 頭頂
  const headY = topY + headR
  const shoulderY = topY + H * 0.2
  const waistY = topY + H * 0.42
  const dressHalf = H * 0.21                                             // 裾の半幅

  ctx.save()
  ctx.globalAlpha = alpha

  // 影
  ctx.fillStyle = 'rgba(8,5,14,0.5)'
  ctx.beginPath()
  ctx.ellipse(x, footY + 4, H * 0.26, 8, 0, 0, Math.PI * 2)
  ctx.fill()

  const DRESS = '#e9e5f0'
  const DRESS_SHADE = '#cfc8de'
  const OUTLINE = '#b9aed2'
  const DARK = '#39294a'

  // ドレス (釣鐘): 腰→裾へ広がる
  ctx.beginPath()
  ctx.moveTo(x - H * 0.07, waistY)
  ctx.bezierCurveTo(x - dressHalf * 0.85, waistY + H * 0.22, x - dressHalf, footY - 6, x - dressHalf, footY)
  ctx.lineTo(x + dressHalf, footY)
  ctx.bezierCurveTo(x + dressHalf, footY - 6, x + dressHalf * 0.85, waistY + H * 0.22, x + H * 0.07, waistY)
  ctx.closePath()
  ctx.fillStyle = DRESS
  ctx.fill()
  ctx.strokeStyle = OUTLINE
  ctx.lineWidth = 2
  ctx.stroke()
  // 裾の陰
  ctx.fillStyle = DRESS_SHADE
  ctx.beginPath()
  ctx.moveTo(x - dressHalf * 0.6, footY)
  ctx.quadraticCurveTo(x, footY - H * 0.16, x + dressHalf * 0.6, footY)
  ctx.closePath()
  ctx.fill()

  // 上体 (細い) + 頭
  ctx.fillStyle = DRESS
  ctx.beginPath()
  ctx.moveTo(x - H * 0.055, shoulderY)
  ctx.lineTo(x + H * 0.055, shoulderY)
  ctx.lineTo(x + H * 0.07, waistY)
  ctx.lineTo(x - H * 0.07, waistY)
  ctx.closePath()
  ctx.fill()
  ctx.stroke()
  ctx.beginPath()
  ctx.arc(x, headY, headR, 0, Math.PI * 2)
  ctx.fill()
  ctx.stroke()
  // ヴェール越しの顔の暗がり (微笑みは見せない)
  ctx.fillStyle = DARK
  ctx.globalAlpha = alpha * 0.35
  ctx.beginPath()
  ctx.arc(x + dir * headR * 0.25, headY + headR * 0.15, headR * 0.62, 0, Math.PI * 2)
  ctx.fill()
  ctx.globalAlpha = alpha

  // 腕 (攻撃ごとのポーズ)
  ctx.strokeStyle = DRESS
  ctx.lineWidth = 5
  ctx.lineCap = 'round'
  const armY = shoulderY + H * 0.04
  if (atkId === 'veilInvitation' && (b.state === 'telegraph' || b.state === 'active')) {
    // 招き手: 前方へ差し伸べる (溜めで伸び、 招くように上下)
    const reach = H * (0.2 + 0.34 * Math.min(1, phase)) * dir
    const wave = Math.sin(t * 7) * 5 * cp
    ctx.beginPath()
    ctx.moveTo(x, armY)
    ctx.quadraticCurveTo(x + reach * 0.5, armY - 12, x + reach, armY - 4 + wave)
    ctx.stroke()
  } else if ((atkId === 'vowEmbrace' || isExec) && (b.state === 'telegraph' || b.state === 'active')) {
    // 抱擁: 両腕を開く (溜め) → 閉じる (active)
    const open = b.state === 'telegraph' ? 0.4 + cp * 0.6 : Math.max(0.15, 1 - (phase - 1) * 1.6)
    const spread = H * 0.3 * open
    ctx.beginPath()
    ctx.moveTo(x, armY)
    ctx.quadraticCurveTo(x + dir * spread * 0.7, armY - spread * 0.5, x + dir * spread + lungeLean * dir, armY - spread * 0.15)
    ctx.moveTo(x, armY)
    ctx.quadraticCurveTo(x + dir * spread * 0.5, armY + spread * 0.45, x + dir * spread * 0.9 + lungeLean * dir, armY + spread * 0.3)
    ctx.stroke()
  } else if (atkId === 'thornAisle' && (b.state === 'telegraph' || b.state === 'active')) {
    // 種蒔き: 床へ手を添える
    ctx.beginPath()
    ctx.moveTo(x, armY)
    ctx.quadraticCurveTo(x + dir * H * 0.16, waistY + H * 0.1, x + dir * H * 0.2, footY - 8)
    ctx.stroke()
  } else {
    // 待機: 胸の前で枯れたブーケを抱く
    ctx.beginPath()
    ctx.moveTo(x - H * 0.05, armY)
    ctx.quadraticCurveTo(x, armY + H * 0.07, x + H * 0.05, armY)
    ctx.stroke()
    ctx.fillStyle = '#5a4a66'
    ctx.beginPath()
    ctx.arc(x + dir * 3, armY + H * 0.055, 7, 0, Math.PI * 2)
    ctx.fill()
    ctx.fillStyle = '#caa3b8'
    for (let i = 0; i < 3; i += 1) {
      ctx.beginPath()
      ctx.arc(x + dir * 3 + Math.cos(i * 2.1) * 6, armY + H * 0.055 + Math.sin(i * 2.1) * 5, 2.4, 0, Math.PI * 2)
      ctx.fill()
    }
  }

  // ヴェール: 頭から床近くまで流れる半透明の布。
  //   veilSweep の溜め/active では左右へ翼状に全開 = 「斬撃が来る」シルエット
  const isSweep = atkId === 'veilSweep' && (b.state === 'telegraph' || b.state === 'active')
  ctx.globalAlpha = alpha * 0.45
  ctx.fillStyle = '#f2eefb'
  if (isSweep) {
    const wing = H * (0.22 + 0.5 * (b.state === 'active' ? 1 : cp))
    const flap = Math.sin(t * 10) * 4 * cp
    for (const side of [-1, 1]) {
      ctx.beginPath()
      ctx.moveTo(x, headY - headR * 0.4)
      ctx.quadraticCurveTo(x + side * wing * 0.7, shoulderY - H * 0.06 + flap, x + side * wing, waistY - H * 0.02)
      ctx.quadraticCurveTo(x + side * wing * 0.55, waistY + H * 0.08, x, waistY + H * 0.04)
      ctx.closePath()
      ctx.fill()
    }
    // キメ絵の茨: ヴェール縁に鋭い刃の読みを足す (弾き=斬撃の補強)
    ctx.strokeStyle = lateCue ? PALETTE.danger : '#8f76b8'
    ctx.globalAlpha = alpha * (0.5 + 0.5 * cp)
    ctx.lineWidth = 1.6
    for (const side of [-1, 1]) {
      const wingX = x + side * H * (0.22 + 0.5 * (b.state === 'active' ? 1 : cp))
      ctx.beginPath()
      for (let i = 0; i < 4; i += 1) {
        const px = x + (wingX - x) * (0.45 + i * 0.16)
        const py = shoulderY + (waistY - shoulderY) * 0.4 + Math.sin(i * 9.3) * 6
        ctx.moveTo(px, py)
        ctx.lineTo(px + side * 7, py - 7)
      }
      ctx.stroke()
    }
  } else {
    ctx.beginPath()
    ctx.moveTo(x - headR * 1.3, headY - headR * 0.7)
    ctx.quadraticCurveTo(x - dir * H * 0.13, waistY, x - dir * H * 0.17, footY - H * 0.07)
    ctx.lineTo(x + dir * headR * 0.5, footY - H * 0.12)
    ctx.quadraticCurveTo(x + headR * 1.1, shoulderY, x + headR * 1.3, headY - headR * 0.7)
    ctx.closePath()
    ctx.fill()
  }
  ctx.globalAlpha = alpha

  // 体幹崩し中の合図 (黄金の揺らぎ) / パリィ後の白フラッシュは共通機構が無いため簡易に
  if (b.state === 'staggered') {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = alpha * (0.25 + 0.15 * Math.sin(t * 18))
    ctx.fillStyle = PALETTE.fxGold
    ctx.beginPath()
    ctx.ellipse(x, footY - H * 0.5, H * 0.3, H * 0.55, 0, 0, Math.PI * 2)
    ctx.fill()
  }
  ctx.restore()
}

// スプライト版ボス描画。 サイズは "ものさし方式": 主人公 (PLAYER_DISPLAY_HEIGHT=120) への
// 表示高さ倍率で決める。 アスペクト維持で幅は自動 → 全ボスの相対サイズが揃う。
// 顔の無い戴冠王 = 主人公の約 1.55 倍。 将来の大型ボス(縦を使う技)は 2.0+ を想定。
const BOSS_HEIGHT_RATIO: Record<string, number> = {
  'dream-hound': 1.55,
  'vigil-knight': 1.8,    // 長身の門番 (主人公の1.8倍=「圧が合う」ユーザー裁定 2026-06-13)。 sprites.ts の per-boss K (0.387) と対
  'former-princess': 1.06, // 主人公とほぼ同じ背丈 (鏡)。 E-2 実機で微調整
  // 🔵 2026-09-02 夜 等身 1.6 化で 0.8 倍（旧 2.0）。ユーザー裁定 2026-09-02 夜
  //   （パック第2便 A-1・実舞台で 2.0/1.8/1.6 を見比べ）。
  //   記録＝docs/playtest/packs/2026-09-02-executioner-visual-audit-pack.md
  'the-executioner': 1.6,
  'inverted-jester': 1.2,  // 人型・スラリとした道化。 E-4 実機で微調整
  'blade-dancer':    1.55, // 186px。 2026-10-19 B の立ち絵へ替えた時に 1.25→1.55 (作者 10-18)。 旧 1.25 は DEV ?bladeArt=old
  'crowned-king-awoken': 1.55, // 王と同等の獣サイズ。 E-6 実機で微調整
  'bride': 1.4,           // LUNAIRE(120px) より明確に大きい ≒168px。 ✅確定 (07-05 boss-slice・検収パックC-1〜C-6+07-03背景v2目視で検証済)。 sprites.ts は固定スケール(BOSS_FIXED_SCALE_REF_H・idle基準) = この ratio が素直に全体高さへ効く
}
const DEFAULT_BOSS_HEIGHT_RATIO = 1.4

// per-boss 接地調整 (drawBossFromSprite)。 元絵の足位置/裾形がボスで違うので、 本体を少し持ち上げて
//   床ディスクへのめり込みを防ぎ、 影幅を裾に合わせる。 既定 = 持ち上げ0・影幅70 (ハウンド基準)。
const BOSS_FOOT_LIFT: Record<string, number> = {
  bride: 6,   // 裾が床に乗る量。 本体だけ少し浮かせ影は床に残す (浮遊する花嫁)。 ✅確定 (07-05 boss-slice・07-03背景v2で接地目視済)
  // 覚醒王 (2026-08-11 ユーザー指摘「プレイヤーとエフェクトと獣の足場が全部違う」→ 実測で確定):
  //   スプライトは全ボス共通で「不透明bbox の下端を centerY+12 へ置く」= 設計上12px 沈む。
  //   人型は足が小さく影で隠れるので見えないが、 四つ足は前後4本の肉球が横に広く並ぶため
  //   床の線が肉球を横切って見える。 主人公のブーツ底は床の線ちょうど = 獣だけ別の線に立っていた。
  //   影は b.y+4 に残るので、 持ち上げても影は床から離れない。
  'crowned-king-awoken': 6,
  // 介錯 (2026-09-02 見た目の棚卸し §C3・docs/reports/2026-09-02-executioner-visual-audit.md):
  //   実舞台で主人公と並べると、主人公の靴底は床の線ちょうど・介錯の靴底は 12px 下 (上の覚醒王と同じ設計上の沈み)。
  //   人型でも黒いブーツの底が床の石目より下に見えるので、覚醒王と同じ 6 を入れる。影は b.y+4 のまま。
  //   ✅ 2026-09-02 夜 実プレイ「6px でいい」(ユーザー裁定・検収パック A-1) = 確定。`?footLift=<0..12>` (src/main.ts・DEV) は比較用に残す。
  'the-executioner': 6,
}
// DEV つまみ: `?footLift=<n>` で BOSS_FOOT_LIFT を実行時に上書きする (比較用・配布ビルドでは呼ばれない)。
export function setBossFootLiftOverride(bossId: string, px: number): void {
  BOSS_FOOT_LIFT[bossId] = px
}
// 🟨 2026-09-02 見た目の棚卸し・DEV 限定・ボスの大きさを実舞台で見比べるため。既定は変えない。
// DEV つまみ: `?bossScale=<n>` で BOSS_HEIGHT_RATIO を実行時に上書きする (比較用・配布ビルドでは呼ばれない)。
export function setBossHeightRatioOverride(bossId: string, ratio: number): void {
  BOSS_HEIGHT_RATIO[bossId] = ratio
}
// 🔵 2026-09-06 便1 (docs/candidates/2026-09-06-boss-core-real-size-fable-design.md §1-2): 実表示の
//   高さ (= drawBossSprite の displayHeight と同じ値)。 sprites.ts の DEV 計測道具 (__measureBossCore) が
//   「描画と同じ倍率」を出すのに読む。 BOSS_HEIGHT_RATIO を他モジュールへコピーしない = 定数は一箇所。
export function bossDisplayHeightFor(bossId: string): number {
  return PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[bossId] ?? DEFAULT_BOSS_HEIGHT_RATIO)
}
const BOSS_SHADOW_RX: Record<string, number> = {
  bride: 46,  // 裾幅に合わせた影 (既定70=ハウンドの横広は花嫁には広すぎる)。 ✅確定 (07-05 boss-slice・07-03背景v2で全幅目視済)
}
// 本体の足元ベースライン (持ち上げ適用後)。 本体・赤呪いリム・顔glow・呪い煙 すべてこれに揃える
//   = lift を上げても body と overlay がズレない (影だけは床 b.y+4 に残す)。
// 大暴れ第5案の高さ (altitudePx) も足元ごと持ち上げる = 体に付く表示が全部ついてくる。影は床のまま。
// 戴冠獣だけ「歩きは 12px・技は 0」を時間で寄せた量 (src/hound_walk_lift.ts・11-03 既定・前の版は DEV ?houndLift=old)。
function bossFootY(b: Boss): number { return b.y - (houndWalkLiftNow(b.id) ?? BOSS_FOOT_LIFT[b.id] ?? 0) - (b.altitudePx ?? 0) }

// パリィ合図の強さ (チュートリアルを難易度カーブに溶かす)。
//   ボスの "顔の虚無" が、 パリィ可能な攻撃の「当たる瞬間」に鋭く一閃する = 押すべき所の合図。
//   文字UIを出さず、 世界の現象(魂の閃き)で timing を教える。
//   序盤ボス=1.0 (くっきり) → 後半ボスは値を下げるだけで合図が薄れ、 アニメの読みが要る。
//   2026-06-29 ユーザー裁定: 顔前の攻撃タイミング指標は「顔無しの王」だけ温存・他は全削除。
//   人型ボス(処刑人/姫/道化/剣舞/花嫁)は顔・体・武器でアニメ読み可=合図を 0 に。
const BOSS_PARRY_CUE: Record<string, number> = {
  'dream-hound': 1.0,   // 王 (顔無しの獣): 合図が唯一の state read = はっきり残す
  // 覚醒王 (crowned-king-awoken) は 0 (10-27 作者・前の 0.55 は DEV ?awokenFaceGlow=old・src/awoken_face_glow.ts awokenParryCue)。
  'nameless-shade': 1.0, // 亡霊 (顔無し): 王と同理由で温存 (チュートリアル稽古2=ジャスト教室の可読性優先・2026-07-05チケットE)
  'vigil-knight': 0,    // 以下、 王以外は全て 0 (アニメ読みのみ)
  'the-executioner': 0,
  'former-princess': 0,
  'inverted-jester': 0,
  'blade-dancer':    0,
  'bride': 0,
}
const DEFAULT_BOSS_PARRY_CUE = 0   // 未指定ボスは合図なし (= アニメ読みのみ)

// 顔の虚無の発光位置 (顔無し戴冠王用)。 状態ごとに頭の位置が違うので、
// 表示高さ h に対する相対オフセット [x, y] (左向き基準。 x<0=左=頭側)。
const BOSS_FACE_ANCHOR: Record<string, [number, number]> = {
  idle:      [-0.60, -0.42],
  telegraph: [-0.55, -0.76],
  active:    [-0.72, -0.46],
  comboGap:  [-0.72, -0.46],
  recovery:  [-0.72, -0.46],
  parried:   [-0.46, -0.82],
  staggered: [-0.56, -0.34],
  defeat:    [-0.62, -0.20],
}
// 顔アンカーのボス別上書き (未指定ボスは上の BOSS_FACE_ANCHOR = 王基準を流用)。
//   騎士: 魂 = 兜スリットの冷光。 獣の顔虚無と違い「頭頂中央やや前」で高く狭い。
const BOSS_FACE_ANCHOR_BY_BOSS: Record<string, Record<string, [number, number]>> = {
  'vigil-knight': {
    idle:      [-0.16, -0.86],
    telegraph: [-0.18, -0.90],
    active:    [-0.40, -0.74],
    comboGap:  [-0.34, -0.76],
    recovery:  [-0.30, -0.78],
    parried:   [-0.14, -0.88],
    staggered: [-0.18, -0.66],
    defeat:    [-0.30, -0.52],
  },
  // 姫: 人型・頭は上部中央 (¾)。 魂=淡青の瞳。 攻撃で前方へ踏み込む。
  'former-princess': {
    idle:      [-0.08, -0.86],
    telegraph: [-0.10, -0.88],
    active:    [-0.32, -0.78],
    comboGap:  [-0.28, -0.80],
    recovery:  [-0.24, -0.80],
    parried:   [-0.06, -0.86],
    staggered: [-0.10, -0.64],
    defeat:    [-0.22, -0.56],
  },
  // 処刑人: 2026-08-12 に旧処刑人の見た目へ戻したため旧アンカーを保存。
  //   BOSS_BASE_SOUL_GLOW_MULT / BOSS_PARRY_CUE が0なので現在は描画に使われない。
  'the-executioner': {
    idle:      [-0.40, -0.70],
    telegraph: [-0.42, -0.74],
    active:    [-0.30, -0.72],
    comboGap:  [-0.30, -0.72],
    recovery:  [-0.32, -0.70],
    parried:   [-0.38, -0.70],
    staggered: [-0.36, -0.56],
    defeat:    [-0.30, -0.46],
  },
  // 道化: 人型・マスクが頭上部にある。 攻撃で前方へ反り込む (右向き素材のためxは逆符号基準)。
  'inverted-jester': {
    idle:      [-0.10, -0.86],
    telegraph: [-0.12, -0.88],
    active:    [-0.35, -0.80],
    comboGap:  [-0.30, -0.82],
    recovery:  [-0.26, -0.82],
    parried:   [-0.08, -0.86],
    staggered: [-0.12, -0.64],
    defeat:    [-0.24, -0.52],
  },
  // 剣舞: 長身のバレリーナ。 頭は上部、攻撃で前傾して剣先に乗る (旧の右向き素材で決めた値)。
  //   10-19 の B の立ち絵 (左向き) には合っていないが、剣舞は BOSS_PARRY_CUE=0・BOSS_BASE_SOUL_GLOW_MULT=0 で
  //   この点に何も描かれない (docs/research/2026-10-19-blade-dancer-ingame-capture.md)。
  'blade-dancer': {
    idle:      [-0.08, -0.88],
    telegraph: [-0.10, -0.90],
    active:    [-0.36, -0.80],
    comboGap:  [-0.32, -0.82],
    recovery:  [-0.28, -0.82],
    parried:   [-0.06, -0.88],
    staggered: [-0.10, -0.66],
    defeat:    [-0.20, -0.58],
  },
  // 覚醒王: 王と同じ四足獣。 覚醒で頭を上げ気味 (idle y=-0.50〜-0.55)。 虚無の口=前方。
  'crowned-king-awoken': {
    idle:      [-0.60, -0.52],
    telegraph: [-0.55, -0.80],
    active:    [-0.72, -0.48],
    comboGap:  [-0.72, -0.48],
    recovery:  [-0.72, -0.48],
    parried:   [-0.46, -0.86],
    staggered: [-0.56, -0.36],
    defeat:    [-0.62, -0.22],
  },
  // 花嫁: ヴェール越しの面=上部中央。 active は正面でヴェール全開=顔中央。
  'bride': {
    idle:      [-0.10, -0.82],
    telegraph: [-0.10, -0.84],
    active:    [0.0, -0.82],
    comboGap:  [-0.06, -0.82],
    recovery:  [-0.06, -0.82],
    parried:   [-0.08, -0.82],
    staggered: [-0.10, -0.62],
    defeat:    [-0.14, -0.58],
  },
}

// ボスの "魂" の発光色。 王=顔の虚無の紫 / 騎士=兜スリットの冷光 (青白)。 既定=王の紫。
type SoulPalette = {
  voidCore: [number, number, number]; voidMid: [number, number, number]; voidOuter: [number, number, number]
  cueNear: string; cueFar: string
  flashCore: [number, number, number]; flashMid: [number, number, number]; flashOuter: [number, number, number]
  ring: string
}
const BOSS_SOUL: Record<string, SoulPalette> = {
  'dream-hound': {
    voidCore: [170, 142, 224], voidMid: [120, 90, 200], voidOuter: [90, 60, 150],
    cueNear: '#efe6ff', cueFar: '#c4a4ec',
    flashCore: [246, 238, 255], flashMid: [196, 156, 238], flashOuter: [150, 110, 210],
    ring: 'rgba(232,222,255,0.9)',
  },
  'vigil-knight': {
    voidCore: [200, 218, 255], voidMid: [126, 156, 214], voidOuter: [80, 110, 172],
    cueNear: '#f0f5ff', cueFar: '#a9c6ea',
    flashCore: [240, 246, 255], flashMid: [172, 200, 240], flashOuter: [110, 150, 212],
    ring: 'rgba(222,235,255,0.9)',
  },
  // 姫 (鏡): 淡青の冷光 (主人公と対の "白い光")。 ラスボスなので幽か。
  'former-princess': {
    voidCore: [212, 228, 255], voidMid: [150, 180, 228], voidOuter: [96, 128, 184],
    cueNear: '#f4f8ff', cueFar: '#bcd4f0',
    flashCore: [244, 248, 255], flashMid: [184, 210, 244], flashOuter: [120, 156, 214],
    ring: 'rgba(230,240,255,0.9)',
  },
  // 処刑人: ⚠️ 🔴廃止済みの「フードの奥の赤」時代の配色。 フードは 2026-07-28 に禁止。
  //   さらに **赤はこのゲームで「弾けない攻撃」専用の信号色** なので、パリィ合図に赤を使うのは信号の反転になる
  //   (パリィ合図 spiral は atk.parryable のときだけ出るため)。 現在は BOSS_PARRY_CUE=0 / BASE_SOUL_GLOW_MULT=0 で
  //   **この配色は一度も描画されていない**＝実害は出ていない。 合図を復活させるなら赤以外へ引き直すこと。
  //   台帳 = docs/decision-ledger.md §常打ちの刑吏「差し色＝緑青」/ 赤の禁止
  'the-executioner': {
    voidCore: [255, 122, 110], voidMid: [206, 64, 70], voidOuter: [120, 30, 42],
    cueNear: '#ffe2da', cueFar: '#e87c74',
    flashCore: [255, 206, 196], flashMid: [224, 96, 96], flashOuter: [140, 40, 52],
    ring: 'rgba(255,212,202,0.9)',
  },
  // 道化: 嘘の赤い笑み。 合図は赤系でにじむが薄め (あべこべなので「合図すら信用できない」雰囲気)。
  'inverted-jester': {
    voidCore: [255, 120, 120], voidMid: [206, 70, 90], voidOuter: [120, 30, 50],
    cueNear: '#ffe0e0', cueFar: '#e87a8a',
    flashCore: [255, 206, 206], flashMid: [224, 96, 110], flashOuter: [140, 40, 60],
    ring: 'rgba(255,210,210,0.9)',
  },
  // 剣舞: くすんだ薔薇色のリズム。 ローズピンクの閃きがビートを刻む。
  'blade-dancer': {
    voidCore: [255, 176, 206], voidMid: [214, 110, 150], voidOuter: [150, 60, 96],
    cueNear: '#ffe6f0', cueFar: '#e89cc0',
    flashCore: [255, 214, 232], flashMid: [230, 130, 170], flashOuter: [150, 70, 110],
    ring: 'rgba(255,220,235,0.9)',
  },
  // 覚醒王: 王の静かな紫を「暴走で濁った紫黒/滲む黒紅」へ (2026-06-14 裁定 7-3)。
  //   旧「真紅オーラ」の語と明るい赤紫を、 くすんだ紫黒へ寄せて低明度化＝裁定C「弾けない=赤黒い呪いオーラ
  //   (高明度・脈打つ)」と見分けが付くようにする。 常時の魂グロー=静か・濁った紫黒。
  'crowned-king-awoken': {
    voidCore: [160, 84, 150], voidMid: [128, 50, 96], voidOuter: [78, 30, 64],
    cueNear: '#d8a8d0', cueFar: '#a85e92',
    flashCore: [204, 150, 196], flashMid: [162, 72, 122], flashOuter: [104, 42, 84],
    ring: 'rgba(200,162,202,0.85)',
  },
  // 花嫁: 喪の淡い灰白。 紫でなく温かみのある白の幽かな灯り (待つ宵の静けさ)。
  'bride': {
    voidCore: [244, 236, 228], voidMid: [206, 192, 176], voidOuter: [140, 128, 114],
    cueNear: '#fff6ec', cueFar: '#ecdccc',
    flashCore: [250, 244, 236], flashMid: [220, 206, 190], flashOuter: [150, 138, 122],
    ring: 'rgba(250,242,232,0.9)',
  },
}
const DEFAULT_SOUL: SoulPalette = BOSS_SOUL['dream-hound']!
// 顔の虚無 "基層 radial グロー" の per-boss 倍率 (全状態に効く・既定 1)。
//   背景: 基層グローは顔無しの獣 (王) 用に作った汎用機構で、 顔/兜/anchor のない王が
//   状態 (telegraph/active/comboGap/recovery) を読める唯一の手がかり=王には残す。
//   騎士は ① body language (sprite の telegraph 震え)、 ② 槍と兜の形、 ③ パリィ合図 spiral
//   で全状態が読めるため基層グローは noise (赤い不可弾攻撃でも光る・当たった瞬間に消えない誤読)
//   になる。 騎士=0 で基層を完全に抑制 (parry cue spiral+閃光は別系統なので影響なし)。
//   先行の `BOSS_IDLE_SOUL_GLOW` (idle 限定) を全状態カバーに拡張した形 (2026-06-24)。
//   2026-06-29 ユーザー裁定: 王以外の全ボスは body/顔/武器で state 読み可 → 基層グローは noise=0。
//   温存は「顔無しの王」のみ (dream-hound / crowned-king-awoken は default 1 のまま=唯一の read 手段)。
const BOSS_BASE_SOUL_GLOW_MULT: Record<string, number> = {
  'vigil-knight': 0,
  'the-executioner': 0,
  'former-princess': 0,
  'inverted-jester': 0,
  'blade-dancer': 0,
  'bride': 0,
}
const DEFAULT_BASE_SOUL_GLOW_MULT = 1
// 大暴れ第5案の「ピカン」(09-20 ユーザー「最後の床技はピカンと光って着地して床技出してほしい」)。
//   顔から十字の光が一瞬走って消える。赤＝弾けない床技／白＝弾ける締めの噛み (仮の見た目・駅3で詰める)。
//   鶏の宙廻り (ラボ専用・10-18) も、降りる直前の止まりで同じ白い光を目から出す (src/rooster_aerial_roam.ts roosterRoamGlint)。
function drawChoreoGlint(ctx: CanvasRenderingContext2D, b: Boss, x: number, y: number): void {
  const g = activeGlint(b) ?? roosterRoamGlint(b) ?? roosterDropGlint(b)
  if (!g) return
  // 鶏の比較版 (DEV ?roosterFx=v1): 白い輪の代わりに目ににじむ光 (src/rooster_fx.ts)。
  if (roosterFx() === 'v1' && b.id === 'inverted-jester') { drawRoosterEyeGlint(ctx, x, y, g.progress, g.color); return }
  drawRampageGlint(ctx, x, y, g.progress, g.color)
}

// 顔の虚無を "生かす": 状態に応じて紫の発光を明滅/燃え上がり/消滅させる (このボスの魂)。
function drawBossFaceGlow(
  ctx: CanvasRenderingContext2D,
  state: GameState,
  h: number,
  bodyPlacement: BossSpritePlacement | null,
): void {
  const b = state.boss
  const t = state.time
  const soul = BOSS_SOUL[b.id] ?? DEFAULT_SOUL
  const anchors = BOSS_FACE_ANCHOR_BY_BOSS[b.id] ?? BOSS_FACE_ANCHOR
  const key = b.hp <= 0 ? 'defeat' : (anchors[b.state] ? b.state : 'idle')
  const stateAnchor = anchors[key] ?? anchors.idle!
  const timelinePose = resolveBossTimelinePose(b.id, b)
  const currentImage = b.hp <= 0 ? 'defeat' : state.bossSprite.currKey
  const off = resolveBossFaceAnchor(b.id, stateAnchor, timelinePose?.frame ?? null, currentImage)
  const artAnchor = bodyPlacement
    ? bodyPlacement.faceAnchorInArt ?? resolveBossFaceAnchorInArt(b.id, bodyPlacement.imageKey)
    : undefined
  const artPoint = bodyPlacement && artAnchor
    ? projectBossSpriteRelativePoint(bodyPlacement, artAnchor)
    : null
  const motion = timelinePose?.motion
  const side = b.facing === 'left' ? 1 : -1 // 元絵は左向き。 反転時はミラー
  const forwardScreen = b.facing === 'left' ? -1 : 1
  // 新しい絵内アンカーがある時は、drawBossSprite が返した最終bbox・反転・回転をそのまま使う。
  // 空の間は全ボスを従来表示に保つため、以下の「足元からの距離」計算へ落とす。
  // 旧式ではタイムラインscaleを足元基準で掛け、平行移動は倍率の外で足す。
  const mScaleX = motion?.scaleX ?? 1
  const mScaleY = motion?.scaleY ?? 1
  const cx = artPoint?.x
    ?? b.x + off[0] * h * side * mScaleX + forwardScreen * (motion?.offsetX ?? 0)
  const cy = artPoint?.y
    ?? bossFootY(b) + off[1] * h * mScaleY + (motion?.offsetY ?? 0)
  // 旧式だけは rot を適用しない。新方式は bodyPlacement の回転に構造的に追従する。

  // 顔の点 (描いた絵の上の座標) を撮影スクリプトが読む (DEV だけ・scripts/capture_awoken_face_overlap_1027.mjs)。
  if (import.meta.env.DEV) (globalThis as { __bossFaceProbe?: unknown }).__bossFaceProbe = { x: cx, y: cy, art: !!artPoint }
  drawChoreoGlint(ctx, b, cx, cy)
  // 大暴れ第5案は技全体が1本の telegraph/active なので、合図の時計を噛みつきごとに付け替える (09-21)。
  const choreoCue = rampageFaceCue(b)
  const cp = choreoCue
    ? (choreoCue.kind === 'converge' ? choreoCue.p : 0)
    : (b.state === 'telegraph' ? telegraphProgress(b) : 0)
  let intensity = 0.40 + Math.sin(t * 2.2) * 0.09 // idle: ゆっくり呼吸
  if (choreoCue) {
    if (choreoCue.kind === 'roar') intensity = 0.48 + choreoCue.p * 0.4       // 雄叫び=昂るが「ここ！」ではない
    else if (choreoCue.kind === 'converge') intensity = 0.48 + cp * 0.85 + Math.sin(t * 22) * 0.06 * cp
    else if (choreoCue.kind === 'flash') intensity = 0.88
    else intensity = 0.30                                                      // 移動・壁の間=攻撃ではない
  }
  else if (b.state === 'telegraph') intensity = 0.48 + cp * 0.85 + Math.sin(t * 22) * 0.06 * cp // 燃え上がる(予兆)
  else if (b.state === 'active') intensity = 0.88 // 閃く (パリィ読み合図)
  else if (b.state === 'comboGap') intensity = 0.18 // コンボ間=次弾溜まり始め (FX#1: 攻撃後の残留グロー低減 0.45→0.18)
  else if (b.state === 'recovery') { // 攻撃終了=光が引いていく
    const recP = b.currentAttack ? Math.min(1, (b.stateElapsed * 1000) / b.currentAttack.recoveryMs) : 1
    intensity = 0.88 - recP * 0.68  // 0.88 → 0.20 (FX#1: 攻撃後の余韻グローを「消えかけの呼吸」だけに 終値 0.40→0.20)
  }
  else if (b.state === 'staggered') intensity = 0.24 + Math.sin(t * 28) * 0.08 // 不安定に弱る
  if (b.hp <= 0) intensity = Math.max(0, 0.5 - state.bossSprite.defeatElapsedSec / 0.8 * 0.5) // 消えていく

  // 基層 radial グローの per-boss 抑制 (騎士=0 で「赤い不可弾でも光る」「当たった瞬間に消えない」誤読を解消)。
  //   パリィ合図 (spiral 粒+閃光) は基層と独立に下で描画するので、 baseIntensity=0 でも cue は出る。
  const baseGlowMult = b.id === 'crowned-king-awoken' ? awokenBaseGlowMult() : BOSS_BASE_SOUL_GLOW_MULT[b.id] ?? DEFAULT_BASE_SOUL_GLOW_MULT
  const baseIntensity = intensity * baseGlowMult

  // 半径はパリィ合図側 (convergeR/outerBase) でも使うので state 分岐の外で確定。
  const motionScale = motion ? Math.sqrt(Math.max(0, motion.scaleX * motion.scaleY)) : 1
  const r = h * (0.34 + cp * 0.18) * motionScale

  // 基層: 溜めで虚無がぐっと膨らむ = 楕円オーラの代わりの予兆 (この王の魂が昂る)。 騎士は mult=0 でスキップ。
  if (baseIntensity > 0.02) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r)
    g.addColorStop(0, `rgba(${soul.voidCore[0]},${soul.voidCore[1]},${soul.voidCore[2]},${0.70 * baseIntensity})`)
    g.addColorStop(0.4, `rgba(${soul.voidMid[0]},${soul.voidMid[1]},${soul.voidMid[2]},${0.30 * baseIntensity})`)
    g.addColorStop(1, `rgba(${soul.voidOuter[0]},${soul.voidOuter[1]},${soul.voidOuter[2]},0)`)
    ctx.fillStyle = g
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.fill()
    ctx.restore()
  }

  // ── パリィ合図: 「虚無に収束する光の輪」 ──
  //   溜めの進行で 光の輪が外から虚無へ閉じていき、 攻撃の『当たる瞬間』にピタッと収束する。
  //   プレイヤーは輪が閉じきる瞬間を "事前に読んで" 押せる = 明るさのピークと違い timing が取れる。
  //   輪は硬い幾何線でなく「魔力が一点に集まる光の粒」で描く (世界の現象・既存FXと統一)。
  //   文字/UI記号は一切なし。 強さはボス別 (序盤くっきり→後半薄く=難易度カーブ)。
  const readability = b.id === 'crowned-king-awoken' ? awokenParryCue() : BOSS_PARRY_CUE[b.id] ?? DEFAULT_BOSS_PARRY_CUE
  const atk = b.currentAttack
  if (readability > 0 && atk && atk.parryable && b.hp > 0) {
    const convergeR = r * 0.5                    // 収束点 (虚無の芯)
    const converging = choreoCue ? choreoCue.kind === 'converge' : b.state === 'telegraph'
    const flashAp = choreoCue
      ? (choreoCue.kind === 'flash' ? choreoCue.p * 0.6 : null)
      : (b.state === 'active' ? Math.min(1, (b.stateElapsed * 1000) / atk.activeMs) : null)
    if (converging) {
      // cp: 0→1 (1 = 口が閉じる = 収束 = パリィ瞬間)
      const appear = Math.min(1, cp / 0.08)      // 出だしふわっと
      // 「魔力が渦を巻いて虚無へ吸い込まれる」: 多数の細かい粒が外→中心へ螺旋で流れ込む。
      //   各粒は出生位置・速さ・角度がバラバラ(等間隔の機械リングを避ける)。 尾(トレイル)つき。
      //   外周半径は cp で閉じる(=収束が近い)、 流れる密度・明るさも cp で増す。
      const tm = performance.now() / 1000
      const outerBase = convergeR + (1 - cp) * r * 1.9   // 渦の外縁 (閉じていく)
      const M = 34
      ctx.save()
      ctx.globalCompositeOperation = 'lighter'
      for (let i = 0; i < M; i += 1) {
        const seed = i * 12.9898
        const baseAng = hash01(seed) * Math.PI * 2
        const speed = 0.5 + hash01(seed + 1.3) * 0.7
        // flow 0(外)→1(中心) を時間で循環 = 連続的に吸い込まれる流れ
        const flow = (tm * speed + hash01(seed + 4.7) + cp * 0.4) % 1
        const ease = flow * flow                       // 中心ほど加速して吸い込まれる
        const jitterR = 0.82 + hash01(seed + 2.1) * 0.4
        const rad = convergeR + (outerBase * jitterR - convergeR) * (1 - ease)
        const spiral = (1 - flow) * 2.4                // 外ほど巻きが強い螺旋
        const ang = baseAng + spiral + tm * 0.5
        const px = cx + Math.cos(ang) * rad
        const py = cy + Math.sin(ang) * rad * 0.9
        // 出生(外)でふっと現れ、 中心で吸い込まれ消える
        const life = Math.sin(flow * Math.PI)
        const a = life * (0.4 + 0.6 * cp) * readability * appear
        if (a <= 0.02) continue
        const dotR = 1.0 + hash01(seed + 3.3) * 1.4 + flow * 1.2
        const col = flow > 0.7 ? soul.cueNear : soul.cueFar  // 中心に近いほど白熱
        // トレイル: 来た方向(外側)へ淡く尾を引く = 吸い込まれてる流れ感
        for (let t = 1; t <= 3; t += 1) {
          const tf = flow + t * 0.05
          if (tf >= 1) continue
          const trad = convergeR + (outerBase * jitterR - convergeR) * (1 - tf * tf)
          const tang = baseAng + (1 - tf) * 2.4 + tm * 0.5
          drawGlowDot(ctx, cx + Math.cos(tang) * trad, cy + Math.sin(tang) * trad * 0.9,
            dotR * (1 - t * 0.22), col, a * (0.5 - t * 0.13))
        }
        drawGlowDot(ctx, px, py, dotR, col, a)
      }
      ctx.restore()
    } else if (flashAp !== null) {
      // 収束の瞬間: 中心で白紫の閃光 + 外へ弾ける小さな波紋 (= 収束して解放された印 = 「ここ!」)
      const ap = flashAp
      if (ap < 0.6) {
        const k = 1 - ap / 0.6
        ctx.save()
        ctx.globalCompositeOperation = 'lighter'
        const fr = convergeR * (1.1 + 0.3 * k)
        const fg = ctx.createRadialGradient(cx, cy, 0, cx, cy, fr)
        fg.addColorStop(0, `rgba(${soul.flashCore[0]},${soul.flashCore[1]},${soul.flashCore[2]},${0.95 * k * readability})`)
        fg.addColorStop(0.4, `rgba(${soul.flashMid[0]},${soul.flashMid[1]},${soul.flashMid[2]},${0.5 * k * readability})`)
        fg.addColorStop(1, `rgba(${soul.flashOuter[0]},${soul.flashOuter[1]},${soul.flashOuter[2]},0)`)
        ctx.fillStyle = fg
        ctx.beginPath(); ctx.arc(cx, cy, fr, 0, Math.PI * 2); ctx.fill()
        // 収束直後だけ外へ弾ける波紋
        const rp = Math.min(1, ap / 0.6)
        ctx.globalAlpha = (1 - rp) * readability
        ctx.strokeStyle = soul.ring
        ctx.lineWidth = 2 * (1 - rp) + 0.5
        ctx.beginPath(); ctx.ellipse(cx, cy, convergeR * (0.6 + rp * 1.4), convergeR * (0.6 + rp * 1.4) * 0.92, 0, 0, Math.PI * 2); ctx.stroke()
        ctx.globalAlpha = 1
        ctx.restore()
      }
    }
  }
}

// 待宵の花嫁・宵渡り (blink/reappear) の渦スプライト (黒背景・additive)。
//   消える時=本体が薄れる上にこの渦が立ち上がり光に解ける / 現れる時=渦から結び直る。
//   黒背景のまま 'lighter' 合成で重ねる (FXスプライト方式・memory reference_fx_sprite_pipeline)。
//   ※絵そのもので「再出現を見せる」= clean な白リング等の UI 図形は足さない (reference_fx_worldview_rule)。
let brideBlinkSwirlImg: HTMLImageElement | null = null
function brideBlinkSwirl(): HTMLImageElement | null {
  if (typeof Image === 'undefined') return null
  if (!brideBlinkSwirlImg) {
    brideBlinkSwirlImg = new Image()
    brideBlinkSwirlImg.src = '/sprites/bosses/bride/blink_swirl.webp'
  }
  const img = brideBlinkSwirlImg
  return img.complete && img.naturalWidth > 0 ? img : null
}

// 撃破死: 各ボスの defeat ポーズ (跪き) を「致命SEの山が引くまで」solid で一拍見せてから灰へ溶かす。
//   全ボス共通 (花嫁特別扱いはしない・ユーザー裁定 2026-06-29 騎士の制御へ統一)。
//   アンカー = execute_hit3 (致命とどめ) の打撃ピーク。 mp3 エンベロープ実測で山は実時間 ~250ms で引く
//   (peak 40ms → 15% に 270ms)。 pull が 0.4x スローのため、 実時間 250ms = fin 換算 ~190
//   (= impact T_PULL 150 + 40)。 → 本体の溶け時計を 40[fin-ms] 遅延させ、 dissolve 開始を山の減衰へ合わせる。
//   ※ FX(魂/バースト)は実 fin で進むので音とは別に走る (本体の灰化開始だけ後ろへ寄せる)。
const DEATH_POSE_HOLD_MS = 40
/** 本体の溶け時計。止め (アリスの技・?lunaExec=swap) は裂け目が弾けるまで崩れた姿で立たせ、弾けてから溶かす。 */
function finisherBodyElapsedMs(state: GameState): number {
  if (!state.finisher) return 0
  const hold = lunaExecSwapOn() ? aliceBurstAtClock() : DEATH_POSE_HOLD_MS
  return Math.max(0, state.finisher.elapsedMs - hold)
}

// 2026-07-02 溜め厚化②: 花嫁の溜め後半に、 打点方向へ体を"じわっと"寄せる (procedural)。
//   telegraph 60〜100% で 0→target へ ease-in (t*t)、 active は target を保持、
//   recovery 前半 (0〜40%) で target→0 へ ease-out (1 - t*t)。
//   段差禁止・時間補間で必ずカーブを描く ([[design_procedural_motion_must_be_smooth]])。
//   影は寄せず本体だけ寄せる=床の影は動かない=「重心が動いた」自然な体感。
//   数値ドラフト: veilSweep 6px前 / veilInvitation 4px前 / vowEmbrace 5px前 / brideExecution 8px上。
//   ※ 花嫁は BOSS_BASE_SOUL_GLOW_MULT/BOSS_PARRY_CUE=0 = 顔前グロー無し。 見た目の予告はこれと絵で。
const BRIDE_WINDUP_LEAN_TARGET: Record<string, { x: number; y: number }> = {
  veilSweep:      { x: 6, y: 0 },
  // 招きは腕を真横へ広げる技=前後どちらへも打点が偏らない (帯は前後両側=打点方向が定まらない)。
  //   加えて至近距離では出さない AI (2026-07-01) = 寄せる必要が体感的にも無い。 2026-07-02 ゼロに。
  veilInvitation: { x: 0, y: 0 },
  vowEmbrace:     { x: 5, y: 0 },
  brideExecution: { x: 0, y: -8 },
}
function brideWindupLean(b: Boss): { leanX: number; leanY: number } {
  if (b.id !== 'bride' || !b.currentAttack) return { leanX: 0, leanY: 0 }
  // 固有の致命 (DEV ?execUnique=1) は絵の並びが体の傾きを持つので、溜めの寄せは足さない。
  if (b.currentAttack.uniqueExec) return { leanX: 0, leanY: 0 }
  const target = BRIDE_WINDUP_LEAN_TARGET[b.currentAttack.id as string]
  if (!target) return { leanX: 0, leanY: 0 }
  const dir = b.facing === 'right' ? 1 : -1
  let k = 0   // 0..1: 溜め寄せの進行 (0=中立姿勢, 1=最大寄せ)
  if (b.state === 'telegraph') {
    const p = Math.min(1, (b.stateElapsed * 1000) / Math.max(1, b.currentAttack.chargeMs))
    const t = Math.max(0, Math.min(1, (p - 0.6) / 0.4))   // 溜めの後半 40% だけを寄せに使う
    k = t * t                                              // ease-in (立ち上がりゆっくり→終盤加速)
  } else if (b.state === 'active') {
    k = 1                                                  // 打点中は寄せ切りを保持 (打ち抜く姿勢)
  } else if (b.state === 'recovery') {
    const p = Math.min(1, (b.stateElapsed * 1000) / Math.max(1, b.currentAttack.recoveryMs))
    const t = Math.max(0, Math.min(1, p / 0.4))            // 隙の前半 40% で中立へ戻す
    k = Math.max(0, 1 - t * t)                             // ease-out (最初速く→終盤ゆっくり=巻き戻り感を消す)
  }
  return { leanX: target.x * dir * k, leanY: target.y * k }
}

// 騎士の跳び下がり薙ぎ・壁ぎわ突進の本体だけの上下 (溜めの沈み・跳びの浮き・走りの上下) と縦のつぶれ。
//   本体の絵と、弾けない赤の輪郭 (bakeCurseSilhouette) の両方がこれを使う = 輪郭が絵の縁からずれない
//   (2026-09-28 ユーザー「壁際の突進の赤いエフェクトが実際の絵の縁とズレてる」)。boss.x と当たり判定は動かさない。
function knightMoveBodyPose(b: Boss): { liftY: number; squashY: number } {
  const id = b.currentAttack?.id
  if (b.id !== 'vigil-knight' || (id !== 'lanceCross' && id !== 'knightWallCharge')) return { liftY: 0, squashY: 1 }
  const attackMs = b.currentAttack?.activeMs ?? 0
  const s = b.state === 'active' ? b.stateElapsed * 1000 : b.state === 'recovery' ? attackMs + b.stateElapsed * 1000 : 0
  if (b.state === 'telegraph' && id === 'lanceCross') {
    // 跳び下がり薙ぎの見分け (09-29): 薙ぎと同じ瞬間に構え、構えの間に膝を曲げて沈む (薙ぎは沈まずわずかに膨らむ)。
    const tell = getKnightLeapTell()
    if (tell === 'none') return { liftY: 0, squashY: 1 }
    const chargeMs = b.currentAttack?.chargeMs ?? 1
    const p = Math.max(0, Math.min(1, (b.stateElapsed * 1000 - KNIGHT_SWEEP_WINDUP_ONSET_MS) / (chargeMs - KNIGHT_SWEEP_WINDUP_ONSET_MS)))
    const depth = tell === 'deep' ? 10 : 5
    return { liftY: depth * p * p, squashY: 1 - depth * 0.006 * p * p }
  }
  if (b.state === 'telegraph') {
    const p = Math.min(1, b.stateElapsed * 1000 / (b.currentAttack?.chargeMs ?? 1))
    return { liftY: 5 * p * p, squashY: 1 - 0.03 * p * p }
  }
  if (id === 'lanceCross') {
    const h = s - KNIGHT_CROSS_HOP_AT_MS   // 跳びは払いの後 (src/knight_leap_slash.ts)
    return { liftY: knightCrossLiftY(s), squashY: h >= KNIGHT_LEAP_AIR_MS && h < KNIGHT_LEAP_AIR_MS + 80 ? 0.95 : 1 }
  }
  if (b.state === 'active') {
    const traveled = Math.abs(b.x - b.actionAnchorX)
    return { liftY: -3 * Math.abs(Math.sin(traveled / KNIGHT_CHARGE_STRIDE * Math.PI)), squashY: 1 }
  }
  return { liftY: 0, squashY: 1 }
}

// 溜め (telegraph) の間だけ本体をわずかに大きく描く = 「力を溜めている」体の予兆。
//   ⚠️ 光は足さない。顔の発光 (BOSS_BASE_SOUL_GLOW_MULT) とパリィ合図の渦 (BOSS_PARRY_CUE) は
//     2026-06-29 のユーザー裁定で騎士は 0。ここはスプライトの表示倍率だけを触る。
//   2026-09-05 ユーザー要望: 騎士に「溜めている感じ」が無いため。既定 0 = 他ボスは1pxも動かない。
const BOSS_TELEGRAPH_SWELL: Record<string, number> = {
  'vigil-knight': 0.035,   // 🟨 仮値 (実機で「ちょっと」に見えるか確認して詰める)
}
export function bossTelegraphSwell(b: Boss): number {
  const swell = BOSS_TELEGRAPH_SWELL[b.id]
  if (!swell || !b.currentAttack) return 1
  // 跳び下がり薙ぎの 'none' (DEV の見比べ用) だけは薙ぎと同じに膨らむ = 違いなし。
  if (b.currentAttack.id === 'lanceCross' && getKnightLeapTell() === 'none') { /* 薙ぎと同じ膨らみ */ }
  else if (b.currentAttack.id === 'lanceCross' || b.currentAttack.id === 'knightWallCharge') return 1
  const smoothstep = (p: number): number => {
    const clamped = Math.max(0, Math.min(1, p))
    return clamped * clamped * (3 - 2 * clamped)
  }
  if (b.state === 'telegraph') {
    const p = Math.max(0, Math.min(1, (b.stateElapsed * 1000) / b.currentAttack.chargeMs))
    const k = p * p   // ease-in
    return 1 + swell * k
  }
  if (b.state === 'active') {
    // 🔴 連撃の2段目以降 (comboHitIndex>0) は telegraph を経由せず comboGap(=1.0) から直接入るので、
    //   ここで減衰させると 1.0 → 1.035 の段差になる。1段目だけ減衰させて全遷移を連続に保つ。
    if ((b.comboHitIndex ?? 0) !== 0) return 1
    const q = Math.max(0, Math.min(1, (b.stateElapsed * 1000) / (b.currentAttack.activeMs * 0.35)))
    const k = 1 - smoothstep(q)   // telegraph 終端 (k=1) と滑らかに繋がり、そこから 1 へ戻る
    return 1 + swell * k
  }
  return 1
}

// 花嫁の回る途中の絵 (DEV ?brideSpin=ca) で、正面の絵の置き場所だけを測るための見えない 1x1 の描き先。
let brideTurnScratch: CanvasRenderingContext2D | null = null
function brideTurnScratchCtx(): CanvasRenderingContext2D {
  if (!brideTurnScratch) {
    const c = document.createElement('canvas')
    c.width = 1; c.height = 1
    brideTurnScratch = c.getContext('2d')!
  }
  return brideTurnScratch
}

// 鶏の宙廻り (ラボ専用・10-18): 降りる直前の止まり〜突っ込みの間、落ちる床を淡い銀の楕円で先に光らせる。
//   線は描かない (FX に線を描かない決まり)。止まりの間は主人公の今の位置から見込んだ所、突っ込み中は決まった着地点。
function drawRoosterLandingGlow(ctx: CanvasRenderingContext2D, b: Boss, playerX: number, visibility: number): void {
  const glow = roosterLandingPreview(b, playerX) ?? roosterDropPreview(b, playerX)
  if (!glow) return
  const rx = 58
  const ry = 11
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.translate(glow.x, b.y + 4)
  ctx.scale(1, ry / rx)
  const g = ctx.createRadialGradient(0, 0, 0, 0, 0, rx)
  const a = glow.alpha * visibility
  g.addColorStop(0, `rgba(214,224,240,${(a * 0.9).toFixed(3)})`)
  g.addColorStop(0.6, `rgba(170,184,210,${(a * 0.45).toFixed(3)})`)
  g.addColorStop(1, 'rgba(150,165,195,0)')
  ctx.fillStyle = g
  ctx.beginPath()
  ctx.arc(0, 0, rx, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()
}

// 本体の絵を置く横の位置・足元・縦の潰れ (足元を軸)・丈。本体の描画 (drawBossFromSprite) と、紫/赤のオーラの形を焼く
//   2回目の描画 (bakeCurseSilhouette) で同じ物を使う = オーラの縁取りが本体から離れない。
//   2026-10-21: 介錯の執行の一歩 (src/exec_finisher_step.ts) の沈み・潰れ (縦 最大 7.5%) と着地の行き過ぎ (横 8px) が
//   本体にだけ掛かり、オーラの縁が頭の上・背中側へ浮いていた (作者「紫の枠がはずれるタイミングがあった」)。
//   前の版 (オーラは足元・花嫁の寄せ・騎士の上下だけ) = DEV ?auraBodyPose=old。
export function bossBodyDrawPose(b: Boss): {
  stepVisual: ReturnType<typeof executionerStepVisual> | null; squashY: number; bodyX: number; bodyFootY: number; bodyHeight: number
} {
  const bossDisplayHeight = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
  const footY = bossFootY(b)
  const brideLean = brideWindupLean(b)
  const { liftY: knightLiftY, squashY: knightSquashY } = knightMoveBodyPose(b)
  const stepVisual = b.exec?.step
    ? executionerStepVisual(b.exec.step, EXECUTIONER.step, EXECUTIONER.step.styles[b.exec.step.style])
    : null
  // 介錯の一歩の沈み・潰れ (前の版＝DEV ?stepWeight=now・src/exec_step_weight.ts)。前の版は 1 なので騎士の縮みだけが残る。
  const squashY = knightSquashY * (stepVisual?.bodyScaleY ?? 1)
  const bodyX = b.x + brideLean.leanX + (stepVisual?.bodyOffsetX ?? 0) + knightGaitDrawOffsetPx(b)
  const bodyFootY = footY + brideLean.leanY + knightLiftY
  // 溜めの膨らみは本体の絵にだけ効かせる (影・当たり判定・残像・dissolve等は素の bossDisplayHeight のまま)。
  return { stepVisual, squashY, bodyX, bodyFootY, bodyHeight: bossDisplayHeight * bossTelegraphSwell(b) }
}
let auraBodyPoseOld = false
/** DEV ?auraBodyPose=old (game.ts): オーラの形を前の版の置き方 (一歩の沈み・行き過ぎ・溜めの膨らみを入れない) で焼く。見比べ用。 */
export function setAuraBodyPose(raw: string | null): void { auraBodyPoseOld = import.meta.env.DEV && raw === 'old' }

function drawBossFromSprite(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const bossDisplayHeight = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
  // 本体の置き方 (足元は per-boss で少し持ち上げて床ディスクへのめり込みを防ぐ・影は床=b.y+4 に残す)。
  const footY = bossFootY(b)
  const { stepVisual, squashY, bodyX, bodyFootY, bodyHeight: bossBodyHeight } = bossBodyDrawPose(b)
  // 花嫁の回る連撃で体を回す (DEV ?brideSpin=b|bc・10-08 試作・src/bride_spin_fx.ts)。配布版は常に null。
  //   足元の中心 (bodyX) を軸に横幅を cos(θ) でつぶし、背中側の半分は左右反転して暗く。右・交差・左の絵の差し替えはそのまま。
  const brideSpin = b.id === 'bride' && state.phase === 'playing' && brideSpinBodyOn() ? brideSpinClock(b) : null
  const spinScale = brideSpin ? brideSpinBodyScale(brideSpinAngle(brideSpin)) : null
  // 回る途中の絵 (DEV ?brideSpin=ca・10-09)。正面の区間と、絵がまだ読み込めていない間は null (今の絵のまま)。
  const turnClock = b.id === 'bride' && state.phase === 'playing' && brideSpinTurnArtOn() ? brideSpinClock(b) : null
  const turnPick = turnClock ? brideTurnPick(brideSpinAngle(turnClock)) : null
  const turnImg = turnPick ? brideTurnImage(turnPick.art) : null
  const ghostClock = turnClock && brideGhostOn() ? turnClock : null
  if (import.meta.env.DEV && b.id === 'bride') {
    (globalThis as { __brideSpinDebug?: unknown }).__brideSpinDebug = spinScale && brideSpin
      ? { theta: brideSpinAngle(brideSpin), sx: spinScale.sx, back: spinScale.back }
      : turnClock ? { theta: brideSpinAngle(turnClock), turn: turnPick ? `${turnPick.art}${turnPick.mirror ? '-m' : ''}` : 'front' } : null
  }
  let bodyPlacement: BossSpritePlacement | null = null
  const drawBody = (targetCtx: CanvasRenderingContext2D): void => {
    if (import.meta.env.DEV && knightSweepStudyApplies(b)) {
      drawKnightSweepStudy(targetCtx, b, bodyX, bodyFootY, bossDisplayHeight)
      return
    }
    // 剣舞の速い連を模型の影絵で (開発版だけ ?bladeQuickMq=220|300・src/blade_quick_mannequin.ts)。
    if (import.meta.env.DEV && bladeQuickMannequinApplies(b)) {
      drawBladeQuickMannequin(targetCtx, b, bodyX, bodyFootY, bossDisplayHeight)
      return
    }
    if (spinScale) {
      targetCtx.save()
      targetCtx.translate(bodyX, 0)
      targetCtx.scale(spinScale.sx, 1)
      targetCtx.translate(-bodyX, 0)
      const filter = brideSpinBackFilter(spinScale.back)
      if (filter !== 'none') targetCtx.filter = filter
    }
    const squash = squashY !== 1
    if (squash) {
      targetCtx.save()
      targetCtx.translate(0, bodyFootY)
      targetCtx.scale(1, squashY)
      targetCtx.translate(0, -bodyFootY)
    }
    // 回る途中の絵: 正面の絵は見えない下書き面へ描いて置き場所 (丈・裾の高さ) だけ受け取り、その上に回る途中の絵を描く。
    if (turnPick && turnImg) {
      bodyPlacement = drawBossSprite(brideTurnScratchCtx(), b.id, b, state.bossSprite, bodyX, bodyFootY, bossBodyHeight,
        state.time, state.player.state === 'grabbed')
      if (bodyPlacement) {
        if (ghostClock) drawBrideSpinGhosts(targetCtx, b, bodyX, (bodyPlacement as BossSpritePlacement).opaqueRect)
        drawBrideTurnArt(targetCtx, turnPick, turnImg, bodyX, (bodyPlacement as BossSpritePlacement).opaqueRect, b.facing)
        if (squash) targetCtx.restore()
        if (spinScale) targetCtx.restore()
        return
      }
    }
    // 本人の残像 (DEV ?brideWind=ghost・11-02): 正面の向きの間も、少し前の回る途中の絵の残像を体より先に描く。置き場所は下書き面で受け取る。
    if (ghostClock) {
      const p = drawBossSprite(brideTurnScratchCtx(), b.id, b, state.bossSprite, bodyX, bodyFootY, bossBodyHeight,
        state.time, state.player.state === 'grabbed')
      if (p) drawBrideSpinGhosts(targetCtx, b, bodyX, p.opaqueRect)
    }
    bodyPlacement = drawBossSprite(
      targetCtx,
      b.id,
      b,
      state.bossSprite,
      bodyX,
      bodyFootY,
      bossBodyHeight,
      state.time,
      state.player.state === 'grabbed',
      state.phase === 'playing',
    )
    if (squash) {
      targetCtx.restore()
      // Placement consumers see the same outer foot-pivot squash as drawImage.
      if (bodyPlacement) {
        const scaleRect = (r: BossSpritePlacement['imageRect']) => ({ ...r,
          y: bodyFootY + (r.y - bodyFootY) * squashY, height: r.height * squashY })
        bodyPlacement = { ...bodyPlacement, imageRect: scaleRect(bodyPlacement.imageRect),
          opaqueRect: scaleRect(bodyPlacement.opaqueRect),
          pivot: { x: bodyPlacement.pivot.x, y: bodyFootY + (bodyPlacement.pivot.y - bodyFootY) * squashY } }
      }
    }
    if (spinScale) targetCtx.restore()
    // DEV 計測フック (2026-09-27): 本体の描画矩形・向き・回転 = 絵の穂先を世界座標へ戻す唯一の材料。
    //   scripts/probe_reach_vs_sprite.mjs が読む (drawImage の変換行列から逆算すると左右反転とカメラで誤る)。
    if (import.meta.env.DEV) (globalThis as { __bossBodyPlacement?: unknown }).__bossBodyPlacement = bodyPlacement
    lastBossBodyPlacement = bodyPlacement
    // DEV 計測フック (10-21 止めの裂け目の位置): 本体だけのバッファへ描いた時、世界座標の点の本体の alpha (0〜255)。
    //   scripts/probe_exec_crack_position.mjs が読む。主画面へ直接描いた時は背景と混ざるので置かない。
    if (import.meta.env.DEV && targetCtx !== ctx) {
      const m = targetCtx.getTransform()
      ;(globalThis as { __bossBodyAlphaAt?: unknown }).__bossBodyAlphaAt = (x: number, y: number): number => {
        const p = m.transformPoint({ x, y })
        const px = Math.round(p.x), py = Math.round(p.y)
        if (px < 0 || py < 0 || px >= targetCtx.canvas.width || py >= targetCtx.canvas.height) return 0
        return targetCtx.getImageData(px, py, 1, 1).data[3]
      }
    }
  }

  // 致命トドメ: dissolve ビートで本体をフェードアウト、 silence で完全に消す。
  // ボスの可視度: impact=見える / pull=崩れてフェード / dissolve・absorb・silence=消滅済(噴出後)
  // (影 alpha も同じ visibility に揃える必要があるので shadow 描画より前に計算する 2026-06-24)
  // 全ボス共通 (騎士の制御): impact+ホールド=solid → pull で崩れフェード → dissolve 以降は消滅。
  //   本体の溶け時計を DEATH_POSE_HOLD_MS 遅延 = 致命SEの山が引くまで死のポーズを solid で見せる。
  const fElapsedBody = finisherBodyElapsedMs(state)
  const fbeat = state.finisher ? finisherBeat(fElapsedBody) : null
  const dissolveA = !state.finisher ? 1
    : fbeat === 'pull' ? 1 - beatProgress(fElapsedBody)
    : (fbeat === 'dissolve' || fbeat === 'absorb' || fbeat === 'silence') ? 0
    : 1
  // 撃破フェード: sprites.ts の defeatAlpha と同カーブ (1.0s で完全消滅・FX#5 と整合)。
  // finisher を経由しない defeat (HPゼロ直行) もあるので独立に計算。
  // post-battle phase (victory/cleared/interlude/choice/ending/defeat) では
  // updateBossSpriteRuntime が止まり defeatElapsedSec が ~1フレーム分で凍結する=本体が薄い
  // アルファのまま立ち続け、 victory 暗幕越しに「縦長の黒シルエット」として残るバグ
  // (2026-06-24 ユーザー実機発見)。 phase が playing 以外なら強制 0 にして本体・影・outline を
  // 同期消失させる (deathBeat 中は phase=playing なので最期の決め手モーションは保持)。
  const rawDefeatA = b.hp <= 0 ? Math.max(0, 1 - state.bossSprite.defeatElapsedSec / 1.0) : 1
  // 🔵 2026-10-02 AI点検の候補4: 主人公が負けた画面 (defeat) で生きているボスまで消えていた (負けた瞬間にボスがパッと消える)。
  //   負け画面では生きているボスを立たせる (他の画面＝勝利・幕間などは従来どおり強制 0)。
  const defeatA = state.phase === 'playing' || (state.phase === 'defeat' && b.hp > 0) ? rawDefeatA : 0
  // ボス本体の可視度 = この値が 0 になるとボスは完全に消える=影も同期して消す (ボス影バグ修正)。
  const bossVisibility = dissolveA * defeatA

  // 宵渡り (blink=消える / reappear=現れる)。 本体を薄れさせ/浮かび上がらせ、 渦スプライトを上に重ねる。
  //   時間定数は boss.ts の BLINK_OUT_MS(420) / BLINK_REAPPEAR_MS(470) と整合。
  //   介錯の幕2の頭の瞬間移動 (開発版 ?execAct2Open=blink・src/exec_act2_blink.ts) も同じ式で描く。
  const act2Blink = act2BlinkVisual(b)
  const blinkKind = act2Blink ? act2Blink.kind : b.state === 'blink' || b.state === 'reappear' ? b.state : null
  const blinkMs = act2Blink ? act2Blink.elapsedMs : b.stateElapsed * 1000
  const blinking = blinkKind !== null
  let blinkBodyMul = 1   // 本体スプライト/影のフェード倍率
  let blinkSwirlA = 0    // 渦スプライトの additive alpha
  if (blinkKind === 'blink') {
    const p = Math.min(1, blinkMs / 420)
    blinkBodyMul = Math.max(0, 1 - p * 1.35)                       // 本体が解けて消える (渦に先行して薄れる)
    blinkSwirlA = Math.sin(Math.min(1, p * 1.1) * Math.PI) * 0.9   // 渦が立ち上がり→消える
  } else if (blinkKind === 'reappear') {
    const p = Math.min(1, blinkMs / 470)
    blinkBodyMul = Math.max(0, Math.min(1, p * 1.7 - 0.5))         // 渦から本体が遅れて結び直る
    blinkSwirlA = Math.sin(Math.min(1, p * 1.15) * Math.PI) * 0.9  // 渦が結び直って消える
  }

  // 接地影 (元絵には影が描かれていないので Canvas 側で薄く)。
  //   突進牙の跳躍中は「浮いている」ので影を小さく薄く = 空中感を強調 (攻撃判別の補強)。
  //   bossVisibility で本体と同期フェード=撃破後に影だけ居座らない (memory ボス影バグ修正 2026-06-24)。
  let groundShrink = 0
  if (b.currentAttack?.id === 'houndLunge' && b.state === 'active') {
    const l = Math.min(1, (b.stateElapsed * 1000) / b.currentAttack.activeMs)
    const ap = 1 - (1 - l) * (1 - l)            // active easeOut 進行 (sprites.ts の弧と同位相)
    groundShrink = Math.sin(ap * Math.PI)        // 跳躍の頂点で最大 (影が最小)
  }
  // 鶏の宙を使う技 (宙廻り・暁呼び・鳴き挟みの締め): 宙にいる間は高さに合わせて影を小さく薄く (高さ 220 で最小)。
  const roosterChoreo = b.currentAttack?.choreography
  if (roosterChoreo === 'roosterAerialRoam' || roosterChoreo === 'roosterDawnCall' || roosterChoreo === 'roosterCrowDrop' || roosterChoreo === 'roosterCrowFinale') groundShrink = Math.min(1, (b.altitudePx ?? 0) / 220)
  if (bossVisibility > 0.01) {
    const shadowRx = BOSS_SHADOW_RX[b.id] ?? 70   // per-boss 影幅 (裾に合わせる・既定70)
    ctx.save()
    ctx.fillStyle = `rgba(0,0,0,${0.45 * (1 - 0.6 * groundShrink) * bossVisibility * (blinking ? blinkBodyMul : 1)})`
    ctx.beginPath()
    ctx.ellipse(b.x, b.y + 4, shadowRx * (1 - 0.4 * groundShrink), 12 * (1 - 0.4 * groundShrink), 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
    drawRoosterLandingGlow(ctx, b, state.player.x, bossVisibility)
    if (roosterFx() === 'v1' && b.id === 'inverted-jester') drawRoosterStompFx(ctx, b, state.time, b.y + 4)
  }

  // 溜めの予兆は「フラットな紫楕円オーラ」を廃し、 顔の虚無の燃え上がり(drawBossFaceGlow)+
  // ボディランゲージ(bossStateOffset の telegraph 震え)に一本化 (世界観: 虚ろな王が魂を昂らせる)。
  // 旧 drawChargeAura はレガシーボス専用に残置 (CLAUDE.md: テレグラフは体で見せる方針)。

  // スプライト本体 (ソース向きは sprites.ts 内部で処理)。
  //   通常: 薄い暗縁を付けて背景に馴染ませる (バッファ合成)。
  //   死に際 (0<dissolveA<1, finisher pull): 均一フェード(幽霊化)でなく
  //   「冠から崩れて灰になる」= セル単位に欠けていく disintegration (バッファに destination-out)。
  const dissolving = !!state.finisher && dissolveA > 0 && dissolveA < 1
  // 踏み込みの土ぼこり (10-29 作者・src/exec_step_dust.ts)。11-01 から配布版の既定。前の版の写しは DEV ?execStep=ghost。
  const stepDust = execStepFxMode() === 'dust'
  if (stepDust && bossVisibility > 0.01 && stepVisual && b.exec?.step && execStepDustReady()) {
    ctx.save()
    ctx.globalAlpha *= bossVisibility
    drawExecStepDust(ctx, b.exec.step, stepVisual, bodyFootY, bossDisplayHeight)
    ctx.restore()
  }
  // ステップ残像は専用バッファでポーズを単色化し、本体より先に鋼色の薄い影として重ねる。
  if (!stepDust && bossVisibility > 0.01 && stepVisual && stepVisual.ghosts.length > 0 && b.exec?.step) {
    const bufs = getOutlineBuffers('boss-ghost')
    if (bufs) {
      const bctx = bufs.buf.ctx
      for (const ghost of stepVisual.ghosts) {
        resetOutlineBuffer(bctx)
        const ghostPhase = b.exec.step.style === 'shunpo' && b.exec.step.kind !== 'back' ? 'crouch' as const : 'travel' as const
        const ghostBoss: Boss = {
          ...b,
          x: ghost.x,
          exec: { ...b.exec, step: { ...b.exec.step, phase: ghostPhase, elapsedMs: 0 } },
        }
        drawBossSprite(
          bctx,
          ghostBoss.id,
          ghostBoss,
          state.bossSprite,
          ghost.x,
          bodyFootY,
          bossDisplayHeight,
          state.time,
          state.player.state === 'grabbed',
        )
        bctx.save()
        bctx.setTransform(1, 0, 0, 1, 0, 0)
        bctx.globalCompositeOperation = 'source-in'
        bctx.fillStyle = PALETTE.fxSilver
        bctx.fillRect(0, 0, bufs.buf.canvas.width, bufs.buf.canvas.height)
        bctx.restore()
        ctx.save()
        ctx.globalAlpha = ghost.alpha
        drawBufferToWorld(ctx, bufs.buf.canvas)
        ctx.restore()
      }
    }
  }
  // bossVisibility <= 0.01 = 本体は完全消滅 (silence ビート / post-battle phase 凍結対策)。
  // 後者は victory 暗幕越しの「縦長黒シルエット」残留バグ (2026-06-24) を断つ。
  if (dissolveA <= 0 || bossVisibility <= 0.01 || stepVisual?.bodyVisible === false) {
    // 完全消滅: 本体は描かない
  } else if (blinking) {
    // 宵渡り: 本体を倍率フェードで描く (outline バッファは通さない=解け/結び直りに無関係)。
    if (blinkBodyMul > 0.01) {
      ctx.save(); ctx.globalAlpha = blinkBodyMul
      drawBody(ctx)
      ctx.restore()
    }
  } else if (state.finisher && lunaExecPierceOn() && aliceClockMs(state) !== null) {
    const sinceHit = pierceSinceHitMs(aliceClockMs(state)!)
    setBossShakeOverride(pierceBossShake(sinceHit))
    drawPierceBossBody(ctx, drawBody, sinceHit, pierceWound(b, bodyFootY - bossDisplayHeight * 0.36), bossDisplayHeight)
    setBossShakeOverride(null)
  } else if (dissolving) {
    const bufs = getOutlineBuffers('boss')
    if (!bufs) {
      ctx.save(); ctx.globalAlpha = dissolveA
      drawBody(ctx)
      ctx.restore()
    } else {
      const bctx = bufs.buf.ctx
      resetOutlineBuffer(bctx)
      drawBody(bctx)
      // 崩落マスク: ボス矩形をセルに割り、 hash 閾値 + 上ほど先に崩れる(冠から灰へ)。
      const prog = 1 - dissolveA                       // 0(崩れ始め)→1(消滅)
      const bw = bossDisplayHeight * 1.25
      // 崩落マスクも本体と同じ寄せ (bodyFootY/bodyX) = 本体とマスクがズレない。
      const topY = bodyFootY - bossDisplayHeight, leftX = bodyX - bw / 2
      const cell = 7
      bctx.save()
      bctx.globalCompositeOperation = 'destination-out'
      for (let gy = topY; gy < bodyFootY + 4; gy += cell) {
        const yn = Math.max(0, Math.min(1, (gy - topY) / bossDisplayHeight))
        for (let gx = leftX; gx < leftX + bw; gx += cell) {
          const th = hash01(gx * 12.97 + gy * 7.13) * 0.62 + yn * 0.42  // 上=低閾値=先に崩れる
          if (prog > th) {
            const k = Math.min(1, (prog - th) / 0.14)   // セルが柔らかく欠ける
            bctx.globalAlpha = k
            bctx.fillRect(gx, gy, cell, cell)
          }
        }
      }
      bctx.restore()
      drawBufferToWorld(ctx, bufs.buf.canvas)
    }
  } else if (OUTLINE_MODE === 'off') {
    drawBody(ctx)
  } else {
    const bufs = getOutlineBuffers('boss')
    if (!bufs) {
      drawBody(ctx)
    } else {
      const bctx = bufs.buf.ctx
      resetOutlineBuffer(bctx)
      drawBody(bctx)
      compositeWithOutline(ctx, bufs)
    }
  }

  if (state.phase === 'playing' && b.id === 'vigil-knight') {
    knightFloorScrape.sync(b, b, state.time * 1000, bodyPlacement)
  }
  if (state.phase === 'playing' && b.id === 'crowned-king-awoken') awokenHopFx.sync(b, state.time * 1000, bodyPlacement)
  drawKnightSweepTrail(ctx, state, bodyPlacement)
  if (import.meta.env.DEV && bossVisibility > 0) drawPlantedTravelGuide(ctx, state, bodyPlacement)
  if (bossVisibility > 0.01 && !blinking && stepVisual?.bodyVisible !== false) {
    drawCannonFajinCharge(ctx, bodyPlacement, cannonFajinChargeProgress(state), bossVisibility)
    // 10-20 手本 A「刃に宿る紫」: 執行の刃の炎と床の噴き上がり (src/exec_fx.ts・前は ?execFlame=old)。
    drawExecFinisherFlame(ctx, state.boss, bodyPlacement, state.time, ARENA.floorY, bossVisibility)
  }

  // 宵渡りの渦 (黒背景 additive)。 本体に重ねて「光に解ける/結び直る」を見せる。
  if (blinking && blinkSwirlA > 0.01) {
    const img = brideBlinkSwirl()
    if (img) {
      const ar = img.naturalWidth / img.naturalHeight
      const dh = bossDisplayHeight * 1.2    // 渦の裾込みで本体よりやや大きく (実機で要微調整)
      const dw = dh * ar
      ctx.save()
      ctx.globalCompositeOperation = 'lighter'
      ctx.globalAlpha = blinkSwirlA
      ctx.drawImage(img, b.x - dw / 2, footY - dh, dw, dh)
      ctx.restore()
    }
  }

  // 顔の虚無の発光 (このボスの "魂"。 状態で明滅/燃え上がり/消滅)
  // bossVisibility で本体と同期=victory 暗幕中に顔だけ光るのを防ぐ (縦長シルエット fix 2026-06-24)。
  // 宵渡り中 (blinking) は渦が演出を担うので顔グローは出さない (解け/結び直りに浮く)。
  // 体を回している間 (DEV ?brideSpin=b|bc) は、ほぼ正面の時だけ顔の光を出す (斜め〜背中では顔の位置がずれる・見えない)。
  if (dissolveA > 0 && bossVisibility > 0.01 && !blinking && stepVisual?.bodyVisible !== false
    && !(spinScale && spinScale.sx < 0.8) && !(turnPick && turnImg)) {
    drawBossFaceGlow(ctx, state, bossDisplayHeight, bodyPlacement)
  }

  // 予兆途中の剣先発光。本体の上へ重ね、active へ入った瞬間には残さない。
  if (bossVisibility > 0.01 && !blinking && stepVisual?.bodyVisible !== false) {
    drawBossCastFlash(ctx, state, bossDisplayHeight, bossVisibility)
  }

  // 全ボス DEVプロキシ稼働中の明示ラベル: 仮モデルを本番アートと誤認させない。
  //   最終絵が入りプロキシフラグを切れば消える。 本体の頭上に小さく・戦闘の邪魔をしない濃度で。
  if (bossProxyEnabled(b.id) && bossVisibility > 0.01) {
    ctx.save()
    ctx.font = '10px monospace'
    ctx.textAlign = 'center'
    ctx.fillStyle = 'rgba(180,170,200,0.4)'
    ctx.fillText('DEV 仮モデル (proxy)', b.x, footY - bossDisplayHeight - 14)
    ctx.restore()
  }
}

// ===== 裁定C (2026-06-13): 弾けない攻撃 = 体の周りに「赤黒い呪いのオーラ」(全ボス共通の視覚言語) =====
//   旧原則「色UIで答えを出さず見た目で読ませる」は廃止 — 画像切り替えアニメだと突き/掴み/突進が
//   見た目で読み切れないので、 弾けない攻撃だけは赤の確定信号で「弾くな (避ける/見切る)」を教える。
//   ※初稿の SEKIRO「危」漢字は世界観に浮く (2026-06-13 ユーザー指摘) → 体の周りに呪いがにじむオーラへ置換。
//   ⚠️ 厳守: キャラ本体の色・明度・コントラストは変えない (本体スプライトの "下" と "外" にだけ描く)。
//   見た目 = 明るい炎柱でなく「黒煙の中に暗赤色の発光がにじむ呪われた舞台の残響」。 深い赤/黒赤/暗ワインレッド。
//   3層: ①輪郭リム (細い赤・additive・わずかに明滅) ②背面の赤黒い煙 (alpha・ゆっくり上昇・破れた不規則形)
//        ③火の粉と煤 (少量・上昇・時々縦の赤黒い筋)。 全体の発光は控えめ=本体を照らしすぎない。
//   スプライト経路のボスは本体シルエットから本物の輪郭リム/体沿いの煙を作る。
//   手描き経路 (花嫁/亡霊/hollow-actor の前の版) はシルエット非取得 → 体サイズのブロブで近似フォールバック。
//   あべこべ (倒錯の道化) は unblockable を付けないのでここに来ない = 嘘の主題を赤の確定信号で裏切らない。
const CURSE_DEEP = '124,11,20'    // #7a0b14 黒に近い赤 (煙の芯)
const CURSE_MID = '176,24,34'     // #b01822
const CURSE_BRIGHT = '225,58,58'  // #e13a3a (リム/火の粉の明部・少量)
// 深紫チャージオーラ (2026-07-02)。 くすんだ黒紫で LUNAIRE 致命の冴えた紫と明度分離。
//   🔴 「処刑人 C6 用」は無効 (2026-07-28 白紙化)。現在の使い手 = 刑吏「据えの一打」`exec_maulSet`。
//   赤オーラより 30% 光量高い (SEKIRO のパリィ可大技のプレゼンス相当)。
const CHARGE_DEEP = '58,10,90'    // #3a0a5a くすんだ黒紫 (煙の芯)
const CHARGE_MID = '95,32,145'    // #5f2091
const CHARGE_BRIGHT = '160,90,215' // #a05ad7 (リム/明部)

// オーラの強度計算 (0=出さない / 予兆で立ち上がり active 直後にスッと消える)。 behind/front 共通。
//   戻り値の tint: 'curse' = 赤 (弾けない) / 'charge' = 深紫 (パリィ可の充填大技)。
//   'swap' = 紫の技を替える比較版 (DEV ?purpleSwap・src/purple_swap.ts) の時だけ。ボスの致命ではない「深紫の溜め大技」(据えの一打) を
//   弾ける技の色 ('parry') へ写す。ボスの致命の紫 (上の execParry の枝) は替えない。案が無い時は出ない。
export function auraStrength(state: GameState): { k: number, tint: 'curse' | 'charge' | 'swap' } | null {
  const b = state.boss
  const atk = b.currentAttack
  if (!atk || b.hp <= 0) return null
  // Mortar is avoided by positioning; its floor warning carries the cue.
  // Suppress only the body's aura, preserving hazard and defense properties.
  if (atk.id === 'exec_cannonMortar') return null
  // 致命を弾ける仕組み (既定・旧は DEV ?execParry=off・src/exec_parry.ts): 致命の溜めに「弾ける重い一撃」の紫を纏う。
  //   溜めが 0.45〜0.69 秒と短いので、紫は溜めの頭から見え (35%)、当たりへ向けて濃くなる。
  if (execParryEnabled() && (atk.bossFinisher || atk.playerLethal)) {
    // 覚醒王の「灰を食む」(DEV ?awokenDevour): 見せの噛みの間は紫を出さない。本命の溜めの 200ms 目で初めて灯る。
    // 騎士と花嫁の固有の致命 (DEV ?execUnique=1): 歩き去る・寄っていく間は薄く、止まりの入りで一気に濃く、止まりの間は保つ。
    if (b.state === 'telegraph' && atk.uniqueExec) return { k: execUniqueAuraK(atk.uniqueExec, b.stateElapsed * 1000), tint: 'charge' }
    if (b.state === 'telegraph' && atk.devour) {
      const k = awokenDevourAuraK(atk.devour, b.stateElapsed * 1000)
      return k === null ? null : { k, tint: 'charge' }
    }
    // 剣舞の手拍子の致命 (src/blade_finisher_v2.ts・既定・前の版は DEV ?bladeFinisher=v1): 手拍子の間は紫を出さない。V 字に開いた所で灯り、2撃目の当たりまで保つ。
    if (atk.bladeClap && b.state === 'telegraph') {
      const k = bladeClapAuraK(atk.bladeClap, b.stateElapsed * 1000)
      return k === null ? null : { k, tint: 'charge' }
    }
    if (atk.bladeClap && b.state === 'comboGap') return { k: 0.9, tint: 'charge' }
    // 跳び噛みの版の合図「無し」(DEV ?gladiusTell=none): 当たりの瞬間の紫も出さない。
    if (b.state === 'active' && atk.devour && !awokenDevourActiveAura(atk.devour)) return null
    if (b.state === 'telegraph') return { k: 0.35 + 0.65 * telegraphProgress(b), tint: 'charge' }
    if (b.state === 'active') return { k: Math.max(0, 1 - (b.stateElapsed * 1000) / Math.max(1, atk.activeMs) * 2.2), tint: 'charge' }
    return null
  }
  const isCharge = atk.auraTint === 'charge'
  const isCurse = !!atk.unblockable
  if (!isCharge && !isCurse) return null
  const tint: 'curse' | 'charge' | 'swap' = isCharge ? (getPurpleSwap() ? 'swap' : 'charge') : 'curse'
  // Both chase hits are unparryable: keep the warning through the rush and coil.
  // Its owner ends at the second active's end; recovery/interruption must be unlit.
  if (isAwokenChaseStudy(b) && tint === 'curse'
    && (b.state === 'active' || b.state === 'comboGap')) return { k: 1, tint }
  // 連撃の途中 (当たりの間・最後でない当たり) は消さずに濃いまま保つ。
  if (atk.auraHoldThroughCombo && (b.state === 'comboGap'
    || (b.state === 'active' && b.comboHitIndex < (atk.comboHits ?? 1) - 1))) return { k: 1, tint }
  if (b.state === 'telegraph') {
    const p = telegraphProgress(b)
    // charge = ease-in で「力が集まる」感 (前半薄い・後半急激に濃く)。 curse は既存線形。
    const k = isCharge ? p * p : p
    return { k, tint }
  }
  if (b.state === 'active') {
    if (atk.id === 'knightWallCharge') return { k: 0.8, tint }
    const k = Math.max(0, 1 - (b.stateElapsed * 1000) / Math.max(1, atk.activeMs) * 2.2)
    return { k, tint }
  }
  return null
}
// 色パレット選択 (curse or charge)。
function auraPalette(tint: 'curse' | 'charge' | 'swap'): { deep: string, mid: string, bright: string, intensityMul: number } {
  if (tint === 'swap') {
    return { deep: swc('parry', CHARGE_DEEP), mid: swc('parry', CHARGE_MID), bright: swc('parry', CHARGE_BRIGHT), intensityMul: 1.3 }
  }
  if (tint === 'charge') {
    return { deep: CHARGE_DEEP, mid: CHARGE_MID, bright: CHARGE_BRIGHT, intensityMul: 1.3 }  // 赤より 30% 光量高
  }
  return { deep: CURSE_DEEP, mid: CURSE_MID, bright: CURSE_BRIGHT, intensityMul: 1.0 }
}

// このボスがシルエットを焼けるか。 手描き経路 (hollow-actor の前の版) は除外。
//   ※ 花嫁は本番絵スプライト経路化済 (2026-06-14) → 除外を外し、 騎士同様に体の輪郭リム込みで
//      赤黒い呪いオーラを焼く (掴み=unblockable=赤 の世界観共通言語)。
//   ※ 亡霊 (2026-07-05): カスタム描画だがポーズ絵ベース化済 → drawShadeBody で焼ける。
//      旧「フラット楕円リム」フォールバックは画像未ロード時の安全網へ降格 (ユーザー指摘: 騎士は纏う形)。
function curseUsesSilhouette(id: string): boolean {
  if (id === 'nameless-shade') return true
  return hasBossSprite(id) && bossSpriteReady(id) && id !== 'hollow-actor'
}

// オーラ系 (呪い/チャージ) の基準高さ。 亡霊はカスタム描画で BOSS_HEIGHT_RATIO に乗らない
//   (SHADE_H=230 は霧裾込み・実体≈130) → 実体寄りの 150 を使う (グロー半径・煙の立ち上り距離の基準)。
function auraBaseHeight(b: Boss): number {
  if (b.id === 'nameless-shade') return 150
  return PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
}

// 本体シルエットを 'curse' バッファへ焼く (buf=本体ピクセル / silh=flood 塗りつぶしマスク)。
//   ※ drawBossSprite (純スプライト描画・顔glow や cue を含まない) を専用バッファへ流す = 描画順に依存しない。
//   ★2026-07-02: 花嫁の溜め寄せ (brideWindupLean) を本体と同じだけシルエットにも掛ける
//     = オーラが本体からズレて浮かないようにする (掴み後半でオーラだけ元位置に残るバグ対策)。
//   ★2026-07-05: 亡霊は drawShadeBody (姿勢+bob+溜めtension 込み) で焼く = オーラが本体に吸着。
function bakeCurseSilhouette(state: GameState, floodColor: string): OutlinePair | null {
  const b = state.boss
  if (!curseUsesSilhouette(b.id)) return null
  const pair = getOutlineBuffers('curse')
  if (!pair) return null
  const bctx = pair.buf.ctx
  bctx.globalCompositeOperation = 'source-over'
  resetOutlineBuffer(bctx)
  if (b.id === 'nameless-shade') {
    if (!drawShadeBody(bctx, state)) return null   // 画像未ロード → 楕円フォールバックへ
  } else {
    // 本体と同じ置き方 (横・足元・縦の潰れ・丈) で焼く (bossBodyDrawPose・drawBossFromSprite と共用)。
    let pose: { x: number; footY: number; squashY: number; h: number }
    if (auraBodyPoseOld) {
      const { leanX, leanY } = brideWindupLean(b)
      const { liftY, squashY } = knightMoveBodyPose(b)
      pose = { x: b.x + leanX, footY: bossFootY(b) + leanY + liftY, squashY,
        h: PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO) }
    } else {
      const p = bossBodyDrawPose(b)
      pose = { x: p.bodyX, footY: p.bodyFootY, squashY: p.squashY, h: p.bodyHeight }
    }
    const { footY, squashY } = pose
    bctx.save()
    if (squashY !== 1) { bctx.translate(0, footY); bctx.scale(1, squashY); bctx.translate(0, -footY) }
    // 遊んでいる間の絵の差し替え (騎士の足を寄せる絵など・playing が要る) を本体と揃える。渡さないと、致命の溜めの頭で
    //   本体は足を寄せる絵なのに、紫のオーラの形だけ直立の絵になっていた (2026-10-12 src/stun_cut.ts の撮影で見つけた)。
    const placed = drawBossSprite(bctx, b.id, b, state.bossSprite, pose.x, footY, pose.h, state.time, state.player.state === 'grabbed',
      state.phase === 'playing')
    bctx.restore()
    // DEV 計測フック: オーラの形を焼いた置き方 (本体の __bossBodyPlacement と比べる・scripts/measure_exec_aura_fit.mjs)。
    if (import.meta.env.DEV) (globalThis as { __auraBakePlacement?: unknown }).__auraBakePlacement = placed
      ? { opaqueRect: placed.opaqueRect, footY, squashY, t: state.time } : null
  }
  const sctx = pair.silh.ctx
  const W = pair.silh.canvas.width, H = pair.silh.canvas.height
  sctx.setTransform(1, 0, 0, 1, 0, 0)
  sctx.globalCompositeOperation = 'source-over'
  sctx.clearRect(0, 0, W, H)
  sctx.drawImage(pair.buf.canvas, 0, 0)
  sctx.globalCompositeOperation = 'source-in'
  sctx.fillStyle = floodColor
  sctx.fillRect(0, 0, W, H)
  sctx.globalCompositeOperation = 'source-over'
  return pair
}

// 花嫁の裾乱れの「弾ける印」(DEV ?brideWind=bc|ac・11-02・src/bride_spin_fx.ts brideHemFlashK)。
//   回る間の跡は白い布だけにして、紫は溜めの終わりに一度だけ、裾の布そのものを染めて光らせる (輪郭の外へ線を引かない)。
//   本体の絵の縁の内側 (縁から数 px) を濃く、裾の布全体を薄く染め、腰より上へは届かない。
function drawBrideHemFlash(ctx: CanvasRenderingContext2D, state: GameState): void {
  const k = brideHemFlashK(state.boss)
  if (k <= 0.01) return
  const sil = bakeCurseSilhouette(state, `rgb(${swc('parry', '196,160,246')})`)
  const pair = getOutlineBuffers('bride-hem')
  if (!sil || !pair) return
  const acc = pair.buf.ctx, tmp = pair.silh.ctx
  const W = pair.buf.canvas.width, H = pair.buf.canvas.height
  acc.setTransform(1, 0, 0, 1, 0, 0); acc.globalCompositeOperation = 'source-over'; acc.clearRect(0, 0, W, H)
  tmp.setTransform(1, 0, 0, 1, 0, 0)
  // 縁の内側の帯 = 体 − (少しずらした体) を 8 方向ぶん重ねる。
  const o = renderScale() * 5
  for (let d = 0; d < 8; d++) {
    const a = (d / 8) * Math.PI * 2
    tmp.globalCompositeOperation = 'source-over'; tmp.clearRect(0, 0, W, H)
    tmp.drawImage(sil.silh.canvas, 0, 0)
    tmp.globalCompositeOperation = 'destination-out'
    tmp.drawImage(sil.buf.canvas, Math.cos(a) * o, Math.sin(a) * o)
    acc.drawImage(pair.silh.canvas, 0, 0)
  }
  tmp.globalCompositeOperation = 'source-over'
  acc.globalAlpha = 0.5
  acc.drawImage(sil.silh.canvas, 0, 0)
  acc.globalAlpha = 1
  // 裾だけ残す (足元から体の高さの 2割は濃く、5割より上は無し)。
  const b = state.boss
  const h = auraBaseHeight(b)
  const { bodyFootY } = bossBodyDrawPose(b)
  const r = bufferRect(), kk = renderScale() * ARENA.width / r.w
  acc.setTransform(kk, 0, 0, kk, -r.x * kk, -r.y * kk)
  const g = acc.createLinearGradient(0, bodyFootY - h * 0.5, 0, bodyFootY - h * 0.2)
  g.addColorStop(0, 'rgba(0,0,0,0)')
  g.addColorStop(1, 'rgba(0,0,0,1)')
  acc.globalCompositeOperation = 'destination-in'
  acc.fillStyle = g
  acc.fillRect(r.x - 10, r.y - 10, r.w + 20, r.h + 20)
  acc.globalCompositeOperation = 'source-over'
  acc.setTransform(1, 0, 0, 1, 0, 0)
  // 白い布に足し算だけだと白く飛ぶので、先に掛け算で布を紫に染め、その上へ縁の光を足す。
  ctx.save()
  ctx.globalCompositeOperation = 'multiply'
  ctx.globalAlpha = 0.9 * k
  drawBufferToWorld(ctx, pair.buf.canvas)
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = 0.6 * k
  drawBufferToWorld(ctx, pair.buf.canvas)
  ctx.restore()
}

// 【層②】背面の煙 + 沈んだグロー。 drawBoss の "前" に呼ぶ = 本体の背後に出る (本体は上に乗る)。
//   tint 'curse' (赤・弾けない) と 'charge' (深紫・パリィ可の大技) で同一構造・パレット切替。
function drawCurseAuraBehind(ctx: CanvasRenderingContext2D, state: GameState): void {
  const aura = auraStrength(state)
  if (!aura || aura.k <= 0.02) return
  const k = aura.k
  const pal = auraPalette(aura.tint)
  const kk = k * pal.intensityMul  // 光量係数 (charge は 30% 高)
  const b = state.boss
  const t = state.time
  const h = auraBaseHeight(b)
  // 2026-07-02: 花嫁の溜め寄せ (brideWindupLean) を本体と同じだけオーラ位置にも掛ける (掴み後半でオーラだけ元位置に浮く対策)。
  const { leanX, leanY } = brideWindupLean(b)
  const cx = b.x + leanX, footY = bossFootY(b) + leanY, midY = footY - h * 0.5
  const breathe = 0.85 + 0.15 * Math.sin(t * 4.2)   // 0.5〜1.5秒周期のゆっくりした膨らみ

  // 沈んだグロー (黒に近い色の芯)。 alpha blend で控えめに = 本体を照らしすぎない。
  ctx.save()
  const gr = h * (0.5 + 0.1 * k) * breathe
  const g = ctx.createRadialGradient(cx, midY, 0, cx, midY, gr)
  g.addColorStop(0, `rgba(${pal.deep},${0.32 * kk})`)
  g.addColorStop(0.55, `rgba(${aura.tint === 'swap' ? swc('parry', '28,6,50') : aura.tint === 'charge' ? '28,6,50' : '58,6,12'},${0.18 * kk})`)
  g.addColorStop(1, `rgba(${aura.tint === 'swap' ? swc('parry', '10,2,20') : aura.tint === 'charge' ? '10,2,20' : '18,2,6'},0)`)
  ctx.fillStyle = g
  ctx.beginPath(); ctx.ellipse(cx, midY, gr * 0.72, gr, 0, 0, Math.PI * 2); ctx.fill()
  ctx.restore()

  // 介錯の靄 (10-29・src/exec_aura.ts): シルエットの写しと丸い煙の粒の代わりに、靄の絵を体の後ろから立てる。
  //   絵が読めるまでは下の前の版で描く。
  if (execAuraMist(b.id)) {
    preloadExecFxMats()
    if (mistReady()) { drawExecMistAura(ctx, state, k, pal, 'behind'); return }
  }
  // 体沿いの煙: シルエットを上方向へ流しながら拡大コピー (体から立ち上る煙・破れた形)。
  const sil = bakeCurseSilhouette(state, `rgba(${pal.deep},1)`)
  ctx.save()
  ctx.globalCompositeOperation = 'source-over'   // 煙 = alpha blend (明るくしない)
  if (sil) {
    const layers = 5
    for (let i = 1; i <= layers; i += 1) {
      const f = i / layers
      const rise = h * (0.06 + 0.16 * f) * (1 + 0.2 * Math.sin(t * 2 + i))
      const sc = 1 + 0.06 * f + 0.025 * Math.sin(t * 3 + i * 1.7)   // 破れ感 = コピーごとに微ゆれ
      const sway = (hash01(i * 3.1 + Math.floor(t * 1.2)) - 0.5) * h * 0.05 * f
      const a = 0.15 * kk * (1 - f * 0.6) * breathe
      ctx.globalAlpha = a
      ctx.save()
      ctx.translate(cx + sway, footY - rise)
      ctx.scale(sc, sc)
      ctx.translate(-cx, -footY)
      drawBufferToWorld(ctx, sil.silh.canvas)
      ctx.restore()
    }
    ctx.globalAlpha = 1
  }
  // ノイズ煙 blob (破れた幕/亡霊の影のギザギザ感)。 シルエット有無問わず上半身〜頭上に少量。
  for (let i = 0; i < 11; i += 1) {
    const seed = i * 7.13
    const ang = hash01(seed) * Math.PI * 2
    const drift = (t * (0.09 + hash01(seed + 1) * 0.09) + hash01(seed + 2)) % 1   // 0→1 上昇ループ
    const rad = h * (0.16 + hash01(seed + 3) * 0.20)
    const px = cx + Math.cos(ang) * rad * 0.65 + (hash01(seed + 4) - 0.5) * h * 0.08
    const py = midY - drift * h * 0.65 + Math.sin(ang) * rad * 0.35
    const r = h * (0.09 + hash01(seed + 5) * 0.09) * (0.7 + 0.5 * Math.sin(t * 1.5 + i))
    const a = 0.09 * kk * Math.sin(drift * Math.PI)   // 出て消える
    drawGlowDot(ctx, px, py, r, `rgb(${i % 3 === 0 ? pal.mid : pal.deep})`, a)
  }
  ctx.restore()
}

// 【層①+③】輪郭リム (additive・明滅) + 火の粉/煤/縦筋。 drawBoss の "後" に呼ぶ = 体の縁の外側に発光。
//   tint 'curse' (赤・弾けない) と 'charge' (深紫・パリィ可の大技) で同一構造・パレット切替。
function drawCurseAuraFront(ctx: CanvasRenderingContext2D, state: GameState): void {
  const aura = auraStrength(state)
  if (!aura || aura.k <= 0.02) return
  const k = aura.k
  const pal = auraPalette(aura.tint)
  const kk = k * pal.intensityMul
  const b = state.boss
  const t = state.time
  const h = auraBaseHeight(b)
  // 2026-07-02: 花嫁の溜め寄せに追従 (drawCurseAuraBehind と同じ理由)。
  const { leanX, leanY } = brideWindupLean(b)
  const cx = b.x + leanX, footY = bossFootY(b) + leanY, midY = footY - h * 0.5
  const flick = 0.7 + 0.3 * Math.abs(Math.sin(t * 9 + Math.sin(t * 17)))   // わずかな明滅

  // 介錯の靄 (10-29・作者「コードで描いた感」): 輪郭の発光線・火の粉の点・縦の筋を描かず、体の前へ薄い靄を立てる。
  //   前の版は DEV ?execAura=rim。絵が読めるまでは前の版のまま。
  if (execAuraMist(b.id)) {
    preloadExecFxMats()
    if (mistReady()) { drawExecMistAura(ctx, state, k, pal, 'front'); return }
  }

  // 層①: 輪郭リム。 シルエット経路 = 本物の輪郭に沿った細い発光線 (dilate − body の輪っか)。
  const sil = bakeCurseSilhouette(state, `rgba(${pal.bright},1)`)
  if (sil) {
    const ring = getOutlineBuffers('curse-ring')
    if (ring) {
      const rctx = ring.buf.ctx
      const W = ring.buf.canvas.width, H = ring.buf.canvas.height
      rctx.setTransform(1, 0, 0, 1, 0, 0)
      rctx.globalCompositeOperation = 'source-over'
      rctx.clearRect(0, 0, W, H)
      // 輪郭の外側 1〜3px に色を盛る: bright シルエットを 8 方向へ微オフセットで重ねて dilate
      const o = renderScale() * (1.4 + 1.4 * k)
      for (let d = 0; d < 8; d += 1) {
        const a = (d / 8) * Math.PI * 2
        const jitter = 0.6 + hash01(d * 2.3 + Math.floor(t * 8)) * 0.8   // 不規則に揺らす
        rctx.drawImage(sil.silh.canvas, Math.cos(a) * o * jitter, Math.sin(a) * o * jitter)
      }
      // 本体の領域を抜く → 輪郭の "外側だけ" の輪っかが残る (本体の明度は変えない)
      rctx.globalCompositeOperation = 'destination-out'
      rctx.drawImage(sil.buf.canvas, 0, 0)
      rctx.globalCompositeOperation = 'source-over'
      ctx.save()
      ctx.globalCompositeOperation = 'lighter'
      ctx.globalAlpha = (0.5 + 0.35 * k) * flick * pal.intensityMul
      drawBufferToWorld(ctx, ring.buf.canvas)
      ctx.restore()
    }
  } else {
    // フォールバック (手描き経路): 体カプセルの縁をにじませる近似リム。
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = (0.4 + 0.3 * k) * flick * pal.intensityMul
    ctx.lineWidth = 2.5
    ctx.strokeStyle = `rgb(${pal.bright})`
    ctx.shadowColor = `rgb(${pal.mid})`
    ctx.shadowBlur = 12
    const rw = h * 0.26, rh = h * 0.46
    ctx.beginPath(); ctx.ellipse(cx, midY, rw, rh, 0, 0, Math.PI * 2); ctx.stroke()
    ctx.restore()
  }

  // 層③: 火の粉と煤 (少量・上昇) + 時々縦の筋 (古い舞台幕の傷/呪いのノイズ・炎ではない)。
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  for (let i = 0; i < 9; i += 1) {
    const seed = i * 5.77
    const life = (t * (0.18 + hash01(seed) * 0.16) + hash01(seed + 1)) % 1   // 0→1 上昇
    const baseX = cx + (hash01(seed + 2) - 0.5) * h * 0.5
    const px = baseX + Math.sin(t * 1.3 + i) * h * 0.03
    const py = footY - life * h * 1.0
    const a = 0.5 * kk * Math.sin(life * Math.PI)
    const r = h * (0.012 + hash01(seed + 3) * 0.016)
    drawGlowDot(ctx, px, py, r, `rgb(${i % 4 === 0 ? pal.bright : pal.mid})`, a)
  }
  // 縦の筋 (時々・背景へ落ちる傷)
  const streak = hash01(Math.floor(t * 1.7) * 3.3 + 0.5)
  if (streak < 0.4 * k + 0.1) {
    const sx = cx + (hash01(Math.floor(t * 1.7) * 1.1) - 0.5) * h * 0.7
    const sy0 = midY - h * 0.3, sy1 = footY + h * 0.05
    ctx.globalAlpha = 0.22 * kk * flick
    ctx.strokeStyle = `rgb(${pal.deep})`
    ctx.lineWidth = 1.4
    ctx.beginPath(); ctx.moveTo(sx, sy0); ctx.lineTo(sx + (hash01(sx) - 0.5) * 6, sy1); ctx.stroke()
  }
  ctx.restore()
}

// 介錯の靄 (10-29)。体の足元〜胸から靄の絵が立ち上り、ほどけて消える。形4種 × 時間3コマを寿命に合わせて重ねて送る。
//   behind = 濃い色 (pal.deep) で普通に重ねる・大きめ。front = 中間色 (pal.mid) を加算で薄く・体の縁に少しかかる程度。
function drawExecMistAura(
  ctx: CanvasRenderingContext2D, state: GameState, k: number,
  pal: { deep: string, mid: string, bright: string, intensityMul: number }, layer: 'behind' | 'front',
): void {
  const b = state.boss
  const t = state.time
  const h = auraBaseHeight(b)
  const cx = b.x, footY = bossFootY(b)
  const kk = Math.min(1.2, k * pal.intensityMul)
  const behind = layer === 'behind'
  const n = behind ? 7 : 5
  const color = behind ? pal.deep : pal.mid
  for (let i = 0; i < n; i += 1) {
    const seed = i * 4.37 + (behind ? 0 : 50)
    const life = (t * (0.42 + hash01(seed) * 0.22) + hash01(seed + 1)) % 1
    const form = Math.floor(hash01(seed + 2 + Math.floor(t * (0.42 + hash01(seed) * 0.22) + hash01(seed + 1))) * MIST_FORMS)
    const pos = life * MIST_STEPS
    const step = Math.min(MIST_STEPS - 1, Math.floor(pos))
    const frac = pos - step
    const spread = behind ? 0.44 : 0.3
    const x = cx + (hash01(seed + 3) - 0.5) * h * spread + Math.sin(t * 0.9 + i) * h * 0.02
    const baseY = footY - h * (0.05 + hash01(seed + 4) * (behind ? 0.45 : 0.35))
    const y = baseY - life * h * (behind ? 0.42 : 0.3)
    const w = h * (behind ? 0.42 : 0.3) * (0.8 + 0.5 * life)
    const hh = w * 1.5
    const fade = Math.sin(Math.min(1, life * 1.15) * Math.PI)
    const a = (behind ? 0.55 : 0.32) * kk * fade
    const flip = hash01(seed + 5) < 0.5
    const op: GlobalCompositeOperation = behind ? 'source-over' : 'lighter'
    const cur = mistSprite(form, step)
    if (cur) drawMat(ctx, tinted(cur, color), x, y, w, hh, 0.5, 1, a * (1 - frac * 0.6), 0, flip, op)
    const next = step < MIST_STEPS - 1 ? mistSprite(form, step + 1) : null
    if (next) drawMat(ctx, tinted(next, color), x, y, w, hh, 0.5, 1, a * frac, 0, flip, op)
  }
  // 前の層の芯: 明るい色を足元へ1つだけ薄く (溜めが濃いほど灯る)。点や線は描かない。
  if (!behind && k > 0.4) {
    const core = mistSprite(Math.floor(t * 0.7) % MIST_FORMS, 0)
    if (core) drawMat(ctx, tinted(core, pal.bright), cx, footY + h * 0.02, h * 0.5, h * 0.45, 0.5, 1, 0.18 * (k - 0.4) * pal.intensityMul, 0, false, 'lighter')
  }
}

// 処刑人 G11「執行の咆哮」FX (2026-07-03)。 telegraph 中のみ描画。
//   構成 (研究に基づく: SEKIRO/ER/MH/Shadow of Colossus):
//     ① 吸気の pull-in dust (0-800ms) = 周囲の粒子が boss.x へ吸い込まれる (音圧の予兆)
//     ② peak flash (波発火の頭 100ms) = boss シルエットが真っ白に (ER Godfrey 系)
//     ③ 有機的な白い光条 (peak 中) = 太さ/角度不揃いのブラシストローク (放射線 NG)
//     ④ radial dust blast (peak) = 吸い込んだ埃を外へ吐き出す
//     ⑤ 骨白の残り光 (peak 後) = boss 頭上の淡い残塵
//   実装: telegraph phase の boss.stateElapsed から吸気/peak を計算・波の telegraphMs (1200/1500/1800) と同期。
function isPhaseTransitionActive(state: GameState): boolean {
  const b = state.boss
  const atk = b.currentAttack
  return b.state === 'telegraph' && atk?.id === 'executioner_phaseTransition'
}

// peak 強度: 波発火の各時点 (t=1200/1500/1800) で 0→1→0 (100ms) の三角波
function roarPeakIntensity(chargeElapsedMs: number): number {
  // 空気の衝撃波 (既定・旧は DEV ?roarAir=0) は波の出る時刻 (1050/1650/2210) に合わせる。
  const peakTimes = roarAirOn() ? ROAR_AIR.emitMs : [1200, 1500, 1800]
  let peak = 0
  for (const pt of peakTimes) {
    const d = Math.abs(chargeElapsedMs - pt)
    if (d < 100) peak = Math.max(peak, 1 - d / 100)
  }
  return peak
}

// ロア解放強度: 吸気完了直後 (~1050ms) の一発の咆哮 (2026-07-03 追加)。
//   これが「今、咆哮した」の瞬間 = 溜め (windup) と衝撃波を分ける明確な beat。
//   80ms の鋭い立ち上がり → 300ms の減衰。 波1 (1200ms) の直前に山が来る = 咆哮→衝撃波の因果。
function roarReleaseIntensity(chargeElapsedMs: number): number {
  const releaseAt = 1050
  if (chargeElapsedMs < releaseAt - 80) return 0
  if (chargeElapsedMs < releaseAt) return (chargeElapsedMs - (releaseAt - 80)) / 80
  return Math.max(0, 1 - (chargeElapsedMs - releaseAt) / 300)
}

// 歪む音波リング (閉じた円・スタイル 1 空気の歪み + 7 音波)。 boss を囲む同心円が広がる。
//   cx,cy = 中心 / rx,ry = 楕円半径 / wobbleFrac = 半径のゆらぎ割合 (0.05 = 5%歪む) / phase = 時間で流す。
function drawSoundRing(
  ctx: CanvasRenderingContext2D, cx: number, cy: number, rx: number, ry: number,
  wobbleFrac: number, phase: number, color: string, lw: number, alpha: number,
): void {
  ctx.globalAlpha = alpha
  ctx.strokeStyle = color
  ctx.lineWidth = lw
  ctx.beginPath()
  const steps = 54
  for (let i = 0; i <= steps; i += 1) {
    const a = (i / steps) * Math.PI * 2
    const wr = 1 + Math.sin(a * 5 + phase) * wobbleFrac   // 半径に歪みを乗せる (円が震える)
    const px = cx + Math.cos(a) * rx * wr
    const py = cy + Math.sin(a) * ry * wr
    if (i === 0) ctx.moveTo(px, py)
    else ctx.lineTo(px, py)
  }
  ctx.closePath()
  ctx.stroke()
}

function drawRoarFxBehind(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (!isPhaseTransitionActive(state)) return
  const b = state.boss
  const t = state.time
  const elapsedMs = b.stateElapsed * 1000 + act2BlinkRoarCutMs()   // ?execAct2Open=blink は溜めの頭を削った分を足す
  const h = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
  const cx = b.x, footY = bossFootY(b), midY = footY - h * 0.55

  // ① 吸気の pull-in dust (0-1000ms・吸気が徐々に強まる)
  const inhaleProgress = Math.min(1, elapsedMs / 1000)
  const inhaleK = inhaleProgress * inhaleProgress   // ease-in で徐々に強く
  if (inhaleK > 0.05) {
    ctx.save()
    ctx.globalCompositeOperation = 'source-over'
    // 環境の減光 vignette (ボス周辺だけ空気が濃くなる)。
    //   ⚠️ 2026-07-03: 旧 fillRect(cx-3h,…,6h,…) は端で発動すると矩形の縁が見切れた。
    //     全画面フィルに変更 = boss 中心の radial は遠方で一様に暗くなるだけ (継ぎ目なし)。
    const vg = ctx.createRadialGradient(cx, midY, h * 0.3, cx, midY, h * 3.2)
    vg.addColorStop(0, 'rgba(0,0,0,0)')
    vg.addColorStop(0.6, `rgba(0,0,0,${(0.10 * inhaleK).toFixed(3)})`)
    vg.addColorStop(1, `rgba(0,0,0,${(0.24 * inhaleK).toFixed(3)})`)
    ctx.fillStyle = vg
    const srRoar = screenRectInWorld()
    ctx.fillRect(srRoar.x, 0, srRoar.w, ARENA.floorY + 40)

    // 吸引される粒子 (外から中央へ流れる常夜燈の色の粒)
    //   10-30 作者「白い球というか粒みたいなのが吸収するようにボスに集まってるんだけど、これを常夜燈の色にして、もっと量を増やしてください」
    //   → 数は 26 → 72。10-31 作者「集まっている光の粒が常夜燈の色になっていない」= 芯だけの小さな点は加算で白く見えた
    //   → 常夜燈の光の1粒 (src/lamp_mote.ts・芯＋青のにじみ・どこでも同じ大きさ)。前の版 = DEV ?lampMote=old。
    ctx.globalCompositeOperation = 'lighter'
    const roarMoteOld = lampMoteOld()
    for (let i = 0; i < 72; i += 1) {
      const seed = i * 4.71
      const angle = hash01(seed) * Math.PI * 2
      const orbitSpeed = 0.4 + hash01(seed + 1) * 0.5
      // 時間経過で半径が減っていく (吸引運動)
      const cycleT = (t * orbitSpeed + hash01(seed + 2)) % 1
      const startRadius = h * (1.5 + hash01(seed + 3) * 0.8)
      const rad = startRadius * (1 - cycleT * 0.8)
      const px = cx + Math.cos(angle) * rad
      const py = midY + Math.sin(angle) * rad * 0.7
      const size = 1 + hash01(seed + 4) * 1.4
      const alpha = inhaleK * (1 - cycleT) * 0.7
      if (!roarMoteOld) { drawLampMote(ctx, px, py, alpha); continue }
      ctx.globalAlpha = alpha
      ctx.fillStyle = hash01(seed + 5) > 0.6 ? 'rgb(200,226,255)' : 'rgb(150,196,255)'
      ctx.beginPath()
      ctx.arc(px, py, size, 0, Math.PI * 2)
      ctx.fill()
    }
    ctx.restore()
  }

  // ② ロア解放 + 波発火で boss 周辺の淡い白グロー (背面から)。 解放時が最も強い。
  const glowK = Math.max(roarReleaseIntensity(elapsedMs), roarPeakIntensity(elapsedMs) * 0.6)
  if (glowK > 0.05) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = 0.35 * glowK
    const glow = ctx.createRadialGradient(cx, midY, 0, cx, midY, h * 1.2)
    glow.addColorStop(0, 'rgba(255,255,255,0.9)')
    glow.addColorStop(0.5, 'rgba(245,245,248,0.35)')
    glow.addColorStop(1, 'rgba(232,224,216,0)')
    ctx.fillStyle = glow
    ctx.beginPath()
    ctx.ellipse(cx, midY, h * 1.2, h * 1.0, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
  }
}

function drawRoarFxFront(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (!isPhaseTransitionActive(state)) return
  const b = state.boss
  const t = state.time
  const elapsedMs = b.stateElapsed * 1000 + act2BlinkRoarCutMs()   // ?execAct2Open=blink は溜めの頭を削った分を足す
  const h = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
  const cx = b.x, footY = bossFootY(b), midY = footY - h * 0.55
  const headY = footY - h * 0.85   // 咆哮の発生源 = 頭の高さ

  // ★ ロア解放 (~1050ms): 頭から同心の音波リングが空気を歪ませながら広がる (スタイル 1+7)。
  //   「今、咆哮した」の瞬間 = 溜めと衝撃波を分ける beat。 白飛び・扇状光条は使わない。
  const release = roarReleaseIntensity(elapsedMs)
  // 比較版 (DEV ?roarTell=v2 の既定 &roarRing=off): 咆哮の瞬間の輪と頭の光を出さない (線・輪／口から出す物に当たるため)。
  if (release > 0.02 && !(roarAirOn() || (import.meta.env.DEV && roarRingsHidden()))) {
    const cyR = footY - h * 0.5
    const expand = 1 - release   // 0 (解放直後) → 1 (減衰後) で外へ膨らむ
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    // 同心の歪む円 (boss を囲むリングが数重・外へ広がる)
    for (let r = 0; r < 4; r += 1) {
      const rx = h * (0.18 + 0.6 * expand) + r * h * 0.16
      const ry = rx * 0.72
      const wob = 0.05 + r * 0.02
      const phase = t * 7 + r * 1.2
      const a = release * (0.5 - r * 0.1)
      if (a <= 0.02) continue
      const col = r === 0 ? '#ffffff' : (r === 1 ? '#f0ece2' : '#d0c8bc')
      drawSoundRing(ctx, cx, cyR, rx, ry, wob, phase, col, 2.4 - r * 0.4, a)
    }
    // 頭のかすかなグロー (声の源・控えめ)
    ctx.globalAlpha = release * 0.3
    const g = ctx.createRadialGradient(cx, headY, 0, cx, headY, h * 0.55)
    g.addColorStop(0, 'rgba(245,245,248,0.7)')
    g.addColorStop(1, 'rgba(245,245,248,0)')
    ctx.fillStyle = g
    ctx.beginPath()
    ctx.ellipse(cx, headY, h * 0.4, h * 0.4, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
  }

  // 吸気末期の空気の張り (elapsedMs 800-1050 の予兆・ボス周辺が薄く震える)
  const preTense = elapsedMs > 800 && elapsedMs < 1050 ? (elapsedMs - 800) / 250 : 0
  if (preTense > 0.05) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = preTense * 0.18
    const g = ctx.createRadialGradient(cx, midY, h * 0.2, cx, midY, h * 0.75)
    g.addColorStop(0, 'rgba(232,228,220,0.4)')
    g.addColorStop(1, 'rgba(232,228,220,0)')
    ctx.fillStyle = g
    ctx.beginPath()
    ctx.ellipse(cx, midY, h * 0.45, h * 0.7, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
  }
}

// DEV: 判定ボックス可視化 (裁定D・H キーで ON/OFF・本番は import.meta.env.DEV ガードで tree-shake)。
//   「攻撃ごとに実際の判定が絵のどこまで届くか」を目で見て間合いを詰めるための場。
//   - 青帯=弾ける melee (contact後・live) / 赤帯=弾けない melee (contact後・live) /
//     黄帯=まだ無効 (ゾーン予告中、 または melee が contact 前) / 灰帯=消費済み / 実線=判定中 (live)。
//   - 縦線 = boss.x (金) / player.x (水) と、 その距離。 「立ち判定だけ伸びてないか」をここで確認する。
//   melee は攻撃段ごとの authored strike 区間を描く。
//   実判定と同じ combat_geometry.ts strikeWorldInterval を使う。
function drawHitboxesDev(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (!(globalThis as { __showHitboxes?: boolean }).__showHitboxes) return
  const p = state.player
  const b = state.boss
  const top = import.meta.env.DEV && wallHuntGameSample(b) ? p.y - PLAYER_DISPLAY_HEIGHT : ARENA.floorY - 150
  const bot = ARENA.floorY
  ctx.save()
  ctx.font = '10px monospace'
  ctx.textBaseline = 'bottom'
  ctx.lineWidth = 1

  // プレイヤーの攻撃リーチ (attacking 中)
  if (p.state === 'attacking') {
    const reach = p.attackIsCounter ? PLAYER.counterThrustRange : playerAttackReachFor(b.bodyHalfWidthPx)
    ctx.fillStyle = 'rgba(122,255,245,0.14)'
    ctx.fillRect(p.x - reach, top, reach * 2, bot - top)
    ctx.strokeStyle = '#7afff5'
    ctx.strokeRect(p.x - reach, top, reach * 2, bot - top)
    ctx.fillStyle = '#7afff5'
    ctx.fillText(`atk ${reach}`, p.x - reach + 2, top + 11)
  }

  // プレイヤーhurtbox。実判定と同じ [x-width/2, x+width/2] を矩形で表示する。
  const playerHurtX = p.x - PLAYER.width / 2
  ctx.fillStyle = 'rgba(122,255,245,0.08)'
  ctx.fillRect(playerHurtX, top, PLAYER.width, bot - top)
  ctx.strokeStyle = 'rgba(122,255,245,0.95)'
  ctx.strokeRect(playerHurtX, top, PLAYER.width, bot - top)
  ctx.fillStyle = '#7afff5'
  ctx.fillText(`player hurtbox ${Math.round(playerHurtX)}..${Math.round(playerHurtX + PLAYER.width)}`, playerHurtX + 2, top + 11)

  // ボスの各 ActiveHit (melee = authored strike区間 / zone = 凍結帯)。
  //   実判定 (hits.ts isHitCollisionActive) と同じ関数を使う (契約2026-07-16 §C):
  //   見た目 (この debug 帯) と当たり判定が別計算でズレる事故を断つ。
  for (const hit of state.hits) {
    const live = isHitCollisionActive(hit, b)
    const hunt = import.meta.env.DEV && hit.follow === 'boss' ? wallHuntGameSample(b) : undefined
    if (hunt) {
      ctx.fillStyle = hit.consumed ? 'rgba(125,125,135,0.25)' : live ? 'rgba(255,58,110,0.30)' : 'rgba(255,210,80,0.20)'
      drawWallHuntHitMask(ctx, hunt)
      ctx.fillStyle = '#ffffff'
      ctx.fillText(`${hit.attackId} ${hit.consumed ? 'CONSUMED' : live ? 'LIVE' : 'NOT LIVE'}`, hunt.bounds[0], hunt.bounds[1] - 4)
      continue
    }
    let x0: number, x1: number
    // 空気の衝撃波 (既定): 当たるのは左右の前縁 (厚み) だけなので、そこだけ描く。
    if (hit.airWave) {
      const rgb = hit.consumed ? '125,125,135' : (!live ? '255,210,80' : '120,200,255')
      const r = (hit.xEnd - hit.xStart) / 2
      for (const side of [-1, 1]) {
        const f = hit.airWave.originX + side * r
        const a = Math.min(f, f - side * hit.airWave.thicknessPx)
        ctx.fillStyle = `rgba(${rgb},${live ? 0.30 : 0.09})`
        ctx.fillRect(a, top, hit.airWave.thicknessPx, bot - top)
      }
      ctx.fillStyle = `rgb(${rgb})`
      ctx.fillText(`${hit.attackId}:air r=${Math.round(r)}${hit.consumed ? ' [CONSUMED]' : live ? ' [LIVE]' : ' [NOT LIVE]'}`, hit.airWave.originX + r + 2, top + 34)
      continue
    }
    if (hit.follow === 'boss') {
      // 覚醒王の噛みは実判定と同じく、いま描いている絵の口の区間を描く (meleeStrikeNow)。
      const strike = meleeStrikeNow(hit, b)
      if (!strike) continue
      const geo = strikeWorldInterval(hit.anchorX ?? b.x, hit.anchorFacing ?? b.facing, strike)
      x0 = geo.xStart; x1 = geo.xEnd
      const rgb = hit.consumed ? '125,125,135' : (!live ? '255,210,80' : (hit.parryable ? '120,200,255' : '255,58,110'))
      ctx.fillStyle = `rgba(${rgb},${live ? 0.20 : 0.09})`
      ctx.fillRect(x0, top, x1 - x0, bot - top)
      ctx.strokeStyle = `rgba(${rgb},0.9)`
      ctx.strokeRect(x0, top, x1 - x0, bot - top)
      ctx.fillStyle = `rgb(${rgb})`
      const status = hit.consumed ? ' [CONSUMED]' : (live ? ' [LIVE]' : ' [NOT LIVE]')
      ctx.fillText(`${hit.attackId} ${Math.round(strike.localFromPx)}..${Math.round(strike.localToPx)}${hit.mouth ? ' mouth' : ''}${hit.parryable ? ' [P]' : ''}${status}`, x0 + 2, top + 22)
    } else {
      x0 = hit.xStart; x1 = hit.xEnd
      const rgb = hit.consumed ? '125,125,135' : (!live ? '255,210,80' : (hit.parryable ? '120,200,255' : '255,58,110'))
      ctx.fillStyle = `rgba(${rgb},${live ? 0.20 : 0.09})`
      ctx.fillRect(x0, top, x1 - x0, bot - top)
      ctx.strokeStyle = `rgba(${rgb},0.9)`
      ctx.strokeRect(x0, top, x1 - x0, bot - top)
      ctx.fillStyle = `rgb(${rgb})`
      const status = hit.consumed ? ' [CONSUMED]' : (live ? ' [LIVE]' : ' [NOT LIVE]')
      ctx.fillText(`${hit.attackId}:${hit.kind}${status}`, x0 + 2, top + 34)
    }
  }

  // boss.x / player.x の縦線 + 距離
  ctx.strokeStyle = '#ffcf40'
  ctx.beginPath(); ctx.moveTo(b.x, top - 14); ctx.lineTo(b.x, bot); ctx.stroke()
  ctx.strokeStyle = '#7afff5'
  ctx.beginPath(); ctx.moveTo(p.x, top - 14); ctx.lineTo(p.x, bot); ctx.stroke()
  ctx.fillStyle = '#ffffff'
  ctx.fillText(`dist ${Math.round(Math.abs(b.x - p.x))}`, (b.x + p.x) / 2 - 16, top - 3)

  // ボスの「芯」(2026-09-06 便1・§5-3): 判定 (bossCoreHalfWidth) と同じ関数を読む = 表示と判定がズレない。
  //   帯 = boss.x ± 芯半幅 (中心線ぶんの薄い白)。停止線 = boss.x ± (芯半幅+主人公半幅)。
  //   主人公が芯の中に居る tick は帯を濃くする (§4 の「滑り出る」が見えるように)。
  {
    const coreHalf = bossCoreHalfWidth(b)
    const stopGap = coreHalf + BOSS_CORE.playerHalfWidth
    const insideCore = Math.abs(p.x - b.x) < stopGap
    ctx.fillStyle = insideCore ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.10)'
    ctx.fillRect(b.x - coreHalf, top, coreHalf * 2, bot - top)
    ctx.strokeStyle = insideCore ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.5)'
    ctx.strokeRect(b.x - coreHalf, top, coreHalf * 2, bot - top)
    ctx.setLineDash([4, 4])
    ctx.strokeStyle = 'rgba(255,255,255,0.7)'
    ctx.beginPath(); ctx.moveTo(b.x - stopGap, top); ctx.lineTo(b.x - stopGap, bot); ctx.stroke()
    ctx.beginPath(); ctx.moveTo(b.x + stopGap, top); ctx.lineTo(b.x + stopGap, bot); ctx.stroke()
    ctx.setLineDash([])
    ctx.fillStyle = '#ffffff'
    const form = b.exec ? `/${b.exec.held}` : ''
    ctx.fillText(`core ±${coreHalf}${form}`, b.x - coreHalf + 2, top - 3)
  }

  // 今のキーポーズ絵名 (sprites.ts が stash)。 上の判定帯 (=攻撃) と突き合わせて
  //   「攻撃とキーポーズのズレ」を目視で指せる。 攻撃中だけ表示。
  const pose = (globalThis as { __poseNow?: {
    image: string; prev: string | null; blend: number; hitIndex: number; phase: string; progress: number
  } }).__poseNow
  const inAtk = b.state === 'telegraph' || b.state === 'active'
    || b.state === 'comboGap' || b.state === 'beatGap' || b.state === 'recovery'
  if (pose && inAtk) {
    ctx.font = 'bold 11px monospace'
    ctx.fillStyle = '#ffe58a'
    const xf = pose.prev ? `  <=${pose.prev} ${pose.blend}` : ''
    ctx.fillText(`pose: ${pose.image}  [hit${pose.hitIndex} ${pose.phase} ${pose.progress}]${xf}`, b.x - 120, top - 20)
  }

  // 体サイズガイド (tool A・2026-07-11): 正しい身長の「頭頂/足元」ライン。 raised pose (振りかぶり等) を
  //   freeze して、 見えてる頭・足をこのラインに合わせるよう __poseFix['<key>'] を回す → 正しい倍率が出る。
  const bh = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
  const footY = bossFootY(b)
  const headY = footY - bh
  ctx.strokeStyle = 'rgba(90,255,160,0.85)'
  ctx.setLineDash([7, 5])
  ctx.beginPath(); ctx.moveTo(b.x - 160, headY); ctx.lineTo(b.x + 160, headY); ctx.stroke()
  ctx.beginPath(); ctx.moveTo(b.x - 160, footY); ctx.lineTo(b.x + 160, footY); ctx.stroke()
  ctx.setLineDash([])
  ctx.font = 'bold 11px monospace'
  ctx.fillStyle = '#5affa0'
  ctx.fillText('head = 正しい頭頂 (ここに頭を合わせる)', b.x - 158, headY - 4)
  ctx.fillText('feet', b.x - 158, footY + 13)
  ctx.restore()
}

// --- ハウンド (機械獣) ---
// Phase 5.1: telegraph→active 間の動きが連続するように attackPhase で補間
//  - houndBite: 顎 0→8→0 (溜め→噛みつき), 頭 0→-8→+8 (後退→突進)
//  - houndLunge: しゃがみ 0→14→0 (沈む→打ち抜く), 脚と尻尾も同様
function drawHound(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const facingMul = b.facing === 'right' ? 1 : -1
  const chargeProgress = telegraphProgress(b)
  const phase = attackPhase(b)
  const atkId = b.currentAttack?.id ?? ''
  // 覚醒王 (crowned-king-awoken) は王の暴走再演 = 同じ獣のシルエットを流用する。
  //   feral 系の攻撃はモーションの系統で bite/lunge のポーズへマップ。
  const isBite = atkId === 'houndBite' || atkId === 'feralBite' || atkId === 'feralFrenzy'
  const isLunge = atkId === 'houndLunge' || atkId === 'feralRush' || atkId === 'rampage'
    || atkId === 'kingExecutionAwoken'

  ctx.save()
  ctx.translate(b.x, b.y)
  ctx.scale(facingMul, 1)

  const [dx, dy] = bossWiggle(b, state.time)
  // しゃがみ: 突進牙は深く沈んでから打ち抜く、噛みつきは浅め
  const crouch = isLunge ? lerpPhase(phase, 0, 14, 0)
               : isBite ? lerpPhase(phase, 0, 4, -2)  // 噛みつき active は少し伸び上がる
               : 0
  ctx.translate(dx, dy + crouch)

  if (chargeProgress > 0) {
    drawChargeAura(ctx, b, chargeProgress, state.time, 50, 38, -38)
  }

  // 影 (突進準備時は大きく、active で標準に戻る)
  ctx.save()
  ctx.fillStyle = 'rgba(0,0,0,0.4)'
  ctx.beginPath()
  const shadowGrow = isLunge ? lerpPhase(phase, 0, 6, 0) : 0
  ctx.ellipse(0, 2, BOSS.width / 2.2 + shadowGrow, 8, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()

  // 4脚 (突進: 溜めで曲がる → 打ち抜きで伸びる)
  const legTense = isLunge ? lerpPhase(phase, 0, 6, 0) : 0
  strokePath(ctx, PALETTE.houndPlate, 6, () => {
    ctx.moveTo(-32, -38 + legTense); ctx.lineTo(-28, -2)
    ctx.moveTo(-24, -34 + legTense); ctx.lineTo(-32, -2)
    ctx.moveTo(24, -38 + legTense); ctx.lineTo(30, -2)
    ctx.moveTo(16, -36 + legTense); ctx.lineTo(14, -2)
  })

  // 胴体
  fillPath(ctx, PALETTE.houndBody, () => {
    ctx.moveTo(-44, -55); ctx.lineTo(36, -62); ctx.lineTo(48, -52)
    ctx.lineTo(46, -36); ctx.lineTo(28, -32); ctx.lineTo(-40, -34); ctx.lineTo(-48, -48); ctx.closePath()
  })
  strokePath(ctx, PALETTE.houndPlate, 1.5, () => {
    ctx.moveTo(-44, -55); ctx.lineTo(36, -62); ctx.lineTo(48, -52)
    ctx.lineTo(46, -36); ctx.lineTo(28, -32); ctx.lineTo(-40, -34); ctx.lineTo(-48, -48); ctx.closePath()
  })

  // 発光シーム
  ctx.save()
  ctx.shadowColor = telegraphAccentColor(b)
  ctx.shadowBlur = 10
  strokePath(ctx, telegraphAccentColor(b), 1.5, () => {
    ctx.moveTo(-42, -52); ctx.lineTo(0, -60); ctx.lineTo(36, -58)
  })
  strokePath(ctx, telegraphAccentColor(b), 1, () => {
    ctx.moveTo(-20, -55); ctx.lineTo(-20, -65)
    ctx.moveTo(10, -60); ctx.lineTo(10, -68)
  })
  ctx.restore()

  // 頭の動き: 噛みつきは 0 → -8 (retract) → +8 (snap forward)
  //           突進牙は 0 → +4 (前傾) → +10 (打ち抜く)
  const headDx = isBite ? lerpPhase(phase, 0, -8, 8)
               : isLunge ? lerpPhase(phase, 0, 4, 10)
               : 0

  // 上顎 (頭の上半分)
  ctx.save()
  ctx.translate(headDx, 0)
  fillPath(ctx, PALETTE.houndPlate, () => {
    ctx.moveTo(34, -60); ctx.lineTo(60, -56)
    ctx.lineTo(63, -47); ctx.lineTo(36, -47); ctx.closePath()
  })
  strokePath(ctx, telegraphAccentColor(b), 1, () => {
    ctx.moveTo(40, -54); ctx.lineTo(58, -54)
  })
  // 上牙 (telegraph/active 中のみ)
  if (b.state === 'telegraph' || b.state === 'active') {
    fillPath(ctx, PALETTE.houndSpark, () => {
      for (let i = 0; i < 5; i += 1) {
        const tx = 42 + i * 3.5
        ctx.moveTo(tx, -47); ctx.lineTo(tx + 1, -43); ctx.lineTo(tx + 2, -47); ctx.closePath()
      }
    })
  }
  ctx.restore()

  // 下顎: 噛みつきは 0 → 8 (開く) → 0 (噛み締める)
  const jawOpen = isBite ? lerpPhase(phase, 0, 8, 0) : 0
  ctx.save()
  ctx.translate(headDx, jawOpen)
  fillPath(ctx, PALETTE.houndBody, () => {
    ctx.moveTo(36, -47); ctx.lineTo(62, -47)
    ctx.lineTo(58, -34); ctx.lineTo(40, -38); ctx.closePath()
  })
  // 下牙
  if (b.state === 'telegraph' || b.state === 'active') {
    fillPath(ctx, PALETTE.houndSpark, () => {
      for (let i = 0; i < 5; i += 1) {
        const tx = 42 + i * 3.5
        ctx.moveTo(tx, -42); ctx.lineTo(tx + 1, -38); ctx.lineTo(tx + 2, -42); ctx.closePath()
      }
    })
  }
  ctx.restore()

  // 顎を開いている時は口の中の闇を見せる (噛む準備の凶悪さ)
  if (jawOpen > 2) {
    ctx.save()
    ctx.translate(headDx, 0)
    ctx.fillStyle = '#0a0314'
    ctx.beginPath()
    ctx.moveTo(40, -45)
    ctx.lineTo(58, -45)
    ctx.lineTo(55, -45 + jawOpen - 2)
    ctx.lineTo(43, -45 + jawOpen - 2)
    ctx.closePath()
    ctx.fill()
    ctx.restore()
  }

  // 目 (phase で滑らかに: idle 2.2 → telegraph終 4.8 → active終 5.5、impact が最強)
  const eyeColor = bossEyeColor(b)
  const eyeR = lerpPhase(phase, 2.2, 4.8, 5.5)
              + (b.state === 'telegraph' ? Math.sin(state.time * 25) * 1.4 * chargeProgress : 0)
  ctx.save()
  ctx.shadowColor = eyeColor
  // glow 強度も phase で連続: idle 12 → telegraph終 30 → active終 36
  ctx.shadowBlur = lerpPhase(phase, 12, 30, 36)
  fillPath(ctx, eyeColor, () => { ctx.arc(48, -52, eyeR, 0, Math.PI * 2) })
  ctx.restore()

  // 尻尾 (突進: 0 → 14 持ち上げ → 4 振り下ろし)
  const tailLift = isLunge ? lerpPhase(phase, 0, 14, 4) : 0
  strokePath(ctx, PALETTE.houndPlate, 5, () => {
    ctx.moveTo(-46, -52)
    ctx.lineTo(-58, -46 - tailLift)
    ctx.lineTo(-62, -36 - tailLift * 1.5)
  })

  ctx.restore()
}

// --- ハーピー (ネオン羽根) ---
// Phase 5.1: telegraph→active 連続モーション
//  - harpyDive: 浮上 0→24→-8 (高く上がって急降下), 翼たたみ→解放で広げる
//  - featherBurst: 翼を MAX に広げる→解放で前方へ振り下ろす
function drawHarpy(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const facingMul = b.facing === 'right' ? 1 : -1
  const winged = b.state === 'telegraph' || b.state === 'active'
  const chargeProgress = telegraphProgress(b)
  const phase = attackPhase(b)
  const atkId = b.currentAttack?.id ?? ''
  const isDive = atkId === 'harpyDive'
  const isBurst = atkId === 'featherBurst'

  ctx.save()
  ctx.translate(b.x, b.y)
  ctx.scale(facingMul, 1)

  const [dx, dy] = bossWiggle(b, state.time)
  const hover = Math.sin(state.time * 2.2) * 3
  // 浮上量: dive は急上昇→急降下、burst は低め維持、その他は緩い上昇
  const rise = isDive ? lerpPhase(phase, 0, 24, -8)
             : isBurst ? lerpPhase(phase, 0, 6, 0)
             : lerpPhase(phase, 0, 12, 8)
  ctx.translate(dx, dy + hover - 6 - rise)

  if (chargeProgress > 0) {
    drawChargeAura(ctx, b, chargeProgress, state.time, 46, 50, -40)
  }

  // 影 (小さめ)
  ctx.save()
  ctx.fillStyle = 'rgba(0,0,0,0.35)'
  ctx.beginPath()
  ctx.ellipse(0, 14, 40, 6, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()

  // 両翼: phase で滑らかに動く
  //   dive: 36 → 18 (たたむ) → 60 (急降下で開く)
  //   burst: 36 → 86 (大きく広げる) → 40 (振り下ろし、前方に押し出す)
  //   その他: 36 → 50 → 50
  const baseSpan = winged ? 56 : 36
  let wingSpan: number
  if (isDive) {
    wingSpan = lerpPhase(phase, 36, 18, 60)
  } else if (isBurst) {
    wingSpan = lerpPhase(phase, 36, 86, 40)
  } else {
    wingSpan = lerpPhase(phase, 36, baseSpan + 14, baseSpan + 14)
  }
  const wingDrop = winged ? -8 : 4
  fillPath(ctx, PALETTE.houndBody, () => {
    ctx.moveTo(-8, -52)
    ctx.quadraticCurveTo(-wingSpan, -70, -wingSpan - 4, wingDrop)
    ctx.quadraticCurveTo(-30, -38, -8, -38)
    ctx.closePath()
  })
  fillPath(ctx, PALETTE.houndBody, () => {
    ctx.moveTo(8, -52)
    ctx.quadraticCurveTo(wingSpan, -70, wingSpan + 4, wingDrop)
    ctx.quadraticCurveTo(30, -38, 8, -38)
    ctx.closePath()
  })

  // 羽の発光ライン
  ctx.save()
  ctx.shadowColor = telegraphAccentColor(b)
  ctx.shadowBlur = 10
  strokePath(ctx, telegraphAccentColor(b), 1.2, () => {
    for (let i = 0; i < 4; i += 1) {
      const r = 0.3 + i * 0.18
      const lx = wingSpan * r
      ctx.moveTo(-lx * 0.8, -56 + i * 3)
      ctx.lineTo(-lx, wingDrop - 4 + i * 2)
      ctx.moveTo(lx * 0.8, -56 + i * 3)
      ctx.lineTo(lx, wingDrop - 4 + i * 2)
    }
  })
  ctx.restore()

  // 胴体（縦長）
  fillPath(ctx, PALETTE.houndPlate, () => {
    ctx.moveTo(-12, -56); ctx.lineTo(12, -56)
    ctx.lineTo(10, -10); ctx.lineTo(-10, -10); ctx.closePath()
  })
  strokePath(ctx, telegraphAccentColor(b), 1.5, () => {
    ctx.moveTo(-10, -40); ctx.lineTo(10, -40)
    ctx.moveTo(-10, -24); ctx.lineTo(10, -24)
  })

  // 頭 (鳥のクチバシ)
  fillPath(ctx, PALETTE.houndPlate, () => {
    ctx.moveTo(0, -70); ctx.lineTo(8, -68); ctx.lineTo(22, -62)
    ctx.lineTo(8, -56); ctx.lineTo(-8, -56); ctx.closePath()
  })
  // クチバシ
  fillPath(ctx, PALETTE.houndSpark, () => {
    ctx.moveTo(22, -62); ctx.lineTo(34, -60); ctx.lineTo(22, -58); ctx.closePath()
  })

  // 目 (phase で滑らかに発光増大、impact が最強)
  const eyeColor = bossEyeColor(b)
  const eyeR = lerpPhase(phase, 2.0, 4.2, 4.8)
             + (b.state === 'telegraph' ? Math.sin(state.time * 25) * 1.1 * chargeProgress : 0)
  ctx.save()
  ctx.shadowColor = eyeColor
  ctx.shadowBlur = lerpPhase(phase, 10, 26, 32)
  fillPath(ctx, eyeColor, () => { ctx.arc(10, -64, eyeR, 0, Math.PI * 2) })
  ctx.restore()

  // 足 (細い2本)
  strokePath(ctx, PALETTE.houndPlate, 3, () => {
    ctx.moveTo(-5, -10); ctx.lineTo(-8, 10)
    ctx.moveTo(5, -10); ctx.lineTo(8, 10)
  })

  // burst 準備: 翼間に羽根のチャージ粒子が集まる (魔力チャージ感)
  if (isBurst && chargeProgress > 0.2) {
    const particleCount = Math.floor(chargeProgress * 8)
    ctx.save()
    ctx.fillStyle = PALETTE.parrySparkCool
    ctx.shadowColor = PALETTE.parrySparkCool
    ctx.shadowBlur = 12
    for (let i = 0; i < particleCount; i += 1) {
      const angle = (i / 8) * Math.PI * 2 + state.time * 5
      const r = 16 - chargeProgress * 8  // 集まってくる
      const px = Math.cos(angle) * r
      const py = -40 + Math.sin(angle) * r * 0.6
      ctx.globalAlpha = 0.4 + Math.random() * 0.4
      ctx.beginPath()
      ctx.arc(px, py, 1.6, 0, Math.PI * 2)
      ctx.fill()
    }
    ctx.restore()
  }

  ctx.restore()

  // ====== projectile 系攻撃の可視化 (featherBurst の羽根弾) ======
  drawHarpyProjectiles(ctx, state)
}

// 羽根散らし: 翼から飛び散る羽根を扇状に描画。プレイヤーから見て
// 「弾が飛んでくる」のが視覚的に明確になる (パリィ不可だと直感で分かる)
function drawHarpyProjectiles(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  if (b.state !== 'active') return
  const atk = b.currentAttack
  if (!atk || atk.kind !== 'projectile') return

  const dir = b.facing === 'right' ? 1 : -1
  const elapsedMs = b.stateElapsed * 1000
  const progress = Math.min(1, elapsedMs / atk.activeMs)

  // 羽根の起点 (ハーピーの中心やや上)
  const ox = b.x
  const oy = b.y - 56

  ctx.save()
  ctx.shadowColor = PALETTE.parrySparkCool
  ctx.shadowBlur = 10

  const FEATHERS = 7
  for (let i = 0; i < FEATHERS; i += 1) {
    // 扇の角度 (前方-30°〜+30° を均等に)
    const spread = (i / (FEATHERS - 1) - 0.5) * 0.8  // -0.4 〜 0.4 rad
    // 進行に応じて飛距離が伸びる
    const distance = progress * atk.range
    const x = ox + Math.cos(spread) * dir * distance
    const y = oy + Math.sin(spread) * distance - progress * 4  // 少し上方向にも

    // 個別の羽根の透明度 (時間とともにフェード)
    const fade = 1 - progress * 0.3
    ctx.globalAlpha = fade

    // 羽根本体 (細長い楕円)
    ctx.fillStyle = PALETTE.parrySparkCool
    ctx.beginPath()
    ctx.ellipse(x, y, 9, 2.5, spread + (dir < 0 ? Math.PI : 0), 0, Math.PI * 2)
    ctx.fill()

    // 羽根の軸 (細い白線)
    ctx.strokeStyle = PALETTE.textBright
    ctx.lineWidth = 0.8
    ctx.beginPath()
    const ax = Math.cos(spread + (dir < 0 ? Math.PI : 0))
    const ay = Math.sin(spread + (dir < 0 ? Math.PI : 0))
    ctx.moveTo(x - ax * 8, y - ay * 8)
    ctx.lineTo(x + ax * 8, y + ay * 8)
    ctx.stroke()
  }
  ctx.restore()
}

// テレグラフチャージの進行 0-1 (telegraph 中以外は 0)
function telegraphProgress(b: Boss): number {
  if (b.state !== 'telegraph' || !b.currentAttack) return 0
  // 連の拍の溜めの上書きがあればそれで割る (定義の値で割ると、短縮した拍で予告の終わりに満ちきらず当たりで跳ねる・2026-10-10)。
  return Math.min(1, (b.stateElapsed * 1000) / Math.max(1, effectiveChargeMs(b)))
}

// 攻撃モーション全体の連続的な進行度。
//   0       : 待機 (idle/recovery)
//   0 → 1   : telegraph (windup, ease-in: ぐっと溜める)
//   1 → 2   : active (release, ease-out: スパっと振る)
// 体の各部位のポーズを3点間で補間 (pose0 → pose1 → pose2) すれば
// 「予兆 → 攻撃」が連続して動いて見える。
function attackPhase(b: Boss): number {
  if (b.state === 'telegraph' && b.currentAttack) {
    const linear = Math.min(1, (b.stateElapsed * 1000) / Math.max(1, effectiveChargeMs(b)))  // 上書きを含む実効の溜め
    return linear * linear  // easeIn (溜めが終盤で加速)
  }
  if (b.state === 'active' && b.currentAttack) {
    const linear = Math.min(1, (b.stateElapsed * 1000) / b.currentAttack.activeMs)
    return 1 + (1 - (1 - linear) * (1 - linear))  // easeOut (出始めが速い)
  }
  return 0
}

// 3点間ベジエ風の補間: phase 0→1→2 で val0→val1→val2 を辿る
function lerpPhase(phase: number, val0: number, val1: number, val2: number): number {
  if (phase <= 0) return val0
  if (phase <= 1) return val0 + (val1 - val0) * phase
  if (phase <= 2) return val1 + (val2 - val1) * (phase - 1)
  return val2
}

// ボス本体にまとわりつくチャージオーラ
//  - 進行度に応じて明るさ・サイズが増す
//  - パリィ可なら紫、不可なら赤
//  - ボス内側に発光する楕円グロー (UI チップではない)
// ⚠ 規約: この関数は原点(0,0)=ボス中心の座標系で描く (楕円中心 x は常に 0)。
//   呼び出し側は必ず ctx.translate(b.x, b.y) 済の状態で呼ぶこと。 怠ると画面左上に発光が漏れる。
function drawChargeAura(
  ctx: CanvasRenderingContext2D,
  b: Boss,
  progress: number,
  t: number,
  baseRx: number,
  baseRy: number,
  cy: number,
): void {
  const color = telegraphAccentColor(b)
  const alpha = 0.10 + progress * 0.30 + Math.sin(t * 14) * 0.05 * progress
  ctx.save()
  ctx.globalAlpha = Math.max(0, alpha)
  ctx.fillStyle = color
  ctx.shadowColor = color
  ctx.shadowBlur = 14 + progress * 28
  const rx = baseRx + progress * 12
  const ry = baseRy + progress * 8
  ctx.beginPath()
  ctx.ellipse(0, cy, rx, ry, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()
}

// --- 仮面の曲芸師たち (2人組) ---
// Phase 7: 2体の演者を boss.x の左右にそれぞれ配置。連撃時にどちらかが中央へ
function drawAcrobats(ctx: CanvasRenderingContext2D, state: GameState): void {
  const b = state.boss
  const cx = b.x
  const cy = b.y
  const phase = attackPhase(b)
  const inGap = b.state === 'comboGap'
  const hitIndex = b.comboHitIndex
  const atkId = b.currentAttack?.id ?? ''
  const isDance = atkId === 'acrobatDance'

  // 2人の基本位置 (boss.x から ±55 px)
  // Acrobat A (笑顔・白) は左、B (無表情・暗紫) は右
  const SIDE_OFFSET = 55

  // 連撃時に「攻撃する側」が中央に出る:
  //   hit 0: A が中央 (左から飛び込む)、B は元位置
  //   hit 1: B が中央、A は元位置
  // gap 中は両方が元位置に戻る瞬間
  let posA = -SIDE_OFFSET
  let posB = +SIDE_OFFSET
  let aAttacking = false
  let bAttacking = false

  if (isDance) {
    // 二人交差ダンス: telegraph で「広がって」、active で「中央を貫通して入れ替わる」
    // これが連撃時の「中央寄せ」と逆方向の動きで判別の手がかりになる
    if (b.state === 'telegraph') {
      // 広がる動き (-SIDE_OFFSET → -SIDE_OFFSET - 22 など、外側へ)
      const spread = phase * 22
      posA = -SIDE_OFFSET - spread
      posB = SIDE_OFFSET + spread
    } else if (b.state === 'active') {
      // 交差: A は左から右へ、B は右から左へ
      const p = Math.min(1, (phase - 1))
      posA = -SIDE_OFFSET - 22 + p * (SIDE_OFFSET + 22 + SIDE_OFFSET - 22)  // -77 → +33
      posB = SIDE_OFFSET + 22 - p * (SIDE_OFFSET + 22 + SIDE_OFFSET - 22)  // +77 → -33
      aAttacking = true
      bAttacking = true
    } else if (b.state === 'recovery') {
      // 入れ替わったまま少し残り、idle で元位置へ
      posA = SIDE_OFFSET - 10
      posB = -SIDE_OFFSET + 10
    } else if (b.state === 'staggered') {
      posA = -SIDE_OFFSET - 6 + Math.sin(state.time * 60) * 3
      posB = SIDE_OFFSET + 6 + Math.cos(state.time * 60) * 3
    } else {
      posA = -SIDE_OFFSET + Math.sin(state.time * 2.5) * 1.5
      posB = SIDE_OFFSET + Math.sin(state.time * 2.5 + Math.PI) * 1.5
    }
  } else if (b.state === 'telegraph') {
    // テレグラフ中 (通常攻撃): お互いに少し中央寄りに (準備動作)
    const lean = phase * 12
    posA = -SIDE_OFFSET + lean
    posB = SIDE_OFFSET - lean
  } else if (b.state === 'active') {
    // active: 該当ヒットの担当が中央へ
    if (hitIndex === 0) {
      posA = lerpPhase(phase - 1, -SIDE_OFFSET + 12, 0, 0)  // phase は 1-2 で active
      posB = SIDE_OFFSET - 6
      aAttacking = true
    } else {
      posA = -SIDE_OFFSET + 6
      posB = lerpPhase(phase - 1, SIDE_OFFSET - 12, 0, 0)
      bAttacking = true
    }
  } else if (inGap) {
    // gap: 攻撃した側が元位置へ戻り、もう一方が準備
    if (hitIndex === 0) {
      posA = 0
      posB = SIDE_OFFSET - 12
    } else {
      posA = -SIDE_OFFSET + 12
      posB = 0
    }
  } else if (b.state === 'staggered') {
    // よろけ: 2人とも崩れて散らばる
    posA = -SIDE_OFFSET - 6 + Math.sin(state.time * 60) * 3
    posB = SIDE_OFFSET + 6 + Math.cos(state.time * 60) * 3
  } else {
    // idle / recovery: 軽く揺れる
    posA = -SIDE_OFFSET + Math.sin(state.time * 2.5) * 1.5
    posB = SIDE_OFFSET + Math.sin(state.time * 2.5 + Math.PI) * 1.5
  }

  // 描画は両方
  drawAcrobat(ctx, cx + posA, cy, state.time, true, b, phase, aAttacking)
  drawAcrobat(ctx, cx + posB, cy, state.time, false, b, phase, bAttacking)

  // 二人交差ダンス active 中: 中央に X 字のリボン軌跡
  if (isDance && b.state === 'active') {
    drawDanceCrossTrail(ctx, cx, cy, phase - 1, state.time)
  }

  // チャージオーラ (中央に集まる)
  if (phase > 0 && phase < 2) {
    drawChargeAura(ctx, b, telegraphProgress(b), state.time, 50, 50, -36)
  }
}

// 二人交差ダンスの軌跡: 中央に X 字状に伸びるリボン (色違い)
function drawDanceCrossTrail(
  ctx: CanvasRenderingContext2D,
  cx: number, cy: number,
  progress: number, t: number,
): void {
  const reach = 90 + progress * 30
  ctx.save()
  ctx.lineWidth = 5
  ctx.shadowBlur = 18
  // A (ピンク, 左下→右上)
  ctx.strokeStyle = PALETTE.neonPink
  ctx.shadowColor = PALETTE.neonPink
  ctx.globalAlpha = 0.7
  ctx.beginPath()
  ctx.moveTo(cx - reach, cy - 14 + Math.sin(t * 18) * 3)
  ctx.lineTo(cx + reach, cy - 70 + Math.sin(t * 18 + 1) * 3)
  ctx.stroke()
  // B (シアン, 右下→左上)
  ctx.strokeStyle = PALETTE.neonCyan
  ctx.shadowColor = PALETTE.neonCyan
  ctx.beginPath()
  ctx.moveTo(cx + reach, cy - 14 + Math.sin(t * 18 + 2) * 3)
  ctx.lineTo(cx - reach, cy - 70 + Math.sin(t * 18 + 3) * 3)
  ctx.stroke()
  ctx.restore()
}

// 個別の曲芸師: マスク + 体 + リボン + ミニ武器
function drawAcrobat(
  ctx: CanvasRenderingContext2D,
  cx: number, cy: number,
  t: number,
  isLaughing: boolean,
  b: Boss,
  _phase: number,
  isAttacking: boolean,
): void {
  ctx.save()
  ctx.translate(cx, cy)

  // 攻撃中は前傾
  const lean = isAttacking ? -8 : 0
  ctx.translate(0, lean)

  // 影
  ctx.save()
  ctx.fillStyle = 'rgba(0,0,0,0.3)'
  ctx.beginPath()
  ctx.ellipse(0, 2, 26, 5, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()

  // 体 (細身、衣装)
  const bodyColor = isLaughing ? '#e8d8ff' : '#2a1240'  // 白衣装 vs 暗紫
  fillPath(ctx, bodyColor, () => {
    ctx.moveTo(-12, -64)
    ctx.lineTo(12, -64)
    ctx.lineTo(10, -8)
    ctx.lineTo(-10, -8)
    ctx.closePath()
  })

  // 胴体の線 (衣装の縦縞)
  strokePath(ctx, isLaughing ? '#a050ff' : '#7afff5', 1, () => {
    ctx.moveTo(0, -64)
    ctx.lineTo(0, -8)
  })

  // 脚
  strokePath(ctx, PALETTE.houndPlate, 3, () => {
    ctx.moveTo(-5, -8); ctx.lineTo(-7, 10)
    ctx.moveTo(5, -8);  ctx.lineTo(7, 10)
  })

  // 腕 (攻撃時は前に伸ばす)
  const armForward = isAttacking ? 16 : 0
  strokePath(ctx, bodyColor, 3, () => {
    ctx.moveTo(-10, -56); ctx.lineTo(-14 + armForward, -38)
    ctx.moveTo(10, -56);  ctx.lineTo(14 + armForward, -38)
  })

  // 手に持つリボン (色違い)
  const ribbonColor = isLaughing ? PALETTE.neonPink : PALETTE.neonCyan
  strokePath(ctx, ribbonColor, 1.5, () => {
    const handX = 14 + armForward
    const handY = -38
    ctx.moveTo(handX, handY)
    ctx.quadraticCurveTo(handX + 8, handY - 6 + Math.sin(t * 4) * 4, handX + 14, handY + 8)
  })

  // 頭 (球)
  fillPath(ctx, PALETTE.playerSkin, () => {
    ctx.arc(0, -72, 9, 0, Math.PI * 2)
  })

  // 仮面
  const maskColor = isLaughing ? '#ffe060' : '#1c0d2e'  // 黄色い笑顔 vs 暗い無表情
  fillPath(ctx, maskColor, () => {
    ctx.arc(0, -72, 7, 0, Math.PI * 2)
  })
  // 仮面の目
  fillPath(ctx, '#1c0d2e', () => {
    ctx.arc(-2.5, -73, 0.8, 0, Math.PI * 2)
    ctx.arc(2.5, -73, 0.8, 0, Math.PI * 2)
  })
  // 仮面の口 (笑い vs 無表情)
  if (isLaughing) {
    strokePath(ctx, '#1c0d2e', 1, () => {
      ctx.arc(0, -69, 2.5, 0, Math.PI)
    })
  } else {
    strokePath(ctx, '#1c0d2e', 1, () => {
      ctx.moveTo(-2, -69); ctx.lineTo(2, -69)
    })
  }

  // 帽子の小さなボンボン
  fillPath(ctx, ribbonColor, () => {
    ctx.arc(0, -82, 2.5, 0, Math.PI * 2)
  })

  // 攻撃時の光るリボン軌跡
  if (isAttacking) {
    ctx.save()
    ctx.shadowColor = ribbonColor
    ctx.shadowBlur = 14
    strokePath(ctx, ribbonColor, 2.5, () => {
      const startX = 14 + armForward
      const endX = startX + 30
      ctx.moveTo(startX, -44)
      ctx.quadraticCurveTo((startX + endX) / 2, -56, endX, -38)
    })
    ctx.restore()
  }

  // よろけ時の崩れ感
  if (b.state === 'staggered') {
    ctx.save()
    ctx.globalAlpha = 0.6
    ctx.strokeStyle = '#ff5a8a'
    ctx.lineWidth = 1
    ctx.beginPath()
    ctx.moveTo(-8, -36); ctx.lineTo(-12, -28)
    ctx.moveTo(8, -36); ctx.lineTo(12, -28)
    ctx.stroke()
    ctx.restore()
  }

  ctx.restore()
}

// ボスの状態ごとのアニメーションオフセット (telegraph後半震え、staggered乱舞、active前傾、idle呼吸)
function bossWiggle(b: Boss, t: number): [number, number] {
  if (b.state === 'staggered') {
    return [Math.sin(t * 60) * 4, Math.sin(t * 75) * 2]
  }
  if (b.state === 'idle') {
    return [0, Math.sin(t * 2.5) * 1.5]
  }
  if (b.state === 'telegraph') {
    const atk = b.currentAttack
    if (atk) {
      const progress = (b.stateElapsed * 1000) / atk.chargeMs
      if (progress > 0.6) {
        const intensity = (progress - 0.6) / 0.4
        return [(Math.random() * 2 - 1) * intensity * 2.5, 0]
      }
    }
  }
  if (b.state === 'active') {
    const atk = b.currentAttack
    if (atk && !atk.lungeDistance) {
      return [12 * (1 - b.stateElapsed * 1000 / (atk.activeMs ?? 140)), 0]
    }
  }
  return [0, 0]
}

// Phase 4.13: 色での parryable 表現を廃止。
// プレイヤーは「攻撃の動き」(physical / projectile / magic / area) で判断する。
// アクセントカラーは常に紫系で固定。
function telegraphAccentColor(_b: Boss): string {
  return PALETTE.houndSeam
}

function bossEyeColor(b: Boss): string {
  if (b.state === 'staggered') return PALETTE.textDim
  if (b.state === 'active') return PALETTE.houndEye
  return PALETTE.houndEye
}

// テレグラフUIは廃止 (Phase 4.7)。ボスのボディランゲージで予兆を伝える方針へ。

// ============== FX ==============
function drawFx(ctx: CanvasRenderingContext2D, fx: FxEvent[], now: number, boss?: Boss, player?: Player): void {
  // 影抜き (DEV ?counterLook=shadow): 見切り反撃の当たり (counter_burst) を金の全方向の炸裂から、突きの向きへ抜ける銀白の粉へ。
  //   致命の途中の counter_burst (combat.ts の致命1・2撃目) は今のまま。 反撃と同時に出る hit_spark (上半円に散る) は出さない = 全方向に散らさない。
  const shadowCounter = counterLookShadow() && player !== undefined && player.state !== 'executing'
  const counterBurstTimes = shadowCounter ? new Set(fx.filter((f) => f.kind === 'counter_burst').map((f) => f.t)) : null
  const counterDir: 1 | -1 = player?.facing === 'left' ? -1 : 1
  for (const f of fx) {
    const age = now - f.t
    if (age < 0) continue
    if (shadowCounter) {
      if (f.kind === 'counter_burst') { drawCounterBurstShadow(ctx, f.x, f.y, age, counterDir); continue }
      if (f.kind === 'hit_spark' && f.color === 'pink' && counterBurstTimes?.has(f.t)) continue
      if (f.kind === 'perfect_dodge') continue   // 見切りの瞬間は残る影 (drawMikiriShadowLayer) とレイピアの合図で見せる
    }
    // 普段のパリィ「手本」(既定・配布版) は世界の層の最後で描く (draw)。
    // 「毛先の紫」(致命の弾き・DEV ?parryLook=kesaki-default では普段のパリィも。 旧へ戻す DEV ?parryLook=old): 接点の小さな淡い紫だけ。
    if (f.kind === 'parry_spark' && tehonTakes(f)) continue
    if (f.kind === 'parry_spark' && kesakiTakes(f)) drawKesakiContact(ctx, f, kesakiClock(f, now, kesakiHitStop))
    else if (f.kind === 'parry_spark') drawParrySpark(ctx, f.x, f.y, age, f.intensity ?? 1, f.isJust ?? false, bloomShapeFor(f))
    // ab (10-05) は色の抜けた画面の上に色付きで描くので、ここでなく drawParryBreakScreen (世界の層の後) で描く。
    else if (f.kind === 'parry_break') { if (getParryBreakLook() !== 'ab') drawParryBreak(ctx, f.x, f.y, f.dir, age, f.x * 0.13 + f.t * 7) }
    else if (f.kind === 'hit_spark') drawHitSpark(ctx, f.x, f.y, age, f.color)
    else if (f.kind === 'execute_flash') drawExecuteFlash(ctx, f.x, f.y, age)
    else if (f.kind === 'luna_exec') {
      // 3 版目の既定 = C 火花の爆ぜ (src/luna_exec_fx_c.ts)・&lunaExecFx=a = A 光の血煙 (src/luna_exec_fx_v3.ts)・?lunaFinisherNormal=v2 = 10-12 の版
      if (execNormalVariant() !== 'v3') drawLunaExecHit(ctx, f, age)
      else if (execFxLookNow() === 'c') drawLunaExecHitC(ctx, f, age, ARENA.floorY)
      else drawLunaExecHitV3(ctx, f, age, ARENA.floorY)
    }   // 3 版目 = src/luna_exec_fx_v3.ts (比較 ?lunaFinisherNormal=v2)
    // 普段の致命 (配布版 lamp): 10-21 A案 = 刺した点から青白い火花が散る (src/luna_spark_fx.ts)・?lunaNormalFx=ribbon = ほどける光・crack = 10-20 のひび。大きさは止めの光と同じ決め方。
    else if (f.kind === 'luna_crack') drawLunaNormalFx(ctx, { x: f.x, y: f.y, dir: f.dir, ageSec: age,
      scale: boss ? Math.max(0.8, Math.min(1.6, bossDisplayHeightFor(boss.id) / PLAYER_DISPLAY_HEIGHT * 0.7)) : 1,
      floorY: boss ? bossFootY(boss) : ARENA.floorY })
    else if (f.kind === 'perfect_dodge') drawPerfectDodge(ctx, f.x, f.y, age, f.dir)
    else if (f.kind === 'counter_burst') drawCounterBurst(ctx, f.x, f.y, age)
    else if (f.kind === 'guard_spark') drawGuardSpark(ctx, f.x, f.y, age, f.material)
    else if (f.kind === 'parry_down') drawParryDownFlash(ctx, f.x, f.y, age)
    else if (f.kind === 'player_guard_impact') {
      if (getGuardFxLook() === 'img') drawGuardImpactImg(ctx, f.x, f.y, age, f.dir, f.postureRatio)
      else if (getGuardFxLook() === 'a2') drawGuardImpactA2(ctx, f.x, f.y, age, f.dir, f.postureRatio)
      else drawPlayerGuardImpact(ctx, f.x, f.y, age, f.dir, f.postureRatio)
    }
    else if (f.kind === 'boss_execute_impact') drawBossExecuteImpact(ctx, f.x, f.y, age, f.dir)
    else if (f.kind === 'lance_flash') {
      // DEV ?knightThrustFx=star (10-08 比較・src/knight_lance_fx.ts): 胸の前の小さな星 + 突きの向きへの火の粉。
      if (getKnightThrustFx() === 'star') drawLanceStar(ctx, f.x, f.y, age, f.dir)
      else drawLanceFlash(ctx, f.x, f.y, age, f.dir)
    }
    else if (f.kind === 'knight_leap_slash') drawKnightLeapSlash(ctx, f.x, f.y, age, f.dir, f.leapPx ?? 180, f.lungePx ?? 0)
    // 花嫁の回る連撃 (2026-10-05「B 前の半円の糸」): 段の糸はボスに付いて動く (裾乱れは回りながら前へ詰めるため)。
    else if (f.kind === 'veil_slash_arc' && f.spin !== undefined && !f.slam) {
      const ax = boss?.id === 'bride' ? boss.x : f.x
      // DEV ?brideSpin=c|bc (10-08 試作): 前の半円の糸の代わりに、向いている側だけの紫の三日月の膜 (src/bride_spin_fx.ts)。
      //   10-09 から、三日月から続いて体の周りを一周する細い紫の帯も出る (体の層で描く・?brideVeil=front で帯なし)。
      if (brideSpinLayersOn()) drawBrideSpinVeil(ctx, ax, f.y, age, f.dir, f.spin, Math.round(f.t * 1000) + f.spin * 131)
      else drawBrideThreadSweep(ctx, ax, f.y, age, f.dir, f.spin, Math.round(f.t * 1000) + f.spin * 131)
    }
    else if (f.kind === 'veil_slash_arc') {
      // DEV ?brideWind=bc|ac (11-02): だんは紫の縦の弧の代わりに白い布の大きい三日月 (絵が読めていない間は前の弧)。
      if (!(f.slam && boss?.id === 'bride' && drawBrideSlamCloth(ctx, boss.x, f.y, age, f.dir))) {
        drawVeilSlashArc(ctx, f.x, f.y, age, f.dir, f.slam ?? false, f.spin)
      }
    }
    else if (f.kind === 'rampage_contact') drawRampageContact(ctx, f.variant, f.x, f.y, f.dir, age, f.t * 91.7 + f.x)
    else if (f.kind === 'downswing_arc') drawDownswingArc(ctx, f.x, f.y, age, f.dir, f.tone)
    else if (f.kind === 'step_gust') drawStepGust(ctx, f.x, f.y, age, f.dir, f.lengthPx, f.mode)
    else if (f.kind === 'knight_lunge_dust') drawKnightLungeDust(ctx, f, age)
    else if (f.kind === 'exec_parry_glow') { if (!execParryFxNew()) drawExecParryGlow(ctx, f, age) }  // 既定 (10-14) は金の光を出さない
    else if (f.kind === 'knight_sweep_scrape') drawKnightSweepScrape(ctx, f, age)
  }
}

// 請われぬ介錯の前進ステップ。足元の砂煙は220ms、腰〜胸の風筋は110msで消える。
// 右向きの局所座標だけを書き、ctx.scale(dir, 1) で必ず鏡像にする。
// 瞬歩の通り道の風を、筆で掃いた絵で描く (11-01 作者の答え step = drawn で配布版の既定)。
//   振りのぶれの絵 (public/fx/exec/mats/swing_sweep_*) を通り道の長さに寝かせ、鉄の灰色で普通に重ねる (光らせない)。
function drawStepWindBrush(ctx: CanvasRenderingContext2D, age: number, windDirection: number, spanPx: number): void {
  const life = 0.16
  if (age > life || !swingReady()) return
  const t = age / life
  const frame = Math.min(3, Math.floor(t * 4))
  const img = swingSprite('sweep', frame)
  if (!img) return
  const fade = 1 - t * t
  const streaks = [
    { y: -96, h: 34, len: 0.95, a: 0.42 },
    { y: -138, h: 24, len: 0.72, a: 0.30 },
  ]
  for (const sp of streaks) {
    const w = spanPx * sp.len
    // 絵の掃き先 (右) が進む向き。通り道の始まり (x=0) から先へ置く。
    drawMat(ctx, tinted(img, '138,144,156'), 0, sp.y, w, sp.h, 0, 0.5, sp.a * fade, 0, windDirection < 0)
  }
}

function drawStepGust(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number, lengthPx: number,
  mode: 'behind' | 'path',
): void {
  const dustLife = 0.22
  if (age > dustLife) return

  ctx.save()
  ctx.translate(x, y)
  ctx.scale(dir, 1)

  // 足元から進行方向の逆へ、低い楕円の砂煙を一歩の60%ぶん残す。
  const dustT = Math.min(1, age / dustLife)
  const dustFade = (1 - dustT) * (1 - dustT)
  const dustGrow = 0.25 + 0.75 * Math.min(1, age / 0.04)
  // 🔵 2026-08-23: 一歩が短い時 (最小40px) でも痕跡が読めるように下限を敷く。
  //   敷かないと砂煙の幅が12px・風の筋が37pxまで縮んで、実機でほぼ見えない (ラボで実測)。
  const spanPx = Math.max(lengthPx, 78)
  const dustRadiusX = spanPx * 0.3 * dustGrow
  // 11-02 比較版 DEV ?execStepGlow=off: この銀の光る楕円を出さない (src/exec_look_1101.ts)。
  ctx.globalAlpha = execStepGlowOn() ? 0.34 * dustFade : 0
  ctx.fillStyle = PALETTE.fxSilver
  ctx.shadowColor = PALETTE.fxSilver
  ctx.shadowBlur = 8 * dustFade
  ctx.beginPath()
  ctx.ellipse(-dustRadiusX, -5, dustRadiusX, 5 + 7 * dustGrow, -0.04, 0, Math.PI * 2)
  ctx.fill()

  // 腰〜胸の風筋。11-01 作者「白いニョロニョロ…安っぽいコードで書いたのが丸わかり」。既定 = 筆の絵 (src/exec_look_1101.ts)。
  //   既定 = 筆で掃いた絵 (振りのぶれの絵) を通り道に寝かせて置く・?execStepWind=off = 消す・?execStepWind=old = 前の白い筋。
  const wind = execStepWind()
  if (wind === 'drawn') drawStepWindBrush(ctx, age, mode === 'path' ? 1 : -1, spanPx)
  ctx.globalCompositeOperation = 'lighter'
  const windLife = 0.11
  if (wind === 'old' && age <= windLife) {
    const windT = age / windLife
    const windFade = (1 - windT) * (1 - windT)
    const arcSpecs = [
      { y: -82, bend: 13, length: 0.92, width: 3.8, alpha: 0.34 },
      { y: -116, bend: -10, length: 1.00, width: 3.0, alpha: 0.30 },
      { y: -148, bend: 8, length: 0.78, width: 2.2, alpha: 0.24 },
    ]
    ctx.lineCap = 'round'
    ctx.strokeStyle = PALETTE.fxSilver
    ctx.shadowBlur = 5 * windFade
    const windDirection = mode === 'path' ? 1 : -1
    for (const spec of arcSpecs) {
      const arcLength = spanPx * spec.length
      const point = (u: number) => ({
        x: windDirection * arcLength * u,
        y: spec.y + Math.sin(Math.PI * u) * spec.bend,
      })
      const segments = 8
      for (let i = 0; i < segments; i += 1) {
        const u0 = i / segments
        const u1 = (i + 1) / segments
        const p0 = point(u0)
        const p1 = point(u1)
        ctx.globalAlpha = spec.alpha * windFade * (1 - u0 * 0.65)
        ctx.lineWidth = spec.width * (1 - u0 * 0.78)
        ctx.beginPath()
        ctx.moveTo(p0.x, p0.y)
        ctx.quadraticCurveTo((p0.x + p1.x) / 2, point((u0 + u1) / 2).y, p1.x, p1.y)
        ctx.stroke()
      }
    }
  }

  ctx.restore()
}

// 主人公の受け専用: 金属の反射でなく、衝撃を身体の内へ飲み込み損ねた冷紫の圧潰粒子。
export function drawPlayerGuardImpact(ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number, postureRatio: number): void {
  // 受けた瞬間で「まだ保つ / もう保たない」を語る (2026-07-20 案1)。
  //   SEKIRO も弾き=明るい火花 / ただのガード=小さく鈍い揺らぎ、と**瞬間の質**で読ませている。
  //   体幹が低い = 鋭く散って短く消える (弾き返せている)
  //   体幹が高い = 散らずに潰れ、鈍く濁って長く尾を引く (受け止めきれていない)
  const strain = postureRatio * postureRatio * (3 - 2 * postureRatio)
  const life = 0.26 + strain * 0.14        // 高いほど余韻が残る = 重い
  if (age < 0 || age >= life) return
  const u = age / life
  const fade = (1 - u) * (1 - u)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  // 前から押し込まれた光が、胸元から下と後方へこぼれる。金/放射線/リングは使わない。
  for (let i = 0; i < 18; i += 1) {
    const seed = 910 + i * 7.7
    const frontBias = 0.25 + hash01(seed) * 0.75
    // 高体幹ほど飛距離が縮む = 散れずにその場で潰れる。
    const travel = (8 + hash01(seed + 1) * 34) * (0.25 + u * 1.1) * (1 - strain * 0.45)
    const px = x - dir * travel * frontBias + (hash01(seed + 2) - 0.5) * 20
    const py = y + (hash01(seed + 3) - 0.25) * 42 + u * (10 + hash01(seed + 4) * 24)
    const color = hash01(seed + 5) < strain ? '#8a6f9d' : '#c5efff'
    // 低体幹は小さく鋭く、高体幹は大きく鈍い。
    const r = (2.4 + hash01(seed + 6) * 4.5) * (1 + strain * 1.1)
    glowMote(ctx, px, py, r, color, fade * ((0.34 - strain * 0.10) + hash01(seed + 7) * 0.42))
  }
  ctx.restore()
}

// 槍突き接触閃光 (A-lite 2026-06-15 visual-only)。 冷たい銀の横一閃 + 芯閃光。 additive 合成。
function drawLanceFlash(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number,
): void {
  if (age > 0.18) return
  const t = age / 0.18
  const a = (1 - t) * (1 - t)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  // 横一閃: dir 方向へ伸びる短い線 (槍の軌跡)
  const len = 55 + 20 * (1 - t)
  const grd = ctx.createLinearGradient(x, y, x + dir * len, y)
  grd.addColorStop(0, `rgba(220,235,255,${a * 0.9})`)
  grd.addColorStop(0.6, `rgba(180,210,255,${a * 0.5})`)
  grd.addColorStop(1, 'rgba(0,0,0,0)')
  ctx.strokeStyle = grd
  ctx.lineWidth = 3 * a
  ctx.shadowColor = '#c8dcff'
  ctx.shadowBlur = 8 * a
  ctx.beginPath()
  ctx.moveTo(x, y)
  ctx.lineTo(x + dir * len, y)
  ctx.stroke()
  // 芯閃光: 命中点に小さい輝点
  ctx.globalAlpha = a * 0.7
  ctx.fillStyle = '#eaf3ff'
  ctx.shadowColor = '#b0ccff'
  ctx.shadowBlur = 14
  ctx.beginPath()
  ctx.arc(x, y, 4 * (1 - t * 0.5), 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()
}

// 石突の金具が床に着く画素 (lanceButt_slam の絵・alpha>16 の下端)。石突の割れ目 (DEV ?knightButtFx=crack) の起点。
export const KNIGHT_BUTT_CAP_SRC = { x: 98, y: 884 }
function knightButtImpactX(state: GameState, hz: ActiveHit): number {
  const b = state.boss
  const dir = hz.originDir ?? (b.facing === 'right' ? 1 : -1)
  const anchorX = b.id === 'vigil-knight' && b.currentAttack?.id === 'lanceButt' ? b.x : (hz.originX ?? b.x)
  const placement = loadedBossSpriteArtPlacement('vigil-knight', 'lanceButt_slam' as SpriteKey, anchorX,
    ARENA.floorY - (BOSS_FOOT_LIFT['vigil-knight'] ?? 0), bossDisplayHeightFor('vigil-knight'), dir < 0 ? 'left' : 'right')
  const p = placement ? projectBossSpriteSourcePoint(placement, [KNIGHT_BUTT_CAP_SRC.x, KNIGHT_BUTT_CAP_SRC.y]) : null
  return p?.x ?? anchorX + dir * 20
}

// Authored source pixel (alpha>16), projected with rectFor's loaded-image placement.
export const KNIGHT_LEAP_TIP_SRC = { x: 280, y: 307 }
export function knightLeapSlashEnd(anchorX: number, floorY: number, dir: number): { x: number; y: number } | null {
  const placement = loadedBossSpriteArtPlacement('vigil-knight', 'leap_swing', anchorX,
    floorY - (BOSS_FOOT_LIFT['vigil-knight'] ?? 0), bossDisplayHeightFor('vigil-knight'), dir < 0 ? 'left' : 'right')
  return placement ? projectBossSpriteSourcePoint(placement, [KNIGHT_LEAP_TIP_SRC.x, KNIGHT_LEAP_TIP_SRC.y]) : null
}
function drawKnightLeapSlash(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number, leapPx: number, lungePx: number,
): void {
  const ageMs = age * 1000
  const sweepMs = 90
  const tip = knightLeapSlashEnd(x, y, dir)
  if (!tip) return
  // 'sweep' (DEV) = ここでは描かない (払いは薙ぎの絵 → 薙ぎの弧が drawBossContactSmear で出る・src/knight_spear_trail.ts)。
  //   DEV `?knightLeapFx=trail` = 槍の軌跡の帯 (10-01 の弧 C)・`crescent` = 槍の弧＋剣圧の三日月 (09-30)。
  if (getKnightLeapFx() === 'sweep') return
  if (getKnightLeapFx() === 'arc') {
    // 既定 (10-02 ユーザー選択「A 手前を回る浅い弧」・src/knight_cross_arc.ts): 騎士と一緒に動き、穂先より前へ出ない。
    const bodyX = x + dir * knightCrossForwardPx(Math.max(0, ageMs), lungePx, leapPx)
    drawKnightCrossArc(ctx, bodyX, tip.y + knightCrossLiftY(Math.max(0, ageMs)), dir, getAttack('lanceCross').strike?.localToPx ?? 0, ageMs)
    return
  }
  if (getKnightLeapFx() === 'trail') {
    // 帯は跳び下がる騎士の体と一緒に動き、穂先より前へ出ない (10-01「どうしても前にエフェクトが出ていってるように見える」)。
    const bodyX = x + dir * knightCrossForwardPx(Math.max(0, ageMs), lungePx, leapPx)
    // 高さも本体の浮きに合わせる (跳びの間に穂先が上がるのに帯だけ下に残らない)。
    drawKnightSpearTrail(ctx, x, tip.y + knightCrossLiftY(Math.max(0, ageMs)), dir, getAttack('lanceCross').strike?.localToPx ?? 0, ageMs, bodyX)
    return
  }
  if (ageMs < 0 || ageMs > sweepMs + SMEAR_FADE_MS) return
  const px = x - dir * 8
  const py = tip.y
  const r = Math.abs(px - tip.x)
  const a0 = dir < 0 ? -Math.PI / 3 : Math.PI - (-Math.PI / 3)
  const a1 = dir < 0 ? -Math.PI : Math.PI - (-Math.PI)
  const sweep = Math.min(1, ageMs / sweepMs)
  const p = sweep * sweep
  const q = Math.max(0, (ageMs - sweepMs) / SMEAR_FADE_MS)
  const fade = (1 - q) * (1 - q)
  const k = Math.max(1, Math.round(p * SMEAR_SWEEP_N))
  const pts = Array.from({ length: k + 1 }, (_, i) => {
    const a = a0 + (a1 - a0) * (i / k) * p
    return { x: px + Math.cos(a) * r, y: py + Math.sin(a) * r }
  })
  const inner = pts.map(pt => ({ x: pt.x + (px - pt.x) * 0.45, y: pt.y + (py - pt.y) * 0.45 }))
  ctx.save()
  drawContactSmearSweep(ctx, pts, inner, SMEAR_SWEEP_N, fade)
  const band = knightLeapPressureCrescent(x, py, dir, r, p)
  if (band) drawKnightLeapPressure(ctx, band.outer, band.inner, fade)
  ctx.restore()
}

// 剣圧の三日月 (2026-09-30 ユーザー選択「範囲を広げてエフェクトで」「弧の外側に剣圧の三日月」):
//   跳び下がり薙ぎの当たりは薙ぎの剣先と同じ 185px (attacks.ts lanceCross) だが、踏み込まない槍の穂先は約 115px まで。
//   その差を、槍の弧の後半 (最後の 60°) の外側に重ねた三日月で見せる。外縁は当たりの前端まで届き、
//   振り切った瞬間の最前点 = 跳び始めの位置 + 前へ当たりの前端 (当たりと同じく跳び始めの位置に残る)。
//   三日月の厚みは尾 (上) で 0・前端で最大 (外縁は一定半径)。前端を尖らせると当たりの端が細い点になって
//   見えないため (09-30 実画面で確認)、前端は太い切り口にして「ここまで届く」を見せる。p = 槍の弧の掃き進み (0..1)。
const KNIGHT_PRESSURE_SPAN_RAD = Math.PI / 3
const KNIGHT_PRESSURE_THICK_PX = 30
export function knightLeapPressureCrescent(
  anchorX: number, tipY: number, dir: number, spearRadius: number, p: number,
): { outer: { x: number; y: number }[]; inner: { x: number; y: number }[] } | null {
  const reach = getAttack('lanceCross').strike?.localToPx ?? 0
  const px = anchorX - dir * 8
  const R = reach + 8
  if (R <= spearRadius) return null
  // 槍の弧と同じ角度の取り方 (a0 = 後ろ上 → a1 = 前の水平)。三日月は a1 の手前 60° から a1 まで。
  const a0 = dir < 0 ? -Math.PI / 3 : Math.PI + Math.PI / 3
  const a1 = dir < 0 ? -Math.PI : 2 * Math.PI
  const as = a1 - Math.sign(a1 - a0) * KNIGHT_PRESSURE_SPAN_RAD
  const swept = a0 + (a1 - a0) * p
  const u1 = (swept - as) / (a1 - as)
  if (u1 <= 0) return null
  const n = 14
  const outer: { x: number; y: number }[] = []
  const inner: { x: number; y: number }[] = []
  for (let i = 0; i <= n; i += 1) {
    const u = (i / n) * Math.min(1, u1)
    const a = as + (a1 - as) * u
    const w = Math.min(R - spearRadius, KNIGHT_PRESSURE_THICK_PX) * Math.sin(Math.PI / 2 * u)
    outer.push({ x: px + Math.cos(a) * R, y: tipY + Math.sin(a) * R })
    inner.push({ x: px + Math.cos(a) * (R - w), y: tipY + Math.sin(a) * (R - w) })
  }
  return { outer, inner }
}
function drawKnightLeapPressure(
  ctx: CanvasRenderingContext2D, outer: { x: number; y: number }[], inner: { x: number; y: number }[], fade: number,
): void {
  if (fade <= 0 || outer.length < 2) return
  ctx.globalCompositeOperation = 'lighter'
  ctx.globalAlpha = 0.3 * fade
  ctx.fillStyle = PALETTE.fxSilver
  ctx.shadowColor = PALETTE.fxSilver
  ctx.shadowBlur = 12 * fade
  ctx.beginPath()
  ctx.moveTo(outer[0]!.x, outer[0]!.y)
  for (let i = 1; i < outer.length; i += 1) ctx.lineTo(outer[i]!.x, outer[i]!.y)
  for (let i = inner.length - 1; i >= 0; i -= 1) ctx.lineTo(inner[i]!.x, inner[i]!.y)
  ctx.closePath()
  ctx.fill()
  // 外縁 = 当たりの前端の線。先へ行くほど濃く。
  for (let i = 0; i < outer.length - 1; i += 1) {
    const seg = (i + 1) / (outer.length - 1)
    ctx.globalAlpha = fade * (0.08 + 0.4 * seg)
    ctx.strokeStyle = PALETTE.fxSilver
    ctx.lineWidth = 1.5 + 2.5 * seg
    ctx.beginPath()
    ctx.moveTo(outer[i]!.x, outer[i]!.y)
    ctx.lineTo(outer[i + 1]!.x, outer[i + 1]!.y)
    ctx.stroke()
  }
}

// 縦の振り下ろし弧 ＋ 足元の横炸裂。
//   2026-07-10 に花嫁の「裾乱れ」最後の一撃 (veil_slash_arc の slam) として作った描画を、
//   2026-08-20 に共通部品へ引き上げた。理由は当時と同じ =「静止絵hold+スメア無しで
//   判定が無モーションで来る」問題の可視化。介錯の振り下ろしが同じ症状だった。
//
// 2026-08-20 (Fable): tone で**枝ごと**分ける。
//   veil = 花嫁の従来描画そのまま (1pxも変えない。下の後半ブロック)。
//   steel = 介錯の体格 (刃先が接地から約320px上→前方約150pxへ落ちる。_確認用/73_arc_probe) に
//     合わせて別形状。楕円ストロークではなく**刃先の通り道 (2次ベジェ) に沿った三日月スメア**。
//     接触 (active 0.35 = 66.5ms。boss_pose_timeline の contact と同期) までに弧を掃き切り、
//     足元の炸裂は**接触後にだけ**出す = 当たる瞬間に手応えが同期する。
//   ⚠️ 呼び出し側は x にボスの**着地位置 (lungeTargetX)** を渡す (game.ts)。boss.x だと
//     踏み込みで弧が置き去りになる。
//   鏡像: steel は ctx.scale(-1,1)。veil は従来どおり鏡像なし (据え置き。docs/backlog.md・旧 sweep-queue)。
type DownswingArcTone = 'veil' | 'steel'
function drawDownswingArc(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number,
  tone: DownswingArcTone,
): void {
  if (tone === 'steel') {
    // ---- 介錯 (steel): 刃先スメア + 接触同期の足元炸裂 --------------------------------
    const life = 0.26
    if (age > life) return
    const tC = 0.0665                    // 接触時刻 = activeMs 190 × 0.35。attacks.ts と同期
    const sweep = Math.min(1, age / tC)
    const p = sweep * sweep              // 掃き進み (easeIn = 刃は加速しながら落ちる)
    const q = Math.max(0, (age - tC) / (life - tC))
    const fade = (1 - q) * (1 - q)       // 接触までは 1、接触後に減衰
    // 刃先の通り道: 振り上げ頂点 (-40,-280) → 前上へ張り出し → 着弾 (70,34)。
    //   数値の出所 = _確認用/73_arc_probe r4850 (頂点) と、74_fable_arcfx の実測
    //   (最初 x=150 で置いたら刃の実着地より約80px前に出た → 70 へ後退)。y=+46 が接地。
    const P0 = { x: -40, y: -280 }, P1 = { x: 165, y: -175 }, P2 = { x: 70, y: 34 }
    const PIVOT = { x: 10, y: -120 }     // 肩 (柄側)。三日月の内側はここへ寄せる
    const N = 18
    const bez = (u: number) => ({
      x: (1 - u) * (1 - u) * P0.x + 2 * (1 - u) * u * P1.x + u * u * P2.x,
      y: (1 - u) * (1 - u) * P0.y + 2 * (1 - u) * u * P1.y + u * u * P2.y,
    })
    const inner = (o: { x: number; y: number }) => ({
      x: o.x + (PIVOT.x - o.x) * 0.45, y: o.y + (PIVOT.y - o.y) * 0.45,
    })
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.translate(x, y)
    if (dir < 0) ctx.scale(-1, 1)        // 以降は「右向き」座標で書く
    const k = Math.max(1, Math.round(p * N))
    const pts = Array.from({ length: k + 1 }, (_, i) => bez((i / k) * p))
    // 10-29 作者 q1: 白い線と足元の白い横線をやめ、筆のぶれの絵にする (比較版 ?execSwing=brush・配布版は前の白い弧)。床は土ぼこりとひびが受け持つ。
    if (execSwingBrushOn()) {
      drawExecSwingBrush(ctx, 'down', pts, PIVOT, sweep, fade, 0.9)
      ctx.restore()
      return
    }
    // 三日月の面 (刃身が掃いた領域のうすい残光)
    ctx.globalAlpha = 0.10 * fade
    ctx.fillStyle = PALETTE.fxSilver
    ctx.beginPath()
    ctx.moveTo(pts[0].x, pts[0].y)
    for (let i = 1; i <= k; i++) ctx.lineTo(pts[i].x, pts[i].y)
    for (let i = k; i >= 0; i--) { const q2 = inner(pts[i]); ctx.lineTo(q2.x, q2.y) }
    ctx.closePath()
    ctx.fill()
    // 刃先の軌跡 (尾=細く淡い / 先端=太く明るい)
    for (let i = 0; i < k; i++) {
      const seg = (i + 1) / N
      ctx.globalAlpha = fade * (0.06 + 0.42 * seg)
      ctx.strokeStyle = PALETTE.fxSilver
      ctx.lineWidth = 2 + 9 * seg
      ctx.shadowColor = PALETTE.fxSilver
      ctx.shadowBlur = 10 * fade * seg
      ctx.beginPath(); ctx.moveTo(pts[i].x, pts[i].y); ctx.lineTo(pts[i + 1].x, pts[i + 1].y); ctx.stroke()
    }
    // 足元の横炸裂: **接触後にだけ** 出す。着弾点 (P2.x) を中心に外へ走る。
    //   広がり 80→180 は strike 帯 (前方 15..195px) をほぼ覆う = 当たった床の範囲がそのまま読みになる
    if (age >= tC) {
      const ab = (1 - q) * (1 - q)
      const half = 80 + 100 * (1 - (1 - q) * (1 - q))   // 80→180 easeOut で広がる
      const grd = ctx.createLinearGradient(P2.x - half, 46, P2.x + half, 46)
      grd.addColorStop(0, 'rgba(0,0,0,0)')
      grd.addColorStop(0.5, `rgba(232,232,238,${ab * 0.6})`)
      grd.addColorStop(1, 'rgba(0,0,0,0)')
      ctx.globalAlpha = 1
      ctx.strokeStyle = grd
      ctx.lineWidth = 1.5 + 4 * ab
      ctx.shadowColor = PALETTE.fxSilver
      ctx.shadowBlur = 12 * ab
      ctx.beginPath(); ctx.moveTo(P2.x - half, 46); ctx.lineTo(P2.x + half, 46); ctx.stroke()
      // 着弾点の短い立ち上がり (土煙の芯)。最初の 60ms だけ
      const af = Math.max(0, 1 - (age - tC) / 0.06)
      if (af > 0) {
        ctx.globalAlpha = af * 0.45
        ctx.strokeStyle = PALETTE.fxSilver
        ctx.lineWidth = 5 * af
        ctx.shadowBlur = 8 * af
        ctx.beginPath(); ctx.moveTo(P2.x, 46); ctx.lineTo(P2.x, 46 - 44 * af); ctx.stroke()
      }
    }
    ctx.restore()
    return
  }
  // ---- 花嫁 (veil): 2026-07-10 の従来描画。据え置き (1pxも変えない) ------------------
  const life = 0.24
  if (age > life) return
  const t = age / life
  const a = (1 - t) * (1 - t)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.translate(x, y)
  // 叩きつけ: 縦の振り下ろし弧 (上→前下) + 足元の横炸裂
  const arcW = 60 + 26 * (1 - t)
  const arcH = 120 + 46 * (1 - t)
  ctx.globalAlpha = a * 0.22
  ctx.strokeStyle = swc('parry', PALETTE.fxVioletBright)
  ctx.lineWidth = 13 * a
  ctx.shadowColor = swc('parry', PALETTE.fxViolet)
  ctx.shadowBlur = 18 * a
  ctx.beginPath()
  ctx.ellipse(dir * 12, -10, arcW, arcH, 0, -Math.PI * 0.55, Math.PI * 0.15)
  ctx.stroke()
  // 足元の横炸裂 (床ヒット・接地付近 y=+46)。左右対称なので鏡像の影響を受けない。
  const burst = 70 + 60 * (1 - t)
  const grd = ctx.createLinearGradient(-burst, 46, burst, 46)
  grd.addColorStop(0, 'rgba(0,0,0,0)')
  grd.addColorStop(0.5, `rgba(${swc('parry', '220,208,240')},${a * 0.5})`)
  grd.addColorStop(1, 'rgba(0,0,0,0)')
  ctx.globalAlpha = 1
  ctx.strokeStyle = grd
  ctx.lineWidth = 3.5 * a
  ctx.shadowColor = PALETTE.fxSilver
  ctx.shadowBlur = 10 * a
  ctx.beginPath()
  ctx.moveTo(-burst, 46)
  ctx.lineTo(burst, 46)
  ctx.stroke()
  ctx.restore()
}

// 裾乱れ 布斬撃弧 (2026-07-10 V-5): 各ヒットの active 突入で翻るヴェールの弧を additive 一閃 =「判定=振り」を可視化。
//   通常ヒット = facing 方向へ翻る柔らかい横弧 (布 = lanceCross より広く柔らかい・紫銀のシアー)。
//   slam=true = 縦の振り下ろし弧 + 足元(床)の横炸裂 (叩きつけ)。 色は fxViolet系/silver のみ (赤・黒禁止)。
function drawVeilSlashArc(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number, slam: boolean,
  spin?: number,
): void {
  // ---- 回り込みヴェールアーク (spin・2026-07-11 A案): 彼女を取り巻く楕円軌道を進む彗星状リボン。
  //   hit ごとに STEP ずつ角度が進み、 life 中は残って重なる (multiples) → 一周する回転に読める。
  //   ⬜数値 (rx/ry/STEP/life/span) は実機で要微調整。
  if (spin !== undefined && !slam) {
    const life = 0.5
    if (age > life) return
    const t = age / life
    const a = (1 - t) * (1 - t)
    const STEP = 2.35                                   // hit ごとの回転角 (rad ≈ 135°)
    const head = spin * STEP * (dir >= 0 ? 1 : -1)      // 先端角 (facing で回転向きを鏡像)
    const rx = 150, ry = 62, cy0 = -6                   // 軌道楕円 (横広・縦短=側面視の回転) + 胴中心へ
    const span = 1.25, N = 14                           // 彗星の尾長 (rad) と分割
    const pos = (p: number): [number, number] => [rx * Math.cos(p), ry * Math.sin(p) + cy0]
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.translate(x, y)
    // violet グロー本体 (尾=細く暗い / 頭=太く明るい / 奥=暗い=回転の奥行き)
    for (let i = 0; i < N; i++) {
      const [ax, ay] = pos(head - span * (1 - i / N))
      const [bx, by] = pos(head - span * (1 - (i + 1) / N))
      const seg = (i + 1) / N
      const dv = 0.45 + 0.55 * ((Math.sin(head - span * (1 - (i + 1) / N)) + 1) / 2)
      ctx.globalAlpha = a * (0.05 + 0.30 * seg) * dv
      ctx.strokeStyle = swc('parry', PALETTE.fxVioletBright)
      ctx.lineWidth = (2 + 15 * seg) * dv * (0.5 + 0.5 * a)
      ctx.shadowColor = swc('parry', PALETTE.fxViolet)
      ctx.shadowBlur = 12 * a * dv
      ctx.beginPath(); ctx.moveTo(ax, ay); ctx.lineTo(bx, by); ctx.stroke()
    }
    // silver コア (頭側半分=鋭い芯)
    for (let i = Math.floor(N * 0.5); i < N; i++) {
      const [ax, ay] = pos(head - span * (1 - i / N))
      const [bx, by] = pos(head - span * (1 - (i + 1) / N))
      const seg = (i + 1) / N
      ctx.globalAlpha = a * 0.5 * seg
      ctx.strokeStyle = PALETTE.fxSilver
      ctx.lineWidth = (1 + 3 * seg) * (0.6 + 0.4 * a)
      ctx.shadowColor = swc('parry', PALETTE.fxVioletBright)
      ctx.shadowBlur = 6 * a
      ctx.beginPath(); ctx.moveTo(ax, ay); ctx.lineTo(bx, by); ctx.stroke()
    }
    ctx.restore()
    return
  }
  if (slam) {
    drawDownswingArc(ctx, x, y, age, dir, 'veil')
    return
  }
  const life = 0.15
  if (age > life) return
  const t = age / life
  const a = (1 - t) * (1 - t)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.translate(x, y)
  // 旋回の翻り: facing 方向へ翻る柔らかい横弧 (布)
  const arcW = 92 + 40 * (1 - t)
  const arcH = arcW * 0.5
  const rot = dir > 0 ? 0.18 : -0.18
  const startAngle = dir > 0 ? -Math.PI * 0.22 : -Math.PI * 0.78
  const endAngle   = dir > 0 ?  Math.PI * 0.48 : -Math.PI * 0.02
  ctx.globalAlpha = a * 0.16
  ctx.strokeStyle = swc('parry', PALETTE.fxVioletBright)
  ctx.lineWidth = 15 * a
  ctx.shadowColor = swc('parry', PALETTE.fxViolet)
  ctx.shadowBlur = 14 * a
  ctx.beginPath()
  ctx.ellipse(dir * 14, 2, arcW, arcH, rot, startAngle, endAngle)
  ctx.stroke()
  ctx.globalAlpha = a * 0.4
  ctx.strokeStyle = PALETTE.fxSilver
  ctx.lineWidth = 2.5 * a
  ctx.shadowColor = swc('parry', PALETTE.fxVioletBright)
  ctx.shadowBlur = 7 * a
  ctx.beginPath()
  ctx.ellipse(dir * 14, 2, arcW, arcH, rot, startAngle, endAngle)
  ctx.stroke()
  ctx.restore()
}

// ボス処刑 (確殺フィニッシャー) の打点。 #2 リワーク (2026-06-21): 死=破壊 → 死=浄化。
//   かつての赤い三重波・横一閃・放射スパーク (破壊) を撤去 = 「1拍の痛み」だけを体に残す。
//   レイヤー (additive): 冷白の芯閃光 (凍りつく一瞬) → 振り抜き方向(dir)へ僅かに伸びる冷光リング1本。
//   余波の浄化 (魂が常夜燈へ昇る・10-11 から青白) は drawDeathPurification (全画面・deathBeat 駆動) が担う。
//   芯の閃光の紫の縁は残す (10-11 朝の答え exec-impact-edge「残す」): 当たった瞬間までがボスの致命の紫・ほどけてからが主人公の青白、と色で分ける。
export function drawBossExecuteImpact(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir: number,
): void {
  const life = 0.34
  if (age > life) return
  const t = age / life

  ctx.save()
  ctx.globalCompositeOperation = 'lighter'   // 加算: 黒は消えて光だけ乗る
  ctx.translate(x, y)

  // 芯の閃光: 発生直後に最大 → 速く減衰 (白→冷青)。 hitStop と噛んで「凍りつく一瞬」を作る。
  const coreA = t < 0.12 ? t / 0.12 : Math.max(0, 1 - (t - 0.12) / 0.42)
  if (coreA > 0.01) {
    const r = 96 * (0.55 + 0.6 * t)
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, r)
    g.addColorStop(0, `rgba(245,248,255,${0.95 * coreA})`)
    g.addColorStop(0.35, `rgba(200,216,255,${0.6 * coreA})`)
    g.addColorStop(0.7, `rgba(154,122,196,${0.28 * coreA})`)   // 紫の縁 = ボスの致命の色 (10-11 朝「残す」・旧は紫の浄化への橋渡しだった)
    g.addColorStop(1, 'rgba(0,0,0,0)')
    ctx.fillStyle = g
    ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.fill()
  }

  // 冷光リング1本: 振り抜き方向(dir)へほんの少し伸びて消える = 一撃の「抜き」を静かに示す。
  //   破壊の三重波と違い、 単発・細く・冷たい銀青で「とどめが入った」の硬直だけを残す。
  // 2026-06-24: 旧 drawRipple (radial-gradient の clean ring) は [[reference_fx_worldview_rule]]
  //   違反 (UI 図形読み) → sprite+additive 経路へリプレース (ripple_execute.png は ChatGPT 生成の
  //   「凍りつき + 墨弾き + 粒子」素材)。 未読込時は drawRipple へフォールバック (即破綻防止)。
  const ringA = Math.max(0, 1 - t / 0.9)
  if (ringA > 0.01) {
    const ring = getFinisherFx('ripple_execute')
    ctx.save()
    ctx.translate(dir * 10 * t, 0)                       // dir 方向へ僅かにずれて流れる
    if (ring) {
      // sprite 経路: 早く立ち上がり外へ広がりながら薄れる (旧 drawRipple と同じカーブ感)。
      //   ease = 1 - (1-t)^2 で早立ち上がり減速、 alpha = ringA * (1-t) で広がるほど薄く。
      const ease = 1 - (1 - t) * (1 - t)
      const w = 300 * (0.45 + 0.85 * ease)               // 旧 rEnd=150 を直径=300 にマップ
      ctx.globalAlpha = ringA * (1 - t) * 0.95
      ctx.drawImage(ring, -w / 2, -w / 2, w, w)
    } else {
      drawRipple(ctx, t, 150, 'rgba(198,214,255,0.9)', 0.9)
    }
    ctx.restore()
  }

  ctx.restore()
}

// 処刑死の全画面シネマティック。 deathBeat.execution 中のみ。 #2 リワーク (2026-06-21): 死=破壊 → 死=浄化。
//   ①冷白の一閃 (1拍の凍結=痛み。 赤白+色収差は撤去) → ②死を縁取る冷たい暗ヴィネットが締まる →
//   ③LUNAIRE 自身の魂 (10-11 から青白) が体からほどけ、 昇って常夜燈へ還る (drawDeathPurification)。 HUD の下に描く。
function drawExecutionCinematic(ctx: CanvasRenderingContext2D, state: GameState): void {
  const db = state.deathBeat
  if (!db || !db.execution) return
  const e = db.elapsedMs

  // ① 冷白の一閃 (additive)。 とどめの白光で画面が一瞬凍る (hitStop 中は elapsed 停止 = 凍結フラッシュ)。
  //   赤+色収差(破壊感)は撤去 = 清潔な冷白だけ。 薄い紫の縁と被せはボスの致命の色として残す (10-11 朝の答え「残す」・続く浄化は青白)。
  const fa = Math.max(0, 1 - e / BOSS_EXECUTE_FX.cinematicFlashMs)
  if (fa > 0.01) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = fa * 0.82
    ctx.fillStyle = '#eef2ff'; ctx.fillRect(0, 0, ARENA.width, ARENA.height)         // 冷白の芯
    ctx.globalAlpha = fa * 0.28
    ctx.fillStyle = '#b9a8e6'; ctx.fillRect(0, 0, ARENA.width, ARENA.height)         // 薄い紫の被り
    ctx.restore()
  }

  // ② 死を縁取る暗ヴィネットが締まる (周縁から内へ)。 ゆっくり濃くなり「終わった」を出す。 冷たい紫黒。
  const vp = Math.min(1, e / BOSS_EXECUTE_FX.vignetteRampMs)
  const va = BOSS_EXECUTE_FX.vignetteMaxAlpha * vp
  if (va > 0.01) {
    const cx = ARENA.width / 2, cy = ARENA.height / 2
    const g = ctx.createRadialGradient(cx, cy, ARENA.height * 0.18, cx, cy, ARENA.height * 0.74)
    g.addColorStop(0, 'rgba(0,0,0,0)')
    g.addColorStop(0.55, `rgba(10,6,22,${va * 0.45})`)
    g.addColorStop(1, `rgba(3,2,8,${va})`)
    ctx.save()
    ctx.fillStyle = g
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    ctx.restore()
  }

  // ③ 浄化: 魂が体からほどけ、 暗がりを抜けて常夜燈へ昇る (暗ヴィネットの上に additive で光らせる)。
  //   体の位置から出る光なので、 画面の寄せ (cam_zoom) に合わせて拡大後の位置へ写す。
  ctx.save()
  applyCamZoomTransform(ctx)
  applyFarView(ctx)
  ctx.translate(-cameraX, 0) // 体の位置は世界の座標 (広い舞台ではカメラが横に動く)
  drawDeathPurification(ctx, state, e)
  ctx.restore()
}

// 死の浄化。 LUNAIRE 自身の魂 (10-11 から撃破と同じ青白 SOUL_BLUE。 旧は紫 #9a7ac4) が崩れ落ちた体からほどけ、 画面上方の散らばった点へ蒸発する。
//   2026-07-02 変更: 旧仕様「常夜燈へ吸い込まれて消える」→ ボス撃破 (drawFinisherSoul) と同じく
//   「画面上方の散らばった点へ蒸発 = 収束点なし」へ統一 (ユーザー裁定)。 常夜燈の位置 reveal を避ける
//   方針 ([[reference_ghostlight_bg_anchor]]) と揃える。 旧・常夜燈の応え (冷青グロー) も撤去。
//   deathBeat 窓 (≤1150ms) に収める。 e = db.elapsedMs (実 ms・timeScale 非依存)。 additive 前提。
export function drawDeathPurification(ctx: CanvasRenderingContext2D, state: GameState, e: number): void {
  const F = BOSS_EXECUTE_FX
  if (e < F.purifyStartMs) return
  const px = state.player.x
  const bodyY = state.player.y - PLAYER.height * 0.42          // 崩れた体の中ほどから剥がれる

  ctx.save()
  ctx.globalCompositeOperation = 'lighter'

  // 体がほどける青白のブルーム: 放出開始直後にふわっと立ち、 体が「自分の光に崩れる」瞬間を見せる。
  //   これがあると点の流れだけより「浄化されて消えていく」が明確に読める。 ~500ms で薄れる。
  const bloom = Math.max(0, 1 - (e - F.purifyStartMs) / 520)
  if (bloom > 0.01) {
    const bi = bloom * bloom
    drawGlowDot(ctx, px, bodyY, 64 + 18 * (1 - bloom), SOUL_BLUE.haze, bi * 0.6)        // 旧 #9a7ac4
    drawGlowDot(ctx, px, bodyY - 4, 34, SOUL_BLUE.head, bi * 0.7)                        // 旧 #c8b0ec
    drawGlowDot(ctx, px, bodyY - 8, 16, SOUL_BLUE.tail, bi * 0.65)                       // 旧 #efe2ff
  }

  // 画面上方の散らばった点へ蒸発 = drawFinisherSoul と同じ言語。 収束点なし。
  const N = F.purifyMoteCount
  for (let i = 0; i < N; i++) {
    // 出生を前半に密集させる (体が一気にほどける): (i/N)^1.4 で序盤を詰める
    const birth = F.purifyStartMs + Math.pow(i / N, 1.4) * F.purifyEmitMs
    const lt = (e - birth) / F.purifyTravelMs
    if (lt >= 1 || lt < 0) continue
    // 出生: 崩れた体の周りに少し散る
    const ox = px + (hash01(i * 3.1) - 0.5) * 70
    const oy = bodyY - hash01(i * 1.7) * 36
    // 終端: 画面上方の散らばった点 (収束点なし・drawFinisherSoul と同構造)。
    const ascendX = px + (hash01(i * 6.7) - 0.5) * 240
    const ascendY = ARENA.height * 0.04 + hash01(i * 7.3) * 46
    const ease = lt * lt * (3 - 2 * lt)                      // smoothstep
    const waver = Math.sin(lt * Math.PI * 2 + i) * 10 * (1 - lt)
    const lift = Math.sin(lt * Math.PI) * 26
    const x = ox + (ascendX - ox) * ease + waver
    const y = oy + (ascendY - oy) * ease - lift
    const r = (4.4 + hash01(i * 2.3) * 4.0) * (1 - 0.35 * lt)
    const fadeIn = Math.min(1, (e - birth) / 80)
    // lt=0.55 で alpha=0 = 上方で自然に薄れて消える (急に切れない)
    const k = Math.max(0, 1 - lt / 0.55)
    const fadeOut = k * k * k
    const col = hash01(i * 5.7) < 0.32 ? SOUL_BLUE.tail : SOUL_BLUE.head   // 旧 #c8b0ec / #9a7ac4 (紫)
    drawGlowDot(ctx, x, y, r, col, fadeIn * fadeOut)
  }

  ctx.restore()
}

// パリィ閃光: 鋭い刃の clash は "描かれた絵" より コードのクリスプ光が映える (ULTRAKILL 系)。
//   既定=コードのみ (白い芯 + 鋭い銀/紫の光の筋 + 柔らかい光の粒)。 PARRY_USE_SPRITE で旧スプライト版に切替可。
//   全レイヤー additive (黒は消えて光だけ乗る)。 intensity = 弾いた攻撃の重さ。
// レンズフレア(光条): 中央が眩しく両端が消える紡錘形。 実線でなく "光の筋" に見せる。 additive 前提。
function drawLensFlare(
  ctx: CanvasRenderingContext2D, halfLen: number, halfWid: number, rot: number, color: string, alpha: number,
): void {
  if (alpha <= 0.01 || halfLen <= 1) return
  ctx.save()
  ctx.rotate(rot)
  ctx.globalAlpha = alpha
  const g = ctx.createLinearGradient(-halfLen, 0, halfLen, 0)
  g.addColorStop(0, 'rgba(0,0,0,0)')   // 端は透明
  g.addColorStop(0.5, color)           // 中央が眩しい
  g.addColorStop(1, 'rgba(0,0,0,0)')
  ctx.fillStyle = g
  ctx.beginPath()
  ctx.moveTo(-halfLen, 0)
  ctx.quadraticCurveTo(0, -halfWid, halfLen, 0)  // 紡錘形 (中央が太く端が尖る)
  ctx.quadraticCurveTo(0, halfWid, -halfLen, 0)
  ctx.closePath()
  ctx.fill()
  ctx.restore()
}

// 光の筋(放射の棘): 根元が太く先端が一点に細り、 グラデで先端へ透明に消える。
//   等幅の実線でなく "先細りの光" にすることで、 描いた星形(シール)感を消す。 additive 前提。
function drawSparkRay(
  ctx: CanvasRenderingContext2D, ang: number, r0: number, len: number, halfWid: number,
  color: string, alpha: number,
): void {
  if (alpha <= 0.01 || len <= 1) return
  ctx.save()
  ctx.rotate(ang)
  ctx.translate(r0, 0)                  // 中心から少し離れた根元から +x 方向へ伸ばす
  const g = ctx.createLinearGradient(0, 0, len, 0)
  g.addColorStop(0, color)              // 根元が明るい
  g.addColorStop(0.45, color)           // 中盤まで明るさを保つ(=長い光の筋に見える)
  g.addColorStop(1, 'rgba(0,0,0,0)')    // 先端は透明に消える
  ctx.globalAlpha = alpha
  ctx.fillStyle = g
  ctx.beginPath()
  ctx.moveTo(0, -halfWid)
  ctx.lineTo(len, 0)                     // 先端は一点 (先細り)
  ctx.lineTo(0, halfWid)
  ctx.closePath()
  ctx.fill()
  ctx.restore()
}

// 波紋(衝撃波): 外へ広がる "光の帯"。 線の輪でなくグラデの帯なので縁が硬くならず車輪化しない。
//   p=0..1 (進行)。 半径 r が広がり、 r 付近だけ発光・内外は透明。 広がるほど薄く消える。 additive 前提。
function drawRipple(
  ctx: CanvasRenderingContext2D, p: number, rEnd: number, color: string, alpha: number,
): void {
  if (p <= 0 || p >= 1 || alpha <= 0.01) return
  const ease = 1 - (1 - p) * (1 - p)        // 立ち上がり速く→減速して広がる
  const r = Math.max(2, rEnd * ease)
  const a = alpha * (1 - p)                   // 広がるほど薄く
  const g = ctx.createRadialGradient(0, 0, 0, 0, 0, r)
  g.addColorStop(0, 'rgba(0,0,0,0)')         // 中心は透明 (=塗りの円盤でない)
  g.addColorStop(0.62, 'rgba(0,0,0,0)')
  g.addColorStop(0.84, color)                // 外周付近だけ光る帯
  g.addColorStop(1, 'rgba(0,0,0,0)')         // 外側も透明にフェード (硬い縁なし)
  ctx.save()
  ctx.globalAlpha = a
  ctx.fillStyle = g
  ctx.beginPath()
  ctx.arc(0, 0, r, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()
}

const PARRY_USE_SPRITE = false
export function drawParrySpark(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, intensity = 1, isJust = false, shape: BloomShape = 'a',
): void {
  // W 系 (DEV ?parryFlash=w1|w2|w3)：光の雲なし。接点のにじみ＋線の火花 (止めが明けてから)＋小さな芯。体の照らしは drawBloomLitBody。
  const wash = parryWashVariant()
  if (wash) { drawParryWashFx(ctx, x, y, age, isJust, wash); return }
  if (!drawParryBloom(ctx, x, y, age, intensity, isJust, shape)) drawParrySparkOld(ctx, x, y, age, intensity, isJust)
}

function drawParrySparkOld(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, intensity = 1, isJust = false,
): void {
  // 連続弾きエスカレーション (P4 §6.1): intensity は最大 sparkIntensityMax まで=段で火花スケールが上がる。
  //   k は半径/本数/速度/重力などのスケール係数にのみ乗る (アルファは別途 0..1 に収まる) ので上限超過しても破綻しない。
  const k = Math.max(0.15, Math.min(COMBAT.parryChain.sparkIntensityMax, intensity))
  // ジャスト: フル。通常: 0.60 縮小 → 火花が小さく暗く「受けた感」を出す。
  const visualScale = isJust ? 1.0 : 0.60
  const life = 0.42 + 0.3 * k                     // 全体(火花が舞い落ちきるまで)。 SEKIRO ~0.9s より少し短く、 灰の城に合わせ抑制
  if (age > life) return
  const t = age / life
  const easeOut = 1 - (1 - t) * (1 - t)
  const base = (24 + 40 * k) * visualScale          // ジャスト=フル / 通常=60%
  const idx = Math.abs(Math.round(x * 0.13 + y * 0.07))
  const seed = idx * 1.37

  ctx.save()
  ctx.globalCompositeOperation = 'lighter'     // 加算: 黒は消えて光だけ乗る
  ctx.translate(x, y)

  // --- レイヤー1: 中心の閃光 (既定=コードのクリスプ / スプライト版は PARRY_USE_SPRITE) ---
  if (PARRY_USE_SPRITE) {
    const img = getParryFlash(idx)
    if (img) {
      const coreSize = base * (0.5 + 1.2 * easeOut)
      const coreA = t < 0.07 ? t / 0.07 : t < 0.55 ? 1 : Math.max(0, 1 - (t - 0.55) / 0.45)
      ctx.save(); ctx.globalAlpha = coreA; ctx.rotate(seed + age * 0.5)
      ctx.drawImage(img, -coreSize / 2, -coreSize / 2, coreSize, coreSize)
      ctx.restore()
    }
  } else {
    // SEKIRO 型の時間差レイヤー (ChatGPT 言語化準拠): 発生直後に最大→0.2s前後で消える。
    //   0.00 コア閃光 → 0.02 衝撃波の膜 → 0.035 放射スパーク → 0.05 横レンズフレア → 0.12 減衰。
    //   色は灰の城向けに冷色を維持 (承認済): コア=白〜淡金で熱、 主発光/火花=銀白・紫銀、 金は数粒のアクセント。
    const flashLife = 0.20 + 0.05 * k
    if (age < flashLife) {
      const T_CORE = 0.13 + 0.04 * k
      const T_RIP_START = 0.02, T_RIP_DUR = 0.13 + 0.03 * k
      const T_SPK_START = 0.035, T_SPK_PEAK = 0.065, T_SPK_END = 0.17 + 0.05 * k
      const T_FLR_START = 0.05, T_FLR_PEAK = 0.09, T_FLR_END = 0.16 + 0.04 * k

      // (a) コア: 冷白の高輝度。 即ピーク→減衰。 塗りの円盤でなく小さい芯 + 背後の滲み
      //   P4.5: intensity>1 で芯を銀→白金へ色温度シフト (5段=熱を帯びた最高潮を色でも)。
      const coreE = Math.max(0, Math.cos(Math.min(1, age / T_CORE) * Math.PI * 0.5))
      const coreCol = sparkCoreColor(intensity)
      if (isJust) {
        // ジャスト専用シグネチャ = 金。 通常パリィは冷色のまま (金を廃止) = 金はジャストにだけ閃く
        //   「完璧の一閃」(2026-06-25)。 SEKIRO の perfect deflect に倣い、 稀な高難度の瞬間だけ暖色の脳汁。
        drawGlowDot(ctx, 0, 0, base * (1.05 + 0.45 * coreE), '#f0b94e', coreE * 0.22)  // 金ハロー(背後・広く)
        drawGlowDot(ctx, 0, 0, base * (0.5 + 0.2 * coreE), '#ffcf63', coreE * 0.5)     // 金ブルーム(中)
        drawGlowDot(ctx, 0, 0, base * (0.17 + 0.1 * coreE), '#ffe9a8', coreE * 0.95)   // 淡金の芯
        drawGlowDot(ctx, 0, 0, base * (0.08 + 0.05 * coreE), '#fffaf0', coreE)         // 白金の極小点
      } else {
        drawGlowDot(ctx, 0, 0, base * (0.85 + 0.35 * coreE), '#9a7ac4', coreE * 0.15 * visualScale)  // 紫ハロー(背後)
        drawGlowDot(ctx, 0, 0, base * (0.17 + 0.1 * coreE), coreCol, coreE * 0.8 * visualScale)     // 冷白〜白金の芯
        drawGlowDot(ctx, 0, 0, base * (0.08 + 0.05 * coreE), '#ffffff', coreE * 0.9 * visualScale)  // 白の極小点
      }

      // (a') シグネチャの輪: ジャストは必ず金の二重リングで「完璧!」を伝える。
      //   通常パリィは cap到達(最高潮)時だけ白リング (従来通り)。
      if (isJust) {
        const ringP = Math.min(1, age / (T_CORE * 1.9))
        const ringA = (1 - ringP) * (1 - ringP)
        ctx.save()
        ctx.globalAlpha = ringA * 0.9
        ctx.strokeStyle = '#ffd770'
        ctx.lineWidth = base * 0.075 * (1 - ringP * 0.5)
        ctx.beginPath(); ctx.arc(0, 0, base * (0.35 + 1.7 * ringP), 0, Math.PI * 2); ctx.stroke()
        ctx.globalAlpha = ringA * 0.5                                   // 内側に薄い追い輪 (厚み)
        ctx.strokeStyle = '#fff1c0'
        ctx.lineWidth = base * 0.04 * (1 - ringP * 0.5)
        ctx.beginPath(); ctx.arc(0, 0, base * (0.2 + 1.2 * ringP), 0, Math.PI * 2); ctx.stroke()
        ctx.restore()
      } else if (intensity >= COMBAT.parryChain.sparkIntensityMax - 0.05) {
        const ringP = Math.min(1, age / (T_CORE * 1.6))
        const ringA = (1 - ringP) * (1 - ringP)
        ctx.save()
        ctx.strokeStyle = '#fff6e0'
        ctx.globalAlpha = ringA * 0.85
        ctx.lineWidth = base * 0.06 * (1 - ringP * 0.5)
        ctx.beginPath(); ctx.arc(0, 0, base * (0.3 + 1.4 * ringP), 0, Math.PI * 2); ctx.stroke()
        ctx.restore()
      }

      // (b) 衝撃波(光の膜): 0.02s から急速に外へ広がる。 塗りでなくグラデの帯=車輪化しない
      //   ジャストは膜を金寄りに (#ffe6a8) = 広がる衝撃波も暖色で「完璧」を補強。
      if (age > T_RIP_START) {
        drawRipple(ctx, Math.min(0.999, (age - T_RIP_START) / T_RIP_DUR), base * 2.2,
          isJust ? '#ffe6a8' : '#e8dcff', isJust ? 0.62 : 0.55)
      }

      // (c) 放射スパーク: 0.035s から外へ飛ぶ。 先細り・長さ角度バラバラ (シール感排除)、 30本
      if (age > T_SPK_START) {
        const sl = age - T_SPK_START
        const sEnv = age < T_SPK_PEAK
          ? sl / (T_SPK_PEAK - T_SPK_START)
          : Math.max(0, 1 - (age - T_SPK_PEAK) / (T_SPK_END - T_SPK_PEAK))
        const g0 = Math.min(1, sl / 0.05)
        const sGrow = 1 - (1 - g0) * (1 - g0)                  // 外へ伸びる(早く展開)
        const rays = 30
        for (let j = 0; j < rays; j += 1) {
          const a = (j / rays) * Math.PI * 2 + (hash01(seed + j * 5.1) - 0.5) * 0.55 + seed * 0.3
          const h = hash01(j * 2.7)
          const len = base * (0.4 + h * h * 2.3) * sGrow       // h^2 で短め寄り + たまに長い主役
          const r0 = base * (0.06 + 0.07 * hash01(j * 3.9))
          const halfWid = (1.1 + 1.4 * k) * (0.35 + 0.6 * h)
          // 通常: 白 / 紫銀のみ (金を廃止)。 ジャスト: 約1/3 を金の主役筋に (残りは白で眩しさを保つ)。
          const hc = hash01(j * 1.7)
          const col = isJust
            ? (hc > 0.62 ? '#ffd97a' : hc > 0.30 ? '#ffffff' : '#ffeec0')
            : (hc > 0.45 ? '#ffffff' : '#cdb8f0')
          const aMul = 0.55 + 0.45 * hash01(j * 1.3)
          drawSparkRay(ctx, a, r0, len, halfWid, col, sEnv * aMul)
        }
        ctx.globalAlpha = 1
      }

      // (d) 横レンズフレア: 0.05s から左右へ長く伸びる。 中心最明→端へ透明 (実線でなく光条)
      if (age > T_FLR_START) {
        const fl = age - T_FLR_START
        const fEnv = age < T_FLR_PEAK
          ? fl / (T_FLR_PEAK - T_FLR_START)
          : Math.max(0, 1 - (age - T_FLR_PEAK) / (T_FLR_END - T_FLR_PEAK))
        const fGrow = Math.min(1, fl / 0.06)
        // ジャストは横一文字の光条を淡金に (中心の眩しさは白金芯が担うので端だけ暖色)。
        drawLensFlare(ctx, base * (1.4 + 2.4 * fGrow), base * 0.09, 0,
          isJust ? '#fff0c4' : '#ffffff', fEnv * 0.8 * visualScale)
      }
    }
  }

  // --- レイヤー2: 火花/残り火 (飛び出し→重力で落下→ゆっくり消える。 月光が刃で弾けた粒) ---
  const ns = Math.max(4, Math.round((12 + Math.round(10 * k)) * visualScale))  // 通常: 本数60%で鈍い印象
  const G = base * (3.5 + 2 * k)                              // 重力
  for (let i = 0; i < ns; i += 1) {
    const st = hash01(i * 0.7) * 0.1
    const lt = (t - st) / (1 - st)
    if (lt <= 0 || lt >= 1) continue
    const ang = hash01(seed + i * 3.3) * Math.PI * 2          // 全方向に放射
    const speed = base * (1.6 + 2.2 * k) * (0.4 + hash01(i * 1.9) * 0.9)
    const ca = Math.cos(ang), sa = Math.sin(ang)
    const outE = 1 - (1 - lt) * (1 - lt)                      // 外へ(減速)
    const px = ca * speed * outE
    const py = sa * speed * outE + G * lt * lt                // + 重力落下
    // 速度(尾の向き=モーションブラー): 序盤は外向き、 終盤は落下
    const vx = ca * speed * 2 * (1 - lt)
    const vy = sa * speed * 2 * (1 - lt) + G * 2 * lt
    const vlen = Math.hypot(vx, vy) || 1
    const tail = 4 + 11 * lt                                  // 落ちるほど尾が伸びる
    const fade = (1 - lt)                                     // ゆっくり消える
    ctx.globalAlpha = fade * 0.9
    // 通常: 冷色のみ 銀白 / 紫銀 / 青銀 (金は廃止)。 ジャスト: 一部の粒を金にして暖かい火の粉に。
    const m = i % 3
    ctx.strokeStyle = isJust
      ? (m === 0 ? '#ffe09a' : m === 1 ? '#fff3d0' : '#eaf0ff')
      : (m === 0 ? '#eaf0ff' : m === 1 ? '#c8b0ec' : '#dce6f4')
    ctx.shadowColor = ctx.strokeStyle; ctx.shadowBlur = 4
    ctx.lineCap = 'round'; ctx.lineWidth = (1.4 + 0.9 * k) * (0.45 + 0.55 * fade)
    ctx.beginPath(); ctx.moveTo(px - (vx / vlen) * tail, py - (vy / vlen) * tail); ctx.lineTo(px, py); ctx.stroke()
  }
  ctx.shadowBlur = 0
  ctx.restore()
}

export function drawHitSpark(ctx: CanvasRenderingContext2D, x: number, y: number, age: number, color: 'pink' | 'red'): void {
  if (age > 0.30) return
  const life = 0.30
  // 色: pink(当て)=銀白 / red(被弾)=赤
  const col  = color === 'red' ? PALETTE.danger : '#f2f7ff'
  const col2 = color === 'red' ? PALETTE.danger : '#cfe0f5'

  // 不規則な火花飛散 (大小・速度・方向がばらける)
  emberBurst(ctx, x, y, 10, col, age, life, color === 'red' ? 5 : 17, 1, 160)

  // キレを出す上半円 spread glowMote ×8: taperStreak ×2 (禁止) を置換
  //   上向き (右上・左上) のベクトルを上半円 spread で粒子の塊として表現
  const streakA = Math.max(0, 1 - age / (life * 0.6))
  if (streakA > 0.01) {
    const N = 8
    for (let i = 0; i < N; i++) {
      // 上半円: -Math.PI 〜 0 (右上〜左上)
      const ang = -Math.PI + hash01(i * 1.9 + age * 5) * Math.PI
      const dist = (15 + hash01(i * 2.7) * 35) * (0.4 + age * 3.5)
      const px = x + Math.cos(ang) * dist
      const py = y + Math.sin(ang) * dist
      const pr = 2.0 + hash01(i * 3.1) * 2.0           // 2-4px
      const colP = hash01(i * 5.7) > 0.5 ? col : col2
      glowMote(ctx, px, py, pr, colP, streakA * (0.5 + hash01(i * 4.3) * 0.5))
    }
  }
}

// P2 経済 (ブループリント §4.1): melee が「受けられた」受け演出。 命中(hit_spark)とは別文法。
//   weapon = 武器で弾く金属の短い火花 (鋭く小さい)。 veil = ヴェールがたわむ布の波 (柔らかく低彩度)。
//   ★手続きプレースホルダ。 専用音と additive 素材は sound/art 部へ handoff。
export function drawGuardSpark(
  ctx: CanvasRenderingContext2D, x: number, y: number, age: number, material: 'weapon' | 'veil',
): void {
  if (material === 'veil') {
    // 布のたわみ: ゆっくり広がる低彩度の楕円波 (受け止めた衝撃を吸う)
    if (age > 0.34) return
    ctx.save()
    const a = Math.max(0, 1 - age / 0.34)
    ctx.globalAlpha = a * 0.5
    ctx.strokeStyle = '#cdbcd6'
    ctx.shadowColor = '#cdbcd6'
    ctx.shadowBlur = 10
    ctx.lineWidth = 2.4 * a
    const r = 8 + age * 90
    ctx.beginPath(); ctx.ellipse(x, y, r, r * 0.6, 0, 0, Math.PI * 2); ctx.stroke()
    ctx.restore()
    return
  }
  // weapon: 弾かれた金属火花 (鋭く・短命・下方向へ散る)
  if (age > 0.20) return
  ctx.save()
  const a = Math.max(0, 1 - age / 0.20)
  ctx.globalAlpha = a
  ctx.strokeStyle = '#e8eef6'
  ctx.shadowColor = '#bcd2ea'
  ctx.shadowBlur = 8
  ctx.lineWidth = 1.6 * a
  for (let i = 0; i < 5; i += 1) {
    const ang = Math.PI * (0.25 + (i / 4) * 0.5)  // 下半球へ扇状に弾ける
    const r1 = 3 + age * 40
    const r2 = r1 + 14
    ctx.beginPath()
    ctx.moveTo(x + Math.cos(ang) * r1, y + Math.sin(ang) * r1)
    ctx.lineTo(x + Math.cos(ang) * r2, y + Math.sin(ang) * r2)
    ctx.stroke()
  }
  ctx.restore()
}

export function drawExecuteFlash(ctx: CanvasRenderingContext2D, x: number, y: number, age: number): void {
  if (age > 0.6) return
  const life = 0.6
  const t = age / life

  // フェードアウト α (全体)
  const aBase = Math.max(0, 1 - t)
  // 発生直後の立ち上がり (最初0.15sで最大へ)
  const aRamp = t < 0.15 ? t / 0.15 : 1

  // 床面の金の砂塵: 旧実装の floorArc (= ctx.stroke の C字弧) を撤去し、 粒子だけで
  //   「衝撃が床に走った」を表現する。 旧弧は UI 図形読みになり安っぽい
  //   ([[reference_fx_worldview_rule]] §禁止: 実線/完全円)。
  const arcR = 70 + age * 80
  const dustA = aBase * aRamp * 0.85
  if (dustA > 0.01) {
    const N = 22
    for (let i = 0; i < N; i += 1) {
      // 角度: 個体ごとに散らす + age を加えて 3 連の各打点で微妙に分布が変わる (リング読みを防ぐ)
      const ang = hash01(i * 1.7 + Math.floor(age * 12) * 0.31) * Math.PI * 2
      // 床 ellipse 上 (perspective squash 0.3) の弧帯 [0.55*R, 1.05*R] に散らす
      const distR = arcR * (0.55 + hash01(i * 2.3) * 0.5)
      const px = x + Math.cos(ang) * distR
      const py = ARENA.floorY + Math.sin(ang) * 0.3 * distR
      const pr = 2.0 + hash01(i * 3.1) * 3.2
      const pa = dustA * (0.45 + hash01(i * 5.3) * 0.5)
      glowMote(ctx, px, py, pr, PALETTE.parrySparkWarm, pa)
    }
  }

  // 打点から外/上へ散る粒子 (旧 taperStreak ×3 を撤去)。
  //   2026-06-24 ユーザー裁定: 細長い光条 (taperStreak) は線として読まれる=
  //   [[reference_fx_worldview_rule]] §禁止カテゴリへ格上げ。 「斬撃の抜き」 感は
  //   上向きベクトルに偏らせた粒子の飛散で表現する。
  //   spread を上半円 (上方向バイアス) に絞った glowMote 散布 = 旧 streak と同じ
  //   時間カーブ (ピーク t=0.08 で減衰)。
  const streakA = aBase * (t < 0.08 ? t / 0.08 : Math.max(0, 1 - (t - 0.08) / 0.5))
  if (streakA > 0.01) {
    const N_UP = 14
    for (let i = 0; i < N_UP; i += 1) {
      // 角度を上半円 (= -Math.PI 〜 0) に限定して「抜き上げ」のベクトルを作る
      const ang = -Math.PI + hash01(i * 1.9 + age * 0.3) * Math.PI
      // 距離は打点近傍 (近い・速い飛散感) でジッター
      const dist = (24 + hash01(i * 2.7) * 60) * (0.4 + age * 4)   // 飛び広がりは age で増加
      const px = x + Math.cos(ang) * dist
      const py = y + Math.sin(ang) * dist
      const pr = 2.5 + hash01(i * 3.3) * 3.5
      const col = hash01(i * 5.7) > 0.7 ? '#f2f7ff' : (hash01(i * 7.1) > 0.5 ? PALETTE.parrySparkWarm : '#cfe0f5')
      glowMote(ctx, px, py, pr, col, streakA * (0.5 + hash01(i * 4.1) * 0.5))
    }
  }

  // 打点の金粉飛散 (全方向の細かな火花)
  emberBurst(ctx, x, y, 14, PALETTE.parrySparkWarm, age, life, 7, 1, 110)
}

export function drawPerfectDodge(ctx: CanvasRenderingContext2D, x: number, y: number, age: number, dir = 1): void {
  if (age > 0.45) return
  const life = 0.45

  // 残像スメア α: 0.75life まで持続 (~0.34s) — 旧 0.55life より長く
  const a = Math.max(0, 1 - age / (life * 0.75))

  // 回避方向への白銀残像スメア: taperStreak ×3 (禁止) を楔型 glowMote ×16 に置換
  //   「移動した軌跡」= -dir 方向に長い楔型の帯に粒を散らして横流動感を維持
  if (a > 0.01) {
    const baseAng = dir > 0 ? Math.PI : 0    // -dir 方向の基準角
    const maxDist = 60 + age * 90            // 元 streak の最長と合わせる
    const N = 16
    for (let i = 0; i < N; i++) {
      // 縦幅 ±15px の楔型に収める (横流動=細長い帯)
      const forwardT = hash01(i * 2.13)                              // 0〜1: 手前〜先端
      const dist = maxDist * (0.15 + forwardT * 0.85)               // 近い〜遠い
      const perpOff = (hash01(i * 3.71) - 0.5) * 30 * (1 - forwardT * 0.6)  // 先端ほど細い
      const flowDrift = age * 20 * hash01(i * 1.37)                 // age で粒が流れる
      const px = x + Math.cos(baseAng) * (dist + flowDrift) + Math.sin(baseAng) * perpOff
      const py = y + Math.sin(baseAng) * (dist + flowDrift) - Math.cos(baseAng) * perpOff
      const pr = 3.0 + hash01(i * 4.11) * 3.0                       // 3-6px
      const col = hash01(i * 5.17) > 0.5 ? '#f2f7ff' : '#cfe0f5'
      glowMote(ctx, px, py, pr, col, a * (0.4 + hash01(i * 6.3) * 0.5))
    }
  }

  // 発生点の冷光フラッシュ: ~0.1s で最大→速く減衰 ("見切った!" のスナップ)
  const flashA = Math.max(0, 1 - age / 0.10)
  if (flashA > 0.01) {
    glowMote(ctx, x, y, 28, '#f2f7ff', flashA * 0.90)
  }

  // きらめきの冷銀火花 (小spread・少量)
  emberBurst(ctx, x, y, 7, '#cfe0f5', age, life * 0.6, 61, 0.6, 90)

  // 持続グロー (フラッシュより長く残る)
  glowMote(ctx, x, y, 16, '#f2f7ff', a * 0.50)
}

export function drawCounterBurst(ctx: CanvasRenderingContext2D, x: number, y: number, age: number): void {
  if (age > 0.5) return
  const life = 0.5

  // 銀金の火花飛散 (hitSpark より大きく速い — カウンターの爽快感)
  emberBurst(ctx, x, y, 14, PALETTE.parrySparkWarm, age, life, 23, 1, 220)
  emberBurst(ctx, x, y,  8, '#f2f7ff',              age, life, 79, 1, 180)

  // 中心からの放射炸裂: taperStreak ×4 (禁止) を全方向 glowMote ×24 に置換
  //   4方向に集中させず全方向ランダム角度で「爆発した」体感を作る
  const streakA = Math.max(0, 1 - age / (life * 0.55))
  if (streakA > 0.01) {
    const N = 24
    for (let i = 0; i < N; i++) {
      const ang = hash01(i * 3.17 + 0.5) * Math.PI * 2    // 全方向ランダム (4方向集中を避ける)
      const dist = (20 + age * 50) * (0.4 + hash01(i * 2.11) * 0.9)
      const px = x + Math.cos(ang) * dist
      const py = y + Math.sin(ang) * dist
      const pr = 3.0 + hash01(i * 4.31) * 3.0              // 3-6px
      const col = hash01(i * 1.73) > 0.4 ? PALETTE.parrySparkWarm : '#f2f7ff'
      glowMote(ctx, px, py, pr, col, streakA * (0.5 + hash01(i * 5.59) * 0.5))
    }
  }
}

// 自分の体幹が満ちてきた時の警告 — 画面端 (2026-07-22)。
//
// ⚠️ なぜ HUD のバーだけでは足りないのか (実機FB「あんまり気づかないかも」→ 調査):
//   ・戦闘中、プレイヤーは **HUD の隅を見ない**。視線を外すのは死に直結するため、
//     隅の情報を確認する数フレームが致命傷になる (Player Research / Game Developer)。
//   ・標準解は **画面端のヴィネット (meta HUD)**。 視線を動かさず「周辺視」で状態を受け取れる。
//     UI 要素を足すのでなく、画面そのものの見え方で状態を伝える。
//   ・SEKIRO は自分の体幹バーを **画面中央下 (キャラの真下)** に置き、割れる直前に橙へ振る。
//   ・格闘ゲーム (SFV 等) は **キャラのポートレートを赤く点滅** させる = 信号をキャラ側へ寄せる。
//   → 本作は左上にバーがあるので隅問題を踏んでいた。 画面端 + 足元 (drawPostureStrainEmbers) の
//     2つで「視線の中心付近」に信号を出す。 バーの色段階はそのまま残す (近くを見た時の確認用)。
//
// 被弾ヴィネット (桃赤 #ff3a6e・0.4秒で消える一発) と混ざらないよう、
//   色 = 琥珀〜朱 (体幹の金の系統) / 動き = 消えずに脈打つ呼吸 で区別する。
// 崩れ (致命が入れられる 1400ms) の合図 — **舞台の照明が絞られる** (2026-07-27)。
//   ユーザー裁定 = docs/candidates/2026-07-26-combat-hud-blank-slate-design-v2.md
//
//   なぜ「ボスを光らせる」ではないか (10体で実測した結論):
//     staggered スプライトの平均明度は 処刑人0.148 〜 先代の姫0.722 まで開いていて、
//     亡霊/虚ろな役者/花嫁/先代の姫 の4体は**元から白い**。 白を乗せても何も起きない。
//     逆に沈めると白い体が背景へ近づいて悪化する。
//   **周囲を沈める**なら体の色に一切依存しない = ボスごとの分岐も明度の表も要らない。
//
//   HUD は何も変えない。 「今だ」は舞台の上で起き、 下端の帯は黙っている
//   (v1 でゲージを白へ跳ねさせたら「画面の重心が下へ落ちる」と実機却下されたため)。
//   ✅ 2026-07-27 ユーザー実機裁定: **③ 深い (0.62)** を採用。 音 (fatal_ready) も同時に on。
//   選ばれなかった値も残す = 後から戻す時の出発点 (①浅い 0.34 / ②標準 0.48)。
//   ⚠️ 「1.4秒ごとに部屋が暗くなるのを繰り返して疲れないか」は短い確認では出ない。
//     v0.5 の通しプレイで再確認する (設計書 v2 §7)。
const SPOT_DEPTH = [0, 0.34, 0.48, 0.62] as const   // 0=切 / 1=浅い / 2=標準 / 3=深い(採用)
const SPOT_DEFAULT_LEVEL = 3
function staggerSpotDepth(): number {
  const lv = import.meta.env.DEV ? ((window as any).__spotLevel ?? SPOT_DEFAULT_LEVEL) : SPOT_DEFAULT_LEVEL
  return SPOT_DEPTH[Math.max(0, Math.min(3, lv))] ?? SPOT_DEPTH[SPOT_DEFAULT_LEVEL]
}
function drawStaggerSpotlight(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (state.phase !== 'playing' || state.finisher || state.deathBeat) return
  const b = state.boss
  if (!b || b.state !== 'staggered' || b.hp <= 0) return
  const depth = staggerSpotDepth()
  if (depth <= 0) return
  // 立ち上がり/引きは時間で補間 = 段差で暗くしない (design_procedural_motion_must_be_smooth)。
  const el = b.stateElapsed
  const total = BOSS.staggerMs / 1000
  const IN = STAGGER_SPOT.inSec, OUT = STAGGER_SPOT.outSec
  const rise = Math.max(0, Math.min(1, el / IN))
  const fall = Math.max(0, Math.min(1, (total - el) / OUT))
  const k = Math.min(rise, fall)
  const ease = k * k * (3 - 2 * k)
  if (ease <= 0.001) return

  const bossH = PLAYER_DISPLAY_HEIGHT * (BOSS_HEIGHT_RATIO[b.id] ?? DEFAULT_BOSS_HEIGHT_RATIO)
  // 中心は画面座標 (広い舞台のカメラ・覚醒獣の大技の縮めに合わせる)。 縮めた時は輪も同じ倍率で小さく。
  const cx = farX(b.x - cameraX)
  const cy = farY(bossFootY(b) - bossH * 0.48)
  const rIn = Math.max(76, bossH * 0.66) * farNow
  const rOut = rIn * 2.5
  const a = depth * ease
  ctx.save()
  applyCamZoomTransform(ctx) // 画面の寄せ (DEV ?camZoom=): 照らす輪をボスの拡大後の位置と大きさへ
  const g = ctx.createRadialGradient(cx, cy, rIn, cx, cy, rOut)
  g.addColorStop(0, 'rgba(4,3,9,0)')
  g.addColorStop(0.55, `rgba(4,3,9,${(a * 0.55).toFixed(3)})`)
  g.addColorStop(1, `rgba(4,3,9,${a.toFixed(3)})`)
  ctx.fillStyle = g
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  // 「部屋が暗くなった」ではなく「照明が当たっている」と読ませるための、 ごく薄い当たり光。
  //   ⚠️ 弱くしか入れない。 ここを強くすると白いボス (花嫁/亡霊/虚ろな役者/先代の姫) で
  //   白飛びして崩れ姿勢が読めなくなる = 明るさに頼らない設計の意味が消える。
  ctx.globalCompositeOperation = 'lighter'
  const lift = ctx.createRadialGradient(cx, cy, 0, cx, cy, rIn * 1.05)
  lift.addColorStop(0, `rgba(255,246,226,${(0.085 * ease).toFixed(3)})`)
  lift.addColorStop(0.6, `rgba(255,240,212,${(0.045 * ease).toFixed(3)})`)
  lift.addColorStop(1, 'rgba(255,236,200,0)')
  ctx.fillStyle = lift
  ctx.fillRect(cx - rIn * 1.05, cy - rIn * 1.05, rIn * 2.1, rIn * 2.1)
  ctx.restore()
}

function drawPostureStrainVignette(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (state.phase !== 'playing' || state.finisher || state.deathBeat) return
  const ratio = Math.max(0, Math.min(1, state.player.posture / playerMaxPosture()))
  const stage = playerPostureStage(ratio)
  if (stage === 'calm') return
  const danger = stage === 'danger'
  // 段の中での進み具合 (0..1)。 端に近いほど濃く = 「じわじわ迫る」
  const warnAt = playerPostureWarnAt()
  const span = danger ? 1 - PLAYER_POSTURE_DANGER_AT : PLAYER_POSTURE_DANGER_AT - warnAt
  const within = Math.min(1, (ratio - (danger ? PLAYER_POSTURE_DANGER_AT : warnAt)) / Math.max(0.0001, span))
  // 心拍: 危険は速い (2.2Hz) / 警戒はゆっくり (1.15Hz)。 「秒読みが速くなった」が体で分かる。
  const hz = danger ? 2.2 : 1.15
  const pulse = 0.5 + 0.5 * Math.sin(state.time * 2 * Math.PI * hz)
  const base = danger ? 0.26 : 0.10
  const swing = danger ? 0.26 : 0.10
  const alpha = (base + swing * pulse) * (0.75 + 0.25 * within)
  // 危険は朱、警戒は琥珀 (バーの色と同じ系統 = 見比べれば同じ意味だと分かる)
  const rv = getRedSignals()   // 画面の赤の分け方 (配布版は b・src/red_signals.ts)。null = 前の見え方
  if (rv === 'a') return       // a: 画面の縁は出さず、足元の熱と体幹の帯だけで知らせる
  if (rv === 'c') { drawPostureSootVignette(ctx, alpha, danger); return }
  const rgb = danger && rv !== 'b' ? '224,80,58' : '224,138,60'   // b: 琥珀のまま朱へ上げない
  const cx = ARENA.width / 2, cy = ARENA.height / 2
  ctx.save()
  // 中央 55% は完全透明 = 敵とレイピアの視認性を絶対に落とさない
  const grad = ctx.createRadialGradient(cx, cy, ARENA.width * 0.30, cx, cy, ARENA.width * 0.62)
  grad.addColorStop(0, `rgba(${rgb},0)`)
  grad.addColorStop(0.55, `rgba(${rgb},${(alpha * 0.35).toFixed(3)})`)
  grad.addColorStop(1, `rgba(${rgb},${alpha.toFixed(3)})`)
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  ctx.restore()
}

// 自分の体幹が満ちてきた時の警告 — 足元 (2026-07-22)。
//   画面端だけだと「何が危ないのか」が分からないので、原因である LUNAIRE 自身にも印を出す。
//   格闘ゲームの「ポートレートが赤く点滅」と同じ役割を、本作の文法 (舞台の現象) で置き換える:
//   足元から立ちのぼる熱 = 立っていられなくなる前触れ。 図形は描かない (FX世界観ルール)。
function drawPostureStrainEmbers(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (state.phase !== 'playing' || state.finisher || state.deathBeat) return
  const ratio = Math.max(0, Math.min(1, state.player.posture / playerMaxPosture()))
  const stage = playerPostureStage(ratio)
  if (stage === 'calm') return
  const danger = stage === 'danger'
  const p = state.player
  const t = state.time
  const hz = danger ? 2.2 : 1.15
  const pulse = 0.5 + 0.5 * Math.sin(t * 2 * Math.PI * hz)
  const rgb = danger ? '224,80,58' : '224,138,60'
  const footY = p.y
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  // 足元の低い熱だまり (楕円グラデ)
  // HUD の初見点検の答え (10-31 p4=b・src/hud_v2.ts): 熱だまりを広く濃く、粒を警戒から出す (警戒 4・危険 9)。図形は足さない。
  //   DEV ?hud=old = 答える前 (狭く薄く・粒は危険だけ)。
  const v2 = !(import.meta.env.DEV && hudOld())
  const grow = v2 ? (danger ? 1.35 : 1.2) : 1
  const rw = (26 + 8 * pulse) * grow, rh = (9 + 3 * pulse) * grow
  const g = ctx.createRadialGradient(p.x, footY - 2, 0, p.x, footY - 2, rw)
  g.addColorStop(0, `rgba(${rgb},${(0.30 + 0.22 * pulse) * (danger ? 1 : 0.6) * (v2 ? 1.35 : 1)})`)
  g.addColorStop(1, `rgba(${rgb},0)`)
  ctx.fillStyle = g
  ctx.save()
  ctx.translate(p.x, footY - 2); ctx.scale(1, rh / rw); ctx.translate(-p.x, -(footY - 2))
  ctx.beginPath(); ctx.arc(p.x, footY - 2, rw, 0, Math.PI * 2); ctx.fill()
  ctx.restore()
  // 立ちのぼる粒 (危険のみ・数は少なく)。 hash で決めるので毎フレーム同じ粒が上へ流れる。
  const embers = v2 ? (danger ? 9 : 4) : (danger ? 5 : 0)
  if (embers > 0) {
    for (let i = 0; i < embers; i++) {
      const seed = hash01(i * 7.13)
      const cycle = (t * (0.55 + seed * 0.3) + seed) % 1
      const ex = p.x + (seed - 0.5) * 34 * grow
      const ey = footY - 4 - cycle * (34 + seed * 16) * (v2 && danger ? 1.5 : 1)
      const a = (1 - cycle) * (0.5 + 0.5 * pulse) * 0.55 * (v2 ? (danger ? 1.3 : 0.8) : 1)
      ctx.fillStyle = `rgba(${rgb},${a.toFixed(3)})`
      ctx.beginPath(); ctx.arc(ex, ey, 1.3 + seed * 0.9, 0, Math.PI * 2); ctx.fill()
    }
  }
  ctx.restore()
}

// 画面の赤の比較版 c (開発版だけ): 体幹の危険を、縁から寄る煤の暗がりで知らせる (視界が狭まる)。色は赤にしない。
//   縁は形を持たせず、ゆらぐ濃淡だけ (線・輪に見せない)。
function drawPostureSootVignette(ctx: CanvasRenderingContext2D, alpha: number, danger: boolean): void {
  const cx = ARENA.width / 2, cy = ARENA.height / 2
  const a = Math.min(0.85, alpha * (danger ? 2.1 : 1.4))
  ctx.save()
  const grad = ctx.createRadialGradient(cx, cy, ARENA.width * (danger ? 0.26 : 0.32), cx, cy, ARENA.width * 0.64)
  grad.addColorStop(0, 'rgba(14,10,14,0)')
  grad.addColorStop(0.5, `rgba(14,10,14,${(a * 0.45).toFixed(3)})`)
  grad.addColorStop(1, `rgba(8,6,9,${a.toFixed(3)})`)
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  ctx.restore()
}

function drawDamageVignette(ctx: CanvasRenderingContext2D, fx: FxEvent[], now: number): void {
  const v = fx.find((f) => f.kind === 'damage_vignette') as Extract<FxEvent, { kind: 'damage_vignette' }> | undefined
  if (!v) return
  const age = now - v.t
  const rv = getRedSignals()   // 画面の赤の分け方 (配布版は b・src/red_signals.ts)
  if (rv === 'b' || rv === 'c') { drawDamageNoRed(ctx, age, rv); return }
  if (age > 0.4 || age < 0) return
  const a = Math.max(0, 1 - age / 0.4)
  ctx.save()
  const grad = ctx.createRadialGradient(
    ARENA.width / 2, ARENA.height / 2, ARENA.width * 0.25,
    ARENA.width / 2, ARENA.height / 2, ARENA.width * 0.7,
  )
  grad.addColorStop(0, 'rgba(255,58,110,0)')
  grad.addColorStop(1, `rgba(255,58,110,${0.55 * a})`)
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  ctx.restore()
}

// 画面の赤の比較版 (開発版だけ): 被弾を赤以外で知らせる。
//   b = 白い灰の短い閃き (0.25秒・縁から)。 c = 画面が一瞬暗く沈む (縁ほど深く・0.35秒)。
function drawDamageNoRed(ctx: CanvasRenderingContext2D, age: number, rv: 'b' | 'c'): void {
  const dur = rv === 'b' ? 0.25 : 0.35
  if (age > dur || age < 0) return
  const a = Math.max(0, 1 - age / dur)
  ctx.save()
  if (rv === 'b') {
    const grad = ctx.createRadialGradient(ARENA.width / 2, ARENA.height / 2, ARENA.width * 0.22, ARENA.width / 2, ARENA.height / 2, ARENA.width * 0.7)
    grad.addColorStop(0, 'rgba(244,236,228,0)')
    grad.addColorStop(1, `rgba(244,236,228,${(0.5 * a).toFixed(3)})`)
    ctx.globalCompositeOperation = 'lighter'
    ctx.fillStyle = grad
  } else {
    // 彩度は落とさない (落とすと弾けない技の赤まで一瞬消える＝10-30 撮って確かめた)。縁ほど深く沈む暗がりだけ。
    const grad = ctx.createRadialGradient(ARENA.width / 2, ARENA.height / 2, ARENA.width * 0.18, ARENA.width / 2, ARENA.height / 2, ARENA.width * 0.7)
    grad.addColorStop(0, `rgba(4,3,6,${(0.22 * a).toFixed(3)})`)
    grad.addColorStop(1, `rgba(4,3,6,${(0.62 * a).toFixed(3)})`)
    ctx.fillStyle = grad
  }
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  ctx.restore()
}

// ============== HUD (Phase 4.16: ER/SEKIRO 風の存在感) ==============
//  - プレイヤーUI: 左上で大きく
//  - ボスUI: 画面下中央にドンと、HPバーは横長で存在感あり
function drawHud(ctx: CanvasRenderingContext2D, state: GameState): void {
  drawPlayerHud(ctx, state)
  if (import.meta.env.DEV && cardHudDemoActive(state)) return
  if (!drawBossHudSilverFromState(ctx, state)) drawBossHud(ctx, state)
  // HUD の比較版 (DEV ?hud=v2・src/hud_v2.ts): 声が戦闘中に一言だけ教える (幕の玉・体力が満ちる・崩れても紫は弾ける)。
  if (import.meta.env.DEV && hudV2() && state.phase === 'playing') {
    const line = hudV2Line(state.time)
    if (line) drawBattleWhisper(ctx, line.text, line.age, HUD_V2_LINE_SEC, line.instant)
  }
}

const cardHudDemoEnabled = import.meta.env.DEV && typeof window !== 'undefined'
  && new URLSearchParams(window.location.search).get('cardDemo') === '1'
let cardHudPreview: ReturnType<typeof createBossHudPreviewState> | null = null
function cardHudDemoActive(state: GameState): boolean {
  return cardHudDemoEnabled && state.boss.id === 'nameless-shade' && activeTipsCard(state)?.card.id === 'execute'
}

// ボスHUD「月光の銀線細工」(2026-10-04・src/boss_hud_view.ts)。画像の読み込み中だけ旧 HUD (drawBossHud)。
//   旧 HUD との見比べ = DEV ?bossHud=legacy・横幅の比較版 = DEV ?bossHud=wide60|wide70|wide80 (URL は game.ts の DEV の箱で読む・boss_hud_view.ts setBossHudMode)。
function drawBossHudSilverFromState(ctx: CanvasRenderingContext2D, state: GameState, demo?: CardHudDemo): boolean {
  if (import.meta.env.DEV && bossHudLegacyMode() && !demo) return false
  let parryAge = 999, parryJust = false
  for (const f of state.fx) {
    if (f.kind === 'parry_spark') {
      const a = state.time - f.t
      if (a >= 0 && a < parryAge) { parryAge = a; parryJust = !!f.isJust }
    }
  }
  if (demo) { parryAge = demo.parryAgeSec; parryJust = demo.parryWasJust }
  const pratio = demo ? demo.posture / demo.maxPosture : state.boss.posture / state.boss.maxPosture
  const flash = parryAge < 0.35 ? 1 - parryAge / 0.35 : 0
  const chainStep = demo ? 1 : Math.max(1, state.player.parryChain)
  const escal = (1 + (pratio >= 0.8 ? 0.5 : 0)) * (1 + (chainStep - 1) * COMBAT.parryChain.popBoostPerStep)
  const staggered = demo ? demo.staggered : state.boss.state === 'staggered'
  return drawBossHudSilver(ctx, {
    bossId: state.boss.id,
    name: state.boss.displayName,
    postureRatio: pratio,
    breakReadyRatio: demo ? breakReadyRatio({ maxPosture: demo.maxPosture, executesTaken: 0, roomCount: 1 })
      : breakReadyRatio(state.boss, parryGainHpMul(state.boss) * bossPostureGainMul(state.boss)),
    staggered,
    omen: staggered ? 0 : crackOmenIntensity(pratio),
    flash: flash * escal,
    parryAgeSec: parryAge,
    parryWasJust: parryJust,
    hpFraction: actRefillCap(state, state.boss.hp <= chipFloor(state.boss) ? 0 : roomHpFraction(state.boss)),
    actMarksW: actMarksWidth(state),
    drawActMarks: (x, baseY) => drawActMarks(ctx, state, x, baseY),
    // 連撃3段目の得 (配布版の既定・10-12) の縁の光。DEV ?combo3rd=off の時は FX が出ない = 0 = 光らない。白い残り (heavyGhost) は DEV &combo3rdBar=1 の時だけ。
    //   稽古の間だけの真鍮の印・斜めの刻み (postureHoldSaved) は 10-12 の答え E-2「要らない」で渡さない (boss_hud_view.ts の描く側は未使用で残してある)。
    postureHold: demo ? 0 : postureHoldLevel(state.boss, state.fx, state.time),
    heavyGhost: demo ? null : heavyBarGhost(state.boss, state.fx, state.time),
  })
}

// 自分の体幹バーの色と危険段階。 純関数 (テスト対象)。
//   段: 平常 (燻し金) → 警戒 65% (橙) → 危険 90% (朱)。 色そのものが「あと何発か」を伝える。
//   警戒はガード2回 (67〜68%) で色が変わるよう 65% (10-31 作者の答え p1=a・src/hud_v2.ts)。DEV ?hud=old = 75%。
//   出所: 2026-07-22 ユーザー裁定「体幹はボスと同じ金系へ。ただし自分が崩れそうな時は
//        しっかり危険が伝わる工夫をしてほしい」。
export const PLAYER_POSTURE_WARN_AT = HUD_V2_WARN_AT
export const PLAYER_POSTURE_DANGER_AT = 0.90

/** 警戒の段の始まり。DEV ?hud=old の時だけ答える前の 0.75。 */
export function playerPostureWarnAt(): number {
  return import.meta.env.DEV && hudOld() ? HUD_OLD_WARN_AT : PLAYER_POSTURE_WARN_AT
}

export function playerPostureStage(ratio: number): 'calm' | 'warn' | 'danger' {
  if (ratio >= PLAYER_POSTURE_DANGER_AT) return 'danger'
  if (ratio >= playerPostureWarnAt()) return 'warn'
  return 'calm'
}

export function playerPostureColor(ratio: number): string {
  switch (playerPostureStage(ratio)) {
    case 'danger': return PALETTE.hudPlayerPostureDanger
    case 'warn': return PALETTE.hudPlayerPostureWarn
    default: return PALETTE.hudPlayerPosture
  }
}

function drawPlayerHud(ctx: CanvasRenderingContext2D, state: GameState): void {
  // ハート (赤・セル暗縁)。 初演は実効最大HPが2倍 = 命灯は5個のまま1個あたりの重み(HP)が増える。
  drawLifeLamps(ctx, 32, 24, state.player.hp, playerMaxHp(), PLAYER.lifeLampCount)
  // 体幹バー — ボス体幹と同じ金系 (2026-07-22 D1 更新)。 自分側は一段暗い燻し金。
  //   幅は命灯の直下に収まる120px。
  const bx = 32, by = 66, bw = 120, bh = 8
  const ratio = Math.max(0, Math.min(1, state.player.posture / playerMaxPosture()))
  drawCelBar(ctx, bx, by, bw, bh, ratio, playerPostureColor(ratio),
    { danger: true, track: PALETTE.hudPlayerPostureTrack })
  drawPlayerPostureAlarm(ctx, bx, by, bw, bh, ratio)
  // スタミナバーは廃止 (2026-06-17)
}

// 崩れが近い時の警報。 バーの色 (段階) に重ねて「外へ広がる縁」で視線を引く。
//   ⚠️ 画面全体を赤くするような強い演出はここでは出さない (被弾と紛れるため)。
//   警戒 = ゆっくり脈打つ縁 / 危険 = 速い脈 + 外側にもう1本 + 両端の楔。
function drawPlayerPostureAlarm(
  ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, ratio: number,
): void {
  const stage = playerPostureStage(ratio)
  if (stage === 'calm') return
  const danger = stage === 'danger'
  const t = performance.now() / 1000
  // 危険は約2倍の速さで脈打つ = 「秒読みが速くなった」と体で分かる。
  const pulse = 0.5 + 0.5 * Math.abs(Math.sin(t * (danger ? 9.5 : 4.6)))
  const col = danger ? PALETTE.hudPlayerPostureDanger : PALETTE.hudPlayerPostureWarn
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  // 縁 (1本目): バーのすぐ外
  ctx.strokeStyle = col
  ctx.globalAlpha = (danger ? 0.55 : 0.34) * (0.45 + 0.55 * pulse)
  ctx.lineWidth = 1.5
  ctx.strokeRect(x - 3.5, y - 3.5, w + 7, h + 7)
  if (danger) {
    // 縁 (2本目): さらに外へ広がる = 「もう猶予が無い」
    const spread = 3 + pulse * 4
    ctx.globalAlpha = 0.3 * pulse
    ctx.lineWidth = 1
    ctx.strokeRect(x - 3.5 - spread, y - 3.5 - spread, w + 7 + spread * 2, h + 7 + spread * 2)
    // 両端の楔 (崩し間際のボス体幹 omen と同じ語彙で「割れる寸前」を示す)
    ctx.globalAlpha = 0.5 + 0.5 * pulse
    ctx.fillStyle = col
    const wd = 3.2
    for (const [ex, sign] of [[x - 5, -1], [x + w + 5, 1]] as Array<[number, number]>) {
      ctx.beginPath()
      ctx.moveTo(ex, y + h / 2 - wd)
      ctx.lineTo(ex + sign * wd, y + h / 2)
      ctx.lineTo(ex, y + h / 2 + wd)
      ctx.closePath(); ctx.fill()
    }
  }
  ctx.restore()
}

// セルバー: 暗縁(四角) + 溝 + フラット塗り + 上半分ツヤ帯。 アニメ調の共通描画
function drawCelBar(
  ctx: CanvasRenderingContext2D,
  x: number, y: number, w: number, h: number,
  ratio: number, color: string,
  opts: { danger?: boolean; track?: string; flash?: number; rainbow?: boolean },
): void {
  ctx.save()
  const r = Math.max(0, Math.min(1, ratio))
  // 暗縁 (四角・2px)
  ctx.fillStyle = PALETTE.hudOutline
  ctx.fillRect(x - 2, y - 2, w + 4, h + 4)
  // 空きトラック
  ctx.fillStyle = opts.track ?? PALETTE.hudGroove
  ctx.fillRect(x, y, w, h)
  // 崩れ間際の明滅 (体幹) / 報酬フラッシュ時もグロー / 崩し中の虹も発光
  const flash = opts.flash ?? 0
  if ((opts.danger && r >= 0.8) || flash > 0 || opts.rainbow) {
    const pulse = 0.6 + Math.abs(Math.sin(performance.now() / 1000 * 14)) * 0.4
    ctx.shadowColor = opts.rainbow ? '#ffffff' : color
    ctx.shadowBlur = Math.max(14 * (opts.danger && r >= 0.8 ? pulse : 0), 20 * flash, opts.rainbow ? 16 : 0)
  }
  // 崩し成立 = 致命確定。 パチンコ/パチスロの「虹=確定演出」を再現 (色ヒエラルキーの頂点)。
  //   流れる虹箔 + 脈動ブルーム + 鏡面スイープ + 金の確定枠 + キラキラ を"ゴリゴリ"に重ねる。
  if (opts.rainbow && r > 0) {
    const tm = performance.now() / 1000
    const fw = w * r
    // 血と金の鼓動: 崩し成立=致命確定。 深紅(血)⇄金を心臓の二連拍(ドクン…ドクン)で脈動。
    //    暗く生々しい死にゲーの脈。 金=崩しの色(UI規則)、 赤=血(既定パレット差し色)。
    const hb = heartbeatPulse(tm)
    const crimson: [number, number, number] = [120, 30, 38]   // 深紅 (#a83a3a を落とした血)
    const gold: [number, number, number] = [244, 216, 120]    // 金 (#f4d878)
    const base = lerpRgb(crimson, gold, hb * 0.9)             // 拍の頂点で金へ寄る
    const pop = hb * (h * 0.26)                               // 拍で僅かに膨らむ
    const by = y - pop, bh = h + pop * 2
    // 縦グラデ: 上=明 / 下=ベース
    const topCol = lerpRgb(crimson, gold, Math.min(1, hb * 0.9 + 0.18))
    const vg = ctx.createLinearGradient(0, by, 0, by + bh)
    vg.addColorStop(0, topCol)
    vg.addColorStop(1, base)
    ctx.shadowColor = `rgba(244,216,120,${0.4 + hb * 0.55})`  // 拍でグローが跳ねる
    ctx.shadowBlur = 8 + hb * 24
    ctx.fillStyle = vg
    ctx.fillRect(x, by, fw, bh)
    ctx.shadowBlur = 0
    // 上ツヤ (拍で強まる)
    ctx.globalAlpha = 0.16 + hb * 0.22
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(x, by, fw, Math.max(1, bh * 0.34))
    ctx.globalAlpha = 1
    // 金の確定枠 (拍で輝く)
    const goldA = 0.45 + hb * 0.5
    ctx.strokeStyle = `rgba(244,216,120,${goldA})`
    ctx.lineWidth = 1.5
    ctx.strokeRect(x - 0.5, by - 0.5, fw + 1, bh + 1)
  } else {
    ctx.fillStyle = color
    ctx.fillRect(x, y, w * r, h)
    ctx.shadowBlur = 0
    // 上半分ツヤ帯
    ctx.fillStyle = PALETTE.hudGloss
    ctx.fillRect(x, y, w * r, Math.max(1, h * 0.45))
  }
  // 報酬フラッシュ: 弾いた瞬間、 満ちた部分が白く光り、 先端がギラッと伸びる
  if (flash > 0 && r > 0) {
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = flash * 0.55
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(x, y, w * r, h)                         // 満ちた部分の白フラッシュ
    // 先端のギラッ (縦の明るい帯)
    const tipX = x + w * r
    ctx.globalAlpha = flash
    const tipG = ctx.createLinearGradient(tipX - 10, 0, tipX + 4, 0)
    tipG.addColorStop(0, 'rgba(255,255,255,0)')
    tipG.addColorStop(1, '#ffffff')
    ctx.fillStyle = tipG
    ctx.fillRect(tipX - 10, y - 2, 14, h + 4)
  }
  ctx.restore()
}

// P4.5 連続弾き最高潮: 火花コアの色温度。 intensity≤1 は通常パリィの冷白(銀)規定を壊さず、
//   1.0 を超えるほど温かい白金 (#fff6e0→#ffe9b8 方向) へブレンドし「5段=熱を帯びた最高潮」を色でも出す。
//   返値は #rrggbb。 純粋関数 (回帰テスト対象)。
export function sparkCoreColor(intensity: number): string {
  // 銀(冷白)の基準コア = #f0ecff。 白金の到達色 = #ffe9b8 (温かい琥珀寄りの金白)。
  const cool: [number, number, number] = [0xf0, 0xec, 0xff]
  const platinum: [number, number, number] = [0xff, 0xe9, 0xb8]
  // intensity 1.0 で 0 (銀のまま) → 上限 2.0 で 1 (白金) へ。 1未満は常に銀。
  const span = COMBAT.parryChain.sparkIntensityMax - 1
  const t = span <= 0 ? 0 : Math.max(0, Math.min(1, (intensity - 1) / span))
  const mix = (a: number, b: number): number => Math.round(a + (b - a) * t)
  const r = mix(cool[0], platinum[0])
  const g = mix(cool[1], platinum[1])
  const b = mix(cool[2], platinum[2])
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
}

// P4 Task2: ボスHUDの座標を純粋関数に切り出し (SEKIRO位置=画面上部中央) — 回帰テスト対象。
//   描画副作用を持たないので vitest から安全に import できる。
// 割れる予兆 (P4 §6.3): 体幹90%超で 0→1 に立ち上がる明滅強度。崩し(満タン)直前の昂揚。
export function crackOmenIntensity(postureRatio: number): number {
  if (postureRatio < 0.9) return 0
  return Math.min(1, (postureRatio - 0.9) / 0.1)
}

export function bossHudLayout(arenaW: number): {
  cx: number; barX: number; barW: number;
  nameY: number; postureY: number; hpY: number; lampY: number;
  troughH: number;
} {
  const cx = arenaW / 2
  const barW = 460
  // 下端配置: 全要素を画面下100px内に収める。 上から nameY→postureY→hpY の順。
  //   ⚠️ lampY は 2026-07-27 に「灯の位置」ではなくなった (灯は役札の行の右端 = drawActLamps へ移設)。
  //     今は **HUD帯の上端の基準線** としてだけ生きている (下端スクリム / 舞台額縁の罫)。
  //     名前を変えると参照箇所が散るので据え置き。 灯の位置には使わないこと。
  // troughH=28 により hpY を 510→524 に下げて体幹バー下端 (490+28=518) との重なりを回避。
  return {
    cx, barW, barX: cx - barW / 2,
    nameY: 476, postureY: 490, hpY: 524, lampY: 458,
    troughH: 28,
  }
}

// 幕票 (残り幕数) — 役札の中に収める印。 2026-07-27 再設計。
//   経緯: ①元は床のすぐ下・画面中央 (y448) = 主人公のブーツと同じ場所で常に隠れていた
//        ②ボスの頭上へ吊ったら「追従する光はダメ」で却下
//        ③帯の右端へ離したら「点が宙に浮く / 対称が崩れた」+「消えた印が見えず総数が読めない」
//   → **札の中**に入れる。 暗い象牙紙の上なので背景の金と競合せず、 主人公とも重ならず、
//     札ごと中央にあるので左右の罫線の対称も保てる。
//   ⚠️ 「残り」だけでなく**総数**が読めることが要件 (友達 3-1「何回致命したら勝ちか」)。
//     消えた幕も必ず見える形で描く。
//   ✅ **形は 2026-07-28 に「丸」で確定** (ユーザー実機比較 → 「丸でOK。他の2つは世界観から浮いている」)。
//     比較用の3案切替 (dev __lampStyle / キー5) と 灯・刻み の実装は撤去した。
//     復元が要るときは commit `3b65de0` 時点の render.ts / main.ts を見ること
//     (SE確定時に fxlab の聞き比べを撤去したのと同じ流儀)。
//   ⚠️ 「世界観に合わせる」= 記号の●○ではなく**真鍮の輪に灯が入った玉**にする。
//     輪は点いていても消えていても必ず描く → 総数が読める要件を形そのものが満たす。
//     輪 = 名札の横罫と同じ「退色した真鍮」/ 灯 = 金の灯 (旧の理由「常夜燈と同じ金」は常夜燈が青になって外れた。
//     10-11 朝の答え act-mark-gold「金のまま」= 真鍮の輪・体幹のゲージと同じ系統でなじむため。青は常夜燈だけの色に取っておく)。
const ACT_MARK_PITCH = 17
function actMarkCount(state: GameState): number {
  // 軍配者たち: 3幕目は現れるまで印を2つに見せる (src/twins_fight.ts twinsActMarks)。
  const tw = twinsActMarks(state.boss, state.time)
  return tw ? tw.count : Math.max(1, state.boss.roomCount)
}
function actMarksWidth(state: GameState): number {
  return (actMarkCount(state) - 1) * ACT_MARK_PITCH + 10
}

function drawActMarks(
  ctx: CanvasRenderingContext2D, state: GameState, x: number, baseY: number,
): void {
  const n = actMarkCount(state)
  const lit = Math.max(0, n - state.boss.executesTaken)
  if (import.meta.env.DEV) { actMarksAt.x = x; actMarksAt.y = baseY; actMarksAt.w = actMarksWidth(state); actMarksAt.ok = true }
  const tw = twinsActMarks(state.boss, state.time)
  const defeated = state.boss.hp <= 0
  // 玉が消える瞬間を強く (10-31 作者の答え p2=b): 一度強く光ってから 1.6 秒かけてゆっくり消える。DEV ?hud=old = 0.85 秒で薄れるだけ。
  const old = import.meta.env.DEV && hudOld()
  const SNUFF = old ? ACT_MARK_SNUFF_OLD_SEC : ACT_MARK_SNUFF_SEC
  const snuff: Map<number, number> = new Map()
  const snuffAge: Map<number, number> = new Map()
  for (const f of state.fx) {
    if (f.kind === 'lamp_snuff') {
      const age = state.time - f.t
      const idx = tw ? tw.snuffIndex(f.lampIndex) : f.lampIndex
      if (age >= 0 && age < SNUFF) { snuff.set(idx, age / SNUFF); snuffAge.set(idx, age) }
    }
  }
  const t = performance.now() / 1000
  for (let i = 0; i < n; i += 1) {
    const cx = x + 5 + i * ACT_MARK_PITCH
    const prog = snuff.get(i)
    const on = !defeated && ((tw ? tw.lit[i] : i < lit) || (prog !== undefined && state.phase === 'playing'))
    // 答えの版は光った後を長く残す (前半ゆっくり・後半で抜ける)
    const fade = prog === undefined ? 1 : old ? Math.max(0, 1 - prog) : Math.max(0, 1 - prog * prog)
    drawActMarkDot(ctx, cx, baseY, on, fade, t, i)
    const age = snuffAge.get(i)
    if (!old && on && age !== undefined && age < ACT_MARK_FLASH_SEC) drawActMarkFlash(ctx, cx, baseY - 6, age / ACT_MARK_FLASH_SEC)
  }
}

// 幕の玉が消える瞬間の強い光 (p2=b)。珠の芯が白く灼けて、にじみが一瞬だけ受け座の外へ広がって引く。
//   ⚠️ 普段のにじみ (drawActMarkDot・R*1.55) は広げない。広がるのはこの 0.32 秒だけ。
function drawActMarkFlash(ctx: CanvasRenderingContext2D, cx: number, cy: number, k: number): void {
  const R = ACT_MARK_R
  const a = k < 0.15 ? k / 0.15 : Math.pow(1 - (k - 0.15) / 0.85, 1.6)
  const r = R * (1.6 + 1.6 * Math.min(1, k * 2.2))
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const g = ctx.createRadialGradient(cx, cy, R * 0.2, cx, cy, r)
  g.addColorStop(0, `rgba(255,248,226,${(0.95 * a).toFixed(3)})`)
  g.addColorStop(0.35, `rgba(246,206,128,${(0.55 * a).toFixed(3)})`)
  g.addColorStop(1, 'rgba(214,160,72,0)')
  ctx.fillStyle = g
  ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.fill()
  ctx.restore()
}

// 幕が変わった直後の相手の体力の見え方 (10-31 作者の答え p3=a): 一瞬で満タンにせず、約1秒で左から右へ満ちる。
//   戦闘の値 (boss.hp) は変えない。見せる長さだけ上限をかける。DEV ?hud=old = 一瞬で満タン。
function actRefillCap(state: GameState, frac: number): number {
  if (import.meta.env.DEV && hudOld()) return frac
  let age = Infinity
  for (const f of state.fx) if (f.kind === 'lamp_snuff') { const a = state.time - f.t; if (a >= 0 && a < age) age = a }
  if (age >= ACT_REFILL_SEC) return frac
  const k = age / ACT_REFILL_SEC
  return Math.min(frac, 1 - (1 - k) * (1 - k))
}

// 幕票の印 — **真鍮の受け座にはまった琥珀の珠**。 済んだ幕は珠が抜けて受け座だけが残る。
//   ⚠️ **受け座は点いていても消えていても必ず同じ位置・同じ太さで描く。** これが総数を読ませる
//     本体で、中に珠が在るかだけが「残っているか」を表す (友達 3-1「何回致命したら勝ちか」)。
//
//   🔴 「世界観から浮く」の正体 (2026-07-28 実機比較で特定):
//     **平らな円 + ぼかしグロー = 現代的な UI の語彙**。 素材も光源も無いのでゲームの外に見える。
//     直したのは3点 — いずれも「物として在る」ための処理:
//       ① ぼかしグローを大幅に削り、代わりに**硬い縁 (受け座)** を立てる
//       ② 珠のハイライトを**左上へ寄せる** = 舞台照明が上から来ている (設計 1-6) と一致する
//       ③ 済んだ幕を「輪郭線」ではなく**空いた受け座**にする
//          (上の内側が暗く落ち、下の内側に真鍮の照り返しが残る = 穴に見える)
//     色は既存の語彙から取る: 受け座 = 名札の横罫と同じ退色した真鍮 / 珠 = 金の灯 (10-11 朝「金のまま」・上の注)。
const ACT_MARK_R = 4.6
function drawActMarkDot(
  ctx: CanvasRenderingContext2D, cx: number, baseY: number, on: boolean, fade: number, t: number, i: number,
): void {
  const cy = baseY - 6
  const R = ACT_MARK_R
  ctx.save()

  // 札の上に「乗っている」ための落ち影 (上から照らされているので影は真下・小さく)。
  ctx.fillStyle = 'rgba(0,0,0,0.38)'
  ctx.beginPath(); ctx.ellipse(cx, cy + R * 0.72, R * 0.82, R * 0.34, 0, 0, Math.PI * 2); ctx.fill()

  if (on) {
    const fl = 0.9 + 0.1 * Math.sin(t * 5.5 + i * 1.7)
    // 珠のにじみ。 ⚠️ ここを広げると元の「UIの点」へ戻る。 受け座が読める範囲に留める。
    ctx.globalCompositeOperation = 'lighter'
    const halo = ctx.createRadialGradient(cx, cy, R * 0.6, cx, cy, R * 1.55)
    halo.addColorStop(0, `rgba(236,190,112,${(0.34 * fade * fl).toFixed(3)})`)
    halo.addColorStop(1, 'rgba(214,160,72,0)')
    ctx.fillStyle = halo
    ctx.beginPath(); ctx.arc(cx, cy, R * 1.55, 0, Math.PI * 2); ctx.fill()
    ctx.globalCompositeOperation = 'source-over'
    // 珠の本体。 中心を左上へずらした球のグラデーション = 上から照らされた琥珀。
    const bead = ctx.createRadialGradient(cx - R * 0.32, cy - R * 0.36, R * 0.1, cx, cy, R * 0.92)
    bead.addColorStop(0, `rgba(255,246,214,${(0.98 * fade).toFixed(3)})`)
    bead.addColorStop(0.45, `rgba(240,198,116,${(0.96 * fade * fl).toFixed(3)})`)
    bead.addColorStop(1, `rgba(160,104,38,${(0.94 * fade).toFixed(3)})`)
    ctx.fillStyle = bead
    ctx.beginPath(); ctx.arc(cx, cy, R * 0.9, 0, Math.PI * 2); ctx.fill()
    // 点光源の映り込み (小さく硬い = 磨かれた表面)
    ctx.fillStyle = `rgba(255,252,236,${(0.9 * fade).toFixed(3)})`
    ctx.beginPath(); ctx.ellipse(cx - R * 0.34, cy - R * 0.4, R * 0.2, R * 0.15, -0.5, 0, Math.PI * 2); ctx.fill()
  } else {
    // 空いた受け座。 穴に見せるため上下で明暗を逆にする (上=影 / 下=真鍮の照り返し)。
    const hole = ctx.createLinearGradient(0, cy - R, 0, cy + R)
    hole.addColorStop(0, 'rgba(10,7,5,0.92)')
    hole.addColorStop(1, 'rgba(58,46,32,0.86)')
    ctx.fillStyle = hole
    ctx.beginPath(); ctx.arc(cx, cy, R * 0.88, 0, Math.PI * 2); ctx.fill()
    ctx.strokeStyle = 'rgba(150,124,80,0.55)'
    ctx.lineWidth = 0.9
    ctx.beginPath(); ctx.arc(cx, cy, R * 0.72, Math.PI * 0.18, Math.PI * 0.82); ctx.stroke()
  }

  // 受け座 (常に同じ = 総数が読める)。 外周の暗い縁で札から浮かせ、内側の真鍮線で形を締める。
  ctx.strokeStyle = 'rgba(26,18,10,0.9)'
  ctx.lineWidth = 1.7
  ctx.beginPath(); ctx.arc(cx, cy, R + 0.5, 0, Math.PI * 2); ctx.stroke()
  ctx.strokeStyle = on ? 'rgba(206,176,116,0.95)' : 'rgba(138,120,86,0.9)'
  ctx.lineWidth = 1.1
  ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.stroke()
  // 受け座の上縁だけ明るく = 光が上から当たっている
  ctx.strokeStyle = on ? 'rgba(255,236,190,0.85)' : 'rgba(188,168,126,0.6)'
  ctx.lineWidth = 0.9
  ctx.beginPath(); ctx.arc(cx, cy, R, Math.PI * 1.12, Math.PI * 1.88); ctx.stroke()

  ctx.restore()
}

// ボス体幹バー専用描画。完全 Canvas 描画 (A案・直角四角・白っぽい枠)。
// 描画レイヤー: L1. 黒漆ベース → L2. 月金fill (clip reveal) → L2.5. staggered金白脈動 → L3. 先端液面ライン → L4. パリィflash → L5. omen楔 → L6. 白っぽい枠
function drawBossPostureGauge(
  ctx: CanvasRenderingContext2D,
  L: ReturnType<typeof bossHudLayout>,
  ratio: number,
  flash: number,
  staggered: boolean,
  omen: number,
): void {
  const r = Math.max(0, Math.min(1, ratio))
  const x = L.barX
  const y = L.postureY
  const w = L.barW
  const h = L.troughH  // 28
  const fillW = w * r

  ctx.save()

  // L1: 内側 黒漆 ベース (空状態の背景)
  ctx.fillStyle = '#0e1018'
  ctx.fillRect(x, y, w, h)

  // L2: 月金 fill (左から ratio 幅・縦グラデ)
  if (fillW > 0) {
    ctx.save()
    ctx.beginPath()
    ctx.rect(x, y, fillW, h)
    ctx.clip()
    const g = ctx.createLinearGradient(0, y, 0, y + h)
    g.addColorStop(0.00, '#f5d860')
    g.addColorStop(0.50, '#d0a838')
    g.addColorStop(1.00, '#564214')
    ctx.fillStyle = g
    ctx.fillRect(x, y, fillW, h)

    // L2.5: staggered 時の金白脈動 (前回追加処理を維持)
    if (staggered) {
      ctx.globalCompositeOperation = 'lighter'
      const pulse = 0.5 + 0.5 * Math.sin(performance.now() / 1000 * 6)
      ctx.globalAlpha = 0.30 + pulse * 0.32
      ctx.fillStyle = 'rgba(255,245,180,1)'
      ctx.fillRect(x, y, fillW, h)
      const cxs = x + fillW * 0.5
      const cys = y + h / 2
      const radius = Math.max(40, fillW * 0.4)
      const spot = ctx.createRadialGradient(cxs, cys, 0, cxs, cys, radius)
      spot.addColorStop(0, `rgba(255,255,255,${0.40 + pulse * 0.40})`)
      spot.addColorStop(1, 'rgba(255,255,255,0)')
      ctx.globalAlpha = 1
      ctx.fillStyle = spot
      ctx.fillRect(x, y, fillW, h)
    }
    ctx.restore()

    // L3: 先端液面ライン (additive 月金 1.5px)
    if (!staggered && r > 0.02 && r < 0.998) {
      const tipX = x + fillW
      ctx.save()
      ctx.globalCompositeOperation = 'lighter'
      ctx.fillStyle = `rgba(240,218,100,${0.30 + r * 0.30})`
      ctx.fillRect(tipX - 1, y + 4, 1.5, h - 8)
      ctx.restore()
    }

    // L4: パリィ flash (clip 領域内に additive 白)
    if (flash > 0 && !staggered) {
      ctx.save()
      ctx.beginPath()
      ctx.rect(x, y, fillW, h)
      ctx.clip()
      ctx.globalCompositeOperation = 'lighter'
      ctx.globalAlpha = flash * 0.42
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(x, y, fillW, h)
      ctx.restore()
    }
  }

  // L5: omen 割れ予兆 = 月金 fill 全体が呼吸的に明滅 (もうすぐ満タン=崩し)。
  //   旧実装 (亀裂線 stroke + 粒 fillRect + 縁 strokeRect blink) は Canvas-path で「完成画に線/小点/枠が見える」
  //   = UIの図形に読まれる (ユーザー判定 2026-06-24・[[reference_fx_worldview_rule]])。 撤去し、
  //   「ゲージ本体の点滅」(ユーザー裁定の代替) に置換。 ENDER LILIES らしい心拍呼吸は維持。
  if (omen > 0 && fillW > 0) {
    const t = performance.now() / 1000
    const beat = Math.max(
      Math.sin(t * 1.6) * 0.5 + 0.5,
      Math.max(0, Math.sin(t * 1.6 + 0.4)) * 0.85,
    )
    const omenBeat = omen * (0.45 + beat * 0.55)
    // 月金+白寄りで fill 部分のみ additive パルス (= 漆器が熱を帯びて満タンが近い)。
    //   clip で fill 領域に閉じ込め、 空(右側)は明滅させない=「ゲージが昂る」読みになる。
    ctx.save()
    ctx.beginPath()
    ctx.rect(x, y, fillW, h)
    ctx.clip()
    ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = omenBeat * 0.55
    ctx.fillStyle = '#fff2c8'
    ctx.fillRect(x, y, fillW, h)
    ctx.restore()
  }

  // L6: 外枠 (1px 銀寄り古銀・全周直角・最後に描いて全部を囲む)
  ctx.strokeStyle = 'rgba(216,212,196,0.70)'
  ctx.lineWidth = 1
  ctx.strokeRect(x + 0.5, y + 0.5, w - 1, h - 1)

  ctx.restore()
}

function drawBossHud(ctx: CanvasRenderingContext2D, state: GameState): void {
  const L = bossHudLayout(ARENA.width)

  ctx.save()
  // 下端スクリム: 画面下部に上向きフェードの暗帯 (HUD 文字の可読性を確保)
  {
    const scrimTop = L.lampY - 14
    const scrimH = 960 - scrimTop  // 下端まで
    const scrimG = ctx.createLinearGradient(0, scrimTop, 0, scrimTop + 40)
    scrimG.addColorStop(0, 'rgba(8,5,12,0)')
    scrimG.addColorStop(1, 'rgba(8,5,12,0.52)')
    ctx.fillStyle = scrimG
    ctx.fillRect(0, scrimTop, 960, scrimH)
  }

  // 舞台額縁 — HUDゾーン上縁の退色した真鍮罫 (stage proscenium edge)
  {
    const edgeY = L.lampY - 12
    ctx.save()
    ctx.strokeStyle = 'rgba(152,136,100,0.30)'
    ctx.lineWidth = 0.65
    ctx.beginPath()
    ctx.moveTo(L.barX, edgeY); ctx.lineTo(L.barX + L.barW, edgeY)
    ctx.stroke()
    // 端の小ひし形 (退色した真鍮の留め)
    const ds = 2.6
    for (let side = 0; side < 2; side++) {
      const ex = side === 0 ? L.barX - 4 : L.barX + L.barW + 4
      const sign = side === 0 ? -1 : 1
      ctx.fillStyle = 'rgba(162,144,104,0.42)'
      ctx.beginPath()
      ctx.moveTo(ex, edgeY - ds)
      ctx.lineTo(ex + sign * ds, edgeY)
      ctx.lineTo(ex, edgeY + ds)
      ctx.lineTo(ex - sign * ds, edgeY)
      ctx.closePath(); ctx.fill()
    }
    ctx.restore()
  }

  // 役札 (ボス名の台紙 — 薄い象牙紙・黒紫縁取り)。
  //   2026-07-27 再設計: 名前と「幕票」(残り幕数) を**1枚の札に収めて中央**へ戻す。
  //   一度は名前を左寄せにして帯の右端へ灯を離したが、 実機で「点が宙に浮く / 対称が崩れた」。
  //   札ごと中央に置けば ①左右の罫線の対称が戻る ②幕票が暗い象牙紙の上に乗るので背景と競合しない
  //   ③主人公 (床 y440 まで) と重ならない (札は y459〜480)。
  const actMarkW = actMarksWidth(state)
  ctx.save()
  ctx.font = `600 18px ${UI_SERIF}`
  const nameW = ctx.measureText(state.boss.displayName).width
  const cardPadX = 16, cardH = 21
  const markGap = actMarkW > 0 ? 14 : 0
  const cardW = cardPadX * 2 + nameW + markGap + actMarkW
  const cardX = L.cx - cardW / 2
  const cardY = L.nameY - 17
  ctx.fillStyle = 'rgba(40,30,16,0.72)'
  ctx.fillRect(cardX, cardY, cardW, cardH)
  ctx.strokeStyle = 'rgba(190,168,118,0.28)'
  ctx.lineWidth = 0.7
  ctx.strokeRect(cardX, cardY, cardW, cardH)
  ctx.strokeStyle = 'rgba(16,8,24,0.55)'
  ctx.lineWidth = 1.4
  ctx.strokeRect(cardX + 2, cardY + 2, cardW - 4, cardH - 4)
  ctx.restore()
  const nameX = cardX + cardPadX

  // ボス名 (明朝・荘厳) — 2パス(暗縁 + 象牙fill) + 燭火の余韻グロー
  ctx.font = `600 18px ${UI_SERIF}`
  ctx.textAlign = 'left'
  ctx.strokeStyle = 'rgba(6,4,10,0.88)'
  ctx.lineWidth = 3
  ctx.shadowBlur = 0
  ctx.strokeText(state.boss.displayName, nameX, L.nameY)
  ctx.fillStyle = '#ede0c4'
  ctx.shadowColor = 'rgba(148,120,68,0.48)'
  ctx.shadowBlur = 9
  ctx.fillText(state.boss.displayName, nameX, L.nameY)
  ctx.shadowBlur = 0
  ctx.textAlign = 'center'

  // 幕票 (残り幕数) — 札の中・名前の右。
  drawActMarks(ctx, state, nameX + nameW + markGap, L.nameY)

  // 名前の横罫 (劇場タイトルカード — 退色した真鍮の横罫 + 外端ドット)。
  //   札の左右へ**対称**に伸ばす = 変更前の「中央の名札 + 左右の罫線」の構図に戻す。
  {
    ctx.save()
    const ruleGap = 16
    const ruleY = L.nameY - 4
    const leftStart = cardX - ruleGap
    const rightStart = cardX + cardW + ruleGap
    const ruleLen = Math.max(0, (leftStart - L.barX)) * 0.62
    ctx.strokeStyle = 'rgba(178,155,106,0.40)'
    ctx.lineWidth = 0.65
    ctx.beginPath(); ctx.moveTo(leftStart, ruleY); ctx.lineTo(leftStart - ruleLen, ruleY); ctx.stroke()
    ctx.beginPath(); ctx.moveTo(rightStart, ruleY); ctx.lineTo(rightStart + ruleLen, ruleY); ctx.stroke()
    ctx.fillStyle = 'rgba(178,155,106,0.52)'
    for (const ex of [leftStart - ruleLen, rightStart + ruleLen]) {
      ctx.beginPath(); ctx.arc(ex, ruleY, 1.4, 0, Math.PI * 2); ctx.fill()
    }
    ctx.restore()
  }

  // パリィ報酬: 直近の parry_spark からの経過で体幹バーを脈打たせる
  let parryAge = 999
  for (const f of state.fx) {
    if (f.kind === 'parry_spark') { const a = state.time - f.t; if (a >= 0 && a < parryAge) parryAge = a }
  }
  const FLASH_DUR = 0.35
  const pratio = state.boss.posture / state.boss.maxPosture
  const flash = parryAge < FLASH_DUR ? 1 - parryAge / FLASH_DUR : 0
  // 崩れ間際ほど報酬を強調 (崩しが近い=脳汁ピーク手前)。
  //   + 連続弾きエスカレーション (P4 §6.1): 途切れず弾いた段でも pop/motes を増幅する。
  const chainStep = Math.max(1, state.player.parryChain)
  const escal = (1 + (pratio >= 0.8 ? 0.5 : 0)) * (1 + (chainStep - 1) * COMBAT.parryChain.popBoostPerStep)

  // ===== 体幹バー (専用関数) =====
  // 器は静的: flash があっても trough 画像を跳ねさせない。fill/光だけ応答。
  const staggered = state.boss.state === 'staggered'
  const omen = staggered ? 0 : crackOmenIntensity(pratio)
  drawBossPostureGauge(ctx, L, pratio, flash * escal, staggered, omen)

  // 幕HPバー (象牙白/銀白・従・細): 「今の幕」の残量のみを示す。 削るほど体幹回復が鈍る (§3)
  //   赤は弾けない攻撃専用色のためHPバーには使わない (2026-06-18 HUD方針)
  // 通常攻撃では chipFloor を下回れないため、HP=床は描画上の空バーとして扱う。
  // roomHpFraction は体幹回復にも使うので、戦闘用の値は変えない。
  const hudHpFraction = actRefillCap(state, state.boss.hp <= chipFloor(state.boss) ? 0 : roomHpFraction(state.boss))
  // 高さ 4 → 8 (2026-07-27・友達FB 3-3「ボスHPが見づらい」)。 画面下端から12pxの位置に
  //   4pxの線があるだけでは実表示で読めていなかった。 体幹ゲージ (h28) との主従は保つ。
  drawCelBar(ctx, L.barX, L.hpY, L.barW, 8, hudHpFraction, '#c2cede',
    { track: '#0a0e16' })

  // HPバー端ノッチ (幕の下線の留め): 細いバーの両端に垂直ニック。
  // 空バーでは左ノッチが残量に見えるため、chipFloor 到達時だけ器と一緒に沈める。
  if (hudHpFraction > 0) {
    ctx.save()
    ctx.strokeStyle = 'rgba(150,168,190,0.42)'
    ctx.lineWidth = 0.8
    for (const nx of [L.barX, L.barX + L.barW]) {
      ctx.beginPath()
      ctx.moveTo(nx, L.hpY - 2); ctx.lineTo(nx, L.hpY + 7)
      ctx.stroke()
    }
    ctx.restore()
  }

  // 🔴 旧「灯」描画 (画面中央・床のすぐ下 y448) は 2026-07-27 に撤去。
  //   移設先 = drawActLamps (役札と同じ行の右端)。 2026-07-26 の実装で新経路を足した際、
  //   revert でこの旧経路が戻っていたことに気づかず**灯が二重に出ていた** (実機で発覚)。

  // 金の粒が体幹バー先端で弾ける (バー自身の金=「ゲージに注がれた」読み。 パリィの銀とは別系統)
  if (flash > 0 && pratio > 0) {
    const tipX = L.barX + 12 + (L.barW - 24) * pratio  // 内溝先端 (innerX + fillW)
    const tipY = L.postureY + 14                        // 内溝中央 (innerY=+7, innerH=14, center=+14)
    const prog = parryAge / FLASH_DUR
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    const motes = 6 + Math.round(3 * escal)
    for (let i = 0; i < motes; i += 1) {
      const ang = -Math.PI / 2 + (hash01(i * 1.7) - 0.5) * 2.1   // 主に上方へ拡散
      const sp = (16 + hash01(i * 2.3) * 28) * escal
      const px = tipX + Math.cos(ang) * sp * prog
      const py = tipY + Math.sin(ang) * sp * prog - 5 * prog
      const a = (1 - prog) * (0.55 + 0.45 * hash01(i * 1.1))
      drawGlowDot(ctx, px, py, 2.2 + 2.4 * hash01(i * 3.1), '#a88a28', a)
    }
    ctx.restore()
  }
  ctx.restore()
}

// 命灯 HUD (HP100 スケール対応)。 lampCount 個の命火を並べる。
//   fill=1.0: 高く明るい象牙白炎 + 淡い紫外炎のグロー
//   fill=0.5: 小さく紫寄りの弱火
//   fill=0.1: 皿の上の火種
//   fill=0.0: 小皿 + 黒い芯 + 薄い残光のみ。赤は弾けない攻撃専用なので使わない。
//
// 品質UP (2026-06-24 #4): 形/色は維持。 ボスHUD並みの密度に底上げ:
//   - 外グロー: 多段グラデ + 副外グロー (柔らかい紫の二重輪) で発光の深みを増す
//   - 炎本体: 紫の縁取り (subtle violet rim) で背景に対し読みやすく
//   - 芯: 2段重ね (中芯+極小コア) で熱の凝集感
//   - 揺らぐ煙: fill>=0.5 で先端から細い紫煙が立ち上る (LUNAIRE の魂の細部)
//   - 皿: 細い銀のリム + 微小なハイライトで金属感
function drawLifeLamps(
  ctx: CanvasRenderingContext2D, x: number, y: number,
  hp: number, maxHp: number, lampCount: number,
): void {
  ctx.save()
  const slotW = 20, gap = 4  // 各灯のスロット幅
  const lampHp = maxHp / lampCount  // 1灯あたりのHP = 20
  const tm = performance.now() / 1000

  for (let i = 0; i < lampCount; i += 1) {
    const cx = x + i * (slotW + gap) + slotW / 2
    const baseY = y + 26   // 小皿の底面 Y
    const fill = Math.max(0, Math.min(1, (hp - i * lampHp) / lampHp))

    // --- 小皿 (楕円形・常時表示) ---
    //   品質UP: 本体 + 細い銀のリム + 上端の極小ハイライト = 金属の小皿らしい立体感
    const dishW = 10, dishH = 4
    ctx.save()
    // 本体 (暗いベース)
    ctx.fillStyle = fill > 0 ? 'rgba(160,148,128,0.80)' : 'rgba(80,72,64,0.6)'
    ctx.beginPath()
    ctx.ellipse(cx, baseY, dishW / 2, dishH / 2, 0, 0, Math.PI * 2)
    ctx.fill()
    // 銀リム (細線)
    ctx.strokeStyle = fill > 0 ? 'rgba(208,196,176,0.55)' : 'rgba(110,100,90,0.4)'
    ctx.lineWidth = 0.6
    ctx.beginPath()
    ctx.ellipse(cx, baseY, dishW / 2, dishH / 2, 0, 0, Math.PI * 2)
    ctx.stroke()
    // 上端ハイライト (極小弧)
    if (fill > 0) {
      ctx.strokeStyle = 'rgba(255,248,232,0.55)'
      ctx.lineWidth = 0.6
      ctx.beginPath()
      ctx.ellipse(cx, baseY - 0.2, dishW / 2 * 0.85, dishH / 2 * 0.7, 0, Math.PI * 1.1, Math.PI * 1.9)
      ctx.stroke()
    }
    ctx.restore()

    if (fill <= 0) {
      // 消灯: 皿 + 黒い芯 + ごく薄い残光
      ctx.save()
      ctx.strokeStyle = 'rgba(90,80,70,0.5)'
      ctx.lineWidth = 1.5
      ctx.beginPath()
      ctx.moveTo(cx, baseY - dishH / 2)
      ctx.lineTo(cx, baseY - 10)
      ctx.stroke()
      // 残光ドット
      ctx.globalCompositeOperation = 'lighter'
      ctx.globalAlpha = 0.06
      const rg = ctx.createRadialGradient(cx, baseY - 10, 0, cx, baseY - 10, 7)
      rg.addColorStop(0, '#c8b0ec')
      rg.addColorStop(1, 'rgba(200,176,236,0)')
      ctx.fillStyle = rg
      ctx.beginPath(); ctx.arc(cx, baseY - 10, 7, 0, Math.PI * 2); ctx.fill()
      ctx.restore()
      continue
    }

    // 炎の揺らぎ (fill に応じて振れ幅を抑える)
    const flicker = fill < 0.3
      ? 0.85 + 0.15 * Math.sin(tm * 14 + i * 2.1 + Math.sin(tm * 31 + i) * 0.6)
      : 0.90 + 0.10 * Math.sin(tm * 9  + i * 1.7 + Math.sin(tm * 22 + i) * 0.4)

    // 炎の高さ: fill=1.0 → 20px / fill=0.1 → 6px
    const flameH = (6 + 14 * fill) * flicker
    // 炎の幅: fill=1.0 → 8px / fill=0.1 → 4px
    const flameW = 4 + 4 * fill
    // 芯のY
    const wickY = baseY - dishH / 2
    // 炎の先端Y
    const tipY = wickY - flameH
    const glowCY = tipY + flameH * 0.35

    // --- 外グロー: 多段グラデ + 副外グロー (加算) ---
    //   品質UP: 単発の薄い淡色グラデから 2 段重ねへ。 内側は密度高く・外側は柔らかく裾を引く。
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    const glowR = flameH * 0.9 * flicker
    const baseGlowA = fill >= 0.5 ? 0.16 : 0.08
    const glowRgb = fill >= 0.65 ? '176,144,228' : '136,96,192'
    // 主グロー (近傍): 4 stop で滑らかな落ち
    const glowG = ctx.createRadialGradient(cx, glowCY, 0, cx, glowCY, glowR)
    glowG.addColorStop(0,    `rgba(${glowRgb},${baseGlowA})`)
    glowG.addColorStop(0.35, `rgba(${glowRgb},${baseGlowA * 0.65})`)
    glowG.addColorStop(0.7,  `rgba(${glowRgb},${baseGlowA * 0.22})`)
    glowG.addColorStop(1,    'rgba(80,40,140,0)')
    ctx.fillStyle = glowG
    ctx.beginPath(); ctx.arc(cx, glowCY, glowR, 0, Math.PI * 2); ctx.fill()
    // 副外グロー (より広く・薄く): ボス HP まわりに置きたい "存在感の裾" を命灯にも入れる
    if (fill >= 0.35) {
      const farR = glowR * 1.9
      const farG = ctx.createRadialGradient(cx, glowCY, glowR * 0.3, cx, glowCY, farR)
      farG.addColorStop(0, `rgba(${glowRgb},${baseGlowA * 0.45})`)
      farG.addColorStop(0.5, `rgba(${glowRgb},${baseGlowA * 0.18})`)
      farG.addColorStop(1, 'rgba(80,40,140,0)')
      ctx.fillStyle = farG
      ctx.beginPath(); ctx.arc(cx, glowCY, farR, 0, Math.PI * 2); ctx.fill()
    }
    ctx.restore()

    // --- 炎本体 (しずく形/涙形: 下が丸く上が尖る) ---
    //   品質UP: 本体の前に紫の細い縁取り (subtle violet rim) を 1px 拡張で描き、 背景に対し
    //   炎の輪郭をくっきり立てる (本体色は不変)。 その上に従来の本体 + 芯ハイライト。
    ctx.save()
    const hw = flameW / 2
    const flameColor = fill >= 0.65
      ? '#f0ecf8'  // 白象牙
      : fill >= 0.35
        ? PALETTE.hudLifeFlameMid  // 淡い紫 '#b9a8e0' (体幹バーとは別系統)
        : '#8060b0'                 // 暗い紫
    // (a) 紫リム: 本体より少し外を淡い紫で描いてから本体で塗り潰す = 周囲に細い紫の縁が残る
    const rimHw = hw + 0.7
    const rimTipY = tipY - 0.6
    const rimWickY = wickY + 0.3
    ctx.globalAlpha = 0.55
    ctx.fillStyle = 'rgba(140,98,196,0.85)'  // 落ち着いた紫リム (色レンジ内)
    ctx.beginPath()
    ctx.moveTo(cx, rimTipY)
    ctx.bezierCurveTo(cx + rimHw * 1.1, rimTipY + (rimWickY - rimTipY) * 0.45,
                      cx + rimHw,       rimWickY,
                      cx,               rimWickY)
    ctx.bezierCurveTo(cx - rimHw,       rimWickY,
                      cx - rimHw * 1.1, rimTipY + (rimWickY - rimTipY) * 0.45,
                      cx,               rimTipY)
    ctx.closePath()
    ctx.fill()
    // (b) 本体: 従来の bezier しずく (色・形不変)
    ctx.globalAlpha = 0.94
    ctx.fillStyle = flameColor
    ctx.shadowColor = fill >= 0.65 ? '#d8c8f0' : '#9070c0'
    ctx.shadowBlur = 6 * fill
    ctx.beginPath()
    ctx.moveTo(cx, tipY)
    ctx.bezierCurveTo(cx + hw * 1.1, tipY + flameH * 0.45,
                      cx + hw, wickY,
                      cx,      wickY)
    ctx.bezierCurveTo(cx - hw, wickY,
                      cx - hw * 1.1, tipY + flameH * 0.45,
                      cx,      tipY)
    ctx.closePath()
    ctx.fill()
    ctx.shadowBlur = 0
    // (c) 芯ハイライト: 中心の明るい白芯 (従来) + 極小の極白コア (新)
    if (fill >= 0.3) {
      ctx.globalAlpha = 0.7 * fill
      const coreH = flameH * 0.5
      const coreW = hw * 0.45
      ctx.fillStyle = '#ffffff'
      ctx.beginPath()
      ctx.moveTo(cx, tipY + flameH * 0.1)
      ctx.bezierCurveTo(cx + coreW, tipY + flameH * 0.45,
                        cx + coreW * 0.7, wickY - coreH * 0.1,
                        cx, wickY - coreH * 0.05)
      ctx.bezierCurveTo(cx - coreW * 0.7, wickY - coreH * 0.1,
                        cx - coreW, tipY + flameH * 0.45,
                        cx, tipY + flameH * 0.1)
      ctx.closePath()
      ctx.fill()
      // 極小コア: 炎の付け根に小さな白点 (熱の凝集)
      ctx.globalCompositeOperation = 'lighter'
      ctx.globalAlpha = 0.85 * fill
      const cgr = ctx.createRadialGradient(cx, wickY - flameH * 0.18, 0, cx, wickY - flameH * 0.18, 2.2)
      cgr.addColorStop(0, '#ffffff')
      cgr.addColorStop(1, 'rgba(255,255,255,0)')
      ctx.fillStyle = cgr
      ctx.beginPath(); ctx.arc(cx, wickY - flameH * 0.18, 2.2, 0, Math.PI * 2); ctx.fill()
    }
    ctx.restore()

    // --- 立ち上る細い紫煙 (fill>=0.5 / 加算・極薄) ---
    //   炎の先端から微かに上へ流れる粒。 LUNAIRE の魂の細部 (火だけでなく「ほどけて昇る」)。
    if (fill >= 0.5) {
      ctx.save()
      ctx.globalCompositeOperation = 'lighter'
      const M = 3
      for (let j = 0; j < M; j += 1) {
        const ph = ((tm * 0.5 + i * 0.3 + j * 0.33) % 1)
        const sx = cx + Math.sin(ph * Math.PI * 2 + i + j) * 1.6
        const sy = tipY - ph * (flameH * 0.9)
        const sr = 1.3 + ph * 1.6
        const sa = (1 - ph) * 0.10 * fill
        const sg = ctx.createRadialGradient(sx, sy, 0, sx, sy, sr)
        sg.addColorStop(0, `rgba(184,150,228,${sa.toFixed(3)})`)
        sg.addColorStop(1, 'rgba(140,98,196,0)')
        ctx.fillStyle = sg
        ctx.beginPath(); ctx.arc(sx, sy, sr, 0, Math.PI * 2); ctx.fill()
      }
      ctx.restore()
    }
  }
  ctx.restore()
}

// チケットB': 死因カテゴリ→心得一行 (defeat 画面専用・技名は出さない)。
//   優先順: bossFinisher(体幹が溜まりきった所への決め技) > unblockable(赤黒いオーラ) > kind==='area'(床) > その他(被弾)。
//   2026-10-10 パリィは1種類: 旧「並のパリィは自分の体幹を削る。当たる瞬間のジャストパリィは、削らない」を、1種類の事実
//   (パリィでは自分の体幹は少し溜まるだけで、溜まりきっても崩れない・hits.ts willStunSelf) に合わせて書き直した。
export function deathTipFor(attackId: string | null | undefined): string | null {
  if (!attackId) return null
  let def
  try {
    def = getAttack(attackId)
  } catch {
    return null
  }
  if (def.bossFinisher) return import.meta.env.DEV && hudOld() ? HUD_OLD_EXEC_DEATH_TIP : HUD_V2_EXEC_DEATH_TIP
  if (def.unblockable) return '赤黒いオーラの攻撃はパリィできない。回避するか、離れるか'
  if (def.kind === 'area') return '足元の印は、立つ場所の問いだ。歩いて外へ'
  return '欲張った一太刀が命取り。攻めるのは、隙にだけ'
}

// 負け画面の一言の行 (0〜2行)。指定なし (配布版) = 死因連動の1行 (deathTipFor)・DEV ?defeatTips=new = Tips 式 (src/defeat_tips.ts)。
//   Tips 式は負け1回につき1つ (キー = ボス id + 総死亡数 + 負けた時刻。負け画面の間 state.time は進まない = 同じ負けの間は同じキー)。
export function defeatTipLinesFor(state: Pick<GameState, 'boss' | 'campaign' | 'lastDeathAttackId' | 'time'>): readonly string[] {
  if (defeatTipsMode() === 'new') {
    const key = `${state.boss.id}:${state.campaign.totalDeaths}:${state.time.toFixed(3)}`
    return defeatTipForDefeat(key, state.campaign, state.boss.id)?.lines ?? []
  }
  const one = deathTipFor(state.lastDeathAttackId)
  return one ? [one] : []
}

// 負け画面の一言の字の大きさ (px) を font 指定から読む (行送り用)。読めなければ 15。
function defeatTipFontPx(font: string): number {
  const m = /(\d+(?:\.\d+)?)px/.exec(font)
  return m ? Number(m[1]) : 15
}

// ============== 勝敗オーバーレイ ==============
// 死亡: タイトル + ロウ断片のみ (戦績や目撃攻撃は表示しない)
// 勝利: タイトル + ロウ断片 + 次ボス名
// 全クリア: タイトル + 全プレイの統計まとめ (ご褒美画面)
function drawPhaseOverlay(ctx: CanvasRenderingContext2D, state: GameState): void {
  if (state.phase === 'playing') return
  if (state.phase === 'title') { drawTitleScreen(ctx, state); return }
  // 「間→重く出現」: フェーズ経過 t で段階的に立ち上げる (死は重くゆっくり、 勝利はやや早め)。
  const t = state.phaseElapsedSec
  const smooth = (v: number): number => { const c = Math.max(0, Math.min(1, v)); return c * c * (3 - 2 * c) }
  const isDefeat = state.phase === 'defeat'
  ctx.save()
  const cx = ARENA.width / 2
  if (isDefeat || state.phase === 'victory') {
    // リトライ画面と勝利画面は、出た最初のコマから黒一色 (10-31 作者「終了画面が出た時に LUNAIRE が瞬間移動してる」
    //   → 後ろのゲーム画面を薄く見せるのをやめる)。画面が替わる時に主人公の位置が戻るのを見せない。
    ctx.fillStyle = '#000'
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  } else {
    // 暗幕 + ヴィネットは t でランプ (世界が静まっていく「間」)
    const scrimA = smooth(t / 0.32)
    ctx.fillStyle = `rgba(6,3,13,${0.86 * scrimA})`
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    const vg = ctx.createRadialGradient(cx, ARENA.height * 0.42, 120, cx, ARENA.height * 0.42, ARENA.width * 0.62)
    vg.addColorStop(0, 'rgba(0,0,0,0)')
    vg.addColorStop(1, `rgba(0,0,0,${0.55 * scrimA})`)
    ctx.fillStyle = vg
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  }
  ctx.textAlign = 'center'

  if (isDefeat) {
    // 死=再演 (spec 2026-06-03 §3): 「YOU DIED」を廃止。 暗転 → 一拍 → 「再演」ボタンが浮かぶ。
    //   死=役者が舞台を降り、 同じ場面をもう一度演じること。
    //   常夜燈は戦闘背景にひっそり存在する方針へ変更 (2026-06-25) = 再演画面でも出さない (victory と統一)。
    const deaths = state.campaign.deathsByBossId[state.boss.id] ?? 0
    const showDifficultyHint = defeatDifficultyHintVisible(state.settings.difficulty, deaths)
    const hasNotice = false // 将来の「芝居の断片」通知描画と同時に true の配線を足す
    const timingScale = import.meta.env.DEV && typeof window !== 'undefined'
      ? ((window as any).__defeatOverlayTimingScale ?? 1)
      : 1
    const timeline = defeatOverlayTimeline(
      { deaths, showDifficultyHint, hasNotice },
      DEFEAT_OVERLAY_TIMING_SEC,
      timingScale,
    )
    const titleA = smooth((t - timeline.retryButton.startSec) / timeline.retryButton.fadeInSec)
    if (titleA > 0.01) {
      const bw = retryLabels().buttonWidth
      const bh = 52
      const by = ARENA.height * 0.42
      const blink = 0.55 + 0.45 * (0.5 + 0.5 * Math.sin(performance.now() / 1000 * 3))
      ctx.save()
      ctx.globalAlpha = titleA
      ctx.strokeStyle = `rgba(154,122,196,${0.85 * blink})`
      ctx.lineWidth = 2
      ctx.strokeRect(cx - bw / 2, by - bh / 2, bw, bh)
      ctx.fillStyle = 'rgba(154,122,196,0.18)'
      ctx.fillRect(cx - bw / 2, by - bh / 2, bw, bh)
      ctx.fillStyle = '#cdb8ec'
      ctx.font = `600 26px ${UI_SERIF}`
      ctx.textAlign = 'center'
      ctx.fillText(retryLabels().button, cx, by + 9)
      ctx.restore()
    }
    // G-6 (2026-06-13): 死因ラベルの *画面表示* は撤去。 SEKIRO は死因を名指ししない / 舞台に
    //   クリニカルな UI 語彙は異物 / Phase M の振りかぶり絵で「何に殺されたか」は見て分かる。
    //   教えは稽古亡霊 (G-7) に集約・本番の舞台はクリーンに。 ※`state.lastDeathCause` の
    //   記録自体は残す (C-3 の死因内訳分析の燃料・game.ts で populate 継続)。
    // チケットB' (2026-07-05): 技名 (G-6) は出さないまま、 死因カテゴリの心得だけ一行足す。
    // 10-09 比較版 (DEV ?defeatTips=new = src/defeat_tips.ts): 死因で選ばず、ロード画面の Tips のように小技・小ネタから毎回1つ (1〜2行)。
    //   指定なし (配布版) は今のまま = 死因連動の1行 (deathTipFor)。
    const tipLines = defeatTipLinesFor(state)
    const tip = tipLines.length > 0 ? tipLines[0] : null
    // 字の大きさ・濃さ (配布版の既定 = big = 21px・濃さ 0.92・影つき・10-08 ユーザー採用 F-2。DEV ?defeatHint=now = 旧 15px・0.75 = src/fresh_eyes_fix_trials.ts)。
    const tipStyle = defeatHintStyle()
    // 2行目以降の行送り (字の大きさの約 1.5 倍)。下の難易度ヒントも同じだけ下げる。
    const tipLineGapPx = Math.round(defeatTipFontPx(tipStyle.font) * 1.5)
    const tipExtraPx = Math.max(0, tipLines.length - 1) * tipLineGapPx
    if (tip) {
      const tipA = Math.max(
        0,
        Math.min(1, (t - timeline.deathTip.startSec) / timeline.deathTip.fadeInSec),
      ) * tipStyle.alphaMul
      if (tipA > 0.01) {
        ctx.save()
        ctx.globalAlpha = tipA
        ctx.fillStyle = tipStyle.color
        ctx.font = tipStyle.font
        ctx.textAlign = 'center'
        if (tipStyle.shadow) { ctx.shadowColor = tipStyle.shadow.color; ctx.shadowBlur = tipStyle.shadow.blur }
        tipLines.forEach((line, i) => ctx.fillText(line, cx, ARENA.height * 0.42 + 26 + 40 + i * tipLineGapPx))
        ctx.restore()
      }
    }
    // 難易度ヒント (2026-07-25): 千秋楽で同じ幕に何度も倒れている人にだけ、初演があることを静かに知らせる。
    //   初演プレイヤーには出さない / 初見の1〜2回では出さない (詰まってから=お節介にならない)。
    if (showDifficultyHint && timeline.difficultyHint) {
      const hintA = Math.max(
        0,
        Math.min(1, (t - timeline.difficultyHint.startSec) / timeline.difficultyHint.fadeInSec),
      ) * 0.6
      if (hintA > 0.01) {
        ctx.save()
        ctx.globalAlpha = hintA
        ctx.fillStyle = 'rgba(176,158,204,0.85)'
        ctx.font = `400 13px ${UI_SERIF}`
        ctx.textAlign = 'center'
        ctx.fillText('タイトルの「幕を選ぶ」で、初演に移ることもできる', cx, ARENA.height * 0.42 + 26 + 40 + tipExtraPx + tipStyle.hintGapPx)
        ctx.restore()
      }
    }
  } else if (state.phase === 'victory') {
    const titleA = smooth((t - 0.1) / 0.55)
    if (state.solo) {
      // 一戦だけモード (?fight=・2026-07-28)。 「ACT N」は本編の幕番号なので単体リンクでは
      //   意味を持たない (第5幕だけ渡された人に「ACT V」と出しても何のことか分からない)。
      //   出すのは「倒した相手の名前」と「ここで終わり」だけ。 物語へは進まない。
      //   ⚠️ 縦位置は感想欄の DOM (top 40%・feedback_panel.ts) の**上**に収める。
      //      画面下にはボスHPバー等の HUD が残っているので、 下へ置くと文字が重なる
      //      (2026-07-28 実表示で衝突を確認して 0.30→0.19 へ上げた)。
      const titleY = ARENA.height * 0.19
      drawOverlayTitle(ctx, '討ち果たした', cx, titleY,
        PALETTE.hudGold, 'rgba(244,216,120,0.85)', titleA)
      const nameA = smooth((t - 0.45) / 0.5)
      if (nameA > 0.01) {
        ctx.save()
        ctx.globalAlpha = nameA * 0.85
        ctx.fillStyle = PALETTE.textDim
        ctx.font = `400 19px ${UI_SERIF}`
        ctx.textAlign = 'center'
        ctx.fillText(state.boss.displayName, cx, titleY + 40)
        ctx.restore()
      }
      // 出口の案内。 感想欄 (DOM) の「もう一度戦う」ボタンと同じ行き先 = どちらを押しても同じ。
      const hintA = smooth((t - 1.2) / 0.6)
      if (hintA > 0.01) {
        ctx.save()
        ctx.globalAlpha = hintA * 0.85
        ctx.fillStyle = PALETTE.textDim
        ctx.font = `400 15px ${UI_SERIF}`
        ctx.textAlign = 'center'
        ctx.fillText(retryLabels().hint, cx, titleY + 72)
        ctx.restore()
      }
    } else {
      // 撃破画面 = ER/SEKIRO 流の一刻印のみ。
      // 常夜燈は戦闘背景にひっそり存在する方針へ変更 (2026-06-25) = ここでは出さない。
      // R プロンプト撤去 (2026-06-25 ユーザー裁定)。
      const act = state.campaign.currentBossIndex + 1
      drawOverlayTitle(ctx, `ACT ${toRoman(act)} FALLS`, cx, ARENA.height * 0.46,
        PALETTE.hudGold, 'rgba(244,216,120,0.85)', titleA)
      // 稽古の6点の比較版 ⑥ (DEV ?tut6): 稽古を終えた時だけ、終わったと一行で言う。
      if (tutSix(6) && state.tutorial) {
        const doneA = smooth((t - 0.6) / 0.5)
        if (doneA > 0.01) {
          ctx.save()
          ctx.globalAlpha = doneA * 0.9
          ctx.fillStyle = PALETTE.textDim
          ctx.font = `400 19px ${UI_SERIF}`
          ctx.textAlign = 'center'
          ctx.fillText(TUT_SIX.doneLine, cx, ARENA.height * 0.46 + 46)
          ctx.restore()
        }
      }
    }
  } else if (state.phase === 'cleared') {
    drawClearedSummary(ctx, state)
  } else if (state.phase === 'interlude') {
    drawInterlude(ctx, state, getInterludeScene(state.boss.id), isCampaignCleared(state.campaign) ? '問いへ' : '次の幕へ')
  } else if (state.phase === 'preBattle') {
    const preBattleScene = getPreBattleScene(state.boss.id, state.campaign)
    if (preBattleScene) drawInterlude(ctx, state, preBattleScene, '戦いへ')
    // 戦いへ抜ける間は、 曲が消えるのに合わせて黒へ落とす (game.ts の exitMs)。
    const exitMs = state.adv?.exitMs
    if (exitMs != null) {
      ctx.save()
      ctx.globalAlpha = Math.min(1, exitMs / (ADV_BATTLE_EXIT_MS * 0.8))
      ctx.fillStyle = '#000'
      ctx.fillRect(0, 0, ARENA.width, ARENA.height)
      ctx.restore()
      // 暗転が終わっても一戦の絵を待っている間 (src/battle_asset_gate.ts battleExitDone)。
      if (exitMs > ADV_BATTLE_EXIT_MS) drawLoadingIndicator(ctx, exitMs - ADV_BATTLE_EXIT_MS)
    }
  } else if (state.phase === 'choice') {
    drawChoice(ctx, state)
  } else if (state.phase === 'ending') {
    drawEnding(ctx, state)
  } else if (state.phase === 'tsuzuku') {
    drawTsuzukuCard(ctx, state)
  } else if (state.phase === 'tsuzukuNote') {
    drawTsuzukuNote(ctx, state)
  }
  ctx.restore()
}

// ============== 物語フェーズ (幕間 / 残るか降りるか / 終幕) ==============
// 台詞は最小限・主観・説明しない (正典 spec §8)。 1行ずつゆっくり浮かび上がる。

// INTERLUDE_TEXTS は adv_scripts.ts の getInterludeScene へ移行済み (B-2 Task5)。

// 常夜燈 (小さな一灯)。 幕間・終幕・死亡画面で共用。
// opts.post=false で支柱を消す (灯体が背景絵側にある時)。
// 既定は青 (cool)。 2026-10-11 ユーザー「常夜燈の色は青っぽい色」= 色を指定しない呼び出し
// (背景絵の無い部屋・2択・終幕) が金で出て、 終幕の「視界の隅に、青が、入った。」と食い違っていた。
// 'warm' (金) は常夜燈には使わない (残しているのは明示指定用だけ)。
export function drawGhostLight(
  ctx: CanvasRenderingContext2D, x: number, y: number, scale: number, intensity: number,
  opts: { post?: boolean; tint?: 'warm' | 'cool' } = {},
): void {
  const post = opts.post ?? true
  const cool = (opts.tint ?? 'cool') === 'cool'
  const tm = performance.now() / 1000
  const flick = 0.85 + 0.15 * Math.sin(tm * 9 + Math.sin(tm * 23) * 2)
  ctx.save()
  // 支柱
  if (post) {
    ctx.strokeStyle = 'rgba(90,74,56,0.9)'
    ctx.lineWidth = 3 * scale
    ctx.beginPath()
    ctx.moveTo(x, y)
    ctx.lineTo(x, y - 34 * scale)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(x - 8 * scale, y)
    ctx.lineTo(x + 8 * scale, y)
    ctx.stroke()
  }
  // 比較版 v1 (11-03・src/lamp_light.ts)。 ここへ来るのは壁も床も無い暗い画面 (2択・終幕) が主なので、 照り返しは描かない。
  if (cool && lampLightV1()) {
    drawLampLightV1(ctx, x, y - 40 * scale, scale, intensity, { seed: 2, wall: false })
    ctx.restore()
    return
  }
  // 灯 (グロー)。 warm=金 / cool=青 (背景の青灯に合わせる)。
  const r = 22 * scale * intensity * flick
  ctx.globalCompositeOperation = 'lighter'
  const g = ctx.createRadialGradient(x, y - 40 * scale, 0, x, y - 40 * scale, r)
  if (cool) {
    g.addColorStop(0, `rgba(170,205,255,${0.9 * intensity})`)
    g.addColorStop(0.35, `rgba(96,142,228,${0.45 * intensity})`)
    g.addColorStop(1, 'rgba(96,142,228,0)')
  } else {
    g.addColorStop(0, `rgba(255,232,170,${0.9 * intensity})`)
    g.addColorStop(0.35, `rgba(244,216,120,${0.45 * intensity})`)
    g.addColorStop(1, 'rgba(244,216,120,0)')
  }
  ctx.fillStyle = g
  ctx.beginPath(); ctx.arc(x, y - 40 * scale, r, 0, Math.PI * 2); ctx.fill()
  ctx.fillStyle = cool ? `rgba(205,228,255,${0.95 * intensity * flick})` : `rgba(255,242,210,${0.95 * intensity * flick})`
  ctx.beginPath(); ctx.arc(x, y - 40 * scale, 3.2 * scale, 0, Math.PI * 2); ctx.fill()
  ctx.restore()
}

// 幕間 (ADV) 専用の常夜燈。 戦闘では灯体を背景絵が持ち、 コードはグローだけ重ねる
// (§4.2 背景アンカー方式) が、 ADV には背景絵が無いため既定の「立ち灯籠」= 支柱と
// 台座の茶色い2本線が出ていた。 真っ黒の画面に線だけが立つので図形に見える
// (FX世界観ルール「UIの図形か舞台の現象か」) + 色も金で正本の冷青と食い違っていた。
//   → 支柱を捨て「暗がりの奥に灯が一つ在る」現象として描く。
//   正本 §4.2: 色=弱く青みがかった淡光 / 見え方=主役感を出さず隅で紛れる
//   (常夜燈の位置を主張すると致命FXが真相を提示してしまう)。
const ADV_BODY_FONT = `17px ${UI_SERIF}`
const ADV_SPEAKER_FONT = `14px ${UI_SERIF}`

// 誰が喋っているかを色だけに頼らせない (2026-07-21 ユーザー指摘)。
//   規則 = **声に出した言葉だけが話者名と鉤括弧を持つ**。 これで「口に出した/心の中」が
//   一目で分かり、 地の文は素のままで自然に区別される。
//   ⚠️ 神の声には話者名を付けない。 台帳で「内面の幻聴・自分との対話」と確定しており
//      (`docs/decision-ledger.md` 神の声)、 名前を出すと正体を確定させて核が壊れる。
//   ⚠️ LUNAIRE の内語も声に出していないので名前・鉤括弧とも付けない。
//   ⚠️ 地の文にイタリックは使わない。 日本語フォントに斜体字形は無く、 canvas の italic は
//      機械的に傾けた偽斜体になる (960→1920 拡大でエッジが荒れる)。 日本語組版の強調は
//      圏点・太さ・字下げが定石で、 そもそも地の文は既定側＝印を付けるのはセリフの方。
export function advLineSegments(
  l: AdvTextLine,
  color: string,
): { text: string; color: string; font: string }[] {
  return advDisplaySegments(l).map((segment) => ({
    text: segment.text,
    color: segment.role === 'speaker' ? 'rgba(198,184,164,0.6)' : color,
    font: segment.role === 'speaker' ? ADV_SPEAKER_FONT : ADV_BODY_FONT,
  }))
}

function revealedAdvLineSegments(
  line: AdvTextLine, color: string, revealedChars: number,
): { text: string; color: string; font: string }[] {
  let remaining = revealedChars
  return advLineSegments(line, color).map((segment) => {
    const text = takeAdvDisplayCharacters(segment.text, remaining)
    remaining -= Array.from(text).length
    return { ...segment, text }
  }).filter((segment) => segment.text.length > 0)
}

// 灯体の意匠 = タイトルキーアート (/bg/title.png) の常夜燈そのもの。
//   コードで灯籠を描くと必ず「図形」に見えるので、 正典の絵から灯体を切り出して使う。
//   出所と再生成手順 = scripts/extract_ghostlight_lantern.py
const ADV_LANTERN_SRC = '/ui/ghostlight_lantern.png'
const ADV_LANTERN_H = 62          // 画面(960x540)上の高さ
const ADV_LANTERN_GLASS = 0.345   // 絵の上端から見たガラス(灯り)の位置

function drawAdvGhostLight(ctx: CanvasRenderingContext2D, x: number, y: number, intensity = 1, motes = true): void {
  const t = performance.now() / 1000
  // 呼吸 (遅い) と揺らぎ (速い) を重ね、 単調な点滅にしない。
  const v1 = lampLightV1()
  const flick = v1
    ? lampFlicker(t, 3) * intensity
    : (0.82 + 0.12 * Math.sin(t * 1.1) + 0.06 * Math.sin(t * 7.3 + Math.sin(t * 19) * 1.4)) * intensity
  // ① グローはコード側 (絵に焼き込むと揺らげない) = §4.2「灯体は絵・グローはコード」。
  //   比較版 v1 (11-03・src/lamp_light.ts) は灯体の後に重ねる (下の ③)。
  if (!v1) {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'
    const halo = ctx.createRadialGradient(x, y, 0, x, y, 52 * flick)
    halo.addColorStop(0, `rgba(120,168,232,${0.22 * flick})`)
    halo.addColorStop(0.45, `rgba(84,128,204,${0.08 * flick})`)
    halo.addColorStop(1, 'rgba(84,128,204,0)')
    ctx.fillStyle = halo
    ctx.beginPath(); ctx.arc(x, y, 52 * flick, 0, Math.PI * 2); ctx.fill()
    ctx.restore()
  }
  // ② 灯体。
  const entry = ensureBg(ADV_LANTERN_SRC)
  const img = entry?.img
  if (img && img.complete && img.naturalWidth > 0) {
    const h = ADV_LANTERN_H
    const w = h * (img.naturalWidth / img.naturalHeight)
    ctx.save()
    ctx.globalAlpha = Math.min(1, 0.78 + 0.22 * flick)
    ctx.drawImage(img, x - w / 2, y - h * ADV_LANTERN_GLASS, w, h)
    ctx.restore()
  }
  // ③ 比較版 v1: 灯体の足もと (絵の下端) を床として照らし、 ガラスの上に芯とにじみを重ねる。
  if (v1) drawLampLightV1(ctx, x, y, 1.1, 0.62 * intensity, { floorY: y + ADV_LANTERN_H * (1 - ADV_LANTERN_GLASS) - 2, seed: 3, motes })
}

// 読み込み待ちの表示 (11-03・src/loading_indicator.ts)。黒の画面の右下に小さく出す。配布版は常夜燈 (11-02 作者の答え)・開発版の ?loading=moon|none で月・黒だけ。
//   常夜燈の案は会話場面の灯 (drawAdvGhostLight) を呼ぶだけ。灯体の濃さを中で決めているので、別の板に描いてから濃さを掛けて重ねる。
let loadingLampLayer: HTMLCanvasElement | null = null
const LOADING_LAMP_W = 160, LOADING_LAMP_H = 200
function drawLoadingIndicator(ctx: CanvasRenderingContext2D, waitedMs: number): void {
  const kind = loadingLook()
  if (kind === 'none') return
  const a = loadingAlpha(waitedMs)
  if (a <= 0) return
  const t = performance.now() / 1000
  if (kind === 'moon') { drawLoadingMoon(ctx, LOADING_X, LOADING_Y, a, t); return }
  if (typeof document === 'undefined') return
  const sc = ctx.getTransform().a || 1
  if (!loadingLampLayer) loadingLampLayer = document.createElement('canvas')
  const L = loadingLampLayer
  const pw = Math.round(LOADING_LAMP_W * sc), ph = Math.round(LOADING_LAMP_H * sc)
  if (L.width !== pw || L.height !== ph) { L.width = pw; L.height = ph }
  const g = L.getContext('2d')
  if (!g) return
  g.setTransform(1, 0, 0, 1, 0, 0)
  g.clearRect(0, 0, pw, ph)
  g.setTransform(sc, 0, 0, sc, 0, 0)
  const lx = LOADING_LAMP_W / 2, ly = LOADING_LAMP_H * 0.42
  // 粒は出さない (11-02 作者の答え「灯だけ（粒なし）」)
  drawAdvGhostLight(g, lx, ly, 1, false)
  ctx.save()
  ctx.globalAlpha = a
  ctx.drawImage(L, LOADING_X - lx, LOADING_Y - ly, LOADING_LAMP_W, LOADING_LAMP_H)
  ctx.restore()
}

// ===== 「つづく」カード (配布版の終わり・2枚組) =====
//   確定文言と構造の正本 = `docs/candidates/2026-07-20-tsuzuku-card-copy-3-options.md` §4
//   1枚目 = 余韻 (舞台の言葉)。 2枚目 = 実務 (制作者の言葉)。 混ぜると余韻が死ぬので割る。
//   ⚠️ 削る時の最終形は「この2行と常夜燈だけで成立すること」= 演出を足しても土台を壊さない。
const TSUZUKU_LINE = 'まだ、廊下は続いていた。'
const TSUZUKU_MARK = 'つづく'
const TSUZUKU_NOTE = ['ここまで遊んでくれてありがとう。', 'この先は、まだ作っている途中です。']

// 1枚目: 常夜燈だけが残る。 廊下の奥 (次の扉) には光が届いていない。
function drawTsuzukuCard(ctx: CanvasRenderingContext2D, state: GameState): void {
  const cx = ARENA.width / 2
  const t = state.phaseElapsedSec
  ctx.fillStyle = 'rgba(6,3,13,1)'
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  // 廊下の奥 = 画面中央のわずかな余光。 常夜燈の光がそこまで届いていないことを見せる。
  const depth = ctx.createRadialGradient(cx, ARENA.height * 0.52, 0, cx, ARENA.height * 0.52, 300)
  depth.addColorStop(0, 'rgba(28,26,54,0.5)')
  depth.addColorStop(1, 'rgba(28,26,54,0)')
  ctx.fillStyle = depth
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)

  ctx.save()
  ctx.textAlign = 'center'
  // 地の文 = ゴシック (TIPS 作法)。 ゆっくり浮かべる。
  ctx.globalAlpha = Math.min(1, t / 1.4)
  ctx.fillStyle = 'rgba(206,198,222,0.86)'
  ctx.font = `500 18px ${uiSans()}`
  ctx.fillText(TSUZUKU_LINE, cx, ARENA.height * 0.44)
  // 「つづく」= タイトル格なので明朝。 地の文より遅れて出る (息を置く)。
  ctx.globalAlpha = Math.min(1, Math.max(0, (t - 1.6) / 1.6))
  ctx.fillStyle = 'rgba(232,222,246,0.92)'
  ctx.font = `26px ${TIPS_TITLE_FONT}`
  ctx.fillText(TSUZUKU_MARK, cx, ARENA.height * 0.6)
  ctx.restore()

  drawAdvGhostLight(ctx, ARENA.width - 70, ARENA.height - 78)
  if (t > 3.4) drawOverlayPrompt(ctx, '進む', cx, '#b9a3d9')
}

// 2枚目: 照明を落とす (常夜燈も消す) = 明らかに枠の外。 ここは制作者の声でよい。
function drawTsuzukuNote(ctx: CanvasRenderingContext2D, state: GameState): void {
  const cx = ARENA.width / 2
  const t = state.phaseElapsedSec
  ctx.fillStyle = '#000'
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  ctx.save()
  ctx.textAlign = 'center'
  ctx.globalAlpha = Math.min(1, t / 0.9)
  ctx.fillStyle = 'rgba(198,196,206,0.9)'
  ctx.font = `500 17px ${uiSans()}`
  TSUZUKU_NOTE.forEach((line, i) => {
    ctx.fillText(line, cx, ARENA.height * 0.46 + i * 34)
  })
  ctx.restore()
  // ⚠️ ここに「タイトルへ」を描かない。 出口は感想欄 (DOM) 側のボタンが持っており、
  //    canvas にも描くと同じ言葉が画面に2つ出る (実表示で確認して外した)。
}

// 本文+選択肢パネルのページ計測。 drawInterlude (描画) と measureAdvChoiceRectsForInput
//   (main.ts が毎フレーム呼ぶ、 マウス当たり判定用) の共通出所 (2026-07-25 第4段)。
//   別々に計算すると、 描画位置とクリック判定位置が黙ってズレる (第2段の menu_layout.ts と同じ教訓)。
function measureAdvChoicePanel(
  ctx: CanvasRenderingContext2D, rt: AdvRuntime, scene: AdvScene,
): { choosing: AdvChoice | null; block: AdvChoiceBlock | null; startY: number; choicePanelTop: number; pageLines: AdvTextLine[] } {
  const lines = visibleLines(rt, scene)
  // 本文 (+選択肢) は画面の中央に置く。 1画面に入らない長い場面はページを送る。
  //   ⚠️ 中央合わせの基準は「今見えている行数」ではなく **そのページの最終行数**。
  //      見えている数で取ると1行増えるたび全体がずり上がって読んでいる最中に動く。
  const choosing = rt.choosing && scene.choice ? scene.choice : null
  const block = choosing ? measureAdvChoiceBlock(ctx, choosing, rt.choiceIndex) : null
  const { capPlain, capLast } = advPageCapacities(block ? block.panelHeight : null)
  const pages = paginateAdvLines(totalTextLineCount(rt, scene), capPlain, capLast)
  // 見えている最後の行が属するページだけを描く (前のページは送られて消える)。
  let pageStart = 0
  let pageIndex = 0
  while (pageIndex < pages.length - 1 && pageStart + pages[pageIndex]! < lines.length) {
    pageStart += pages[pageIndex]!
    pageIndex += 1
  }
  const pageLines = lines.slice(pageStart)
  const onLastPage = pageIndex === pages.length - 1
  const { startY, choicePanelTop } = layoutAdvInterlude(
    pages[pageIndex] ?? pageLines.length,
    block && onLastPage ? block.panelHeight : null,
  )
  return { choosing, block, startY, choicePanelTop, pageLines }
}

// main.ts が毎フレーム呼ぶ。 ctx はここでしか持てない (main.ts だけが CanvasRenderingContext2D を
//   持つ) ため、 計測の置き場所として最も素直 (票 §5-1)。 選択肢が出ていない時は undefined。
export function measureAdvChoiceRectsForInput(ctx: CanvasRenderingContext2D, state: GameState): MenuRect[] | undefined {
  if (state.phase !== 'interlude' || !state.adv?.choosing) return undefined
  const scene = getInterludeScene(state.boss.id)
  if (isPictureScene(scene)) return measurePictureChoiceRects(ctx, state, scene)
  if (!scene.choice) return undefined
  const { choicePanelTop } = measureAdvChoicePanel(ctx, state.adv, scene)
  ctx.save()
  ctx.font = `600 17px ${uiSans()}`
  const rects = advChoiceOptionRects(scene.choice, state.adv.choiceIndex, choicePanelTop, (text) => ctx.measureText(text).width)
  ctx.restore()
  return rects
}

function drawInterlude(ctx: CanvasRenderingContext2D, state: GameState, scene: AdvScene, doneLabel: string): void {
  // 場面の頭の絵を待つ間は黒のまま (src/battle_asset_gate.ts holdAdvEntry・11-02)。 文字窓も出さない。
  if (advEntryHolding(state.adv)) {
    ctx.fillStyle = '#000'
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    drawLoadingIndicator(ctx, state.adv?.entryWaitMs ?? 0)
    return
  }
  // 回想フラッシュバック中 (former-princess 内語): 4枚の絵を順にクロスフェード。 テキストは出さない。
  //   先代の撃破後は絵の場面なので、 絵の場面へ抜ける前に見る。
  const cb = state.adv ? activeCueBeat(state.adv, scene) : null
  if (cb && cb.effect === 'flashback' && state.phase === 'interlude') {
    drawFlashbackImages(ctx, cb.progress)
    return
  }
  if (isPictureScene(scene)) { drawPictureInterlude(ctx, state, scene, doneLabel); return }
  const cx = ARENA.width / 2
  ctx.fillStyle = 'rgba(6,3,13,0.96)'
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  // 常夜燈は本文と選択肢の後に重ねる (選択肢の下地の影でハローが食われないように)。
  // 回想フラッシュバック中だけは絵より下に置きたいので、 その経路では先に描く。
  const lamp = (): void => drawAdvGhostLight(ctx, ARENA.width - 70, ARENA.height - 78)
  const rt = state.adv
  if (!rt) { lamp(); return }
  const colorOf = (kind: string): string =>
    kind === 'voice' ? 'rgba(244,216,120,0.92)'
      : kind === 'other' ? 'rgba(170,160,150,0.85)'
      : kind === 'narration' ? 'rgba(168,160,184,0.72)'
      : kind === 'boss' ? 'rgba(214,196,168,0.9)'
      : '#ddd0f2'
  const { choosing, block, startY, choicePanelTop, pageLines } = measureAdvChoicePanel(ctx, rt, scene)
  // 選択肢が現れてくる分だけ本文を落とす (2026-07-25 第4段-b)。 文章を読んでいない人にも
  //   「画面が切り替わった」ことが視界の端で分かるようにする = 気づかせるための唯一の演出。
  const revealAlpha = choosing ? choiceRevealAlpha(rt) : 0
  const bodyDim = 1 - 0.45 * revealAlpha
  const activeLine = activeTextLine(rt, scene)
  ctx.save()
  ctx.textAlign = 'left'
  pageLines.forEach((l, i) => {
    ctx.globalAlpha = bodyDim
    // 文字が増えるたびに既に出た文字が横へ動かないよう、中央位置は全文の幅で固定する。
    const fullSegs = advLineSegments(l, colorOf(l.kind))
    const fullWidths = fullSegs.map((s) => { ctx.font = s.font; return ctx.measureText(s.text).width })
    let x = cx - fullWidths.reduce((a, b) => a + b, 0) / 2
    const segs = revealedAdvLineSegments(l, colorOf(l.kind), l === activeLine ? rt.revealedChars : Infinity)
    segs.forEach((s) => {
      ctx.font = s.font
      ctx.fillStyle = s.color
      ctx.fillText(s.text, x, startY + i * ADV_LINE_STEP)
      x += ctx.measureText(s.text).width
    })
  })
  ctx.restore()

  if (choosing && block) {
    // 本文が終わってから CHOICE_REVEAL_DELAY_MS は何も出さず、 そのあと
    //   CHOICE_REVEAL_FADE_MS かけてじわっと現れる (2026-07-25 第4段-b)。
    //   ⚠️ 現れきるまで入力は死んでいる (adv.ts の isChoiceInputOpen が唯一の境界)。
    //   ここで見えているものと押せるものが必ず一致する = 「見えているのに効かない」時間を作らない。
    drawAdvChoice(ctx, choosing, rt.choiceIndex, cx, choicePanelTop, block, revealAlpha)
    // 比較版 b (DEV ?advChoice=b): 案内を画面の下の小さな字から、2択のすぐ下へ大きく出す。
    if (revealAlpha > 0) drawAdvChoiceHint(ctx, cx, revealAlpha, import.meta.env.DEV && advChoiceLook() === 'b' ? choicePanelTop + block.panelHeight + 18 : undefined)
  } else if (rt.done) {
    drawOverlayPrompt(ctx, doneLabel, cx, '#b9a3d9')
  } else {
    drawAdvAdvanceHint(ctx, cx)
  }
  lamp()
}

// 進行ヒント (推奨・小さく画面下)。
//   ⚠️ 2026-07-24: 以前はここに「長押しで早送り」とだけ出しており、タップで1行送れることが
//   画面から読めなかった (実機FB)。早送り (✕/R 長押し600ms=skip) の仕様自体は変えず、UIテキストとしては
//   タップの「次へ」だけを教える形へ変更。
//   ⚠️ 2026-07-24 追補: kbmのADV進行はRキーを廃止しクリック専用にした (ユーザー裁定)。
//   TIPSカードの nextToken と同じ考え方で pad→{retry}(✕)・kbm→{attack}(クリック) を出し分ける。
function drawAdvAdvanceHint(ctx: CanvasRenderingContext2D, cx: number): void {
  ctx.save()
  ctx.textAlign = 'center'
  ctx.globalAlpha = 0.5
  ctx.fillStyle = '#8a7aa8'
  ctx.font = `11px ${uiSans()}`
  const token = inputDeviceView().device === 'pad' ? '{retry}' : '{attack}'
  ctx.fillText(resolveInputText(`${token} で 次へ`, inputDeviceView()), cx, ARENA.height - 16)
  ctx.restore()
}

// 選択中の画面下ヒント (2026-07-25 第4段)。 これまでは選択中に操作ヒントが消えていた。
//   読み飛ばす人ほど、選択肢の手前で手が止まった時に画面から情報が減るのは最悪
//   (§4「何をすればいいかを画面に出す」)。 選択肢パネルと同じ濃度で一緒に現れる
//   (2026-07-25 第4段-b: 未選択状態を廃止したので、 濃さの出し分けも廃止)。
function drawAdvChoiceHint(ctx: CanvasRenderingContext2D, cx: number, revealAlpha: number, nearY?: number): void {
  ctx.save()
  ctx.textAlign = 'center'
  ctx.globalAlpha = (nearY === undefined ? 0.5 : 0.9) * revealAlpha
  ctx.fillStyle = nearY === undefined ? '#8a7aa8' : '#d9cbef'
  ctx.font = nearY === undefined ? `11px ${uiSans()}` : `15px ${uiSans()}`
  // 2026-07-26: kbm は ↑↓ を廃止し、選択肢そのものをクリックして選ぶ形に統一した
  //   (Space で誤って分岐が確定しないよう、確定もクリック限定にしてある・game.ts の kbmChoiceOpen)。
  const text = inputDeviceView().device === 'pad'
    ? '{move}で選ぶ  ・  {retry}で決める'
    : '選びたい方をクリック'
  ctx.fillText(resolveInputText(text, inputDeviceView()), cx, Math.min(nearY ?? ARENA.height - 16, ARENA.height - 16))
  ctx.restore()
}

// former-princess 内語フェーズの回想。 4枚を progress(0..1) で順にクロスフェード表示 (絵のみ)。
//   絵の順 = ワークブック選定順 (騎士の長槍→覚醒王の虚無→前の hollow-actor の仮面→先代がほどける姿)。
const FLASHBACK_SRCS = [
  '/flashback/flashback_knight_lance.png',
  '/flashback/flashback_awoken_king_void.png',
  '/flashback/flashback_hollow_mask.png',
  '/flashback/flashback_princess_dissolve.png',
]
function drawFlashbackImages(ctx: CanvasRenderingContext2D, progress: number): void {
  ctx.fillStyle = 'rgba(2,1,6,1)'
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  const n = FLASHBACK_SRCS.length
  const seg = 1 / n
  const idx = Math.min(n - 1, Math.floor(progress / seg))
  const local = (progress - idx * seg) / seg   // 0..1 この絵の中での進捗
  // クロスフェード: 各絵は入り18%でフェードイン・出18%でフェードアウト
  const fadeIn = Math.min(1, local / 0.18)
  const fadeOut = Math.min(1, (1 - local) / 0.18)
  const alpha = Math.max(0, Math.min(1, Math.min(fadeIn, fadeOut)))
  const entry = ensureBg(FLASHBACK_SRCS[idx]!)
  if (entry && entry.img.complete && entry.img.naturalWidth > 0) {
    const img = entry.img
    // contain フィット (画面中央・アスペクト維持・画面の78%サイズ)
    const maxW = ARENA.width * 0.78, maxH = ARENA.height * 0.78
    const s = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight)
    const w = img.naturalWidth * s, h = img.naturalHeight * s
    ctx.save()
    ctx.globalAlpha = alpha
    ctx.drawImage(img, (ARENA.width - w) / 2, (ARENA.height - h) / 2, w, h)
    ctx.restore()
  }
  // 常夜燈の気配 (冷青) を隅に薄く残す (魂が常夜燈へ昇る内語との連続性)
  drawAdvGhostLight(ctx, ARENA.width - 70, ARENA.height - 78, 0.6)
}

// 選択UI: 中央下・控えめ・選択後のフィードバック演出なし (善悪を見せない・正典§4.1)。
// 選択肢は長文を含むため、横並びにはしない。本文と同じくゴシックで読ませる。
const ADV_LINE_STEP = 42
const ADV_CHOICE_MAX_WIDTH = ARENA.width * 0.72
const ADV_CHOICE_LINE_HEIGHT = 28
const ADV_CHOICE_OPTION_GAP = 14
const ADV_CHOICE_NO_LINE_START = '、。，．・：；？！」』）］｝〕〉》”’ー〜…'
const ADV_CHOICE_PANEL_PAD_Y = 16
const ADV_CHOICE_PROMPT_HEIGHT = 30
// 本文の最終行と選択肢パネルの間隔 / 画面の上下に最低限残す余白。
const ADV_CHOICE_BODY_GAP = 26
const ADV_EDGE_MARGIN = 24
// フェードイン尺は adv.ts の CHOICE_REVEAL_FADE_MS へ移した (2026-07-25 第4段-b)。
//   入力を開ける境界と描画の境界を1か所で持つため (choiceRevealAlpha / isChoiceInputOpen)。
// 1行目のベースラインから見た文字の高さ / 最終行のベースラインから下に出る分。
const ADV_LINE_CAP = 17
const ADV_LINE_DESCENT = 6
// 1画面に置く本文の最大行数。 幾何的には12行入るが詰まって見えるので8行で切る
// (これまでの最長場面=鶏7行の見た目に合わせる)。 溢れた分はページを送る。
const ADV_MAX_LINES_PER_PAGE = 8

// 下に tail px を空けた時、 1画面に何行置けるか。
function advLinesThatFit(tail: number): number {
  const room = ARENA.height - ADV_EDGE_MARGIN * 2 - ADV_LINE_CAP - tail
  return Math.max(1, Math.min(ADV_MAX_LINES_PER_PAGE, Math.floor(room / ADV_LINE_STEP) + 1))
}

// 1ページに入る行数。 最後のページは選択肢パネルの分だけ減る。
export function advPageCapacities(choicePanelHeight: number | null): { capPlain: number; capLast: number } {
  const capPlain = advLinesThatFit(ADV_LINE_DESCENT)
  return {
    capPlain,
    capLast: choicePanelHeight !== null ? advLinesThatFit(ADV_CHOICE_BODY_GAP + choicePanelHeight) : capPlain,
  }
}

// 本文をページへ割る (2026-07-21 ユーザー裁定「文字数多いなら2ページになってもいい」)。
//   最後のページだけ選択肢パネルの分だけ入る行数が減るので capLast を別に取る。
//   ページ送りに専用の入力は要らない: 行を進めれば、 いつもの操作でそのまま次ページへ移る。
export function paginateAdvLines(total: number, capPlain: number, capLast: number): number[] {
  const pages: number[] = []
  let placed = 0
  while (placed < total) {
    const rest = total - placed
    const take = rest <= capLast ? rest : Math.min(rest, capPlain)
    pages.push(take)
    placed += take
  }
  return pages.length ? pages : [0]
}

type AdvChoiceOptionLayout = {
  lines: string[]
  top: number
  bottom: number
}

// Canvas 用の和文折り返し。選択マーカーを付けた最終表示文言を渡すため、幅計測にも含まれる。
export function layoutAdvChoiceOptions(
  texts: string[],
  maxWidth: number,
  measure: (text: string) => number,
): AdvChoiceOptionLayout[] {
  let top = 0
  return texts.map((text, i) => {
    const lines: string[] = []
    let line = ''
    for (const char of text) {
      if (line && measure(line + char) > maxWidth) {
        if (ADV_CHOICE_NO_LINE_START.includes(char)) {
          lines.push(line + char)
          line = ''
        } else {
          lines.push(line)
          line = char
        }
      } else {
        line += char
      }
    }
    if (line) lines.push(line)
    const height = lines.length * ADV_CHOICE_LINE_HEIGHT
    const layout = { lines, top, bottom: top + height }
    top = layout.bottom + (i < texts.length - 1 ? ADV_CHOICE_OPTION_GAP : 0)
    return layout
  })
}

// 本文ブロックと選択肢パネルの縦位置 (2026-07-21 ユーザー裁定「画面中央に合わせる」)。
//   ⚠️ lineCount は「今見えている行数」ではなく **その場面で最終的に出る行数**。
//      見えている数で中央を取ると、 1行増えるたび文章全体がずり上がって読んでいる最中に動く。
//      最終行数で先に場所を決めておけば、 行は上から埋まるだけで1文字も動かない。
//   fits=false は画面に収まらなかった合図 (現状どの場面も収まる。 テストで見張る)。
export function layoutAdvInterlude(
  lineCount: number,
  choicePanelHeight: number | null,
): { startY: number; choicePanelTop: number; bodyLastY: number; blockHeight: number; fits: boolean } {
  const bodySpan = Math.max(0, lineCount - 1) * ADV_LINE_STEP
  const tail = choicePanelHeight !== null
    ? ADV_CHOICE_BODY_GAP + choicePanelHeight
    : ADV_LINE_DESCENT
  const blockHeight = ADV_LINE_CAP + bodySpan + tail
  const top = Math.max(ADV_EDGE_MARGIN, (ARENA.height - blockHeight) / 2)
  const startY = top + ADV_LINE_CAP
  const bodyLastY = startY + bodySpan
  return {
    startY,
    choicePanelTop: choicePanelHeight !== null ? bodyLastY + ADV_CHOICE_BODY_GAP : 0,
    bodyLastY,
    blockHeight,
    fits: blockHeight <= ARENA.height - ADV_EDGE_MARGIN * 2,
  }
}

type AdvChoiceBlock = {
  layouts: AdvChoiceOptionLayout[]
  promptOffset: number
  panelHeight: number
}

// 本文の下へ収めるため、描く前に高さだけ測る (行数は折り返し後にしか決まらない)。
function measureAdvChoiceBlock(
  ctx: CanvasRenderingContext2D,
  choice: { prompt?: string; options: { text: string }[] },
  index: number,
): AdvChoiceBlock {
  ctx.save()
  ctx.font = `600 17px ${uiSans()}`
  const texts = choice.options.map((o, i) => i === index ? `― ${o.text} ―` : o.text)
  const layouts = layoutAdvChoiceOptions(texts, ADV_CHOICE_MAX_WIDTH, (text) => ctx.measureText(text).width)
  ctx.restore()
  const promptOffset = choice.prompt ? ADV_CHOICE_PROMPT_HEIGHT : 0
  const contentHeight = layouts.at(-1)?.bottom ?? 0
  return { layouts, promptOffset, panelHeight: contentHeight + promptOffset + ADV_CHOICE_PANEL_PAD_Y * 2 }
}

// 選択肢1つ1つの矩形 (ARENA座標)。 描画 (drawAdvChoice) と当たり判定 (game.ts) が
//   同じ関数から取る唯一の出所 (第2段の menu_layout.ts と同じ規律・別々に書くと黙ってズレる)。
//   幅は ADV_CHOICE_MAX_WIDTH いっぱい・中央揃え、 高さは各 option の行数 × ADV_CHOICE_LINE_HEIGHT。
export function advChoiceOptionRects(
  choice: { prompt?: string; options: { text: string }[] },
  index: number,
  choicePanelTop: number,
  measure: (text: string) => number,
): MenuRect[] {
  const texts = choice.options.map((o, i) => i === index ? `― ${o.text} ―` : o.text)
  const layouts = layoutAdvChoiceOptions(texts, ADV_CHOICE_MAX_WIDTH, measure)
  const promptOffset = choice.prompt ? ADV_CHOICE_PROMPT_HEIGHT : 0
  const optionsTop = choicePanelTop + ADV_CHOICE_PANEL_PAD_Y + promptOffset
  const left = ARENA.width / 2 - ADV_CHOICE_MAX_WIDTH / 2
  return layouts.map((layout) => ({
    x: left, y: optionsTop + layout.top, w: ADV_CHOICE_MAX_WIDTH, h: layout.bottom - layout.top,
  }))
}

function drawAdvChoice(
  ctx: CanvasRenderingContext2D,
  choice: { prompt?: string; options: { text: string }[] },
  index: number,
  cx: number,
  panelTop: number,
  block: AdvChoiceBlock,
  fadeAlpha: number,
): void {
  ctx.save()
  ctx.textAlign = 'center'
  // 下地は「箱」ではなく画面下の影を深める形にする。 矩形で塗ると幕間の背景
  // (rgba(6,3,13,0.96)) より明るい四角が浮いて、舞台の現象でなくUIの図形に見える。
  // 上下を透明へ落とし、横は画面幅いっぱいに広げて縁を作らない。
  const shade = ctx.createLinearGradient(0, panelTop - 14, 0, panelTop + block.panelHeight + 14)
  shade.addColorStop(0, 'rgba(0,0,0,0)')
  shade.addColorStop(0.3, 'rgba(0,0,0,0.5)')
  shade.addColorStop(0.7, 'rgba(0,0,0,0.5)')
  shade.addColorStop(1, 'rgba(0,0,0,0)')
  ctx.fillStyle = shade
  ctx.globalAlpha = fadeAlpha
  ctx.fillRect(0, panelTop - 14, ARENA.width, block.panelHeight + 28)
  const contentTop = panelTop + ADV_CHOICE_PANEL_PAD_Y
  if (choice.prompt) {
    ctx.font = `15px ${UI_SERIF}`
    ctx.fillStyle = 'rgba(220,208,242,0.7)'
    ctx.globalAlpha = fadeAlpha
    ctx.fillText(choice.prompt, cx, contentTop + 18)
  }
  ctx.font = `600 17px ${uiSans()}`
  const optionsTop = contentTop + block.promptOffset
  choice.options.forEach((_, i) => {
    const sel = i === index
    const lay = block.layouts[i]!
    // 2択の読みやすさ (src/readability_1104.ts)。配布版 = a (墨の帯・選んでいない方 0.85)。?advChoice=old は帯なし・0.5。
    {
      const tw = Math.max(...lay.lines.map((l) => ctx.measureText(l).width))
      const h = lay.lines.length * ADV_CHOICE_LINE_HEIGHT
      drawChoiceInk(ctx, cx, optionsTop + lay.top + h / 2 + 5, tw + 130, h + 22, sel, fadeAlpha)
    }
    ctx.globalAlpha = (sel ? 1 : advChoiceIdleAlpha()) * fadeAlpha
    ctx.fillStyle = sel ? '#f4d878' : advChoiceIdleColor()
    for (const [lineIndex, line] of lay.lines.entries()) {
      ctx.fillText(line, cx, optionsTop + lay.top + (lineIndex + 1) * ADV_CHOICE_LINE_HEIGHT)
    }
  })
  ctx.restore()
}

// 城に残って次の姫になる / 舞台を降りて城を出る の短縮ラベル+補助フル文言 (画面幅に収める)。
const CHOICE_LABELS = ['城に残る', '城を出る']
const CHOICE_FULL_TEXT = ['城に残って次の姫になる', '舞台を降りて城を出る']
const CHOICE_LIMIT_SEC = 5

function drawChoice(ctx: CanvasRenderingContext2D, state: GameState): void {
  const t = state.phaseElapsedSec
  const cx = ARENA.width / 2
  const smooth = (v: number): number => { const c = Math.max(0, Math.min(1, v)); return c * c * (3 - 2 * c) }
  ctx.fillStyle = 'rgba(6,3,13,0.97)'
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  // 中央の常夜燈が問いかける
  drawGhostLight(ctx, cx, ARENA.height * 0.34, 1.4, 1)

  const a = smooth(t / 0.8)
  ctx.save()
  ctx.textAlign = 'center'

  // 残り秒カウントダウン (読めるが急かす演出。2秒以下は暖色へ寄せる)。
  const remaining = Math.max(0, Math.ceil(CHOICE_LIMIT_SEC - t))
  ctx.globalAlpha = a * 0.8
  ctx.font = `15px ${UI_SERIF}`
  ctx.fillStyle = remaining <= 2 ? PALETTE.hudGold : 'rgba(220,208,242,0.7)'
  if (choiceTimerOn()) ctx.fillText(`${remaining}`, cx, ARENA.height * 0.34 + 6)

  CHOICE_LABELS.forEach((label, i) => {
    // 座標は menu_layout.ts (endingChoiceRects) と共有 (2026-07-25 第2段・当たり判定と同じ出所)。
    const ox = cx + (i === 0 ? -ENDING_CHOICE_OFFSET_X : ENDING_CHOICE_OFFSET_X)
    const oy = ARENA.height * ENDING_CHOICE_Y_FRAC
    const selected = state.choiceIndex === i
    ctx.globalAlpha = a * (selected ? 1 : 0.4)
    ctx.font = `600 ${ENDING_CHOICE_FONT_PX}px ${UI_SERIF}`
    if (selected) {
      ctx.shadowColor = 'rgba(244,216,120,0.9)'
      ctx.shadowBlur = 24
      ctx.fillStyle = PALETTE.hudGold
    } else {
      ctx.shadowBlur = 0
      ctx.fillStyle = '#9a8cb8'
    }
    ctx.fillText(label, ox, oy)
    ctx.shadowBlur = 0
  })

  // 選択中の側だけフルの言い回しを補助行として出す。
  ctx.globalAlpha = a * 0.7
  ctx.font = `13px ${UI_SERIF}`
  ctx.fillStyle = '#cbb8ea'
  ctx.fillText(CHOICE_FULL_TEXT[state.choiceIndex] ?? '', cx, ARENA.height * 0.62 + 40)

  ctx.globalAlpha = a * 0.6
  ctx.fillStyle = '#8a7aa8'
  ctx.font = `12px ${uiSans()}`
  const choiceHint = inputDeviceView().device === 'pad'
    ? resolveInputText('{move}で選ぶ ・ {retry}で決める', inputDeviceView())
    : 'A / D で選ぶ ・ クリック で決める'
  ctx.fillText(choiceHint, cx, ARENA.height - 36)
  ctx.restore()
}

function drawEnding(ctx: CanvasRenderingContext2D, state: GameState): void {
  const cx = ARENA.width / 2
  const kind = state.endingChoice ?? 'loop'
  const scene = getEndingScene(kind)
  const rt = state.adv
  // 絵のある結末 (今は「残る」の版7・?stayEnding=old の前の台本は文字だけ) は会話場面と同じ紙芝居で見せ、 終わりの光の川だけ重ねる。
  if (rt && isPictureScene(scene)) {
    drawPictureInterlude(ctx, state, scene, '幕')
    const cue = activeCueBeat(rt, scene)
    if (cue?.effect === 'lamp_focus') drawLampRiver(ctx, cue.progress)
    return
  }
  ctx.fillStyle = 'rgba(4,2,9,0.98)'
  ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  if (!rt) return
  // 常夜燈 (常時)。 cue演出 (紫光の川/世界消失/スライド) は本文の後に重ねる。
  drawGhostLight(ctx, ARENA.width - 110, ARENA.height - 80, 0.9, 0.7)
  // 本文テキスト (drawInterlude と同じ colorOf・文字送り)。
  // 終幕は本文が長い(stay=15行前後/true=18行前後)ため、直近 RECENT_LINES_MAX 行だけを
  // 画面下端(540px)まで収まる範囲でウィンドウ表示する (古い行は流れて消える=VN履歴パネル方式)。
  const RECENT_LINES_MAX = 6
  const allLines = visibleLines(rt, scene)
  const lines = allLines.slice(-RECENT_LINES_MAX)
  const colorOf = (k: string): string =>
    k === 'voice' ? 'rgba(244,216,120,0.92)'
      : k === 'narration' ? 'rgba(168,160,184,0.72)'
      : k === 'boss' ? 'rgba(214,196,168,0.9)'
      : '#ddd0f2'
  ctx.save()
  ctx.textAlign = 'left'
  const startY = ARENA.height * 0.4
  const activeLine = activeTextLine(rt, scene)
  lines.forEach((l, i) => {
    ctx.globalAlpha = 1
    // 幕間と同じく、文字送り中に出済みの文字をずらさない。
    const fullSegs = advLineSegments(l, colorOf(l.kind))
    const fullWidths = fullSegs.map((segment) => { ctx.font = segment.font; return ctx.measureText(segment.text).width })
    let x = cx - fullWidths.reduce((sum, width) => sum + width, 0) / 2
    const segs = revealedAdvLineSegments(l, colorOf(l.kind), l === activeLine ? rt.revealedChars : Infinity)
    segs.forEach((segment) => {
      ctx.font = segment.font
      ctx.fillStyle = segment.color
      ctx.fillText(segment.text, x, startY + i * 34)
      x += ctx.measureText(segment.text).width
    })
  })
  ctx.restore()
  const cb = activeCueBeat(rt, scene)
  if (cb) {
    if (cb.effect === 'lamp_focus') drawLampRiver(ctx, cb.progress)       // エンドA
    else if (cb.effect === 'world_out') drawWorldOut(ctx, cb.progress)     // エンドC
    else if (cb.effect === 'slide') drawRecapSlides(ctx, kind, cb.progress)   // エンドB/Loop-2
    else if (cb.effect === 'flashback') drawRecapSlides(ctx, kind, cb.progress) // エンドC 未完了5象徴
  }
  if (rt.done) drawOverlayPrompt(ctx, '幕', cx, '#b9a3d9')
  else drawAdvAdvanceHint(ctx, cx)
}

// エンドA (Stay): 無数の光の川が中央の常夜燈へ吸い込まれ、末尾で暗転する。
// 個別のボス象徴は識別可能な形で見せない (台帳「Stay=8択回収なし」)。
function drawLampRiver(ctx: CanvasRenderingContext2D, p: number): void {
  const cx = ARENA.width / 2, cy = ARENA.height * 0.42
  // 川: 画面周縁の多数の点が常夜燈へ吸い込まれる (taperStreak を燈へ向ける)
  const streams = 48
  for (let i = 0; i < streams; i += 1) {
    const ang = hash01(i * 3.1) * Math.PI * 2
    const startR = 320 + hash01(i * 7.7) * 240
    const flow = (p + hash01(i * 1.9)) % 1          // 0..1 燈への到達進捗
    const r = startR * (1 - flow)
    const x = cx + Math.cos(ang) * r
    const y = cy + Math.sin(ang) * r * 0.7
    const dx = cx - x, dy = cy - y
    const a = 0.5 * (1 - flow) * Math.min(1, p * 1.4)
    taperStreak(ctx, x, y, dx, dy, 40 + hash01(i) * 50, 3, 'rgba(198,216,244,1)', a)   // = SOUL_BLUE.head (旧 rgba(150,110,220))
    glowMote(ctx, x, y, 3 + hash01(i * 2.3) * 3, 'rgba(232,240,255,1)', a)   // = SOUL_BLUE.tail (旧 rgba(170,130,240))
  }
  // 常夜燈が呑む: 後半で強く光る
  const lampI = 0.7 + Math.min(1, Math.max(0, (p - 0.4) / 0.6)) * 1.3
  drawGhostLight(ctx, cx, cy, 1.4, lampI)
  // 末尾で暗転
  const black = Math.max(0, (p - 0.8) / 0.2)
  if (black > 0) { ctx.save(); ctx.globalAlpha = black; ctx.fillStyle = '#020106'; ctx.fillRect(0, 0, ARENA.width, ARENA.height); ctx.restore() }
}

// エンドC (True): 常夜燈が消灯し、その位置から世界そのものが黒に呑まれ、真の暗黒で終わる。
// エンドAの暗転と違い「光の残りもない」(末尾で全面 #000)。
function drawWorldOut(ctx: CanvasRenderingContext2D, p: number): void {
  const cx = ARENA.width / 2, cy = ARENA.height * 0.42
  // 前半: 燈が消えていく (intensity 落ちる)
  const lampI = Math.max(0, 0.9 * (1 - p / 0.45))
  if (lampI > 0.01) drawGhostLight(ctx, cx, cy, 1.3, lampI)
  // 後半: 消えた点から黒が世界を呑む (半径拡大)
  if (p > 0.4) {
    const grow = (p - 0.4) / 0.6
    const R = grow * Math.hypot(ARENA.width, ARENA.height)
    ctx.save()
    const g = ctx.createRadialGradient(cx, cy, Math.max(0, R - 120), cx, cy, R)
    g.addColorStop(0, '#000000')
    g.addColorStop(1, 'rgba(0,0,0,0)')
    ctx.fillStyle = g
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    ctx.restore()
  }
  // 完全暗転 (末尾)
  if (p > 0.92) { ctx.fillStyle = '#000'; ctx.fillRect(0, 0, ARENA.width, ARENA.height) }
}

// エンドB/C/Loop-2: 5象徴スライドのプレースホルダー (差し替えやすい形)。
// ENDING_RECAP_SYMBOLS を progress で1枚ずつ順送りし、キャプションを出す。
// imageSrcBefore/After が将来入れば ensureBg で絵を出す分岐へ切り替わる (今は空なのでキャプション表示にフォールバック)。
function drawRecapSlides(ctx: CanvasRenderingContext2D, kind: EndingChoice, p: number): void {
  const syms = ENDING_RECAP_SYMBOLS
  const seg = 1 / syms.length
  const idx = Math.min(syms.length - 1, Math.floor(p / seg))
  const local = (p - idx * seg) / seg
  const alpha = Math.max(0, Math.min(1, Math.min(local / 0.2, (1 - local) / 0.2)))
  const sym = syms[idx]!
  // true (エンドC flashback) = 未完了キャプション / それ以外 (loop/loop2 slide) = 整ったキャプション
  const caption = kind === 'true' ? sym.trueCaption : sym.loopCaption
  const src = kind === 'true' ? sym.imageSrcBefore : sym.imageSrcAfter
  ctx.fillStyle = 'rgba(2,1,6,1)'; ctx.fillRect(0, 0, ARENA.width, ARENA.height)
  const cx = ARENA.width / 2, cy = ARENA.height * 0.44
  const entry = src ? ensureBg(src) : null
  if (entry && entry.img.complete && entry.img.naturalWidth > 0) {
    // 画像到着後の経路 (現状 src は空なので通らない)
    const img = entry.img
    const s = Math.min(ARENA.width * 0.7 / img.naturalWidth, ARENA.height * 0.6 / img.naturalHeight)
    const w = img.naturalWidth * s, h = img.naturalHeight * s
    ctx.save(); ctx.globalAlpha = alpha; ctx.drawImage(img, (ARENA.width - w) / 2, cy - h / 2, w, h); ctx.restore()
  } else {
    // プレースホルダー: 象徴名+状態キャプション (画像未発注)
    emberRise(ctx, cx, cy + 40, 10, kind === 'true' ? 'rgba(150,110,220,1)' : 'rgba(120,150,220,1)', p * 4, idx * 13.1, 120, 220)
    ctx.save(); ctx.textAlign = 'center'; ctx.globalAlpha = alpha
    ctx.fillStyle = '#c9bce6'; ctx.font = `600 26px ${UI_SERIF}`
    ctx.fillText(sym.name, cx, cy - 8)
    ctx.fillStyle = 'rgba(168,160,184,0.85)'; ctx.font = `16px ${UI_SERIF}`
    ctx.fillText(caption, cx, cy + 28)
    ctx.restore()
  }
  drawGhostLight(ctx, ARENA.width - 90, ARENA.height - 70, 1, 0.55)
}

function toRoman(n: number): string {
  const map: [number, string][] = [[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']]
  let out = ''; let v = Math.max(1, n)
  for (const [val, sym] of map) while (v >= val) { out += sym; v -= val }
  return out
}

// 勝敗オーバーレイの大見出し (明朝・荘厳・グロー。 タイトル画面と統一トーン)。
function drawOverlayTitle(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, color: string, glow: string, alpha = 1): void {
  if (alpha <= 0.01) return
  ctx.save()
  ctx.globalAlpha = alpha
  ctx.textAlign = 'center'
  ctx.fillStyle = color
  ctx.shadowColor = glow
  ctx.shadowBlur = 30
  ctx.font = `600 52px ${UI_SERIF}`
  ctx.fillText(text, x, y)
  ctx.shadowBlur = 14
  ctx.fillText(text, x, y)  // 二度刷りで芯を強く
  ctx.restore()
  // 見出し下の細い金/血の罫線 (端を fade)。 罫線は本文より少し遅れて伸びる
  ctx.save()
  const w = 150 * alpha
  const lg = ctx.createLinearGradient(x - w, 0, x + w, 0)
  lg.addColorStop(0, 'rgba(0,0,0,0)')
  lg.addColorStop(0.5, color)
  lg.addColorStop(1, 'rgba(0,0,0,0)')
  ctx.globalAlpha = 0.55 * alpha
  ctx.fillStyle = lg
  ctx.fillRect(x - w, y + 14, w * 2, 1.4)
  ctx.restore()
}

// 点滅する継続プロンプト (sim 時間は止まるので実時間で点滅)。
function drawOverlayPrompt(ctx: CanvasRenderingContext2D, text: string, x: number, color: string): void {
  const blink = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin(performance.now() / 1000 * 3.5))
  ctx.save()
  ctx.textAlign = 'center'
  ctx.globalAlpha = blink
  ctx.fillStyle = color
  ctx.font = `15px ${UI_SERIF}`
  ctx.fillText(text, x, ARENA.height - 28)
  ctx.restore()
}

// 開始画面 (ENDER LILIES 流リデザイン 2026-06-22 #10): 説明を全撤去しアートとロゴと最小メニューだけ。
//   ①専用の静止背景 (/bg/title.png があれば使う / 無ければ procedural な暗い夜+常夜燈の一灯で代替)。
//   ②2段階ゲート: titleEntered=false=ロゴ+「押して始める」だけ / true=縦型ミニマルメニューを浮かべる。
//   機構説明「弾いて崩し…」/キャラ説明「黒衣の姫 LUNAIRE」/操作ヒント「A/Dで…」は撤去 (操作は幕間の記録へ)。
//   ※「進化するタイトル」(True エンド到達でこの絵が"足し算"で変わる)= True エンド本体実装時にここへ分岐を足す。
const TITLE_BG_SRC = '/bg/title.png'
let titleBootDone = false
// 最後に描いたコマで、タイトルの絵を待つ常夜燈を描いたか (index.html の起動の灯をそのまま引き継いだかを main.ts が見る)
let titleBootLampDrawn = false
export function titleBootLampDrawnLastFrame(): boolean { return titleBootLampDrawn }
function titleBootWaiting(bgLoaded: boolean): boolean {
  if (titleBootDone) return false
  if (bgLoaded || typeof Image === 'undefined' || performance.now() >= TITLE_BOOT_WAIT_MAX_MS) { titleBootDone = true; return false }
  return true
}
function drawTitleScreen(ctx: CanvasRenderingContext2D, state: GameState): void {
  const cx = ARENA.width / 2
  const tm = performance.now() / 1000   // sim 時間は止まるので実時間で点滅
  ctx.save()

  // 比較版 ?title=v9 (src/title_v9.ts): ロゴ入りの霧の絵を敷き、暗い字のメニューを中央に置く。
  if (titleV9()) {
    drawTitleScreenV9(ctx, state, tm)
    ctx.restore()
    return
  }

  // ① 専用の静止背景。 画像があればそれを、 無ければ procedural な暗い夜+常夜燈で代替 (キーアート到着で自動差替)。
  const bg = ensureBg(TITLE_BG_SRC)
  // ページを開いた直後、背景の絵が届くまでは黒と読み込み待ちの常夜燈 (11-03・作者 q6「開いた直後にも出す」)。
  //   待ちはページを開いてからの時間 (index.html の起動の灯と同じ時計)。上限を過ぎたら前と同じ代わりの夜の絵へ。一度抜けたら二度と待たない。
  titleBootLampDrawn = titleBootWaiting(!!bg?.loaded)
  if (titleBootLampDrawn) {
    ctx.fillStyle = '#000'
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    drawLoadingIndicator(ctx, performance.now())
    ctx.restore()
    return
  }
  if (bg && bg.loaded) {
    ctx.drawImage(bg.img, 0, 0, ARENA.width, ARENA.height)
    ctx.fillStyle = 'rgba(6,3,13,0.22)'   // 全体を軽く沈める
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    // 上端スクリム (ロゴ用) と 下端スクリム (メニュー用): 絵の中央の見せ場は明るく残し、 文字の乗る上下だけ沈める。
    const top = ctx.createLinearGradient(0, 0, 0, ARENA.height * 0.42)
    top.addColorStop(0, 'rgba(6,3,13,0.62)'); top.addColorStop(1, 'rgba(6,3,13,0)')
    ctx.fillStyle = top; ctx.fillRect(0, 0, ARENA.width, ARENA.height * 0.42)
    const bot = ctx.createLinearGradient(0, ARENA.height * 0.5, 0, ARENA.height)
    bot.addColorStop(0, 'rgba(6,3,13,0)'); bot.addColorStop(1, 'rgba(6,3,13,0.78)')
    ctx.fillStyle = bot; ctx.fillRect(0, ARENA.height * 0.5, ARENA.width, ARENA.height * 0.5)
  } else {
    drawTitleProceduralBg(ctx)
  }
  ctx.textAlign = 'center'

  // 幕間の記録サブパネルが開いている場合はそちらを描く
  if (state.pausePanel === 'records') {
    drawRecordsPanel(ctx, state)
    ctx.restore()
    return
  }
  if (state.pausePanel === 'credits') {
    drawCreditsPanel(ctx, state)
    ctx.restore()
    return
  }

  // ロゴ「LUNAIRE」だけ (10-31 作者「LUNAIREで」「LUNAIREだけにする」・副題「常夜燈」は外した) (明朝・荘厳・紫グロー)。 両段階で共通。
  ctx.save()
  ctx.fillStyle = '#efe2ff'
  ctx.shadowColor = 'rgba(154,122,196,0.9)'
  ctx.shadowBlur = 26
  ctx.font = `600 54px ${UI_SERIF}`
  ctx.fillText('LUNAIRE', cx, 150)
  ctx.restore()

  // 「幕を選ぶ」= 難易度選択サブ画面 (B案)。 タイトルの bg + ロゴの上に2択を重ねて描く。
  if (state.pausePanel === 'difficulty') {
    drawDifficultyOptions(ctx, state, tm)
    ctx.restore()
    return
  }
  // 「最初から始める」の確かめ (2026-10-19)。 「幕を選ぶ」と同じ左寄せ・箱なしで重ねる。
  if (state.pausePanel === 'newGameConfirm') {
    drawNewGameConfirm(ctx, state, tm)
    ctx.restore()
    return
  }

  const blink = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin(tm * 3))
  if (!state.titleEntered) {
    // ② 段階0: 「押して始める」だけ静かに点滅。 メニューも説明も出さない (アート前面)。
    ctx.globalAlpha = blink * 0.85
    ctx.fillStyle = '#cfc6dc'
    ctx.font = `15px ${uiSans()}`
    // 2026-07-26: kbm はクリック専用になったので「押して始める」では嘘になる
    //   (キーボードを押しても開かない)。 デバイスごとに実際の操作を書く
    //   (2026-07-25 の「『何かキー』は嘘」と同じ考え方)。
    ctx.fillText(
      inputDeviceView().device === 'pad'
        ? resolveInputText('{retry} で始める', inputDeviceView())
        : 'クリックして始める',
      cx, ARENA.height - 70,
    )
    // パッド入力は autoplay policy 上ブラウザの user activation にならず音が解錠されない
    //   (ブラウザ仕様上、パッド入力での解錠は不可能=試みない)。パッドで始めた人にだけヒントを出す。
    if (inputDeviceView().device === 'pad' && !audioUnlocked()) {
      ctx.globalAlpha = blink * 0.6
      ctx.fillStyle = '#8a7aa8'
      ctx.font = `12px ${uiSans()}`
      ctx.fillText('♪ 音を出すには、画面を一度クリック', cx, ARENA.height - 50)
    }
    ctx.globalAlpha = 1
    ctx.restore()
    return
  }

  // ② 段階1: 縦型ミニマルメニュー (選択中だけ淡い金 + 小さな灯の点)。 ブラケット ▸◂ は撤去。
  //   左下に寄せて中央のキーアート(LUNAIRE+常夜燈の軸)を避ける = 非対称で絵が映える。
  //   項目は進み具合の有無で3つか4つ (menu_layout.ts titleMenuItems・game.ts の決定と同じ出所・2026-10-19)。
  const opts = titleMenuItems(hasCampaignProgress(state.campaign)).map((k) => TITLE_MENU_LABELS[k])
  // 座標は menu_layout.ts (titleMenuRects) と共有 (2026-07-25 第2段・当たり判定と同じ出所)。
  const menuLeft = TITLE_MENU_LEFT
  const menuTop = titleMenuTop(opts.length)
  const rowH = TITLE_MENU_ROW_H
  ctx.font = `${TITLE_MENU_FONT_PX}px ${uiSans()}`
  ctx.textAlign = 'left'
  for (let i = 0; i < opts.length; i += 1) {
    const sel = i === state.titleIndex
    const y = menuTop + i * rowH
    if (sel) {
      ctx.beginPath()
      ctx.fillStyle = '#f4d878'
      ctx.arc(menuLeft, y - 6, 2.6, 0, Math.PI * 2)
      ctx.fill()
      ctx.globalAlpha = blink
      ctx.fillStyle = '#f4d878'
      ctx.fillText(opts[i]!, menuLeft + TITLE_MENU_TEXT_OFFSET_X, y)
      ctx.globalAlpha = 1
    } else {
      ctx.globalAlpha = 0.55
      ctx.fillStyle = '#8a8496'
      ctx.fillText(opts[i]!, menuLeft + TITLE_MENU_TEXT_OFFSET_X, y)
    }
  }
  ctx.globalAlpha = 1
  ctx.restore()
}

// タイトル画面の比較版 (?title=v9・src/title_v9.ts)。ロゴは絵に描き込み済みなので字の LUNAIRE は描かない。
//   霧の地が明るいので、メニューは暗い字 + 白い滲みで読ませる。選んでいる項目は濃い字と左右の細い線 (金の点は明るい地で沈むので使わない)。
//   幕を選ぶ・確かめ・幕間の記録は配布版の明るい字のままなので、その時だけ絵を暗く沈める。
function drawTitleScreenV9(ctx: CanvasRenderingContext2D, state: GameState, tm: number): void {
  const cx = ARENA.width / 2
  const bg = ensureBg(TITLE_V9_BG)
  if (bg && bg.loaded) ctx.drawImage(bg.img, 0, 0, ARENA.width, ARENA.height)
  else { ctx.fillStyle = '#cfc6e0'; ctx.fillRect(0, 0, ARENA.width, ARENA.height) }
  if (state.pausePanel === 'records' || state.pausePanel === 'credits' || state.pausePanel === 'difficulty' || state.pausePanel === 'newGameConfirm') {
    ctx.fillStyle = 'rgba(6,3,13,0.62)'
    ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    ctx.textAlign = 'center'
    if (state.pausePanel === 'records') drawRecordsPanel(ctx, state)
    else if (state.pausePanel === 'credits') drawCreditsPanel(ctx, state)
    else if (state.pausePanel === 'difficulty') drawDifficultyOptions(ctx, state, tm)
    else drawNewGameConfirm(ctx, state, tm)
    return
  }
  const blink = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin(tm * 3))
  ctx.textAlign = 'center'
  ctx.shadowColor = 'rgba(255,255,255,0.75)'
  ctx.shadowBlur = 10
  ctx.letterSpacing = '0.3em'
  if (!state.titleEntered) {
    ctx.globalAlpha = 0.45 + 0.55 * blink
    ctx.fillStyle = '#4a4060'
    ctx.font = titleV9Font(500, 15)
    ctx.fillText(
      inputDeviceView().device === 'pad' ? resolveInputText('{retry} で始める', inputDeviceView()) : 'クリックして始める',
      cx, TITLE_V9_MENU_TOP + TITLE_V9_MENU_ROW_H,
    )
    ctx.globalAlpha = 1
    ctx.letterSpacing = '0px'
    return
  }
  const opts = titleMenuItems(hasCampaignProgress(state.campaign)).map((k) => TITLE_MENU_LABELS[k])
  for (let i = 0; i < opts.length; i += 1) {
    const sel = i === state.titleIndex
    const y = TITLE_V9_MENU_TOP + i * TITLE_V9_MENU_ROW_H
    ctx.font = titleV9Font(sel ? 600 : 500)
    ctx.fillStyle = sel ? '#241c30' : '#4a4060'
    ctx.globalAlpha = sel ? 1 : 0.82
    ctx.fillText(opts[i]!, cx, y)
    if (sel) {
      const half = ctx.measureText(opts[i]!).width / 2
      ctx.globalAlpha = 0.55 + 0.25 * blink
      ctx.fillRect(cx - half - 34, y - 6, 22, 1)
      ctx.fillRect(cx + half + 12, y - 6, 22, 1)
    }
  }
  ctx.globalAlpha = 1
  ctx.letterSpacing = '0px'
}

// 難易度選択サブ画面の2択コピー (2026-07-25 ユーザー確定)。 数値・「既定」ラベルは書かない。
//   名=明朝(見せる) / 説明=ゴシック(読ませる)。 先頭が「――」の行は締めのキャプション扱い。
// ⚠️ export している理由: menu_layout.ts の DIFFICULTY_DESC_LINE_COUNTS が desc の行数を複製しており、
//   ここを増減すると「幕を選ぶ」の当たり判定がズレる。 tests/menu_layout.test.ts が一致を機械で固定する。
export const DIFFICULTY_OPTIONS: { name: string; yomi: string; desc: string[] }[] = [
  {
    name: '千秋楽', yomi: 'せんしゅうらく',
    desc: [
      '幾度もの死を越えて、なお立つあなたへ。',
      'ここに、慈悲はない。ひとつの綻びが、そのまま終幕となる。',
      '―― 磨き上げられた、最後の一夜。',
    ],
  },
  {
    name: '初演', yomi: 'はつえん',
    desc: [
      'はじめて、この舞台に上がるあなたへ。',
      '初演で、しくじらぬ役者はいない。',
      '転んでは覚え、また幕を上げればいい。',
      '―― 倒れても、灯は絶やさない。物語を、その結末まで。',
    ],
  },
]

// 千秋楽がまだ開いていない時の説明 (2026-10-09・終幕まで通した後でだけ選べる)。
//   行数は千秋楽の desc と同じ3行 = 当たり判定の並び (menu_layout.ts DIFFICULTY_DESC_LINE_COUNTS) がズレない。
export const SENSHURAKU_LOCKED_DESC: string[] = [
  'この幕は、まだ開かない。',
  '初演で、物語を終幕まで通したあなたにだけ、扉が開く。',
  '―― 先に、結末まで。',
]

// 「幕を選ぶ」サブ画面 (B案・2026-07-25)。 選んでいる幕だけ説明が灯る = キーアートを大きく見せる。
//   タイトルの bg + ロゴは drawTitleScreen 側で描き済み。 ここは 2択 + 操作ヒントだけを重ねる。
function drawDifficultyOptions(ctx: CanvasRenderingContext2D, state: GameState, tm: number): void {
  // 座標は menu_layout.ts (difficultyMenuRects) と共有 (2026-07-25 第2段・当たり判定と同じ出所)。
  const leftName = DIFFICULTY_LEFT_NAME, leftDot = 100
  // 読みやすさ: 左側だけそっと沈める (中央〜右の常夜燈の灯りは残す)。 箱は描かない (title の scrim と同型)。
  ctx.save()
  const scrim = ctx.createLinearGradient(0, 0, ARENA.width * 0.62, 0)
  scrim.addColorStop(0, 'rgba(6,3,13,0.66)')
  scrim.addColorStop(0.7, 'rgba(6,3,13,0.32)')
  scrim.addColorStop(1, 'rgba(6,3,13,0)')
  ctx.fillStyle = scrim
  ctx.fillRect(0, 214, ARENA.width * 0.62, 262)
  ctx.restore()

  const blink = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin(tm * 3))
  ctx.textAlign = 'left'

  // eyebrow「幕を選ぶ」
  ctx.save()
  ctx.fillStyle = 'rgba(244,216,120,0.62)'
  ctx.font = `400 13px ${uiSans()}`
  ctx.fillText('――  幕を選ぶ  ――', leftName, 246)
  ctx.restore()

  let y = DIFFICULTY_START_Y
  for (let i = 0; i < DIFFICULTY_OPTIONS.length; i += 1) {
    const opt = DIFFICULTY_OPTIONS[i]!
    const sel = i === state.difficultyIndex
    const locked = i === 0 && !state.senshurakuOpen   // 千秋楽: 終幕まで通すまで開かない
    // 灯の点 (選択中のみ・脈打つ)
    if (sel) {
      ctx.save()
      ctx.globalAlpha = blink
      ctx.fillStyle = locked ? '#8a8496' : '#f4d878'   // 鍵の掛かった幕の点は金に灯らない
      ctx.beginPath(); ctx.arc(leftDot, y - 9, 2.6, 0, Math.PI * 2); ctx.fill()
      ctx.restore()
    }
    // 名 (明朝)。 選択中=金+淡いグロー / 非選択=くすみグレー。
    ctx.save()
    ctx.font = `600 ${DIFFICULTY_NAME_FONT_PX}px ${UI_SERIF}`
    if (locked) {
      // 鍵の掛かった幕: 選んでいても金に灯らない (灯の点は出る = 説明は読める・決定は通らない)。
      ctx.fillStyle = sel ? '#6f6a80' : '#5a566a'
    } else if (sel) {
      ctx.fillStyle = '#f4d878'
      ctx.shadowColor = 'rgba(244,216,120,0.35)'; ctx.shadowBlur = 16
    } else {
      ctx.fillStyle = '#8a8496'
    }
    ctx.fillText(opt.name, leftName, y)
    const nameW = ctx.measureText(opt.name).width
    ctx.restore()
    // 読み (ゴシック小)
    ctx.save()
    ctx.fillStyle = 'rgba(168,160,184,0.6)'
    ctx.font = `400 12px ${uiSans()}`
    ctx.fillText(locked ? 'まだ開かない' : opt.yomi, leftName + nameW + 10, y - 2)
    ctx.restore()
    y += DIFFICULTY_NAME_ROW_H
    // 説明 (選択中のみ・ゴシック)。 先頭「――」行は締めで少し明るく。
    if (sel) {
      ctx.save()
      ctx.font = `400 14px ${uiSans()}`
      ctx.shadowColor = 'rgba(3,1,8,0.9)'; ctx.shadowBlur = 4
      const descLines = locked ? SENSHURAKU_LOCKED_DESC : opt.desc
      for (let li = 0; li < descLines.length; li += 1) {
        const line = descLines[li]!
        ctx.fillStyle = line.startsWith('――') ? 'rgba(232,226,244,0.82)' : 'rgba(214,208,226,0.72)'
        ctx.fillText(line, leftName, y + 8)
        y += DIFFICULTY_DESC_LINE_H
      }
      ctx.restore()
      y += DIFFICULTY_DESC_GAP
    }
    y += DIFFICULTY_TAIL_GAP
  }

  // 操作ヒント (下・控えめ)
  ctx.save()
  ctx.fillStyle = 'rgba(196,190,212,0.44)'
  ctx.font = `400 12px ${uiSans()}`
  const view = inputDeviceView()
  const hint = view.device === 'pad'
    ? resolveInputText('{move}で選ぶ · {retry}で幕が上がる · {step}で戻る', view)
    : '左クリックで幕を選ぶ · Esc で戻る'
  ctx.fillText(hint, leftName, 512)
  ctx.restore()
}

// 「最初から始める」の確かめ (2026-10-19)。 進み具合が保存されている時だけ、 タイトルの「最初から」で開く。
//   消える物・残る物を2行で言い、 「始める」「やめる」を選ばせる (開いた時は「やめる」に灯)。
//   座標は menu_layout.ts (newGameConfirmRects) と共有。
export const NEW_GAME_CONFIRM_BODY: string[] = [
  'いまの進み具合は消え、最初の幕からやり直しになる。',
  '通算の記録と、音と揺れの設定は残る。',
]
function drawNewGameConfirm(ctx: CanvasRenderingContext2D, state: GameState, tm: number): void {
  const left = NEW_GAME_CONFIRM_LEFT, leftDot = left - 16
  ctx.save()
  const scrim = ctx.createLinearGradient(0, 0, ARENA.width * 0.62, 0)
  scrim.addColorStop(0, 'rgba(6,3,13,0.66)')
  scrim.addColorStop(0.7, 'rgba(6,3,13,0.32)')
  scrim.addColorStop(1, 'rgba(6,3,13,0)')
  ctx.fillStyle = scrim
  ctx.fillRect(0, 214, ARENA.width * 0.62, 262)
  ctx.restore()

  const blink = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin(tm * 3))
  ctx.textAlign = 'left'

  ctx.save()
  ctx.fillStyle = 'rgba(244,216,120,0.62)'
  ctx.font = `400 13px ${uiSans()}`
  ctx.fillText('――  最初から始める  ――', left, NEW_GAME_CONFIRM_EYEBROW_Y)
  ctx.restore()

  ctx.save()
  ctx.font = `400 14px ${uiSans()}`
  ctx.shadowColor = 'rgba(3,1,8,0.9)'; ctx.shadowBlur = 4
  ctx.fillStyle = 'rgba(214,208,226,0.78)'
  for (let i = 0; i < NEW_GAME_CONFIRM_BODY.length; i += 1) {
    ctx.fillText(NEW_GAME_CONFIRM_BODY[i]!, left, NEW_GAME_CONFIRM_BODY_Y + i * NEW_GAME_CONFIRM_BODY_LINE_H)
  }
  ctx.restore()

  for (let i = 0; i < NEW_GAME_CONFIRM_ITEMS.length; i += 1) {
    const sel = i === state.newGameConfirmIndex
    const y = NEW_GAME_CONFIRM_CHOICE_Y + i * NEW_GAME_CONFIRM_ROW_H
    if (sel) {
      ctx.save()
      ctx.globalAlpha = blink
      ctx.fillStyle = '#f4d878'
      ctx.beginPath(); ctx.arc(leftDot, y - 8, 2.6, 0, Math.PI * 2); ctx.fill()
      ctx.restore()
    }
    ctx.save()
    ctx.font = `600 ${NEW_GAME_CONFIRM_FONT_PX}px ${UI_SERIF}`
    if (sel) {
      ctx.fillStyle = '#f4d878'
      ctx.shadowColor = 'rgba(244,216,120,0.35)'; ctx.shadowBlur = 16
    } else {
      ctx.fillStyle = '#8a8496'
    }
    ctx.fillText(NEW_GAME_CONFIRM_ITEMS[i]!, left, y)
    ctx.restore()
  }

  ctx.save()
  ctx.fillStyle = 'rgba(196,190,212,0.44)'
  ctx.font = `400 12px ${uiSans()}`
  const view = inputDeviceView()
  const hint = view.device === 'pad'
    ? resolveInputText('{move}で選ぶ · {retry}で決める · {step}で戻る', view)
    : '左クリックで選ぶ · Esc で戻る'
  ctx.fillText(hint, left, 512)
  ctx.restore()
}

// タイトルの procedural 背景 (専用キーアート未配置時の代替)。 深い夜空 + 常夜燈の冷青の一灯 + 薄い柱/床。
//   キーアート (/bg/title.png) が届けば drawTitleScreen 側で自動的に置き換わる。
function drawTitleProceduralBg(ctx: CanvasRenderingContext2D): void {
  const W = ARENA.width, H = ARENA.height
  const grad = ctx.createLinearGradient(0, 0, 0, H)
  grad.addColorStop(0, '#0a0618')
  grad.addColorStop(0.55, '#0f0a20')
  grad.addColorStop(1, '#0a0712')
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, W, H)
  // 薄い柱 (奥行き) と床際の沈み
  ctx.fillStyle = 'rgba(19,16,30,0.55)'
  ctx.fillRect(W * 0.20, 40, 30, H - 90)
  ctx.fillRect(W * 0.77, 40, 30, H - 90)
  ctx.fillStyle = 'rgba(8,5,15,0.6)'
  ctx.fillRect(0, H - 92, W, 92)
  // 常夜燈の一灯 (冷青) を上部中央に。 加算の radial グローで滑らかに (積層円のバンディングを回避)。
  const lx = W / 2, ly = 250
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const g = ctx.createRadialGradient(lx, ly, 0, lx, ly, 160)
  g.addColorStop(0, 'rgba(230,243,255,0.85)')
  g.addColorStop(0.08, 'rgba(196,224,255,0.42)')
  g.addColorStop(0.24, 'rgba(143,182,244,0.16)')
  g.addColorStop(0.55, 'rgba(96,130,220,0.06)')
  g.addColorStop(1, 'rgba(60,90,180,0)')
  ctx.fillStyle = g
  ctx.beginPath(); ctx.arc(lx, ly, 160, 0, Math.PI * 2); ctx.fill()
  ctx.fillStyle = '#ffffff'
  ctx.beginPath(); ctx.arc(lx, ly, 5, 0, Math.PI * 2); ctx.fill()
  ctx.restore()
}

function drawBigTitle(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, color: string): void {
  ctx.save()
  ctx.fillStyle = color
  ctx.shadowColor = color
  ctx.shadowBlur = 28
  ctx.font = `bold 48px ${uiSans()}`
  ctx.textAlign = 'center'
  ctx.fillText(text, x, y)
  ctx.restore()
}

// 全クリア画面: プレイ全体のサマリーとご褒美
function drawClearedSummary(ctx: CanvasRenderingContext2D, state: GameState): void {
  const cx = ARENA.width / 2
  // 旧 'DREAMLAND CLEARED' は退役済みの遊園地路線の残骸 → 演劇正典 (2026-06-03) のカーテンコールへ
  drawBigTitle(ctx, 'CURTAIN CALL', cx, 90, PALETTE.parrySparkWarm)

  ctx.textAlign = 'center'
  ctx.fillStyle = PALETTE.textDim
  ctx.font = `italic 13px ${uiSans()}`
  ctx.fillText('あなたが越えてきた夜の記録', cx, 130)

  const c = state.campaign

  // 集計
  const totalParrySuccess = sumByBoss(c.parrySuccessByBossId)
  const totalParryFail = sumByBoss(c.parryFailByBossId)
  const totalDodge = sumByBoss(c.dodgeByBossId)
  const totalCounter = sumByBoss(c.counterByBossId)

  ctx.save()
  ctx.textAlign = 'center'

  // 総計
  let y = 180
  ctx.fillStyle = PALETTE.parrySparkWarm
  ctx.font = `bold 12px ${uiSans()}`
  ctx.fillText('— TOTAL —', cx, y)
  y += 26
  ctx.fillStyle = PALETTE.textBright
  ctx.font = `15px ${uiSans()}`
  ctx.fillText(`倒れた回数  ${c.totalDeaths}　/　総プレイ時間  ${formatClearTime(c.totalTime ?? 0)}`, cx, y); y += 22
  ctx.fillText(`パリィ  ${totalParrySuccess}成功 / ${totalParryFail}失敗`, cx, y); y += 22
  ctx.fillText(`回避  ${totalDodge}  /  回避カウンター  ${totalCounter}`, cx, y); y += 26

  // 撃破ボス一覧
  ctx.fillStyle = PALETTE.parrySparkWarm
  ctx.font = `bold 12px ${uiSans()}`
  ctx.fillText('— THE CAST —', cx, y); y += 22
  ctx.font = `13px ${uiSans()}`
  ctx.fillStyle = PALETTE.textBright
  for (const id of c.defeatedBossIds) {
    const def = getBossDefinitionById(id)
    if (!def) continue
    const deaths = c.deathsByBossId[id] ?? 0
    const bossTime = c.timeByBossId?.[id] ?? 0
    ctx.fillText(`${def.name}    ( 倒れた回数 ${deaths} / ${formatClearTime(bossTime)} )`, cx, y); y += 20
  }

  y += 20
  ctx.font = `italic 14px ${uiSans()}`
  ctx.fillStyle = PALETTE.parrySparkWarm
  // G-6 (2026-06-13): 旧2行目「あなたが灯した灯りは、もう消えない。」は True エンド (常夜燈を消す) と
  //   矛盾し、 撃破=救い (解放は嘘) とも逆を語っていた → 達成の祝辞でなく、 灯が消えない不穏さへ。
  ctx.fillText('灰の王城の舞台は、もう静かだ。', cx, y); y += 20
  ctx.fillText('それでも、常夜燈は消えない。', cx, y)

  ctx.restore()
}

function sumByBoss(record: Record<string, number>): number {
  let s = 0
  for (const k in record) s += record[k] ?? 0
  return s
}

// ============== Path ヘルパ ==============
function fillPath(ctx: CanvasRenderingContext2D, color: string, build: () => void): void {
  ctx.fillStyle = color
  ctx.beginPath()
  build()
  ctx.fill()
}
function strokePath(ctx: CanvasRenderingContext2D, color: string, w: number, build: () => void): void {
  ctx.strokeStyle = color
  ctx.lineWidth = w
  ctx.beginPath()
  build()
  ctx.stroke()
}
function drawStar(ctx: CanvasRenderingContext2D, cx: number, cy: number, r1: number, r2: number): void {
  const points = 4
  for (let i = 0; i < points * 2; i += 1) {
    const r = i % 2 === 0 ? r2 : r1
    const ang = (i / (points * 2)) * Math.PI * 2 - Math.PI / 2
    const x = cx + Math.cos(ang) * r
    const y = cy + Math.sin(ang) * r
    if (i === 0) ctx.moveTo(x, y)
    else ctx.lineTo(x, y)
  }
  ctx.closePath()
}

// ============== 幕間メニューオーバーレイ ==============

// 所作の記録パネル = キー設定の表 (幕間メニュー・タイトル両方から呼ばれる・2026-10-31)。
//   座標と行は controls_panel.ts (当たり判定と同じ出所)。 割り当ては input.ts の今の値を毎フレーム読む。
function drawRecordsPanel(ctx: CanvasRenderingContext2D, state: GameState): void {
  const cx = ARENA.width / 2
  const P = CONTROLS_PANEL
  const px = controlsPanelX(); const py = P.y
  const view = inputDeviceView()
  const glyph = view.padGlyph
  const b = getKeyBindings()
  const capture = keyCaptureView()
  const sel = state.controlsIndex ?? 0
  ctx.save()
  ctx.fillStyle = 'rgba(8,4,16,0.92)'
  ctx.strokeStyle = 'rgba(154,122,196,0.4)'
  ctx.lineWidth = 1
  ctx.beginPath(); ctx.roundRect(px, py, P.w, P.h, 8); ctx.fill(); ctx.stroke()

  ctx.textAlign = 'center'
  ctx.fillStyle = PALETTE.hudGold
  ctx.font = `600 17px ${UI_SERIF}`
  ctx.fillText('所作の記録', cx, py + 30)
  ctx.strokeStyle = 'rgba(154,122,196,0.3)'; ctx.lineWidth = 1
  ctx.beginPath(); ctx.moveTo(px + 20, py + 42); ctx.lineTo(px + P.w - 20, py + 42); ctx.stroke()

  // 列の見出し
  ctx.font = `12px ${uiSans()}`
  ctx.fillStyle = PALETTE.textDim
  ctx.fillText('キーボード・マウス', px + P.kbmX + P.cellW / 2, py + P.headerY)
  ctx.fillText('パッド', px + P.padX + P.cellW / 2, py + P.headerY)

  const drawCell = (r: { x: number, y: number, w: number, h: number }, text: string, waiting: boolean, editable: boolean): void => {
    if (editable) {
      ctx.fillStyle = waiting ? 'rgba(244,216,120,0.16)' : 'rgba(154,122,196,0.10)'
      ctx.strokeStyle = waiting ? 'rgba(244,216,120,0.75)' : 'rgba(154,122,196,0.35)'
      ctx.beginPath(); ctx.roundRect(r.x, r.y, r.w, r.h, 4); ctx.fill(); ctx.stroke()
    }
    ctx.textAlign = 'center'
    ctx.fillStyle = waiting ? PALETTE.hudGold : editable ? PALETTE.textBright : PALETTE.textDim
    ctx.font = `14px ${uiSans()}`
    ctx.fillText(waiting ? '押してください…' : text, r.x + r.w / 2, r.y + r.h / 2 + 5)
  }

  for (let i = 0; i < CONTROLS_ROWS.length; i += 1) {
    const row = CONTROLS_ROWS[i]!
    const top = controlsRowTop(i)
    const isSel = i === sel && !capture
    ctx.textAlign = 'left'
    ctx.fillStyle = isSel ? PALETTE.hudGold : PALETTE.textDim
    ctx.font = `14px ${uiSans()}`
    ctx.fillText((isSel ? '▸ ' : '  ') + row.label, px + P.labelX - 12, top + P.rowH / 2 + 5)
    drawCell(controlsCellRect(i, 'kbm'), kbmCodeLabel(b.kbm[row.kbm]),
      capture?.kind === 'kbm' && capture.action === row.kbm, true)
    const padRect = controlsCellRect(i, 'pad')
    if (row.pad) {
      drawCell(padRect, padButtonLabel(b.pad[row.pad], glyph), capture?.kind === 'pad' && capture.action === row.pad, true)
    } else if (i === 0) {
      // 移動はパッドでは変えない (左スティック・十字キー)。 2行ぶんの高さの真ん中に1つだけ書く。
      ctx.textAlign = 'center'; ctx.fillStyle = PALETTE.textDim
      ctx.font = `13px ${uiSans()}`
      ctx.fillText('左スティック / 十字キー', padRect.x + padRect.w / 2, controlsRowTop(1) + 5)
    }
  }

  // 変えられない操作 (表示だけ)
  const fixed: [string, string, string][] = [
    ['幕間', 'Esc', inputLabel('pause', { device: 'pad', padGlyph: glyph })],
    ['決定・戻る', '左クリック · Esc', `${inputLabel('retry', { device: 'pad', padGlyph: glyph })} · ${glyph === 'ps' ? '○' : 'B'}`],
  ]
  ctx.font = `13px ${uiSans()}`
  for (let i = 0; i < fixed.length; i += 1) {
    const [label, kbm, pad] = fixed[i]!
    const y = controlsFixedRowTop(i) + P.fixedRowH / 2 + 5
    ctx.fillStyle = PALETTE.textDim
    ctx.textAlign = 'left'; ctx.fillText('  ' + label, px + P.labelX - 12, y)
    ctx.textAlign = 'center'
    ctx.fillText(kbm, px + P.kbmX + P.cellW / 2, y)
    ctx.fillText(pad, px + P.padX + P.cellW / 2, y)
  }

  // 既定に戻す / 閉じる
  const buttons: [number, 'reset' | 'close', string][] = [[CONTROLS_RESET_INDEX, 'reset', '既定に戻す'], [CONTROLS_CLOSE_INDEX, 'close', '閉じる']]
  for (const [index, which, text] of buttons) {
    const r = controlsButtonRect(which)
    const isSel = index === sel && !capture
    ctx.fillStyle = isSel ? 'rgba(244,216,120,0.14)' : 'rgba(154,122,196,0.08)'
    ctx.strokeStyle = isSel ? 'rgba(244,216,120,0.7)' : 'rgba(154,122,196,0.35)'
    ctx.beginPath(); ctx.roundRect(r.x, r.y, r.w, r.h, 4); ctx.fill(); ctx.stroke()
    ctx.textAlign = 'center'
    ctx.fillStyle = isSel ? PALETTE.hudGold : PALETTE.textBright
    ctx.font = `14px ${uiSans()}`
    ctx.fillText(text, r.x + r.w / 2, r.y + r.h / 2 + 5)
  }

  const hint = capture
    ? capture.kind === 'kbm'
      ? '割り当てるキーかマウスのボタンを押す · Esc でやめる'
      : resolveInputText('割り当てるボタンを押す · {pause} でやめる', { device: 'pad', padGlyph: glyph })
    : view.device === 'pad'
      ? resolveInputText('{move}で選択 · {retry}で変える · {step}で閉じる', view)
      : '変えたい欄をクリック · Esc で閉じる'
  drawPanelHint(ctx, hint, cx, py + P.h - 14, P.w)
  ctx.restore()
}

// クレジット (2026-10-31・タイトルから)。 座標と送りの量は src/credits.ts (game.ts の送り・当たり判定と同じ出所)。
const CREDITS_STEAM_BUILD = import.meta.env.MODE === 'steam'
function drawCreditsPanel(ctx: CanvasRenderingContext2D, state: GameState): void {
  const P = CREDITS_PANEL
  const cx = ARENA.width / 2
  const px = creditsPanelX(ARENA.width); const py = P.y
  const lines = creditLines(CREDITS_STEAM_BUILD)
  const maxScroll = creditsMaxScroll(lines)
  const scroll = Math.max(0, Math.min(maxScroll, state.creditsScroll ?? 0))
  const view = inputDeviceView()
  ctx.save()
  ctx.fillStyle = 'rgba(8,4,16,0.94)'
  ctx.strokeStyle = 'rgba(154,122,196,0.4)'
  ctx.lineWidth = 1
  ctx.beginPath(); ctx.roundRect(px, py, P.w, P.h, 8); ctx.fill(); ctx.stroke()

  // 文の窓。 はみ出た分は切る。
  const top = py + P.padTop
  ctx.save()
  ctx.beginPath(); ctx.rect(px + 8, top, P.w - 16, P.viewH); ctx.clip()
  let y = top - scroll
  for (const line of lines) {
    const h = creditLineHeight(line.kind)
    if (y + h >= top && y <= top + P.viewH && line.text) {
      const baseline = y + h - Math.round(h * 0.3)
      if (line.kind === 'title') {
        ctx.textAlign = 'center'; ctx.fillStyle = '#efe2ff'
        ctx.font = `600 30px ${UI_SERIF}`
        ctx.fillText(line.text, cx, baseline)
      } else if (line.kind === 'heading') {
        ctx.textAlign = 'center'; ctx.fillStyle = PALETTE.hudGold
        ctx.font = `600 16px ${UI_SERIF}`
        ctx.fillText(line.text, cx, baseline)
      } else if (line.kind === 'name') {
        ctx.textAlign = 'left'; ctx.fillStyle = PALETTE.textBright
        ctx.font = `14px ${uiSans()}`
        ctx.fillText(line.text, px + P.textX, baseline)
      } else if (line.kind === 'body') {
        ctx.textAlign = 'left'; ctx.fillStyle = PALETTE.textDim
        ctx.font = `12px ${uiSans()}`
        ctx.fillText(line.text, px + P.textX, baseline)
      } else {
        ctx.textAlign = 'left'; ctx.fillStyle = PALETTE.textDim
        ctx.font = '11px Menlo,Consolas,"Courier New",monospace'
        ctx.fillText(line.text, px + P.textX, baseline)
      }
    }
    y += h
  }
  ctx.restore()

  // 送りの位置 (右端の細い棒)。 送る物が無い時は描かない。
  if (maxScroll > 0) {
    const trackX = px + P.w - 14
    const thumbH = Math.max(24, P.viewH * (P.viewH / (P.viewH + maxScroll)))
    const thumbY = top + (P.viewH - thumbH) * (scroll / maxScroll)
    ctx.fillStyle = 'rgba(154,122,196,0.15)'; ctx.fillRect(trackX, top, 3, P.viewH)
    ctx.fillStyle = 'rgba(154,122,196,0.6)'; ctx.fillRect(trackX, thumbY, 3, thumbH)
  }

  // 閉じる (選べる物はこれ1つ = いつも選ばれている色)
  const r = creditsCloseRect(ARENA.width)
  ctx.fillStyle = 'rgba(244,216,120,0.14)'
  ctx.strokeStyle = 'rgba(244,216,120,0.7)'
  ctx.beginPath(); ctx.roundRect(r.x, r.y, r.w, r.h, 4); ctx.fill(); ctx.stroke()
  ctx.textAlign = 'center'; ctx.fillStyle = PALETTE.hudGold
  ctx.font = `14px ${uiSans()}`
  ctx.fillText('閉じる', r.x + r.w / 2, r.y + r.h / 2 + 5)

  ctx.textAlign = 'left'; ctx.fillStyle = PALETTE.textDim
  ctx.font = `12px ${uiSans()}`
  ctx.fillText(
    view.device === 'pad' ? resolveInputText('{move}で送る · {step}で閉じる', view) : 'ホイール・↑↓ で送る · Esc で閉じる',
    px + 24, r.y + r.h / 2 + 4,
  )
  ctx.restore()
}

// 音と揺れ設定パネル
function drawSettingsPanel(
  ctx: CanvasRenderingContext2D,
  settings: GameState['settings'],
  pauseIndex: number,
): void {
  const cx = ARENA.width / 2
  ctx.save()
  // 座標は menu_layout.ts (pauseSettingsRects) と共有 (2026-07-25 第2段・当たり判定と同じ出所)。
  const pw = PAUSE_SETTINGS_PANEL_W; const ph = 180; const px = cx - pw / 2; const py = PAUSE_SETTINGS_PANEL_Y
  ctx.fillStyle = 'rgba(8,4,16,0.92)'
  ctx.strokeStyle = 'rgba(154,122,196,0.4)'
  ctx.lineWidth = 1
  ctx.beginPath(); ctx.roundRect(px, py, pw, ph, 8); ctx.fill(); ctx.stroke()

  ctx.textAlign = 'center'
  ctx.fillStyle = PALETTE.hudGold
  ctx.font = `600 17px ${UI_SERIF}`
  ctx.fillText('音と揺れ', cx, py + 30)
  ctx.strokeStyle = 'rgba(154,122,196,0.3)'; ctx.lineWidth = 1
  ctx.beginPath(); ctx.moveTo(px + 20, py + 42); ctx.lineTo(px + pw - 20, py + 42); ctx.stroke()

  const items: [string, boolean][] = [
    ['BGM', settings.bgmOn],
    ['SE', settings.seOn],
    ['画面揺れ', settings.shakeOn],
  ]
  let sy = py + PAUSE_SETTINGS_FIRST_ROW_OFFSET_Y
  const sh = PAUSE_SETTINGS_ROW_H
  ctx.font = `${PAUSE_SETTINGS_FONT_PX}px ${uiSans()}`
  for (let i = 0; i < items.length; i += 1) {
    const [label, on] = items[i]!
    const sel = i === pauseIndex
    ctx.textAlign = 'right'
    ctx.fillStyle = sel ? PALETTE.hudGold : PALETTE.textDim
    ctx.fillText((sel ? '▸ ' : '  ') + label, cx - 16, sy)
    ctx.textAlign = 'left'
    ctx.fillStyle = on ? '#7afff5' : '#8a8496'
    ctx.fillText(on ? '● ON' : '○ OFF', cx + 20, sy)
    sy += sh
  }

  // 2026-07-25 第1段-b: 「何かキー」は嘘。戻るは Esc と右クリック。
  // 2026-07-26 追補: 切替はkbm=クリックのみ (R/Enterはもう決定に効かない)。
  // 2026-07-26: 幕間メインと同じ書式へ揃える (kbm=2項・pad=3項・区切りは詰める)。
  const settingsHint = inputDeviceView().device === 'pad'
    ? resolveInputText('{move}で選択 · {retry}で切替 · {step}で戻る', inputDeviceView())
    : 'クリックで切替 · Esc で戻る'
  drawPanelHint(ctx, settingsHint, cx, py + ph - 14, pw)
  ctx.restore()
}

// パネル下端のヒント行 (2026-07-26・ユーザー実機「見切れそうギリギリ」)。
//   幕間メインのパネル幅は260pxで、 kbm の文言は実測259px = 左右の余白がほぼゼロだった。
//   ①文言を短くする ②それでも入らない時は自動で字を詰める、 の二段構えにして
//   将来デバイス表記が伸びても枠から出ないようにする (パッドは ✕/○ と A/B で幅が変わる)。
function drawPanelHint(
  ctx: CanvasRenderingContext2D, text: string, cx: number, y: number, panelW: number,
): void {
  const maxW = panelW - 40   // 左右20pxずつは必ず空ける
  ctx.save()
  ctx.textAlign = 'center'
  ctx.fillStyle = PALETTE.textDim
  let px = 12
  ctx.font = `${px}px ${uiSans()}`
  while (ctx.measureText(text).width > maxW && px > 9) {
    px -= 0.5
    ctx.font = `${px}px ${uiSans()}`
  }
  ctx.fillText(text, cx, y)
  ctx.restore()
}

// 幕間メニューオーバーレイ本体
function drawPauseOverlay(ctx: CanvasRenderingContext2D, state: GameState): void {
  const cx = ARENA.width / 2
  ctx.save()

  // サブパネル
  if (state.pausePanel === 'records') {
    ctx.fillStyle = 'rgba(6,3,13,0.72)'; ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    drawRecordsPanel(ctx, state)
    ctx.restore()
    return
  }
  if (state.pausePanel === 'settings') {
    ctx.fillStyle = 'rgba(6,3,13,0.72)'; ctx.fillRect(0, 0, ARENA.width, ARENA.height)
    drawSettingsPanel(ctx, state.settings, state.pauseIndex)
    ctx.restore()
    return
  }

  // メインメニュー
  ctx.fillStyle = 'rgba(6,3,13,0.78)'; ctx.fillRect(0, 0, ARENA.width, ARENA.height)

  // 座標は menu_layout.ts (pauseMainRects) と共有 (2026-07-25 第2段・当たり判定と同じ出所)。
  const items = pauseMainItems(state.solo)
  // 高さは項目数に追従させる (一戦だけモードは4項目 = 1行ぶん低い。 固定 260 のままだと下が空く)。
  const pw = PAUSE_MAIN_PANEL_W
  const ph = 260 - (5 - items.length) * PAUSE_MAIN_ROW_H
  const px = cx - pw / 2; const py = PAUSE_MAIN_PANEL_Y
  ctx.fillStyle = 'rgba(10,5,20,0.92)'
  ctx.strokeStyle = 'rgba(154,122,196,0.45)'
  ctx.lineWidth = 1
  ctx.beginPath(); ctx.roundRect(px, py, pw, ph, 8); ctx.fill(); ctx.stroke()

  ctx.textAlign = 'center'
  ctx.fillStyle = PALETTE.hudGold
  ctx.font = `600 18px ${UI_SERIF}`
  ctx.fillText('幕間', cx, py + 32)
  ctx.strokeStyle = 'rgba(154,122,196,0.3)'; ctx.lineWidth = 1
  ctx.beginPath(); ctx.moveTo(px + 16, py + 44); ctx.lineTo(px + pw - 16, py + 44); ctx.stroke()

  let my = py + PAUSE_MAIN_FIRST_ROW_OFFSET_Y
  const mh = PAUSE_MAIN_ROW_H
  ctx.font = `${PAUSE_MAIN_FONT_PX}px ${uiSans()}`
  for (let i = 0; i < items.length; i += 1) {
    const sel = i === state.pauseIndex
    ctx.textAlign = 'center'
    ctx.fillStyle = sel ? PALETTE.hudGold : PALETTE.textDim
    ctx.fillText((sel ? '▸ ' : '  ') + items[i]! + (sel ? ' ◂' : ''), cx, my)
    my += mh
  }

  // 2026-07-26 ユーザー裁定: キーボード上下キーでのメニュー移動を廃止し、マウス専用の文言へ (「↑↓」は撤去)。
  // 2026-07-25 第1段-b: 「何かキー」は嘘。
  //   ○ (pad) でも閉じられるようになった (§6-2) ので pad 側は {pause} → {step} へ。
  //   2026-07-26 追補: 決定はkbm=クリックのみ (R/Enterはもう決定に効かない・下の文言も同期)。
  // 2026-07-26 実機指摘「見切れそうギリギリ」: kbm は「マウスで選ぶ」を落とす。
  //   マウスは合わせれば行が光るので、 動かし方は文字で言わなくても分かる。
  //   パッドはスティックで動かす手掛かりが要るので3項のまま、 区切りだけ詰める。
  const pauseHint = inputDeviceView().device === 'pad'
    ? resolveInputText('{move}で選択 · {retry}で決定 · {step}で閉じる', inputDeviceView())
    : 'クリックで決定 · Esc で閉じる'
  drawPanelHint(ctx, pauseHint, cx, py + ph - 14, pw)
  ctx.restore()
}
